import { ref, getCurrentInstance, provide, watch, unref, computed, inject, shallowRef, reactive, markRaw, onBeforeUnmount, customRef, readonly, shallowReactive, defineComponent, h, openBlock, createElementBlock, createElementVNode, createTextVNode, createVNode, withCtx, onUnmounted, mergeModels, useAttrs, useModel, mergeProps, Fragment, normalizeStyle, withModifiers, renderSlot, createCommentVNode, createSlots, normalizeProps, guardReactiveProps, normalizeClass, toDisplayString as toDisplayString$1, createBlock, resolveDynamicComponent, toRef, nextTick, render as render$1, Transition as Transition$1, withDirectives, onMounted, withKeys, watchEffect, renderList, useSlots, toRefs as toRefs$1, resolveComponent, vShow, createStaticVNode, getCurrentScope, onScopeDispose, Teleport, resolveDirective, isRef, TransitionGroup, effectScope, toValue as toValue$2, createPropsRestProxy, onBeforeMount, isMemoSame, cloneVNode, useCssVars, triggerRef } from "vue";
import { useProp, useNamespace as useNamespace$1, ElMessage, useZIndex, ElLink, ElMessageBox, ElButton, ElDialog, ElScrollbar, useFormItem, ElCascader, ElCheckbox, datePickerProps, useFormDisabled, ElDatePicker, ElTimePicker, ElPopover, inputProps, ElInput, inputNumberProps, ElInputNumber, ElTag, ElDivider, buttonProps, buttonEmits, ElDropdown, ElDropdownItem, ElDropdownMenu, useTooltipProps, ElTooltip, useDisabled, ElEmpty, ElPopconfirm, ElTable, ElTableColumn, ElRadioGroup, ElRadioButton, ElPagination, ElResult, ClickOutside, ElTree, ElImage, ElProgress, ElCol, ElForm, ElFormItem, ElRow, ElTabPane, ElTabs, ElStep, ElSteps, ElUpload, ElAlert, ElPageHeader, ElRadio, ElCarousel, ElCarouselItem, ElAutoResizer, ElTableV2, ElCard, ElCollapse, ElCollapseItem } from "element-plus";
import { deepClone, merge as merge$1, isArray, getKeys, isQiankun, warn as warn$2, toSqlWhere, debounce, capitalize, objOmit, cryptoProps, objPick, isEmptyObject, isPlainObject, getInstanceMethod, createUuid, isNumber, filterStr, isBlank, isJSON, toQueryConditionList, isEqual, syncReturnBoolean, compressorImage, encryptAES, formatNumber, formatDate, toQueryParams, throttle, getUTCTimeStamp, deepCompare, execCopy, isPrettierNumber, toEscapeCharset, deepMerge } from "@alc/utils";
import { apiGetButtonListByMenuCode, apiGetEnumArchive, apiGetTableArchive, msPost, apiGetVoucherPrintTemplate, apiGetTemplate, msGet, apiUploadFile, apiGetReferArchive, apiGetFilePreviewUrlById, getFilePreviewUrl, apiRemoveFile, apiGetFileInfo, apiDownloadFile, apiGetWorkFlowByVoucher, apiGetReferDataByCode, apiGetDefaultVoucherTemplate, apiGetVoucherTemplateByUuid } from "@alc/http";
import { eventEmit, eventOn, onPageVisit, onPageLeave, onOrgChange, onRouteArgumentsChange } from "@alc/event";
import { utils, writeFileXLSX, writeFile, read } from "xlsx";
import Draggable from "vuedraggable";
import { useRoute } from "vue-router";
const ALC_CONFIG_PROVIDER = Symbol(
  "ALC_CONFIG_PROVIDER"
), ACCESS_CONTROL_LIST = Symbol("access-control-list"), DIALOG_REGISTER_OPEN = Symbol(), DIALOG_REGISTER_CONFIRM = Symbol(), DIALOG_REGISTER_BEFORE_CLOSE = Symbol(), DIALOG_REGISTER_CUSTOM_FOOTER = Symbol(), DIALOG_STATE = Symbol(), INSERT_ROW = "insert", UPDATE_ROW = "update", ROW_STATE = Symbol("ROW_STATE"), ALC_PROCESS_TRACK_COUNT = Symbol("alc-process-track-count"), defaultValue = {
  state: {},
  dict: {},
  refer: {},
  acl: {},
  oss: {
    usePublicUrl: !0
  },
  routerArguments: {},
  payView: {
    fuzzy: !1
  }
}, globalConfig = ref(deepClone(defaultValue)), useGlobalConfig = (e, o) => {
  const n = !!getCurrentInstance(), t = n ? useProviderConfig() : void 0, r = (o == null ? void 0 : o.provide) ?? (n ? provide : appInstance.provide);
  return watch(
    () => [unref(e), t == null ? void 0 : t.value],
    ([a, l]) => {
      globalConfig.value = merge$1(globalConfig.value, defaultValue, a, l);
    },
    { immediate: !0, deep: !0 }
  ), r(ALC_CONFIG_PROVIDER, globalConfig), r(
    ACCESS_CONTROL_LIST,
    computed(() => globalConfig.value.acl[globalConfig.value.state.cMenuCode])
  ), globalConfig;
};
function useProviderConfig(e, o = void 0) {
  const n = getCurrentInstance() ? inject(ALC_CONFIG_PROVIDER, globalConfig) : globalConfig;
  return e ? computed(() => {
    var t;
    return ((t = n.value) == null ? void 0 : t[e]) ?? o;
  }) : n;
}
function useUsePublicUrl() {
  const e = useProp("usePublicUrl"), o = useProviderConfig("oss");
  return computed(() => e.value ?? !!o.value.usePublicUrl);
}
const useAcl = (e) => {
  const o = useProviderConfig(), n = inject(ACCESS_CONTROL_LIST);
  if (!n.value) {
    const t = o.value.state.cMenuCode, r = o.value.acl;
    return r[t] = /* @__PURE__ */ new Set(), getAuthAccessButton(t).then((a) => {
      r[t] = getFlatCode(a.data);
    }), {
      haveAccess: (a) => r[t].has(a)
    };
  }
  if (e) {
    const t = shallowRef();
    return provide(ACCESS_CONTROL_LIST, t), o.value.acl[e] ? t.value = o.value.acl[e] : (o.value.acl[e] = /* @__PURE__ */ new Set(), getAuthAccessButton(e).then((r) => {
      e ? t.value = getFlatCode(r.data) : o.value.acl[e] = getFlatCode(r.data);
    })), {
      haveAccess: (r) => {
        var a;
        return (a = t.value) == null ? void 0 : a.has(r);
      }
    };
  }
  return {
    haveAccess: (t) => {
      var r;
      return (r = n.value) == null ? void 0 : r.has(t);
    }
  };
};
function getFlatCode(e) {
  return e ? Object.values(e).reduce((o, n) => ("buttonList" in n && isArray(n.buttonList) && n.buttonList.forEach(
    (t) => {
      o.add(t.cButtonCode);
    }
  ), o), /* @__PURE__ */ new Set()) : /* @__PURE__ */ new Set();
}
function getAuthAccessButton(e) {
  const { cAccUuid: o, cPersonUuid: n, cUserType: t } = useProviderConfig().value.state;
  return apiGetButtonListByMenuCode({
    cAccUuid: o,
    cPersonUuid: n,
    cMenuCode: e,
    cUserType: t
  });
}
const dataMap = /* @__PURE__ */ new WeakMap(), useCudData = (e, o) => {
  var p, f;
  e || (e = reactive([]));
  const n = ((p = dataMap.get(e)) == null ? void 0 : p.checkBlankFn) || o || ((g) => {
    const b = getKeys(g);
    return b.length ? !b.some((k) => g[k] != null && (typeof g[k] == "string" ? !!g[k] : !0)) : !0;
  }), t = ((f = dataMap.get(e)) == null ? void 0 : f.delData) || shallowRef([]);
  dataMap.set(e, {
    checkBlankFn: n,
    delData: t
  });
  function r() {
    return e.filter((g) => g[ROW_STATE] === INSERT_ROW && !n(g) || g[ROW_STATE] === UPDATE_ROW);
  }
  function a() {
    return e.filter((g) => g[ROW_STATE] === INSERT_ROW && !n(g));
  }
  function l() {
    return e.filter((g) => g[ROW_STATE] === UPDATE_ROW);
  }
  function s(g, b = e.length) {
    isArray(g) ? g.forEach((k) => {
      g[ROW_STATE] || (k[ROW_STATE] = INSERT_ROW);
    }) : g[ROW_STATE] || (g[ROW_STATE] = INSERT_ROW), e.splice(b, 0, ...isArray(g) ? g : [g]);
  }
  function c(g) {
    return g[ROW_STATE] || (g[ROW_STATE] = UPDATE_ROW), g;
  }
  function d(g) {
    let b;
    if (typeof g == "number")
      [b] = e.splice(g, 1);
    else {
      const k = e.findIndex((x) => x === g);
      ~k && ([b] = e.splice(k, 1));
    }
    b && (!n(b) && b[ROW_STATE] !== INSERT_ROW || b[ROW_STATE] === UPDATE_ROW) && t.value.push(b);
  }
  return {
    data: e,
    delData: t,
    getExpectData: r,
    getInsertData: a,
    getUpdateData: l,
    doInsert: s,
    doUpdate: c,
    doDel: d,
    checkBlankRow: n
  };
};
function useDefineForm(e) {
  const o = ref(), n = typeof e.schema == "function" ? computed(e.schema) : e.schema, t = typeof e.rules == "function" ? computed(e.rules) : e.rules;
  return {
    formRef: o,
    schema: n,
    rules: t
  };
}
const inDialog = (e) => e != null;
function useDialogState(e) {
  const o = inject(
    DIALOG_STATE,
    {}
  );
  return e && getKeys(e).forEach((n) => {
    o[n].value = e[n];
  }), o;
}
const onDialogOpen = (e) => {
  const o = inject(DIALOG_REGISTER_OPEN, void 0);
  inDialog(o) && (o.value = e);
}, onDialogConfirm = (e) => {
  const o = inject(DIALOG_REGISTER_CONFIRM, void 0);
  inDialog(o) && (o.value = async () => e());
}, onDialogBeforeClose = (e) => {
  const o = inject(DIALOG_REGISTER_BEFORE_CLOSE, void 0);
  inDialog(o) && (o.value = e);
}, catchType = reactive(/* @__PURE__ */ new Set());
function getEnumOptions(e, o = !1) {
  var n;
  return catchType.has(e) || (n = globalConfig.value.dict[e]) != null && n.length && !o ? Promise.resolve() : (catchType.add(e), apiGetEnumArchive(e).then((t) => {
    var r;
    globalConfig.value.dict[e] = markRaw(
      ((r = t.data.optionList) == null ? void 0 : r.map((a) => ({
        label: a.cOptionName,
        value: a.cOptionKey,
        ...a.bDefault ? { default: !0 } : {}
      }))) || []
    );
  }).catch(() => {
    globalConfig.value.dict[e] = [];
  }).finally(() => {
    catchType.delete(e);
  }));
}
const useEnumOptions = (e, o = !1) => {
  const n = computed(() => catchType.has(e)), t = computed(() => globalConfig.value.dict[e] || []), r = computed(() => (a) => {
    var l, s;
    return ((s = (l = globalConfig.value.dict[e]) == null ? void 0 : l.find((c) => c.value === String(a))) == null ? void 0 : s.label) || "";
  });
  return e && getEnumOptions(e, o), {
    isFetch: n,
    options: t,
    getOptionLabel: r,
    getEnumOptions
  };
};
function useHoverShow(e) {
  let t, r;
  const a = ref(), l = ref(!1), s = ref(), c = shallowRef();
  function d(g, b) {
    var x, N;
    r && window.clearTimeout(r), c.value = g.currentTarget, e != null && e.deContentBounce || (a.value = b), t = window.setTimeout(() => {
      e != null && e.deContentBounce && (a.value = b), l.value = !0;
    }, 240);
    const k = (N = (x = s.value) == null ? void 0 : x.popperRef) == null ? void 0 : N.contentRef;
    k && (k.onmouseenter = (O) => {
      window.clearTimeout(r), O.currentTarget.addEventListener(
        "mouseleave",
        () => {
          r = window.setTimeout(f, 320);
        },
        { once: !0 }
      );
    });
  }
  function p() {
    t && window.clearTimeout(t), r = window.setTimeout(f, 320);
  }
  function f() {
    l.value = !1;
  }
  return {
    currentActive: a,
    visible: l,
    virtualRef: c,
    popoverRef: s,
    mouseenter: d,
    mouseleave: p
  };
}
function useMainApp() {
  const e = getCurrentInstance(), o = e ? e.appContext : appInstance;
  function n(...t) {
    o.config.globalProperties.parentProps.modalWinOpen(
      useProviderConfig("appName").value,
      ...t
    );
  }
  return {
    ...o.config.globalProperties.parentProps,
    modalOtherOpen: n
  };
}
const useNamespace = (e) => useNamespace$1(e, ref("alc"));
function visitTargetPage(e) {
  return typeof e == "string" ? (delete useProviderConfig().value.routerArguments[e], appInstance.config.globalProperties.$router.replace(e)) : ("path" in e && ("query" in e || "params" in e ? useProviderConfig().value.routerArguments[e.path] = {
    query: "query" in e ? e.query : void 0,
    params: "params" in e ? e.params : void 0
  } : delete useProviderConfig().value.routerArguments[e.path]), appInstance.config.globalProperties.$router.replace({
    path: e.path,
    query: "query" in e ? e.query : void 0
  }));
}
function visitInnerPage(e) {
  if (typeof e == "string")
    return isQiankun() ? visitOuterPage(useProviderConfig().value.appRoutePrefix + e) : visitTargetPage(e);
  let o;
  if ("path" in e && e.path)
    o = isQiankun() ? useProviderConfig().value.appRoutePrefix + e.path : e.path;
  else
    return warn$2("visitInnerPage", "请提供路由跳转标识"), Promise.reject();
  return isQiankun() ? visitOuterPage({ ...e, path: o }) : visitTargetPage({ ...e, path: o });
}
function visitOuterPage(e) {
  return isQiankun() ? useMainApp().visitTargetPage(e) : Promise.reject(
    void ElMessage.error("当前是独立运行模式，无法访问外部功能")
  );
}
function useOwnRouter() {
  const { path: e } = useRoute(), o = useProviderConfig(), n = computed(() => {
    var r;
    return ((r = o.value.routerArguments[e]) == null ? void 0 : r.query) || {};
  }), t = computed(() => {
    var r;
    return ((r = o.value.routerArguments[e]) == null ? void 0 : r.params) || {};
  });
  return {
    query: n,
    params: t,
    visitInnerPage,
    visitOuterPage
  };
}
function useRouterQuery() {
  const { path: e } = useRoute(), o = useProviderConfig();
  return computed(() => {
    var n;
    return ((n = o.value.routerArguments[e]) == null ? void 0 : n.query) || {};
  });
}
function useRouterParams() {
  const { path: e } = useRoute(), o = useProviderConfig();
  return computed(() => {
    var n;
    return ((n = o.value.routerArguments[e]) == null ? void 0 : n.params) || {};
  });
}
const useQueryList = (e, o) => {
  const n = shallowRef({}), t = (c) => {
    n.value = c != null && c.queryValue ? c.queryValue : {}, a.value && a.value.paging.pageNumber !== 1 && (a.value.paging.pageNumber = 1), s();
  }, r = computed(() => {
    const c = unref(e), d = Object.values(n.value);
    if (c) {
      const p = isArray(c), f = p ? c.map((b) => b.queryName) : Object.keys(c), g = p ? c : Object.values(c);
      return d.forEach((b, k) => {
        f.includes(b.queryName) && d.splice(k, 1);
      }), toSqlWhere(d.concat(g));
    }
    return toSqlWhere(d);
  }), a = ref();
  let l;
  const s = () => {
    var c;
    (c = a.value) != null && c.tableFile.list.length ? (a.value.getListDataByLayout(), typeof o == "function" && o()) : (l && l(), l = watch(
      () => {
        var d;
        return (d = a.value) == null ? void 0 : d.tableFile.list.length;
      },
      () => {
        var d;
        l(), (d = a.value) == null || d.getListDataByLayout(), typeof o == "function" && o();
      }
    ));
  };
  return onBeforeUnmount(() => {
    l && l();
  }), {
    listRef: a,
    listWhere: r,
    queryValue: n,
    refreshList: s,
    queryOk: t
  };
}, SAME_Z_INDEX = Symbol.for("same-z-index"), useSameZIndex = (e) => {
  const o = e || useProviderConfig().value.appName, n = useMainApp(), { currentZIndex: t, nextZIndex: r } = useZIndex();
  n && s({
    source: "alc-portal",
    zIndex: n.currentZIndex
  });
  const a = debounce(() => {
    eventEmit(SAME_Z_INDEX, {
      source: o,
      zIndex: t.value
    });
  });
  watch(t, a);
  const l = eventOn(SAME_Z_INDEX, s);
  function s(c) {
    if (c.source === o || c.zIndex === t.value)
      return;
    let d = c.zIndex - t.value;
    if (!(d <= 0))
      for (; d--; )
        r();
  }
  return onBeforeUnmount(l), {
    sameZIndex: s
  };
};
function useSliceList(e, o = {}) {
  const n = {}, t = reactive({});
  function r(g) {
    g && Object.assign(n, g), Object.assign(t, n);
  }
  r({
    pageNumber: o.pageNumber ?? 1,
    pageSize: o.pageSize ?? 50
  });
  let a = !1, l;
  const s = o.loadingDelay ? customRef((g, b) => ({
    get() {
      return g(), a;
    },
    set(k) {
      l && window.clearTimeout(l), l = window.setTimeout(() => {
        a = k, b(), l = null;
      }, o.loadingDelay);
    }
  })) : ref(!1), c = customRef((g, b) => {
    let k = 0;
    return {
      get() {
        return g(), typeof e == "function" ? k : unref(e).length;
      },
      set(x) {
        k = x, b();
      }
    };
  }), d = shallowRef([]);
  typeof e == "function" ? watch(() => ({ ...t }), f) : watch(
    () => ({ v: unref(e), ...t }),
    (g, b) => {
      b && g.v !== b.v && r(), f();
    },
    { immediate: !0 }
  );
  function p(g, b, k) {
    d.value = g.slice(
      (b - 1) * k,
      b * k
    );
  }
  async function f() {
    if (!s.value)
      if (s.value = !0, typeof e == "function")
        try {
          const g = await e({ ...t });
          g && (c.value = g.total, d.value = g.list);
        } catch (g) {
          c.value = 0, d.value = [], console.error(g);
        } finally {
          s.value = !1;
        }
      else
        p(unref(e), t.pageNumber, t.pageSize), s.value = !1;
  }
  return {
    sliceList: d,
    paging: t,
    total: readonly(c),
    isLoading: readonly(s),
    resetPaging: r,
    searchFn: f
  };
}
function useTabActiveLine(e) {
  const o = e || ref();
  let n;
  watch(o, (r) => {
    r ? (n = r == null ? void 0 : r.$el.querySelector(".el-tabs__active-bar.is-top"), n && t.observe(r.$el)) : t.disconnect();
  });
  const t = new ResizeObserver(() => {
    var a, l;
    const r = (l = (a = o.value) == null ? void 0 : a.$el.getElementsByClassName("is-active")[0]) == null ? void 0 : l.offsetLeft;
    r && n && (n.style.transform = `translateX(${r}px)`);
  });
  return onBeforeUnmount(() => {
    n = null, t.disconnect();
  }), {
    tabsRef: o
  };
}
const itemTypeRef = Object.freeze({
  Text: "input",
  Number: "number",
  Select: "select",
  Date: "date",
  Boolean: "checkbox",
  Refer: "refer",
  Checkbox: "checkbox"
}), useTableArchive = (e, o) => {
  const n = ref(!1), t = ref(!1), r = shallowRef({
    orgPlan: !1,
    userPlan: !1,
    list: [],
    baseList: {},
    plan: {}
  }), a = computed(() => r.value.list.map((s) => {
    const c = {
      itemType: itemTypeRef[s.cFieldType],
      label: s.cTitleName,
      prop: s.cFieldName,
      width: s.iColumnWidthMin,
      align: s.cAlignmentType,
      sum: s.bSum,
      fixed: s.bFixed ? "left" : void 0,
      show: s.bShow,
      required: s.bRequired,
      sortable: s.bOrder ? "custom" : !1
    };
    return s.cFieldType === "Number" ? Object.assign(c, {
      code: s.iPrecision,
      precision: s.iPrecision,
      min: s.iMin,
      max: s.iMax
    }) : s.cFieldType === "Date" ? Object.assign(c, {
      code: s.cFieldTypeCode,
      type: s.cFieldTypeCode
    }) : (s.cFieldType === "Select" || s.cFieldType === "Refer") && (c.code = s.cFieldTypeCode), c;
  }));
  function l() {
    n.value = !0;
    const { cOrgUuid: s, cPersonUuid: c } = useProviderConfig().value.state;
    return apiGetTableArchive({
      cBaseListCode: e.value,
      cOrgUuid: s,
      cPersonUuid: c
    }).then((d) => {
      if (d.code === 1) {
        t.value = !1;
        const p = d.data;
        return r.value = {
          bHasPersonPlan: p.bHasPersonPlan,
          bHasOrgPlan: p.bHasOrgPlan,
          list: isArray(p.list) ? p.list.sort((f, g) => f.iOrder - g.iOrder) : [],
          baseList: p.baseList || {},
          plan: p.plan || {}
        }, o == null || o(r.value), !0;
      } else d.code === 2106 && (t.value = !0);
    }).catch(() => {
      t.value = !1;
    }).finally(() => {
      n.value = !1;
    });
  }
  return {
    isFetch: n,
    isAuthControl: t,
    tableFile: r,
    listSchema: a,
    initLayout: l
  };
}, defaultConfig = {
  fineGrit: !0,
  maxTrack: 110,
  initialTrack: !1,
  noTrackEmpty: !0,
  undoLimit: "没有变更",
  redoLimit: "无法重做"
};
function useFormTimeTravel(e, o) {
  const n = Object.assign({}, defaultConfig, o);
  let t = 0, r = !1;
  const a = Symbol(), l = shallowReactive([]), s = computed(() => l.reduce(
    (k, x) => (Object.keys(x).forEach((N) => {
      k.add(N);
    }), k),
    /* @__PURE__ */ new Set()
  ));
  watch(
    () => l.length,
    (k) => {
      if (k > n.maxTrack) {
        const x = l.shift();
        if (x) {
          for (const N of l)
            if (Object.hasOwn(N, a) && N[a] === x) {
              x[a] = null, N[a] = x;
              break;
            }
          t--;
        }
      }
    },
    { flush: "post" }
  );
  const c = ref({ ...e }), d = new Proxy(c.value, {
    set(k, x, N) {
      const O = Reflect.set(k, x, N);
      if (O) {
        r && l.splice(t);
        const m = l.at(-1);
        if (n.noTrackEmpty && p(N))
          return O;
        if (!m || m[x] !== N) {
          if (!n.fineGrit) {
            const z = l.at(-1);
            if (z && Object.keys(z)[0] === x) {
              if (z[x] = N, !Object.hasOwn(z, a)) {
                let P = t;
                for (; P-- > 0; )
                  if (Object.hasOwn(l[P], x)) {
                    z[a] = l[P];
                    break;
                  }
              }
              return O;
            }
          }
          const ee = { [x]: N };
          if (!s.value.has(x))
            ee[a] = { [x]: e[x] };
          else {
            let z = t;
            for (; z-- > 0; )
              if (Object.hasOwn(l[z], x)) {
                ee[a] = l[z];
                break;
              }
          }
          t = l.push(ee);
        }
      }
      return O;
    }
  }), p = (k) => ["", null, void 0].includes(k), f = (k = e) => {
    n.initialTrack ? Object.assign(d, k) : (Object.assign(e, k), Object.assign(d, e)), t = 0, l.splice(0);
  }, g = (k = 1) => {
    if (t === 0)
      return void (typeof n.undoLimit == "function" ? n.undoLimit() : ElMessage.warning({
        message: n.undoLimit,
        grouping: !0
      }));
    r = !0, k = Math.max(k, 0), Object.assign(
      c.value,
      l.slice(t - k, t).reduceRight((x, N) => ({
        ...x,
        ...N[a]
      }), {})
    ), t -= k;
  }, b = (k = 1) => {
    if (t === l.length)
      return void (typeof n.redoLimit == "function" ? n.redoLimit() : ElMessage.warning({
        message: n.redoLimit,
        grouping: !0
      }));
    k = Math.min(k, l.length - t), Object.assign(
      c.value,
      l.slice(t, t + k).reduce((x, N) => ({ ...x, ...N }), {})
    ), t += k;
  };
  return f(), {
    form: d,
    reset: f,
    undo: g,
    redo: b
  };
}
const alcAccessControlProps = {
  /**
   * 访问控制关键字
   * @description 有时只根据当前 code 判断是否渲染内容；没有时可以获取插槽传递的 haveAccess，在容器内进行单个判断。如果页面上有多个需要控制的渲染，建议使用插槽绑定的方法，和在 ts 中使用 useAcl() 拿到 haveAccess 去使用是一样的。
   */
  code: { type: String },
  /**
   * 菜单 code
   * @description 指定 menuCode 时，将会覆盖后代组件的访问控制列表
   */
  menuCode: { type: String },
  /**
   * 渲染的元素
   * @description div 等原生标签
   */
  tag: { type: String }
}, _sfc_main$16 = defineComponent({
  name: "alc-access-control",
  props: alcAccessControlProps,
  setup(e, { attrs: o, slots: n }) {
    const { haveAccess: t } = useAcl(e.menuCode);
    return () => {
      var r, a, l, s;
      return e.code ? t(e.code) ? (r = n.default) == null ? void 0 : r.call(n) : (a = n.fallback) == null ? void 0 : a.call(n) : e.tag ? h(e.tag, o, (l = n.default) == null ? void 0 : l.call(n, { haveAccess: t })) : (s = n.default) == null ? void 0 : s.call(n, { haveAccess: t });
    };
  }
}), _export_sfc = (e, o) => {
  const n = e.__vccOpts || e;
  for (const [t, r] of o)
    n[t] = r;
  return n;
}, AccessControl = /* @__PURE__ */ _export_sfc(_sfc_main$16, [["__file", "access-control.vue"]]), _sfc_main$15 = /* @__PURE__ */ defineComponent({
  name: "alc-grp-check",
  __name: "grp-check",
  emits: ["startServer"],
  setup(e, { expose: o }) {
    o();
    const n = { get ElLink() {
      return ElLink;
    } };
    return Object.defineProperty(n, "__isScriptSetup", { enumerable: !1, value: !0 }), n;
  }
}), _hoisted_1$M = { class: "alc-component-grp-check-container" }, _hoisted_2$C = /* @__PURE__ */ createElementVNode("div", { class: "cpt-grp-check-illustrate" }, " 请参照以下说明，查找解决问题： ", -1), _hoisted_3$w = { class: "cpt-grp-check-illustrate" }, _hoisted_4$n = /* @__PURE__ */ createElementVNode("div", { class: "cpt-grp-check-illustrate" }, " 2、部分安全工具或杀毒软件会对客户端服务进行误报拦截，且浏览器需支持 WebSocket 协议，请检查以保证客户端能够正常启动运行； ", -1), _hoisted_5$k = { class: "cpt-grp-check-illustrate" }, _hoisted_6$j = /* @__PURE__ */ createElementVNode("img", {
  src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAABCCAYAAADjVADoAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAAIWSURBVHhe7ZRttqsgDEUdukPrzPpATp5pCCgqft2TtfYPSYBk1zp8GVNQBIIiELtEjON4K/YERSB2ifh8PhPjOFxEEjAMww9bgiIQrxDhCWkNikC8QsTcx3YhL3kj0rMWomWsEUIRiC4ihiE2chwjmJ/DPREjQhAZLUIoAtFFhDSu12IPEb2mqeVLOTtkCzbylYagCMTVIjJCUfrLzEiPFLFVxBA2r2VJhP7gxbsTdl2o5Zf2JrwfgCLALUTotTRI778GRSR6iPh/6JVgmNh3RA/oYvZFKAIcJ0IdeipyfyD2ncg/kBqv50tETKcFvFwz6u4k4UFvxJ8TIQOX8Gr1mmaaMJDlKALcWYQMZbH5Wv2c85F8vFt6mdP5B1JDEaC7iNIwFi+/vCeR5dRAKPnNe1AEOEuEvqA7FAGeKELya/D2u4S7pZfYdyL/QGooAnQV0TKErrX1tZyLGihJWLmHIgI9RcTD1jYvdbX6Wu6HO4uw6At1nV3XuVKNNNwLigCHiLDYoUp4tfYsQRr2coI5KsPbQxGgq4gSWWcO3r5ITYQ9ZmldQxHgFiK8nF7TbBGxBooAl4qo5Uo1LSJKeHspAmwWIbFHhFCrsestIlryFAFOFZF1oliqkTxFIP8KEUdwfxEnIQ3X0MN6eHsEigCbRawJuUS/ineDIsCpIp4ARYCuIuzhT8IGRSB2iXhTUASCIqb4fv8BuP6nPJmGYRcAAAAASUVORK5CYII=",
  style: { width: "16px", height: "16px" },
  alt: "应用图标"
}, null, -1);
function _sfc_render$12(e, o, n, t, r, a) {
  return openBlock(), createElementBlock("div", _hoisted_1$M, [
    _hoisted_2$C,
    createElementVNode("div", _hoisted_3$w, [
      createTextVNode(" 1、导出/打印功能依赖客户端服务，请先确认是否安装过客户端，如未安装，请点击 "),
      createVNode(t.ElLink, {
        type: "primary",
        underline: !1,
        href: "http://www.rubylong.cn/download/gridreport6-webapp.exe"
      }, {
        default: withCtx(() => [
          createTextVNode(" [下载客户端] ")
        ]),
        _: 1
      }),
      createTextVNode(" 进行安装； ")
    ]),
    _hoisted_4$n,
    createElementVNode("div", _hoisted_5$k, [
      createTextVNode(" 3、客户端服务正常运行时电脑右下角会有任务图标 "),
      _hoisted_6$j,
      createTextVNode("。如尚未启动，可点击 "),
      createVNode(t.ElLink, {
        type: "primary",
        underline: !1,
        onClick: o[0] || (o[0] = (l) => e.$emit("startServer"))
      }, {
        default: withCtx(() => [
          createTextVNode(" [启动客户端] ")
        ]),
        _: 1
      }),
      createTextVNode(" 尝试运行服务。 ")
    ])
  ]);
}
const GrpCheck = /* @__PURE__ */ _export_sfc(_sfc_main$15, [["render", _sfc_render$12], ["__file", "grp-check.vue"]]), AlcGrpCheck = withInstall(GrpCheck);
let _grwebapp_websocket = null;
function _gr_up_href(e) {
  return "grwebapp://";
}
function webapp_urlprotocol_startup(e) {
  window.location.href = _gr_up_href();
}
function webapp_ws_check(e) {
  return e || (_grwebapp_websocket ? _grwebapp_websocket.readyState != 1 && alert("WebSocket正在连接中，暂不能发送数据！") : alert("WebSocket没有创建，无法发送数据！")), _grwebapp_websocket && _grwebapp_websocket.readyState === 1;
}
function webapp_ws_create(e, o) {
  _grwebapp_websocket && _grwebapp_websocket.readyState === 1 || ("WebSocket" in window ? (_grwebapp_websocket = new WebSocket("ws://127.0.0.1:22333"), e && (_grwebapp_websocket.onopen = e), _grwebapp_websocket.onerror = function(...n) {
    _grwebapp_websocket = null, o(...n);
  }, _grwebapp_websocket.onclose = function() {
    _grwebapp_websocket = null;
  }) : alert("当前浏览器不支持HTML5的WebSocket，请选用更新版本的浏览器！"));
}
function webapp_ws_run(e, o, n) {
  function t(r, a, l) {
    let s;
    webapp_ws_check() && (typeof r == "string" && (r = {
      type: r
    }), s = JSON.stringify(r), a && (a.substr(0, 4) === "_WR_" && (s += a.length), s += a, l && (s += l)), _grwebapp_websocket.send(s));
  }
  if (!webapp_ws_check(1)) {
    webapp_ws_create(() => {
      webapp_ws_run(e, o, n);
    });
    return;
  }
  Array.isArray(e) ? e.forEach((r) => {
    t(r);
  }) : t(e, o, n);
}
function checkGrpServerState() {
  return new Promise((e, o) => {
    webapp_ws_check(!0) ? e() : webapp_ws_create(e, (...n) => {
      ElMessageBox.alert(
        h(AlcGrpCheck, {
          onStartServer: () => {
            webapp_urlprotocol_startup(), e();
          }
        }),
        "GRP服务未能正常运行",
        {
          confirmButtonText: "确定",
          dangerouslyUseHTMLString: !0
        }
      ), o(...n);
    });
  });
}
function grpRun(e, o, n) {
  checkGrpServerState().then(() => {
    webapp_ws_run(e, o, n);
  });
}
async function printByGrpTemplate(e, o) {
  if (!isArray(o) || o.length === 0)
    return Promise.reject({ msg: "打印数据为空" });
  let n;
  if (e.processInst)
    try {
      n = (await msPost(
        "alc-city-framework/TaskAction/getWfOpinion",
        {
          cWfToolTypeCode: "albpm",
          processInstId: e.processInst
        }
      )).data || void 0;
    } catch {
    }
  if (e.voucherTemplateUuid)
    return apiGetVoucherPrintTemplate(e.voucherTemplateUuid).then(
      (r) => r.code === 1 ? void grpRun(
        {
          type: e.preview ? "preview" : "print",
          showOptionDlg: !1
        },
        r.data.cGrf,
        JSON.stringify({ recordset: o, wfReportList: n })
      ) : Promise.reject(r)
    );
  const t = useProviderConfig("state");
  return apiGetTemplate({
    cTemplateUuid: "id" in e ? e.id : void 0,
    cReportCode: "code" in e ? e.code : void 0,
    cOrgUuid: t.value.cOrgUuid,
    cPersonUuid: t.value.cPersonUuid
  }).then((r) => r.code === 1 ? void grpRun(
    {
      type: e.preview ? "preview" : "print",
      showOptionDlg: !1
    },
    r.data.strJSON,
    JSON.stringify({ recordset: o, wfReportList: n })
  ) : Promise.reject(r));
}
function exportByGrpTemplate(e, o) {
  if (!isArray(o) || o.length === 0)
    return Promise.reject({ msg: "导出数据为空" });
  const n = useProviderConfig("state");
  return apiGetTemplate({
    cTemplateUuid: "id" in e ? e.id : void 0,
    cReportCode: "code" in e ? e.code : void 0,
    cOrgUuid: n.value.cOrgUuid,
    cPersonUuid: n.value.cPersonUuid
  }).then((t) => t.code === 1 ? void grpRun(
    {
      type: e.type || "xls",
      showOptionDlg: !0,
      SameAsPrint: !1,
      filename: e.filename
    },
    t.data.strJSON,
    JSON.stringify({ recordset: o })
  ) : Promise.reject(t));
}
function withInstall(e, o) {
  return e.install = (n) => {
    for (const t of [e, ...Object.values({})])
      n.component(t.name, t);
  }, e;
}
function withInstallDirective(e, o) {
  return e.install = (n) => {
    n.directive(o, e);
  }, e;
}
function emitsToProps(e) {
  return getKeys(e).reduce(
    (o, n) => (o[`on${capitalize(n)}`] = { type: Function }, o),
    {}
  );
}
const remixIconTags = {
  Arrows: {
    "arrow-left-up": "corner,左上",
    "arrow-up": "send,箭头,向上,发送",
    "arrow-right-up": "send,corner,右上,发送",
    "arrow-right": "forward,箭头,向右",
    "arrow-right-down": "corner,右下",
    "arrow-down": "receive,箭头,向下,接收,收款",
    "arrow-left-down": "receive,corner,箭头,左下,接收,收款",
    "arrow-left": "backward,箭头,向左,返回",
    "corner-right-up": "arrow,箭头,右上",
    "corner-up-left": "arrow,箭头,上左",
    "corner-up-right": "arrow,箭头,上右",
    "corner-right-down": "arrow,箭头,右下",
    "corner-down-left": "arrow,箭头,下左",
    "corner-left-up": "arrow,箭头,左上",
    "corner-left-down": "arrow,箭头,左下",
    "corner-down-right": "arrow,箭头,下右",
    "arrow-up-circle": "箭头,向上",
    "arrow-right-circle": "forward,箭头,向右",
    "arrow-down-circle": "箭头,向下,下载",
    "arrow-left-circle": "backward,箭头,向左,返回",
    "arrow-up-s": "chevron,箭头,向上",
    "arrow-right-s": "chevron,forward,箭头,向右",
    "arrow-down-s": "chevron,箭头,向下",
    "arrow-left-s": "chevron,backward,箭头,向左,返回",
    "skip-up": "arrow,unfold,top,expand,置顶,展开,收起",
    "skip-right": "arrow,unfold,next,expand,跳过,展开,收起",
    "skip-down": "arrow,unfold,next,expand,跳过,展开,收起",
    "skip-left": "arrow,unfold,expand,bottom,展开,收起",
    "arrow-left-right": "exchange,swap,箭头,左右,交换,换算,兑换",
    "arrow-up-down": "exchange,swap,箭头,上下,交换,换算,兑换",
    "arrow-drop-up": "chevron,箭头,向上",
    "arrow-drop-right": "chevron,forward,箭头,向右",
    "arrow-drop-down": "chevron,箭头,向下",
    "arrow-drop-left": "chevron,backward,箭头,向左,返回",
    "arrow-up-wide": "expand,箭头,向上,展开",
    "arrow-right-wide": "expand,箭头,向上,展开",
    "arrow-down-wide": "expand,箭头,向上,展开",
    "arrow-left-wide": "expand,箭头,向上,展开",
    "arrow-up-double": "unfold,expand,top,chevron,展开,收起",
    "arrow-right-double": "unfold,expand,chevron,展开,收起",
    "arrow-down-double": "unfold,expand,chevron,展开,收起",
    "arrow-left-double": "unfold,expand,chevron,展开,收起",
    "corner-up-left-double": "arrow,replay-all,回复全部",
    "corner-up-right-double": "arrow,forward-all,转发全部",
    "drag-move": "arrow,拖拽,移动,箭头",
    "drag-move-2": "arrow,拖拽,移动,箭头",
    "expand-left": "slide,pull,unfold,arrow",
    "expand-right": "arrow,展开,收起,右",
    "contract-left": "slide,pull,fold,arrow",
    "contract-right": "arrow,slide,pull,fold,展开,收起,右",
    "expand-up-down": "arrow,unfold,dropdown,switch,展开",
    "expand-left-right": "arrow,unfold,dropdown,switch",
    "contract-up-down": "fold,arrow,fold,收起",
    "contract-left-right": "arrow,fold,收起",
    "expand-height": "arrow,unfold,switch,展开",
    "expand-width": "arrow,unfold,switch,展开",
    "expand-horizontal": "arrow,unfold,switch,展开",
    "expand-vertical": "arrow,unfold,dropdown,switch,展开",
    "collapse-horizontal": "arrow,scale,收起,缩小",
    "collapse-vertical": "arrow,scale,收起,缩小",
    "expand-diagonal": "arrow,scale,展开,放大",
    "expand-diagonal-2": "arrow,scale,展开,放大",
    "collapse-diagonal": "arrow,scale,收起,缩小",
    "collapse-diagonal-2": "arrow,scale,收起,缩小",
    "expand-horizontal-s": "arrow,unfold,switch,展开",
    "expand-vertical-s": "arrow,unfold,switch,展开",
    "expand-diagonal-s": "arrow,scale,展开,放大",
    "expand-diagonal-s-2": "arrow,scale,展开,放大",
    "arrow-go-back": "undo,箭头,返回,撤销,撤回",
    "arrow-go-forward": "redo,箭头,重做,撤销,撤回",
    "arrow-turn-forward": "箭头,掉头",
    "arrow-turn-back": "箭头,掉头",
    "scroll-to-bottom": "mouse,滚动到底部,鼠标"
  },
  Buildings: {
    home: "house,房子,家,主页",
    "home-2": "house,房子,家,主页",
    "home-3": "house,房子,家,主页",
    "home-4": "house,房子,家,主页",
    "home-5": "house,房子,家,主页",
    "home-6": "house,房子,家,主页",
    "home-7": "house,房子,家,主页",
    "home-8": "house,房子,家,主页",
    "home-gear": "house,房子,工厂",
    "home-wifi": "smart home,房子,家具,智能家居",
    "home-smile": "house,smart home,smile,房子,智能家居,微笑",
    "home-smile-2": "house,smart home,smile,房子,智能家居,微笑",
    "home-heart": "house,心,房子,家,主页,孤儿院",
    "home-office": "居家办公",
    building: "city,office,enterprise,建筑,城市,楼,办公楼,写字楼,企业",
    "building-2": "city,office,construction,enterprise,城市,建筑,楼,企业",
    "building-3": "factory,plant,enterprise,工厂,建筑,楼,企业",
    "building-4": "city,office,enterprise,建筑,城市,楼,办公楼,写字楼,企业",
    hotel: "building,hotel,office,enterprise,tavern,建筑,酒店,楼,办公楼,写字楼,企业",
    community: "building,hotel,社区,建筑,酒店",
    school: "college,university,学校,学院",
    government: "building,政府,建筑,大会堂",
    bank: "bank,finance,savings,banking,银行,交易所",
    store: "shop,mall,supermarket,retail,商店,超市,店铺,商家",
    "store-2": "shop,mall,supermarket,retail,商店,超市,店铺,商家",
    "store-3": "shop,mall,supermarket,retail,商店,超市,店铺,商家",
    hospital: "medical,health,医院",
    "ancient-gate": "historical,genre,scenic,trip,travel,旅行,旅游,城门,古代,历史,景区",
    "ancient-pavilion": "historical,genre,scenic,trip,travel,旅行,旅游,凉亭,古代,历史,景区",
    tent: "camping,帐篷,露营,营地"
  },
  Business: {
    mail: "envelope,email,inbox,信封,邮箱,邮件,收件箱",
    "mail-open": "envelope,email,inbox,信封,邮箱,邮件,收件箱",
    "mail-send": "envelope,email,inbox,zoom,whoosh,信封,邮箱,邮件,发送,发件箱",
    "mail-unread": "envelope,email,inbox,信封,邮箱,邮件,未读",
    "mail-add": "envelope,email,inbox,add,信封,邮箱,邮件,新增,添加",
    "mail-check": "envelope,email,inbox,read,信封,邮箱,邮件,已读",
    "mail-close": "envelope,email,inbox,failed,x,信封,邮箱,邮件,失败",
    "mail-download": "envelope,email,inbox,download,信封,邮箱,邮件,下载",
    "mail-forbid": "envelope,email,inbox,privacy,信封,邮箱,邮件,禁止",
    "mail-lock": "envelope,email,inbox,lock,信封,邮箱,邮件,加密",
    "mail-settings": "envelope,email,inbox,settings,信封,邮箱,邮件,设置",
    "mail-star": "envelope,email,inbox,favorite,信封,邮箱,邮件,收藏,喜欢",
    "mail-volume": "envelope,email,inbox,promotional email,email campaign,subscription,sound,信封,邮箱,邮件,收件箱,推广,订阅",
    inbox: "收件箱",
    "inbox-2": "收件箱",
    "inbox-archive": "收件箱,归档,收纳",
    "inbox-unarchive": "unzip,unpack,extract,收件箱,取消归档,还原,解压缩",
    cloud: "weather,云端",
    "cloud-off": "offline mode,connection fail,slash,weather,云端,断网,无信号,连接失败",
    attachment: "annex,paperclip,附件,曲别针",
    profile: "id,档案,资料,身份证,证件",
    archive: "box,收纳,归档,存档,盒子,纸箱",
    "archive-2": "box,收纳,归档,存档,盒子,纸箱",
    "archive-drawer": "night table,收纳,抽屉,归档,存档,床头柜",
    "archive-stack": "box,收纳,归档,存档,盒子,纸箱,堆叠",
    at: "@,mention,提到,在",
    award: "medal,achievement,badge,成就,奖牌,金牌,勋章",
    medal: "award,achievement,badge,成就,奖牌,金牌,勋章",
    "medal-2": "award,achievement,badge,成就,奖牌,金牌,勋章",
    "verified-badge": "认证标志",
    "bar-chart": "statistics,rhythm,柱状图,统计,韵律,节奏",
    "bar-chart-horizontal": "statistics,rhythm,柱状图,统计,韵律,节奏",
    "bar-chart-2": "statistics,rhythm,柱状图,统计,排行,节奏",
    "bar-chart-box": "statistics,rhythm,柱状图,统计,节奏",
    "bar-chart-grouped": "statistics,rhythm,柱状图,统计,分组",
    "bubble-chart": "data,analysis,statistics,circles,气泡图,统计",
    "pie-chart": "data,analysis,饼图,饼状图,数据,分析",
    "pie-chart-2": "data,analysis,饼图,饼状图,数据,分析",
    "pie-chart-box": "data,analysis,饼图,饼状图,数据,分析",
    "donut-chart": "data,analysis,circle,pie,环形图,数据,分析",
    "line-chart": "data,analysis,stats,折线图,数据,分析",
    bookmark: "tag,书签,标记",
    "bookmark-2": "tag,书签,标记",
    "bookmark-3": "tag,书签,标记,荣誉",
    briefcase: "bag,baggage,公文包,行李箱,旅行箱,皮包",
    "briefcase-2": "bag,baggage,公文包,行李箱,旅行箱,皮包",
    "briefcase-3": "bag,baggage,公文包,行李箱,旅行箱,皮包",
    "briefcase-4": "bag,baggage,公文包,行李箱,旅行箱,皮包",
    "briefcase-5": "bag,baggage,公文包,行李箱,旅行箱,皮包",
    calculator: "计算器,计算机",
    calendar: "date,plan,schedule,agenda,日历,日期,月份,计划,日程,时间表",
    "calendar-2": "date,plan,schedule,agenda,日历,日期,月份,计划,日程,时间表",
    "calendar-event": "date,plan,schedule,agenda,日历,日期,月份,计划,日程,时间表",
    "calendar-todo": "date,plan,schedule,agenda,日历,日期,月份,计划,日程,时间表",
    "calendar-check": "date,plan,schedule,agenda,check-in,punch,日历,日期,月份,计划,日程,时间表,签到,打卡",
    "calendar-close": "date,plan,schedule,agenda,error,cancel,日历,日期,月份,计划,日程,时间表,取消,错误",
    "calendar-schedule": "date,plan,schedule,agenda,date,time,日历,日期,月份,计划,日程,时间表,预定,预约",
    "customer-service": "headset,headphones,earphones,客服,售后,耳机,耳麦",
    "customer-service-2": "headset,headphones,earphones,smile,客服,售后,耳机,耳麦",
    flag: "banner,pin,mark,milestone,旗帜,旗子,国旗,标记,里程碑",
    "flag-2": "banner,pin,mark,milestone,旗帜,旗子,国旗,标记,里程碑",
    "triangular-flag": "banner,pin,mark,milestone,旗帜,旗子,国旗,标记,里程碑",
    global: "earth,union,world,language,地球,联合,世界,全球,语言",
    honour: "honor,glory,锦旗,荣誉,荣耀,军衔",
    links: "connection,address,联系,链接,地址",
    printer: "打印机",
    "printer-cloud": "network,打印机,云打印",
    "record-mail": "voice mail,tape,录音,留言,语音信箱,磁带",
    reply: "forward,回复全部,回复所有",
    "reply-all": "forward,回复,答复,留言,转发",
    "send-plane": "发送,纸飞机",
    "send-plane-2": "发送,纸飞机",
    projector: "projection,meeting,投影仪,会议室",
    "projector-2": "projection,meeting,投影仪,会议室,极米",
    slideshow: "presentation,meeting,PPT,keynote,投影,放映,演示,演讲,幻灯片,会议室",
    "slideshow-2": "presentation,meeting,投影,放映,演示,演讲,幻灯片,会议室",
    "slideshow-3": "presentation,meeting,投影,放映,演示,演讲,视频会议,幻灯片,会议室",
    "slideshow-4": "presentation,meeting,投影,放映,演示,演讲,可视对讲,幻灯片,会议室",
    presentation: "teaching,training,演讲,老师,培训",
    window: "browser,program,web,窗口,浏览器,程序,网站",
    "window-2": "browser,program,web,窗口,浏览器,程序,网站",
    stack: "layers,图层,叠加,堆栈",
    "shake-hands": "cooperation,business,握手,合作,商务",
    service: "heart,handshake,cooperation,client,服务,握手,心,合作",
    registered: "注册,商标",
    trademark: "注册,商标",
    advertisement: "ad,广告,推广",
    copyleft: "著佐权",
    copyright: "版权",
    "creative-commons": "知识共享",
    "creative-commons-by": "attribution,copyright,版权,知识共享,署名",
    "creative-commons-nc": "noncommercial,copyright,版权,知识共享,非商业用途",
    "creative-commons-nd": "no derivative works,copyright,版权,知识共享,禁止演绎",
    "creative-commons-sa": "share alike,copyright,版权,知识共享,相同方式共享",
    "creative-commons-zero": "cc0,copyright,版权,知识共享",
    megaphone: "bullhorn,loudspeaker,commercial,campaign,扩音器,喇叭,广告,活动",
    "pass-valid": "id,passport,护照有效",
    "pass-pending": "id,passport,护照等待",
    "pass-expired": "id,passport,护照过期",
    "id-card": "card,identity,user,license,badge,passport,身份证,用户,许可证,护照",
    seo: "搜索引擎优化"
  },
  Communication: {
    "chat-1": "message,reply,comment,消息,聊天,回复,评论",
    "chat-2": "message,reply,comment,消息,聊天,回复,评论",
    "chat-3": "message,reply,comment,消息,聊天,回复,评论",
    "chat-4": "message,reply,comment,消息,聊天,回复,评论",
    message: "chat,comment,reply,消息,聊天,回复,评论",
    "message-2": "chat,reply,comment,消息,聊天,回复,评论",
    "message-3": "chat,reply,comment,消息,聊天,回复,评论",
    "chat-check": "message,reply,comment,消息,聊天,回复,评论,已阅",
    "chat-delete": "message,comment,消息,聊天,回复,评论,清除,删除",
    "chat-forward": "message,comment,消息,聊天,转发",
    "chat-upload": "message,comment,消息,聊天,上传",
    "chat-download": "message,comment,消息,下载",
    "chat-new": "message,reply,comment,消息,聊天,回复,评论",
    "chat-settings": "message,comment,消息,聊天,回复,评论,设置",
    "chat-unread": "new message,comment,badge,消息,聊天,回复,评论,未读",
    "chat-search": "message,comment,消息,聊天,回复,评论,搜索,放大镜",
    "chat-smile": "message,reply,comment,消息,聊天,回复,评论",
    "chat-smile-2": "message,reply,comment,消息,聊天,回复,评论",
    "chat-smile-3": "message,reply,comment,消息,聊天,回复,评论",
    "chat-heart": "message,reply,comment,消息,聊天,回复,评论,心,点赞,收藏",
    "chat-off": "message,reply,comment,slash,消息,聊天,回复,评论,禁止,关闭",
    feedback: "message,comment,消息,聊天,回复,评论,反馈",
    discuss: "message,reply,comment,消息,聊天,回复,评论,讨论,群聊",
    "question-answer": "message,reply,comment,消息,聊天,回复,评论,讨论,群聊",
    questionnaire: "message,comment,help,消息,聊天,回复,评论,讨论,调查问卷,帮助",
    "video-chat": "message,comment,消息,视频聊天",
    "chat-voice": "message,comment,消息,语音消息",
    "chat-quote": "message,reply,comment,消息,引用回复",
    "chat-follow-up": "message,reply,comment,消息,+1,跟帖",
    "chat-poll": "message,vote,questionnaire,消息,投票,问卷调查",
    "chat-history": "message,历史消息,消息记录",
    "chat-private": "message,私密消息,密聊",
    "chat-thread": "topic,hashtag,话题,井号,哈希",
    speak: "voice,讲话,声音",
    "emoji-sticker": "表情,贴纸"
  },
  Design: {
    pencil: "edit,铅笔,编辑",
    edit: "pencil,铅笔,编辑",
    "edit-2": "pencil,铅笔,编辑",
    "ball-pen": "圆珠笔",
    "quill-pen": "羽毛笔,钢笔,编辑",
    "pen-nib": "钢笔,笔尖",
    "ink-bottle": "墨水瓶",
    "mark-pen": "马克笔",
    markup: "标记,马克",
    "edit-box": "编辑",
    "edit-circle": "编辑",
    sip: "吸管,取色器",
    brush: "笔刷,画笔,刷子",
    "brush-2": "刷子",
    "brush-3": "刷子",
    "brush-4": "刷子",
    "paint-brush": "填色,填充,刷子",
    contrast: "brightness,tonalit,对比度,亮度,色调",
    "contrast-2": "moon,dark,brightness,tonalit,月亮,夜间,对比度,亮度,色调",
    drop: "water,blur,模糊,水,滴",
    "blur-off": "water,drop,slash,模糊,水,滴,禁止,关闭",
    "contrast-drop": "water,brightness,tonalit,水,对比度,亮度,色调,滴",
    "contrast-drop-2": "water,brightness,tonalit,水,对比度,亮度,色调,滴",
    "color-filter": "effect,滤镜,特效",
    compasses: "圆规",
    "compasses-2": "圆规",
    scissors: "剪刀,裁剪",
    "scissors-cut": "剪刀,裁剪",
    "scissors-2": "剪刀,裁剪,截屏",
    slice: "knife,切图,切片,刀",
    eraser: "remove formatting,橡皮,擦除,清除格式",
    ruler: "尺子",
    "ruler-2": "尺子",
    "pencil-ruler": "design,铅笔,尺子,文具,设计",
    "pencil-ruler-2": "design,铅笔,尺子,文具,设计",
    "t-box": "文字,字体,字号",
    "input-method": "输入法,文字",
    artboard: "grid,crop,画板,裁切",
    "artboard-2": "画板",
    crop: "裁切",
    "crop-2": "裁切",
    screenshot: "capture,屏幕截图,截屏",
    "screenshot-2": "capture,屏幕截图,截屏",
    focus: "aim,target,goal,焦点,聚焦,目标,靶心",
    "focus-2": "aim,target,goal,bullseye,焦点,聚焦,目标,靶心",
    "focus-3": "aim,target,goal,bullseye,crosshair,locate,焦点,聚焦,目标,靶心,瞄准镜,准心,定位",
    crosshair: "aim,target,goal,bullseye,crosshair,locate,焦点,聚焦,目标,靶心,瞄准镜,准心,定位",
    "crosshair-2": "aim,target,goal,bullseye,crosshair,locate,焦点,聚焦,目标,靶心,瞄准镜,准心,定位",
    paint: "fill,填色,填充,油漆桶",
    palette: "color,调色盘,色板",
    pantone: "color,色板,潘通色,色号",
    shape: "border,形状,描边,边框",
    "shape-2": "border,形状,描边,边框",
    magic: "fantasy,magic stick,beautify,wand,魔法棒,美化,幻想,魔幻",
    anticlockwise: "rotate,left,counterclockwise,左翻转,左旋转",
    "anticlockwise-2": "rotate,left,counterclockwise,左翻转,左旋转",
    clockwise: "rotate,right,右翻转,右旋转",
    "clockwise-2": "rotate,right,右翻转,右旋转",
    hammer: "tool,锤子",
    tools: "settings,screwdriver,configuration,工具,设置",
    "drag-drop": "drag and drop,mouse,拖拽,鼠标",
    table: "表格",
    "table-alt": "表格",
    layout: "布局",
    "layout-2": "collage,布局,拼贴画",
    "layout-3": "collage,布局,拼贴画",
    "layout-4": "collage,布局,拼贴画",
    "layout-5": "collage,布局,拼贴画",
    "layout-6": "collage,布局,拼贴画",
    "layout-column": "左右布局",
    "layout-row": "上下布局",
    "layout-top": "顶部布局,顶部导航",
    "layout-right": "右侧布局,右侧导航",
    "layout-bottom": "底部布局,底部导航",
    "layout-left": "左侧布局,左侧导航",
    "layout-top-2": "顶部布局,顶部导航",
    "layout-right-2": "右侧布局,右侧导航",
    "layout-bottom-2": "底部布局,底部导航",
    "layout-left-2": "左侧布局,左侧导航",
    "layout-grid": "卡片布局,网格",
    "layout-grid-2": "卡片布局,网格",
    "layout-masonry": "collage,瀑布流布局,拼贴画",
    collage: "瀑布流布局,拼贴画",
    grid: "table,网格,表格",
    circle: "圆形",
    triangle: "三角形",
    pentagon: "五边形,五角形",
    hexagon: "六边形",
    octagon: "八边形",
    square: "正方形",
    rectangle: "长方形,矩形",
    shapes: "形状,模块",
    shadow: "投影,影子",
    "layout-horizontal": "水平布局",
    "layout-vertical": "垂直布局",
    "flip-horizontal-2": "水平翻转",
    "flip-horizontal": "水平翻转",
    "flip-vertical": "垂直翻转",
    "flip-vertical-2": "垂直翻转",
    "align-item-horizontal-center": "水平居中",
    "align-item-vertical-center": "垂直居中",
    "align-item-left": "左对齐",
    "align-item-top": "顶部对齐",
    "align-item-right": "右对齐",
    "align-item-bottom": "底部对齐"
  },
  Development: {
    bug: "虫子",
    "bug-2": "虫子",
    code: "代码,编程",
    "code-s": "代码,编程",
    "code-s-slash": "代码,编程",
    "code-box": "代码,编程",
    "terminal-box": "code,command line,prompt,终端,代码,命令行",
    terminal: "code,command line,prompt,终端,代码,命令行",
    "terminal-window": "code,command line,browser,app,ui,终端,代码,命令行",
    parentheses: "code,math,小括号",
    brackets: "code,math,中括号",
    braces: "code,math,大括号,花括号",
    command: "apple key,place of interest,modified key,花键,苹果键",
    cursor: "mouse,pointer,arrow,指针,鼠标",
    "git-commit": "node,onewheel,circle line,dot line,history point,提交",
    "git-pull-request": "合并申请",
    "git-merge": "combine,unite,branch,split,diverge,合并",
    "git-branch": "combine,unite,split,diverge,分支",
    "git-fork": "",
    "git-close-pull-request": "取消,关闭",
    "git-pr-draft": "pull request,草稿",
    "git-repository": "book,bookmark,仓库",
    "git-repository-commits": "book,upload,仓库,提交",
    "git-repository-private": "lock,secure,私密仓库,私人仓库",
    html5: "html,h5,web",
    css3: "css,web,styles",
    javascript: "js,脚本",
    puzzle: "plugins,拼图,插件",
    "puzzle-2": "plugins,拼图,插件"
  },
  Device: {
    tv: "television,antenna,rabbet ears,电视",
    "tv-2": "monitor,display,screen,television,电视,显示器",
    computer: "pc,monitor,display,screen,电脑,显示器",
    mac: "monitor,imac,display,computer,screen,显示器",
    macbook: "laptop,computer,笔记本",
    cellphone: "手机,电话",
    smartphone: "mobile,手机",
    "mobile-download": "手机,下载",
    tablet: "平板电脑",
    device: "设备",
    phone: "电话",
    instance: "box,nft,cvm,实例,盒子,虚拟机",
    database: "storage,resource,bars,progress,数据库,存储",
    "database-2": "storage,discs,silo,platter,数据库,存储",
    server: "服务器",
    "hard-drive": "disc,storage,硬盘,存储",
    "hard-drive-2": "disc,server,storage,硬盘,服务器,存储",
    "hard-drive-3": "disc,server,storage,硬盘,服务器,存储",
    install: "安装",
    uninstall: "卸载",
    save: "floppy,保存,软盘",
    "save-2": "floppy,保存,软盘",
    "save-3": "floppy,保存,软盘",
    "sd-card": "内存卡",
    "sd-card-mini": "内存卡",
    "sim-card": "电话卡",
    "sim-card-2": "电话卡",
    "dual-sim-1": "sim card,电话卡,卡槽,双卡双待",
    "dual-sim-2": "sim card,电话卡,卡槽,双卡双待",
    "u-disk": "U盘,优盘",
    battery: "电池",
    "battery-charge": "电池,充电",
    "battery-low": "电池,低电量",
    "battery-2": "电池",
    "battery-2-charge": "电池,充电",
    "battery-saver": "电池,省电模式",
    "battery-share": "电池共享,共享电量",
    cast: "mirroring,投屏,无线,广播",
    airplay: "mirroring,投屏,无线",
    cpu: "中央处理器",
    gradienter: "水平仪",
    keyboard: "input,键盘,输入",
    "keyboard-box": "input,键盘,输入",
    mouse: "鼠标",
    sensor: "capacitor,传感器,电容器",
    router: "wifi,signal tower,radio,station,路由器,信号塔,广播,基站,流量",
    radar: "satellite receiver,雷达,卫星接收器,锅",
    gamepad: "consoles,controller,游戏手柄",
    "remote-control": "controller,遥控器",
    "remote-control-2": "controller,遥控器",
    "device-recover": "恢复出厂设置",
    hotspot: "手机热点",
    "phone-find": "找回手机",
    "phone-lock": "锁定手机",
    "rotate-lock": "锁定旋转屏幕",
    restart: "reload,refresh,重启",
    "shut-down": "power off,关机",
    fingerprint: "指纹",
    "fingerprint-2": "指纹",
    barcode: "scan,扫码,条形码,条码",
    "barcode-box": "scan,扫码,条形码,条码",
    "qr-code": "二维码",
    "qr-scan": "二维码,扫描",
    "qr-scan-2": "二维码,扫描",
    scan: "扫描",
    "scan-2": "扫描",
    rss: "feed,subscribe,订阅",
    gps: "signal,定位,信号",
    "base-station": "wifi,signal tower,router,cast,基站,信号塔,路由器,广播,流量",
    bluetooth: "wireless,蓝牙,无线",
    "bluetooth-connect": "wireless,蓝牙,连接,无线",
    wifi: "无线网",
    "wifi-off": "slash,offline,connection-fail,无线网,关闭,断网,链接失败",
    "signal-wifi": "cellular,strength,无线网,信号",
    "signal-wifi-1": "cellular,strength,无线网,信号",
    "signal-wifi-2": "cellular,strength,无线网,信号",
    "signal-wifi-3": "cellular,strength,无线网,信号",
    "signal-wifi-error": "cellular,offline,connection-fail,无线网,断网,链接失败,无信号",
    "signal-wifi-off": "cellular,slash,offline,connection-fail,无线网,关闭,断网,链接失败",
    "wireless-charging": "power,flash,无线充电,闪充",
    "dashboard-2": "仪表盘",
    "dashboard-3": "仪表盘",
    usb: "优盘",
    rfid: "radio,frequency,identification,devices,无线,射频识别",
    ram: "memory,electronics,内存条,记忆卡",
    "ram-2": "memory,electronics,内存条,记忆卡"
  },
  Document: {
    file: "new,paper,文件,文档,新建",
    "file-2": "new,paper,文件,文档,新建",
    "file-3": "new,paper,文件,文档,新建",
    "file-4": "new,paper,文件,文档,新建",
    "sticky-note": "new,paper,文件,文档,新建,便签纸,便利贴",
    "sticky-note-add": "new,paper,文件,文档,新建,便签纸,便利贴,添加",
    "sticky-note-2": "new,paper,文件,文档,新建,便签纸,便利贴",
    "file-edit": "文件,文档,编辑",
    draft: "草稿箱,文件,文档,编辑",
    "file-paper": "文件,文档,纸,谱",
    "file-paper-2": "文件,文档,纸,谱",
    receipt: "收据,凭据",
    "file-text": "文件,文档,文本",
    "file-list": "清单,列表",
    "file-list-2": "清单,列表",
    "file-list-3": "newspaper,清单,列表,报纸",
    bill: "账单",
    "file-copy": "duplicate,clone,复制,克隆",
    "file-copy-2": "duplicate,clone,复制,克隆",
    clipboard: "copy,复制,剪切板",
    survey: "research,questionnaire,clipboard,checkboxes,form,census,调查,问卷,调研",
    article: "newspaper,document,publisher,print,page,word,file,publication,文章,报纸",
    newspaper: "新闻,报纸",
    news: "blog,新闻,博客",
    "file-zip": "7z,rar,压缩包",
    "file-marked": "文件,文档,标记",
    task: "todo,任务,待办",
    todo: "待办",
    book: "read,dictionary,booklet,书,阅读,字典,小册子",
    "book-marked": "read,dictionary,booklet,书,阅读,字典,小册子,书签",
    "book-2": "read,dictionary,booklet,书,阅读,字典,小册子",
    "book-3": "read,dictionary,booklet,书,阅读,字典,小册子",
    "book-open": "read,booklet,magazine,书,阅读,小册子,杂志",
    "book-read": "booklet,magazine,书,阅读,小册子,杂志",
    "contacts-book": "通讯录,联系人",
    "contacts-book-2": "通讯录,联系人",
    "contacts-book-upload": "upload,通讯录,联系人,上传",
    booklet: "notebook,手册,笔记本,小册子",
    "contacts-book-3": "通讯录,联系人",
    "file-code": "config,文件,文档,代码,脚本,配置文件",
    "file-pdf": "文件,文档",
    "file-pdf-2": "文件,文档",
    "file-word": "文档",
    "file-ppt": "文件,文档",
    "file-excel": "文档,表单",
    "file-word-2": "文档",
    "file-ppt-2": "文件,文档",
    "file-excel-2": "文档,表单",
    "file-hwp": "文件,文档,hangul word processor",
    keynote: "演示文稿,幻灯片,讲演",
    numbers: "表格",
    pages: "website,browser,ui,blocks,prototype,文稿",
    "file-search": "文件,文档,搜索",
    "file-add": "page,document,new,plus,add,文件,文档,新建",
    "file-reduce": "page,document,subtract,delete,文件,文档,减",
    "file-settings": "page,document,cog,gear,文件,文档,设置",
    "file-upload": "page,document,文件,文档,上传",
    "file-transfer": "page,document,文件,文档,传输",
    "file-download": "page,document,文件,文档,下载",
    "file-lock": "page,document,文件,文档,锁",
    "file-chart": "page,document,report,文件,文档,柱状图,报表",
    "file-chart-2": "report,文件,文档,饼图,报表",
    "file-image": "文件,文档,图片",
    "file-music": "文件,文档,音乐",
    "file-video": "文件,文档,视频",
    "file-gif": "文件,文档,动图",
    "file-check": "文件,文档,对勾",
    "file-close": "文件,文档,关闭,删除,错误",
    "file-forbid": "文件,文档,禁用",
    "file-info": "文件,文档,信息",
    "file-warning": "page,document,paper,!,alert,important,exclamation,文件,文档,警告,提醒",
    "file-unknow": "文件,文档,未知,问号",
    "file-user": "文件,文档,用户",
    "file-shield": "protected,secured,文件,文档,盾牌,保护,安全",
    "file-shield-2": "protected,secured,文件,文档,盾牌,保护,安全",
    "file-damage": "breakdown,broken,corrupt,文件,文档,损坏,破损,破裂",
    "file-history": "record,文件,文档,记录,历史",
    "file-shred": "shredder,shred,destroy,cut,文档,销毁,碎纸机,破裂,粉碎",
    "file-cloud": "network,文件,文档,云",
    contract: "examine,apporove,合约,合同,考试,审批通过",
    folder: "directory,file,文件夹,目录,文档",
    "folder-2": "directory,file,文件夹,目录,文档",
    "folder-3": "directory,file,文件夹,目录,文档",
    "folder-4": "directory,file,文件夹,目录,文档",
    "folder-5": "directory,file,文件夹,目录,文档",
    "folder-6": "directory,file,文件夹,目录,文档",
    folders: "directory,file,文件夹,目录,文档,批量",
    "folder-add": "directory,file,文件夹,目录,文档,添加",
    "folder-reduce": "directory,file,remove,subtract,文件夹,目录,文档,减",
    "folder-settings": "directory,file,文件夹,目录,文档,设置",
    "folder-upload": "directory,file,文件夹,目录,文档,上传",
    "folder-transfer": "directory,file,文件夹,目录,文档,传输",
    "folder-download": "directory,file,文件夹,目录,文档,下载",
    "folder-lock": "directory,file,文件夹,目录,文档,锁",
    "folder-chart": "report,文件夹,目录,文档,柱状图,报表",
    "folder-chart-2": "report,文件夹,目录,文档,饼图,报表",
    "folder-music": "directory,file,audio,sound,文件夹,目录,文档,音乐",
    "folder-image": "directory,file,文件夹,目录,文档,图片",
    "folder-video": "directory,file,文件夹,目录,文档,视频",
    "folder-check": "directory,file,文件夹,目录,文档,对勾",
    "folder-close": "directory,file,文件夹,目录,文档,错误",
    "folder-forbid": "directory,file,文件夹,目录,文档,禁用",
    "folder-info": "directory,file,文件夹,目录,文档,信息",
    "folder-warning": "!,alert,important,exclamation,alert,directory,file,文件夹,目录,文档,警告,提醒",
    "folder-unknow": "directory,file,文件夹,目录,文档,未知",
    "folder-user": "directory,file,文件夹,目录,文档,用户",
    "folder-shield": "directory,file,protected,secured,文件夹,目录,文档,保护,盾牌,安全",
    "folder-shield-2": "directory,file,protected,secured,文件夹,目录,文档,保护,盾牌,安全",
    "folder-shared": "directory,file,文件夹,目录,文档,分享",
    "folder-received": "directory,file,文件夹,目录,文档,接收",
    "folder-open": "directory,file,文件夹,目录,文档,打开",
    "folder-keyhole": "directory,encryption,file,文件夹,目录,文档,打开,加密文档",
    "folder-zip": "directory,file,文件夹,目录,文档,打开,压缩",
    "folder-history": "directory,file,record,文件夹,目录,文档,记录,历史",
    "folder-cloud": "directory,file,云文件夹,目录,云文档",
    markdown: "arrow,箭头,下"
  },
  Editor: {
    bold: "加粗",
    italic: "斜体",
    heading: "标题",
    text: "字体",
    "font-family": "字体",
    "font-sans-serif": "衬线体",
    "font-sans": "非衬线体",
    "font-mono": "等宽字体",
    "font-color": "文字色",
    "font-size": "字号,字体大小",
    "font-size-2": "字号,字体大小",
    underline: "下划线",
    overline: "上划线",
    emphasis: "着重号",
    "emphasis-cn": "着重号",
    strikethrough: "remove formatting,del,删除线",
    "strikethrough-2": "remove formatting,del,删除线",
    "format-clear": "remove formatting,清除格式",
    "align-left": "ragged right,左对齐",
    "align-center": "居中对齐",
    "align-right": "ragged left,右对齐",
    "align-justify": "four,lines,ruled,left-right,full width,排列对齐",
    "align-top": "two arrows up,double-up,start,顶部对齐",
    "align-vertically": "centered,middle,balance,垂直对齐",
    "align-bottom": "two arrows down,double-down,end,底部对齐",
    "list-check": "check list,清单列表",
    "list-check-2": "check list,清单列表",
    "list-check-3": "check list,清单列表,问卷,task",
    "list-ordered": "numbered list,有序列表",
    "list-ordered-2": "numbered list,有序列表",
    "list-unordered": "bullet list,无序列表",
    "list-radio": "vote,投票,列表",
    "list-indefinite": "列表",
    "indent-decrease": "indent more,quote,缩进",
    "indent-increase": "indent less,quote,缩进",
    "line-height": "leading,行高",
    "text-spacing": "letter spacing,character spacing,kerning,tracking,字间距",
    "text-wrap": "return,文本换行",
    "attachment-2": "annex,paperclip,附件,曲别针",
    link: "connection,address,联系,链接,地址",
    "link-unlink": "connection,remove address,去除链接",
    "link-m": "connection,address,联系,链接,地址",
    "link-unlink-m": "connection,remove address,去除链接",
    separator: "分割线",
    space: "空格",
    "page-separator": "insert,分页符,插入",
    "code-view": "代码视图",
    "quote-text": "引用",
    "double-quotes-l": "left,quotaion marks,双引号",
    "double-quotes-r": "right,quotaion marks,双引号",
    "single-quotes-l": "left,quotaion marks,单引号",
    "single-quotes-r": "right,quotaion marks,单引号",
    "table-2": "表格",
    "table-3": "表格",
    subscript: "角标,下标,脚注",
    "subscript-2": "角标,下标,脚注",
    superscript: "角标,上标",
    "superscript-2": "角标,上标",
    paragraph: "¶,pilcrow,段落",
    "text-direction-l": "文本左对齐",
    "text-direction-r": "文本左对齐",
    functions: "Σ,sum,sigma,功能",
    omega: "Ω,horseshoe,特殊符号",
    hashtag: "#,pound,number,井号",
    asterisk: "*,all,everything,wildcard,星号",
    "question-mark": "?,问号",
    "info-i": "information,信息",
    translate: "translator,翻译",
    "translate-2": "translator,翻译",
    "a-b": "a/b testing,ab testing,split test,either-or,ab测试",
    "english-input": "英文输入法",
    "pinyin-input": "拼音输入法",
    "wubi-input": "五笔输入法",
    "input-cursor-move": "移动输入光标",
    "number-1": "1,一,数字",
    "number-2": "2,二,数字",
    "number-3": "3,三,数字",
    "number-4": "4,四,数字",
    "number-5": "5,五,数字",
    "number-6": "6,六,数字",
    "number-7": "7,七,数字",
    "number-8": "8,八,数字",
    "number-9": "9,九,数字",
    "number-0": "0,零,数字",
    "sort-asc": "ranking,ordering,sorting,ascending,descending,升序排列,排序,顺序",
    "sort-desc": "ranking,ordering,降序排列,排序",
    "sort-alphabet-asc": "ranking,ordering,升序排列,数字排序,顺序",
    "sort-alphabet-desc": "ranking,ordering,降序排列,字母排序,倒序,倒序",
    "sort-number-asc": "ranking,ordering,升序排列,数字排序,顺序",
    "sort-number-desc": "ranking,ordering,降序排列,数字排序,倒序",
    "bring-forward": "arrange,层级,向上一层",
    "send-backward": "arrange,层级,向下一层",
    "bring-to-front": "arrange,层级,移到最前面",
    "send-to-back": "arrange,层级,移到最后面",
    "h-1": "heading,一级标题",
    "h-2": "heading,一级标题",
    "h-3": "heading,一级标题",
    "h-4": "heading,一级标题",
    "h-5": "heading,一级标题",
    "h-6": "heading,一级标题",
    "insert-column-left": "添加列,左侧",
    "insert-column-right": "添加列,右侧",
    "insert-row-top": "添加行,顶部",
    "insert-row-bottom": "添加行,底部",
    "delete-column": "删除列,底部",
    "delete-row": "添加行,底部",
    "merge-cells-horizontal": "合并单元格",
    "merge-cells-vertical": "合并单元格",
    "split-cells-horizontal": "拆分单元格",
    "split-cells-vertical": "拆分单元格",
    "flow-chart": "流程图",
    "mind-map": "mindmap,脑图,思维导图",
    "node-tree": "节点,层级关系图",
    "organization-chart": "组织架构图,局域网",
    "rounded-corner": "圆角",
    sketching: "signature,手写,手绘,签名",
    draggable: "move,reorder,拖拽,排序",
    "slash-commands": "命令,斜线",
    "slash-commands-2": "命令,斜线",
    "ai-generate": "AI自动生成",
    "dropdown-list": "下拉菜单",
    "code-block": "代码块",
    "text-snippet": "文字片段,剪切板",
    "text-block": "文字块,文字片段",
    "table-view": "表格视图",
    "kanban-view": "看板视图",
    "kanban-view-2": "看板视图",
    "gallery-view": "画廊视图",
    "gallery-view-2": "画廊视图",
    "timeline-view": "时间轴视图,甘特图",
    "calendar-view": "日历视图",
    "list-view": "列表视图",
    "focus-mode": "聚焦模式,沉浸模式",
    "slideshow-view": "幻灯片视图",
    "stacked-view": "堆叠视图",
    "carousel-view": "循环播放视图",
    "input-field": "cursor,输入框,光标",
    hand: "drag,手,拖拽",
    "square-root": "formula,开根号,公式,计算",
    formula: "公式,计算"
  },
  Finance: {
    wallet: "pocketbook,钱包,卡包",
    "wallet-2": "money clip,钱包,卡包",
    "wallet-3": "money clip,钱包,卡包",
    "bank-card": "credit,purchase,payment,cc,银行卡,信用卡,购买,消费,支付",
    "bank-card-2": "credit,purchase,payment,cc,银行卡,信用卡,购买,消费,支付",
    "secure-payment": "credit,purchase,payment,cc,银行卡,信用卡,购买,消费,支付,安全",
    refund: "credit card,repayment,cc,银行卡,信用卡还款",
    "refund-2": "credit card,repayment,cc,银行卡,信用卡还款",
    safe: "vault,secure,保险柜,保险箱",
    "safe-2": "vault,insecure,unlocked,保险柜,保险箱",
    "price-tag": "label,标签,价签",
    "price-tag-2": "label,标签,价签",
    "price-tag-3": "label,标签,价签",
    ticket: "coupon,票,优惠券,代金券",
    "ticket-2": "coupon,票,优惠券,代金券",
    coupon: "ticket,票,优惠券,代金券",
    "coupon-2": "ticket,票,优惠券,代金券",
    "coupon-3": "ticket,票,优惠券,代金券",
    "coupon-4": "优惠券,代金券",
    "coupon-5": "优惠券,代金券",
    "shopping-bag": "purse,购物袋,购买,消费,商城",
    "shopping-bag-2": "购物袋,购买,消费,商城",
    "shopping-bag-3": "购物袋,购买,消费,商城",
    "shopping-basket": "购物篮,购买,消费,商城",
    "shopping-basket-2": "购物篮,购买,消费,商城",
    "shopping-cart": "购物车,购买,消费,商城",
    "shopping-cart-2": "购物车,购买,消费,商城",
    vip: "会员",
    "vip-crown": "king,queen,皇冠,会员,国王,女王,王后",
    "vip-crown-2": "king,queen,皇冠,会员,国王,女王,王后",
    "vip-diamond": "钻石,会员",
    trophy: "奖品,奖杯,金杯",
    exchange: "swap,交换,换算,兑换,交易",
    "exchange-box": "swap,交换,换算,兑换,交易",
    "exchange-2": "swap,交换,换算,兑换,交易",
    swap: "exchange,交换,换算,兑换,交易",
    "swap-box": "exchange,交换,换算,兑换,交易",
    "swap-2": "flow direction,exchange,交换,换算,兑换,交易",
    "swap-3": "flow direction,exchange,交换,换算,兑换,交易",
    "exchange-dollar": "swap,transfer,交换,换算,兑换,美元,转账,交易",
    "exchange-cny": "swap,transfer,交换,换算,兑换,人民币,转账,交易",
    "exchange-funds": "swap,transfer,交换,换算,兑换,基金,股票,转账,交易",
    "increase-decrease": "计算器",
    percent: "百分之,百分比",
    "copper-coin": "currency,payment,铜币,硬币,货币,钱,支付",
    "copper-diamond": "currency,coins,金币,钻石,货币,钱,支付",
    "money-cny-box": "currency,payment,货币,钱,支付,人民币",
    "money-cny-circle": "currency,coins,金币,payment,货币,钱,支付,人民币",
    "money-dollar-box": "currency,payment,货币,钱,支付,美元",
    "money-dollar-circle": "currency,coins,金币,payment,cent,penny,货币,钱,支付,美元,美分,便士",
    "money-euro-box": "currency,payment,货币,钱,支付,欧元",
    "money-euro-circle": "currency,coins,金币,payment,货币,钱,支付,欧元",
    "money-pound-box": "currency,payment,货币,钱,支付,英镑",
    "money-pound-circle": "currency,coins,金币,payment,货币,钱,支付,英镑",
    "money-rupee-circle": "currency,coins,金币,payment,货币,钱,支付,卢比",
    "bit-coin": "currency,payment,货币,钱,比特币",
    coin: "金币,硬币",
    cash: "现金,钞票",
    coins: "金币,硬币",
    currency: "cash,payment,货币,钱",
    funds: "foundation,stock,基金,股票",
    "funds-box": "foundation,stock,基金,股票",
    "red-packet": "红包",
    "water-flash": "水电费",
    stock: "股票",
    auction: "hammer,gavel,拍卖,锤子",
    gift: "present,礼物",
    "gift-2": "present,礼物",
    "hand-coin": "donate,business,捐赠",
    "hand-heart": "help,donate,volunteer,welfare,帮助,爱心,捐赠,志愿者,公益",
    "24-hours": "last,24小时营业",
    nft: "token",
    p2p: "trade,点对点,交易",
    "token-swap": "cryptocurrency,数字货币,代币,兑换",
    btc: "cryptocurrency,数字货币,bitcoin,比特币",
    eth: "cryptocurrency,数字货币,ethereum,以太坊",
    xtz: "cryptocurrency,数字货币,tezos,兔子币",
    bnb: "cryptocurrency,数字货币,binance,币安币",
    xrp: "cryptocurrency,数字货币,ripple,瑞波币",
    "discount-percent": "promotion,sale,折扣,促销,打折",
    "shopping-bag-4": "购物车,购买,消费,商城"
  },
  Food: {
    restaurant: "餐厅,饭店",
    "restaurant-2": "餐厅,饭店",
    cup: "tea,coffee,杯子,咖啡,茶",
    goblet: "cup,wine glass,cocktail,高脚杯,酒杯,鸡尾酒",
    "goblet-2": "cup,wine glass,cocktail,高脚杯,酒杯,鸡尾酒",
    beer: "cup,啤酒杯",
    cake: "anniversary,蛋糕",
    "cake-2": "anniversary,蛋糕,生日,蜡烛",
    "cake-3": "蛋糕,生日,蜡烛",
    knife: "菜刀",
    "knife-blood": "crime,菜刀,犯罪,血,杀人",
    bread: "toast,吐司面包",
    drinks: "beverage,coffee,饮料,咖啡",
    "drinks-2": "beverage,juice,饮料,果汁",
    bowl: "soup,碗,汤"
  },
  "Health & Medical": {
    heart: "like,love,favorite,心,喜欢,爱,收藏",
    "heart-2": "like,love,favorite,心,喜欢,爱,收藏",
    "heart-3": "like,love,favorite,心,喜欢,爱,收藏",
    "heart-add": "like,love,favorite,心,喜欢,爱,收藏",
    "heart-add-2": "like,love,favorite,心,喜欢,爱,收藏",
    dislike: "like,love,remove favorite,心,不喜欢,取消收藏",
    hearts: "romance,爱情,浪漫,心",
    "heart-pulse": "heart rate,脉搏,心率",
    pulse: "wave,heart rate,脉搏,心率,波",
    empathize: "care,heart,同理心,关爱,心",
    nurse: "doctors,医生,护士",
    dossier: "病例",
    "health-book": "健康手册,医疗手册",
    "first-aid-kit": "case,急救箱",
    capsule: "medicine,胶囊,药",
    "medicine-bottle": "药瓶",
    flask: "testing,experimental,experiment,烧瓶,实验,试验",
    "test-tube": "testing,experimental,experiment,试管,实验,试验",
    dropper: "eyedropper,color picker,color dropper,实验,试验,胶头滴管,取色器",
    microscope: "testing,experimental,experiment,显微镜,实验,试验",
    "hand-sanitizer": "alcohol,酒精消毒洗手液",
    "mental-health": "心理健康",
    psychotherapy: "心理治疗",
    stethoscope: "听诊器",
    syringe: "注射器",
    thermometer: "体温计",
    "infrared-thermometer": "红外线体温计,体温枪",
    "surgical-mask": "外科医用口罩",
    virus: "病毒",
    lungs: "肺部",
    "rest-time": "close,休息时间,打烊",
    zzz: "睡觉",
    brain: "think,ai,大脑,思考,人工智能",
    "brain-2": "think,ai,大脑,思考,人工智能",
    aed: "flash,心脏电击去颤器",
    "aed-electrodes": "电极",
    dna: "health,medical,people,DNA,gene,基因,健康,医疗"
  },
  Logos: {
    alipay: "zhifubao,支付宝",
    "alibaba-cloud": "阿里云",
    amazon: "亚马逊",
    android: "applications,安卓,应用",
    angularjs: "angular,programing framework",
    "app-store": "applications,苹果应用商店",
    apple: "苹果",
    baidu: "du,claw,百度,爪",
    bard: "google,ai,magic,star,shining,sparkling,twinkle,人工智能,魔法,星星,闪烁",
    behance: "behance",
    bilibili: "哔哩哔哩",
    blender: "3d",
    blogger: "博客",
    bluesky: "",
    bootstrap: "",
    centos: "linux,system,系统",
    chrome: "谷歌浏览器",
    codepen: "代码笔",
    copilot: "github,飞行员",
    coreos: "linux,system,系统",
    dingding: "钉钉",
    discord: "game,chat",
    disqus: "comments",
    douban: "豆瓣",
    dribbble: "追波",
    drive: "google drive,谷歌云端硬盘",
    dropbox: "多宝箱",
    edge: "microsoft edge,edge浏览器",
    "edge-new": "microsoft-edge,浏览器",
    evernote: "印象笔记",
    facebook: "脸书",
    "facebook-circle": "脸书",
    "facebook-box": "脸书",
    finder: "macintosh,仿达",
    firebase: "",
    firefox: "火狐浏览器",
    flickr: "",
    flutter: "google",
    friendica: "",
    gatsby: "gatsby",
    gemini: "ai,star",
    github: "github",
    gitlab: "gitlab",
    google: "谷歌",
    "google-play": "applications,谷歌应用商店",
    "honor-of-kings": "game,王者荣耀",
    ie: "internet explorer,浏览器",
    instagram: "照片墙",
    invision: "invision",
    "kakao-talk": "kakao talk,chat",
    line: "连我",
    linkedin: "领英",
    "linkedin-box": "领英",
    java: "",
    kick: "",
    "microsoft-loop": "Doc,笔记",
    mastercard: "bank card,银行卡",
    mastodon: "mastodon,长毛象",
    medium: "媒体",
    messenger: "facebook,脸书,信使",
    meta: "元",
    microsoft: "windows,窗户,微软",
    "mini-program": "微信小程序",
    "netease-cloud-music": "netease cloud music,网易云音乐",
    netflix: "网飞",
    nextjs: "",
    nodejs: "",
    notion: "notes,doc,笔记,文档",
    npmjs: "npm,nodejs",
    openai: "人工智能",
    openbase: "",
    "open-source": "opensource,开源",
    opera: "欧朋浏览器",
    patreon: "donate,money,捐赠,打赏",
    paypal: "贝宝",
    pinterest: "拼趣",
    pixelfed: "photography,pixelfed",
    playstation: "ps",
    "product-hunt": "product hunt",
    qq: "penguin,tencent,腾讯,企鹅",
    reactjs: "react,programing framework,facebook",
    reddit: "reddit",
    remixicon: "remix icon,图标",
    "remix-run": "",
    safari: "safari浏览器",
    skype: "skype",
    slack: "slack",
    snapchat: "ghost,色拉布,幽灵",
    soundcloud: "声云",
    spectrum: "spectrum",
    spotify: "music,音乐",
    "stack-overflow": "stack overflow",
    stackshare: "share,分享,技术栈",
    steam: "game,store",
    supabase: "",
    svelte: "",
    switch: "nintendo,任天堂",
    "tailwind-css": "",
    taobao: "淘宝",
    telegram: "telegram",
    "telegram-2": "",
    threads: "",
    tiktok: "抖音",
    trello: "trello",
    tumblr: "汤博乐",
    twitch: "twitch",
    twitter: "推特",
    "twitter-x": "推特",
    ubuntu: "linux,system,系统",
    unsplash: "photos",
    vimeo: "视频",
    vk: "",
    visa: "bank card,银行卡",
    vuejs: "vue,programing framework",
    webhook: "",
    wechat: "微信",
    "wechat-2": "微信",
    "wechat-channels": "微信视频号",
    "wechat-pay": "微信支付",
    weibo: "新浪微博",
    whatsapp: "瓦次艾普",
    windows: "microsoft,窗户,微软",
    wordpress: "blog,博客",
    xbox: "xbox",
    xing: "xing",
    youtube: "优兔,油管",
    yuque: "语雀",
    zcool: "zcool,站酷",
    zhihu: "知乎"
  },
  Map: {
    "map-pin": "location,navigation,地图,坐标,定位,导航,位置",
    "map-pin-2": "location,navigation,地图,坐标,定位,导航,位置",
    "map-pin-3": "location,navigation,地图,坐标,定位,导航,位置",
    "map-pin-4": "location,navigation,地图,坐标,定位,导航,位置",
    "map-pin-5": "location,navigation,地图,坐标,定位,导航,位置",
    "map-pin-add": "location,navigation,地图,坐标,定位,导航,位置,新增,添加",
    "map-pin-range": "location,navigation,地图,坐标,定位,导航,位置,范围",
    "map-pin-time": "location,navigation,地图,坐标,定位,导航,位置,时间",
    "map-pin-user": "location,navigation,地图,坐标,定位,导航,位置,用户",
    "pin-distance": "坐标,距离",
    pushpin: "图钉",
    unpin: "图钉,取消固定",
    "pushpin-2": "图钉",
    compass: "navigation,safari,direction,discover,指南针,导航,方向,发现,探索",
    "compass-2": "navigation,direction,discover,指南针,导航,方向,发现,探索",
    "compass-3": "navigation,safari,direction,discover,指南针,导航,方向,发现,探索",
    "compass-4": "navigation,direction,discover,指南针,导航,方向,发现,探索",
    "compass-discover": "navigation,direction,指南针,导航,方向,发现,探索",
    anchor: "锚",
    "china-railway": "中铁,铁路,火车",
    "space-ship": "太空飞船",
    rocket: "火箭",
    "rocket-2": "space ship,火箭,太空飞船",
    map: "navigation,travel,地图,导航,旅行",
    "map-2": "location,navigation,travel,地图,定位,导航,旅行",
    "treasure-map": "thriller,adventure,地图,藏宝图",
    "road-map": "navigation,travel,地图,导航,旅行",
    earth: "global,union,world,language,地球,全球,联合,世界,语言",
    "time-zone": "global,地球,时区,时间",
    globe: "earth,地球仪",
    planet: "space,discover,星球,宇宙,探索,发现",
    parking: "停车场",
    "parking-box": "停车场",
    route: "path,路线",
    guide: "path,指引,路线",
    "gas-station": "加气站,加油站",
    "charging-pile": "充电桩",
    "charging-pile-2": "充电桩",
    car: "汽车",
    "car-washing": "汽车,洗车",
    roadster: "car,汽车,跑车",
    taxi: "car,出租车,汽车",
    "taxi-wifi": "car,出租车,汽车",
    "police-car": "汽车,警车",
    bus: "大巴,巴士",
    "bus-2": "大巴,巴士",
    "bus-wifi": "大巴,巴士",
    truck: "van,delivery,卡车,货车,运输",
    train: "火车",
    "train-wifi": "火车",
    subway: "地铁",
    "subway-wifi": "地铁",
    "flight-takeoff": "airplane,plane,origin,起飞,出发,始发,起点,飞机",
    "flight-land": "airplane,plane,destination,着陆,到达,抵达,终点,飞机",
    plane: "fight,飞机,航班",
    sailboat: "帆船",
    ship: "轮船,航海,海运",
    "ship-2": "轮船",
    bike: "自行车",
    "e-bike": "take out,takeaway,电动车,外卖",
    "e-bike-2": "take out,takeaway,电动车,外卖",
    takeaway: "take out,takeaway,电动车,外卖",
    motorbike: "摩托车",
    caravan: "房车",
    walk: "步行",
    run: "奔跑,跑步",
    riding: "bike,骑行,自行车",
    barricade: "路障",
    footprint: "脚印,足迹",
    "traffic-light": "交通,信号灯",
    "signal-tower": "base station,antenna,信号塔,基站,天线",
    "hotel-bed": "酒店,床",
    navigation: "gps,导航",
    oil: "汽油,机油",
    direction: "right,方向,右转",
    steering: "drive,方向盘,驾车",
    "steering-2": "drive,方向盘,驾车",
    lifebuoy: "life ring,救生圈",
    passport: "passports,护照",
    suitcase: "travel,旅行,行李箱",
    "suitcase-2": "travel,旅行,行李箱,拉杆箱",
    "suitcase-3": "travel,旅行,boarding case,行李箱,拉杆箱,登机箱",
    "luggage-deposit": "consignment,行李箱,行李寄存,托运",
    "luggage-cart": "行李车",
    signpost: "milestone,路标,路牌,里程碑"
  },
  Media: {
    image: "picture,photo,图片,照片",
    "image-circle": "picture,photo,图片,照片",
    "image-2": "picture,photo,图片,照片",
    "image-add": "picture,photo,图片,照片,添加",
    "image-edit": "picture,photo,图片,照片,编辑",
    landscape: "picture,image,photo,图片,照片",
    gallery: "picture,image,图片,相册",
    "gallery-upload": "picture,image,图片,相册,上传",
    video: "视频",
    movie: "film,video,电影,硬盘,视频",
    "movie-2": "film,video,电影,硬盘,视频",
    film: "movie,video,影片,电影,视频",
    clapperboard: "movie,film,场记板,电影",
    "video-on": "vidicon,camera,摄像机,摄影机,视频",
    "video-off": "vidicon,camera,摄像机,摄影机,视频,关",
    vidicon: "video,camera,摄像机,摄影机,视频",
    "vidicon-2": "camera,摄像机,摄影机",
    live: "video,camera,摄像机,摄影机,视频,直播",
    "video-add": "camera,摄像机,摄影机,视频,添加",
    "video-upload": "camera,摄像机,摄影机,视频,上传",
    "video-download": "camera,摄像机,摄影机,视频,下载",
    dv: "vidicon,camera,摄像机,摄影机",
    camera: "photo,照相机,拍照,照片",
    "camera-off": "photo,slash,照相机,拍照,照片,禁止,关闭",
    "camera-2": "photo,照相机,拍照,照片",
    "camera-3": "photo,照相机,拍照,照片",
    "camera-lens": "aperture,photo,照相机,拍照,照片,朋友圈",
    "camera-switch": "照相机,拍照,翻转",
    polaroid: "camera,相机,宝丽来",
    "polaroid-2": "camera,相机,宝丽来",
    "phone-camera": "手机相机,手机摄像头",
    webcam: "摄像头",
    mv: "music video,音乐",
    music: "音乐",
    "music-2": "音乐",
    disc: "music,album,音乐,唱片",
    album: "music,唱片,音乐",
    dvd: "cd,dvd,record,光盘,刻录",
    headphone: "music,headset,耳机,音乐",
    radio: "收音机,电台",
    "radio-2": "收音机,电台",
    tape: "录音,磁带",
    mic: "record,voice,话筒,语音,录音,声音",
    "mic-2": "record,voice,话筒,语音,录音,声音",
    "mic-off": "record,voice,slash,关闭话筒,关闭语音,录音,关闭声音,静音,禁止",
    "volume-down": "trumpet,sound,speaker,音量低,喇叭,声音,扬声器",
    "volume-mute": "trumpet,sound,off,音量低,喇叭,声音,静音",
    "volume-up": "trumpet,sound,speaker,音量高,喇叭,声音,扬声器",
    "volume-vibrate": "trumpet,sound,speaker,喇叭,声音,扬声器,震动模式",
    "volume-off-vibrate": "trumpet,sound,speaker,静音,喇叭,声音,扬声器,静音模式",
    speaker: "音响",
    "speaker-2": "音响",
    "speaker-3": "音响",
    "surround-sound": "环绕立体声",
    broadcast: "广播",
    notification: "bell,alarm,通知,铃铛,提醒",
    "notification-2": "bell,alarm,通知,铃铛,提醒",
    "notification-3": "bell,alarm,通知,铃铛,提醒",
    "notification-4": "bell,alarm,通知,铃铛,提醒",
    "notification-off": "bell,alarm,silent,slash,通知,铃铛,提醒,免打扰,静音,关闭,禁止",
    "play-circle": "start,播放,开始",
    "pause-circle": "暂停",
    "record-circle": "录音",
    "stop-circle": "停止",
    eject: "推出",
    "play-reverse": "回放",
    play: "start,播放,开始",
    pause: "暂停",
    stop: "停止",
    rewind: "fast,快退",
    speed: "fast,快进",
    "skip-back": "上一曲",
    "skip-forward": "下一曲",
    "rewind-start": "上一曲",
    "forward-end": "下一曲",
    "play-reverse-mini": "回放",
    "play-mini": "播放",
    "pause-mini": "暂停",
    "stop-mini": "停止",
    "rewind-mini": "fast,快退",
    "speed-mini": "fast,快进",
    "skip-back-mini": "上一曲",
    "skip-forward-mini": "下一曲",
    "rewind-start-mini": "上一曲",
    "forward-end-mini": "下一曲",
    "play-reverse-large": "回放",
    "play-large": "start,播放,开始",
    "pause-large": "暂停",
    "stop-large": "停止",
    "replay-5": "playback,重播,回放",
    "forward-5": "skip,快进,快放,跳过",
    "replay-10": "playback,重播,回放",
    "forward-10": "skip,快进,快放,跳过",
    "replay-15": "playback,重播,回放",
    "forward-15": "skip,快进,快放,跳过",
    "replay-30": "playback,重播,回放",
    "forward-30": "skip,快进,快放,跳过",
    memories: "回忆",
    repeat: "swap,交换,循环播放",
    "repeat-2": "swap,交换,循环播放",
    "repeat-one": "单曲循环",
    "order-play": "顺序播放",
    shuffle: "随机播放",
    "play-list": "播放列表",
    "play-list-2": "播放列表",
    "play-list-add": "列表,添加",
    fullscreen: "maximize,全屏,最大化",
    "fullscreen-exit": "minimize,退出全屏,最小化",
    equalizer: "sliders,controls,settings,filter,均衡器,控制器,设置,筛选",
    "equalizer-2": "sliders,controls,settings,filter,均衡器,控制器,设置,筛选",
    "equalizer-3": "sliders,controls,settings,filter,均衡器,控制器,设置,筛选",
    "sound-module": "sliders,controls,settings,filter,均衡器,控制器,设置,筛选",
    rhythm: "节奏,韵律",
    voiceprint: "声纹",
    "speed-up": "dashboard,快,加速,仪表盘",
    "slow-down": "dashboard,慢,减速,仪表盘",
    hq: "high quality,高质量,高品质",
    hd: "high definition,高清晰度",
    "4k": "high definition,high quality,高清晰度,高品质,超清",
    "closed-captioning": "隐藏字幕",
    "aspect-ratio": "宽高比,比例",
    "picture-in-picture": "画中画,小窗",
    "picture-in-picture-2": "画中画,小窗",
    "picture-in-picture-exit": "退出画中画,退出小窗"
  },
  System: {
    apps: "应用",
    "apps-2": "应用",
    "apps-2-add": "添加应用",
    function: "layout,功能,应用,卡片布局",
    "function-add": "添加应用",
    dashboard: "仪表盘",
    "dashboard-horizontal": "仪表盘",
    menu: "navigation,hamburger,导航,菜单,汉堡包",
    "menu-2": "navigation,hamburger,导航,菜单,汉堡包",
    "menu-3": "navigation,hamburger,导航,菜单,汉堡包",
    "menu-4": "navigation,hamburger,导航,菜单,汉堡包",
    "menu-5": "navigation,hamburger,导航,菜单,汉堡包",
    "menu-add": "navigation,hamburger,导航,菜单,汉堡包,添加",
    "menu-fold": "collapse,navigation,hamburger,导航,菜单,汉堡包,收起,展开",
    "menu-unfold": "expand,navigation,hamburger,导航,菜单,汉堡包,收起,展开",
    "menu-unfold-3": "expand,navigation,hamburger,导航,菜单,汉堡包,收起,展开",
    "menu-fold-4": "collapse,navigation,hamburger,导航,菜单,汉堡包,收起,展开",
    "menu-unfold-4": "expand,navigation,hamburger,导航,菜单,汉堡包,收起,展开",
    "menu-fold-3": "collapse,navigation,hamburger,导航,菜单,汉堡包,收起,展开",
    "menu-fold-2": "collapse,navigation,hamburger,导航,菜单,汉堡包,收起,展开",
    "menu-unfold-2": "expand,navigation,hamburger,导航,菜单,汉堡包,收起,展开",
    "menu-search": "category,菜单,搜索",
    more: "ellipsis,更多,省略",
    "more-2": "kebab menu,ellipsis,更多,省略",
    star: "favorite,like,mark,星星,星标,喜欢",
    "star-s": "favorite,like,mark,星星,星标,喜欢,半星",
    "star-half": "favorite,like,mark,星星,星标,喜欢",
    "star-half-s": "favorite,like,mark,星星,星标,喜欢,半星",
    settings: "edit,gear,preferences,偏好设置,编辑,齿轮",
    "settings-2": "edit,gear,preferences,偏好设置,编辑,齿轮",
    "settings-3": "edit,gear,preferences,偏好设置,编辑,齿轮",
    "settings-4": "edit,gear,preferences,偏好设置,编辑,齿轮",
    "settings-5": "edit,gear,preferences,偏好设置,编辑,齿轮",
    "settings-6": "edit,gear,preferences,偏好设置,编辑,齿轮",
    "list-settings": "列表,设置",
    forbid: "prohibited,slash,ban,禁止,禁用",
    "forbid-2": "prohibited,slash,ban,禁止,禁用",
    prohibited: "forbid,lash,ban,禁止,禁用",
    "prohibited-2": "forbid,lash,ban,禁止,禁用",
    information: "i,信息",
    "information-2": "i,信息",
    "information-off": "i,信息,关闭",
    "error-warning": "!,alert,important,alert,exclamation,警告,错误",
    question: "help,问号,帮助",
    alert: "提醒,警告",
    spam: "alert,垃圾邮件,警告",
    "spam-2": "block,alert,垃圾邮件,警告,拦截",
    "spam-3": "block,alert,垃圾邮件,警告,拦截",
    "checkbox-blank": "复选框,空",
    checkbox: "复选框",
    "checkbox-indeterminate": "复选框",
    "add-box": "plus,new,复选框,添加,加号,新增",
    "checkbox-blank-circle": "复选框,空",
    "checkbox-circle": "复选框",
    "indeterminate-circle": "slash,ban,复选框,禁",
    "add-circle": "plus,new,复选框,添加,加号,新增",
    "close-circle": "cancel,remove,delete,empty,x,关闭,取消,移除,删除,清空",
    "radio-button": "单选框",
    "checkbox-multiple-blank": "复选框,空",
    "checkbox-multiple": "复选框,空",
    check: "对勾",
    "check-double": "read,done,double-tick,双对勾,已读",
    close: "cancel,remove,delete,empty,x,关闭,取消,移除,删除,清空",
    add: "plus,new,添加,新增,加号",
    subtract: "minus,减",
    divide: "除以",
    equal: "sum,result,等于",
    "close-large": "cancel,remove,delete,empty,x,关闭,取消,移除,删除,清空",
    "add-large": "lus,new,添加,新增,加号",
    download: "import,receive,下载,接收,导入",
    upload: "export,send,上传,发送,导出",
    "download-2": "import,receive,下载,接收,导入",
    "upload-2": "export,send,上传,发送,导出",
    import: "download,导入,下载",
    export: "upload,导出,上传",
    "download-cloud": "下载,云",
    "upload-cloud": "上传,云",
    "download-cloud-2": "下载,云",
    "upload-cloud-2": "上传,云",
    "login-box": "sign in,登录",
    "logout-box": "sign out,登出,注销",
    "logout-box-r": "sign out,登出,注销",
    "login-circle": "sign in,登录",
    "logout-circle": "sign out,登出,注销",
    "logout-circle-r": "sign out,登出,注销",
    shield: "safety,protect,盾牌,卫士,安全,防御",
    "shield-cross": "safety,protect,盾牌,卫士,安全,防御,闪电",
    "shield-flash": "safety,protect,盾牌,卫士,安全,防御",
    "shield-star": "police badge,safety,protect,盾牌,卫士,安全,防御,星星,警徽",
    "shield-user": "safety,protect,user protected,guarantor,盾牌,卫士,安全,防御,用户",
    "shield-keyhole": "safety,protect,guarantor,盾牌,卫士,安全,防御,钥匙孔",
    "shield-check": "safety,protect,盾牌,卫士,安全,防御",
    "delete-back": "backspace,删除,退格",
    "delete-back-2": "backspace,删除,退格",
    "delete-bin": "trash,remove,ash-bin,garbage,dustbin,uninstall,卸载,删除,垃圾桶",
    "delete-bin-2": "trash,remove,ash-bin,garbage,dustbin,uninstall,卸载,删除,垃圾桶",
    "delete-bin-3": "trash,remove,ash-bin,garbage,dustbin,uninstall,卸载,删除,垃圾桶",
    "delete-bin-4": "trash,remove,ash-bin,garbage,dustbin,uninstall,卸载,删除,垃圾桶",
    "delete-bin-5": "trash,remove,ash-bin,garbage,dustbin,uninstall,卸载,删除,垃圾桶",
    "delete-bin-6": "trash,remove,ash-bin,garbage,dustbin,uninstall,卸载,删除,垃圾桶",
    "delete-bin-7": "trash,remove,ash-bin,garbage,dustbin,uninstall,卸载,删除,垃圾桶",
    lock: "security,password,锁子,安全,密码",
    "lock-2": "security,password,锁子,安全,密码",
    "lock-password": "security,锁子,安全,密码",
    "lock-unlock": "security,password,锁子,安全,密码",
    "lock-star": "security,premium,锁子,安全,密码,会员,高级",
    eye: "watch,view,眼睛,查看",
    "eye-off": "slash,眼睛,不可见,关闭,禁止",
    "eye-2": "watch,view,眼睛,查看",
    "eye-close": "x,闭眼",
    search: "搜索,放大镜",
    "search-2": "搜索,放大镜",
    "search-eye": "搜索,放大镜,眼睛",
    "zoom-in": "放大,放大镜",
    "zoom-out": "缩小,放大镜",
    "find-replace": "查找,搜索,替换",
    share: "sharing,分享,转发",
    "share-2": "sharing,分享,转发",
    "share-box": "sharing,分享,转发",
    "share-circle": "sharing,分享,转发",
    "share-forward": "sharing,分享,转发",
    "share-forward-2": "sharing,分享,转发",
    "share-forward-box": "sharing,分享,转发",
    "external-link": "外链",
    "side-bar": "侧边栏",
    "sidebar-unfold": "expand,展开侧边栏",
    "sidebar-fold": "收起侧边栏",
    time: "clock,时间,时钟,钟表",
    timer: "chronograph,stopwatch,秒表,计时器",
    "timer-2": "chronograph,stopwatch,秒表,计时器",
    "timer-flash": "chronograph,stopwatch,秒表,计时器,闪电",
    alarm: "闹钟",
    history: "record,recent,time machine,历史记录,最近",
    "hourglass-2": "time,history,recent,duration,沙漏,时间,历史记录,最近",
    hourglass: "time,history,recent,duration,沙漏,时间,历史记录,最近",
    "thumb-up": "like,good,喜欢,好",
    "thumb-down": "dislike,bad,不喜欢,不好",
    "alarm-warning": "alert,report,police light,告警,举报,警灯",
    "notification-badge": "red dot,通知,小红点",
    toggle: "switch,开关,触发器",
    filter: "filtration,筛选,过滤",
    "filter-2": "filtration,筛选,过滤",
    "filter-3": "filtration,筛选,过滤",
    "filter-off": "filtration,clear-filter,筛选,过滤",
    loader: "loader,spinner,ajax,waiting,delay,加载中,载入中,正在加载",
    "loader-2": "loader,spinner,ajax,waiting,delay,加载中,载入中,正在加载",
    "loader-3": "loader,spinner,ajax,waiting,delay,加载中,载入中,正在加载",
    "loader-4": "loader,spinner,ajax,waiting,delay,加载中,载入中,正在加载",
    "loader-5": "loader,spinner,ajax,waiting,delay,加载中,载入中,正在加载",
    refresh: "reload,repeat,replace,reset,restart,synchronization,spinner,loader,update,刷新,重新加载,重复,重置,替换,重启,同步,更新",
    "loop-left": "reload,repeat,replace,reset,restart,synchronization,spinner,loader,update,刷新,重新加载,重复,重置,替换,重启,同步,更新",
    "loop-right": "reload,repeat,replace,reset,restart,synchronization,spinner,loader,update,刷新,重新加载,重复,重置,替换,重启,同步,更新",
    "reset-left": "reload,repeat,replace,refresh,restart,synchronization,spinner,loader,update,刷新,重新加载,重复,重置,替换,重启,同步,更新",
    "reset-right": "reload,repeat,replace,refresh,restart,synchronization,spinner,loader,update,刷新,重新加载,重复,重置,替换,重启,同步,更新",
    "progress-1": "percent,进度,百分比",
    "progress-2": "percent,进度,百分比",
    "progress-3": "percent,进度,百分比",
    "progress-4": "percent,进度,百分比",
    "progress-5": "percent,进度,百分比",
    "progress-6": "percent,进度,百分比",
    "progress-7": "percent,进度,百分比",
    "progress-8": "percent,进度,百分比"
  },
  "User & Faces": {
    user: "person,people,用户",
    "user-2": "person,people,用户",
    "user-3": "person,people,用户",
    "user-4": "person,people,用户",
    "user-5": "person,people,用户",
    "user-6": "person,people,用户",
    "user-smile": "person,people,用户,微笑",
    "account-box": "person,people,用户,微笑",
    "account-circle": "person,people,用户,微笑",
    "account-pin-box": "person,people,用户,微笑",
    "account-pin-circle": "person,people,用户,微笑",
    "user-add": "person,people,用户,添加,新增",
    "user-minus": "person,peopl,unfollow,用户,减少,移除",
    "user-follow": "person,people,关注",
    "user-unfollow": "person,people,rejected,用户,取消关注,拒绝,错误",
    "user-shared": "transfer,用户,我分享的,发送,person,people",
    "user-shared-2": "transfer,用户,我分享的,发送,person,people",
    "user-received": "用户,我接收的,收取,person,people",
    "user-received-2": "用户,我接收的,收取,person,people",
    "user-location": "用户,定位,person,people",
    "user-search": "用户,查找,person,people",
    "user-settings": "admin,用户,设置,管理员,person,people",
    "user-star": "用户,关注,person,people",
    "user-heart": "用户,关注,person,people",
    admin: "admin,用户,管理员,person,people",
    "user-forbid": "terminated,禁止,终止",
    contacts: "联系人",
    group: "team,团队,群组,person,people,multiple users,user group",
    "group-2": "team,团队,群组,person,people,multiple users,user group",
    "group-3": "team,团队,群组,person,people,multiple users,user group",
    team: "团队,小组,群主,person,people",
    "user-voice": "用户,录音,演讲",
    emotion: "表情,笑脸",
    "emotion-2": "表情,笑脸",
    "emotion-happy": "表情,开心",
    "emotion-normal": "表情,一般",
    "emotion-unhappy": "表情,不开心",
    "emotion-laugh": "comedy,happy,表情,大笑,笑脸,开心,喜剧",
    "emotion-sad": "drama,tears,悲剧,哭泣,泪",
    skull: "ghost,骷髅,鬼怪",
    "skull-2": "ghost,horror,thriller,骷髅,鬼怪,恐惧,恐怖",
    men: "gender,man,male,男人,男性",
    women: "gender,woman,female,女人,女性",
    travesti: "女人,女性",
    genderless: "女人,女性",
    "open-arm": "张开双臂",
    "body-scan": "gesture recognition,body,扫描身体,体态识别,动作之别,手势识别",
    parent: "patriarch,父母,亲子,家长",
    robot: "AI,mechanic,机器人",
    "robot-2": "AI,mechanic,机器人",
    "robot-3": "AI,mechanic,机器人",
    aliens: "science fiction,ET,外星人,科幻小说",
    "bear-smile": "cartoon,anime,cartoon,小熊,微笑,儿童,动画片,卡通,动漫",
    mickey: "cartoon,disney,迪士尼,米老鼠,微笑,儿童,动画片",
    criminal: "horror,thriller,罪犯,犯罪,恐怖",
    ghost: "horror,thriller,鬼怪,恐怖,恐惧",
    "ghost-2": "horror,鬼怪,恐怖,恐惧",
    "ghost-smile": "鬼怪,笑",
    "star-smile": "animation,动画,微笑,星星",
    spy: "incognito mode,detective,secret,间谍,侦探,无痕模式,隐私模式"
  },
  Weather: {
    sun: "light mode,sunny,太阳,白天模式,晴天",
    moon: "dark mode,night,月亮,夜间模式,月牙",
    flashlight: "闪电",
    cloudy: "多云",
    "cloudy-2": "多云",
    mist: "雾气,雾霾",
    foggy: "大雾",
    "cloud-windy": "风",
    windy: "大风,刮风",
    rainy: "下雨,雨天",
    drizzle: "小雨",
    showers: "中雨",
    "heavy-showers": "大雨",
    thunderstorms: "雷暴,雷阵雨",
    hail: "冰雹",
    snowy: "下雪,雪天",
    snowflake: "下雪,雪天,雪花",
    "sun-cloudy": "晴转多云",
    "moon-cloudy": "夜间多云",
    tornado: "龙卷风",
    typhoon: "cyclone,tornado,龙卷风,旋风,台风",
    haze: "阴霾,薄雾",
    "haze-2": "阴霾,薄雾",
    "sun-foggy": "薄雾",
    "moon-foggy": "薄雾",
    "moon-clear": "夜间模式,夜间无云",
    "temp-hot": "temperature,温度,高温,热",
    "temp-cold": "temperature,温度,低温,冷",
    celsius: "temperature,温度,摄氏度",
    fahrenheit: "temperature,温度,华氏度",
    "water-percent": "humidity,水,百分比,湿度",
    fire: "flame,hot,火,热门",
    blaze: "flame,火灾",
    earthquake: "地震",
    flood: "洪水",
    meteor: "流星,陨石",
    rainbow: "彩虹",
    shining: "star,magic,ai,twinkle,星星,魔法,闪烁",
    "shining-2": "star,magic,ai,twinkle,星星,魔法,闪烁",
    sparkling: "shining,star,magic,ai,twinkle,星星,魔法,闪烁",
    "sparkling-2": "shining,star,magic,ai,twinkle,星星,魔法,闪烁"
  },
  Others: {
    basketball: "sports,篮球,运动,体育",
    bell: "cartoon,anime,doraemon,铃铛,哆啦A梦,卡通,动漫",
    billiards: "sports,运动,台球,8,体育",
    boxing: "sports,运动,拳击,体育",
    "door-lock": "门锁",
    "door-lock-box": "门锁",
    football: "sports,运动,足球,体育",
    game: "pac man,游戏,吃豆人,体育",
    handbag: "fashion,时尚,手提包,女包",
    key: "password,钥匙,密码",
    "key-2": "password,钥匙,密码",
    lightbulb: "energy,creativity,灯泡,能源,白炽灯,能源,电子产品",
    "lightbulb-flash": "energy,creativity,idea,灯泡,白炽灯,能源,闪电,创意,灵感",
    outlet: "二脚插座",
    "outlet-2": "三脚插座",
    plug: "plugin,二脚插头",
    "plug-2": "plugin,三脚插头",
    "ping-pong": "sports,table tennis,运动,乒乓球,球拍,体育",
    reserved: "已预定,会议室屏幕,电视,显示器",
    shirt: "clothes,衬衫,衣服,服饰,西装,西服",
    sword: "war,刀剑,战争,战斗,玄幻,对抗",
    "t-shirt": "skin,theme,T恤,皮肤,主题,服饰",
    "t-shirt-2": "skin,theme,T恤,皮肤,主题,服饰",
    "t-shirt-air": "dry,T恤,风干,烘干,服饰",
    umbrella: "protect,雨伞,保护,保险",
    "character-recognition": "ocr,文字识别",
    "voice-recognition": "asr,语音识别,音频",
    leaf: "energy,ecology,树叶,节能,环保,草,植物",
    plant: "植物,叶子,草,花盆",
    seedling: "树苗,植物,叶子,草",
    tree: "植物,树木",
    recycle: "recyclable,可回收,循环",
    "scales-2": "厨房称",
    scales: "balance,称,天平,天秤",
    "scales-3": "balance,称,天平,天秤",
    fridge: "refrigerator,电冰箱,柜子,服务器",
    wheelchair: "accessbility,轮椅,可访问性,辅助功能,残疾人",
    cactus: "desertr,仙人掌,沙漠,植物",
    door: "门,建筑",
    "door-open": "开门,建筑",
    "door-closed": "关门,建筑",
    "graduation-cap": "cap,school,student,毕业,帽子,学校,学生",
    "box-1": "instance,盒子,实例",
    "box-2": "instance,盒子,实例",
    "box-3": "instance,3d,盒子,实例,立体",
    candle: "蜡烛",
    cross: "tomb,十字架,坟墓",
    infinity: "infinite,endless,loop,forever,math,eternal,无限,循环,永远,永久,永恒",
    goggles: "vr,vision,护目镜",
    glasses: "vision,spectacles,眼镜",
    "glasses-2": "vision,spectacles,眼镜",
    "dice-1": "random,骰子",
    "dice-2": "random,骰子",
    "dice-4": "random,骰子",
    "dice-6": "random,骰子",
    "dice-5": "random,骰子",
    "dice-3": "random,骰子",
    dice: "random,骰子",
    flower: "plant,植物,花",
    armchair: "sofa,seat,手扶椅,沙发,座位",
    sofa: "armchair,seat,手扶椅,沙发,座位",
    tooth: "teeth,牙齿",
    weight: "weight,heavy,dense,kilo,pound,gram,large,重量",
    "police-badge": "警察,警徽",
    "golf-ball": "sports,高尔夫球",
    stairs: "stages,levels,楼梯,步行梯,台阶",
    "book-shelf": "books,library,categories,书架,书籍,图书馆,分类"
  }
}, closeDialogs = /* @__PURE__ */ new Set(), useCloseDialog = (e) => {
  closeDialogs.add(e), onBeforeUnmount(() => {
    closeDialogs.delete(e);
  });
}, closeAllDialogs = () => {
  closeDialogs.forEach((e) => e());
}, useContentHeightFit = (e) => {
  const o = shallowRef(), n = shallowRef(), t = ref(45), r = ref(0), a = "146px", l = computed(() => `calc(${e.value ? "100vh" : `100vh - ${a} - 66px`} - ${t.value}px - ${r.value}px)`), s = new ResizeObserver((d) => {
    d.forEach((p) => {
      const { dataset: f, parentElement: g } = p.target;
      f.tag === "header" ? t.value = g.getBoundingClientRect().height : f.tag === "footer" && (r.value = g.getBoundingClientRect().height);
    });
  }), c = () => {
    o.value && s.observe(o.value.$el || o.value), n.value && s.observe(n.value);
  };
  return onUnmounted(() => {
    s.disconnect();
  }), {
    footerDivRef: o,
    headerDivRef: n,
    contentHeight: l,
    marginTop: a,
    startObserve: c
  };
}, useFullscreen = (e) => ({
  screenClass: computed(() => e.value ? "ri-fullscreen-exit-line" : "ri-fullscreen-line"),
  switchFullMode: (t) => {
    e.value = typeof t == "boolean" ? t : !e.value;
  }
}), useRefSyncProp = (e) => {
  const o = useProp(e), n = ref(o.value);
  return watch(o, (t) => {
    n.value = t;
  }), n;
}, useStateProvide = (e) => {
  const o = ref(!1), n = ref(), t = useRefSyncProp("title"), r = useRefSyncProp("showFooter"), a = shallowRef(), l = shallowRef(), s = shallowRef(), c = shallowRef();
  return provide(DIALOG_REGISTER_OPEN, l), provide(DIALOG_REGISTER_CONFIRM, s), provide(DIALOG_REGISTER_BEFORE_CLOSE, c), provide(DIALOG_REGISTER_CUSTOM_FOOTER, a), provide(DIALOG_STATE, {
    title: t,
    fullscreen: e.fullscreen,
    widthType: e.widthType,
    showFooter: r,
    scrollRef: n,
    close: () => {
      o.value = !1, e.dialogVisible.value = !1;
    }
  }), {
    isLoading: o,
    scrollRef: n,
    title$: t,
    showFooter$: r,
    footerElRegister: a,
    confirmRegister: s,
    beforeCloseRegister: c,
    dialogOpenRegister: l
  };
}, useWidthType = () => {
  const e = {
    mi: "340px",
    xs: "576px",
    sm: "768px",
    md: "992px",
    lg: "1200px"
  }, o = useRefSyncProp("widthType");
  return {
    width: computed(() => e[o.value] || e.sm),
    widthType$: o
  };
}, _sfc_main$14 = /* @__PURE__ */ defineComponent({
  name: "alc-dialog",
  inheritAttrs: !1,
  __name: "dialog",
  props: /* @__PURE__ */ mergeModels({
    appendToBody: { type: Boolean, default: !0 },
    appendTo: {},
    beforeClose: {},
    destroyOnClose: { type: Boolean, default: !0 },
    closeOnClickModal: { type: Boolean, default: !1 },
    closeOnPressEscape: { type: Boolean, default: !1 },
    lockScroll: { type: Boolean, default: !1 },
    openDelay: {},
    closeDelay: {},
    trapFocus: { type: Boolean },
    headerAriaLevel: {},
    alignCenter: { type: Boolean },
    draggable: { type: Boolean, default: !0 },
    overflow: { type: Boolean },
    fullscreen: { type: Boolean },
    showClose: { type: Boolean, default: !0 },
    title: {},
    ariaLevel: {},
    widthType: { default: "sm" },
    showFullscreen: { type: Boolean },
    beforeOpen: {},
    cancelButtonText: { default: "取消" },
    cancelButtonType: { default: "text" },
    confirmButtonText: { default: "确定" },
    confirmButtonType: { default: "primary" },
    showFooter: { type: Boolean, default: !0 },
    contentHeightFit: { type: Boolean },
    bodyStyle: { type: [Boolean, null, String, Object, Array] },
    bodyClass: { default: "" },
    class: {},
    style: { type: [Boolean, null, String, Object, Array] },
    onConfirm: {}
  }, {
    modelValue: { type: Boolean, type: Boolean, default: !1 },
    modelModifiers: {},
    fullscreen: { type: Boolean, type: Boolean, default: !1 },
    fullscreenModifiers: {}
  }),
  emits: /* @__PURE__ */ mergeModels(["confirm", "cancel"], ["update:modelValue", "update:fullscreen"]),
  setup(e, { expose: o, emit: n }) {
    const t = e, r = n, a = useAttrs(), l = useModel(e, "modelValue"), s = useModel(e, "fullscreen"), c = ref();
    useCloseDialog(() => {
      l.value = !1;
    });
    const d = computed(() => mergeProps(
      a,
      objOmit(t, [
        "title",
        "widthType",
        "showFullscreen",
        "beforeOpen",
        "cancelButtonText",
        "cancelButtonType",
        "confirmButtonText",
        "confirmButtonType",
        "showFooter",
        "contentHeightFit",
        "bodyStyle",
        "bodyClass",
        "onConfirm"
      ])
    )), { width: p, widthType$: f } = useWidthType(), {
      isLoading: g,
      scrollRef: b,
      title$: k,
      showFooter$: x,
      footerElRegister: N,
      confirmRegister: O,
      beforeCloseRegister: m,
      dialogOpenRegister: ee
    } = useStateProvide({
      fullscreen: s,
      widthType: f,
      dialogVisible: l
    }), { headerDivRef: z, footerDivRef: P, contentHeight: V, marginTop: U, startObserve: E } = useContentHeightFit(s), { screenClass: C, switchFullMode: I } = useFullscreen(s);
    function v() {
      typeof t.beforeOpen == "function" ? t.beforeOpen(() => {
        l.value = !0;
      }) : l.value = !0;
    }
    function M(oe) {
      m.value ? m.value(oe) : oe();
    }
    function $() {
      g.value || (g.value = !0, O.value ? O.value().then((oe) => {
        oe && r("confirm", oe), l.value = !oe;
      }).catch((oe) => {
        warn("onDialogConfirm", oe);
      }).finally(() => {
        g.value = !1;
      }) : (r("confirm"), g.value = !1, l.value = !1));
    }
    function H() {
      r("cancel"), l.value = !1;
    }
    function X(oe) {
      return ["primary", "success", "warning", "danger", "info", ""].includes(oe) ? {
        type: oe
      } : {
        [oe]: !0,
        ...oe === "text" ? { bg: !0 } : {}
      };
    }
    o({
      instance: c,
      open: () => {
        l.value = !0;
      },
      close: () => {
        l.value = !1;
      }
    });
    const te = { props: t, emits: r, attrs: a, dialogVisible: l, fullscreen$: s, dialogRef: c, dialogBind: d, width: p, widthType$: f, isLoading: g, scrollRef: b, title$: k, showFooter$: x, footerElRegister: N, confirmRegister: O, beforeCloseRegister: m, dialogOpenRegister: ee, headerDivRef: z, footerDivRef: P, contentHeight: V, marginTop: U, startObserve: E, screenClass: C, switchFullMode: I, openDialog: v, onBeforeClose: M, onConfirm: $, onCancel: H, covertButtonType: X, get ElButton() {
      return ElButton;
    }, get ElDialog() {
      return ElDialog;
    }, get ElScrollbar() {
      return ElScrollbar;
    } };
    return Object.defineProperty(te, "__isScriptSetup", { enumerable: !1, value: !0 }), te;
  }
}), _hoisted_1$L = {
  ref: "headerDivRef",
  "data-tag": "header"
}, _hoisted_2$B = ["id"], _hoisted_3$v = {
  ref: "footerDivRef",
  "data-tag": "footer"
};
function _sfc_render$11(e, o, n, t, r, a) {
  return openBlock(), createElementBlock(Fragment, null, [
    e.$slots.reference ? (openBlock(), createElementBlock("span", {
      key: 0,
      style: normalizeStyle([
        {
          display: e.$slots.reference ? "inline-block" : "none"
        },
        n.style
      ]),
      class: "alc-component-dialog--trigger",
      onClick: withModifiers(t.openDialog, ["stop"])
    }, [
      renderSlot(e.$slots, "reference")
    ], 4)) : createCommentVNode("", !0),
    createVNode(t.ElDialog, mergeProps({
      ref: "dialogRef",
      "before-close": t.onBeforeClose
    }, t.dialogBind, {
      modelValue: t.dialogVisible,
      "onUpdate:modelValue": o[0] || (o[0] = (l) => t.dialogVisible = l),
      top: t.marginTop,
      title: t.title$,
      width: t.width,
      fullscreen: t.fullscreen$,
      onOpen: t.dialogOpenRegister,
      onOpened: t.startObserve
    }), createSlots({
      default: withCtx(() => [
        createVNode(t.ElScrollbar, mergeProps(
          { ref: "scrollRef" },
          n.contentHeightFit || n.showFullscreen && t.fullscreen$ ? { height: t.contentHeight } : {},
          {
            "max-height": t.contentHeight,
            "view-style": [n.bodyStyle, { "--content-height-fit": t.contentHeight }],
            "view-class": `h100 ${n.bodyClass}`
          }
        ), {
          default: withCtx(() => [
            renderSlot(e.$slots, "default", { fillHeight: t.contentHeight })
          ]),
          _: 3
        }, 16, ["max-height", "view-style", "view-class"])
      ]),
      _: 2
    }, [
      e.$slots.header || n.showFullscreen ? {
        name: "header",
        fn: withCtx(({ close: l, titleId: s, titleClass: c }) => [
          createElementVNode("div", _hoisted_1$L, [
            renderSlot(e.$slots, "header", normalizeProps(guardReactiveProps({
              close: l,
              titleId: s,
              titleClass: c,
              switchFullMode: t.switchFullMode
            })), () => [
              createElementVNode("span", {
                id: s,
                class: normalizeClass(c)
              }, toDisplayString$1(t.title$), 11, _hoisted_2$B)
            ]),
            n.showFullscreen ? (openBlock(), createBlock(t.ElButton, {
              key: 0,
              class: "el-dialog__headerbtn",
              link: "",
              onClick: t.switchFullMode
            }, {
              default: withCtx(() => [
                createElementVNode("i", {
                  class: normalizeClass([t.screenClass, "el-dialog__close el-icon"]),
                  style: { right: "35px" }
                }, null, 2)
              ]),
              _: 1
            }, 8, ["onClick"])) : createCommentVNode("", !0)
          ], 512)
        ]),
        key: "0"
      } : void 0,
      t.showFooter$ ? {
        name: "footer",
        fn: withCtx(() => [
          createElementVNode("div", _hoisted_3$v, [
            t.footerElRegister ? (openBlock(), createBlock(resolveDynamicComponent(t.footerElRegister), { key: 0 })) : renderSlot(e.$slots, "footer", { key: 1 }, () => [
              createVNode(t.ElButton, mergeProps(t.covertButtonType(n.cancelButtonType), { onClick: t.onCancel }), {
                default: withCtx(() => [
                  createTextVNode(toDisplayString$1(n.cancelButtonText), 1)
                ]),
                _: 1
              }, 16),
              createVNode(t.ElButton, mergeProps(t.covertButtonType(n.confirmButtonType), {
                loading: t.isLoading,
                onClick: t.onConfirm
              }), {
                default: withCtx(() => [
                  createTextVNode(toDisplayString$1(n.confirmButtonText), 1)
                ]),
                _: 1
              }, 16, ["loading"])
            ])
          ], 512)
        ]),
        key: "1"
      } : void 0
    ]), 1040, ["modelValue", "top", "title", "width", "fullscreen", "onOpen", "onOpened"])
  ], 64);
}
const Dialog = /* @__PURE__ */ _export_sfc(_sfc_main$14, [["render", _sfc_render$11], ["__file", "dialog.vue"]]), AlcDialog = withInstall(Dialog), alcCascaderProps = {
  /**
   * 方案编码
   */
  code: { type: String },
  /**
   * 是否启用多选
   * @default false
   * @description options 中有此项的，options 中的优先级更高，这个放在外面只是尽可能同步 alc-tree 组件属性
   */
  multiple: { type: Boolean, default: !1 },
  /**
   * 多选模式是否半联动
   * @default false
   * @description options 中有此项的，options 中的优先级更高，这个放在外面只是尽可能同步 alc-tree 组件属性
   */
  checkStrictly: { type: Boolean, default: !1 },
  /**
   * 是否显示节点编码
   * @default false
   * @description 非响应式
   */
  showCode: { type: Boolean, default: !1 },
  /**
   * 内置数据源自定义条件
   */
  where: { type: String, default: void 0 },
  /**
   * 内置数据源查询组件条件
   */
  query: {
    type: Array
  },
  /**
   * 节点配置参数
   * @default {
   *   label: 'cTreeNodeTitle',
       value: 'cTreeKey',
       code: 'cTreeCode',
       parent: 'cParentKey',
       children: 'children',
       disabled: 'disabled',
   * }
   */
  props: {
    type: Object,
    default: () => ({
      label: "cTreeNodeTitle",
      value: "cTreeKey",
      code: "cTreeCode",
      parent: "cParentKey",
      children: "children",
      disabled: "disabled"
    })
  },
  /**
   * 级联数据
   * @default []
   */
  options: {
    type: Array,
    default: () => []
  },
  /**
   * 输入时触发校验
   * @default false
   */
  validateEvent: { type: Boolean, default: !1 }
}, useTreeData = (e, o, n = {}, t = "props", r = !1) => {
  const a = useProp(t), l = useProp("code"), s = useProp("multiple"), c = useProp("checkStrictly"), d = shallowRef([]), p = computed(() => !l.value), f = computed(() => getKeys(a.value).reduce(
    (N, O) => (typeof a.value[O] < "u" && (N[O] = a.value[O]), N),
    {
      /**
       * tree、cascades 通用
       */
      label: "cTreeNodeTitle",
      code: "cTreeCode",
      value: "cTreeKey",
      parent: "cParentKey",
      children: "children",
      disabled: "disabled",
      multiple: s.value,
      checkStrictly: c.value,
      ...n
    }
  )), g = computed(() => e.value || d.value), b = computed(() => {
    const N = x(g.value);
    return r ? new Set(N.flat()).size : N.length;
  }), k = computed(() => f.value.multiple && o.value.length > 0 && o.value.length < b.value);
  function x(N, O = [], m = { value: 0 }) {
    return N.reduce((ee, z, P, V) => {
      O.push(z[f.value.value]);
      const U = isArray(z[f.value.children]) && z[f.value.children].length;
      return U && (m.value++, ee.push(
        ...x(
          z[f.value.children],
          [...O],
          m
        )
      )), (!U || f.value.checkStrictly) && ee.push([...O]), P === V.length - 1 && m.value--, O = O.slice(0, m.value), ee;
    }, []);
  }
  return {
    isManual: p,
    nodeData: d,
    nodeConfig: f,
    renderNodeData: g,
    indeterminate: k,
    getAllNode: x
  };
}, useTreeLayout = (e) => {
  const { props: o } = getCurrentInstance(), n = useProviderConfig("state"), t = shallowRef({});
  function r() {
    return o.code ? msGet(
      `alc-city-framework/SysTreeBaseAction/getOneTreeBaseByCode/${o.code}`
    ).then((s) => {
      if (s.code === 1 && s.data) {
        t.value = s.data;
        return;
      }
      return Promise.reject();
    }) : Promise.reject();
  }
  function a() {
    return msPost(
      "alc-city-framework/SysTreeBaseAction/getData4Tree",
      cryptoProps(
        {
          ...objPick(t.value, [
            "cDataSourceType",
            "cServerName",
            "cTableName",
            "cDataScopeType",
            "cDefinedApi",
            "cQueryField",
            "cOrderField",
            "cKeyField",
            "cParentKeyField",
            "cShowField",
            "cTreeCodeField"
          ]),
          bEncrypt: !0,
          cWhere: o.where,
          queryConditionList: o.query,
          cOrgUuid: n.value.cOrgUuid,
          cAccUuid: n.value.cAccUuid
        },
        [
          "cServerName",
          "cTableName",
          "cDefinedApi",
          "cQueryField",
          "cOrderField",
          "cWhere",
          "cKeyField",
          "cParentKeyField",
          "cShowField",
          "cTreeCodeField"
        ]
      )
    ).then((s) => {
      if (s.code === 1) {
        const c = s.data.treeList || [];
        return o.showCode && l(c), c;
      }
      return operatorErrorTip(s.msg), [];
    }).catch(() => (apiLinkErrorTip("节点数据获取"), []));
  }
  function l(s) {
    const { code: c, label: d, children: p } = e.value;
    s.forEach((f) => {
      f[c] && (f[d] = `[${f[c]}] ${f[d]}`);
      const g = f[p];
      isArray(g) && g.length > 0 && l(g);
    });
  }
  return {
    layout: t,
    getTreeLayout: r,
    getTreeDataByLayout: a,
    formatCodeNodeData: l
  };
}, _sfc_main$13 = /* @__PURE__ */ defineComponent({
  name: "alc-cascader",
  inheritAttrs: !1,
  __name: "cascader",
  props: /* @__PURE__ */ mergeModels(alcCascaderProps, {
    modelValue: {
      default: () => []
    },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ mergeModels(["layoutLoaded", "nodeLoaded", "checkAll"], ["update:modelValue"]),
  setup(e, { expose: o, emit: n }) {
    const t = e, r = n, a = useModel(e, "modelValue"), {
      isManual: l,
      nodeData: s,
      nodeConfig: c,
      renderNodeData: d,
      indeterminate: p,
      getAllNode: f
    } = useTreeData(toRef(t, "options"), a, {
      value: "cTreeKey",
      expandTrigger: "hover"
    });
    function g(P) {
      a.value = P ? f(d.value) : [], r("checkAll", a.value);
    }
    const { layout: b, getTreeLayout: k, getTreeDataByLayout: x } = useTreeLayout(c);
    t.code && k().then(() => {
      if (r("layoutLoaded"), !(l.value || b.value.cDataSourceType === "none"))
        return x();
    }).then((P) => {
      P && (s.value = P, r("nodeLoaded", { nodeData: s.value }));
    });
    const { formItem: N } = useFormItem();
    function O() {
      t.validateEvent && nextTick(() => {
        var P;
        (P = N == null ? void 0 : N.validate) == null || P.call(N, "change");
      });
    }
    const m = ref(), ee = ref(!1);
    o({
      instanceRef: m,
      toggleCheckAll: g,
      getCheckedNodes: (P) => {
        var V;
        return (V = m.value) == null ? void 0 : V.getCheckedNodes(P);
      }
    });
    const z = { props: t, emits: r, value: a, isManual: l, nodeData: s, nodeConfig: c, renderNodeData: d, indeterminate: p, getAllNode: f, onCheckAllChange: g, layout: b, getTreeLayout: k, getTreeDataByLayout: x, formItem: N, doValid: O, instanceRef: m, isFocus: ee, get ElCascader() {
      return ElCascader;
    }, get ElCheckbox() {
      return ElCheckbox;
    } };
    return Object.defineProperty(z, "__isScriptSetup", { enumerable: !1, value: !0 }), z;
  }
}), _hoisted_1$K = { class: "alc-component-cascader-container" };
function _sfc_render$10(e, o, n, t, r, a) {
  return openBlock(), createElementBlock("div", _hoisted_1$K, [
    t.nodeConfig.multiple && !t.nodeConfig.lazy ? (openBlock(), createBlock(t.ElCheckbox, {
      key: 0,
      class: normalizeClass({ "is-focus": t.isFocus }),
      indeterminate: t.indeterminate,
      "model-value": !!t.value.length,
      "onUpdate:modelValue": t.onCheckAllChange
    }, null, 8, ["class", "indeterminate", "model-value"])) : createCommentVNode("", !0),
    createVNode(t.ElCascader, mergeProps(e.$attrs, {
      ref: "instanceRef",
      modelValue: t.value,
      "onUpdate:modelValue": o[0] || (o[0] = (l) => t.value = l),
      teleported: !1,
      "popper-append-to-body": !1,
      options: t.renderNodeData,
      "validate-event": e.validateEvent,
      props: t.nodeConfig,
      class: [{ "is-multiple": t.nodeConfig.multiple && !t.nodeConfig.lazy }, "alc-cpt-cascader"],
      "collapse-tags": "",
      "collapse-tags-tooltip": "",
      onFocus: o[1] || (o[1] = (l) => t.isFocus = !0),
      onBlur: o[2] || (o[2] = (l) => t.isFocus = !1),
      onChange: t.doValid
    }), null, 16, ["modelValue", "options", "validate-event", "props", "class"])
  ]);
}
const Cascader = /* @__PURE__ */ _export_sfc(_sfc_main$13, [["render", _sfc_render$10], ["__file", "cascader.vue"]]), AlcCascader = withInstall(Cascader), alcCascaderRegionProps = {
  /**
   * 省名
   */
  province: { type: String },
  /**
   * 省级编码
   */
  provinceCode: { type: String },
  /**
   * 市名
   */
  city: { type: String },
  /**
   * 市级编码
   */
  cityCode: { type: String },
  /**
   * 区名
   */
  area: { type: String },
  /**
   * 区级编码
   */
  areaCode: { type: String },
  /**
   * 详细地址
   * @description 'province/city/area' 拼接的字符串
   */
  location: { type: String },
  /**
   * 多属性的双向绑定
   */
  modelValue: {
    type: Object
  },
  /**
   * 控制 cascader 显示样式和保存的 location 文本样式
   * @default '/'
   */
  separator: { type: String, default: "/" },
  /**
   * 严格的遵守父子节点不互相关联
   * @default false
   */
  checkStrictly: { type: Boolean, default: !1 }
}, _sfc_main$12 = /* @__PURE__ */ defineComponent({
  name: "alc-cascader-region",
  inheritAttrs: !1,
  __name: "cascader-region",
  props: /* @__PURE__ */ mergeModels(alcCascaderRegionProps, {
    modelValue: {},
    modelModifiers: {},
    province: {},
    provinceModifiers: {},
    city: {},
    cityModifiers: {},
    area: {},
    areaModifiers: {},
    provinceCode: {},
    provinceCodeModifiers: {},
    cityCode: {},
    cityCodeModifiers: {},
    areaCode: {},
    areaCodeModifiers: {},
    location: {},
    locationModifiers: {}
  }),
  emits: ["update:modelValue", "update:province", "update:city", "update:area", "update:provinceCode", "update:cityCode", "update:areaCode", "update:location"],
  setup(e, { expose: o }) {
    const n = e, t = useModel(e, "modelValue"), r = useModel(e, "province"), a = useModel(e, "city"), l = useModel(e, "area"), s = useModel(e, "provinceCode"), c = useModel(e, "cityCode"), d = useModel(e, "areaCode"), p = useModel(e, "location"), f = shallowRef(), g = computed(() => {
      const m = t.value;
      if (m && !isEmptyObject(m)) {
        if (m.province && m.area)
          return [m.province, ...m.city ? [m.city, m.area] : [m.area]];
        if (m.location)
          return m.location.split(n.separator);
      } else {
        if (r.value && l.value)
          return [
            r.value,
            ...a.value ? [a.value, l.value] : [l.value]
          ];
        if (p.value)
          return p.value.split(n.separator);
      }
      return [];
    });
    watch(g, (m) => {
      if (!(m != null && m.length)) {
        const ee = f.value.instanceRef.cascaderPanelRef;
        ee.menuList = ee.menuList.slice(0, 1), ee.menus = ee.menus.slice(0, 1);
      }
    });
    const b = computed(() => ({
      label: "cFullName",
      value: "cFullName",
      checkStrictly: n.checkStrictly,
      lazy: !0,
      lazyLoad: async (m, ee) => {
        var P;
        const z = await k((P = m.data) == null ? void 0 : P.cAreaCode);
        ee(z);
      }
    }));
    function k(m = "") {
      return msGet(
        `alc-public-framework/AreaAction/getChildrenArea?cParentCode=${m}`
      ).then((ee) => ee.data.map((z) => Object.assign(z, { leaf: z.cGrade === "13" }))).catch(() => []);
    }
    const x = (m) => {
      var v;
      let ee = "", z = "", P = "", V = "", U = "", E = "";
      const C = (v = f.value) == null ? void 0 : v.instanceRef.cascaderPanelRef.menus;
      for (let M = 0; M < C.length; M++)
        for (let $ = 0; $ < C[M].length; $++) {
          const H = C[M][$].data;
          if (H.cFullName === m[M]) {
            H.cGrade === "11" ? (ee = m[M], z = H.cAreaCode) : H.cGrade === "12" ? (P = m[M], V = H.cAreaCode) : H.cGrade === "13" && (U = m[M], E = H.cAreaCode);
            break;
          }
        }
      const I = [ee, P, U].filter(Boolean).join(n.separator);
      return {
        province: ee,
        city: P,
        area: U,
        // 本属性做兼容旧版本用
        cArea: U,
        location: I,
        provinceCode: z,
        cityCode: V,
        areaCode: E
      };
    };
    function N() {
      if (g.value) {
        const m = x(g.value);
        isPlainObject(t.value) ? t.value = m : (r.value = m.province, a.value = m.city, l.value = m.area, s.value = m.provinceCode, c.value = m.cityCode, d.value = m.areaCode, p.value = m.location);
      } else
        isPlainObject(t.value) ? t.value = {
          province: "",
          city: "",
          area: "",
          location: ""
        } : (r.value = "", a.value = "", l.value = "", s.value = "", c.value = "", d.value = "", p.value = "");
    }
    o({
      getCheckedNodes: (m) => {
        var ee;
        return (ee = f.value) == null ? void 0 : ee.getCheckedNodes(m);
      },
      getAreaCode: x
    });
    const O = { props: n, modelValue: t, province: r, city: a, area: l, provinceCode: s, cityCode: c, areaCode: d, location: p, cascaderHandle: f, value: g, cascaderProps: b, getRegionByCode: k, getAreaCode: x, updateBind: N, get AlcCascader() {
      return AlcCascader;
    } };
    return Object.defineProperty(O, "__isScriptSetup", { enumerable: !1, value: !0 }), O;
  }
});
function _sfc_render$$(e, o, n, t, r, a) {
  return openBlock(), createBlock(t.AlcCascader, mergeProps({ ref: "cascaderHandle" }, e.$attrs, {
    "model-value": t.value,
    props: t.cascaderProps,
    separator: e.separator,
    "onUpdate:modelValue": t.updateBind
  }), null, 16, ["model-value", "props", "separator"]);
}
const CascaderRegion = /* @__PURE__ */ _export_sfc(_sfc_main$12, [["render", _sfc_render$$], ["__file", "cascader-region.vue"]]), AlcCascaderRegion = withInstall(CascaderRegion), alcCascaderRegion2Props = {
  // 地区级连绑定类型
  bingingType: {
    type: String,
    default: "name"
  },
  // 是否多选
  multiple: { type: Boolean, default: !1 },
  // 控制 cascader 显示样式和保存的 location 文本样式
  separator: { type: String, default: "/" },
  // 是否严格的遵守父子节点不互相关联
  checkStrictly: { type: Boolean, default: !1 }
}, _sfc_main$11 = /* @__PURE__ */ defineComponent({
  name: "alc-cascader-region-2",
  __name: "cascader-region-2",
  props: /* @__PURE__ */ mergeModels(alcCascaderRegion2Props, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e, { expose: o }) {
    const n = e, t = useModel(e, "modelValue"), r = ref();
    watch(t, (d) => {
      if (!(d != null && d.length)) {
        const p = r.value.instanceRef.cascaderPanelRef;
        p.menuList = p.menuList.slice(0, 1), p.menus = p.menus.slice(0, 1);
      }
    });
    const a = computed(() => ({
      label: "cFullName",
      value: n.bingingType === "code" ? "cAreaCode" : "cFullName",
      checkStrictly: n.checkStrictly,
      multiple: n.multiple,
      lazy: !0,
      lazyLoad: async (d, p) => {
        var g;
        const f = await l((g = d.data) == null ? void 0 : g.cAreaCode);
        p(f);
      }
    }));
    function l(d = "") {
      return msGet(
        `alc-public-framework/AreaAction/getChildrenArea?cParentCode=${d}`
      ).then((p) => p.data.map((f) => Object.assign(f, {
        leaf: f.cGrade === "13"
      }))).catch(() => []);
    }
    function s() {
      var d, p, f, g;
      return (g = (f = (p = (d = r.value) == null ? void 0 : d.instanceRef) == null ? void 0 : p.cascaderPanelRef) == null ? void 0 : f.getCheckedNodes(!1)) == null ? void 0 : g.map((b) => {
        let k = "", x = "", N = "", O = "", m = "", ee = "";
        return b.pathNodes.forEach((z) => {
          const P = z.data;
          n.bingingType === "name" ? P.cGrade === "11" ? (k = P.cFullName, x = P.cAreaCode) : P.cGrade === "12" ? (N = P.cFullName, O = P.cAreaCode) : P.cGrade === "13" && (m = P.cFullName, ee = P.cAreaCode) : P.cGrade === "11" ? (x = P.cAreaCode, k = P.cFullName) : P.cGrade === "12" ? (O = P.cAreaCode, N = P.cFullName) : P.cGrade === "13" && (ee = P.cAreaCode, m = P.cFullName);
        }), {
          province: k,
          city: N,
          area: m,
          location: [k, N, m].filter(Boolean).join(n.separator),
          provinceCode: x,
          cityCode: O,
          areaCode: ee
        };
      });
    }
    o({
      getCheckedNodes: (d) => {
        var p;
        return (p = r.value) == null ? void 0 : p.getCheckedNodes(d);
      },
      getCheckedRegionInfo: s
    });
    const c = { props: n, value: t, cascaderHandle: r, cascaderProps: a, getRegionByCode: l, getCheckedRegionInfo: s, get AlcCascader() {
      return AlcCascader;
    } };
    return Object.defineProperty(c, "__isScriptSetup", { enumerable: !1, value: !0 }), c;
  }
});
function _sfc_render$_(e, o, n, t, r, a) {
  return openBlock(), createBlock(t.AlcCascader, mergeProps({ ref: "cascaderHandle" }, e.$attrs, {
    modelValue: t.value,
    "onUpdate:modelValue": o[0] || (o[0] = (l) => t.value = l),
    props: t.cascaderProps,
    separator: e.separator
  }), null, 16, ["modelValue", "props", "separator"]);
}
const CascaderRegion2 = /* @__PURE__ */ _export_sfc(_sfc_main$11, [["render", _sfc_render$_], ["__file", "cascader-region-2.vue"]]), AlcCascaderRegion2 = withInstall(CascaderRegion2), alcDateTimeProps = {
  ...objOmit(datePickerProps, [
    "editable",
    "popperClass",
    "size",
    "rangeSeparator",
    "prefixIcon",
    "clearIcon"
  ]),
  /**
   * 组件类型
   * @default 'date'
   */
  type: {
    type: String,
    default: "date"
  },
  /**
   * 是否区间模式
   * @default false
   */
  range: { type: Boolean, default: !1 },
  /**
   * 显示格式
   */
  format: { type: String },
  /**
   * 是否输入时触发校验
   * @default false
   */
  validateEvent: { type: Boolean, default: !1 },
  /**
   * 开始禁用日期
   * 暂时为了解决 https://github.com/element-plus/element-plus/issues/12633 这个问题，不要乱用
   */
  disabledDateStart: { type: [Number, Date], default: void 0 },
  /**
   * 结束禁用日期
   * 暂时为了解决 https://github.com/element-plus/element-plus/issues/12633 这个问题，不要乱用
   */
  disabledDateEnd: { type: [Number, Date], default: void 0 }
}, _sfc_main$10 = /* @__PURE__ */ defineComponent({
  name: "alc-date-time",
  inheritAttrs: !1,
  __name: "date-time",
  props: /* @__PURE__ */ mergeModels(alcDateTimeProps, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e, { expose: o }) {
    const n = e, t = useModel(e, "modelValue"), { formItem: r } = useFormItem(), a = useFormDisabled(), l = ref(), s = computed(() => {
      const g = ["year", "month", "date", "datetime"].includes(n.type) ? n.type : "date";
      return n.range === !0 ? g === "year" ? "monthrange" : `${g}range` : g;
    }), c = computed(() => {
      if (n.format)
        return n.format;
      switch (n.type) {
        case "year":
          return "YYYY";
        case "month":
          return "YYYY-MM";
        case "date":
          return "YYYY-MM-DD";
        case "datetime":
          return "YYYY-MM-DD HH:mm:ss";
        case "time":
          return "HH:mm:ss";
        default:
          return "YYYY-MM-DD";
      }
    }), d = () => {
      n.validateEvent && nextTick(() => {
        var g;
        (g = r == null ? void 0 : r.validate) == null || g.call(r, "change");
      });
    };
    function p(g) {
      return n.disabledDateStart || n.disabledDateEnd ? g < n.disabledDateStart || g > n.disabledDateEnd : !1;
    }
    o({
      instanceRef: l,
      ...getInstanceMethod(l, ["focus", "handleOpen", "handleClose"])
    });
    const f = { props: n, dateTimeValue: t, formItem: r, isDisabled: a, instanceRef: l, dateTimeType: s, dateTimeFormat: c, doValid: d, disabledDate: p, get ElDatePicker() {
      return ElDatePicker;
    }, get ElTimePicker() {
      return ElTimePicker;
    } };
    return Object.defineProperty(f, "__isScriptSetup", { enumerable: !1, value: !0 }), f;
  }
});
function _sfc_render$Z(e, o, n, t, r, a) {
  return e.$props.type === "time" ? (openBlock(), createBlock(t.ElTimePicker, mergeProps({
    key: 0,
    ref: "instanceRef"
  }, { ...e.$attrs, ...e.$props }, {
    modelValue: t.dateTimeValue,
    "onUpdate:modelValue": o[0] || (o[0] = (l) => t.dateTimeValue = l),
    disabled: t.isDisabled,
    editable: !1,
    "is-range": e.$props.range,
    format: t.dateTimeFormat,
    class: "alc-cpt-datetime",
    style: { width: "100%" },
    onChange: t.doValid
  }), null, 16, ["modelValue", "disabled", "is-range", "format"])) : (openBlock(), createBlock(t.ElDatePicker, mergeProps({
    key: 1,
    ref: "instanceRef",
    "disabled-date": t.disabledDate
  }, { ...e.$attrs, ...e.$props }, {
    modelValue: t.dateTimeValue,
    "onUpdate:modelValue": o[1] || (o[1] = (l) => t.dateTimeValue = l),
    disabled: t.isDisabled,
    editable: !1,
    type: t.dateTimeType,
    format: t.dateTimeFormat,
    class: "alc-cpt-datetime",
    style: { width: "100%" },
    onChange: t.doValid
  }), createSlots({ _: 2 }, [
    e.$slots["range-separator"] ? {
      name: "range-separator",
      fn: withCtx(() => [
        renderSlot(e.$slots, "range-separator")
      ]),
      key: "0"
    } : void 0
  ]), 1040, ["modelValue", "disabled", "type", "format"]));
}
const DateTime = /* @__PURE__ */ _export_sfc(_sfc_main$10, [["render", _sfc_render$Z], ["__file", "date-time.vue"]]), AlcDateTime = withInstall(DateTime), alcDisplayProps = {
  /**
   * 显示的值
   * @default ''
   */
  modelValue: {
    type: [Number, String, Boolean, Date, Array],
    default: ""
  },
  /**
   * 自定义格式化
   * @description 优先级最高跳过 type 和 code 的格式化
   */
  formatter: {
    type: Function
  },
  /**
   * 预制的组件类型，配合 value 进行展示格式化
   * @default text
   */
  itemType: {
    type: String,
    default: "text"
  },
  /**
   * 辅助 value 格式化
   * @deprecated 如 select 的 code，date 的 type
   */
  code: { type: [String, Number] },
  /**
   * 使数据更易读，在数值中体现为千分位
   */
  prettier: { type: Boolean, default: !0 }
}, drag$1 = withInstallDirective(
  {
    mounted(e, o) {
      if (!o.value)
        return !1;
      const n = document.querySelector(
        o.value[0]
      ), t = document.querySelector(
        o.value[1]
      );
      t.onmouseover = () => t.style.cursor = "move";
      function r(l, s) {
        const c = s === "pc" ? l.clientX - t.offsetLeft : l.touches[0].clientX - t.offsetLeft, d = s === "pc" ? l.clientY - t.offsetTop : l.touches[0].clientY - t.offsetTop, p = document.body.clientWidth, f = document.documentElement.clientHeight, g = n.offsetWidth, b = n.offsetHeight, k = n.offsetLeft, x = p - n.offsetLeft - g, N = n.offsetTop, O = f - n.offsetTop - b;
        let m = getComputedStyle(n).left, ee = getComputedStyle(n).top;
        return m.includes("%") ? (m = +document.body.clientWidth * (+m.replace(/%/g, "") / 100), ee = +document.body.clientHeight * (+ee.replace(/%/g, "") / 100)) : (m = +m.replace(/px/g, ""), ee = +ee.replace(/px/g, "")), {
          disX: c,
          disY: d,
          minDragDomLeft: k,
          maxDragDomLeft: x,
          minDragDomTop: N,
          maxDragDomTop: O,
          styL: m,
          styT: ee
        };
      }
      function a(l, s, c) {
        const {
          disX: d,
          disY: p,
          minDragDomLeft: f,
          maxDragDomLeft: g,
          minDragDomTop: b,
          maxDragDomTop: k,
          styL: x,
          styT: N
        } = c;
        let O = s === "pc" ? l.clientX - d : l.touches[0].clientX - d, m = s === "pc" ? l.clientY - p : l.touches[0].clientY - p;
        -O > f ? O = -f : O > g && (O = g), -m > b ? m = -b : m > k && (m = k), n.style.cssText += `;left:${O + x}px;top:${m + N}px;`;
      }
      t.onmousedown = (l) => {
        const s = r(l, "pc");
        document.onmousemove = (c) => {
          a(c, "pc", s);
        }, document.onmouseup = () => {
          document.onmousemove = null, document.onmouseup = null;
        };
      }, t.ontouchstart = (l) => {
        const s = r(l, "app");
        document.ontouchmove = (c) => {
          a(c, "app", s);
        }, document.ontouchend = () => {
          document.ontouchmove = null, document.ontouchend = null;
        };
      };
    }
  },
  "drag"
), timerWm = /* @__PURE__ */ new WeakMap(), identWm = /* @__PURE__ */ new WeakMap();
let loadingVNode, destroyTimer;
function mountEl(e, o) {
  e.classList.add("is-load-on"), loadingVNode || (loadingVNode = createVNode(
    Transition$1,
    { name: "el-fade-in", appear: !0 },
    {
      default: () => h(
        "div",
        { class: "load-on--mask" },
        h("i", {
          class: "ri-loader-2-line is-rotate-loading"
        })
      )
    }
  )), render$1(loadingVNode, e), destroyTimer && window.clearTimeout(destroyTimer), destroyTimer = window.setTimeout(() => {
    loadingVNode = null;
  }, 1e3 * 30);
  function n() {
    return ((1 + Math.random()) * 65536 | 0).toString(16).substring(1);
  }
  const t = e.querySelector(":scope > .load-on--mask");
  if (t) {
    const r = `data-load-${n()}`;
    identWm.set(e, r), t.setAttribute(r, "true");
    const a = t.querySelector(".is-rotate-loading");
    if (a) {
      const l = {
        small: "16px",
        default: "20px",
        large: "28px"
      };
      a.style.fontSize = l[getKeys(o)[0]] || l.default, a.style.setProperty(
        "--alc-loading-spinner-size",
        a.style.fontSize
      );
    }
  }
}
const loadOn = withInstallDirective(
  {
    beforeMount(e, o) {
      o.value && (timerWm.set(e, Date.now()), mountEl(e, o.modifiers));
    },
    beforeUpdate(e, o) {
      var n;
      if (o.value) {
        if (timerWm.has(e))
          return;
        timerWm.set(
          e,
          window.setTimeout(
            mountEl,
            o.arg ? +o.arg : 200,
            e,
            o.modifiers
          )
        );
      } else
        timerWm.has(e) && window.clearTimeout(timerWm.get(e)), (n = e.querySelector(`[${identWm.get(e)}]`)) == null || n.remove(), e.classList.remove("is-load-on"), render$1(null, e), timerWm.delete(e), identWm.delete(e);
    }
  },
  "load-on"
), _sfc_main$$ = /* @__PURE__ */ defineComponent({
  name: "alc-overflow-tooltip",
  __name: "overflow-tooltip",
  setup(e, { expose: o }) {
    const n = ref(), t = `tooltip-${Date.now()}`, {
      currentActive: r,
      visible: a,
      virtualRef: l,
      popoverRef: s,
      mouseenter: c,
      mouseleave: d
    } = useHoverShow();
    let p;
    function f(x, N) {
      N.onmouseleave = () => {
        d(), p == null || p();
      }, N.onmouseenter = (O) => {
        var ee;
        shouldShowTooltip(N) && (c(O, x), (ee = n.value) == null || ee.update(), p = attachEvent({
          eventName: "scroll",
          callback: (z) => {
            (z.path || z.composedPath()).some((V) => {
              var U;
              return (U = V == null ? void 0 : V.classList) == null ? void 0 : U.contains(t);
            }) || (a.value = !1);
          },
          options: { passive: !0, once: !0, capture: !0 }
        }));
      };
    }
    function g() {
      a.value = !1;
    }
    function b() {
      p == null || p();
    }
    o({
      pin: f,
      close: g,
      remove: b
    });
    const k = { scrollRef: n, popperClass: t, currentActive: r, visible: a, virtualRef: l, popoverRef: s, mouseenter: c, mouseleave: d, get removeListen() {
      return p;
    }, set removeListen(x) {
      p = x;
    }, pin: f, close: g, remove: b, get ElPopover() {
      return ElPopover;
    }, get ElScrollbar() {
      return ElScrollbar;
    } };
    return Object.defineProperty(k, "__isScriptSetup", { enumerable: !1, value: !0 }), k;
  }
});
function _sfc_render$Y(e, o, n, t, r, a) {
  return openBlock(), createBlock(t.ElPopover, {
    visible: t.visible,
    ref: "popoverRef",
    "popper-class": `${t.popperClass} alc-overflow-tooltip__pop`,
    offset: 2,
    width: "unset",
    "virtual-ref": t.virtualRef,
    "show-arrow": !1,
    trigger: "hover",
    transition: "el-zoom-in-top",
    "virtual-triggering": ""
  }, createSlots({
    default: withCtx(() => [
      createVNode(t.ElScrollbar, {
        ref: "scrollRef",
        "max-height": "300px",
        "view-class": "overflow-content",
        style: { "max-width": "600px" }
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString$1(t.currentActive), 1)
        ]),
        _: 1
      }, 512)
    ]),
    _: 2
  }, [
    e.$slots.default ? {
      name: "reference",
      fn: withCtx(() => [
        renderSlot(e.$slots, "default")
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["visible", "popper-class", "virtual-ref"]);
}
const OverflowTooltip = /* @__PURE__ */ _export_sfc(_sfc_main$$, [["render", _sfc_render$Y], ["__file", "overflow-tooltip.vue"]]), AlcOverflowTooltip = withInstall(OverflowTooltip);
let vm;
const overflowTooltip = withInstallDirective(
  {
    created() {
      if (vm)
        return;
      const e = createVNode(AlcOverflowTooltip), o = document.createElement("div");
      render$1(e, o), document.body.appendChild(o), vm = e.component;
    },
    mounted(e, o) {
      e.classList.contains("single-line-overflow") || e.classList.add("single-line-overflow"), o.value && vm.exposed.pin(o.value, e);
    },
    updated(e, o) {
      vm.exposed.remove(), o.value && vm.exposed.pin(o.value, e);
    },
    beforeUnmount() {
      vm.exposed.remove();
    }
  },
  "overflow-tooltip"
), _sfc_main$_ = defineComponent({
  name: "alc-display",
  props: alcDisplayProps,
  setup(e) {
    return () => {
      if (["checkbox", "boolean"].includes(e.itemType))
        return h(
          "div",
          h("i", {
            class: `alc-cpt-display ${e.modelValue ? "ri-checkbox-line" : "ri-checkbox-blank-line"}`
          })
        );
      if (e.itemType === "edit")
        return h("div", {
          innerHTML: e.modelValue,
          class: "alc-cpt-display alc-cpt-display--rich-text"
        });
      let o = typeof e.formatter == "function" ? e.formatter(e.modelValue) : toDisplayString(
        e.itemType,
        e.modelValue,
        e.code,
        e.prettier
      );
      return o != null && typeof o != "string" && (o = String(o)), o ? withDirectives(
        h(
          "div",
          { class: "alc-cpt-display single-line-overflow" },
          o
        ),
        [[overflowTooltip, o]]
      ) : null;
    };
  }
}), Display = /* @__PURE__ */ _export_sfc(_sfc_main$_, [["__file", "display.vue"]]), AlcDisplay = withInstall(Display), alcEditProps = {
  /**
   * 编辑器绑定值
   */
  modelValue: { type: String, default: "" },
  /**
   * 绑定值是否是 html 富文本
   * @default true
   */
  rawValue: { type: Boolean, default: !0 },
  /**
   * 是否禁用
   * @default false
   */
  disabled: { type: Boolean, default: !1 },
  /**
   * 输入框占位符
   */
  placeholder: { type: String },
  /**
   * 文件和图像上传的业务编码
   * @default 'editImage'
   */
  businessType: { type: String, default: "editImage" },
  /**
   * 文件和图像上传的业务名称
   * @default '富文本图片'
   */
  businessName: { type: String, default: "富文本图片" },
  /**
   * 上传保存文件名称是否变更为随机名称
   * @description 在强制要求上传文件名称不变化的场景设置为 false, 默认为 true，如果文档目录相同会产生覆盖
   */
  randomName: { type: Boolean, default: !0 },
  /**
   * 是否使用公共上传地址
   * @description 如果使用公共上传地址则固定，否则走 server.config.json 代理转发
   * @default true
   */
  usePublicUrl: { type: Boolean, default: !0 },
  /**
   * tiny 其他初始化选项
   */
  tinyOptions: { type: Object },
  /**
   * 编辑器高度
   * @default '100%'
   */
  height: { type: String, default: "100%" }
}, _sfc_main$Z = /* @__PURE__ */ defineComponent({
  name: "alc-edit",
  __name: "edit",
  props: /* @__PURE__ */ mergeModels(alcEditProps, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ mergeModels(["mounted", "change", "focus", "blur"], ["update:modelValue"]),
  setup(e, { expose: o, emit: n }) {
    const t = e, r = n, a = useModel(e, "modelValue"), l = useFormDisabled(), s = useProviderConfig("state"), c = useUsePublicUrl(), d = {
      // 语言类型
      language: "zh-Hans",
      // 字体
      font_family_formats: "微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun,serif;仿宋体=FangSong,serif;楷体='楷体';隶书='隶书';黑体=SimHei,sans-serif;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;",
      // 字号
      font_size_formats: "12px 14px 16px 18px 20px 22px 24px 28px 32px 36px 48px 56px 72px",
      // 宽度
      width: "100%",
      // 高度
      height: t.height,
      // 是否显示 tiny 技术支持信息
      branding: !1,
      // 是否显示元素路径
      elementpath: !1,
      // 是否可改变编辑器大小（false-不可改变，true-仅高度可改变，'both'-宽高均可改变）
      resize: !1,
      // 是否可粘贴图片
      paste_data_images: !0,
      // 空白占位提示
      placeholder: t.placeholder,
      // 自定义可编辑区域的css样式
      content_style: "img {max-width:100%;}",
      // 工具栏模式（floating / sliding / scrolling / wrap）
      toolbar_mode: "floating",
      // 编辑器撤销次数
      custom_undo_redo_levels: 10,
      // 1级菜单
      menubar: "edit insert format table",
      // 菜单配置
      menu: {
        edit: {
          title: "编辑",
          items: "undo redo | cut copy paste pastetext | selectall searchreplace restoredraft"
        },
        insert: {
          title: "插入",
          items: "link image media | charmap"
        },
        format: {
          title: "格式",
          items: "bold italic underline strikethrough superscript subscript | formats | removeformat"
        },
        table: {
          title: "表格",
          items: "inserttable | cell row column | tableprops deletetable"
        }
      },
      // 工具栏
      toolbar: "fullscreen preview code | fontfamily fontsize forecolor backcolor | alignleft aligncenter alignright alignjustify indent outdent indent2em | bullist numlist lineheight ",
      // 插件
      plugins: "advlist, autosave, charmap, code, indent2em, fullscreen, image, link, lists, media, preview, searchreplace, table, wordcount",
      // 允许的图像文件格式
      images_file_types: "png,jpg,jpeg,gif,ico"
    }, p = `edit_${createUuid()}`, f = shallowRef();
    let g;
    const { nextZIndex: b } = useZIndex();
    let k;
    const x = new MutationObserver((v) => {
      for (const M of v)
        M.type === "childList" && M.target instanceof HTMLElement && (M.target.style.zIndex = k);
    });
    let N = !1;
    const O = watch(
      () => a.value,
      (v) => {
        if (N) {
          O();
          return;
        }
        v && (O(), V(v));
      }
    );
    let m;
    onPageVisit(() => {
      nextTick(ee);
    }), onPageLeave(() => {
      O(), m == null || m(), z();
    });
    function ee() {
      N = !1, window.tinymce.init({
        ...d,
        // 将 TinyMCE 的默认 JavaScript 上传处理函数替换为自定义逻辑
        images_upload_handler: C,
        ...t.tinyOptions,
        selector: `#${p}`,
        readonly: l.value,
        init_instance_callback(v) {
          f.value = v, m = watch(
            l,
            () => {
              f.value !== null && P(l.value);
            },
            { immediate: !0 }
          );
          let M = v.targetElm.parentElement, $ = !1;
          for (; M && M.parentElement && M; ) {
            if (M != null && M.classList.contains("el-overlay")) {
              $ = !0;
              break;
            }
            M = M.parentElement;
          }
          $ && (g = document.querySelector(
            ".tox.tox-silver-sink.tox-tinymce-aux"
          ), k = b().toString(), g && x.observe(g, { childList: !0 })), a.value && V(a.value), r("mounted"), f.value.on("change", () => {
            N = !0, a.value = t.rawValue ? U() : E(), r("change", a.value || "");
          }), f.value.on("focus", () => {
            r("focus");
          }), f.value.on("blur", () => {
            r("blur");
          });
        }
      });
    }
    function z() {
      var v;
      (v = f.value) == null || v.destroy(!1), g == null || g.remove(), g = null, x.disconnect();
    }
    function P(v) {
      var $;
      const M = v === !0 ? "readonly" : "design";
      ($ = f.value) == null || $.mode.set(M);
    }
    function V(v) {
      var M;
      (M = f.value) == null || M.setContent(v || "");
    }
    function U() {
      var v;
      return (v = f.value) == null ? void 0 : v.getContent();
    }
    function E() {
      var v;
      return (v = f.value) == null ? void 0 : v.getContent({ format: "text" });
    }
    function C(v, M) {
      const $ = new FormData();
      return $.append("files", v.blob(), v.filename()), apiUploadFile(
        {
          businessType: t.businessType,
          businessName: t.businessName,
          randomName: t.randomName,
          cAccSignId: s.value.cAccSignId,
          cAllLinkUserUuid: s.value.cAllLinkUserUuid,
          cMenuName: s.value.cMenuName,
          cMobilePhone: s.value.cMobilePhone,
          progress: M
        },
        $,
        c.value
      ).then((H) => {
        const { code: X, data: te } = H;
        if (X === 1 && te && te[0].bUpSuccess)
          return te[0].cUrl;
      });
    }
    o({
      editor: f,
      setContent: V,
      getContent: U,
      getText: E
    });
    const I = { props: t, emits: r, value: a, isDisabled: l, coreState: s, usePublicUrl$: c, config: d, editUid: p, editorIns: f, get toxIns() {
      return g;
    }, set toxIns(v) {
      g = v;
    }, nextZIndex: b, get nextZIndexValue() {
      return k;
    }, set nextZIndexValue(v) {
      k = v;
    }, observer: x, get edited() {
      return N;
    }, set edited(v) {
      N = v;
    }, unwatchModelValue: O, get unWatchDisabled() {
      return m;
    }, set unWatchDisabled(v) {
      m = v;
    }, initEditor: ee, destroyEditor: z, setDisable: P, setContent: V, getContent: U, getText: E, imagesUploadHandler: C };
    return Object.defineProperty(I, "__isScriptSetup", { enumerable: !1, value: !0 }), I;
  }
}), _hoisted_1$J = ["value"];
function _sfc_render$X(e, o, n, t, r, a) {
  var l;
  return (l = e.tinyOptions) != null && l.inline ? (openBlock(), createElementBlock("div", {
    key: 0,
    id: t.editUid
  })) : (openBlock(), createElementBlock("textarea", {
    key: 1,
    id: t.editUid,
    value: t.value
  }, null, 8, _hoisted_1$J));
}
const Edit = /* @__PURE__ */ _export_sfc(_sfc_main$Z, [["render", _sfc_render$X], ["__file", "edit.vue"]]), AlcEdit = withInstall(Edit), alcInputProps = {
  ...inputProps,
  /**
   * 是否过滤特殊字符
   * @default false
   */
  filter: { type: Boolean, default: !1 },
  /**
   * 最大输入字符数
   * @description 普通输入框默认 50，文本域默认 200
   */
  maxlength: { type: [String, Number] },
  /**
   * 是否输入时触发校验
   * @default false
   */
  validateEvent: { type: Boolean, default: !1 },
  /**
   * 输入完毕是否去除输入字符的左右两边的空格
   * @default true
   */
  trim: { type: Boolean, default: !0 },
  /**
   * 自动聚焦，仅在非禁用，非只读情况下生效
   * @default false
   */
  autofocus: { type: Boolean, default: !1 },
  /**
   * 输入框行数
   * @description 仅 type 为 'textarea' 时有效
   * @default 3
   */
  rows: { type: Number, default: 3 }
}, _sfc_main$Y = /* @__PURE__ */ defineComponent({
  name: "alc-input",
  __name: "input",
  props: /* @__PURE__ */ mergeModels(alcInputProps, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ mergeModels(["enter"], ["update:modelValue"]),
  setup(e, { expose: o }) {
    const n = e, t = useModel(e, "modelValue"), r = useFormDisabled(), a = ref();
    !n.readonly && !r.value && n.autofocus && onMounted(() => {
      a.value.focus();
    });
    const l = computed(() => isNumber(n.maxlength) ? n.maxlength : n.type === "textarea" ? 200 : 50);
    function s(p) {
      t.value = n.filter ? filterStr(p) : p;
    }
    function c() {
      n.trim && typeof t.value == "string" && (t.value = t.value.trim());
    }
    o({
      ...getInstanceMethod(a, [
        "focus",
        "blur",
        "select",
        "clear",
        "resizeTextarea"
      ]),
      instanceRef: a,
      textValue: t,
      maxlength: l
    });
    const d = { props: n, textValue: t, disabled: r, instanceRef: a, maxlength$: l, updateValue: s, onBlur: c, get ElInput() {
      return ElInput;
    }, get filterStr() {
      return filterStr;
    } };
    return Object.defineProperty(d, "__isScriptSetup", { enumerable: !1, value: !0 }), d;
  }
});
function _sfc_render$W(e, o, n, t, r, a) {
  return openBlock(), createBlock(t.ElInput, mergeProps({ ref: "instanceRef" }, t.props, {
    "model-value": t.textValue,
    maxlength: t.maxlength$,
    resize: "none",
    "onUpdate:modelValue": t.updateValue,
    onKeydownPassive: o[0] || (o[0] = withKeys((l) => e.$emit("enter", e.filter ? t.filterStr(t.textValue) : t.textValue), ["enter"])),
    onBlur: t.onBlur
  }), createSlots({ _: 2 }, [
    e.$slots.prefix ? {
      name: "prefix",
      fn: withCtx(() => [
        renderSlot(e.$slots, "prefix")
      ]),
      key: "0"
    } : void 0,
    e.$slots.suffix ? {
      name: "suffix",
      fn: withCtx(() => [
        renderSlot(e.$slots, "suffix")
      ]),
      key: "1"
    } : void 0,
    e.$slots.prepend ? {
      name: "prepend",
      fn: withCtx(() => [
        renderSlot(e.$slots, "prepend")
      ]),
      key: "2"
    } : void 0,
    e.$slots.append ? {
      name: "append",
      fn: withCtx(() => [
        renderSlot(e.$slots, "append")
      ]),
      key: "3"
    } : void 0
  ]), 1040, ["model-value", "maxlength"]);
}
const Input = /* @__PURE__ */ _export_sfc(_sfc_main$Y, [["render", _sfc_render$W], ["__file", "input.vue"]]), AlcInput = withInstall(Input), alcInputNumberProps = {
  ...inputNumberProps,
  /**
   * 绑定值
   * @default undefined
   */
  modelValue: { type: [Number, String], default: void 0 },
  /**
   * 数值精度
   * @default 0
   */
  precision: { type: Number, default: 0 },
  /**
   * 显示控制按钮
   * @default false
   */
  controls: { type: Boolean, default: !1 },
  /**
   * 控制按钮位置
   * @default 'right'
   */
  controlsPosition: {
    type: String,
    default: "right"
  },
  /**
   * 数值对齐方式
   * @default 'right'
   */
  valueAlign: {
    type: String,
    default: "right"
  },
  /**
   * 输入时触发校验
   * @default false
   */
  validateEvent: { type: Boolean, default: !1 },
  /**
   * 输入框静态时是否显示千分位分隔符
   * @default true
   */
  prettier: { type: Boolean, default: !0 }
}, _sfc_main$X = /* @__PURE__ */ defineComponent({
  name: "alc-input-number",
  __name: "input-number",
  props: alcInputNumberProps,
  emits: ["update:modelValue", "change", "enter"],
  setup(e, { expose: o, emit: n }) {
    const t = e, r = n, a = ref(), l = ref(), s = ref(!1);
    watchEffect(() => {
      var k;
      if (!t.prettier)
        return;
      const b = (k = a.value) == null ? void 0 : k.$el.querySelector(".el-input__wrapper");
      b && (b.dataset.prettierValue = toDisplayString(
        "Number",
        l.value,
        t.precision,
        !0
      ) || "");
    });
    const c = computed(() => `value-align-${t.valueAlign}`), d = computed(() => typeof t.max == "number" ? t.max : 9999999999999998);
    watch(
      () => t.modelValue,
      (b) => {
        b != null ? l.value = typeof b == "number" ? b : Number.parseFloat(b) : l.value = b;
      },
      { immediate: !0 }
    ), watch(l, (b) => {
      r("update:modelValue", b);
    });
    const p = (b, k) => {
      r("update:modelValue", b), r("change", b, k);
    }, f = (b) => {
      s.value = !0, b.target instanceof HTMLInputElement && b.target.select();
    };
    o({
      ...getInstanceMethod(a, ["focus", "blur"]),
      max: d
    });
    const g = { props: t, emits: r, instanceRef: a, numberValue: l, isFocus: s, localValueAlign: c, max$: d, onChange: p, onFocus: f, get ElInputNumber() {
      return ElInputNumber;
    } };
    return Object.defineProperty(g, "__isScriptSetup", { enumerable: !1, value: !0 }), g;
  }
});
function _sfc_render$V(e, o, n, t, r, a) {
  return openBlock(), createBlock(t.ElInputNumber, mergeProps({ ref: "instanceRef" }, e.$props, {
    modelValue: t.numberValue,
    "onUpdate:modelValue": o[0] || (o[0] = (l) => t.numberValue = l),
    max: t.max$,
    class: [[
      t.localValueAlign,
      (!t.isFocus || t.props.readonly) && e.prettier && t.numberValue != null ? "prettier-number" : ""
    ], "alc-cpt-number"],
    onFocus: t.onFocus,
    onBlur: o[1] || (o[1] = (l) => t.isFocus = !1),
    onChange: t.onChange,
    onKeydownPassive: o[2] || (o[2] = withKeys((l) => e.$emit("enter", t.numberValue), ["enter"])),
    onWheelCapture: o[3] || (o[3] = withModifiers(() => {
    }, ["prevent"]))
  }), null, 16, ["modelValue", "max", "class"]);
}
const InputNumber = /* @__PURE__ */ _export_sfc(_sfc_main$X, [["render", _sfc_render$V], ["__file", "input-number.vue"]]), AlcInputNumber = withInstall(InputNumber), alcInputTagsProps = {
  /**
   * 配置选项
   * @default { label: 'label' }
   */
  props: {
    type: Object,
    default: () => ({
      label: "label",
      value: "value",
      disabled: "disabled"
    })
  },
  /**
   * tag 标签在输入元素内的排布形式
   * @default 'horizontal'
   */
  mode: {
    type: String,
    default: "horizontal"
  },
  /**
   * 多选时元素渲染为 tag 形式
   * @default true
   */
  multiple: { type: Boolean, default: !0 },
  /**
   * 是否支持内置输入框输入
   * @default false
   */
  writable: { type: Boolean, default: !1 },
  /**
   * 输入框占位符
   * @default '请输入'
   */
  placeholder: { type: String, default: "请输入" },
  /**
   * 如果 mode 是 vertical，本项指定最大高度
   * @default '200px'
   */
  maxHeight: { type: [String, Number], default: "200px" },
  /**
   * 是否在选中项后保留搜索关键字
   * @default true
   */
  // reserveKeyword: { type: Boolean, default: true },
  /**
   * 是否展示清除按钮
   * @default true
   */
  clearable: { type: Boolean, default: !0 },
  /**
   * 只读
   * @default false
   */
  readonly: { type: Boolean, default: !1 },
  /**
   * 禁用
   * @default false
   */
  disabled: { type: Boolean, default: !1 },
  /**
   * 收起 tag 展示
   * @default false
   */
  collapseTags: { type: Boolean, default: !1 },
  /**
   * 当多选隐藏于折叠标签中时，是否在外部保留一项
   * @default true
   */
  collapseShowOne: { type: Boolean, default: !0 },
  /**
   * 当鼠标悬停于折叠标签的文本时，是否显示所有选中的标签
   * @default true
   */
  collapseTagsTooltip: { type: Boolean, default: !0 },
  /**
   * 当选项选择器未被激活并且 persistent 设置为 false，选择器会被删除
   * @default true
   */
  persistent: { type: Boolean, default: !0 }
}, _sfc_main$W = /* @__PURE__ */ defineComponent({
  name: "alc-tags-input",
  __name: "input-tags",
  props: /* @__PURE__ */ mergeModels(alcInputTagsProps, {
    modelValue: {
      default: () => []
    },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ mergeModels(["clear", "focus", "blur", "enter", "input"], ["update:modelValue"]),
  setup(e, { expose: o, emit: n }) {
    const t = e, r = n, a = useModel(e, "modelValue"), l = useFormDisabled(), s = computed(() => !t.readonly && !l.value && t.clearable), c = ref(""), d = computed(() => ({
      readonly: t.readonly || !t.writable,
      ...t.writable && !t.multiple ? {
        readonly: !1,
        "onUpdate:modelValue": (C) => {
          c.value = C;
        }
      } : {}
    })), p = computed(() => {
      var C;
      return t.multiple ? a.value.length ? void 0 : t.placeholder : ((C = a.value) == null ? void 0 : C[t.props.label]) || t.placeholder;
    }), f = ref();
    watch(
      () => [a.value, t.props.label],
      ([C, I]) => {
        var v, M;
        C && I ? (isPlainObject(C) ? c.value = C[I] : isArray(C) && !t.multiple && (c.value = (v = C[0]) == null ? void 0 : v[I]), (M = f.value) == null || M.update()) : c.value = "";
      },
      { deep: !0, immediate: !0 }
    );
    const g = ref(), b = ref("auto"), k = new ResizeObserver((C) => {
      b.value = `${C[0].borderBoxSize[0].inlineSize + 8}px`;
    });
    onPageVisit(() => {
      var C;
      (C = m.value) == null || C.querySelectorAll(".el-scrollbar .el-scrollbar__bar").forEach((I) => {
        I.addEventListener("click", U, { passive: !1 });
      }), k.observe(g.value.input);
    }), onPageLeave(() => {
      var C;
      (C = m.value) == null || C.querySelectorAll(".el-scrollbar .el-scrollbar__bar").forEach((I) => {
        I.removeEventListener("click", U);
      }), k.disconnect();
    });
    const x = computed(() => {
      const C = {
        width: "100%",
        display: "flex",
        alignItems: "center"
      };
      return t.mode === "vertical" ? {
        ...C,
        height: "fit-content",
        maxHeight: t.maxHeight,
        flexFlow: "row wrap"
      } : {
        ...C,
        height: "100%",
        flexFlow: "row nowrap"
      };
    }), N = computed(() => +t.collapseShowOne), O = (C) => {
      const [I] = a.value.splice(C, 1);
      a.value = [...a.value], r("clear", I, C);
    }, m = ref(), ee = ref(150), z = () => {
      ee.value = m.value.offsetWidth;
    };
    function P(C) {
      r("focus", C), t.writable && (c.value = "");
    }
    function V(C) {
      isPlainObject(a.value) && (c.value = a.value[t.props.label]), r("blur", C);
    }
    function U(C) {
      C.stopPropagation();
    }
    o({
      ...getInstanceMethod(g, ["focus", "blur", "select"]),
      instanceRef: g
    });
    const E = { props: t, emits: r, multiList: a, isDisabled: l, canShowClearIcon: s, filter: c, showTextInputBind: d, filterPlaceholder: p, scrollbarRef: f, instanceRef: g, scrollWidth: b, inputWidthOs: k, cssVar: x, index: N, removeTag: O, wrapRef: m, popoverWidth: ee, popoverBeforeEnter: z, onFocus: P, onBlur: V, stop: U, get ElInput() {
      return ElInput;
    }, get ElPopover() {
      return ElPopover;
    }, get ElScrollbar() {
      return ElScrollbar;
    }, get ElTag() {
      return ElTag;
    }, get isArray() {
      return isArray;
    } };
    return Object.defineProperty(E, "__isScriptSetup", { enumerable: !1, value: !0 }), E;
  }
});
function _sfc_render$U(e, o, n, t, r, a) {
  var l;
  return openBlock(), createElementBlock("div", {
    ref: "wrapRef",
    style: normalizeStyle(e.mode === "vertical" ? { maxHeight: e.maxHeight } : {}),
    class: normalizeClass([{ "is-disabled": t.isDisabled, "is-readonly": e.readonly }, "alc-cpt-multi-text"])
  }, [
    createVNode(t.ElInput, mergeProps({
      ref: "instanceRef",
      "model-value": t.filter
    }, t.showTextInputBind, {
      disabled: t.isDisabled,
      "validate-event": !1,
      placeholder: t.filterPlaceholder,
      onKeydown: o[0] || (o[0] = withKeys((s) => e.$emit("enter", s), ["enter"])),
      onInput: o[1] || (o[1] = (s) => e.$emit("input", s)),
      onFocus: t.onFocus,
      onBlur: t.onBlur
    }), {
      suffix: withCtx(() => [
        renderSlot(e.$slots, "suffix")
      ]),
      _: 3
    }, 16, ["model-value", "disabled", "placeholder"]),
    e.multiple && t.isArray(t.multiList) ? (openBlock(), createBlock(t.ElScrollbar, {
      key: 0,
      ref: "scrollbarRef",
      class: normalizeClass([{ "is-disabled": t.isDisabled }, "custom-contain-scroll"]),
      "wrap-style": `width: ${t.scrollWidth}`,
      "view-style": t.cssVar
    }, {
      default: withCtx(() => {
        var s, c, d;
        return [
          e.collapseTags ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            e.collapseShowOne && t.multiList[0] && ((s = e.$props.props) != null && s.label) ? (openBlock(), createBlock(t.ElTag, {
              key: 0,
              closable: t.canShowClearIcon && !t.multiList[0].disabled,
              class: "custom-tags",
              size: "small",
              type: "info",
              onClose: o[2] || (o[2] = (p) => t.removeTag(0))
            }, {
              default: withCtx(() => {
                var p;
                return [
                  createTextVNode(toDisplayString$1(String((p = t.multiList[0]) == null ? void 0 : p[e.$props.props.label])), 1)
                ];
              }),
              _: 1
            }, 8, ["closable"])) : createCommentVNode("", !0),
            ((c = t.multiList) == null ? void 0 : c.length) > t.index ? (openBlock(), createBlock(t.ElTag, {
              key: 1,
              class: "custom-tags",
              size: "small",
              type: "info"
            }, {
              default: withCtx(() => {
                var p;
                return [
                  createTextVNode(" + " + toDisplayString$1(((p = t.multiList) == null ? void 0 : p.length) - t.index), 1)
                ];
              }),
              _: 1
            })) : createCommentVNode("", !0)
          ], 64)) : (d = t.multiList) != null && d.length ? (openBlock(!0), createElementBlock(Fragment, { key: 1 }, renderList(t.multiList, (p, f) => (openBlock(), createBlock(t.ElTag, {
            key: `s-t-i-${String(f)}`,
            closable: t.canShowClearIcon && !p.disabled,
            style: normalizeStyle([e.mode === "vertical" ? "margin-bottom: 4px" : ""]),
            class: "custom-tags",
            size: "small",
            type: "info",
            onClose: (g) => t.removeTag(f)
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString$1(String(p == null ? void 0 : p[e.$props.props.label])), 1)
            ]),
            _: 2
          }, 1032, ["closable", "style", "onClose"]))), 128)) : createCommentVNode("", !0)
        ];
      }),
      _: 1
    }, 8, ["class", "wrap-style", "view-style"])) : createCommentVNode("", !0),
    e.collapseTags && e.collapseTagsTooltip && ((l = t.multiList) == null ? void 0 : l.length) > t.index ? (openBlock(), createBlock(t.ElPopover, {
      key: 1,
      ref: "popoverRef",
      "virtual-ref": t.wrapRef,
      persistent: e.persistent,
      "show-after": 300,
      width: t.popoverWidth,
      "popper-class": [
        "alc-cpt-multi-tag--popover",
        { "non-pointer": e.readonly || t.isDisabled }
      ],
      "virtual-triggering": "",
      trigger: "hover",
      transition: "el-zoom-in-top",
      onBeforeEnter: t.popoverBeforeEnter
    }, {
      default: withCtx(() => [
        createVNode(t.ElScrollbar, {
          "view-style": "padding-bottom: 10px",
          "max-height": "240px"
        }, {
          default: withCtx(() => [
            (openBlock(!0), createElementBlock(Fragment, null, renderList(t.multiList.slice(t.index), (s, c) => (openBlock(), createBlock(t.ElTag, {
              key: `s-t-i-p-${String(c)}`,
              closable: t.canShowClearIcon && !s.disabled,
              class: "custom-tags",
              size: "small",
              type: "info",
              onClose: (d) => t.removeTag(c + t.index)
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString$1((s == null ? void 0 : s[e.$props.props.label]) || s), 1)
              ]),
              _: 2
            }, 1032, ["closable", "onClose"]))), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["virtual-ref", "persistent", "width", "popper-class"])) : createCommentVNode("", !0)
  ], 6);
}
const InputTabs = /* @__PURE__ */ _export_sfc(_sfc_main$W, [["render", _sfc_render$U], ["__file", "input-tags.vue"]]), AlcInputTags = withInstall(InputTabs), alcReferProps = {
  /**
   * 数据绑定值，参照当前的选择数据
   */
  modelValue: {
    type: [Object, Array],
    default: () => ({})
  },
  /**
   * 参照编码
   */
  code: { type: String, required: !0 },
  /**
   * 只读
   * @default false
   */
  readonly: { type: Boolean, default: !1 },
  /**
   * 禁用
   * @default false
   */
  disabled: { type: Boolean, default: !1 },
  /**
   * 多选
   * @default false
   */
  multiple: { type: Boolean, default: !1 },
  /**
   * 显示清空按钮
   * @default true
   */
  clearable: { type: Boolean, default: !0 },
  /**
   * 输入框占位符
   * @default '请选择'
   */
  placeholder: { type: String, default: "请选择" },
  /**
   * 纵向填充
   * @default false
   * @description 用于列表中
   */
  portraitFill: { type: Boolean, default: !1 },
  /**
   * 树-配置项
   */
  treeOption: {
    type: Object
  },
  /**
   * 列表-配置项
   */
  listOption: {
    type: Object
  },
  /**
   * 查询配置项
   */
  queryOption: { type: Object },
  /**
   * 自定义参照弹窗标题
   */
  dialogTitle: { type: String },
  /**
   * 收起 tag 展示
   * @default false
   */
  collapseTags: { type: Boolean, default: !1 },
  /**
   * 当多选隐藏于折叠标签中时，是否在外部保留一项
   * @default true
   */
  collapseShowOne: { type: Boolean, default: !0 },
  /**
   * change 时触发校验
   * @default false
   */
  validateEvent: { type: Boolean, default: !1 }
}, _sfc_main$V = defineComponent({
  name: "alc-dialog-footer",
  setup(e, { slots: o }) {
    const n = inject(DIALOG_REGISTER_CUSTOM_FOOTER);
    return inDialog(n) && onDialogOpen(() => {
      n.value = o.default;
    }), () => null;
  }
}), DialogFooter = /* @__PURE__ */ _export_sfc(_sfc_main$V, [["__file", "dialog-footer.vue"]]), AlcDialogFooter = withInstall(DialogFooter), alcAreaTitle = {
  /**
   * 标题
   */
  title: { type: String },
  /**
   * 顶部分割线
   * @default false
   */
  divided: { type: Boolean, default: !1 },
  /**
   * 拓展区域水平对齐方式
   * @default right
   */
  extraAlign: {
    type: String,
    default: "right"
  }
}, _sfc_main$U = /* @__PURE__ */ defineComponent({
  name: "alc-area-title",
  inheritAttrs: !1,
  __name: "area-title",
  props: alcAreaTitle,
  setup(e, { expose: o }) {
    o();
    const n = { get ElDivider() {
      return ElDivider;
    } };
    return Object.defineProperty(n, "__isScriptSetup", { enumerable: !1, value: !0 }), n;
  }
}), _hoisted_1$I = {
  key: 0,
  class: "alc-components-area-title--divided"
}, _hoisted_2$A = ["data-has-title"], _hoisted_3$u = ["title"];
function _sfc_render$T(e, o, n, t, r, a) {
  return openBlock(), createElementBlock(Fragment, null, [
    e.divided ? (openBlock(), createElementBlock("div", _hoisted_1$I)) : createCommentVNode("", !0),
    createElementVNode("div", mergeProps({
      class: "alc-components-area-title-container auto-width--wrap",
      "data-has-title": !!e.$slots.default || !!e.title
    }, e.$attrs), [
      createElementVNode("div", {
        class: "area-title",
        title: e.title
      }, [
        e.$slots.default ? renderSlot(e.$slots, "default", { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
          createTextVNode(toDisplayString$1(e.title), 1)
        ], 64))
      ], 8, _hoisted_3$u),
      e.$slots.extra ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: "alc-components-area-title--extra auto-width--target",
        style: normalizeStyle({
          justifyContent: e.extraAlign === "right" ? "flex-end" : "flex-start"
        })
      }, [
        e.$slots.extra && e.extraAlign === "left" ? (openBlock(), createBlock(t.ElDivider, {
          key: 0,
          direction: "vertical"
        })) : createCommentVNode("", !0),
        renderSlot(e.$slots, "extra")
      ], 4)) : createCommentVNode("", !0)
    ], 16, _hoisted_2$A)
  ], 64);
}
const AreaTitle = /* @__PURE__ */ _export_sfc(_sfc_main$U, [["render", _sfc_render$T], ["__file", "area-title.vue"]]), AlcAreaTitle = withInstall(AreaTitle), alcButtonProps = {
  ...buttonProps,
  ...alcAccessControlProps,
  ...emitsToProps(buttonEmits)
}, _sfc_main$T = defineComponent({
  name: "alc-button",
  props: alcButtonProps,
  setup(e, { attrs: o, slots: n }) {
    return e.code ? () => h(
      AlcAccessControl,
      { code: e.code },
      {
        default: () => h(
          ElButton,
          { ...e, ...o, code: void 0 },
          n
        )
      }
    ) : () => h(ElButton, { ...e, ...o }, n);
  }
}), Button = /* @__PURE__ */ _export_sfc(_sfc_main$T, [["__file", "button.vue"]]), AlcButton = withInstall(Button), _sfc_main$S = /* @__PURE__ */ defineComponent({
  name: "alc-table-operation",
  __name: "table-operation",
  props: {
    operations: {},
    scope: {},
    disabled: { type: Boolean },
    onOperationClick: { type: Function },
    onOpenConfirmPopover: { type: Function }
  },
  emits: ["operationClick", "openConfirmPopover"],
  setup(e, { expose: o, emit: n }) {
    o();
    const t = e, r = n, { haveAccess: a } = useAcl(), l = computed(() => t.operations.filter((f) => c(f))), s = /* @__PURE__ */ new WeakSet();
    function c(f) {
      if (typeof f.iif == "boolean")
        return f.iif;
      if (typeof f.iif == "function") {
        const { row: g, $index: b } = t.scope, k = f.iif({
          row: g,
          $index: b
        });
        return typeof k == "boolean" ? k : (k === "disabled" ? s.add(f) : s.delete(f), ["disabled", "show"].includes(k));
      }
      return !0;
    }
    function d(f, g) {
      const b = () => {
        typeof f.click == "function" ? f.click(t.scope) : r("operationClick", {
          operation: f,
          scope: t.scope
        });
      };
      f.pop && g ? r("openConfirmPopover", {
        title: "确定要删除本条数据吗？",
        ...f.popConfig,
        onConfirm: b,
        virtualRef: g.target,
        virtualTriggering: !0
      }) : b();
    }
    const p = { props: t, emit: r, haveAccess: a, enabledOperation: l, disabledBtnSet: s, operationIif: c, onRowOperationClick: d, get AlcButton() {
      return AlcButton;
    }, get ElButton() {
      return ElButton;
    }, get ElDropdown() {
      return ElDropdown;
    }, get ElDropdownItem() {
      return ElDropdownItem;
    }, get ElDropdownMenu() {
      return ElDropdownMenu;
    } };
    return Object.defineProperty(p, "__isScriptSetup", { enumerable: !1, value: !0 }), p;
  }
}), _hoisted_1$H = { class: "flex alc-cpt-container-operation" };
function _sfc_render$S(e, o, n, t, r, a) {
  return openBlock(), createElementBlock("div", _hoisted_1$H, [
    (openBlock(!0), createElementBlock(Fragment, null, renderList(t.enabledOperation, (l, s) => {
      var c;
      return openBlock(), createElementBlock(Fragment, null, [
        (c = l.children) != null && c.length ? (openBlock(), createBlock(t.ElDropdown, {
          key: `${l.label}_${s}`,
          disabled: n.disabled,
          size: "small",
          class: "alc-cpt-operation--more",
          onCommand: t.onRowOperationClick
        }, {
          dropdown: withCtx(() => [
            createVNode(t.ElDropdownMenu, null, {
              default: withCtx(() => [
                (openBlock(!0), createElementBlock(Fragment, null, renderList(l.children, (d, p) => (openBlock(), createElementBlock(Fragment, null, [
                  t.operationIif(d) && (!d.code || t.haveAccess(d.code)) ? (openBlock(), createBlock(t.ElDropdownItem, {
                    key: p,
                    command: d,
                    disabled: n.disabled || t.disabledBtnSet.has(l),
                    divided: d.divided
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString$1(d.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["command", "disabled", "divided"])) : createCommentVNode("", !0)
                ], 64))), 256))
              ]),
              _: 2
            }, 1024)
          ]),
          default: withCtx(() => [
            createVNode(t.ElButton, {
              size: "small",
              class: "ri-more-2-fill"
            })
          ]),
          _: 2
        }, 1032, ["disabled"])) : (openBlock(), createBlock(t.AlcButton, {
          key: `${l.label}_${s}_else`,
          code: l.code,
          disabled: n.disabled || t.disabledBtnSet.has(l),
          type: l.type || "default",
          size: "small",
          onClick: (d) => t.onRowOperationClick(l, d)
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString$1(l.label), 1)
          ]),
          _: 2
        }, 1032, ["code", "disabled", "type", "onClick"]))
      ], 64);
    }), 256))
  ]);
}
const TableOperation = /* @__PURE__ */ _export_sfc(_sfc_main$S, [["render", _sfc_render$S], ["__file", "table-operation.vue"]]), AlcTableOperation = withInstall(TableOperation), alcTooltipProps = objPick(useTooltipProps, [
  "appendTo",
  "teleported",
  "ariaLabel",
  "placement",
  "offset",
  /**
   * @change 由 tips 变为 content 了
   */
  "content"
]), _sfc_main$R = /* @__PURE__ */ defineComponent({
  name: "alc-tooltip",
  inheritAttrs: !1,
  __name: "tooltip",
  props: alcTooltipProps,
  setup(e, { expose: o }) {
    o();
    const t = { props: e, get ElTooltip() {
      return ElTooltip;
    } };
    return Object.defineProperty(t, "__isScriptSetup", { enumerable: !1, value: !0 }), t;
  }
});
function _sfc_render$R(e, o, n, t, r, a) {
  return openBlock(), createBlock(t.ElTooltip, mergeProps(t.props, { "raw-content": "" }), {
    content: withCtx(() => [
      renderSlot(e.$slots, "content")
    ]),
    default: withCtx(() => [
      createElementVNode("i", mergeProps({ class: "ri-question-line alc-cpt-tips" }, e.$attrs), null, 16)
    ]),
    _: 3
  }, 16);
}
const Tooltip = /* @__PURE__ */ _export_sfc(_sfc_main$R, [["render", _sfc_render$R], ["__file", "tooltip.vue"]]), AlcTooltip = withInstall(Tooltip);
var isNumeric$1 = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, mathceil = Math.ceil, mathfloor = Math.floor, bignumberError = "[BigNumber Error] ", tooManyDigits = bignumberError + "Number primitive has more than 15 significant digits: ", BASE = 1e14, LOG_BASE = 14, MAX_SAFE_INTEGER = 9007199254740991, POWS_TEN = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13], SQRT_BASE = 1e7, MAX = 1e9;
function clone(e) {
  var o, n, t, r = m.prototype = { constructor: m, toString: null, valueOf: null }, a = new m(1), l = 20, s = 4, c = -7, d = 21, p = -1e7, f = 1e7, g = !1, b = 1, k = 0, x = {
    prefix: "",
    groupSize: 3,
    secondaryGroupSize: 0,
    groupSeparator: ",",
    decimalSeparator: ".",
    fractionGroupSize: 0,
    fractionGroupSeparator: " ",
    // non-breaking space
    suffix: ""
  }, N = "0123456789abcdefghijklmnopqrstuvwxyz", O = !0;
  function m(E, C) {
    var I, v, M, $, H, X, te, oe, ne = this;
    if (!(ne instanceof m)) return new m(E, C);
    if (C == null) {
      if (E && E._isBigNumber === !0) {
        ne.s = E.s, !E.c || E.e > f ? ne.c = ne.e = null : E.e < p ? ne.c = [ne.e = 0] : (ne.e = E.e, ne.c = E.c.slice());
        return;
      }
      if ((X = typeof E == "number") && E * 0 == 0) {
        if (ne.s = 1 / E < 0 ? (E = -E, -1) : 1, E === ~~E) {
          for ($ = 0, H = E; H >= 10; H /= 10, $++) ;
          $ > f ? ne.c = ne.e = null : (ne.e = $, ne.c = [E]);
          return;
        }
        oe = String(E);
      } else {
        if (!isNumeric$1.test(oe = String(E))) return t(ne, oe, X);
        ne.s = oe.charCodeAt(0) == 45 ? (oe = oe.slice(1), -1) : 1;
      }
      ($ = oe.indexOf(".")) > -1 && (oe = oe.replace(".", "")), (H = oe.search(/e/i)) > 0 ? ($ < 0 && ($ = H), $ += +oe.slice(H + 1), oe = oe.substring(0, H)) : $ < 0 && ($ = oe.length);
    } else {
      if (intCheck(C, 2, N.length, "Base"), C == 10 && O)
        return ne = new m(E), V(ne, l + ne.e + 1, s);
      if (oe = String(E), X = typeof E == "number") {
        if (E * 0 != 0) return t(ne, oe, X, C);
        if (ne.s = 1 / E < 0 ? (oe = oe.slice(1), -1) : 1, m.DEBUG && oe.replace(/^0\.0*|\./, "").length > 15)
          throw Error(tooManyDigits + E);
      } else
        ne.s = oe.charCodeAt(0) === 45 ? (oe = oe.slice(1), -1) : 1;
      for (I = N.slice(0, C), $ = H = 0, te = oe.length; H < te; H++)
        if (I.indexOf(v = oe.charAt(H)) < 0) {
          if (v == ".") {
            if (H > $) {
              $ = te;
              continue;
            }
          } else if (!M && (oe == oe.toUpperCase() && (oe = oe.toLowerCase()) || oe == oe.toLowerCase() && (oe = oe.toUpperCase()))) {
            M = !0, H = -1, $ = 0;
            continue;
          }
          return t(ne, String(E), X, C);
        }
      X = !1, oe = n(oe, C, 10, ne.s), ($ = oe.indexOf(".")) > -1 ? oe = oe.replace(".", "") : $ = oe.length;
    }
    for (H = 0; oe.charCodeAt(H) === 48; H++) ;
    for (te = oe.length; oe.charCodeAt(--te) === 48; ) ;
    if (oe = oe.slice(H, ++te)) {
      if (te -= H, X && m.DEBUG && te > 15 && (E > MAX_SAFE_INTEGER || E !== mathfloor(E)))
        throw Error(tooManyDigits + ne.s * E);
      if (($ = $ - H - 1) > f)
        ne.c = ne.e = null;
      else if ($ < p)
        ne.c = [ne.e = 0];
      else {
        if (ne.e = $, ne.c = [], H = ($ + 1) % LOG_BASE, $ < 0 && (H += LOG_BASE), H < te) {
          for (H && ne.c.push(+oe.slice(0, H)), te -= LOG_BASE; H < te; )
            ne.c.push(+oe.slice(H, H += LOG_BASE));
          H = LOG_BASE - (oe = oe.slice(H)).length;
        } else
          H -= te;
        for (; H--; oe += "0") ;
        ne.c.push(+oe);
      }
    } else
      ne.c = [ne.e = 0];
  }
  m.clone = clone, m.ROUND_UP = 0, m.ROUND_DOWN = 1, m.ROUND_CEIL = 2, m.ROUND_FLOOR = 3, m.ROUND_HALF_UP = 4, m.ROUND_HALF_DOWN = 5, m.ROUND_HALF_EVEN = 6, m.ROUND_HALF_CEIL = 7, m.ROUND_HALF_FLOOR = 8, m.EUCLID = 9, m.config = m.set = function(E) {
    var C, I;
    if (E != null)
      if (typeof E == "object") {
        if (E.hasOwnProperty(C = "DECIMAL_PLACES") && (I = E[C], intCheck(I, 0, MAX, C), l = I), E.hasOwnProperty(C = "ROUNDING_MODE") && (I = E[C], intCheck(I, 0, 8, C), s = I), E.hasOwnProperty(C = "EXPONENTIAL_AT") && (I = E[C], I && I.pop ? (intCheck(I[0], -MAX, 0, C), intCheck(I[1], 0, MAX, C), c = I[0], d = I[1]) : (intCheck(I, -MAX, MAX, C), c = -(d = I < 0 ? -I : I))), E.hasOwnProperty(C = "RANGE"))
          if (I = E[C], I && I.pop)
            intCheck(I[0], -MAX, -1, C), intCheck(I[1], 1, MAX, C), p = I[0], f = I[1];
          else if (intCheck(I, -MAX, MAX, C), I)
            p = -(f = I < 0 ? -I : I);
          else
            throw Error(bignumberError + C + " cannot be zero: " + I);
        if (E.hasOwnProperty(C = "CRYPTO"))
          if (I = E[C], I === !!I)
            if (I)
              if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes))
                g = I;
              else
                throw g = !I, Error(bignumberError + "crypto unavailable");
            else
              g = I;
          else
            throw Error(bignumberError + C + " not true or false: " + I);
        if (E.hasOwnProperty(C = "MODULO_MODE") && (I = E[C], intCheck(I, 0, 9, C), b = I), E.hasOwnProperty(C = "POW_PRECISION") && (I = E[C], intCheck(I, 0, MAX, C), k = I), E.hasOwnProperty(C = "FORMAT"))
          if (I = E[C], typeof I == "object") x = I;
          else throw Error(bignumberError + C + " not an object: " + I);
        if (E.hasOwnProperty(C = "ALPHABET"))
          if (I = E[C], typeof I == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(I))
            O = I.slice(0, 10) == "0123456789", N = I;
          else
            throw Error(bignumberError + C + " invalid: " + I);
      } else
        throw Error(bignumberError + "Object expected: " + E);
    return {
      DECIMAL_PLACES: l,
      ROUNDING_MODE: s,
      EXPONENTIAL_AT: [c, d],
      RANGE: [p, f],
      CRYPTO: g,
      MODULO_MODE: b,
      POW_PRECISION: k,
      FORMAT: x,
      ALPHABET: N
    };
  }, m.isBigNumber = function(E) {
    if (!E || E._isBigNumber !== !0) return !1;
    if (!m.DEBUG) return !0;
    var C, I, v = E.c, M = E.e, $ = E.s;
    e: if ({}.toString.call(v) == "[object Array]") {
      if (($ === 1 || $ === -1) && M >= -MAX && M <= MAX && M === mathfloor(M)) {
        if (v[0] === 0) {
          if (M === 0 && v.length === 1) return !0;
          break e;
        }
        if (C = (M + 1) % LOG_BASE, C < 1 && (C += LOG_BASE), String(v[0]).length == C) {
          for (C = 0; C < v.length; C++)
            if (I = v[C], I < 0 || I >= BASE || I !== mathfloor(I)) break e;
          if (I !== 0) return !0;
        }
      }
    } else if (v === null && M === null && ($ === null || $ === 1 || $ === -1))
      return !0;
    throw Error(bignumberError + "Invalid BigNumber: " + E);
  }, m.maximum = m.max = function() {
    return z(arguments, -1);
  }, m.minimum = m.min = function() {
    return z(arguments, 1);
  }, m.random = function() {
    var E = 9007199254740992, C = Math.random() * E & 2097151 ? function() {
      return mathfloor(Math.random() * E);
    } : function() {
      return (Math.random() * 1073741824 | 0) * 8388608 + (Math.random() * 8388608 | 0);
    };
    return function(I) {
      var v, M, $, H, X, te = 0, oe = [], ne = new m(a);
      if (I == null ? I = l : intCheck(I, 0, MAX), H = mathceil(I / LOG_BASE), g)
        if (crypto.getRandomValues) {
          for (v = crypto.getRandomValues(new Uint32Array(H *= 2)); te < H; )
            X = v[te] * 131072 + (v[te + 1] >>> 11), X >= 9e15 ? (M = crypto.getRandomValues(new Uint32Array(2)), v[te] = M[0], v[te + 1] = M[1]) : (oe.push(X % 1e14), te += 2);
          te = H / 2;
        } else if (crypto.randomBytes) {
          for (v = crypto.randomBytes(H *= 7); te < H; )
            X = (v[te] & 31) * 281474976710656 + v[te + 1] * 1099511627776 + v[te + 2] * 4294967296 + v[te + 3] * 16777216 + (v[te + 4] << 16) + (v[te + 5] << 8) + v[te + 6], X >= 9e15 ? crypto.randomBytes(7).copy(v, te) : (oe.push(X % 1e14), te += 7);
          te = H / 7;
        } else
          throw g = !1, Error(bignumberError + "crypto unavailable");
      if (!g)
        for (; te < H; )
          X = C(), X < 9e15 && (oe[te++] = X % 1e14);
      for (H = oe[--te], I %= LOG_BASE, H && I && (X = POWS_TEN[LOG_BASE - I], oe[te] = mathfloor(H / X) * X); oe[te] === 0; oe.pop(), te--) ;
      if (te < 0)
        oe = [$ = 0];
      else {
        for ($ = -1; oe[0] === 0; oe.splice(0, 1), $ -= LOG_BASE) ;
        for (te = 1, X = oe[0]; X >= 10; X /= 10, te++) ;
        te < LOG_BASE && ($ -= LOG_BASE - te);
      }
      return ne.e = $, ne.c = oe, ne;
    };
  }(), m.sum = function() {
    for (var E = 1, C = arguments, I = new m(C[0]); E < C.length; ) I = I.plus(C[E++]);
    return I;
  }, n = /* @__PURE__ */ function() {
    var E = "0123456789";
    function C(I, v, M, $) {
      for (var H, X = [0], te, oe = 0, ne = I.length; oe < ne; ) {
        for (te = X.length; te--; X[te] *= v) ;
        for (X[0] += $.indexOf(I.charAt(oe++)), H = 0; H < X.length; H++)
          X[H] > M - 1 && (X[H + 1] == null && (X[H + 1] = 0), X[H + 1] += X[H] / M | 0, X[H] %= M);
      }
      return X.reverse();
    }
    return function(I, v, M, $, H) {
      var X, te, oe, ne, ie, se, pe, he, ae = I.indexOf("."), le = l, fe = s;
      for (ae >= 0 && (ne = k, k = 0, I = I.replace(".", ""), he = new m(v), se = he.pow(I.length - ae), k = ne, he.c = C(
        toFixedPoint(coeffToString(se.c), se.e, "0"),
        10,
        M,
        E
      ), he.e = he.c.length), pe = C(I, v, M, H ? (X = N, E) : (X = E, N)), oe = ne = pe.length; pe[--ne] == 0; pe.pop()) ;
      if (!pe[0]) return X.charAt(0);
      if (ae < 0 ? --oe : (se.c = pe, se.e = oe, se.s = $, se = o(se, he, le, fe, M), pe = se.c, ie = se.r, oe = se.e), te = oe + le + 1, ae = pe[te], ne = M / 2, ie = ie || te < 0 || pe[te + 1] != null, ie = fe < 4 ? (ae != null || ie) && (fe == 0 || fe == (se.s < 0 ? 3 : 2)) : ae > ne || ae == ne && (fe == 4 || ie || fe == 6 && pe[te - 1] & 1 || fe == (se.s < 0 ? 8 : 7)), te < 1 || !pe[0])
        I = ie ? toFixedPoint(X.charAt(1), -le, X.charAt(0)) : X.charAt(0);
      else {
        if (pe.length = te, ie)
          for (--M; ++pe[--te] > M; )
            pe[te] = 0, te || (++oe, pe = [1].concat(pe));
        for (ne = pe.length; !pe[--ne]; ) ;
        for (ae = 0, I = ""; ae <= ne; I += X.charAt(pe[ae++])) ;
        I = toFixedPoint(I, oe, X.charAt(0));
      }
      return I;
    };
  }(), o = /* @__PURE__ */ function() {
    function E(v, M, $) {
      var H, X, te, oe, ne = 0, ie = v.length, se = M % SQRT_BASE, pe = M / SQRT_BASE | 0;
      for (v = v.slice(); ie--; )
        te = v[ie] % SQRT_BASE, oe = v[ie] / SQRT_BASE | 0, H = pe * te + oe * se, X = se * te + H % SQRT_BASE * SQRT_BASE + ne, ne = (X / $ | 0) + (H / SQRT_BASE | 0) + pe * oe, v[ie] = X % $;
      return ne && (v = [ne].concat(v)), v;
    }
    function C(v, M, $, H) {
      var X, te;
      if ($ != H)
        te = $ > H ? 1 : -1;
      else
        for (X = te = 0; X < $; X++)
          if (v[X] != M[X]) {
            te = v[X] > M[X] ? 1 : -1;
            break;
          }
      return te;
    }
    function I(v, M, $, H) {
      for (var X = 0; $--; )
        v[$] -= X, X = v[$] < M[$] ? 1 : 0, v[$] = X * H + v[$] - M[$];
      for (; !v[0] && v.length > 1; v.splice(0, 1)) ;
    }
    return function(v, M, $, H, X) {
      var te, oe, ne, ie, se, pe, he, ae, le, fe, Ce, Be, De, Fe, Me, xe, _e, Ee = v.s == M.s ? 1 : -1, re = v.c, ce = M.c;
      if (!re || !re[0] || !ce || !ce[0])
        return new m(
          // Return NaN if either NaN, or both Infinity or 0.
          !v.s || !M.s || (re ? ce && re[0] == ce[0] : !ce) ? NaN : (
            // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
            re && re[0] == 0 || !ce ? Ee * 0 : Ee / 0
          )
        );
      for (ae = new m(Ee), le = ae.c = [], oe = v.e - M.e, Ee = $ + oe + 1, X || (X = BASE, oe = bitFloor(v.e / LOG_BASE) - bitFloor(M.e / LOG_BASE), Ee = Ee / LOG_BASE | 0), ne = 0; ce[ne] == (re[ne] || 0); ne++) ;
      if (ce[ne] > (re[ne] || 0) && oe--, Ee < 0)
        le.push(1), ie = !0;
      else {
        for (Fe = re.length, xe = ce.length, ne = 0, Ee += 2, se = mathfloor(X / (ce[0] + 1)), se > 1 && (ce = E(ce, se, X), re = E(re, se, X), xe = ce.length, Fe = re.length), De = xe, fe = re.slice(0, xe), Ce = fe.length; Ce < xe; fe[Ce++] = 0) ;
        _e = ce.slice(), _e = [0].concat(_e), Me = ce[0], ce[1] >= X / 2 && Me++;
        do {
          if (se = 0, te = C(ce, fe, xe, Ce), te < 0) {
            if (Be = fe[0], xe != Ce && (Be = Be * X + (fe[1] || 0)), se = mathfloor(Be / Me), se > 1)
              for (se >= X && (se = X - 1), pe = E(ce, se, X), he = pe.length, Ce = fe.length; C(pe, fe, he, Ce) == 1; )
                se--, I(pe, xe < he ? _e : ce, he, X), he = pe.length, te = 1;
            else
              se == 0 && (te = se = 1), pe = ce.slice(), he = pe.length;
            if (he < Ce && (pe = [0].concat(pe)), I(fe, pe, Ce, X), Ce = fe.length, te == -1)
              for (; C(ce, fe, xe, Ce) < 1; )
                se++, I(fe, xe < Ce ? _e : ce, Ce, X), Ce = fe.length;
          } else te === 0 && (se++, fe = [0]);
          le[ne++] = se, fe[0] ? fe[Ce++] = re[De] || 0 : (fe = [re[De]], Ce = 1);
        } while ((De++ < Fe || fe[0] != null) && Ee--);
        ie = fe[0] != null, le[0] || le.splice(0, 1);
      }
      if (X == BASE) {
        for (ne = 1, Ee = le[0]; Ee >= 10; Ee /= 10, ne++) ;
        V(ae, $ + (ae.e = ne + oe * LOG_BASE - 1) + 1, H, ie);
      } else
        ae.e = oe, ae.r = +ie;
      return ae;
    };
  }();
  function ee(E, C, I, v) {
    var M, $, H, X, te;
    if (I == null ? I = s : intCheck(I, 0, 8), !E.c) return E.toString();
    if (M = E.c[0], H = E.e, C == null)
      te = coeffToString(E.c), te = v == 1 || v == 2 && (H <= c || H >= d) ? toExponential(te, H) : toFixedPoint(te, H, "0");
    else if (E = V(new m(E), C, I), $ = E.e, te = coeffToString(E.c), X = te.length, v == 1 || v == 2 && (C <= $ || $ <= c)) {
      for (; X < C; te += "0", X++) ;
      te = toExponential(te, $);
    } else if (C -= H, te = toFixedPoint(te, $, "0"), $ + 1 > X) {
      if (--C > 0) for (te += "."; C--; te += "0") ;
    } else if (C += $ - X, C > 0)
      for ($ + 1 == X && (te += "."); C--; te += "0") ;
    return E.s < 0 && M ? "-" + te : te;
  }
  function z(E, C) {
    for (var I, v, M = 1, $ = new m(E[0]); M < E.length; M++)
      v = new m(E[M]), (!v.s || (I = compare($, v)) === C || I === 0 && $.s === C) && ($ = v);
    return $;
  }
  function P(E, C, I) {
    for (var v = 1, M = C.length; !C[--M]; C.pop()) ;
    for (M = C[0]; M >= 10; M /= 10, v++) ;
    return (I = v + I * LOG_BASE - 1) > f ? E.c = E.e = null : I < p ? E.c = [E.e = 0] : (E.e = I, E.c = C), E;
  }
  t = /* @__PURE__ */ function() {
    var E = /^(-?)0([xbo])(?=\w[\w.]*$)/i, C = /^([^.]+)\.$/, I = /^\.([^.]+)$/, v = /^-?(Infinity|NaN)$/, M = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
    return function($, H, X, te) {
      var oe, ne = X ? H : H.replace(M, "");
      if (v.test(ne))
        $.s = isNaN(ne) ? null : ne < 0 ? -1 : 1;
      else {
        if (!X && (ne = ne.replace(E, function(ie, se, pe) {
          return oe = (pe = pe.toLowerCase()) == "x" ? 16 : pe == "b" ? 2 : 8, !te || te == oe ? se : ie;
        }), te && (oe = te, ne = ne.replace(C, "$1").replace(I, "0.$1")), H != ne))
          return new m(ne, oe);
        if (m.DEBUG)
          throw Error(bignumberError + "Not a" + (te ? " base " + te : "") + " number: " + H);
        $.s = null;
      }
      $.c = $.e = null;
    };
  }();
  function V(E, C, I, v) {
    var M, $, H, X, te, oe, ne, ie = E.c, se = POWS_TEN;
    if (ie) {
      e: {
        for (M = 1, X = ie[0]; X >= 10; X /= 10, M++) ;
        if ($ = C - M, $ < 0)
          $ += LOG_BASE, H = C, te = ie[oe = 0], ne = mathfloor(te / se[M - H - 1] % 10);
        else if (oe = mathceil(($ + 1) / LOG_BASE), oe >= ie.length)
          if (v) {
            for (; ie.length <= oe; ie.push(0)) ;
            te = ne = 0, M = 1, $ %= LOG_BASE, H = $ - LOG_BASE + 1;
          } else
            break e;
        else {
          for (te = X = ie[oe], M = 1; X >= 10; X /= 10, M++) ;
          $ %= LOG_BASE, H = $ - LOG_BASE + M, ne = H < 0 ? 0 : mathfloor(te / se[M - H - 1] % 10);
        }
        if (v = v || C < 0 || // Are there any non-zero digits after the rounding digit?
        // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
        // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
        ie[oe + 1] != null || (H < 0 ? te : te % se[M - H - 1]), v = I < 4 ? (ne || v) && (I == 0 || I == (E.s < 0 ? 3 : 2)) : ne > 5 || ne == 5 && (I == 4 || v || I == 6 && // Check whether the digit to the left of the rounding digit is odd.
        ($ > 0 ? H > 0 ? te / se[M - H] : 0 : ie[oe - 1]) % 10 & 1 || I == (E.s < 0 ? 8 : 7)), C < 1 || !ie[0])
          return ie.length = 0, v ? (C -= E.e + 1, ie[0] = se[(LOG_BASE - C % LOG_BASE) % LOG_BASE], E.e = -C || 0) : ie[0] = E.e = 0, E;
        if ($ == 0 ? (ie.length = oe, X = 1, oe--) : (ie.length = oe + 1, X = se[LOG_BASE - $], ie[oe] = H > 0 ? mathfloor(te / se[M - H] % se[H]) * X : 0), v)
          for (; ; )
            if (oe == 0) {
              for ($ = 1, H = ie[0]; H >= 10; H /= 10, $++) ;
              for (H = ie[0] += X, X = 1; H >= 10; H /= 10, X++) ;
              $ != X && (E.e++, ie[0] == BASE && (ie[0] = 1));
              break;
            } else {
              if (ie[oe] += X, ie[oe] != BASE) break;
              ie[oe--] = 0, X = 1;
            }
        for ($ = ie.length; ie[--$] === 0; ie.pop()) ;
      }
      E.e > f ? E.c = E.e = null : E.e < p && (E.c = [E.e = 0]);
    }
    return E;
  }
  function U(E) {
    var C, I = E.e;
    return I === null ? E.toString() : (C = coeffToString(E.c), C = I <= c || I >= d ? toExponential(C, I) : toFixedPoint(C, I, "0"), E.s < 0 ? "-" + C : C);
  }
  return r.absoluteValue = r.abs = function() {
    var E = new m(this);
    return E.s < 0 && (E.s = 1), E;
  }, r.comparedTo = function(E, C) {
    return compare(this, new m(E, C));
  }, r.decimalPlaces = r.dp = function(E, C) {
    var I, v, M, $ = this;
    if (E != null)
      return intCheck(E, 0, MAX), C == null ? C = s : intCheck(C, 0, 8), V(new m($), E + $.e + 1, C);
    if (!(I = $.c)) return null;
    if (v = ((M = I.length - 1) - bitFloor(this.e / LOG_BASE)) * LOG_BASE, M = I[M]) for (; M % 10 == 0; M /= 10, v--) ;
    return v < 0 && (v = 0), v;
  }, r.dividedBy = r.div = function(E, C) {
    return o(this, new m(E, C), l, s);
  }, r.dividedToIntegerBy = r.idiv = function(E, C) {
    return o(this, new m(E, C), 0, 1);
  }, r.exponentiatedBy = r.pow = function(E, C) {
    var I, v, M, $, H, X, te, oe, ne, ie = this;
    if (E = new m(E), E.c && !E.isInteger())
      throw Error(bignumberError + "Exponent not an integer: " + U(E));
    if (C != null && (C = new m(C)), X = E.e > 14, !ie.c || !ie.c[0] || ie.c[0] == 1 && !ie.e && ie.c.length == 1 || !E.c || !E.c[0])
      return ne = new m(Math.pow(+U(ie), X ? E.s * (2 - isOdd(E)) : +U(E))), C ? ne.mod(C) : ne;
    if (te = E.s < 0, C) {
      if (C.c ? !C.c[0] : !C.s) return new m(NaN);
      v = !te && ie.isInteger() && C.isInteger(), v && (ie = ie.mod(C));
    } else {
      if (E.e > 9 && (ie.e > 0 || ie.e < -1 || (ie.e == 0 ? ie.c[0] > 1 || X && ie.c[1] >= 24e7 : ie.c[0] < 8e13 || X && ie.c[0] <= 9999975e7)))
        return $ = ie.s < 0 && isOdd(E) ? -0 : 0, ie.e > -1 && ($ = 1 / $), new m(te ? 1 / $ : $);
      k && ($ = mathceil(k / LOG_BASE + 2));
    }
    for (X ? (I = new m(0.5), te && (E.s = 1), oe = isOdd(E)) : (M = Math.abs(+U(E)), oe = M % 2), ne = new m(a); ; ) {
      if (oe) {
        if (ne = ne.times(ie), !ne.c) break;
        $ ? ne.c.length > $ && (ne.c.length = $) : v && (ne = ne.mod(C));
      }
      if (M) {
        if (M = mathfloor(M / 2), M === 0) break;
        oe = M % 2;
      } else if (E = E.times(I), V(E, E.e + 1, 1), E.e > 14)
        oe = isOdd(E);
      else {
        if (M = +U(E), M === 0) break;
        oe = M % 2;
      }
      ie = ie.times(ie), $ ? ie.c && ie.c.length > $ && (ie.c.length = $) : v && (ie = ie.mod(C));
    }
    return v ? ne : (te && (ne = a.div(ne)), C ? ne.mod(C) : $ ? V(ne, k, s, H) : ne);
  }, r.integerValue = function(E) {
    var C = new m(this);
    return E == null ? E = s : intCheck(E, 0, 8), V(C, C.e + 1, E);
  }, r.isEqualTo = r.eq = function(E, C) {
    return compare(this, new m(E, C)) === 0;
  }, r.isFinite = function() {
    return !!this.c;
  }, r.isGreaterThan = r.gt = function(E, C) {
    return compare(this, new m(E, C)) > 0;
  }, r.isGreaterThanOrEqualTo = r.gte = function(E, C) {
    return (C = compare(this, new m(E, C))) === 1 || C === 0;
  }, r.isInteger = function() {
    return !!this.c && bitFloor(this.e / LOG_BASE) > this.c.length - 2;
  }, r.isLessThan = r.lt = function(E, C) {
    return compare(this, new m(E, C)) < 0;
  }, r.isLessThanOrEqualTo = r.lte = function(E, C) {
    return (C = compare(this, new m(E, C))) === -1 || C === 0;
  }, r.isNaN = function() {
    return !this.s;
  }, r.isNegative = function() {
    return this.s < 0;
  }, r.isPositive = function() {
    return this.s > 0;
  }, r.isZero = function() {
    return !!this.c && this.c[0] == 0;
  }, r.minus = function(E, C) {
    var I, v, M, $, H = this, X = H.s;
    if (E = new m(E, C), C = E.s, !X || !C) return new m(NaN);
    if (X != C)
      return E.s = -C, H.plus(E);
    var te = H.e / LOG_BASE, oe = E.e / LOG_BASE, ne = H.c, ie = E.c;
    if (!te || !oe) {
      if (!ne || !ie) return ne ? (E.s = -C, E) : new m(ie ? H : NaN);
      if (!ne[0] || !ie[0])
        return ie[0] ? (E.s = -C, E) : new m(ne[0] ? H : (
          // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
          s == 3 ? -0 : 0
        ));
    }
    if (te = bitFloor(te), oe = bitFloor(oe), ne = ne.slice(), X = te - oe) {
      for (($ = X < 0) ? (X = -X, M = ne) : (oe = te, M = ie), M.reverse(), C = X; C--; M.push(0)) ;
      M.reverse();
    } else
      for (v = ($ = (X = ne.length) < (C = ie.length)) ? X : C, X = C = 0; C < v; C++)
        if (ne[C] != ie[C]) {
          $ = ne[C] < ie[C];
          break;
        }
    if ($ && (M = ne, ne = ie, ie = M, E.s = -E.s), C = (v = ie.length) - (I = ne.length), C > 0) for (; C--; ne[I++] = 0) ;
    for (C = BASE - 1; v > X; ) {
      if (ne[--v] < ie[v]) {
        for (I = v; I && !ne[--I]; ne[I] = C) ;
        --ne[I], ne[v] += BASE;
      }
      ne[v] -= ie[v];
    }
    for (; ne[0] == 0; ne.splice(0, 1), --oe) ;
    return ne[0] ? P(E, ne, oe) : (E.s = s == 3 ? -1 : 1, E.c = [E.e = 0], E);
  }, r.modulo = r.mod = function(E, C) {
    var I, v, M = this;
    return E = new m(E, C), !M.c || !E.s || E.c && !E.c[0] ? new m(NaN) : !E.c || M.c && !M.c[0] ? new m(M) : (b == 9 ? (v = E.s, E.s = 1, I = o(M, E, 0, 3), E.s = v, I.s *= v) : I = o(M, E, 0, b), E = M.minus(I.times(E)), !E.c[0] && b == 1 && (E.s = M.s), E);
  }, r.multipliedBy = r.times = function(E, C) {
    var I, v, M, $, H, X, te, oe, ne, ie, se, pe, he, ae, le, fe = this, Ce = fe.c, Be = (E = new m(E, C)).c;
    if (!Ce || !Be || !Ce[0] || !Be[0])
      return !fe.s || !E.s || Ce && !Ce[0] && !Be || Be && !Be[0] && !Ce ? E.c = E.e = E.s = null : (E.s *= fe.s, !Ce || !Be ? E.c = E.e = null : (E.c = [0], E.e = 0)), E;
    for (v = bitFloor(fe.e / LOG_BASE) + bitFloor(E.e / LOG_BASE), E.s *= fe.s, te = Ce.length, ie = Be.length, te < ie && (he = Ce, Ce = Be, Be = he, M = te, te = ie, ie = M), M = te + ie, he = []; M--; he.push(0)) ;
    for (ae = BASE, le = SQRT_BASE, M = ie; --M >= 0; ) {
      for (I = 0, se = Be[M] % le, pe = Be[M] / le | 0, H = te, $ = M + H; $ > M; )
        oe = Ce[--H] % le, ne = Ce[H] / le | 0, X = pe * oe + ne * se, oe = se * oe + X % le * le + he[$] + I, I = (oe / ae | 0) + (X / le | 0) + pe * ne, he[$--] = oe % ae;
      he[$] = I;
    }
    return I ? ++v : he.splice(0, 1), P(E, he, v);
  }, r.negated = function() {
    var E = new m(this);
    return E.s = -E.s || null, E;
  }, r.plus = function(E, C) {
    var I, v = this, M = v.s;
    if (E = new m(E, C), C = E.s, !M || !C) return new m(NaN);
    if (M != C)
      return E.s = -C, v.minus(E);
    var $ = v.e / LOG_BASE, H = E.e / LOG_BASE, X = v.c, te = E.c;
    if (!$ || !H) {
      if (!X || !te) return new m(M / 0);
      if (!X[0] || !te[0]) return te[0] ? E : new m(X[0] ? v : M * 0);
    }
    if ($ = bitFloor($), H = bitFloor(H), X = X.slice(), M = $ - H) {
      for (M > 0 ? (H = $, I = te) : (M = -M, I = X), I.reverse(); M--; I.push(0)) ;
      I.reverse();
    }
    for (M = X.length, C = te.length, M - C < 0 && (I = te, te = X, X = I, C = M), M = 0; C; )
      M = (X[--C] = X[C] + te[C] + M) / BASE | 0, X[C] = BASE === X[C] ? 0 : X[C] % BASE;
    return M && (X = [M].concat(X), ++H), P(E, X, H);
  }, r.precision = r.sd = function(E, C) {
    var I, v, M, $ = this;
    if (E != null && E !== !!E)
      return intCheck(E, 1, MAX), C == null ? C = s : intCheck(C, 0, 8), V(new m($), E, C);
    if (!(I = $.c)) return null;
    if (M = I.length - 1, v = M * LOG_BASE + 1, M = I[M]) {
      for (; M % 10 == 0; M /= 10, v--) ;
      for (M = I[0]; M >= 10; M /= 10, v++) ;
    }
    return E && $.e + 1 > v && (v = $.e + 1), v;
  }, r.shiftedBy = function(E) {
    return intCheck(E, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER), this.times("1e" + E);
  }, r.squareRoot = r.sqrt = function() {
    var E, C, I, v, M, $ = this, H = $.c, X = $.s, te = $.e, oe = l + 4, ne = new m("0.5");
    if (X !== 1 || !H || !H[0])
      return new m(!X || X < 0 && (!H || H[0]) ? NaN : H ? $ : 1 / 0);
    if (X = Math.sqrt(+U($)), X == 0 || X == 1 / 0 ? (C = coeffToString(H), (C.length + te) % 2 == 0 && (C += "0"), X = Math.sqrt(+C), te = bitFloor((te + 1) / 2) - (te < 0 || te % 2), X == 1 / 0 ? C = "5e" + te : (C = X.toExponential(), C = C.slice(0, C.indexOf("e") + 1) + te), I = new m(C)) : I = new m(X + ""), I.c[0]) {
      for (te = I.e, X = te + oe, X < 3 && (X = 0); ; )
        if (M = I, I = ne.times(M.plus(o($, M, oe, 1))), coeffToString(M.c).slice(0, X) === (C = coeffToString(I.c)).slice(0, X))
          if (I.e < te && --X, C = C.slice(X - 3, X + 1), C == "9999" || !v && C == "4999") {
            if (!v && (V(M, M.e + l + 2, 0), M.times(M).eq($))) {
              I = M;
              break;
            }
            oe += 4, X += 4, v = 1;
          } else {
            (!+C || !+C.slice(1) && C.charAt(0) == "5") && (V(I, I.e + l + 2, 1), E = !I.times(I).eq($));
            break;
          }
    }
    return V(I, I.e + l + 1, s, E);
  }, r.toExponential = function(E, C) {
    return E != null && (intCheck(E, 0, MAX), E++), ee(this, E, C, 1);
  }, r.toFixed = function(E, C) {
    return E != null && (intCheck(E, 0, MAX), E = E + this.e + 1), ee(this, E, C);
  }, r.toFormat = function(E, C, I) {
    var v, M = this;
    if (I == null)
      E != null && C && typeof C == "object" ? (I = C, C = null) : E && typeof E == "object" ? (I = E, E = C = null) : I = x;
    else if (typeof I != "object")
      throw Error(bignumberError + "Argument not an object: " + I);
    if (v = M.toFixed(E, C), M.c) {
      var $, H = v.split("."), X = +I.groupSize, te = +I.secondaryGroupSize, oe = I.groupSeparator || "", ne = H[0], ie = H[1], se = M.s < 0, pe = se ? ne.slice(1) : ne, he = pe.length;
      if (te && ($ = X, X = te, te = $, he -= $), X > 0 && he > 0) {
        for ($ = he % X || X, ne = pe.substr(0, $); $ < he; $ += X) ne += oe + pe.substr($, X);
        te > 0 && (ne += oe + pe.slice($)), se && (ne = "-" + ne);
      }
      v = ie ? ne + (I.decimalSeparator || "") + ((te = +I.fractionGroupSize) ? ie.replace(
        new RegExp("\\d{" + te + "}\\B", "g"),
        "$&" + (I.fractionGroupSeparator || "")
      ) : ie) : ne;
    }
    return (I.prefix || "") + v + (I.suffix || "");
  }, r.toFraction = function(E) {
    var C, I, v, M, $, H, X, te, oe, ne, ie, se, pe = this, he = pe.c;
    if (E != null && (X = new m(E), !X.isInteger() && (X.c || X.s !== 1) || X.lt(a)))
      throw Error(bignumberError + "Argument " + (X.isInteger() ? "out of range: " : "not an integer: ") + U(X));
    if (!he) return new m(pe);
    for (C = new m(a), oe = I = new m(a), v = te = new m(a), se = coeffToString(he), $ = C.e = se.length - pe.e - 1, C.c[0] = POWS_TEN[(H = $ % LOG_BASE) < 0 ? LOG_BASE + H : H], E = !E || X.comparedTo(C) > 0 ? $ > 0 ? C : oe : X, H = f, f = 1 / 0, X = new m(se), te.c[0] = 0; ne = o(X, C, 0, 1), M = I.plus(ne.times(v)), M.comparedTo(E) != 1; )
      I = v, v = M, oe = te.plus(ne.times(M = oe)), te = M, C = X.minus(ne.times(M = C)), X = M;
    return M = o(E.minus(I), v, 0, 1), te = te.plus(M.times(oe)), I = I.plus(M.times(v)), te.s = oe.s = pe.s, $ = $ * 2, ie = o(oe, v, $, s).minus(pe).abs().comparedTo(
      o(te, I, $, s).minus(pe).abs()
    ) < 1 ? [oe, v] : [te, I], f = H, ie;
  }, r.toNumber = function() {
    return +U(this);
  }, r.toPrecision = function(E, C) {
    return E != null && intCheck(E, 1, MAX), ee(this, E, C, 2);
  }, r.toString = function(E) {
    var C, I = this, v = I.s, M = I.e;
    return M === null ? v ? (C = "Infinity", v < 0 && (C = "-" + C)) : C = "NaN" : (E == null ? C = M <= c || M >= d ? toExponential(coeffToString(I.c), M) : toFixedPoint(coeffToString(I.c), M, "0") : E === 10 && O ? (I = V(new m(I), l + M + 1, s), C = toFixedPoint(coeffToString(I.c), I.e, "0")) : (intCheck(E, 2, N.length, "Base"), C = n(toFixedPoint(coeffToString(I.c), M, "0"), 10, E, v, !0)), v < 0 && I.c[0] && (C = "-" + C)), C;
  }, r.valueOf = r.toJSON = function() {
    return U(this);
  }, r._isBigNumber = !0, r[Symbol.toStringTag] = "BigNumber", r[Symbol.for("nodejs.util.inspect.custom")] = r.valueOf, e != null && m.set(e), m;
}
function bitFloor(e) {
  var o = e | 0;
  return e > 0 || e === o ? o : o - 1;
}
function coeffToString(e) {
  for (var o, n, t = 1, r = e.length, a = e[0] + ""; t < r; ) {
    for (o = e[t++] + "", n = LOG_BASE - o.length; n--; o = "0" + o) ;
    a += o;
  }
  for (r = a.length; a.charCodeAt(--r) === 48; ) ;
  return a.slice(0, r + 1 || 1);
}
function compare(e, o) {
  var n, t, r = e.c, a = o.c, l = e.s, s = o.s, c = e.e, d = o.e;
  if (!l || !s) return null;
  if (n = r && !r[0], t = a && !a[0], n || t) return n ? t ? 0 : -s : l;
  if (l != s) return l;
  if (n = l < 0, t = c == d, !r || !a) return t ? 0 : !r ^ n ? 1 : -1;
  if (!t) return c > d ^ n ? 1 : -1;
  for (s = (c = r.length) < (d = a.length) ? c : d, l = 0; l < s; l++) if (r[l] != a[l]) return r[l] > a[l] ^ n ? 1 : -1;
  return c == d ? 0 : c > d ^ n ? 1 : -1;
}
function intCheck(e, o, n, t) {
  if (e < o || e > n || e !== mathfloor(e))
    throw Error(bignumberError + (t || "Argument") + (typeof e == "number" ? e < o || e > n ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(e));
}
function isOdd(e) {
  var o = e.c.length - 1;
  return bitFloor(e.e / LOG_BASE) == o && e.c[o] % 2 != 0;
}
function toExponential(e, o) {
  return (e.length > 1 ? e.charAt(0) + "." + e.slice(1) : e) + (o < 0 ? "e" : "e+") + o;
}
function toFixedPoint(e, o, n) {
  var t, r;
  if (o < 0) {
    for (r = n + "."; ++o; r += n) ;
    e = r + e;
  } else if (t = e.length, ++o > t) {
    for (r = n, o -= t; --o; r += n) ;
    e += r;
  } else o < t && (e = e.slice(0, o) + "." + e.slice(o));
  return e;
}
var BigNumber = clone();
const useConfirmPop = (e) => {
  const o = useProp("operation"), n = computed(() => {
    var d;
    return ((d = o.value) == null ? void 0 : d.map((p, f) => ({
      ...p,
      label: isBlank(p.label) ? "未命名" : p.label,
      method: isBlank(p.method) ? `method${f}` : p.method,
      type: ["primary", "warning", "danger", "success"].includes(
        p.type
      ) ? p.type : "primary"
    }))) || [];
  });
  function t(d) {
    e.value || (a.value = d);
  }
  const r = ref(!1), a = ref(
    {}
  );
  let l, s;
  watch(r, (d) => {
    d ? (l = c({
      eventName: "mousedown",
      callback: (p) => {
        (p.path || p.composedPath()).some((g) => {
          var b;
          return (b = g.classList) == null ? void 0 : b.contains("el-popover");
        }) || (r.value = !1, l(), s == null || s());
      },
      options: {
        passive: !0
      }
    }), s = c({
      eventName: "scroll",
      callback: () => {
        r.value = !1, s(), l == null || l();
      },
      options: {
        capture: !0,
        passive: !0
      }
    })) : (l(), s());
  });
  function c(d) {
    return d.target || (d.target = document), d.target.addEventListener(
      d.eventName,
      d.callback,
      d.options
    ), () => {
      d.target.removeEventListener(
        d.eventName,
        d.callback
      );
    };
  }
  return {
    operationSets: n,
    popoverVisible: r,
    popConfig: a,
    openConfirmPop: t
  };
}, useShowConditionColumn = (e) => {
  const o = useProp("schema"), n = useProp("operation"), { haveAccess: t } = useAcl(), r = computed(() => {
    var b;
    return ((b = n.value) == null ? void 0 : b.some((k) => k.code === void 0 ? !0 : t(k.code))) ?? !1;
  }), a = ref(0), l = ref(0), s = computed(() => {
    var b;
    return (b = o.value) == null ? void 0 : b.some((k) => !k.width);
  }), c = ref(!0), d = computed(() => s.value && c.value ? 0 : l.value === 0 ? 1 : Math.max(a.value - l.value, 1)), p = new ResizeObserver((b) => {
    b.length > 0 && b[0].contentRect.width !== a.value && (a.value = b[0].contentRect.width);
  }), f = new MutationObserver(g);
  onPageVisit(() => {
    p.observe(e.value.$el), f.observe(
      e.value.$el.querySelector(".el-table__header"),
      {
        subtree: !0,
        attributeFilter: ["width"],
        childList: !1,
        characterData: !1
      }
    );
  }), onPageLeave(() => {
    p.disconnect(), f.disconnect();
  });
  function g() {
    const b = [
      ...e.value.$el.querySelectorAll(
        ".el-table__header > colgroup > col"
      )
    ], k = [
      ...e.value.$el.querySelectorAll(
        ".el-table__header > thead > tr > th"
      )
    ], x = k.findLastIndex((N) => N.classList.contains("placeholder-column"));
    b.length === k.length && x !== -1 && b.splice(x, 1), l.value = b.reduce((N, O) => N + Number.parseInt(O.getAttribute("width")), 0);
  }
  return {
    isColumnWidthUnAdjust: c,
    showOperationColumn: r,
    placeholderColumnWidth: d,
    colWidthChange: g
  };
}, noneDrag = "none-drag", noneInteraction = "no-interaction", _sfc_main$Q = /* @__PURE__ */ defineComponent({
  name: "alc-list-next",
  inheritAttrs: !1,
  __name: "list-next",
  props: {
    size: {},
    height: { default: "100%" },
    maxHeight: {},
    stripe: { type: Boolean, default: !0 },
    border: { type: Boolean },
    rowKey: {},
    showHeader: { type: Boolean, default: !0 },
    summaryMethod: {},
    rowClassName: {},
    rowStyle: {},
    cellClassName: {},
    cellStyle: {},
    headerRowClassName: {},
    headerRowStyle: {},
    headerCellClassName: {},
    headerCellStyle: {},
    highlightCurrentRow: { type: Boolean, default: !0 },
    currentRowKey: {},
    emptyText: {},
    expandRowKeys: {},
    defaultExpandAll: { type: Boolean },
    defaultSort: {},
    spanMethod: {},
    treeProps: {},
    lazy: { type: Boolean },
    load: {},
    className: {},
    style: {},
    data: { default: () => [] },
    title: {},
    schema: {},
    operation: {},
    operationWidth: { default: 112 },
    operationTips: {},
    disabled: { type: Boolean, default: !1 },
    showIndex: { type: Boolean, default: !0 },
    index: {},
    multiple: { type: Boolean, default: !1 },
    selectable: {},
    reserveSelection: { type: Boolean },
    class: {}
  },
  emits: ["operationClick"],
  setup(e, { expose: o }) {
    const n = useAttrs(), t = e, r = useSlots();
    watch(
      () => t.schema,
      (E) => {
        if (E && E.length > 0) {
          const C = E.reduce((I, v) => (v.itemType === "select" && v.code && I.push(v.code), I), []);
          C.length && Promise.allSettled(
            C.map((I) => getEnumOptions(I))
          );
        }
      },
      { immediate: !0 }
    );
    const a = useDisabled(), l = ref(), s = computed(() => !!(t.title || r.extra)), c = computed(() => typeof t.height == "number" ? `${t.height}px` : t.height), d = computed(() => typeof t.maxHeight == "number" ? `${t.maxHeight}px` : t.maxHeight), p = computed(() => mergeProps(
      objOmit(t, [
        "title",
        "height",
        "schema",
        "operation",
        "operationWidth",
        "operationTips",
        "disabled",
        "showIndex",
        "index",
        "multiple",
        "style",
        "className",
        "class",
        "selectable",
        "reserveSelection"
      ]),
      n
    )), { isColumnWidthUnAdjust: f, showOperationColumn: g, placeholderColumnWidth: b } = useShowConditionColumn(l), k = (E) => ({
      ...objPick(E, [
        "label",
        "prop",
        "width",
        "minWidth",
        "resizable",
        "sortable",
        "sortBy",
        "sortMethod",
        "sortOrders",
        "align",
        "className",
        "fixed"
      ]),
      // width: isLastColumnNeedsAutoWidth ? undefined : item.width,
      // minWidth: isLastColumnNeedsAutoWidth ? item.width : undefined,
      labelClassName: E.resizable === !1 ? `${E.labelClassName || ""} ${noneDrag}` : E.labelClassName,
      align: E.align || V(E.itemType)
    }), x = {
      width: 54,
      fixed: "left",
      align: "center",
      headerAlign: "center",
      resizable: !1,
      labelClassName: noneDrag,
      className: noneInteraction
    }, { operationSets: N, openConfirmPop: O, popoverVisible: m, popConfig: ee } = useConfirmPop(a), z = computed(() => t.schema.some((E) => E.sum === !0));
    function P({ columns: E, data: C }) {
      return [
        // 第一列显示"合计"
        "合计",
        // 从第二列开始循环
        ...E.slice(1).reduce((I, v, M) => {
          const $ = t.schema.find((H) => v.rawColumnKey === H.prop);
          if (($ == null ? void 0 : $.itemType) === "number" && $.prop && $.sum === !0) {
            const H = ($ == null ? void 0 : $.precision) ?? 0, X = C.reduce((te, oe) => isNumber(oe[$.prop]) ? te.plus(
              BigNumber(oe[$.prop]).toFixed(H)
            ) : te, BigNumber(0));
            I[M] = $.prettier === !1 ? X.toFixed(H) : X.toFormat(H);
          } else
            I[M] = "";
          return I;
        }, [])
      ].map((I, v) => {
        var $;
        if (!E[v])
          return I;
        const M = ($ = t.schema) == null ? void 0 : $.find((H) => E[v].rawColumnKey === H.prop);
        return (M == null ? void 0 : M.itemType) === "number" && M.sum === !0 ? toDisplayString("number", I, M.precision) : I;
      });
    }
    function V(E) {
      return E === "checkbox" ? "center" : E === "number" ? "right" : void 0;
    }
    o({
      instanceRef: l,
      ...getInstanceMethod(l, [
        "clearSelection",
        "getSelectionRows",
        "toggleRowSelection",
        "toggleAllSelection",
        "toggleRowExpansion",
        "setCurrentRow",
        "clearSort",
        "clearFilter",
        "doLayout",
        "sort",
        "scrollTo",
        "setScrollTop",
        "setScrollLeft"
      ]),
      isDisabled: a
    });
    const U = { attrs: n, props: t, slots: r, isDisabled: a, instanceRef: l, showTitle: s, localHeight: c, localMaxHeight: d, tableProps: p, isColumnWidthUnAdjust: f, showOperationColumn: g, placeholderColumnWidth: b, columnProps: k, noneDrag, noneInteraction, presetColumnAttrs: x, operationSets: N, openConfirmPop: O, popoverVisible: m, popConfig: ee, showSummary: z, summaryMethod$: P, getAlign: V, get AlcAreaTitle() {
      return AlcAreaTitle;
    }, get AlcDisplay() {
      return AlcDisplay;
    }, get AlcTableOperation() {
      return AlcTableOperation;
    }, get AlcTooltip() {
      return AlcTooltip;
    }, get ElEmpty() {
      return ElEmpty;
    }, get ElPopconfirm() {
      return ElPopconfirm;
    }, get ElTable() {
      return ElTable;
    }, get ElTableColumn() {
      return ElTableColumn;
    }, get isBlank() {
      return isBlank;
    }, get getDisplayStringFormatCode() {
      return getDisplayStringFormatCode;
    } };
    return Object.defineProperty(U, "__isScriptSetup", { enumerable: !1, value: !0 }), U;
  }
}), _hoisted_1$G = ["title"], _hoisted_2$z = { style: { display: "flex", "flex-flow": "row nowrap", "text-align": "center" } }, _hoisted_3$t = {
  class: "single-line-overflow",
  style: { width: "100%" }
};
function _sfc_render$Q(e, o, n, t, r, a) {
  return openBlock(), createElementBlock("div", {
    style: normalizeStyle([{ height: t.localHeight, maxHeight: t.localMaxHeight }, n.style]),
    class: normalizeClass(["alc-component-list-next", n.className, e.$props.class])
  }, [
    t.showTitle ? (openBlock(), createBlock(t.AlcAreaTitle, {
      key: 0,
      title: n.title
    }, {
      extra: withCtx(() => [
        renderSlot(e.$slots, "extra")
      ]),
      _: 3
    }, 8, ["title"])) : createCommentVNode("", !0),
    createVNode(t.ElTable, mergeProps({
      ref: "instanceRef",
      "show-summary": t.showSummary,
      "summary-method": n.summaryMethod || t.summaryMethod$,
      "highlight-current-row": !t.isDisabled
    }, t.tableProps, {
      class: n.border ? "" : "el-table--hide-border",
      style: {
        height: t.showTitle ? "calc(100% - 40px)" : "100%"
      },
      border: "",
      height: "100%",
      onHeaderDragend: o[1] || (o[1] = (l) => t.isColumnWidthUnAdjust = null)
    }), {
      empty: withCtx(() => [
        renderSlot(e.$slots, "empty", {}, () => [
          createVNode(t.ElEmpty)
        ])
      ]),
      default: withCtx(() => [
        n.showIndex ? (openBlock(), createBlock(t.ElTableColumn, mergeProps({
          key: 0,
          index: n.index,
          type: "index"
        }, t.presetColumnAttrs), {
          header: withCtx((l) => [
            renderSlot(e.$slots, "indexHeader", normalizeProps(guardReactiveProps(l)), () => [
              createTextVNode(" 序号 ")
            ])
          ]),
          _: 3
        }, 16, ["index"])) : createCommentVNode("", !0),
        e.$slots.expand ? (openBlock(), createBlock(t.ElTableColumn, mergeProps({
          key: 1,
          type: "expand"
        }, t.presetColumnAttrs), {
          default: withCtx((l) => [
            renderSlot(e.$slots, "expand", normalizeProps(guardReactiveProps(l)))
          ]),
          _: 3
        }, 16)) : createCommentVNode("", !0),
        n.multiple ? (openBlock(), createBlock(t.ElTableColumn, mergeProps({
          key: 2,
          type: "selection",
          selectable: n.selectable,
          "reserve-selection": n.reserveSelection
        }, t.presetColumnAttrs), null, 16, ["selectable", "reserve-selection"])) : createCommentVNode("", !0),
        renderSlot(e.$slots, "columns", {
          labelClassName: t.presetColumnAttrs.labelClassName,
          className: t.presetColumnAttrs.className
        }),
        (openBlock(!0), createElementBlock(Fragment, null, renderList(n.schema, (l) => (openBlock(), createBlock(t.ElTableColumn, mergeProps({
          key: l.prop,
          ref_for: !0
        }, t.columnProps(l)), createSlots({
          default: withCtx((s) => [
            renderSlot(e.$slots, e.$slots.cell ? "cell" : l.prop, mergeProps({ ref_for: !0 }, { ...s, item: l }), () => [
              createVNode(t.AlcDisplay, {
                "model-value": s.row[l.prop],
                formatter: l.formatter ? (c) => l.formatter(
                  s.row,
                  s.column,
                  c,
                  s.$index
                ) : void 0,
                "item-type": l.itemType,
                code: t.getDisplayStringFormatCode(l)
              }, null, 8, ["model-value", "formatter", "item-type", "code"])
            ])
          ]),
          _: 2
        }, [
          l.isHeaderSlots ? {
            name: "header",
            fn: withCtx((s) => [
              renderSlot(e.$slots, `${l.prop}Header`, mergeProps({ ref_for: !0 }, {
                label: l.label,
                scope: s,
                tips: l.tips
              }))
            ]),
            key: "0"
          } : {
            name: "header",
            fn: withCtx(() => [
              createElementVNode("div", {
                class: "single-line-overflow header-cell__title",
                title: l.label
              }, toDisplayString$1(l.label), 9, _hoisted_1$G),
              t.isBlank(l.tips) ? createCommentVNode("", !0) : (openBlock(), createBlock(t.AlcTooltip, {
                key: 0,
                content: l.tips,
                tabindex: null
              }, null, 8, ["content"]))
            ]),
            key: "1"
          }
        ]), 1040))), 128)),
        t.placeholderColumnWidth ? (openBlock(), createBlock(t.ElTableColumn, {
          key: 3,
          width: t.placeholderColumnWidth,
          resizable: !1,
          "label-class-name": t.presetColumnAttrs.labelClassName,
          "class-name": `${t.presetColumnAttrs.className} placeholder-column`
        }, null, 8, ["width", "label-class-name", "class-name"])) : createCommentVNode("", !0),
        t.showOperationColumn ? (openBlock(), createBlock(t.ElTableColumn, {
          key: 4,
          width: n.operationWidth,
          resizable: !1,
          "label-class-name": t.presetColumnAttrs.labelClassName,
          "class-name": t.presetColumnAttrs.className,
          label: "操作",
          prop: "$operation",
          fixed: "right"
        }, {
          header: withCtx(() => [
            createElementVNode("div", _hoisted_2$z, [
              createElementVNode("div", _hoisted_3$t, [
                createTextVNode(" 操作 "),
                t.isBlank(n.operationTips) ? createCommentVNode("", !0) : (openBlock(), createBlock(t.AlcTooltip, {
                  key: 0,
                  content: n.operationTips,
                  tabindex: null
                }, null, 8, ["content"]))
              ])
            ])
          ]),
          default: withCtx((l) => [
            createVNode(t.AlcTableOperation, {
              operations: t.operationSets,
              scope: l,
              disabled: t.isDisabled,
              onOperationClick: o[0] || (o[0] = (s) => e.$emit("operationClick", s)),
              onOpenConfirmPopover: t.openConfirmPop
            }, null, 8, ["operations", "scope", "disabled", "onOpenConfirmPopover"])
          ]),
          _: 1
        }, 8, ["width", "label-class-name", "class-name"])) : createCommentVNode("", !0)
      ]),
      _: 3
    }, 16, ["show-summary", "summary-method", "highlight-current-row", "class", "style"]),
    createVNode(t.ElPopconfirm, mergeProps({
      visible: t.popoverVisible,
      "onUpdate:visible": o[2] || (o[2] = (l) => t.popoverVisible = l),
      width: "200px"
    }, t.popConfig, {
      trigger: "click",
      "virtual-triggering": ""
    }), null, 16, ["visible"])
  ], 6);
}
const ListNext = /* @__PURE__ */ _export_sfc(_sfc_main$Q, [["render", _sfc_render$Q], ["__file", "list-next.vue"]]), AlcListNext = withInstall(ListNext), _sfc_main$P = defineComponent({
  name: "alc-column-set",
  components: {
    AlcTooltip,
    AlcDialogFooter,
    AlcInputNumber,
    Draggable,
    ElScrollbar,
    ElCheckbox,
    ElInput,
    ElButton,
    ElInputNumber,
    ElRadioGroup,
    ElRadioButton
  },
  props: {
    // 布局方案编码
    code: { type: String, required: !0 },
    // 父级组件类型
    type: { type: String, required: !0 },
    // 父级组件当前方案
    userPlan: { type: Boolean, required: !0 }
  },
  emits: ["change"],
  setup(e, o) {
    const n = useProviderConfig("state"), { close: t } = useDialogState(), r = reactive({
      // 当前选择的方案类型标识
      planType: e.userPlan === !0 ? 2 : 1,
      // 列表布局方案
      listLayout: {
        // 是否存在组件方案
        orgPlan: !1,
        // 是否存在个人方案
        userPlan: !1,
        // 列表布局信息
        layout: [],
        // 列表方案信息
        plan: {
          iPageRowSize: 10
        }
      },
      // 单元格编辑标识
      editFlag: {
        itemUuid: "",
        fieldName: ""
      },
      // 单元格编辑框操作句柄
      cellInputEditHandle: null,
      // 快速设置排序 目标序号
      targetSortIndex: 1,
      // 栏目设置恢复默认按钮 loading
      defaultSchemeLoading: !1,
      // 栏目设置保存设置按钮 loading
      saveSchemeLoading: !1
    });
    a(r.planType);
    function a(z) {
      c(z, !1).then((P) => {
        P.code === 1 && P.data ? f(P.data, !1) : l(!1);
      }).catch(() => {
        apiLinkErrorTip("栏目设置获取");
      });
    }
    function l(z) {
      return c(0, !0).then((P) => {
        P.code === 1 ? f(P.data, z) : operatorErrorTip(P.msg);
      }).catch(() => (apiLinkErrorTip("栏目设置获取"), Promise.reject()));
    }
    function s() {
      const z = r.planType === 1 ? "确认删除组织栏目设置？" : "确认删除个人栏目设置？";
      openConfirm(z, {}, (P) => {
        P.action === "confirm" && d().then((V) => {
          V.code === 1 ? (ElMessage.success("栏目设置删除完成"), l(!1), o.emit("change")) : operatorErrorTip(V.msg);
        }).catch(() => {
          apiLinkErrorTip("栏目设置删除");
        });
      });
    }
    function c(z, P) {
      const V = {
        cBaseListCode: e.code,
        iPlanType: z,
        bInit: P,
        cOrgUuid: n.value.cOrgUuid,
        cPersonUuid: n.value.cPersonUuid
      };
      return msPost(
        "alc-city-framework/SysBaseListAction/getBaseListPlan",
        V
      );
    }
    function d() {
      const z = {
        cBaseListCode: e.code,
        iPlanType: r.planType,
        cOrgUuid: n.value.cOrgUuid,
        cPersonUuid: n.value.cPersonUuid
      };
      return msPost(
        "alc-city-framework/SysBaseListAction/deleteOneBaseListPlanPost",
        z
      );
    }
    function p() {
      r.defaultSchemeLoading = !0;
      const z = r.listLayout.plan, P = r.listLayout.layout;
      z.iPlanType !== r.planType && (z.cPlanUUID = null, z.iPlanID = null), z.bInit === !0 && (z.bInit = !1), z.iPlanType = r.planType, z.cOrgUuid = n.value.cOrgUuid, z.cPersonUuid = n.value.cPersonUuid;
      for (let V = 0; V < P.length; V++)
        P[V].iOrder = V + 1;
      return msPost(
        "alc-city-framework/SysBaseListAction/saveOneBaseListPlan",
        {
          plan: z,
          list: P
        }
      ).then((V) => {
        V.code === 1 ? (t(), ElMessage.success("栏目设置保存完成"), o.emit("change")) : operatorErrorTip(V.msg);
      }).catch(() => (apiLinkErrorTip("栏目设置保存"), Promise.reject())).finally(() => {
        r.defaultSchemeLoading = !1;
      });
    }
    function f(z, P) {
      z ? (P !== !0 && (r.listLayout.orgPlan = z.bHasOrgPlan === !0, r.listLayout.userPlan = z.bHasPersonPlan === !0, r.listLayout.plan = z.plan || {}), r.listLayout.layout = z.list || []) : (P !== !0 && (r.listLayout.orgPlan = !1, r.listLayout.userPlan = !1, r.listLayout.plan = {}), r.listLayout.layout = []);
    }
    function g() {
      return r.defaultSchemeLoading = !0, l(!0).finally(() => {
        r.defaultSchemeLoading = !1;
      });
    }
    function b() {
      a(r.planType);
    }
    function k(z, P) {
      r.editFlag = {
        itemUuid: z,
        fieldName: P
      }, nextTick(() => {
        r.cellInputEditHandle.focus();
      });
    }
    function x() {
      r.editFlag = {
        itemUuid: "",
        fieldName: ""
      };
    }
    function N() {
      const z = r.listLayout.layout;
      let P = z.filter((V) => V.bHide === !1 && V.bFixed).length;
      for (let V = 0; V < z.length; V++)
        z[V].bFixed = !1, z[V].bHide === !1 && P > 0 && (z[V].bFixed = !0, P--);
    }
    function O(z, P) {
      const V = r.listLayout.layout;
      (z ? V.slice(0, P) : V.slice(P)).forEach((E) => {
        E.bHide === !1 && E.bFixed !== z && (E.bFixed = z);
      });
    }
    function m(z, P, V) {
      r.targetSortIndex = P, k(z, V);
    }
    function ee(z, P) {
      if (P === void 0)
        return;
      x();
      const [V] = r.listLayout.layout.splice(z, 1);
      r.listLayout.layout.splice(P - 1, 0, V), N();
    }
    return {
      ...toRefs$1(r),
      deleteScheme: s,
      saveListLayoutScheme: p,
      resetDefaultSchema: g,
      onPlanTypeChange: b,
      onCellClick: k,
      onCellBlur: x,
      onListSortChange: N,
      onFixedCheckboxClick: O,
      onFieldSortClick: m,
      onFieldSortChange: ee
    };
  }
}), _hoisted_1$F = { class: "alc-component-columnset-container h100 auto-height--wrap" }, _hoisted_2$y = { class: "flex alc-cpt-columnset" }, _hoisted_3$s = {
  class: "flex",
  style: { width: "auto", "align-items": "center", "margin-left": "20px" }
}, _hoisted_4$m = { key: 0 }, _hoisted_5$j = { class: "flex columnset-title-container" }, _hoisted_6$i = /* @__PURE__ */ createStaticVNode('<div class="columnset-title" style="width:80px;">排序</div><div class="columnset-title" style="width:50px;">序号</div><div class="columnset-title" style="width:220px;">显示名称</div><div class="columnset-title" style="width:100px;">显示宽度</div><div class="columnset-title" style="width:100px;">数据精度</div><div class="columnset-title" style="width:50px;">显示</div><div class="columnset-title" style="width:50px;">合计</div><div class="columnset-title" style="width:50px;">锁定</div>', 8), _hoisted_14$6 = {
  class: "columnset-title alc-cpt-columnset-oper",
  style: { "text-align": "left" }
}, _hoisted_15$4 = /* @__PURE__ */ createElementVNode("span", null, "操作", -1), _hoisted_16$4 = { class: "flex columnset-item-container" }, _hoisted_17$4 = /* @__PURE__ */ createElementVNode("div", {
  class: "columnset-item",
  style: { width: "80px" }
}, [
  /* @__PURE__ */ createElementVNode("i", {
    class: "ri-arrow-up-down-line columnset-edit-handle",
    title: "拖放排序"
  })
], -1), _hoisted_18$4 = {
  class: "columnset-item",
  style: { width: "50px" }
}, _hoisted_19$3 = ["onClick"], _hoisted_20$2 = { key: 1 }, _hoisted_21$1 = ["onClick"], _hoisted_22$1 = { key: 1 }, _hoisted_23$1 = ["onClick"], _hoisted_24$1 = { key: 1 }, _hoisted_25$1 = ["title"], _hoisted_26$1 = {
  class: "flex columnset-item",
  style: { width: "50px", "max-width": "50px", "align-items": "center", "justify-content": "center", cursor: "pointer" }
}, _hoisted_27$1 = {
  class: "flex columnset-item",
  style: { width: "50px", "max-width": "50px", "align-items": "center", "justify-content": "center", cursor: "pointer" }
}, _hoisted_28$1 = {
  class: "flex columnset-item alc-cpt-columnset-oper",
  style: { "align-items": "center" }
};
function _sfc_render$P(e, o, n, t, r, a) {
  const l = resolveComponent("ElRadioButton"), s = resolveComponent("ElRadioGroup"), c = resolveComponent("ElInputNumber"), d = resolveComponent("AlcTooltip"), p = resolveComponent("ElButton"), f = resolveComponent("ElInput"), g = resolveComponent("ElCheckbox"), b = resolveComponent("AlcInputNumber"), k = resolveComponent("Draggable"), x = resolveComponent("ElScrollbar"), N = resolveComponent("AlcDialogFooter");
  return openBlock(), createElementBlock("div", _hoisted_1$F, [
    createElementVNode("div", _hoisted_2$y, [
      createVNode(s, {
        modelValue: e.planType,
        "onUpdate:modelValue": o[0] || (o[0] = (O) => e.planType = O),
        onChange: e.onPlanTypeChange,
        style: { "margin-left": "16px" }
      }, {
        default: withCtx(() => [
          createVNode(l, { value: 1 }, {
            default: withCtx(() => [
              createTextVNode(" 组织设置 ")
            ]),
            _: 1
          }),
          createVNode(l, { value: 2 }, {
            default: withCtx(() => [
              createTextVNode(" 个人设置 ")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "onChange"]),
      createElementVNode("div", _hoisted_3$s, [
        e.type === "list" ? (openBlock(), createElementBlock("span", _hoisted_4$m, "每页显示（条）")) : createCommentVNode("", !0),
        e.type === "list" ? (openBlock(), createBlock(c, {
          key: 1,
          style: { "max-width": "70px" },
          modelValue: e.listLayout.plan.iPageRowSize,
          "onUpdate:modelValue": o[1] || (o[1] = (O) => e.listLayout.plan.iPageRowSize = O),
          min: 1,
          max: 200,
          precision: 0,
          controls: !1
        }, null, 8, ["modelValue"])) : createCommentVNode("", !0),
        e.type === "list" ? (openBlock(), createBlock(d, {
          key: 2,
          content: "<p>1、栏目设置优先级：个人 > 组织 > 默认</p><p>2、组织或个人若无设置，会显示默认设置</p><p>3、每页显示数据条数范围：1 ~ 200</p>",
          tabindex: null
        })) : createCommentVNode("", !0),
        e.type === "table" ? (openBlock(), createBlock(d, {
          key: 3,
          content: "<p>1、栏目设置优先级：个人 > 组织 > 默认</p><p>2、组织或个人若无设置，会显示默认设置</p>",
          tabindex: null
        })) : createCommentVNode("", !0)
      ]),
      e.planType === 1 && e.listLayout.orgPlan === !0 || e.planType === 2 && e.listLayout.userPlan === !0 ? (openBlock(), createBlock(p, {
        key: 0,
        text: "",
        class: "alc-cpt-columnset-delete",
        title: e.planType === 1 ? "删除组织设置" : "删除个人设置",
        onClick: withModifiers(e.deleteScheme, ["stop"])
      }, {
        default: withCtx(() => [
          createTextVNode(" 删除设置 ")
        ]),
        _: 1
      }, 8, ["title", "onClick"])) : createCommentVNode("", !0)
    ]),
    createElementVNode("div", _hoisted_5$j, [
      _hoisted_6$i,
      createElementVNode("div", _hoisted_14$6, [
        _hoisted_15$4,
        createVNode(d, {
          content: "<p>1、点击操作行中【移动至】按钮</p><p>2、输入移动的目标序号，回车确认</p>",
          tabindex: null
        })
      ])
    ]),
    createVNode(x, { class: "auto-height--target" }, {
      default: withCtx(() => [
        createVNode(k, {
          animation: "200",
          "ghost-class": "drag-ghost",
          handle: ".columnset-edit-handle",
          "item-key": "cItemUuid",
          modelValue: e.listLayout.layout,
          "onUpdate:modelValue": o[3] || (o[3] = (O) => e.listLayout.layout = O),
          "force-fallback": !0,
          disabled: !1,
          onSort: e.onListSortChange
        }, {
          item: withCtx(({ element: O, index: m }) => [
            withDirectives(createElementVNode("div", _hoisted_16$4, [
              _hoisted_17$4,
              createElementVNode("div", _hoisted_18$4, toDisplayString$1(m + 1), 1),
              createElementVNode("div", {
                class: "columnset-item",
                style: { width: "220px", "max-width": "220px", cursor: "pointer" },
                onClick: withModifiers((ee) => e.onCellClick(O.cItemUuid, "cFieldName"), ["stop"])
              }, [
                e.editFlag.itemUuid === O.cItemUuid && e.editFlag.fieldName === "cFieldName" ? (openBlock(), createBlock(f, {
                  key: 0,
                  ref: "cellInputEditHandle",
                  style: { "max-width": "180px", "text-align": "center" },
                  modelValue: O.cTitleName,
                  "onUpdate:modelValue": (ee) => O.cTitleName = ee,
                  onBlur: e.onCellBlur
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])) : (openBlock(), createElementBlock("span", _hoisted_20$2, toDisplayString$1(O.cTitleName), 1))
              ], 8, _hoisted_19$3),
              createElementVNode("div", {
                class: "columnset-item",
                style: { width: "100px", "max-width": "100px", cursor: "pointer" },
                onClick: withModifiers((ee) => e.onCellClick(
                  O.cItemUuid,
                  "iColumnWidthMin"
                ), ["stop"])
              }, [
                e.editFlag.itemUuid === O.cItemUuid && e.editFlag.fieldName === "iColumnWidthMin" ? (openBlock(), createBlock(c, {
                  key: 0,
                  ref: "cellInputEditHandle",
                  style: { "max-width": "80px" },
                  modelValue: O.iColumnWidthMin,
                  "onUpdate:modelValue": (ee) => O.iColumnWidthMin = ee,
                  min: 0,
                  precision: 0,
                  controls: !1,
                  onBlur: e.onCellBlur
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])) : (openBlock(), createElementBlock("span", _hoisted_22$1, toDisplayString$1(O.iColumnWidthMin), 1))
              ], 8, _hoisted_21$1),
              createElementVNode("div", {
                class: "columnset-item",
                style: { width: "100px", "max-width": "100px", cursor: "pointer" },
                onClick: withModifiers((ee) => e.onCellClick(O.cItemUuid, "iPrecision"), ["stop"])
              }, [
                e.editFlag.itemUuid === O.cItemUuid && e.editFlag.fieldName === "iPrecision" ? (openBlock(), createBlock(c, {
                  key: 0,
                  ref: "cellInputEditHandle",
                  style: { "max-width": "80px" },
                  modelValue: O.iPrecision,
                  "onUpdate:modelValue": (ee) => O.iPrecision = ee,
                  min: 0,
                  precision: 0,
                  controls: !1,
                  onBlur: e.onCellBlur
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])) : (openBlock(), createElementBlock("span", _hoisted_24$1, toDisplayString$1(O.iPrecision), 1))
              ], 8, _hoisted_23$1),
              createElementVNode("div", {
                title: O.bRequired ? "该项必须展示" : "",
                class: "flex columnset-item",
                style: { width: "50px", "max-width": "50px", "align-items": "center", "justify-content": "center" }
              }, [
                createVNode(g, {
                  label: "",
                  modelValue: O.bShow,
                  "onUpdate:modelValue": (ee) => O.bShow = ee,
                  disabled: O.bRequired
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
              ], 8, _hoisted_25$1),
              createElementVNode("div", _hoisted_26$1, [
                O.cFieldType === "Number" ? (openBlock(), createBlock(g, {
                  key: 0,
                  label: "",
                  modelValue: O.bSum,
                  "onUpdate:modelValue": (ee) => O.bSum = ee
                }, null, 8, ["modelValue", "onUpdate:modelValue"])) : createCommentVNode("", !0)
              ]),
              createElementVNode("div", _hoisted_27$1, [
                createVNode(g, {
                  label: "",
                  modelValue: O.bFixed,
                  "onUpdate:modelValue": (ee) => O.bFixed = ee,
                  onChange: (ee) => e.onFixedCheckboxClick(
                    ee,
                    m
                  )
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
              ]),
              createElementVNode("div", _hoisted_28$1, [
                createVNode(p, {
                  text: "",
                  onClick: withModifiers((ee) => e.onFieldSortClick(
                    O.cItemUuid,
                    m + 1,
                    "fieldSort"
                  ), ["stop"]),
                  style: { "margin-right": "8px" }
                }, {
                  default: withCtx(() => [
                    createTextVNode(" 移动至 ")
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                e.editFlag.itemUuid === O.cItemUuid && e.editFlag.fieldName === "fieldSort" ? (openBlock(), createBlock(b, {
                  key: 0,
                  ref: "cellInputEditHandle",
                  modelValue: e.targetSortIndex,
                  "onUpdate:modelValue": o[2] || (o[2] = (ee) => e.targetSortIndex = ee),
                  onEnter: (ee) => e.onFieldSortChange(m, ee),
                  min: 1,
                  max: e.listLayout.layout.length,
                  style: { width: "calc(100% - 72px - 16px)" }
                }, null, 8, ["modelValue", "onEnter", "max"])) : createCommentVNode("", !0)
              ])
            ], 512), [
              [vShow, !O.bHide]
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "onSort"])
      ]),
      _: 1
    }),
    createVNode(N, null, {
      default: withCtx(() => [
        createVNode(p, {
          loading: e.defaultSchemeLoading,
          onClick: e.resetDefaultSchema
        }, {
          default: withCtx(() => [
            createTextVNode(" 恢复默认 ")
          ]),
          _: 1
        }, 8, ["loading", "onClick"]),
        createVNode(p, {
          type: "primary",
          loading: e.saveSchemeLoading,
          onClick: e.saveListLayoutScheme
        }, {
          default: withCtx(() => [
            createTextVNode(" 保存设置 ")
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ]),
      _: 1
    })
  ]);
}
const AlcColumnSet = /* @__PURE__ */ _export_sfc(_sfc_main$P, [["render", _sfc_render$P], ["__file", "column-set.vue"]]);
function adjacentGroup(e) {
  return e.split(",").reduce(
    (o, n, t, r) => (+n - 1 === +r[t - 1] ? o.at(-1).push(n) : o.push([n]), o),
    []
  );
}
function mergeMethod(e, o) {
  const n = /* @__PURE__ */ new Map();
  function t({ rowIndex: r, columnIndex: a, row: l, column: s }, c) {
    let d = 1;
    const p = s.property || `$${s.type}`;
    if (e && e[p]) {
      const g = e[p], b = n.get(p);
      if (b) {
        d = 0;
        const k = b - 1;
        k ? n.set(p, k) : n.delete(p);
      } else {
        let k = 1;
        for (; r + k < c.length && c[r + k][g] === l[g]; )
          k++;
        k !== 1 && (d = k, n.set(p, k - 1));
      }
    }
    let f = 1;
    if (o) {
      const g = Object.entries(o);
      for (const [b, k] of g) {
        if (!b.includes(String(a)) || !k({ rowData: l, rowIndex: r }))
          continue;
        const x = adjacentGroup(b);
        for (const N of x)
          f = a === +N[0] ? N.length : 0;
      }
    }
    return { rowspan: d, colspan: f };
  }
  return {
    spanMethod: t
  };
}
const useListData = (e, o) => {
  const { emit: n, props: t } = getCurrentInstance(), r = useProviderConfig("state"), {
    isLoading: a,
    sliceList: l,
    paging: s,
    total: c,
    searchFn: d,
    resetPaging: p
  } = useSliceList((x) => e || o.value.baseList.cDataSourceType === "none" || !o.value.list.length ? {
    list: [],
    total: 0
  } : k({
    pageSize: x.pageSize,
    currentPage: x.pageNumber
  }).then((N) => {
    var O;
    if (N.code === 1)
      return {
        list: ((O = N.data.pageData) == null ? void 0 : O.map((ee) => markRaw(ee))) || [],
        total: N.data.iTotleSize
      };
    operatorErrorTip(N.msg);
  }).catch(() => {
    apiLinkErrorTip("列表数据获取");
  }));
  function f() {
    return d().then(() => {
      n("dataLoaded", l.value);
    });
  }
  let g = "";
  function b(x) {
    const N = {
      descending: "desc",
      ascending: "asc"
    };
    g = x.order ? `${x.prop} ${N[x.order]}` : "", f();
  }
  function k(x = {}) {
    const N = isArray(o.value.list) && o.value.list.length > 0 ? [
      .../* @__PURE__ */ new Set([
        ...t.extraColumn,
        ...o.value.list.filter((m) => m.bHide || m.bShow || m.bRequired).map((m) => m.cFieldName)
      ])
    ].join(",") : "", O = {
      bPage: x.bPage ?? t.showPaging,
      iPageNumber: x.currentPage,
      iPageSize: x.pageSize,
      iPageLoadNumber: x.pageLoadNumber,
      ...cryptoProps({
        cColumns: x.columns || N,
        cWhere: t.where,
        cFilterField: t.filterName,
        cFilterValue: t.filterValue,
        cFormat: t.dataFormat,
        ...objPick(o.value.baseList, [
          "cServerName",
          "cTableName",
          "cDefinedApi"
        ]),
        cOrderField: g || t.orderField || o.value.baseList.cOrderField
      }),
      cDataSourceType: o.value.baseList.cDataSourceType,
      cDataScopeType: t.dataScope || o.value.baseList.cDataScopeType,
      queryConditionList: t.query,
      cOrgUuid: r.value.cOrgUuid,
      cAccUuid: r.value.cAccUuid
    };
    return msPost("alc-city-framework/SysBaseListAction/getPageData4List", O);
  }
  return {
    dataLoading: a,
    sliceList: l,
    paging: s,
    total: c,
    refreshList: f,
    resetPaging: p,
    doGetListDataByLayout: k,
    onSortChange: b
  };
}, usePagination = (e, o, n) => {
  const { emit: t } = getCurrentInstance(), r = useAttrs(), a = useProp("total"), l = useProp("pageSize"), s = useProp("currentPage"), c = useProp("size"), d = useProp("beforeFlip"), p = computed(() => e ? {
    // 还是兼容不绑定 page 属性时的写法
    currentPage: s.value ?? o.pageNumber,
    pageSize: l.value ?? o.pageSize,
    total: a.value
  } : {
    currentPage: o.pageNumber,
    pageSize: o.pageSize,
    total: n.value
  });
  async function f(P, V = !0) {
    if (V && await b())
      return;
    const U = m("onUpdate:page-size");
    e && U.length ? (ee("onUpdate:current-page", 1), U.forEach((E) => {
      E(P);
    })) : (o.pageNumber = 1, o.pageSize = P), t("sizeChange", {
      currentPage: o.pageNumber,
      pageSize: o.pageSize
    });
  }
  async function g(P, V = !0) {
    if (p.value.currentPage === P || V && await b())
      return;
    const U = m(
      "onUpdate:current-page"
    );
    e && U.length ? U.forEach((E) => {
      E(P);
    }) : o.pageNumber = P, t("pageChange", {
      currentPage: p.value.currentPage,
      pageSize: p.value.pageSize
    });
  }
  async function b() {
    if (typeof d.value == "function")
      try {
        if (await d.value({
          currentPage: p.value.currentPage,
          pageSize: p.value.pageSize
        }) === !1)
          return !0;
      } catch {
        return !0;
      }
    else if (typeof d.value == "boolean")
      return !d.value;
    return !1;
  }
  const k = computed(() => c.value === "small"), x = [10, 30, 50, 100, 200], N = computed(() => {
    const P = p.value.pageSize;
    if (x.includes(P) || !P)
      return x;
    const V = x.findIndex((U) => U <= P);
    return ~V ? x[V] === P ? x : [.../* @__PURE__ */ new Set([P, ...x])] : [.../* @__PURE__ */ new Set([...x, P])];
  });
  function O(P) {
    return P.replace(/-(\w)/g, (V, U) => U ? U.toUpperCase() : "");
  }
  function m(P) {
    const V = r[P] || r[O(P)];
    return V ? [V].flat() : [];
  }
  function ee(P, ...V) {
    m(P).forEach((U) => {
      U(...V);
    });
  }
  function z(P) {
    e ? f(P, !1) : o.pageSize = P;
  }
  return {
    pagingProps: p,
    smallPaging: k,
    pageSizes: N,
    manualUpdatePageSize: z,
    onCurrentPageChange: g,
    onPageSizeChange: f
  };
};
function useMergeEffect(e, o) {
  const { emit: n } = getCurrentInstance(), t = useProp("rowMerge"), r = useProp("selectSummary"), a = shallowRef([]), l = /* @__PURE__ */ new Map();
  function s() {
    a.value = [], l.clear();
  }
  function c(x) {
    if (typeof x == "function")
      return !r.value || !a.value.length ? x : (N) => x({ columns: N.columns, data: a.value });
  }
  function d({ columns: x, data: N }) {
    const O = t.value ? Object.keys(t.value) : [];
    return [
      // 第一列显示"合计"
      "合计",
      // 从第二列开始循环
      ...x.slice(1).reduce((m, ee, z) => {
        const P = o.value.find((V) => ee.property === V.prop);
        if ((P == null ? void 0 : P.itemType) === "number" && P.prop && P.sum === !0) {
          const V = (P == null ? void 0 : P.precision) ?? 0;
          let U;
          O.includes(P.prop) ? U = N.reduce((E, C, I, v) => {
            var $;
            const M = t.value[P.prop];
            return C[M] !== (($ = v[I - 1]) == null ? void 0 : $[M]) && isNumber(C[P.prop]) ? E.plus(
              BigNumber(C[P.prop]).toFixed(
                V
              )
            ) : E;
          }, BigNumber(0)) : U = N.reduce((E, C) => isNumber(C[P.prop]) ? E.plus(
            BigNumber(C[P.prop]).toFixed(
              V
            )
          ) : E, BigNumber(0)), m[z] = U.toFixed(V);
        } else
          m[z] = "";
        return m;
      }, [])
    ].map((m, ee) => {
      const z = o.value.find((P) => x[ee].rawColumnKey === P.prop);
      return (z == null ? void 0 : z.itemType) === "number" && z.sum === !0 ? toDisplayString("number", m, z.precision) : m;
    });
  }
  let p = 1;
  function f(x) {
    return x === 0 ? (p = 1, p) : p + 1 === x ? (p = x, p) : ++p;
  }
  function g(x, N) {
    if (t.value && t.value.$selection) {
      const O = t.value.$selection;
      if (N)
        if (x.includes(N)) {
          const ee = e.value.findIndex((P) => P === N), z = k(
            O,
            N[O],
            ee
          );
          l.set(N, z);
        } else
          l.delete(N);
      else if (x.length === e.value.length)
        for (let m = 0, ee = e.value.length; m < ee; ) {
          const z = e.value[m], P = k(O, z[O], m);
          P.length ? (l.set(z, P), m += P.length) : m++;
        }
      else x.length === 0 && l.clear();
    }
    a.value = [...l.values()].flat(), N && n("select", a.value, N);
  }
  function b() {
    nextTick(() => {
      n("selectionChange", a.value);
    });
  }
  function k(x, N, O) {
    const m = e.value.slice(O), ee = [];
    for (const z of m)
      if (z[x] === N)
        ee.push(z);
      else
        break;
    return ee;
  }
  return {
    selectData: a,
    summarySelect: c,
    summaryMethod: d,
    mergeIndex: f,
    selectMerge: g,
    selectChangeMerge: b,
    clearSelectData: s
  };
}
const useExportList = () => useDialogOpen(AlcExportList, {
  title: "导出配置",
  widthType: "xs",
  closeOnClickModal: !0,
  closeOnPressEscape: !0
}), useExportGrp = () => useDialogOpen(AlcExportGrp, {
  title: "导出配置",
  widthType: "xs",
  closeOnClickModal: !0,
  closeOnPressEscape: !0
}), usePrintGrp = () => useDialogOpen(AlcPrintGrp, {
  title: "打印配置",
  widthType: "xs",
  confirmButtonText: "打印",
  closeOnClickModal: !0,
  closeOnPressEscape: !0,
  beforeOpen: (e) => {
    checkGrpServerState().then(e);
  }
});
function useImportData() {
  return useDialogOpen(AlcImportData, { title: "数据导入" });
}
const _sfc_main$O = /* @__PURE__ */ defineComponent({
  name: "alc-list",
  inheritAttrs: !1,
  __name: "list",
  props: {
    size: {},
    height: { default: "100%" },
    maxHeight: {},
    stripe: { type: Boolean },
    border: { type: Boolean },
    rowKey: {},
    showHeader: { type: Boolean, default: !0 },
    summaryMethod: {},
    rowClassName: {},
    rowStyle: {},
    cellClassName: {},
    cellStyle: {},
    headerRowClassName: {},
    headerRowStyle: {},
    headerCellClassName: {},
    headerCellStyle: {},
    highlightCurrentRow: { type: Boolean },
    currentRowKey: {},
    emptyText: {},
    expandRowKeys: {},
    defaultExpandAll: { type: Boolean },
    defaultSort: {},
    spanMethod: {},
    treeProps: {},
    lazy: { type: Boolean },
    load: {},
    className: {},
    style: {},
    data: {},
    title: {},
    operation: {},
    operationWidth: {},
    operationTips: {},
    disabled: { type: Boolean },
    showIndex: { type: Boolean, default: !0 },
    index: {},
    multiple: { type: Boolean },
    selectable: {},
    reserveSelection: { type: Boolean },
    class: {},
    schema: {},
    code: {},
    initFetch: { type: Boolean, default: !0 },
    filterName: {},
    filterValue: {},
    where: {},
    orderField: {},
    dataFormat: {},
    query: {},
    loading: { type: Boolean },
    showTitle: { type: Boolean },
    showPaging: { type: Boolean, default: !0 },
    tips: {},
    beforeFlip: { type: [Function, Boolean], default: !0 },
    rowMerge: {},
    colMerge: {},
    loadingDelay: {},
    extraColumn: { default: () => [] },
    dataScope: {},
    selectSummary: { type: Boolean, default: !0 },
    modifyLayout: { type: Boolean, default: !0 },
    pageSize: { default: 50 },
    total: {},
    currentPage: { default: 1 }
  },
  emits: ["layoutLoaded", "dataLoaded", "pageChange", "sizeChange", "select", "selectionChange"],
  setup(e, { expose: o, emit: n }) {
    const t = useAttrs(), r = e, a = n, l = !!r.schema || !!r.data, { isFetch: s, isAuthControl: c, tableFile: d, listSchema: p, initLayout: f } = useTableArchive(toRef(r, "code"), (Ce) => {
      te(Ce.plan.iPageRowSize), r.initFetch && !l && O(), a("layoutLoaded");
    }), g = computed(() => r.loading || s.value || b.value);
    r.code && (f(), onOrgChange(() => {
      f().then(() => {
        d.value.baseList.cDataScopeType === "organization" && oe(1, !1);
      });
    }));
    const {
      dataLoading: b,
      sliceList: k,
      paging: x,
      total: N,
      refreshList: O,
      doGetListDataByLayout: m,
      onSortChange: ee
    } = useListData(l, d), z = computed(() => l ? r.data || [] : k.value), P = computed(() => r.schema || p.value.reduce(
      (Ce, Be) => {
        var De;
        return Be.show && Ce.push({
          ...Be,
          tips: (De = r.tips) == null ? void 0 : De[Be.prop]
        }), Ce;
      },
      []
    )), {
      selectData: V,
      summarySelect: U,
      summaryMethod: E,
      mergeIndex: C,
      selectMerge: I,
      selectChangeMerge: v,
      clearSelectData: M
    } = useMergeEffect(z, P);
    watch(
      k,
      () => {
        r.reserveSelection || M();
      },
      { flush: "sync" }
    );
    const {
      pagingProps: $,
      smallPaging: H,
      pageSizes: X,
      manualUpdatePageSize: te,
      onCurrentPageChange: oe,
      onPageSizeChange: ne
    } = usePagination(l, x, N), ie = ref(), se = computed(() => mergeProps(
      objOmit(r, [
        /**
         * alc-list 扩展的
         */
        "schema",
        "code",
        "initFetch",
        "filterName",
        "filterValue",
        "where",
        "orderField",
        "dataFormat",
        "query",
        "showTitle",
        "showPaging",
        "tips",
        "beforeFlip",
        "rowMerge",
        "colMerge",
        "extraColumn",
        "dataScope",
        /**
         * 分页的
         */
        "pageSize",
        "total",
        "currentPage",
        /**
         * 在本地实现的
         */
        "data",
        "index",
        "spanMethod",
        "summaryMethod",
        "stripe",
        "selectable",
        "style",
        "className",
        "class"
      ]),
      t
    )), pe = useFormDisabled(), { spanMethod: he } = mergeMethod(r.rowMerge, r.colMerge);
    function ae(...Ce) {
      return typeof r.selectable == "function" ? !pe.value && r.selectable(...Ce) : !pe.value;
    }
    const { open: le } = useExportList();
    o({
      listValue: z,
      selectData: V,
      preferenceSchema: P,
      tableFile: d,
      paging: x,
      total: N,
      getInstance() {
        return ie.value;
      },
      ...getInstanceMethod(ie, [
        "clearSelection",
        "toggleRowSelection",
        "toggleAllSelection",
        "toggleRowExpansion",
        "setCurrentRow",
        "clearSort",
        "clearFilter",
        "doLayout",
        "sort",
        "scrollTo",
        "setScrollTop",
        "setScrollLeft"
      ]),
      getListDataByLayout() {
        nextTick(O);
      },
      getSelectData() {
        return r.disabled ? [] : V.value;
      },
      clearSelectData: M,
      setCurrentPage(Ce) {
        x.pageNumber = Ce, l || O();
      },
      getListPageInfo() {
        if (r.showPaging)
          return {
            currentPage: $.value.currentPage,
            pageSize: $.value.pageSize
          };
      },
      setListData(Ce) {
        if (l)
          if (isArray(Ce) && Ce.length) {
            const Be = $.value.pageSize;
            r.showPaging && Ce.length > Be ? k.value = Ce.slice(0, Be) : k.value = Ce;
          } else
            k.value = [];
      },
      exportData(Ce) {
        let Be = Ce == null ? void 0 : Ce.colInfo;
        Be || (Be = P.value.reduce((De, Fe) => (De[Fe.prop] = {
          label: Fe.label,
          wpx: Fe.width || Fe.minWidth || 150,
          fieldType: Fe.itemType,
          fieldTypeCode: getDisplayStringFormatCode(Fe)
        }, De), {})), le({
          fileName: `导出_${r.title || d.value.baseList.cListName || "未命名文件"}_${Date.now()}`,
          ...Ce,
          colInfo: Be,
          async dataSource(De) {
            if (typeof (Ce == null ? void 0 : Ce.dataSource) == "function")
              return Ce == null ? void 0 : Ce.dataSource(De);
            if (De.type === "selected")
              return ie.value.getSelectionRows();
            d.value.baseList.cDataSourceType === "none" && warn(
              "components/list",
              "当前列表未配置数据源，无法导出数据"
            );
            const Fe = {
              bPage: De.type !== "all",
              pageSize: De.type === "current" ? $.value.pageSize : De.pageSize,
              currentPage: De.type === "current" ? $.value.currentPage : De.pageIndex,
              pageLoadNumber: De.pageNumber,
              columns: d.value.list.filter((Me) => Me.bShow).map((Me) => Me.cFieldName).join(",")
            };
            return m(Fe).then((Me) => Me.code === 1 ? Me.data.pageData : (operatorErrorTip(Me.msg), [])).catch(() => (apiLinkErrorTip("列表数据获取"), []));
          }
        });
      }
    });
    const fe = { attrs: t, props: r, emits: a, isManual: l, isFetch: s, isAuthControl: c, tableFile: d, listSchema: p, initLayout: f, isLoading: g, dataLoading: b, sliceList: k, paging: x, total: N, refreshList: O, doGetListDataByLayout: m, onSortChange: ee, listData: z, preferenceSchema: P, selectData: V, summarySelect: U, summaryMethod$: E, mergeIndex: C, selectMerge: I, selectChangeMerge: v, clearSelectData: M, pagingProps: $, smallPaging: H, pageSizes: X, manualUpdatePageSize: te, onCurrentPageChange: oe, onPageSizeChange: ne, instanceRef: ie, tableProps: se, isDisabled: pe, spanMethod: he, checkboxCanChoose: ae, openExportConfView: le, get AlcListNext() {
      return AlcListNext;
    }, get ElButton() {
      return ElButton;
    }, get ElPagination() {
      return ElPagination;
    }, get ElResult() {
      return ElResult;
    }, get AlcDialog() {
      return AlcDialog;
    }, AlcColumnSet, get vLoadOn() {
      return loadOn;
    } };
    return Object.defineProperty(fe, "__isScriptSetup", { enumerable: !1, value: !0 }), fe;
  }
}), _hoisted_1$E = { key: 1 };
function _sfc_render$O(e, o, n, t, r, a) {
  return openBlock(), createElementBlock("div", {
    style: normalizeStyle([{ height: n.height, maxHeight: n.maxHeight }, n.style]),
    class: normalizeClass(["alc-component-list-container", e.$props.class, n.className])
  }, [
    withDirectives((openBlock(), createBlock(t.AlcListNext, mergeProps({
      ref: "instanceRef",
      schema: t.preferenceSchema
    }, t.tableProps, {
      data: t.listData,
      height: n.showPaging ? "calc(100% - 64px)" : void 0,
      stripe: !n.rowMerge,
      "span-method": (n.rowMerge || n.colMerge) && ((l) => t.spanMethod(l, t.listData)),
      border: !!(n.rowMerge || n.colMerge),
      "summary-method": t.summarySelect(n.summaryMethod || n.rowMerge && t.summaryMethod$),
      index: n.rowMerge && t.mergeIndex,
      selectable: t.checkboxCanChoose,
      class: "alc-component-list-container",
      onSortChange: t.onSortChange,
      onSelect: t.selectMerge,
      onSelectAll: t.selectMerge,
      onSelectionChange: t.selectChangeMerge
    }), createSlots({
      indexHeader: withCtx(() => [
        n.code && n.modifyLayout ? (openBlock(), createBlock(t.AlcDialog, {
          key: 0,
          title: "栏目设置",
          "width-type": "md",
          draggable: "",
          "show-fullscreen": "",
          "close-on-click-modal": "",
          "close-on-press-escape": "",
          "content-height-fit": ""
        }, {
          reference: withCtx(() => [
            createVNode(t.ElButton, {
              loading: !t.isDisabled && t.isFetch,
              class: "ri-list-settings-line alc-list-set__icon",
              link: "",
              title: "栏目设置"
            }, null, 8, ["loading"])
          ]),
          default: withCtx(() => [
            createVNode(t.AlcColumnSet, {
              type: "list",
              code: n.code,
              "user-plan": t.tableFile.bHasPersonPlan,
              onChange: t.initLayout
            }, null, 8, ["code", "user-plan", "onChange"])
          ]),
          _: 1
        })) : (openBlock(), createElementBlock("span", _hoisted_1$E, "序号"))
      ]),
      _: 2
    }, [
      e.$slots.extra ? {
        name: "extra",
        fn: withCtx(() => [
          renderSlot(e.$slots, "extra")
        ]),
        key: "0"
      } : void 0,
      !t.isManual && !t.isFetch && t.isAuthControl ? {
        name: "empty",
        fn: withCtx(() => [
          createVNode(t.ElResult, {
            icon: "warning",
            title: "权限缺失",
            "sub-title": "当前列表启用了栏目授权，请联系管理员授权"
          })
        ]),
        key: "1"
      } : void 0,
      renderList(Object.keys(e.$slots), (l) => ({
        name: l,
        fn: withCtx((s) => [
          renderSlot(e.$slots, l, normalizeProps(guardReactiveProps(s)))
        ])
      }))
    ]), 1040, ["schema", "data", "height", "stripe", "span-method", "border", "summary-method", "index", "onSortChange", "onSelect", "onSelectAll", "onSelectionChange"])), [
      [
        t.vLoadOn,
        t.isLoading,
        n.loadingDelay,
        { large: !0 }
      ]
    ]),
    n.showPaging ? (openBlock(), createBlock(t.ElPagination, mergeProps({ key: 0 }, t.pagingProps, {
      "onUpdate:currentPage": t.onCurrentPageChange,
      "onUpdate:pageSize": t.onPageSizeChange,
      "pager-count": t.smallPaging ? 5 : 7,
      "page-sizes": t.pageSizes,
      disabled: t.isDisabled,
      small: t.smallPaging,
      layout: t.smallPaging ? "prev, pager, next, sizes" : "prev, pager, next, jumper, ->, sizes, total",
      class: "alc-component-list-pagination"
    }), null, 16, ["onUpdate:currentPage", "onUpdate:pageSize", "pager-count", "page-sizes", "disabled", "small", "layout"])) : createCommentVNode("", !0)
  ], 6);
}
const List = /* @__PURE__ */ _export_sfc(_sfc_main$O, [["render", _sfc_render$O], ["__file", "list.vue"]]), AlcList = withInstall(List);
function tryOnScopeDispose$1(e) {
  return getCurrentScope() ? (onScopeDispose(e), !0) : !1;
}
function toValue$1(e) {
  return typeof e == "function" ? e() : unref(e);
}
const isClient$1 = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const toString$1 = Object.prototype.toString, isObject$1 = (e) => toString$1.call(e) === "[object Object]", noop$3 = () => {
};
function unrefElement$1(e) {
  var o;
  const n = toValue$1(e);
  return (o = n == null ? void 0 : n.$el) != null ? o : n;
}
const defaultWindow$1 = isClient$1 ? window : void 0;
function useEventListener$1(...e) {
  let o, n, t, r;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([n, t, r] = e, o = defaultWindow$1) : [o, n, t, r] = e, !o)
    return noop$3;
  Array.isArray(n) || (n = [n]), Array.isArray(t) || (t = [t]);
  const a = [], l = () => {
    a.forEach((p) => p()), a.length = 0;
  }, s = (p, f, g, b) => (p.addEventListener(f, g, b), () => p.removeEventListener(f, g, b)), c = watch(
    () => [unrefElement$1(o), toValue$1(r)],
    ([p, f]) => {
      if (l(), !p)
        return;
      const g = isObject$1(f) ? { ...f } : f;
      a.push(
        ...n.flatMap((b) => t.map((k) => s(p, b, k, g)))
      );
    },
    { immediate: !0, flush: "post" }
  ), d = () => {
    c(), l();
  };
  return tryOnScopeDispose$1(d), d;
}
const alcQueryProps = {
  /**
   * 查询方案编码
   * @default ''
   */
  code: { type: String, required: !0, default: "" },
  /**
   * 查询条件默认值
   * @description 仅为初始值，如果用户设置了自定义的，则以用户设置的为准
   * @default {}
   */
  defaultValue: {
    type: Object,
    default: () => ({})
  },
  /**
   * 是否渲染参照类型
   * @default false
   */
  noRefer: { type: Boolean, default: !1 },
  /**
   * 查询项 props 绑定
   * @description 会覆盖组件或者布局方案中的设置
   * @example
   *  {
   *      personName: {
   *          filter: false,
   *      }
   *  }
   */
  extraBind: {
    type: Object,
    default() {
      return {};
    }
  },
  /**
   * 超出 - 行后折叠
   * @default 2
   */
  showLines: { type: Number, default: 2 }
}, _sfc_main$N = defineComponent({
  name: "alc-query-set",
  components: {
    Draggable,
    AlcTooltip,
    AlcInputNumber,
    AlcDialogFooter,
    ElRadioGroup,
    ElRadioButton,
    ElButton,
    ElInput,
    ElCheckbox,
    ElScrollbar
  },
  props: {
    // 布局方案编码 默认：''
    code: { type: String, required: !0, default: "" },
    // 是否渲染参照类型 默认：false
    noRefer: { type: Boolean, default: !1 },
    // 父级组件当前方案 默认：false
    userPlan: { type: Boolean, required: !0, default: !1 }
  },
  emits: ["modalConfirm"],
  setup(e, o) {
    const n = useProviderConfig("state"), t = reactive({
      // 当前选择的方案类型标识
      planType: e.userPlan === !0 ? 2 : 1,
      // 查询条件布局方案
      queryLayout: {
        // 是否存在组件方案
        orgPlan: !1,
        // 是否存在个人方案
        userPlan: !1,
        // 查询条件布局信息
        layout: [],
        // 查询条件方案信息
        plan: {}
      },
      // 单元格编辑标识
      editFlag: {
        itemUuid: "",
        fieldName: ""
      },
      // 单元格编辑框操作句柄
      cellInputEditHandle: null,
      // 快速设置排序 目标序号
      targetSortIndex: 1,
      // 重置默认布局方案 loading
      defaultSchemeLoading: !1,
      // 保存布局方案
      saveSchemeLoading: !1
    }), { close: r } = useDialogState();
    a(t.planType);
    function a(ee) {
      c(ee, !1).then((z) => {
        z.code === 1 && z.data ? f(z.data, !1) : l(!1);
      }).catch(() => {
        apiLinkErrorTip("条件设置获取");
      });
    }
    function l(ee) {
      return c(0, !0).then((z) => {
        z.code === 1 ? f(z.data, ee) : operatorErrorTip(z.msg);
      }).catch(() => {
        apiLinkErrorTip("条件设置获取服务链接失败");
      });
    }
    function s() {
      const ee = t.planType === 1 ? "确认删除组织条件设置？" : "确认删除个人条件设置？";
      openConfirm(ee, {}, (z) => {
        z.action === "confirm" && d().then((P) => {
          P.code === 1 ? (ElMessage.success("条件设置删除完成"), l(!1), o.emit("modalConfirm")) : operatorErrorTip(P.msg);
        }).catch(() => {
          apiLinkErrorTip("条件设置删除");
        });
      });
    }
    function c(ee, z) {
      const P = {
        cBaseQueryCode: e.code,
        iPlanType: ee,
        bInit: z,
        cOrgUuid: n.value.cOrgUuid,
        cPersonUuid: n.value.cPersonUuid
      };
      return msPost(
        "alc-city-framework/SysBaseQueryAction/getBaseQueryPlan",
        P
      );
    }
    function d() {
      const ee = {
        cBaseQueryCode: e.code,
        iPlanType: t.planType,
        cOrgUuid: n.value.cOrgUuid,
        cPersonUuid: n.value.cPersonUuid
      };
      return msPost(
        "alc-city-framework/SysBaseQueryAction/deleteOneBaseQueryPlanPost",
        ee
      );
    }
    function p() {
      const ee = t.queryLayout.plan, z = t.queryLayout.layout;
      ee.iPlanType !== t.planType && (ee.cPlanUUID = null, ee.iPlanID = null), ee.bInit === !0 && (ee.bInit = !1), ee.iPlanType = t.planType, ee.cOrgUuid = n.value.cOrgUuid, ee.cPersonUuid = n.value.cPersonUuid;
      for (let V = 0; V < z.length; V++)
        z[V].iOrder = V + 1;
      return msPost(
        "alc-city-framework/SysBaseQueryAction/saveOneBaseQueryPlan",
        {
          plan: ee,
          list: z
        }
      );
    }
    function f(ee, z) {
      ee ? (z !== !0 && (t.queryLayout.orgPlan = ee.bHasOrgPlan === !0, t.queryLayout.userPlan = ee.bHasPersonPlan === !0, t.queryLayout.plan = ee.plan || {}), t.queryLayout.layout = ee.list || []) : (z !== !0 && (t.queryLayout.orgPlan = !1, t.queryLayout.userPlan = !1, t.queryLayout.plan = {}), t.queryLayout.layout = []);
    }
    function g() {
      return p().then((ee) => (ee.code === 1 ? (ElMessage.success("条件设置保存完成"), o.emit("modalConfirm"), r()) : operatorErrorTip(ee.msg), ee)).catch(() => {
        apiLinkErrorTip("条件设置保存服务链接失败");
      });
    }
    function b() {
      return l(!0);
    }
    function k() {
      a(t.planType);
    }
    function x(ee, z) {
      t.editFlag = {
        itemUuid: ee,
        fieldName: z
      }, nextTick(() => {
        t.cellInputEditHandle.focus();
      });
    }
    function N() {
      t.editFlag = {
        itemUuid: "",
        fieldName: ""
      };
    }
    function O(ee, z, P) {
      t.targetSortIndex = z, x(ee, P);
    }
    function m(ee, z) {
      if (z === void 0)
        return;
      N();
      const [P] = t.queryLayout.layout.splice(ee, 1);
      t.queryLayout.layout.splice(z - 1, 0, P);
    }
    return {
      ...toRefs$1(t),
      deleteScheme: s,
      btnClickOK: g,
      btnClickDefault: b,
      onPlanTypeChange: k,
      onCellClick: x,
      onCellBlur: N,
      onFieldSortClick: O,
      onFieldSortChange: m
    };
  }
}), _hoisted_1$D = { class: "alc-component-columnset-container" }, _hoisted_2$x = { class: "flex alc-cpt-columnset" }, _hoisted_3$r = {
  class: "flex",
  style: { width: "auto", "align-items": "center", "margin-left": "20px" }
}, _hoisted_4$l = { class: "flex columnset-title-container" }, _hoisted_5$i = /* @__PURE__ */ createElementVNode("div", {
  class: "columnset-title",
  style: { width: "80px" }
}, "排序", -1), _hoisted_6$h = /* @__PURE__ */ createElementVNode("div", {
  class: "columnset-title",
  style: { width: "50px" }
}, "序号", -1), _hoisted_7$f = /* @__PURE__ */ createElementVNode("div", {
  class: "columnset-title",
  style: { width: "220px" }
}, "显示名称", -1), _hoisted_8$c = /* @__PURE__ */ createElementVNode("div", {
  class: "columnset-title",
  style: { width: "50px" }
}, "显示", -1), _hoisted_9$c = {
  class: "columnset-title alc-cpt-columnset-oper",
  style: { "text-align": "left" }
}, _hoisted_10$a = /* @__PURE__ */ createElementVNode("span", null, "操作", -1), _hoisted_11$9 = { class: "flex columnset-item-container" }, _hoisted_12$8 = /* @__PURE__ */ createElementVNode("div", {
  class: "columnset-item",
  style: { width: "80px" }
}, [
  /* @__PURE__ */ createElementVNode("i", {
    class: "ri-arrow-up-down-line columnset-edit-handle",
    title: "拖放排序"
  })
], -1), _hoisted_13$7 = {
  class: "columnset-item",
  style: { width: "50px" }
}, _hoisted_14$5 = ["onClick"], _hoisted_15$3 = { key: 1 }, _hoisted_16$3 = { key: 0 }, _hoisted_17$3 = {
  class: "flex columnset-item",
  style: { width: "50px", "max-width": "50px", "align-items": "center", "justify-content": "center" }
}, _hoisted_18$3 = {
  class: "flex columnset-item alc-cpt-columnset-oper",
  style: { "align-items": "center" }
};
function _sfc_render$N(e, o, n, t, r, a) {
  const l = resolveComponent("ElRadioButton"), s = resolveComponent("ElRadioGroup"), c = resolveComponent("AlcTooltip"), d = resolveComponent("ElButton"), p = resolveComponent("ElInput"), f = resolveComponent("ElCheckbox"), g = resolveComponent("AlcInputNumber"), b = resolveComponent("Draggable"), k = resolveComponent("ElScrollbar"), x = resolveComponent("AlcDialogFooter");
  return openBlock(), createElementBlock("div", _hoisted_1$D, [
    createElementVNode("div", _hoisted_2$x, [
      createVNode(s, {
        modelValue: e.planType,
        "onUpdate:modelValue": o[0] || (o[0] = (N) => e.planType = N),
        onChange: e.onPlanTypeChange,
        style: { "margin-left": "16px" }
      }, {
        default: withCtx(() => [
          createVNode(l, { value: 1 }, {
            default: withCtx(() => [
              createTextVNode(" 组织设置 ")
            ]),
            _: 1
          }),
          createVNode(l, { value: 2 }, {
            default: withCtx(() => [
              createTextVNode(" 个人设置 ")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "onChange"]),
      createElementVNode("div", _hoisted_3$r, [
        createVNode(c, {
          content: "<p>1、条件设置优先级：个人 > 组织 > 默认</p><p>2、组织或个人若无设置，会显示默认设置</p>",
          tabindex: null
        })
      ]),
      e.planType === 1 && e.queryLayout.orgPlan === !0 || e.planType === 2 && e.queryLayout.userPlan === !0 ? (openBlock(), createBlock(d, {
        key: 0,
        text: "",
        class: "alc-cpt-columnset-delete",
        title: e.planType === 1 ? "删除组织设置" : "删除个人设置",
        onClick: withModifiers(e.deleteScheme, ["stop"])
      }, {
        default: withCtx(() => [
          createTextVNode(" 删除设置 ")
        ]),
        _: 1
      }, 8, ["title", "onClick"])) : createCommentVNode("", !0)
    ]),
    createElementVNode("div", _hoisted_4$l, [
      _hoisted_5$i,
      _hoisted_6$h,
      _hoisted_7$f,
      _hoisted_8$c,
      createElementVNode("div", _hoisted_9$c, [
        _hoisted_10$a,
        createVNode(c, {
          content: "<p>1、点击操作行中【移动至】按钮</p><p>2、输入移动的目标序号，回车确认</p>",
          tabindex: null
        })
      ])
    ]),
    createVNode(k, { style: { height: "calc(100% - 80px)" } }, {
      default: withCtx(() => [
        createVNode(b, {
          animation: "200",
          "ghost-class": "drag-ghost",
          handle: ".columnset-edit-handle",
          "item-key": "cItemUuid",
          modelValue: e.queryLayout.layout,
          "onUpdate:modelValue": o[2] || (o[2] = (N) => e.queryLayout.layout = N),
          "force-fallback": !0,
          disabled: !1
        }, {
          item: withCtx(({ element: N, index: O }) => [
            createElementVNode("div", _hoisted_11$9, [
              _hoisted_12$8,
              createElementVNode("div", _hoisted_13$7, toDisplayString$1(O + 1), 1),
              createElementVNode("div", {
                class: "columnset-item",
                style: { width: "220px", "max-width": "220px", cursor: "pointer" },
                onClick: withModifiers((m) => e.onCellClick(N.cItemUuid, "cFieldName"), ["stop"])
              }, [
                e.editFlag.itemUuid === N.cItemUuid && e.editFlag.fieldName === "cFieldName" ? (openBlock(), createBlock(p, {
                  key: 0,
                  ref: "cellInputEditHandle",
                  style: { "max-width": "180px", "text-align": "center" },
                  modelValue: N.cLabelName,
                  "onUpdate:modelValue": (m) => N.cLabelName = m,
                  onBlur: e.onCellBlur
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])) : (openBlock(), createElementBlock("span", _hoisted_15$3, [
                  createTextVNode(toDisplayString$1(N.cLabelName) + " ", 1),
                  N.cFieldType === "Refer" && e.noRefer === !0 ? (openBlock(), createElementBlock("span", _hoisted_16$3, " 【参照不显示】 ")) : createCommentVNode("", !0)
                ]))
              ], 8, _hoisted_14$5),
              createElementVNode("div", _hoisted_17$3, [
                createVNode(f, {
                  label: "",
                  modelValue: N.bShow,
                  "onUpdate:modelValue": (m) => N.bShow = m
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              createElementVNode("div", _hoisted_18$3, [
                createVNode(d, {
                  text: "",
                  onClick: withModifiers((m) => e.onFieldSortClick(
                    N.cItemUuid,
                    O + 1,
                    "fieldSort"
                  ), ["stop"]),
                  style: { "margin-right": "8px" }
                }, {
                  default: withCtx(() => [
                    createTextVNode(" 移动至 ")
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                e.editFlag.itemUuid === N.cItemUuid && e.editFlag.fieldName === "fieldSort" ? (openBlock(), createBlock(g, {
                  key: 0,
                  ref: "cellInputEditHandle",
                  modelValue: e.targetSortIndex,
                  "onUpdate:modelValue": o[1] || (o[1] = (m) => e.targetSortIndex = m),
                  onEnter: (m) => e.onFieldSortChange(O, m),
                  min: 1,
                  max: e.queryLayout.layout.length,
                  style: { width: "calc(100% - 72px - 16px)" }
                }, null, 8, ["modelValue", "onEnter", "max"])) : createCommentVNode("", !0)
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    createVNode(x, null, {
      default: withCtx(() => [
        createVNode(d, {
          loading: e.defaultSchemeLoading,
          onClick: e.btnClickDefault
        }, {
          default: withCtx(() => [
            createTextVNode(" 恢复默认 ")
          ]),
          _: 1
        }, 8, ["loading", "onClick"]),
        createVNode(d, {
          type: "primary",
          loading: e.saveSchemeLoading,
          onClick: e.btnClickOK
        }, {
          default: withCtx(() => [
            createTextVNode(" 保存设置 ")
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ]),
      _: 1
    })
  ]);
}
const QuerySet = /* @__PURE__ */ _export_sfc(_sfc_main$N, [["render", _sfc_render$N], ["__file", "query-set.vue"]]), _sfc_main$M = /* @__PURE__ */ defineComponent({
  name: "alc-query",
  __name: "query",
  props: alcQueryProps,
  emits: ["layoutLoaded", "queryOk", "queryClear"],
  setup(e, { expose: o, emit: n }) {
    const t = e, r = n, a = useProviderConfig("state"), l = computed(() => a.value.cPersonUuid || a.value.cAllLinkUserUuid), s = ref(!0), c = ref(!1), d = ref(!1);
    Promise.all([E(), $()]).then(
      ([ae, le]) => {
        C(ae), ae && (isEmptyObject(le) ? r("queryClear", {
          queryValue: te()
        }) : (f.value.list.forEach((fe) => {
          if (![null, void 0, ""].includes(
            le[fe.cFieldName]
          )) {
            if (fe.iQueryModel !== 6 && [
              "Text",
              "Number",
              "Date",
              "Select",
              "Checkbox"
            ].includes(fe.cFieldType))
              b.value[fe.cFieldName] = le[fe.cFieldName];
            else if ((fe.iQueryModel === 6 || fe.cFieldType === "Refer") && isJSON(le[fe.cFieldName])) {
              const Ce = JSON.parse(
                le[fe.cFieldName]
              );
              b.value[fe.cFieldName] = fe.cFieldType === "Date" ? Ce.map((Be) => new Date(Be)) : Ce;
            }
          }
        }), r("queryOk", {
          queryValue: te()
        })));
      }
    );
    const p = ref(), f = shallowRef({
      orgPlan: !1,
      userPlan: !1,
      list: [],
      plan: {}
    }), g = computed(() => f.value.list.filter((ae) => ae.bShow));
    watch(
      () => g.value,
      () => {
        V(p.value.$el.getBoundingClientRect().width);
      }
    );
    const b = ref({ ...t.defaultValue }), k = {
      Text: "input",
      Number: "number",
      Select: "select",
      Date: "date",
      Boolean: "checkbox",
      Refer: "refer",
      Checkbox: "checkbox"
    }, x = ref(3), N = ref(8), O = computed(() => g.value.reduce((ae, le) => (le.bRequired && (ae[le.cFieldName] = {
      required: !0,
      message: `请${["Text", "Number"].includes(le.cFieldType) ? "输入" : "选择"}${le.cLabelName}`
    }), ae), {})), m = computed(() => {
      var Be;
      const le = t.showLines * 24;
      let fe = 0;
      const Ce = [];
      for (const De of g.value) {
        let Fe = (De.iQueryModel === 6 ? N.value : 24 / x.value) + (((Be = t.extraBind[De.cFieldName]) == null ? void 0 : Be.offset) || 0);
        if (fe % 24 + Fe > 24 && (Fe += 24 - fe % 24), s.value && (fe >= le || fe + Fe > le))
          break;
        fe += Fe, Ce.push({
          label: De.cLabelName,
          span: De.iQueryModel === 6 ? N.value : void 0,
          ...t.extraBind[De.cFieldName],
          itemType: k[De.cFieldType],
          prop: De.cFieldName,
          ...De.cFieldType === "Date" ? {
            type: De.cFieldTypeCode,
            range: De.iQueryModel === 6
          } : ["Select", "Refer"].includes(De.cFieldType) ? {
            multiple: De.iQueryModel === 6,
            code: De.cFieldTypeCode
          } : {},
          isSlots: De.iQueryModel === 6 && ["Text", "Number"].includes(De.cFieldType)
        });
      }
      return Ce;
    }), ee = computed(() => m.value.filter((ae) => ae.isSlots)), z = debounce(ne);
    useEventListener$1(
      () => {
        var ae;
        return (ae = p.value) == null ? void 0 : ae.$el;
      },
      "keyup",
      (ae) => {
        ae.key === "Enter" && z();
      }
    );
    const P = new ResizeObserver((ae) => {
      V(ae[0].borderBoxSize[0].inlineSize);
    });
    onPageVisit(() => {
      P.observe(p.value.$el);
    }), onPageLeave(() => {
      P.disconnect();
    }), onOrgChange(E);
    function V(ae) {
      ae >= 1400 ? (x.value = 4, N.value = 6) : ae >= 992 ? (x.value = 4, N.value = 8) : ae >= 768 || ae >= 576 ? (x.value = 3, N.value = 12) : ae >= 375 ? (x.value = 2, N.value = 24) : ae < 375 && (x.value = 1, N.value = 24), c.value = !s.value || m.value.length < g.value.length;
    }
    function U() {
      return msPost(
        "alc-city-framework/SysBaseQueryAction/getBaseQueryPlan",
        {
          cBaseQueryCode: t.code,
          iPlanType: null,
          bInit: !1,
          cOrgUuid: a.value.cOrgUuid,
          cPersonUuid: a.value.cPersonUuid
        }
      );
    }
    function E() {
      return d.value = !0, U().then((ae) => {
        if (!(ae.code !== 1 || isEmptyObject(ae.data)))
          return r("layoutLoaded"), ae.data;
      }).finally(() => {
        d.value = !1;
      });
    }
    function C(ae) {
      ae ? f.value = {
        orgPlan: ae.bHasOrgPlan,
        userPlan: ae.bHasPersonPlan,
        list: isArray(ae.list) ? ae.list : [],
        plan: ae.plan || {}
      } : f.value = {
        orgPlan: !1,
        userPlan: !1,
        list: [],
        plan: {}
      }, I();
    }
    function I() {
      f.value.list.forEach((ae) => {
        var le;
        ae.cFieldType === "Text" && ae.iQueryModel === 6 && !isArray(b.value[ae.cFieldName]) ? b.value[ae.cFieldName] = [] : ae.cFieldType === "Number" && ae.iQueryModel === 6 && !isArray(b.value[ae.cFieldName]) ? b.value[ae.cFieldName] = [] : ae.cFieldType === "Checkbox" && typeof b.value[ae.cFieldName] != "boolean" ? b.value[ae.cFieldName] = !1 : ae.cFieldType === "Refer" && !b.value[ae.cFieldName] && (b.value[ae.cFieldName] = (le = t.extraBind[ae.cFieldName]) != null && le.multiple ? [] : {});
      });
    }
    function v() {
      const ae = {};
      return f.value.list.forEach((le) => {
        le.iQueryModel !== 6 && (le.cFieldType === "Text" || le.cFieldType === "Number" || le.cFieldType === "Date" || le.cFieldType === "Select" || le.cFieldType === "Checkbox") && b.value[le.cFieldName] !== void 0 ? ae[le.cFieldName] = b.value[le.cFieldName] : (le.iQueryModel === 6 || le.cFieldType === "Refer") && (isArray(b.value[le.cFieldName]) && b.value[le.cFieldName].length > 0 || !isEmptyObject(b.value[le.cFieldName])) && (ae[le.cFieldName] = JSON.stringify(
          b.value[le.cFieldName]
        ));
      }), msPost(
        "alc-public-framework/PubDefaultValueAction/saveDefaultValue",
        {
          componentTypeEnum: "QUERY",
          cComponentKey: t.code,
          cUserUuid: l.value,
          defaultMap: ae
        }
      );
    }
    function M() {
      return msGet(
        `alc-public-framework/PubDefaultValueAction/deleteDefaultValue/QUERY/${t.code}/${a.value.cPersonUuid}`
      );
    }
    function $() {
      return msGet(
        `alc-public-framework/PubDefaultValueAction/getDefaultValue/QUERY/${t.code}/${a.value.cPersonUuid}`
      ).then((ae) => ae.data || {}).catch(() => ({}));
    }
    function H() {
      if (isEmptyObject(b.value)) {
        operatorErrorTip("当前查询条件没有任何值，无法保存");
        return;
      }
      v().then((ae) => {
        ae.code === 1 ? ElMessage.success("查询条件默认值保存成功") : operatorErrorTip(ae.msg);
      }).catch(() => {
        apiLinkErrorTip("查询条件默认值");
      });
    }
    function X() {
      M().then((ae) => {
        ae.code === 1 ? ElMessage.success("查询条件默认值清除成功") : operatorErrorTip(ae.msg);
      }).catch(() => {
        apiLinkErrorTip("查询条件默认值");
      });
    }
    function te() {
      return Object.keys(b.value).reduce((ae, le) => {
        if (![null, void 0, ""].includes(b.value[le])) {
          const fe = f.value.list.find((Ce) => le === Ce.cFieldName);
          if (fe) {
            if (fe.cFieldType === "Text" && fe.iQueryModel === 6 && (b.value[le].length === 0 || isBlank(b.value[le][0]) && isBlank(b.value[le][1])) || fe.cFieldType === "Number" && (fe.iQueryModel !== 6 && !isNumber(b.value[le]) || fe.iQueryModel === 6 && (b.value[le].length === 0 || !isNumber(b.value[le][0]) && !isNumber(b.value[le][1]))) || fe.cFieldType === "Refer" && (isPlainObject(b.value[le]) && isEmptyObject(b.value[le]) || isArray(b.value[le]) && b.value[le].length === 0))
              return ae;
            ae[le] = {
              fieldName: fe.cFieldName,
              fieldType: fe.cFieldType,
              queryName: fe.cQueryFieldName,
              queryType: fe.iQueryModel,
              queryValue: b.value[le],
              queryValueTypeCode: fe.cFieldTypeCode
            };
          }
        }
        return ae;
      }, {});
    }
    function oe() {
      b.value = {}, f.value.list.filter((ae) => ae.cFieldType === "Refer").forEach((ae) => {
        var le;
        b.value[ae.cFieldName] = (le = t.extraBind[ae.cFieldName]) != null && le.multiple ? [] : {};
      }), I(), r("queryClear", {
        queryValue: te()
      });
    }
    function ne() {
      r("queryOk", {
        queryValue: te()
      });
    }
    function ie(ae) {
      ae === "clearQuery" ? oe() : ae === "saveDefaultQueryValue" ? H() : ae === "deleteDefaultQueryValue" && X();
    }
    function se() {
      d.value = !0, U().then((ae) => {
        C(ae.data);
      }).catch(() => {
        C();
      }).finally(() => {
        d.value = !1;
      });
    }
    function pe(ae, le) {
      (ae.length !== 2 || ae.some((fe) => !fe)) && le.stopPropagation();
    }
    o({
      ...getInstanceMethod(p, ["clearValidate", "validate"]),
      queryValue: b,
      clearQuery: oe,
      clearItemQuery(ae) {
        b.value[ae] !== void 0 && delete b.value[ae], I();
      },
      setQuery(ae) {
        b.value = { ...ae }, I();
      },
      setItemQuery(ae, le) {
        b.value[ae] = le, I();
      },
      getQuery: te,
      getQueryCondition() {
        const ae = te();
        return isEmptyObject(ae) ? [] : toQueryConditionList(ae);
      }
    });
    const he = { props: t, emits: r, coreState: a, personUuid: l, isCollapse: s, canCollapse: c, isLoading: d, formRef: p, queryLayout: f, showLayoutList: g, queryValue: b, itemReference: k, column: x, rangeItemSpan: N, rules: O, schema: m, slotsItem: ee, run: z, resizeSubscribe: P, setColNumber: V, fetchLayout: U, initLayout: E, setQueryLayoutData: C, formatQueryValue: I, doSaveDefaultQueryValue: v, doDeleteDefaultQueryValue: M, getDefaultQueryValue: $, saveDefaultQueryValue: H, deleteDefaultQueryValue: X, getQuery: te, clearQuery: oe, confirmQuery: ne, queryListItemClick: ie, planTypeChange: se, stopEvent: pe, get AlcDialog() {
      return AlcDialog;
    }, get AlcForm() {
      return AlcForm;
    }, get AlcInput() {
      return AlcInput;
    }, get AlcInputNumber() {
      return AlcInputNumber;
    }, get ElButton() {
      return ElButton;
    }, get ElDropdown() {
      return ElDropdown;
    }, get ElDropdownItem() {
      return ElDropdownItem;
    }, get ElDropdownMenu() {
      return ElDropdownMenu;
    }, get isNumber() {
      return isNumber;
    }, QuerySet };
    return Object.defineProperty(he, "__isScriptSetup", { enumerable: !1, value: !0 }), he;
  }
}), _hoisted_1$C = { class: "alc-collapse--wrap alc-component-query-container" }, _hoisted_2$w = {
  key: 0,
  style: { width: "100%", display: "flex", "flex-flow": "row nowrap" }
}, _hoisted_3$q = /* @__PURE__ */ createElementVNode("div", { class: "cpt-query-item-range-separator" }, [
  /* @__PURE__ */ createElementVNode("div", { class: "range-separator" }, "-")
], -1), _hoisted_4$k = {
  key: 1,
  style: { width: "100%", display: "flex", "flex-flow": "row nowrap" }
}, _hoisted_5$h = /* @__PURE__ */ createElementVNode("div", { class: "cpt-query-item-range-separator" }, [
  /* @__PURE__ */ createElementVNode("div", { class: "range-separator" }, "-")
], -1), _hoisted_6$g = { class: "alc-component-query--operator" }, _hoisted_7$e = ["title"];
function _sfc_render$M(e, o, n, t, r, a) {
  return openBlock(), createElementBlock("div", _hoisted_1$C, [
    createVNode(t.AlcForm, {
      ref: "formRef",
      modelValue: t.queryValue,
      "onUpdate:modelValue": o[0] || (o[0] = (l) => t.queryValue = l),
      schema: t.schema,
      rules: t.rules,
      column: t.column,
      clearable: "",
      "same-label": "",
      background: "",
      onSubmit: o[1] || (o[1] = withModifiers(() => {
      }, ["prevent"]))
    }, createSlots({ _: 2 }, [
      renderList(t.slotsItem, (l) => ({
        name: l.prop,
        fn: withCtx(() => [
          l.itemType === "input" ? (openBlock(), createElementBlock("div", _hoisted_2$w, [
            createVNode(t.AlcInput, mergeProps(e.extraBind[l.prop + "_1"], {
              modelValue: t.queryValue[l.prop][0],
              "onUpdate:modelValue": (s) => t.queryValue[l.prop][0] = s,
              onKeyup: (s) => t.stopEvent(t.queryValue[l.prop], s)
            }), null, 16, ["modelValue", "onUpdate:modelValue", "onKeyup"]),
            _hoisted_3$q,
            createVNode(t.AlcInput, mergeProps(e.extraBind[l.prop + "_2"], {
              modelValue: t.queryValue[l.prop][1],
              "onUpdate:modelValue": (s) => t.queryValue[l.prop][1] = s,
              onKeyup: (s) => t.stopEvent(t.queryValue[l.prop], s)
            }), null, 16, ["modelValue", "onUpdate:modelValue", "onKeyup"])
          ])) : l.itemType === "number" ? (openBlock(), createElementBlock("div", _hoisted_4$k, [
            createVNode(t.AlcInputNumber, mergeProps(e.extraBind[l.prop + "_1"], {
              modelValue: t.queryValue[l.prop][0],
              "onUpdate:modelValue": (s) => t.queryValue[l.prop][0] = s,
              precision: t.isNumber(l.precision) ? Number(l.precision) : 0,
              class: "cpt-query-item-range-container",
              onKeyup: (s) => t.stopEvent(t.queryValue[l.prop], s)
            }), null, 16, ["modelValue", "onUpdate:modelValue", "precision", "onKeyup"]),
            _hoisted_5$h,
            createVNode(t.AlcInputNumber, mergeProps(e.extraBind[l.prop + "_2"], {
              modelValue: t.queryValue[l.prop][1],
              "onUpdate:modelValue": (s) => t.queryValue[l.prop][1] = s,
              precision: Number(l.precision) ? Number(l.precision) : 0,
              class: "cpt-query-item-range-container",
              onKeyup: (s) => t.stopEvent(t.queryValue[l.prop], s)
            }), null, 16, ["modelValue", "onUpdate:modelValue", "precision", "onKeyup"])
          ])) : createCommentVNode("", !0)
        ])
      }))
    ]), 1032, ["modelValue", "schema", "rules", "column"]),
    createElementVNode("div", _hoisted_6$g, [
      createVNode(t.ElDropdown, {
        type: "primary",
        "split-button": "",
        onClick: t.confirmQuery,
        onCommand: t.queryListItemClick
      }, {
        dropdown: withCtx(() => [
          createVNode(t.ElDropdownMenu, null, {
            default: withCtx(() => [
              createVNode(t.ElDropdownItem, { command: "clearQuery" }, {
                default: withCtx(() => [
                  createTextVNode(" 清空查询条件 ")
                ]),
                _: 1
              }),
              createVNode(t.ElDropdownItem, { command: "saveDefaultQueryValue" }, {
                default: withCtx(() => [
                  createTextVNode(" 保存默认值 ")
                ]),
                _: 1
              }),
              createVNode(t.ElDropdownItem, { command: "deleteDefaultQueryValue" }, {
                default: withCtx(() => [
                  createTextVNode(" 清除默认值 ")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: withCtx(() => [
          createTextVNode(" 查询 ")
        ]),
        _: 1
      }),
      createVNode(t.AlcDialog, {
        title: "条件设置",
        "width-type": "sm",
        "show-fullscreen": "",
        draggable: "",
        "content-fil-height": "",
        style: { display: "inline-flex" }
      }, {
        reference: withCtx(() => [
          createVNode(t.ElButton, {
            class: "ri-settings-4-line",
            title: "条件设置",
            style: { "margin-left": "4px", "font-size": "16px" }
          })
        ]),
        default: withCtx(() => [
          createVNode(t.QuerySet, {
            ref: "querySetHandle",
            code: e.code,
            "no-refer": e.noRefer,
            "user-plan": t.queryLayout.userPlan,
            onModalConfirm: t.planTypeChange
          }, null, 8, ["code", "no-refer", "user-plan"])
        ]),
        _: 1
      })
    ]),
    createVNode(Transition$1, {
      name: "el-zoom-in-bottom",
      appear: ""
    }, {
      default: withCtx(() => [
        t.canCollapse ? (openBlock(), createElementBlock("span", {
          key: 0,
          class: normalizeClass([{ rotate: t.isCollapse }, "alc-collapse--handle"]),
          title: t.isCollapse ? "展开" : "收起",
          onClick: o[2] || (o[2] = (l) => t.isCollapse = !t.isCollapse)
        }, null, 10, _hoisted_7$e)) : createCommentVNode("", !0)
      ]),
      _: 1
    })
  ]);
}
const Query = /* @__PURE__ */ _export_sfc(_sfc_main$M, [["render", _sfc_render$M], ["__file", "query.vue"]]), AlcQuery = withInstall(Query), alcSplitView = {
  /**
   * 横向布局
   * @default false
   */
  horizontal: { type: Boolean, default: !1 },
  /**
   * 折叠后被收起的视图
   * @default 'first'
   */
  collapse: {
    type: String,
    default: "first"
  },
  /**
   * 禁止调整大小
   * @default false
   */
  disabled: { type: Boolean, default: !1 },
  /**
   * 是否可手动调整大小，false 时只能展开/收起
   * @default false
   */
  manual: { type: Boolean, default: !1 },
  /**
   * first 容器初始宽度
   * @default 'auto'
   */
  firstInit: { type: [Number, String], default: "auto" },
  /**
   * first 容器最大宽度，manual 为 true 时生效
   */
  firstMax: { type: Number },
  /**
   * first 容器最小宽度，manual 为 true 时生效
   * @default 0
   */
  firstMin: { type: Number, default: 0 },
  /**
   * 内部滚动
   * @default false
   * @deprecated
   */
  firstWrap: { type: Boolean, default: !1 },
  /**
   * 内部滚动
   * @default false
   * @deprecated
   */
  lastWrap: { type: Boolean, default: !1 },
  /**
   * 隐藏分割线
   * @default false
   */
  hideDivided: { type: Boolean, default: !1 },
  /**
   * 翻转 first 和 last 插槽的位置
   * @default false
   */
  reverse: { type: Boolean, default: !1 }
}, _sfc_main$L = /* @__PURE__ */ defineComponent({
  name: "alc-split-view",
  __name: "split-view",
  props: alcSplitView,
  setup(e, { expose: o }) {
    const n = e, t = useSlots(), r = computed(() => n.horizontal ? "width" : "height"), a = computed(() => n.horizontal ? "clientX" : "clientY"), l = ref(n.firstMax);
    watch(
      () => n.firstMax,
      (E) => {
        l.value = E;
      }
    );
    const s = computed(() => [x.value.$el.getBoundingClientRect()[r.value], 0]), c = computed(() => [N.value.$el.getBoundingClientRect()[r.value], 0]), d = ref(!1), p = !n.hideDivided && t.first && t.last ? 1 : 0, f = computed(() => n.manual ? {
      onmousedown: ee,
      class: n.horizontal ? "manual-flag--horizontal-handle" : "manual-flag--vertical-handle"
    } : {
      onClick: () => {
        P();
      },
      class: n.horizontal ? [
        "ri-arrow-right-s-line out-the-right",
        "ri-arrow-left-s-line out-the-left"
      ][Number(
        n.reverse ? d.value : !d.value
      )] : [
        "ri-arrow-down-s-line out-the-bottom",
        "ri-arrow-up-s-line out-the-top"
      ][Number(
        n.reverse ? d.value : !d.value
      )]
    }), g = computed(() => n.disabled ? {} : f.value), b = computed(() => n.disabled || !n.manual ? "cursor-default" : n.horizontal ? "cursor-h-resize" : "cursor-y-resize"), k = ref(), x = ref(), N = ref();
    let O = 0;
    const { moveWidth: m, mouseDown: ee } = V(() => {
      var E, C;
      typeof ((E = x.value) == null ? void 0 : E.update) == "function" && x.value.update(), typeof ((C = N.value) == null ? void 0 : C.update) == "function" && N.value.update();
    });
    watch(m, (E) => {
      x.value && N.value && (x.value.$el.style.flexBasis = `${E}px`, N.value.$el.style.flexBasis = `calc(100% - ${p}px - ${E}px)`, x.value.$el.style[r.value] = x.value.$el.style.flexBasis, N.value.$el.style[r.value] = N.value.$el.style.flexBasis);
    });
    const z = new MutationObserver(() => {
      var C;
      const E = Number.parseInt(
        window.getComputedStyle((C = x.value) == null ? void 0 : C.wrapRef).getPropertyValue(r.value)
      );
      m.value = Math.min(
        Math.max(E, n.firstMin)
        // localFirstMax.value! / 2,
      );
    });
    onPageVisit(() => {
      var E;
      x.value instanceof HTMLDivElement && (x.value.$el = x.value, x.value.wrapRef = x.value), N.value instanceof HTMLDivElement && (N.value.$el = N.value, N.value.wrapRef = N.value), N.value.$el.style.flexGrow = "1", N.value.$el.style.width = "100%", x.value.$el.style.transition = "all .2s", N.value.$el.style.transition = "all .2s", O = Number.parseInt(
        window.getComputedStyle(k.value).getPropertyValue(r.value)
      ) - p, l.value || (l.value = O), n.firstInit === "auto" ? z.observe((E = x.value) == null ? void 0 : E.wrapRef, {
        childList: !0,
        subtree: !0
      }) : m.value = Math.min(
        Math.max(Number.parseInt(String(n.firstInit)), n.firstMin)
        // localFirstMax.value,
      );
    }), onPageLeave(() => {
      z.disconnect();
    });
    function P(E = !d.value) {
      d.value = E, n.collapse === "first" ? m.value = s.value[+d.value] : n.collapse === "last" && x.value && N.value && (N.value.$el.style.flexBasis = c.value[+d.value], x.value.$el.style.flexBasis = `calc(100% - -${p}px - ${c.value[+d.value]}px)`, x.value.$el.style[r.value] = x.value.$el.style.flexBasis, N.value.$el.style[r.value] = N.value.$el.style.flexBasis);
    }
    function V(E) {
      const C = ref(0);
      let I = 0;
      const v = () => {
        E == null || E(), document.removeEventListener("mousemove", M);
      }, M = (H) => {
        H.preventDefault();
        const X = H[a.value];
        X > I ? C.value = Math.min(
          l.value,
          C.value + X - I
        ) : C.value = Math.max(
          n.firstMin,
          C.value - (I - X)
        ), I = X;
      };
      return {
        moveWidth: C,
        mouseDown: (H) => {
          I = H[a.value], document.addEventListener("mousemove", M, {
            passive: !1
          }), document.addEventListener("mouseup", v, {
            once: !0,
            passive: !0
          });
        }
      };
    }
    o({
      doCollapse: P
    });
    const U = { props: n, slots: t, modeBoxMap: r, modeAttrMap: a, localFirstMax: l, firstCollapseSize: s, lastCollapseSize: c, isCollapse: d, moveFlagSize: p, flagCss: f, moveFlagAttrs: g, cursorStyle: b, splitViewEl: k, firstView: x, lastView: N, get splitViewDivSize() {
      return O;
    }, set splitViewDivSize(E) {
      O = E;
    }, moveWidth: m, mouseDown: ee, observer: z, doCollapse: P, useMouseMove: V, get ElScrollbar() {
      return ElScrollbar;
    } };
    return Object.defineProperty(U, "__isScriptSetup", { enumerable: !1, value: !0 }), U;
  }
}), _hoisted_1$B = {
  key: 1,
  ref: "firstView",
  class: "split-view--first"
}, _hoisted_2$v = {
  key: 4,
  ref: "lastView",
  class: "split-view--last"
};
function _sfc_render$L(e, o, n, t, r, a) {
  return openBlock(), createElementBlock("div", {
    ref: "splitViewEl",
    class: normalizeClass(["alc-component-split-view-container", {
      "order-reverse": e.reverse
    }]),
    style: normalizeStyle({
      flexFlow: `${e.horizontal ? "row" : "column"} nowrap`
    })
  }, [
    e.firstWrap ? (openBlock(), createBlock(t.ElScrollbar, {
      key: 0,
      ref: "firstView"
    }, {
      default: withCtx(() => [
        renderSlot(e.$slots, "first")
      ]),
      _: 3
    }, 512)) : (openBlock(), createElementBlock("div", _hoisted_1$B, [
      renderSlot(e.$slots, "first")
    ], 512)),
    e.$slots.first && e.$slots.last ? (openBlock(), createElementBlock("div", {
      key: 2,
      style: normalizeStyle({ [t.modeBoxMap]: t.moveFlagSize + "px" }),
      class: "split-view--divided"
    }, [
      createElementVNode("i", mergeProps(t.moveFlagAttrs, {
        class: [t.cursorStyle, "split-view--handle"]
      }), null, 16)
    ], 4)) : createCommentVNode("", !0),
    e.lastWrap ? (openBlock(), createBlock(t.ElScrollbar, {
      key: 3,
      ref: "lastView"
    }, {
      default: withCtx(() => [
        renderSlot(e.$slots, "last")
      ]),
      _: 3
    }, 512)) : (openBlock(), createElementBlock("div", _hoisted_2$v, [
      renderSlot(e.$slots, "last")
    ], 512))
  ], 6);
}
const SplitView = /* @__PURE__ */ _export_sfc(_sfc_main$L, [["render", _sfc_render$L], ["__file", "split-view.vue"]]), AlcSplitView = withInstall(SplitView), alcContextMenuProps = {
  /**
   * 触发右键菜单的元素
   * @default null
   */
  selector: {
    type: [Object, String],
    validator: (e) => e instanceof HTMLElement || typeof e == "string"
  },
  /**
   * 接受右键点击事件的委托元素，应当传递目标元素的 nodeName 或 className
   * @default ''
   * @example 'div' 或 '.el-table__body' 或 'tr.is-hover'，不支持层级嵌套、伪元素和 id
   */
  delegate: { type: String, default: "" },
  /**
   * 右键菜单数据对象集合
   */
  menuList: {
    type: Array,
    required: !0
  }
}, _sfc_main$K = /* @__PURE__ */ defineComponent({
  name: "alc-context-menu",
  __name: "context-menu",
  props: alcContextMenuProps,
  emits: ["itemClick"],
  setup(e, { expose: o, emit: n }) {
    const t = e, r = n, a = reactive({
      x: 0,
      y: 0
    }), l = ref(!1), s = ref("el-zoom-in-top"), c = shallowRef();
    let d = null, p, f;
    watch(
      () => t.selector,
      (m, ee) => {
        ee && g(ee), m && nextTick(() => {
          typeof m == "string" ? (d = document.querySelector(m), d ? d.addEventListener(
            "contextmenu",
            b,
            {
              passive: !1,
              capture: !0
            }
          ) : warn$2(
            "components/alc-context-menu",
            "$selector is not found"
          )) : m.addEventListener("contextmenu", b, {
            passive: !1,
            capture: !0
          });
        });
      },
      { immediate: !0 }
    ), onUnmounted(() => {
      g(t.selector);
    });
    function g(m) {
      typeof m == "string" ? d == null || d.removeEventListener("contextmenu", b) : m == null || m.removeEventListener("contextmenu", b);
    }
    function b(m) {
      if (isBlank(t.delegate))
        m.preventDefault(), k(
          { x: m.clientX, y: m.clientY },
          m.target,
          f
        );
      else {
        const [ee, ...z] = t.delegate.split("."), P = m.path || m.composedPath && m.composedPath();
        P != null && P.some((V) => {
          if ([
            Node.ELEMENT_NODE,
            Node.TEXT_NODE,
            Node.DOCUMENT_FRAGMENT_NODE
          ].includes(V.nodeType)) {
            let U = !0, E = !0;
            return ee && V.nodeName.toLowerCase() !== ee.toLowerCase() && (U = !1), z.length && (E = z.every((C) => V.classList.contains(C))), U && E && (p = V), U && E;
          }
          return !1;
        }) && (m.preventDefault(), k(
          { x: m.clientX, y: m.clientY },
          p,
          f
        ));
      }
    }
    function k(m, ee, z) {
      f = z, p = ee, x(), nextTick(() => {
        var E, C;
        const P = ((E = c.value) == null ? void 0 : E.clientHeight) || 0, V = ((C = c.value) == null ? void 0 : C.clientWidth) || 0, U = m.y + P < document.body.offsetHeight;
        Object.assign(a, {
          x: m.x + V < document.body.offsetWidth ? m.x : m.x - V,
          y: U ? m.y : m.y - P
        }), s.value = U ? "el-zoom-in-top" : "el-zoom-in-bottom", l.value = !0, window.addEventListener("scroll", x, {
          passive: !0,
          capture: !0,
          once: !0
        });
      });
    }
    function x() {
      l.value && (l.value = !1);
    }
    function N(m) {
      x(), typeof m.click == "function" ? m.click(f, p) : r("itemClick", {
        command: m.command,
        triggerEl: p,
        eventData: f
      });
    }
    o({
      open: k,
      close: x
    });
    const O = { props: t, emit: r, position: a, isShow: l, transitionName: s, contextMenuRef: c, get triggerContextMenuEL() {
      return d;
    }, set triggerContextMenuEL(m) {
      d = m;
    }, get triggerEl() {
      return p;
    }, set triggerEl(m) {
      p = m;
    }, get eventData() {
      return f;
    }, set eventData(m) {
      f = m;
    }, removeListener: g, delegateBind: b, openContextmenu: k, closeContextmenu: x, onCurrentContextmenuClick: N, get vClickOutside() {
      return ClickOutside;
    }, get isBlank() {
      return isBlank;
    } };
    return Object.defineProperty(O, "__isScriptSetup", { enumerable: !1, value: !0 }), O;
  }
}), _hoisted_1$A = { class: "el-dropdown-menu" }, _hoisted_2$u = {
  key: 0,
  class: "el-dropdown-menu__item--divided"
}, _hoisted_3$p = ["aria-disabled", "onClick"], _hoisted_4$j = { style: { flex: "1" } };
function _sfc_render$K(e, o, n, t, r, a) {
  return openBlock(), createBlock(Teleport, { to: "body" }, [
    createVNode(Transition$1, {
      name: t.transitionName,
      mode: "out-in"
    }, {
      default: withCtx(() => [
        withDirectives((openBlock(), createElementBlock("div", {
          ref: "contextMenuRef",
          "aria-hidden": "true",
          class: "el-dropdown__popper el-popper is-light is-pure alc-component-contextmenu",
          role: "tooltip",
          "data-popper-placement": "bottom",
          style: normalizeStyle(`top: ${t.position.y}px; left: ${t.position.x}px`),
          onContextmenu: o[0] || (o[0] = withModifiers(() => {
          }, ["prevent"]))
        }, [
          createElementVNode("ul", _hoisted_1$A, [
            (openBlock(!0), createElementBlock(Fragment, null, renderList(e.menuList, (l) => (openBlock(), createElementBlock(Fragment, {
              key: l.label
            }, [
              l.divided ? (openBlock(), createElementBlock("li", _hoisted_2$u)) : createCommentVNode("", !0),
              createElementVNode("li", {
                class: normalizeClass(["el-dropdown-menu__item flex", { "is-disabled": l.disabled }]),
                "aria-disabled": l.disabled,
                onClick: (s) => l.disabled || t.onCurrentContextmenuClick(l)
              }, [
                t.isBlank(l.icon) ? createCommentVNode("", !0) : (openBlock(), createElementBlock("i", {
                  key: 0,
                  class: normalizeClass(l.icon)
                }, null, 2)),
                createElementVNode("span", _hoisted_4$j, toDisplayString$1(l.label), 1)
              ], 10, _hoisted_3$p)
            ], 64))), 128))
          ])
        ], 36)), [
          [vShow, t.isShow],
          [t.vClickOutside, t.closeContextmenu]
        ])
      ]),
      _: 1
    }, 8, ["name"])
  ]);
}
const ContextMenu = /* @__PURE__ */ _export_sfc(_sfc_main$K, [["render", _sfc_render$K], ["__file", "context-menu.vue"]]), AlcContextMenu = withInstall(ContextMenu), _sfc_main$J = /* @__PURE__ */ defineComponent({
  name: "alc-tree",
  __name: "tree",
  props: {
    defaultExpandAll: { type: Boolean },
    checkDescendants: { type: Boolean },
    defaultCheckedKeys: {},
    defaultExpandedKeys: {},
    currentNodeKey: {},
    renderContent: {},
    draggable: { type: Boolean },
    allowDrag: {},
    allowDrop: {},
    lazy: { type: Boolean },
    load: {},
    accordion: { type: Boolean },
    icon: {},
    data: {},
    code: {},
    label: {},
    disabled: { type: Boolean, default: !1 },
    multiple: { type: Boolean, default: !1 },
    checkStrictly: { type: Boolean },
    search: { type: Boolean, default: !0 },
    fastEdit: { type: Boolean, default: !1 },
    showCode: { type: Boolean, default: !1 },
    initFetch: { type: Boolean, default: !0 },
    where: {},
    query: {},
    nodeConfig: { default: () => ({
      label: "cTreeNodeTitle",
      value: "cTreeKey",
      code: "cTreeCode",
      parent: "cParentKey"
    }) },
    menuList: {},
    tips: {},
    dataScope: {},
    style: {},
    class: {}
  },
  emits: ["layoutLoaded", "nodeLoaded", "refresh", "nodeContextmenu", "nodeClick", "removeNode", "appendNode", "contextItemClick", "checkAll", "checkSelect", "checkUnselect"],
  setup(e, { expose: o, emit: n }) {
    const t = useAttrs(), r = e, a = n, l = ref(), s = computed(() => mergeProps(
      objOmit(r, [
        "data",
        "code",
        "label",
        "disabled",
        "multiple",
        "search",
        "fastEdit",
        "showCode",
        "initFetch",
        "where",
        "query",
        "nodeConfig",
        "menuList",
        "tips",
        "dataScope",
        "style",
        "class"
      ]),
      t
    )), c = shallowRef([]), {
      isManual: d,
      nodeData: p,
      nodeConfig: f,
      renderNodeData: g,
      indeterminate: b,
      getAllNode: k
    } = useTreeData(
      toRef(r, "data"),
      c,
      {},
      "nodeConfig",
      !0
    ), { layout: x, getTreeLayout: N, getTreeDataByLayout: O, formatCodeNodeData: m } = useTreeLayout(f);
    N().then(() => {
      a("layoutLoaded"), r.initFetch && x.value.cDataSourceType !== "none" && I();
    });
    const ee = computed(() => r.label || x.value.cBaseTreeTitle), z = ref(!1), P = ref("");
    function V() {
      var le;
      (le = l.value) == null || le.filter(P.value);
    }
    function U(le, fe) {
      return isBlank(le) ? !0 : fe[f.value.label].indexOf(le) !== -1;
    }
    function E(le, fe) {
      return r.disabled ? !0 : typeof f.value.disabled == "function" ? f.value.disabled(le, fe) : le[f.value.disabled];
    }
    function C() {
      a("refresh"), !d.value && x.value.cDataSourceType !== "none" && I();
    }
    async function I() {
      return p.value = await O(), a("nodeLoaded", p.value), p.value;
    }
    function v(le, fe) {
      fe.disabled || a("nodeClick", le, fe);
    }
    const M = ref(), $ = shallowRef();
    function H(le, ...fe) {
      var Ce;
      (Ce = r.menuList) != null && Ce.length && fe[0].disabled !== !0 && (M.value.open(
        {
          x: le.clientX,
          y: le.clientY
        },
        le.target,
        {
          data: fe[0],
          node: fe[1]
        }
      ), $.value = fe);
    }
    function X(le, fe) {
      c.value = fe.checkedNodes.concat(fe.halfCheckedNodes).map((Be) => Be[f.value.value]);
      const Ce = l.value.getNode(le[f.value.value]);
      Ce.checked ? a("checkSelect", le, Ce) : a("checkUnselect", le, Ce);
    }
    function te(le) {
      var fe;
      c.value = le ? [...new Set(k(g.value).flat())] : [], c.value.length ? (fe = l.value) == null || fe.setCheckedKeys(c.value) : g.value.forEach((Ce) => {
        var Be;
        (Be = l.value) == null || Be.setChecked(Ce[f.value.value], !1, !0);
      }), a("checkAll", c.value);
    }
    function oe(le) {
      a("appendNode", le);
    }
    function ne(le) {
      var fe;
      (fe = l.value) == null || fe.remove(le), a("removeNode", le);
    }
    const ie = ref();
    function se() {
      nextTick(() => {
        ie.value && ie.value.update();
      });
    }
    function pe(le) {
      a("contextItemClick", le, $.value[0]);
    }
    function he(le, fe) {
      const Ce = [];
      return le.forEach((Be) => {
        Be[f.value.parent] === fe && (Be[f.value.children] = he(
          le,
          Be[f.value.code]
        ), Ce.push(Be));
      }), Ce;
    }
    o({
      nodeData: p,
      getInstance() {
        return l.value;
      },
      setRefreshLoad(le) {
        z.value = le;
      },
      setNodeData(le, fe) {
        le = deepClone(le), r.showCode && m(deepClone(le)), p.value = fe ? he(le) : le, se(), a("nodeLoaded", p.value);
      },
      async getNodeDataByLayout() {
        return await nextTick(), I();
      },
      ...getInstanceMethod(l, [
        "updateKeyChildren",
        "getCheckedNodes",
        "setCheckedNodes",
        "getCheckedKeys",
        "setCheckedKeys",
        "setChecked",
        "getHalfCheckedNodes",
        "getHalfCheckedKeys",
        "getCurrentKey",
        "getCurrentNode",
        "setCurrentKey",
        "setCurrentNode",
        "getNode",
        "remove",
        "append",
        "insertBefore",
        "insertAfter"
      ])
    });
    const ae = { attrs: t, props: r, emits: a, treeRef: l, treeProps: s, checkedNodes: c, isManual: d, nodeData: p, nodeConfig: f, renderNodeData: g, indeterminate: b, getAllNode: k, layout: x, getTreeLayout: N, getTreeDataByLayout: O, formatCodeNodeData: m, treeTitle: ee, nodeDataLoading: z, searchText: P, onSearchChange: V, onFilterNode: U, treeDisabled: E, refreshTree: C, fetchNodeData: I, onNodeClick: v, contextmenuRef: M, contextmenuSelect: $, onNodeContextmenu: H, onCheck: X, onCheckAllChange: te, appendNode: oe, removeNode: ne, treeScrollbarRef: ie, updateTreeScroll: se, onContextMenuItemClick: pe, formatNodeData: he, get AlcContextMenu() {
      return AlcContextMenu;
    }, get AlcInput() {
      return AlcInput;
    }, get AlcTooltip() {
      return AlcTooltip;
    }, get ElButton() {
      return ElButton;
    }, get ElCheckbox() {
      return ElCheckbox;
    }, get ElPopconfirm() {
      return ElPopconfirm;
    }, get ElScrollbar() {
      return ElScrollbar;
    }, get ElTree() {
      return ElTree;
    } };
    return Object.defineProperty(ae, "__isScriptSetup", { enumerable: !1, value: !0 }), ae;
  }
}), _hoisted_1$z = { class: "flex w100 alc-cpt-layout-prefix-tree" }, _hoisted_2$t = ["title"], _hoisted_3$o = {
  key: 0,
  class: "flex w100 alc-cpt-layout-oper-tree"
}, _hoisted_4$i = /* @__PURE__ */ createElementVNode("i", {
  class: "ri-search-line",
  style: { width: "22px", "font-size": "16px" }
}, null, -1), _hoisted_5$g = ["onContextmenu"], _hoisted_6$f = {
  class: "flex",
  style: { padding: "0 5px", "align-items": "center" }
}, _hoisted_7$d = ["onClick"];
function _sfc_render$J(e, o, n, t, r, a) {
  var l;
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["flex h100 alc-component-tree-container", e.$props.class]),
    style: normalizeStyle(e.$props.style)
  }, [
    createElementVNode("div", _hoisted_1$z, [
      withDirectives(createElementVNode("span", {
        class: "alc-cpt-layout-label-tree single-line-overflow flex",
        title: t.treeTitle
      }, [
        createTextVNode(toDisplayString$1(t.treeTitle) + " ", 1),
        n.tips ? (openBlock(), createBlock(t.AlcTooltip, {
          key: 0,
          content: n.tips,
          tabindex: null
        }, null, 8, ["content"])) : createCommentVNode("", !0)
      ], 8, _hoisted_2$t), [
        [vShow, t.treeTitle]
      ]),
      createVNode(t.ElButton, {
        loading: t.nodeDataLoading,
        class: "ri-refresh-line",
        title: "刷新",
        onClick: t.refreshTree
      }, null, 8, ["loading"])
    ]),
    n.multiple || n.search ? (openBlock(), createElementBlock("div", _hoisted_3$o, [
      t.nodeConfig.multiple ? (openBlock(), createBlock(t.ElCheckbox, {
        key: 0,
        disabled: n.disabled,
        indeterminate: t.indeterminate,
        "model-value": !!t.checkedNodes.length,
        label: "全选",
        class: "alc-cpt-oper-tree-checkall",
        "onUpdate:modelValue": t.onCheckAllChange
      }, null, 8, ["disabled", "indeterminate", "model-value"])) : createCommentVNode("", !0),
      n.search ? (openBlock(), createBlock(t.AlcInput, {
        key: 1,
        modelValue: t.searchText,
        "onUpdate:modelValue": o[0] || (o[0] = (s) => t.searchText = s),
        placeholder: "节点过滤",
        clearable: "",
        class: "alc-cpt-oper-tree-searchnode",
        onChange: t.onSearchChange
      }, {
        prefix: withCtx(() => [
          _hoisted_4$i
        ]),
        _: 1
      }, 8, ["modelValue"])) : createCommentVNode("", !0)
    ])) : createCommentVNode("", !0),
    createVNode(t.ElScrollbar, {
      ref: "treeScrollbarRef",
      class: "w100 alc-cpt-layout-content-tree"
    }, {
      default: withCtx(() => [
        createVNode(t.ElTree, mergeProps({ ref: "treeRef" }, t.treeProps, {
          data: t.renderNodeData,
          props: {
            label: t.nodeConfig.label,
            children: t.nodeConfig.children,
            disabled: t.treeDisabled,
            isLeaf: t.nodeConfig.isLeaf,
            class: t.nodeConfig.class
          },
          "node-key": t.nodeConfig.value,
          "show-checkbox": n.multiple,
          "highlight-current": !n.multiple,
          "filter-node-method": t.onFilterNode,
          "auto-expand-parent": "",
          onNodeClick: t.onNodeClick,
          onNodeContextmenu: t.onNodeContextmenu,
          onCheck: t.onCheck
        }), createSlots({ _: 2 }, [
          n.fastEdit && !n.disabled ? {
            name: "default",
            fn: withCtx(({ node: s, data: c, store: d }) => [
              createElementVNode("span", {
                class: "flex alc-cpt-node-tree",
                onContextmenu: (p) => t.onNodeContextmenu(p, c, s, d)
              }, [
                createElementVNode("span", null, toDisplayString$1(s.label), 1),
                createElementVNode("span", _hoisted_6$f, [
                  createElementVNode("i", {
                    class: "ri-add-line alc-cpt-node-add",
                    title: "添加节点",
                    onClick: withModifiers((p) => t.appendNode(c), ["stop"])
                  }, null, 8, _hoisted_7$d),
                  createVNode(t.ElPopconfirm, {
                    title: "确定删除节点？",
                    onConfirm: (p) => t.removeNode(c)
                  }, {
                    reference: withCtx(() => [
                      createElementVNode("i", {
                        class: "ri-close-line alc-cpt-node-remove",
                        title: "删除节点",
                        onClick: o[1] || (o[1] = withModifiers(() => {
                        }, ["prevent"]))
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"])
                ])
              ], 40, _hoisted_5$g)
            ]),
            key: "0"
          } : void 0
        ]), 1040, ["data", "props", "node-key", "show-checkbox", "highlight-current"])
      ]),
      _: 1
    }, 512),
    (l = n.menuList) != null && l.length ? (openBlock(), createBlock(t.AlcContextMenu, {
      key: 1,
      ref: "contextMenuHandle",
      "menu-list": n.menuList,
      onItemClick: t.onContextMenuItemClick
    }, null, 8, ["menu-list"])) : createCommentVNode("", !0)
  ], 6);
}
const Tree = /* @__PURE__ */ _export_sfc(_sfc_main$J, [["render", _sfc_render$J], ["__file", "tree.vue"]]), AlcTree = withInstall(Tree), _sfc_main$I = /* @__PURE__ */ defineComponent({
  name: "alc-refer-choose",
  __name: "refer-choose",
  props: {
    // 数据绑定值 参照当前的选择数据
    modelValue: { type: [Object, Array] },
    // 布局信息
    referLayout: {
      type: Object,
      required: !0
    },
    // 绑定给查询组件的配置
    queryOption: { type: Object },
    // 是否多选 默认：false
    multiple: { type: Boolean, default: !1 },
    // 纵向填充是否启用  默认：false
    portraitFill: { type: Boolean, default: !1 },
    // 树 - 数据属性配置
    treeOption: {
      type: Object,
      default() {
        return {};
      }
    },
    // 列表 - 数据属性配置
    listOption: {
      type: Object,
      default() {
        return {};
      }
    },
    // 弹窗标题
    title: { type: String }
  },
  emits: ["referOk"],
  setup(e, { expose: o, emit: n }) {
    const t = e, r = n, a = ref(), l = ref(), s = ref(), c = ref(""), d = computed(() => isEmptyObject(t.referLayout) ? [] : t.referLayout.cSaveField.split(",").filter(Boolean).concat(t.referLayout.cShowField)), { listRef: p, queryOk: f } = useQueryList(), g = shallowRef([]), b = shallowRef({}), k = shallowReactive(/* @__PURE__ */ new Map());
    onDialogOpen(() => {
      var te, oe;
      t.multiple ? (oe = (te = t.modelValue) == null ? void 0 : te.forEach) == null || oe.call(te, (ne) => {
        ne[t.referLayout.cReferDataKey] && k.set(ne[t.referLayout.cReferDataKey], ne);
      }) : b.value = isEmptyObject(t.modelValue) || !t.modelValue[t.referLayout.cReferDataKey] ? {} : { ...t.modelValue };
    });
    function x(te) {
      t.multiple || (b.value = te.treeData);
    }
    function N() {
      const oe = l.value.getInstance().getCheckedNodes(t.treeOption.onlyLeaf, !0);
      k.clear(), oe.forEach((ne) => {
        k.set(
          ne.treeData[t.referLayout.cReferDataKey],
          ne.treeData
        );
      });
    }
    function O() {
      const te = l.value.getInstance();
      if (t.multiple) {
        if (te.setCheckedKeys([]), k.size === 0)
          return;
        [...k.keys()].forEach((oe) => {
          te.setChecked(oe, !0, !1);
        });
      } else {
        if (isEmptyObject(b.value)) {
          l.value.searchText = "", te.setCurrentKey(null), te.filter();
          return;
        }
        te.setCurrentKey(
          b.value[t.referLayout.cReferDataKey]
        );
      }
    }
    function m() {
      t.referLayout.cReferType === "tree-list" && E();
    }
    function ee(te) {
      t.multiple || (b.value = te);
    }
    function z(te) {
      t.multiple ? (k.set(te[t.referLayout.cReferDataKey], te), V()) : (b.value = te, H());
    }
    function P(te, oe) {
      var ne;
      if (oe) {
        const ie = oe[t.referLayout.cReferDataKey];
        k.has(ie) ? k.delete(ie) : k.set(ie, oe);
      } else
        !(isArray(te) && te.length === 0) ? te.forEach((se) => {
          k.set(se[t.referLayout.cReferDataKey], se);
        }) : (ne = p.value) == null || ne.listValue.forEach((se) => {
          k.delete(se[t.referLayout.cReferDataKey]);
        });
    }
    function V(te = ((oe) => (oe = p.value) == null ? void 0 : oe.listValue)() || []) {
      const ne = t.referLayout.cReferDataKey, ie = p.value.getInstance();
      if (t.multiple)
        ie.clearSelection(), te.forEach((se) => {
          k.has(se[ne]) && ie.toggleRowSelection(se, !0);
        });
      else {
        const se = te.find((pe) => pe[ne] === b.value[ne]);
        se && ie.setCurrentRow(se);
      }
    }
    function U(te) {
      k.delete(te), t.referLayout.cReferType === "tree" ? O() : t.referLayout.cReferType.includes("list") && V();
    }
    function E() {
      if (a.value !== null && (g.value = a.value.getQueryCondition()), t.referLayout.cReferType === "tree-list" && s.value !== null) {
        const te = s.value.getInstance().getCurrentNode();
        te ? c.value = C([te]) : c.value = "";
      }
      f({});
    }
    function C(te) {
      return te.reduce((oe, ne) => (oe.push(ne.treeData[t.referLayout.cTreeJoinField]), isArray(ne.children) && ne.children.length && oe.push(C(ne.children)), oe), []).join(",");
    }
    function I() {
      const { cShowField: te, cSaveField: oe } = t.referLayout;
      return objPick(
        b.value,
        oe.split(",").concat(te)
      );
    }
    function v() {
      const { cShowField: te, cSaveField: oe } = t.referLayout;
      return [...k.values()].map((ne) => objPick(ne, oe.split(",").concat(te)));
    }
    function M() {
      g.value = [], a.value !== null && a.value.clearQuery(), t.referLayout.cReferType === "tree-list" && (c.value = "", s.value !== null && s.value.getInstance().setCurrentKey(null)), f({});
    }
    function $() {
      b.value = {}, k.clear(), t.referLayout.cReferType === "tree" ? O() : t.referLayout.cReferType.includes("list") && V(), r("referOk", {
        referValue: t.multiple ? [] : {},
        isPortraitFill: t.portraitFill
      });
    }
    function H() {
      r("referOk", {
        referValue: t.multiple ? v() : I(),
        isPortraitFill: t.portraitFill
      });
    }
    o({
      queryHandle: a,
      singleTreeHandle: l,
      groupTreeHandle: s,
      listHandle: p,
      queryCondition: g,
      multipleChooseData: k,
      searchListData: E,
      onSingleTreeNodeClick: x,
      onSingleTreeSelectChange: N,
      setSingleTreeNodeSelect: O,
      onGroupTreeSelectChange: m,
      onMultipleListItemRemove: U,
      onRowClick: ee,
      onRowDblclick: z,
      onCheckSelectChange: P,
      onClearCondition: M,
      onClearRefer: $,
      onConfirmRefer: H
    });
    const X = { props: t, emits: r, queryHandle: a, singleTreeHandle: l, groupTreeHandle: s, treeFilterValue: c, extraColumn: d, listHandle: p, queryOk: f, queryCondition: g, singleChooseData: b, multipleChooseData: k, onSingleTreeNodeClick: x, onSingleTreeSelectChange: N, setSingleTreeNodeSelect: O, onGroupTreeSelectChange: m, onRowClick: ee, onRowDblclick: z, onCheckSelectChange: P, setListSelectState: V, onMultipleListItemRemove: U, searchListData: E, getTreeFilterValue: C, getSingleChooseData: I, getMultipleChooseData: v, onClearCondition: M, onClearRefer: $, onConfirmRefer: H, get AlcDialogFooter() {
      return AlcDialogFooter;
    }, get AlcList() {
      return AlcList;
    }, get AlcQuery() {
      return AlcQuery;
    }, get AlcSplitView() {
      return AlcSplitView;
    }, get AlcTooltip() {
      return AlcTooltip;
    }, get AlcTree() {
      return AlcTree;
    }, get ElButton() {
      return ElButton;
    }, get ElCheckbox() {
      return ElCheckbox;
    }, get ElScrollbar() {
      return ElScrollbar;
    } };
    return Object.defineProperty(X, "__isScriptSetup", { enumerable: !1, value: !0 }), X;
  }
}), _hoisted_1$y = { class: "h100 w100 flex auto-width--wrap" }, _hoisted_2$s = { class: "h100 alc-component-refer-choose-container auto-width--target auto-height--wrap" }, _hoisted_3$n = {
  key: 0,
  class: "auto-height--wrap cpt-refer-choose-multiple"
}, _hoisted_4$h = { class: "flex cpt-refer-choose-multiple-title-container" }, _hoisted_5$f = { class: "cpt-refer-choose-multiple-list-item-title single-line-overflow" }, _hoisted_6$e = ["onClick"];
function _sfc_render$I(e, o, n, t, r, a) {
  return openBlock(), createElementBlock("div", _hoisted_1$y, [
    createElementVNode("div", _hoisted_2$s, [
      n.referLayout.cBaseQueryCode && n.referLayout.cReferType !== "tree" ? (openBlock(), createBlock(t.AlcQuery, {
        key: 0,
        ref: "queryHandle",
        code: n.referLayout.cBaseQueryCode,
        "no-refer": !0,
        "extra-bind": n.queryOption,
        onQueryOk: t.searchListData,
        onQueryClear: t.searchListData
      }, null, 8, ["code", "extra-bind"])) : createCommentVNode("", !0),
      n.referLayout.cReferType === "tree" ? (openBlock(), createBlock(t.AlcTree, {
        key: 1,
        ref: "singleTreeHandle",
        label: n.referLayout.cBaseTreeTitle,
        code: n.referLayout.cBaseTreeCode,
        search: !0,
        multiple: !!n.multiple,
        "check-strictly": n.treeOption.checkStrictly && n.multiple,
        manual: n.treeOption.manual,
        where: n.treeOption.where,
        "node-config": n.treeOption.nodeConfig,
        query: n.treeOption.query,
        "show-code": n.treeOption.showCode,
        "data-scope": n.referLayout.cTreeDataScopeType,
        style: { padding: "0 16px" },
        onNodeLoaded: t.setSingleTreeNodeSelect,
        onNodeClick: t.onSingleTreeNodeClick,
        onCheck: t.onSingleTreeSelectChange,
        onCheckAll: t.onSingleTreeSelectChange
      }, null, 8, ["label", "code", "multiple", "check-strictly", "manual", "where", "node-config", "query", "show-code", "data-scope"])) : (openBlock(), createBlock(t.AlcSplitView, {
        key: 2,
        "first-init": n.referLayout.cReferType === "tree-list" ? "240px" : "0px",
        horizontal: "",
        class: "auto-height--target"
      }, createSlots({ _: 2 }, [
        n.referLayout.cReferType === "tree-list" ? {
          name: "first",
          fn: withCtx(() => [
            createVNode(t.AlcTree, {
              ref: "groupTreeHandle",
              label: n.referLayout.cBaseTreeTitle,
              code: n.referLayout.cBaseTreeCode,
              search: !0,
              where: n.treeOption.where,
              query: n.treeOption.query,
              "show-code": n.treeOption.showCode,
              "data-scope": n.referLayout.cTreeDataScopeType,
              style: { padding: "0 16px" },
              onNodeClick: t.onGroupTreeSelectChange
            }, null, 8, ["label", "code", "where", "query", "show-code", "data-scope"])
          ]),
          key: "0"
        } : void 0,
        n.referLayout.cReferType.includes("list") ? {
          name: "last",
          fn: withCtx(() => [
            createVNode(t.AlcList, {
              ref: "listHandle",
              code: n.referLayout.cBaseListCode,
              "show-title": !1,
              multiple: n.multiple,
              query: [
                ...t.queryCondition,
                ...n.listOption.query || []
              ],
              "init-fetch": !n.referLayout.cBaseQueryCode,
              where: n.listOption.where,
              "filter-name": n.referLayout.cListJoinField,
              "filter-value": t.treeFilterValue,
              "extra-column": t.extraColumn,
              "data-scope": n.referLayout.cListDataScopeType,
              onDataLoaded: t.setListSelectState,
              onRowClick: t.onRowClick,
              onRowDblclick: t.onRowDblclick,
              onSelect: t.onCheckSelectChange,
              onSelectAll: t.onCheckSelectChange
            }, null, 8, ["code", "multiple", "query", "init-fetch", "where", "filter-name", "filter-value", "extra-column", "data-scope"])
          ]),
          key: "1"
        } : void 0
      ]), 1032, ["first-init"]))
    ]),
    n.multiple ? (openBlock(), createElementBlock("div", _hoisted_3$n, [
      createElementVNode("div", _hoisted_4$h, [
        createElementVNode("span", null, "已选： " + toDisplayString$1(t.multipleChooseData.size) + " 项", 1),
        n.portraitFill ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          createVNode(t.ElCheckbox, {
            "model-value": n.portraitFill,
            disabled: "",
            style: { width: "80px" }
          }, {
            default: withCtx(() => [
              createTextVNode(" 纵向填充 ")
            ]),
            _: 1
          }, 8, ["model-value"]),
          createVNode(t.AlcTooltip, {
            content: "选择的每个参照项将在表格中生成一条独立的记录",
            tabindex: null
          })
        ], 64)) : createCommentVNode("", !0)
      ]),
      createVNode(t.ElScrollbar, { class: "auto-height--target cpt-refer-choose-multiple-list-container" }, {
        default: withCtx(() => [
          (openBlock(!0), createElementBlock(Fragment, null, renderList(t.multipleChooseData.values(), (l, s) => (openBlock(), createElementBlock("div", {
            key: s,
            class: "flex cpt-refer-choose-multiple-list-item"
          }, [
            createElementVNode("div", _hoisted_5$f, toDisplayString$1(l[n.referLayout.cShowField]), 1),
            createElementVNode("i", {
              class: "ri-close-line cpt-refer-choose-multiple-list-item-remove",
              title: "删除选择项",
              onClick: (c) => t.onMultipleListItemRemove(
                l[n.referLayout.cReferDataKey]
              )
            }, null, 8, _hoisted_6$e)
          ]))), 128))
        ]),
        _: 1
      })
    ])) : createCommentVNode("", !0),
    createVNode(t.AlcDialogFooter, null, {
      default: withCtx(() => [
        n.referLayout.cReferType === "tree-list" ? (openBlock(), createBlock(t.ElButton, {
          key: 0,
          title: "清除分类及条件，查看全部数据",
          onClick: o[0] || (o[0] = (l) => t.onClearCondition())
        }, {
          default: withCtx(() => [
            createTextVNode(" 全部 ")
          ]),
          _: 1
        })) : createCommentVNode("", !0),
        createVNode(t.ElButton, {
          title: "清除参照选择结果",
          onClick: t.onClearRefer
        }, {
          default: withCtx(() => [
            createTextVNode(" 清空 ")
          ]),
          _: 1
        }),
        createVNode(t.ElButton, {
          type: "primary",
          onClick: t.onConfirmRefer
        }, {
          default: withCtx(() => [
            createTextVNode(" 确定 ")
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]);
}
const AlcReferChoose = /* @__PURE__ */ _export_sfc(_sfc_main$I, [["render", _sfc_render$I], ["__file", "refer-choose.vue"]]), useData$1 = (e) => {
  const { emit: o } = getCurrentInstance(), n = useProp("modelValue"), t = useProp("portraitFill"), r = useProp("multiple"), a = computed({
    get() {
      var s;
      if (isPlainObject(n.value)) {
        if (t.value)
          return [n.value];
        if (r.value) {
          const { cShowField: c, cSaveField: d } = e.value, p = (s = n.value[c]) == null ? void 0 : s.split(
            ","
          ).length;
          if (p > 1) {
            const f = d.split(",").concat(c);
            return Array.from({ length: p }, (g, b) => f.reduce(
              (k, x) => (n.value[x] && (k[x] = n.value[x].split(",")[b]), k),
              {}
            ));
          }
        }
      }
      return n.value || (r.value ? [] : {});
    },
    set(s) {
      o("update:modelValue", s);
    }
  });
  function l(s) {
    const { cShowField: c, cSaveField: d } = e.value;
    if (isBlank(c) || isBlank(d)) {
      a.value = r.value ? [] : {};
      return;
    }
    function p(f) {
      return { ...f };
    }
    isPlainObject(s) ? isEmptyObject(s) ? isEmptyObject(a.value) || (a.value = {}) : a.value = p(s) : isArray(s) && (s.length ? a.value = s.map(p) : a.value.length && (a.value = []));
  }
  return {
    referValue: a,
    setReferValue: l
  };
}, useLayout = () => {
  const { props: e } = getCurrentInstance(), o = ref(!0), n = shallowRef(
    {}
  );
  function t() {
    return apiGetReferArchive(e.code).then((r) => {
      if (r.code === 1 && r.data)
        return n.value = r.data, !0;
      n.value = {};
    }).catch(() => {
      n.value = {}, apiLinkErrorTip("参照配置获取");
    }).finally(() => {
      o.value = !1;
    });
  }
  return t(), {
    layoutLoading: o,
    referLayout: n,
    loadLayout: t
  };
}, _sfc_main$H = /* @__PURE__ */ defineComponent({
  name: "alc-refer",
  __name: "refer",
  props: alcReferProps,
  emits: ["clear", "change", "openedChoose", "focus", "blur", "update:modelValue"],
  setup(e, { expose: o, emit: n }) {
    const t = e, r = n, { referLayout: a, layoutLoading: l, loadLayout: s } = useLayout(), { referValue: c, setReferValue: d } = useData$1(a), p = useFormDisabled(), { formItem: f } = useFormItem();
    function g() {
      var C;
      t.validateEvent && ((C = f == null ? void 0 : f.validate) == null || C.call(f, "change"));
    }
    const b = ref(), k = ref(!1), x = computed(() => t.portraitFill === !0 && t.multiple), N = computed(() => t.multiple === !0 && !t.portraitFill);
    function O() {
      c.value.length === 0 && r("clear", {
        saveField: a.value.cSaveField,
        showField: a.value.cShowField
      }), r("change", {
        referValue: c.value,
        isPortraitFill: x.value,
        saveField: a.value.cSaveField,
        showField: a.value.cShowField,
        referDataKey: a.value.cReferDataKey
      }), g();
    }
    function m() {
      k.value = !1, d(t.multiple ? [] : {}), r("clear", {
        saveField: a.value.cSaveField,
        showField: a.value.cShowField
      }), g();
    }
    function ee(C) {
      if ((isPlainObject(C.referValue) && isEmptyObject(C.referValue) || isArray(C.referValue) && C.referValue.length === 0) && m(), !isEqual(c.value, C.referValue)) {
        const I = t.multiple && x.value ? C.referValue[0] ? [C.referValue[0]] : [] : C.referValue;
        d(I), r(
          "change",
          Object.assign({}, C, {
            saveField: a.value.cSaveField,
            showField: a.value.cShowField,
            referDataKey: a.value.cReferDataKey
          })
        ), g();
      }
      z.value = !1;
    }
    const z = ref(!1), P = computed(() => {
      if (t.multiple)
        switch (a.value.cReferType) {
          case "list":
            return "lg";
          case "tree-list":
            return "lg";
          case "tree":
            return "sm";
          default:
            return "md";
        }
      else
        switch (a.value.cReferType) {
          case "list":
            return "md";
          case "tree-list":
            return "md";
          case "tree":
            return "xs";
          default:
            return "sm";
        }
    }), V = ref();
    function U() {
      return s().then((C) => {
        C ? (z.value = !0, nextTick(() => {
          r("openedChoose", {
            instance: V.value
          });
        })) : operatorErrorTip("参照不存在或已删除");
      });
    }
    o({
      referChooseHandle: V,
      async focus() {
        await b.value.focus(), await U();
      },
      openReferChooseModal: U,
      clearReferValue: m
    });
    const E = { props: t, emits: r, referLayout: a, layoutLoading: l, loadLayout: s, referValue: c, setReferValue: d, isDisabled: p, formItem: f, formItemValid: g, instanceRef: b, canShowClearIcon: k, isPortraitFill: x, isRenderOfMultiple: N, onClearItem: O, clearReferValue: m, onReferChooseOk: ee, referChooseDialogVisible: z, widthType: P, referChooseHandle: V, openReferChooseModal: U, get AlcDialog() {
      return AlcDialog;
    }, get AlcInputTags() {
      return AlcInputTags;
    }, get isEmptyObject() {
      return isEmptyObject;
    }, AlcReferChoose, get vLoadOn() {
      return loadOn;
    } };
    return Object.defineProperty(E, "__isScriptSetup", { enumerable: !1, value: !0 }), E;
  }
}), _hoisted_1$x = {
  class: "ri-search-line",
  style: { height: "calc(var(--el-input-height) - 2px)" },
  title: "参照选择"
};
function _sfc_render$H(e, o, n, t, r, a) {
  return openBlock(), createBlock(t.AlcInputTags, {
    ref: "instanceRef",
    modelValue: t.referValue,
    "onUpdate:modelValue": o[2] || (o[2] = (l) => t.referValue = l),
    props: {
      label: t.referLayout.cShowField
    },
    disabled: t.isDisabled,
    placeholder: e.readonly ? "" : e.placeholder,
    multiple: t.isRenderOfMultiple,
    readonly: e.readonly,
    clearable: e.clearable,
    "collapse-tags": e.collapseTags,
    "collapse-show-one": e.collapseShowOne,
    class: normalizeClass([e.$attrs.class, "alc-component-refer"]),
    style: normalizeStyle([
      e.$attrs.style,
      { cursor: t.isDisabled ? "not-allowed" : "pointer" }
    ]),
    onMouseenter: o[3] || (o[3] = (l) => t.canShowClearIcon = e.clearable && (!!t.referValue.length || !t.isEmptyObject(t.referValue))),
    onMouseleave: o[4] || (o[4] = (l) => t.canShowClearIcon = !1),
    onClear: t.onClearItem,
    onFocus: o[5] || (o[5] = (l) => e.$emit("focus", l)),
    onBlur: o[6] || (o[6] = (l) => e.$emit("blur", l)),
    onClick: o[7] || (o[7] = (l) => e.readonly || t.isDisabled || t.openReferChooseModal())
  }, {
    suffix: withCtx(() => [
      t.canShowClearIcon ? (openBlock(), createElementBlock("i", {
        key: 0,
        class: "ri-close-circle-line",
        onClick: o[0] || (o[0] = withModifiers((l) => t.canShowClearIcon && t.clearReferValue(), ["stop"]))
      })) : createCommentVNode("", !0),
      createVNode(t.AlcDialog, {
        modelValue: t.referChooseDialogVisible,
        "onUpdate:modelValue": o[1] || (o[1] = (l) => t.referChooseDialogVisible = l),
        title: e.dialogTitle || t.referLayout.cReferName,
        "width-type": t.widthType,
        "close-on-click-modal": "",
        "close-on-press-escape": "",
        "content-height-fit": "",
        class: "refer-choose-dialog"
      }, {
        reference: withCtx(() => [
          withDirectives(createElementVNode("i", _hoisted_1$x, null, 512), [
            [vShow, !t.canShowClearIcon],
            [
              t.vLoadOn,
              t.layoutLoading,
              void 0,
              { small: !0 }
            ]
          ])
        ]),
        default: withCtx(() => [
          createVNode(t.AlcReferChoose, {
            ref: "referChooseHandle",
            "query-option": e.queryOption,
            "refer-layout": t.referLayout,
            "model-value": t.referValue,
            multiple: e.multiple,
            "portrait-fill": t.isPortraitFill,
            "tree-option": e.treeOption,
            "list-option": e.listOption,
            onReferOk: t.onReferChooseOk
          }, null, 8, ["query-option", "refer-layout", "model-value", "multiple", "portrait-fill", "tree-option", "list-option"])
        ]),
        _: 1
      }, 8, ["modelValue", "title", "width-type"])
    ]),
    _: 1
  }, 8, ["modelValue", "props", "disabled", "placeholder", "multiple", "readonly", "clearable", "collapse-tags", "collapse-show-one", "class", "style"]);
}
const Refer = /* @__PURE__ */ _export_sfc(_sfc_main$H, [["render", _sfc_render$H], ["__file", "refer.vue"]]), AlcRefer = withInstall(Refer), _sfc_main$G = /* @__PURE__ */ defineComponent({
  name: "alc-virtual-grid",
  inheritAttrs: !1,
  __name: "virtual-grid",
  props: {
    data: { default: () => [] },
    rows: {},
    columns: {},
    rowHeight: {},
    gap: { default: 0 },
    tag: { default: "div" },
    tagProp: {},
    viewStyle: {}
  },
  setup(e, { expose: o }) {
    const n = e, t = ref(n.rows);
    watch(
      () => n.rows,
      (N) => {
        t.value = N;
      }
    );
    const r = shallowRef([]), a = ref(0), l = t.value * n.columns, s = n.rowHeight + n.gap, c = ref(), d = ref(), p = computed(() => Object.assign({}, n.viewStyle, {
      position: "relative",
      height: `${t.value * n.rowHeight + (t.value - 1) * n.gap}px`,
      marginTop: `${n.gap}px`
    })), f = reactive({
      zIndex: -1
    }), g = computed(() => ({
      position: "absolute",
      inset: "0",
      display: "grid",
      gridTemplateRows: `repeat(${t.value}, ${n.rowHeight}px)`,
      gridTemplateColumns: `repeat(${n.columns}, 1fr)`,
      gap: `${n.gap}px`
    }));
    watch(
      () => n.data,
      (N) => {
        var m;
        const O = Math.ceil(N.length / n.columns) || t.value;
        f.height = `${O * n.rowHeight + (O - 1) * n.gap}px`, k(), (m = c.value) == null || m.setScrollTop(0);
      },
      { immediate: !0 }
    );
    function b({ scrollTop: N }) {
      k(N);
    }
    function k(N = 0) {
      const O = Math.ceil(N / s) * n.columns, m = O + l;
      if (O === 0 && m > n.data.length) {
        r.value = n.data, t.value = Math.ceil(r.value.length / n.columns);
        return;
      }
      r.value = n.data.slice(O, m), a.value = O, d.value && (d.value.style.webkitTransform = `translate3d(0, ${N / s * s}px, 0)`), t.value = Math.ceil(r.value.length / n.columns);
    }
    o(
      getInstanceMethod(c, [
        "handleScroll",
        "scrollTo",
        "setScrollTop",
        "setScrollLeft",
        "update"
      ])
    );
    const x = { props: n, rows$: t, sliceSet: r, startIndex: a, visibleElNum: l, itemHeight: s, scrollbarRef: c, contentRef: d, parentStyle: p, fillHeightStyle: f, gridStyle: g, onScroll: b, setSliceSet: k, get ElScrollbar() {
      return ElScrollbar;
    } };
    return Object.defineProperty(x, "__isScriptSetup", { enumerable: !1, value: !0 }), x;
  }
});
function _sfc_render$G(e, o, n, t, r, a) {
  return openBlock(), createBlock(t.ElScrollbar, mergeProps({ ref: "scrollbarRef" }, e.$attrs, {
    "view-style": t.parentStyle,
    onScroll: t.onScroll
  }), {
    default: withCtx(() => [
      createElementVNode("div", {
        style: normalizeStyle(t.fillHeightStyle)
      }, null, 4),
      (openBlock(), createBlock(resolveDynamicComponent(n.tag), mergeProps({ ref: "contentRef" }, n.tagProp, { style: t.gridStyle }), {
        default: withCtx(() => [
          (openBlock(!0), createElementBlock(Fragment, null, renderList(t.sliceSet, (l, s) => renderSlot(e.$slots, "default", mergeProps({
            key: l,
            ref_for: !0
          }, { element: l, index: t.startIndex + s, vIndex: s }))), 128))
        ]),
        _: 3
      }, 16, ["style"]))
    ]),
    _: 3
  }, 16, ["view-style"]);
}
const VirtualGrid = /* @__PURE__ */ _export_sfc(_sfc_main$G, [["render", _sfc_render$G], ["__file", "virtual-grid.vue"]]), AlcVirtualGrid = withInstall(VirtualGrid), alcSelectProps = {
  /**
   * 数据绑定值
   * @description 多选模式下，用","隔开的多个值
   * @default ''
   */
  modelValue: { type: [String, Number], default: "" },
  /**
   * 数据对应的 label 绑定值
   * @description 该选项不会影响 option 的选中，主要是为了便捷获取选中项的 label
   * @default '''
   */
  labelValue: { type: String, default: "" },
  /**
   * 下拉枚举 code
   * @default ''
   */
  code: { type: String, default: "" },
  /**
   * 下拉枚举项数据集合（前台枚举项赋值）
   * @default undefined
   */
  options: {
    type: Array,
    default: void 0
  },
  /**
   * 是否禁用
   * @default false
   */
  disabled: { type: Boolean, default: !1 },
  /**
   * 是否只读
   * @default false
   */
  readonly: { type: Boolean, default: !1 },
  /**
   * 是否多选
   * @default false
   */
  multiple: { type: Boolean, default: !1 },
  /**
   * 是否显示清除按钮
   * @default false
   */
  clearable: { type: Boolean, default: !0 },
  /**
   * 枚举项目过滤
   * @default false
   */
  filter: { type: String, default: "" },
  /**
   * 是否支持筛选，文本匹配
   * @default false
   */
  filterable: { type: Boolean, default: !1 },
  /**
   * 自定义筛选方法
   *@default: undefined
   */
  filterMethod: {
    type: Function
  },
  /**
   * 显示刷新按钮
   * @default false
   */
  refresh: {
    type: [Boolean, Function],
    default: !1
  },
  /**
   * 是否保持初始化状态（总是重新请求枚举数据）
   * @default false
   */
  init: { type: Boolean, default: !1 },
  /**
   * 占位符
   * @default '请选择'
   */
  placeholder: { type: String, default: "请选择" },
  /**
   * 是否使用方案配置的默认值
   * @default false
   */
  useDefault: { type: Boolean, default: !1 },
  /**
   * 收起 tag 展示
   * @default false
   */
  collapseTags: { type: Boolean, default: !1 },
  /**
   * 当多选隐藏于折叠标签中时，是否在外部保留一项
   * @default false
   */
  collapseShowOne: { type: Boolean, default: !0 },
  /**
   * 是否 change 时触发校验
   * @default false
   */
  validateEvent: { type: Boolean, default: !1 },
  /**
   * 是否渲染为虚拟列表
   * @default false
   */
  virtualized: { type: Boolean, default: !1 }
}, useAccessibility$1 = (e, o, n, t) => {
  const r = ref(-1), a = ref(), l = 34, s = 5;
  watch(e, (d) => {
    d ? document.addEventListener("keydown", c, {
      passive: !1
    }) : document.removeEventListener("keydown", c);
  }), onUnmounted(() => {
    document.removeEventListener("keydown", c);
  });
  function c(d) {
    d.code === "ArrowUp" || d.code === "ArrowDown" ? (d.stopPropagation(), d.preventDefault(), d.code === "ArrowUp" ? r.value > 0 ? r.value-- : r.value = o.value.length - 1 : d.code === "ArrowDown" && (r.value < o.value.length - 1 ? r.value++ : r.value = 0), n.value ? r.value % s === 0 && (a.value.setScrollTop(
      r.value * l
    ), a.value.handleScroll()) : a.value.$el.querySelector(
      `li:nth-child(${r.value + 1})`
    ).scrollIntoView({ behavior: "smooth" })) : d.code === "Enter" && (d.stopPropagation(), d.preventDefault(), ~r.value && t(o.value[r.value]));
  }
  return {
    optionsWrapRef: a,
    virtualRowHeight: l,
    virtualRows: s,
    hoverItemIndex: r
  };
}, useOptions = (e, o, n) => {
  const t = ref(""), r = "-null-", a = computed(() => isBlank(o.code) ? isArray(o.options) ? o.options : [] : e.value.length ? e.value : []), l = computed(() => {
    const c = isBlank(o.filter) ? void 0 : o.filter.split(n);
    return c ? a.value.filter((d) => !c.includes(d.value)) : a.value;
  }), s = computed(() => {
    let c = l.value;
    return o.filterable && (c = l.value.filter((d) => typeof o.filterMethod == "function" ? o.filterMethod(t.value, d) : d.label.includes(t.value))), c.length ? c : [
      {
        label: "无可选项",
        value: r,
        disabled: !0
      }
    ];
  });
  return {
    filterStr: t,
    availableEnumOptions: l,
    showEnumOptions: s
  };
}, usePlacement = (e) => {
  const o = ref("bottom"), n = ref();
  return watch(e, (t) => {
    t && nextTick(() => {
      const r = n.value.popperRef.contentRef.querySelector(
        ".el-scrollbar__view"
      );
      if (r) {
        const a = Number.parseInt(
          window.getComputedStyle(r).height
        ), { top: l } = n.value.popperRef.contentRef.getBoundingClientRect();
        l + a > window.innerHeight ? o.value = "top" : o.value = "bottom";
      }
    });
  }), {
    placement: o,
    popoverHandle: n
  };
}, usePopoverWidth = () => {
  const e = ref(), o = ref(150), n = new ResizeObserver((t) => {
    o.value = t[0].contentRect.width;
  });
  return onPageVisit(() => {
    n.observe(e.value.$el);
  }), onPageLeave(() => {
    n.disconnect();
  }), {
    popoverWidth: o,
    selectHandle: e
  };
}, separator = ",", _sfc_main$F = /* @__PURE__ */ defineComponent({
  name: "alc-select",
  inheritAttrs: !1,
  __name: "select",
  props: alcSelectProps,
  emits: ["update:modelValue", "update:labelValue", "change", "refresh", "clear", "removeTag", "visibleChange"],
  setup(e, { expose: o, emit: n }) {
    const t = e, r = n, a = useFormDisabled(), l = ref(!1), { isFetch: s, options: c, getEnumOptions: d } = useEnumOptions(
      t.code,
      t.init
    ), { filterStr: p, showEnumOptions: f, availableEnumOptions: g } = useOptions(
      c,
      t,
      separator
    ), b = ref([]), k = computed(() => t.multiple ? {
      modelValue: b.value,
      "onUpdate:modelValue": function(ne) {
        b.value = ne, X();
      }
    } : {
      modelValue: b.value[0],
      "onUpdate:modelValue": function(ne) {
        b.value[0] = ne, X();
      }
    }), x = computed(() => l.value ? ["ri-arrow-down-s-line", "is-dropdown"] : ["ri-arrow-down-s-line"]), { popoverWidth: N, selectHandle: O } = usePopoverWidth(), { placement: m, popoverHandle: ee } = usePlacement(l), { optionsWrapRef: z, virtualRowHeight: P, virtualRows: V, hoverItemIndex: U } = useAccessibility$1(
      l,
      f,
      toRef(t, "virtualized"),
      $
    ), { formItem: E } = useFormItem(), C = ref(!1), I = ref(!1);
    watch(
      () => [t.modelValue, g.value],
      ([ne, ie]) => {
        if (ie.length)
          if (ne || ne === 0 || ne === "") {
            const se = new Set(String(ne).split(separator));
            b.value = ie.filter((pe) => se.has(pe.value));
          } else
            b.value = [];
        else
          b.value = [];
      },
      { immediate: !0 }
    );
    let v = !0;
    watch(
      g,
      (ne) => {
        if (ne.length && t.useDefault && v) {
          const ie = ne.find((se) => se.default);
          ie && (b.value = [ie], X()), v = null;
        }
      },
      { immediate: !0 }
    );
    function M() {
      l.value && (l.value = !1);
    }
    function $(ne) {
      if (t.multiple === !0) {
        const ie = b.value.findIndex((se) => se.value === ne.value);
        ~ie ? b.value.splice(ie, 1) : b.value.push(ne);
      } else {
        if (l.value = !1, t.modelValue === ne.value)
          return;
        b.value = [ne], nextTick(() => {
          var ie;
          (ie = O.value) == null || ie.blur();
        });
      }
      X();
    }
    function H() {
      b.value = [], X(), r("clear");
    }
    function X() {
      var ae;
      const ne = t.modelValue, { value: ie, name: se } = b.value.reduce(
        (le, fe) => (le.name.push((fe == null ? void 0 : fe.label) || ""), le.value.push((fe == null ? void 0 : fe.value) || ""), le),
        {
          name: [],
          value: []
        }
      ), pe = ie.join(separator), he = se.join(separator);
      ne === pe && !he || (r("update:modelValue", pe), r("update:labelValue", he), pe !== ne && (r("change", pe, he), t.validateEvent && ((ae = E == null ? void 0 : E.validate) == null || ae.call(E, "change"))));
    }
    function te() {
      if (isBlank(t.code) && typeof t.refresh != "function")
        return r("refresh");
      if (C.value)
        return;
      C.value = !0;
      function ne(ie = 1e3) {
        return new Promise((se) => {
          window.setTimeout(se, ie);
        });
      }
      Promise.all([
        typeof t.refresh == "function" ? t.refresh() : d(t.code, !0),
        ne()
      ]).finally(() => {
        C.value = !1;
      });
    }
    o({
      // 设置刷新 loading 状态
      setRefreshLoad(ne) {
        C.value = ne;
      },
      async focus() {
        await O.value.focus(), l.value = !0;
      },
      blur() {
        O.value.blur(), l.value = !1;
      }
    });
    const oe = { props: t, emits: r, isDisabled: a, popoverVisible: l, separator, isFetch: s, options: c, getEnumOptions: d, filterStr: p, showEnumOptions: f, availableEnumOptions: g, selectItem: b, modelBind: k, suffixIcon: x, popoverWidth: N, selectHandle: O, placement: m, popoverHandle: ee, optionsWrapRef: z, virtualRowHeight: P, virtualRows: V, hoverItemIndex: U, formItem: E, isShowDelayFetch: C, canShowClearIcon: I, get useDefaultOnce() {
      return v;
    }, set useDefaultOnce(ne) {
      v = ne;
    }, clickOutside: M, selectListItemClick: $, clearSelectValue: H, changeValue: X, refreshOptions: te, get AlcInputTags() {
      return AlcInputTags;
    }, get AlcVirtualGrid() {
      return AlcVirtualGrid;
    }, get ElPopover() {
      return ElPopover;
    }, get ElScrollbar() {
      return ElScrollbar;
    }, get vClickOutside() {
      return ClickOutside;
    } };
    return Object.defineProperty(oe, "__isScriptSetup", { enumerable: !1, value: !0 }), oe;
  }
}), _hoisted_1$w = ["title", "onMousemove", "onClick"], _hoisted_2$r = ["title", "onMousemove", "onClick"];
function _sfc_render$F(e, o, n, t, r, a) {
  return openBlock(), createBlock(t.ElPopover, {
    ref: "popoverHandle",
    visible: t.popoverVisible,
    disabled: e.readonly || t.isDisabled,
    placement: t.placement,
    "show-after": 80,
    width: t.popoverWidth,
    trigger: "click",
    "popper-class": "alc-component-select-options-container",
    transition: "el-zoom-in-top",
    onShow: o[5] || (o[5] = (l) => e.$emit("visibleChange", !0)),
    onHide: o[6] || (o[6] = (l) => e.$emit("visibleChange", !1))
  }, {
    reference: withCtx(() => [
      createVNode(t.AlcInputTags, mergeProps({ ref: "selectHandle" }, {
        ...e.$attrs,
        ...t.modelBind
      }, {
        writable: e.filterable,
        disabled: t.isDisabled,
        multiple: e.multiple,
        readonly: e.readonly,
        clearable: e.clearable,
        placeholder: e.readonly ? "" : e.placeholder,
        "collapse-tags": e.collapseTags,
        "collapse-show-one": e.collapseShowOne,
        class: [e.$attrs.class, "alc-cpt-select"],
        style: e.$attrs.style,
        onClear: o[0] || (o[0] = (...l) => e.$emit("removeTag", ...l)),
        onClick: o[1] || (o[1] = (l) => t.popoverVisible = !0),
        onInput: o[2] || (o[2] = (l) => t.filterStr = l),
        onMouseenter: o[3] || (o[3] = (l) => t.canShowClearIcon = e.clearable && !!t.selectItem.length),
        onMouseleave: o[4] || (o[4] = (l) => t.canShowClearIcon = !1)
      }), createSlots({ _: 2 }, [
        !e.readonly && !t.isDisabled ? {
          name: "suffix",
          fn: withCtx(() => [
            withDirectives(createElementVNode("i", {
              class: "ri-close-circle-line cursor-pointer",
              onClick: withModifiers(t.clearSelectValue, ["stop"])
            }, null, 512), [
              [vShow, t.canShowClearIcon]
            ]),
            withDirectives(createElementVNode("i", {
              class: normalizeClass([t.suffixIcon, "cursor-pointer"])
            }, null, 2), [
              [vShow, !t.canShowClearIcon]
            ]),
            e.refresh ? (openBlock(), createElementBlock("i", {
              key: 0,
              class: normalizeClass([{
                "refresh-rotate": t.isShowDelayFetch || t.isFetch
              }, "ri-refresh-line cursor-pointer"]),
              title: "刷新选项列表",
              onClick: withModifiers(t.refreshOptions, ["stop"])
            }, null, 2)) : createCommentVNode("", !0)
          ]),
          key: "0"
        } : void 0
      ]), 1040, ["writable", "disabled", "multiple", "readonly", "clearable", "placeholder", "collapse-tags", "collapse-show-one", "class", "style"])
    ]),
    default: withCtx(() => [
      e.virtualized ? withDirectives((openBlock(), createBlock(t.AlcVirtualGrid, {
        key: 0,
        ref: "optionsWrapRef",
        data: t.showEnumOptions,
        "row-height": t.virtualRowHeight,
        columns: 1,
        rows: t.virtualRows,
        class: "el-select-dropdown el-select-dropdown__wrap is-virtual",
        tag: "ul",
        "tag-prop": {
          class: "el-select-dropdown__list"
        }
      }, {
        default: withCtx(({ element: l, index: s }) => [
          createElementVNode("li", {
            class: normalizeClass([{
              selected: t.selectItem.includes(l),
              "is-disabled": l.disabled,
              "is-hover": t.hoverItemIndex === s
            }, "el-select-dropdown__item"]),
            title: l.label,
            onMousemove: (c) => t.hoverItemIndex = s,
            onClick: (c) => l.disabled || t.selectListItemClick(l)
          }, [
            createElementVNode("span", null, toDisplayString$1(l.label), 1)
          ], 42, _hoisted_1$w)
        ]),
        _: 1
      }, 8, ["data", "row-height", "rows"])), [
        [t.vClickOutside, t.clickOutside]
      ]) : (openBlock(), createElementBlock("div", {
        key: 1,
        ref: "optionsWrapRef",
        class: normalizeClass(["el-select-dropdown", { "is-multiple": e.multiple }])
      }, [
        withDirectives((openBlock(), createBlock(t.ElScrollbar, {
          "wrap-class": "el-select-dropdown__wrap",
          tag: "ul",
          "view-class": "el-select-dropdown__list"
        }, {
          default: withCtx(() => [
            (openBlock(!0), createElementBlock(Fragment, null, renderList(t.showEnumOptions, (l, s) => (openBlock(), createElementBlock("li", {
              key: s,
              class: normalizeClass([{
                "is-selected": t.selectItem.includes(l),
                "is-disabled": l.disabled,
                "is-hovering": t.hoverItemIndex === s
              }, "el-select-dropdown__item"]),
              title: l.label,
              onMousemove: (c) => t.hoverItemIndex = s,
              onClick: (c) => l.disabled || t.selectListItemClick(l)
            }, [
              createElementVNode("span", null, toDisplayString$1(l.label), 1)
            ], 42, _hoisted_2$r))), 128))
          ]),
          _: 1
        })), [
          [t.vClickOutside, t.clickOutside]
        ])
      ], 2))
    ]),
    _: 1
  }, 8, ["visible", "disabled", "placement", "width"]);
}
const Select = /* @__PURE__ */ _export_sfc(_sfc_main$F, [["render", _sfc_render$F], ["__file", "select.vue"]]), AlcSelect = withInstall(Select), alcIconLauncherProps = {
  /**
   * 使用内置过滤
   * @default true
   */
  filter: { type: Boolean, default: !0 },
  /**
   * 组件是否可唤起
   * @default false
   */
  disabled: { type: Boolean, default: !1 },
  /**
   * 触发方式
   * @default 'click'
   */
  trigger: {
    type: String,
    default: "click"
  }
}, columns = 4, rowHeight = 80, gap = 8, _sfc_main$E = /* @__PURE__ */ defineComponent({
  name: "alc-icon-launcher",
  __name: "icon-launcher",
  props: alcIconLauncherProps,
  emits: ["change"],
  setup(e, { expose: o, emit: n }) {
    const t = n, r = ref(!1), a = ref(!1), l = watch(a, (ee) => {
      ee && (l(), r.value = !0);
    }), s = ref(5), c = rowHeight * columns + gap * (columns - 1), d = shallowRef(
      getKeys(remixIconTags).flatMap((ee) => ee === "Editor" ? getKeys(remixIconTags[ee]).map((z) => `ri-${z}`) : getKeys(remixIconTags[ee]).map((z) => `ri-${z}-line`))
    ), p = ref(), f = ref(""), g = shallowRef([]), b = h("i", { class: "ri-search-2-line" });
    function k(ee = "") {
      g.value = d.value.filter((z) => z.slice(3).includes(ee)), s.value = Math.min(5, Math.ceil(g.value.length / columns));
    }
    function x(ee) {
      return ee.replace(/(^ri-|-line$)/g, "");
    }
    function N(ee) {
      t("change", ee), a.value = !1;
    }
    function O() {
      var ee;
      f.value = "", k(), (ee = p.value) == null || ee.focus();
    }
    o({
      search: k,
      show: () => {
        a.value = !0;
      },
      hide: () => {
        a.value = !1;
      }
    });
    const m = { emits: t, lazyLoad: r, popoverVisible: a, unwatch: l, rows: s, columns, rowHeight, gap, popWidth: c, iconSet: d, searchRef: p, searchText: f, searchSet: g, prefixIcon: b, search: k, getIconName: x, onSelectIcon: N, filterInputFocus: O, get AlcVirtualGrid() {
      return AlcVirtualGrid;
    }, get ElInput() {
      return ElInput;
    }, get ElPopover() {
      return ElPopover;
    } };
    return Object.defineProperty(m, "__isScriptSetup", { enumerable: !1, value: !0 }), m;
  }
}), _hoisted_1$v = { key: 0 }, _hoisted_2$q = ["onClick"], _hoisted_3$m = { class: "icon-name" };
function _sfc_render$E(e, o, n, t, r, a) {
  return openBlock(), createBlock(t.ElPopover, {
    visible: t.popoverVisible,
    "onUpdate:visible": o[1] || (o[1] = (l) => t.popoverVisible = l),
    width: t.popWidth,
    disabled: e.disabled,
    trigger: e.trigger,
    transition: "el-zoom-in-top",
    "popper-class": "alc-component-icon-launcher",
    onBeforeEnter: t.filterInputFocus
  }, createSlots({ _: 2 }, [
    e.$slots.default ? {
      name: "reference",
      fn: withCtx(() => [
        renderSlot(e.$slots, "default")
      ]),
      key: "0"
    } : void 0,
    t.lazyLoad ? {
      name: "default",
      fn: withCtx(() => [
        e.filter ? (openBlock(), createElementBlock("div", _hoisted_1$v, [
          createVNode(t.ElInput, {
            ref: "searchRef",
            modelValue: t.searchText,
            "onUpdate:modelValue": o[0] || (o[0] = (l) => t.searchText = l),
            "prefix-icon": t.prefixIcon,
            placeholder: "键入以搜索",
            onInput: t.search
          }, null, 8, ["modelValue", "prefix-icon"])
        ])) : createCommentVNode("", !0),
        createVNode(t.AlcVirtualGrid, {
          data: t.searchSet,
          rows: t.rows,
          columns: t.columns,
          "row-height": 80,
          gap: 8
        }, {
          default: withCtx(({ element: l }) => [
            createElementVNode("div", {
              class: "icon-container",
              onClick: (s) => t.onSelectIcon(l)
            }, [
              createElementVNode("i", {
                class: normalizeClass([l, "icon-icon"])
              }, null, 2),
              createElementVNode("p", _hoisted_3$m, toDisplayString$1(t.getIconName(l)), 1)
            ], 8, _hoisted_2$q)
          ]),
          _: 1
        }, 8, ["data", "rows"])
      ]),
      key: "1"
    } : void 0
  ]), 1032, ["visible", "disabled", "trigger"]);
}
const IconLauncher = /* @__PURE__ */ _export_sfc(_sfc_main$E, [["render", _sfc_render$E], ["__file", "icon-launcher.vue"]]), AlcIconLauncher = withInstall(IconLauncher), alcSelectIconProps = {
  /**
   * 只读
   */
  readonly: { type: Boolean, default: !1 },
  /**
   * 禁用
   * @default false
   */
  disabled: { type: Boolean, default: !1 },
  /**
   * 输入框占位符
   * @default '请选择'
   */
  placeholder: { type: String, default: "请选择" },
  /**
   * 可清空
   * @default false
   */
  clearable: { type: Boolean, default: !1 },
  /**
   * 原生属性
   */
  name: { type: String },
  /**
   * 输入时触发校验
   * @default false
   */
  validateEvent: { type: Boolean, default: !1 }
}, _sfc_main$D = /* @__PURE__ */ defineComponent({
  name: "alc-icon-select",
  inheritAttrs: !1,
  __name: "select-icon",
  props: /* @__PURE__ */ mergeModels(alcSelectIconProps, {
    modelValue: { default: "" },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ mergeModels(["change", "clear"], ["update:modelValue"]),
  setup(e, { expose: o, emit: n }) {
    const t = n, r = useModel(e, "modelValue"), a = ref();
    onMounted(() => {
      a.value.ref.setAttribute("readonly", "true");
    });
    const l = useFormDisabled();
    function s(p) {
      t("change", r.value, p), r.value = p;
    }
    function c() {
      r.value = "", t("clear");
    }
    o({
      instanceRef: a,
      ...getInstanceMethod(a, ["focus", "blur", "select"])
    });
    const d = { emits: t, iconText: r, instanceRef: a, isDisabled: l, onChange: s, onClear: c, get AlcIconLauncher() {
      return AlcIconLauncher;
    }, get ElInput() {
      return ElInput;
    } };
    return Object.defineProperty(d, "__isScriptSetup", { enumerable: !1, value: !0 }), d;
  }
});
function _sfc_render$D(e, o, n, t, r, a) {
  return openBlock(), createBlock(t.AlcIconLauncher, {
    disabled: t.isDisabled,
    onChange: t.onChange
  }, {
    default: withCtx(() => [
      createVNode(t.ElInput, mergeProps({ ref: "instanceRef" }, e.$attrs, {
        "model-value": t.iconText,
        "validate-event": e.validateEvent,
        placeholder: e.placeholder,
        clearable: e.clearable,
        readonly: e.readonly,
        class: "alc-component-icon-select",
        onClear: t.onClear
      }), {
        prepend: withCtx(() => [
          createElementVNode("i", {
            class: normalizeClass(t.iconText || "non-icon")
          }, null, 2)
        ]),
        _: 1
      }, 16, ["model-value", "validate-event", "placeholder", "clearable", "readonly"])
    ]),
    _: 1
  }, 8, ["disabled"]);
}
const SelectIcon = /* @__PURE__ */ _export_sfc(_sfc_main$D, [["render", _sfc_render$D], ["__file", "select-icon.vue"]]), AlcSelectIcon = withInstall(SelectIcon), localCodePrefix = "_", imgType = ["png", "jpg", "jpeg", "gif", "ico"], imgIcon = "ri-image-line", fileIcon = {
  doc: "ri-file-word-line",
  docx: "ri-file-word-line",
  xlsx: "ri-file-excel-line",
  xls: "ri-file-excel-line",
  ppt: "ri-file-ppt-line",
  pptx: "ri-file-ppt-line",
  pdf: "ri-file-pdf-line",
  wps: "ri-file-word-2-line",
  txt: "ri-file-text-line",
  json: "ri-file-code-line",
  xml: "ri-file-code-line",
  grf: "ri-file-code-line",
  rar: "ri-folder-zip-line",
  zip: "ri-folder-zip-line",
  mp3: "ri-music-2-line",
  mp4: "ri-vidicon-line",
  chm: "ri-file-unknow-line"
};
function matchIcon(e) {
  return imgType.includes(e) ? imgIcon : fileIcon[e] || "ri-file-unknow-line";
}
const useAccept = () => {
  const e = useProp("accept"), o = useProp("limitSize"), n = useProp("limit"), t = imgType.map((c) => `.${c}`).join(","), r = Object.keys(fileIcon).map((c) => `.${c}`).join(","), a = computed(() => e.value || `${r},${t}`), l = computed(() => `<i class="ri-asterisk"></i> 上传类型必须为 ${a.value}${`${o.value ? `<br /><i class="ri-asterisk"></i> 单个文件大小不超过 ${s(
    o.value
  )}` : ""}<br /><i class="ri-asterisk"></i> 最多上传 ${n.value} 个文件`}`);
  function s(c, d = 2) {
    const p = ["", "B", "KB", "MB", "GB"];
    let f = 0;
    for (c *= Math.pow(1024, d); d < p.length && (f = c / Math.pow(1024, d), f >= 1024); )
      d++;
    return (Number.isInteger(f) ? f : f.toFixed(2)) + (p[d] || "GB");
  }
  return {
    imgType,
    tipText: l,
    uploadAccept: a,
    getLimitSizeTips: s
  };
}, usePreview = (e) => {
  const o = useProp("preview"), n = useProp("download"), t = ref(-1), r = useProviderConfig("state"), a = useUsePublicUrl(), { open: l } = usePreviewView();
  function s(c) {
    if (o.value) {
      if (!c.type)
        return void operatorErrorTip("该文件不支持预览");
      if (["zip", "rar"].includes(c.type))
        return void operatorErrorTip(
          n.value ? "压缩包请下载后查看" : "压缩包不支持预览"
        );
      imgType.includes(c.type) ? c.status === "success" ? apiGetFilePreviewUrlById(
        c.code,
        r.value.cAllLinkUserUuid,
        a.value
      ).then((d) => {
        l({
          list: [d.url]
        });
      }).catch(() => {
        operatorErrorTip("文件资源获取失败");
      }) : c.reference ? l({
        list: [c.reference]
      }) : operatorErrorTip("该文件不支持预览") : c.previewUrl && c.url ? window.open(
        getFilePreviewUrl(
          c.previewUrl,
          c.url,
          r.value.cAccSignId,
          r.value.token
        ),
        "_blank"
      ) : operatorErrorTip("该文件不支持预览");
    }
  }
  return onUnmounted(() => {
    e.value.forEach((c) => {
      var d;
      (d = c.reference) != null && d.startsWith("blob:") && URL.revokeObjectURL(c.reference);
    });
  }), {
    active: t,
    onPreview: s
  };
}, alcUploadProps = {
  /**
   * 业务编码
   */
  businessType: { type: String, required: !0 },
  /**
   * 业务名称
   */
  businessName: { type: String, required: !0 },
  /**
   * 上传的文件名称是否变更为随机名称
   * @default true
   * @description 在强制要求上传文件名称不变化的场景设置为 false, 默认为 true，如果文档目录相同会产生覆盖
   */
  randomName: { type: Boolean, default: !0 },
  /**
   * input 原生属性
   * @default 'files'
   */
  name: { type: String, default: "files" },
  /**
   * 使用公共上传地址
   * @default true
   * @description 如果使用公共上传地址则固定，否则走 server.config.json 代理转发
   */
  usePublicUrl: { type: Boolean },
  /**
   * 自定义上传
   */
  httpRequest: {
    type: Function
  },
  /**
   * 上传之前的钩子
   */
  beforeUpload: {
    type: Function
  },
  /**
   * 文件类型
   * @description 自定义接受的上传文件类型会覆盖组件内置的类型，主要是和 httpRequest 结合使用
   */
  accept: { type: String, default: "" },
  /**
   * 文件列表展示形式
   * @default 'text'
   */
  listType: {
    type: String,
    default: "text",
    validator: (e) => ["text", "card"].includes(e)
  },
  /**
   * 上传按钮文本
   * @default '选择文件'
   */
  buttonText: { type: String, default: "选择文件" },
  /**
   * 显示文件列表
   * @default true
   */
  showFileList: { type: Boolean, default: !0 },
  /**
   * 是否禁用
   * @default false
   */
  disabled: { type: Boolean, default: !1 },
  /**
   * 显示文件状态
   * @default true
   */
  showStatus: { type: Boolean, default: !0 },
  /**
   * 文件多选
   * @default false
   */
  multiple: { type: Boolean, default: !1 },
  /**
   * 超出限制时启用压缩
   * @default true
   * @description gif 图片将跳过压缩步骤（压缩后图片信息丢失）
   */
  compressor: { type: Boolean, default: !0 },
  /**
   * 自动上传
   * @default true
   */
  autoUpload: { type: Boolean, default: !0 },
  /**
   * 限制上传的最大数量
   * @default 10
   */
  limit: { type: Number, default: 10 },
  /**
   * 单文件限制大小（kb 为单位）
   * @default 5120
   */
  limitSize: { type: Number, default: 5120 },
  /**
   * 当文件到达 limit 限制是否隐藏触发文件选择的控件
   * @default false
   */
  limitHide: { type: Boolean, default: !1 },
  /**
   * 超过文件限制数量时运行的钩子函数
   */
  onExceed: {
    type: Function
  },
  /**
   * 裁切
   * @default false
   * @description 多选和裁切不能同时开启
   */
  cropper: { type: Boolean, default: !1 },
  /**
   * 传递给裁切组件的 props
   * @default {}
   */
  cropperProps: {
    type: Object
  },
  /**
   * 拖拽上传
   * @default false
   */
  drag: { type: Boolean, default: !1 },
  /**
   * 支持预览
   * @default false
   */
  preview: { type: Boolean, default: !1 },
  /**
   * 支持下载
   * @default false
   */
  download: { type: Boolean, default: !1 },
  /**
   * 支持分享
   * @todo 还没做
   * @default false
   */
  // share: { type: Boolean, default: false },
  /**
   * 支持删除
   * @default true
   */
  remove: { type: Boolean, default: !0 },
  /**
   * 同步删除服务端文件
   * @default true
   * @description 即点击文件列表的删除图标是否同步删除服务器资源，为 false 时，需要手动调用 syncRemove 或 submit 方法移除资源
   *
   */
  syncRemove: { type: Boolean, default: !0 },
  /**
   * 删除前的钩子
   */
  beforeRemove: {
    type: Function
  }
}, alcUploadContentListProps = {
  /**
   * 上传的进度
   */
  uploadProgress: {
    type: Map
  },
  ...objPick(alcUploadProps, [
    "disabled",
    "preview",
    "download",
    "remove",
    "showStatus",
    "usePublicUrl"
  ])
}, useRemove = (e, o) => {
  const n = getCurrentInstance(), { emit: t } = n, r = shallowReactive(/* @__PURE__ */ new WeakSet()), a = useProp("syncRemove"), l = useProp("beforeRemove"), s = async (p) => {
    const f = {
      remote: [],
      local: []
    };
    if (typeof p[0] == "string" ? p.forEach((g) => {
      g.startsWith(o) ? f.local.push(g) : f.remote.push(g);
    }) : p.forEach((g) => {
      r.add(g), g.code.startsWith(o) ? f.local.push(g.code) : f.remote.push(g.code);
    }), f.local.length && (e.value = e.value.filter((g) => !f.local.includes(g.code))), f.remote.length)
      try {
        const g = await apiRemoveFile({
          cDocIds: f.remote,
          cAllLinkUserUuid: useProviderConfig().value.state.cAllLinkUserUuid
        });
        if (g.code === 1) {
          const b = g.data.reduce(
            (k, x) => x.bDel ? k.add(x.cDocId) : k,
            /* @__PURE__ */ new Set()
          );
          e.value = e.value.filter((k) => !b.has(k.code));
        } else
          return Promise.reject(g);
      } finally {
        p.forEach((g) => {
          r.delete(g);
        });
      }
  };
  return {
    removingSet: r,
    innerRemove: async (p, f) => {
      if (!(typeof l.value == "function" ? await syncReturnBoolean(
        l.value,
        p,
        e.value
      ) : !0))
        return;
      let b = !1;
      if (a.value)
        try {
          await s([p.code]), b = !0;
        } catch (k) {
          operatorErrorTip(k.msg || "文件删除失败");
        }
      else
        b = !0, e.value.splice(f, 1);
      t("remove", b, p);
    },
    outerRemove: async (p) => (p = p ? Array.isArray(p) ? p : [p] : [], p.length ? s(p) : !0)
  };
}, useControl = (e) => {
  const { emit: o } = getCurrentInstance(), n = useProp("preview"), t = useProp("download"), r = useProp("remove"), a = useProp("disabled"), l = useUsePublicUrl(), s = useProviderConfig("state");
  watchEffect(() => {
    const x = [];
    e.value.forEach((N) => {
      var m;
      if (N.code.startsWith(localCodePrefix))
        return;
      const O = !!N.code && !!N.name && !!N.url && !!N.previewUrl;
      Object.assign(N, {
        status: O ? "success" : "wait",
        type: (m = N.name) == null ? void 0 : m.slice(N.name.lastIndexOf(".") + 1)
      }), O || x.push(N);
    }), x.length && k(x);
  });
  const { removingSet: c, innerRemove: d, outerRemove: p } = useRemove(
    e,
    localCodePrefix
  ), f = shallowReactive(/* @__PURE__ */ new WeakSet());
  function g(x) {
    return imgType.includes(x.type) ? n.value || t.value || r.value && !a.value : ["success", "fail"].includes(x.status) || r.value && !a.value;
  }
  async function b(x) {
    if (x.status !== "success")
      return void operatorErrorTip("该文件状态不支持下载");
    if (x.code.startsWith(localCodePrefix))
      return void operatorErrorTip("发布者未提供文件标识，不支持下载");
    try {
      return f.add(x), await apiDownloadFile(
        x.code,
        s.value.cAllLinkUserUuid,
        l.value
      ), o("download", x), !0;
    } catch {
      return;
    } finally {
      f.delete(x);
    }
  }
  function k(x) {
    apiGetFileInfo(
      x.map((N) => N.code)
    ).then((N) => {
      if (N.code !== 1)
        return Promise.reject();
      x.forEach((O) => {
        var ee;
        const m = N.data.find((z) => O.code === z.cDocId);
        Object.assign(
          O,
          m ? {
            code: m.cDocId,
            name: m.cOssOriginalName,
            url: m.cOssPublicUrl,
            previewUrl: m.cPreviewUrl,
            status: "success",
            type: m.cOssOriginalName.slice(
              m.cOssOriginalName.lastIndexOf(".") + 1
            )
          } : {
            status: "fail",
            msg: "找不到该文件",
            type: (ee = O.url) == null ? void 0 : ee.slice(
              O.url.lastIndexOf(".") + 1
            )
          }
        );
      });
    }).catch(() => {
      x.forEach((N) => {
        var O;
        N.status = "fail", N.msg = "找不到该文件", N.type = ((O = N.url) == null ? void 0 : O.slice(N.url.lastIndexOf(".") + 1)) || "";
      });
    });
  }
  return {
    removingSet: c,
    downloadingSet: f,
    showOperation: g,
    fileDownLoad: b,
    innerRemove: d,
    outerRemove: p
  };
}, _sfc_main$C = /* @__PURE__ */ defineComponent({
  name: "alc-upload-card-list",
  __name: "card",
  props: /* @__PURE__ */ mergeModels(alcUploadContentListProps, {
    fileList: {
      required: !0
    },
    fileListModifiers: {}
  }),
  emits: /* @__PURE__ */ mergeModels(["preview", "download", "remove"], ["update:fileList"]),
  setup(e, { expose: o }) {
    const n = useModel(e, "fileList"), { onPreview: t } = usePreview(n), {
      removingSet: r,
      downloadingSet: a,
      innerRemove: l,
      fileDownLoad: s,
      showOperation: c,
      outerRemove: d
    } = useControl(n);
    o({
      outerRemove: d
    });
    const p = { fileList: n, onPreview: t, removingSet: r, downloadingSet: a, innerRemove: l, fileDownLoad: s, showOperation: c, outerRemove: d, get ElImage() {
      return ElImage;
    }, get ElProgress() {
      return ElProgress;
    }, get ElTooltip() {
      return ElTooltip;
    }, get imgType() {
      return imgType;
    }, get matchIcon() {
      return matchIcon;
    } };
    return Object.defineProperty(p, "__isScriptSetup", { enumerable: !1, value: !0 }), p;
  }
}), _hoisted_1$u = {
  class: "alc-upload-list",
  style: { "flex-flow": "row wrap" }
}, _hoisted_2$p = ["title"], _hoisted_3$l = {
  key: 0,
  class: "ri-upload-cloud-line"
}, _hoisted_4$g = {
  key: 1,
  class: "ri-check-line"
}, _hoisted_5$e = { style: { margin: "0", padding: "0", "max-width": "300px", "font-size": "12px", "max-height": "100px", overflow: "hidden", "text-overflow": "ellipsis" } }, _hoisted_6$d = /* @__PURE__ */ createElementVNode("i", { class: "ri-alert-line" }, null, -1), _hoisted_7$c = {
  key: 1,
  class: "filter_1"
}, _hoisted_8$b = { class: "alc-upload-list__item-img" }, _hoisted_9$b = {
  key: 1,
  class: "file-item"
}, _hoisted_10$9 = { class: "file-name" }, _hoisted_11$8 = {
  key: 2,
  class: "alc-upload-list__item-operate"
}, _hoisted_12$7 = ["title", "onClick"], _hoisted_13$6 = ["onClick"], _hoisted_14$4 = ["onClick"];
function _sfc_render$C(e, o, n, t, r, a) {
  const l = resolveDirective("loading");
  return openBlock(), createElementBlock("ul", _hoisted_1$u, [
    (openBlock(!0), createElementBlock(Fragment, null, renderList(t.fileList, (s, c) => {
      var d;
      return openBlock(), createElementBlock("li", {
        key: s.code,
        class: normalizeClass([s.status === "uploading" ? "progress-status" : "", "alc-upload-list__item alc-upload-list--card alc-upload-list--card-hover"]),
        tabindex: "0",
        title: s.name
      }, [
        e.showStatus && s.status ? (openBlock(), createElementBlock("label", {
          key: 0,
          class: normalizeClass([
            "img-status-label alc-upload-list__item-status",
            ["wait", "uploading"].includes(s.status) ? "is-warning" : s.status === "success" ? "is-success" : "is-danger"
          ])
        }, [
          ["wait", "uploading"].includes(s.status) ? (openBlock(), createElementBlock("i", _hoisted_3$l)) : s.status === "success" ? (openBlock(), createElementBlock("i", _hoisted_4$g)) : s.status === "fail" ? (openBlock(), createBlock(t.ElTooltip, { key: 2 }, {
            content: withCtx(() => [
              createElementVNode("p", _hoisted_5$e, toDisplayString$1(s.msg), 1)
            ]),
            default: withCtx(() => [
              _hoisted_6$d
            ]),
            _: 2
          }, 1024)) : createCommentVNode("", !0)
        ], 2)) : createCommentVNode("", !0),
        (d = e.uploadProgress) != null && d.has(s.raw) && e.uploadProgress.get(s.raw) < 100 ? (openBlock(), createElementBlock("div", _hoisted_7$c, [
          createVNode(t.ElProgress, {
            type: "circle",
            percentage: e.uploadProgress.get(s.raw),
            indeterminate: ""
          }, null, 8, ["percentage"])
        ])) : createCommentVNode("", !0),
        createElementVNode("div", _hoisted_8$b, [
          t.imgType.includes(s.type) ? (openBlock(), createBlock(t.ElImage, {
            key: 0,
            src: s.url || s.reference,
            alt: s.name
          }, null, 8, ["src", "alt"])) : (openBlock(), createElementBlock("div", _hoisted_9$b, [
            createElementVNode("i", {
              class: normalizeClass([t.matchIcon(s.type), "file-icon"])
            }, null, 2),
            createElementVNode("div", _hoisted_10$9, toDisplayString$1(s.name), 1)
          ])),
          t.showOperation(s) ? (openBlock(), createElementBlock("span", _hoisted_11$8, [
            e.preview && s.status === "success" ? (openBlock(), createElementBlock("i", {
              key: 0,
              title: s.type,
              class: "ri-zoom-in-line",
              onClick: (p) => [t.onPreview(s), e.$emit("preview", s)]
            }, null, 8, _hoisted_12$7)) : createCommentVNode("", !0),
            e.download && s.status === "success" ? withDirectives((openBlock(), createElementBlock("i", {
              key: 1,
              "element-loading-background": "transparent",
              class: "ri-download-cloud-2-line",
              onClick: (p) => t.fileDownLoad(s)
            }, null, 8, _hoisted_13$6)), [
              [l, t.downloadingSet.has(s)]
            ]) : createCommentVNode("", !0),
            e.remove && !e.disabled || s.status === "fail" ? withDirectives((openBlock(), createElementBlock("i", {
              key: 2,
              "element-loading-background": "transparent",
              class: "ri-delete-bin-line",
              onClick: (p) => t.innerRemove(s, c)
            }, null, 8, _hoisted_14$4)), [
              [l, t.removingSet.has(s)]
            ]) : createCommentVNode("", !0)
          ])) : createCommentVNode("", !0)
        ])
      ], 10, _hoisted_2$p);
    }), 128))
  ]);
}
const UploadCardList = /* @__PURE__ */ _export_sfc(_sfc_main$C, [["render", _sfc_render$C], ["__file", "card.vue"]]), _sfc_main$B = /* @__PURE__ */ defineComponent({
  name: "alc-upload-text-list",
  __name: "text",
  props: /* @__PURE__ */ mergeModels(alcUploadContentListProps, {
    fileList: {
      required: !0
    },
    fileListModifiers: {}
  }),
  emits: /* @__PURE__ */ mergeModels(["preview", "download", "remove"], ["update:fileList"]),
  setup(e, { expose: o }) {
    const n = useModel(e, "fileList"), { onPreview: t } = usePreview(n), {
      removingSet: r,
      downloadingSet: a,
      showOperation: l,
      fileDownLoad: s,
      innerRemove: c,
      outerRemove: d
    } = useControl(n);
    o({
      outerRemove: d
    });
    const p = { fileList: n, onPreview: t, removingSet: r, downloadingSet: a, showOperation: l, fileDownLoad: s, innerRemove: c, outerRemove: d, get ElProgress() {
      return ElProgress;
    }, get ElTooltip() {
      return ElTooltip;
    }, get matchIcon() {
      return matchIcon;
    } };
    return Object.defineProperty(p, "__isScriptSetup", { enumerable: !1, value: !0 }), p;
  }
}), _hoisted_1$t = {
  class: "alc-upload-list",
  style: { "flex-flow": "column nowrap" }
}, _hoisted_2$o = {
  key: 0,
  class: "filter_1"
}, _hoisted_3$k = ["title", "onClick"], _hoisted_4$f = ["onClick"], _hoisted_5$d = ["onClick"], _hoisted_6$c = {
  key: 0,
  class: "ri-upload-cloud-line"
}, _hoisted_7$b = {
  key: 1,
  class: "ri-checkbox-circle-line"
}, _hoisted_8$a = { style: { margin: "0", padding: "0", "max-width": "300px", "font-size": "12px", "max-height": "100px", overflow: "hidden", "text-overflow": "ellipsis" } }, _hoisted_9$a = /* @__PURE__ */ createElementVNode("i", { class: "ri-alert-line" }, null, -1);
function _sfc_render$B(e, o, n, t, r, a) {
  const l = resolveDirective("loading");
  return openBlock(), createElementBlock("ul", _hoisted_1$t, [
    (openBlock(!0), createElementBlock(Fragment, null, renderList(t.fileList, (s, c) => {
      var d;
      return openBlock(), createElementBlock("li", {
        key: s.code,
        class: normalizeClass([s.status === "uploading" ? "progress-status" : "", "alc-upload-list__item alc-upload-list--text"]),
        tabindex: "0"
      }, [
        (d = e.uploadProgress) != null && d.has(s.raw) && e.uploadProgress.get(s.raw) < 100 ? (openBlock(), createElementBlock("div", _hoisted_2$o, [
          createVNode(t.ElProgress, {
            percentage: e.uploadProgress.get(s.raw),
            indeterminate: ""
          }, null, 8, ["percentage"])
        ])) : createCommentVNode("", !0),
        createElementVNode("i", {
          class: normalizeClass([t.matchIcon(s.type), "alc-upload-list__item-icon"])
        }, null, 2),
        createElementVNode("a", {
          class: normalizeClass(["alc-upload-list__item-name", {
            "alc-upload-list__item-name--hove": e.preview
          }]),
          title: s.name,
          style: normalizeStyle({
            cursor: e.preview ? "pointer" : "text"
          }),
          onClick: (p) => t.onPreview(s)
        }, toDisplayString$1(s.name), 15, _hoisted_3$k),
        createElementVNode("label", {
          class: "alc-upload-list__item-extra",
          onMousemove: o[0] || (o[0] = withModifiers(() => {
          }, ["stop"]))
        }, [
          t.showOperation(s) ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            s.status !== "fail" && e.download ? withDirectives((openBlock(), createElementBlock("i", {
              key: 0,
              "element-loading-background": "transparent",
              class: "ri-download-cloud-2-line alc-upload-list__item-operate",
              onClick: (p) => t.fileDownLoad(s)
            }, null, 8, _hoisted_4$f)), [
              [l, t.downloadingSet.has(s)]
            ]) : createCommentVNode("", !0),
            !e.disabled && e.remove || s.status === "fail" ? withDirectives((openBlock(), createElementBlock("i", {
              key: 1,
              "element-loading-background": "transparent",
              class: "ri-close-circle-line alc-upload-list__item-operate",
              onClick: (p) => t.innerRemove(s, c)
            }, null, 8, _hoisted_5$d)), [
              [l, t.removingSet.has(s)]
            ]) : createCommentVNode("", !0)
          ], 64)) : createCommentVNode("", !0),
          e.showStatus && s.status ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
            ["wait", "uploading"].includes(s.status) ? (openBlock(), createElementBlock("i", _hoisted_6$c)) : s.status === "success" ? (openBlock(), createElementBlock("i", _hoisted_7$b)) : s.status === "fail" ? (openBlock(), createBlock(t.ElTooltip, { key: 2 }, {
              content: withCtx(() => [
                createElementVNode("p", _hoisted_8$a, toDisplayString$1(s.msg), 1)
              ]),
              default: withCtx(() => [
                _hoisted_9$a
              ]),
              _: 2
            }, 1024)) : createCommentVNode("", !0)
          ], 64)) : createCommentVNode("", !0)
        ], 32)
      ], 2);
    }), 128))
  ]);
}
const UploadTextList = /* @__PURE__ */ _export_sfc(_sfc_main$B, [["render", _sfc_render$B], ["__file", "text.vue"]]), _sfc_main$A = /* @__PURE__ */ defineComponent({
  name: "alc-upload-trigger",
  __name: "trigger",
  props: {
    ...objPick(alcUploadProps, ["drag", "buttonText", "listType"]),
    disabled: { type: Boolean, required: !0 },
    tipText: { type: String, required: !0 }
  },
  setup(e, { expose: o }) {
    o();
    const n = { get ElButton() {
      return ElButton;
    }, get AlcTooltip() {
      return AlcTooltip;
    } };
    return Object.defineProperty(n, "__isScriptSetup", { enumerable: !1, value: !0 }), n;
  }
}), _hoisted_1$s = /* @__PURE__ */ createElementVNode("i", {
  class: "ri-upload-cloud-2-line upload-dragger-icon--upload",
  style: { "font-size": "36px" }
}, null, -1), _hoisted_2$n = { class: "upload-dragger__text" }, _hoisted_3$j = /* @__PURE__ */ createElementVNode("span", null, "点击上传", -1), _hoisted_4$e = { class: "card-trigger-box" }, _hoisted_5$c = /* @__PURE__ */ createElementVNode("i", {
  class: "ri-add-line",
  style: { "font-size": "32px" }
}, null, -1), _hoisted_6$b = { class: "card-trigger-tip" };
function _sfc_render$A(e, o, n, t, r, a) {
  return e.drag ? (openBlock(), createElementBlock("div", {
    key: 0,
    class: normalizeClass(["alc-upload-dragger", {
      "alc-upload-dragger--hover": !n.disabled
    }])
  }, [
    _hoisted_1$s,
    createElementVNode("p", _hoisted_2$n, [
      createTextVNode(" 拖放文件到这里或者 "),
      _hoisted_3$j,
      createVNode(t.AlcTooltip, { content: n.tipText }, null, 8, ["content"])
    ])
  ], 2)) : e.listType === "text" ? (openBlock(), createBlock(t.ElButton, {
    key: 1,
    disabled: n.disabled,
    type: "primary",
    plain: ""
  }, {
    default: withCtx(() => [
      createTextVNode(toDisplayString$1(e.buttonText) + " ", 1),
      createVNode(t.AlcTooltip, { content: n.tipText }, null, 8, ["content"])
    ]),
    _: 1
  }, 8, ["disabled"])) : e.listType === "card" ? (openBlock(), createElementBlock("div", {
    key: 2,
    class: normalizeClass(["alc-upload-list--card-trigger", {
      "alc-upload-list--card-trigger-hover": !n.disabled
    }])
  }, [
    createElementVNode("div", _hoisted_4$e, [
      _hoisted_5$c,
      createElementVNode("span", _hoisted_6$b, [
        createVNode(t.AlcTooltip, { content: n.tipText }, null, 8, ["content"])
      ])
    ])
  ], 2)) : createCommentVNode("", !0);
}
const UploadTrigger = /* @__PURE__ */ _export_sfc(_sfc_main$A, [["render", _sfc_render$A], ["__file", "trigger.vue"]]), messageDefaultOptions = Object.freeze({
  offset: 20,
  center: !1,
  grouping: !0,
  duration: 8e3
});
function apiLinkErrorTip(e) {
  return ElMessage.error({
    message: `【异常】：${e}服务链接失败`,
    ...messageDefaultOptions
  });
}
function operatorErrorTip(e) {
  return typeof e == "string" ? ElMessage.warning({ message: e, ...messageDefaultOptions }) : ElMessage.warning({ ...e, ...messageDefaultOptions });
}
const useSelectFile = (e, o) => {
  const n = useProp("drag"), t = useProp("limit"), r = useProp("onExceed"), a = useFormDisabled(), l = ref(), s = computed(() => n.value && !a.value ? {
    draggable: !0,
    ondragover: d,
    ondrop: c
  } : {});
  function c(b) {
    var k, x;
    if (b.preventDefault(), !b.dataTransfer)
      return operatorErrorTip("浏览器不支持拖放文件");
    if ((k = b.dataTransfer.items) != null && k.length) {
      const N = [...b.dataTransfer.items].reduce((O, m) => {
        if (m.kind === "file") {
          const ee = m.getAsFile();
          ee && O.push(ee);
        }
        return O;
      }, []);
      o(N);
    } else (x = b.dataTransfer.files) != null && x.length && o([...b.dataTransfer.files]);
  }
  function d(b) {
    b.preventDefault();
  }
  function p() {
    var b;
    if (!a.value) {
      if (e.value.length > t.value)
        return void g();
      (b = l.value) == null || b.dispatchEvent(new MouseEvent("click"));
    }
  }
  async function f(b) {
    const k = [...b.target.files || []];
    if (k != null && k.length) {
      if (l.value && (l.value.value = ""), k.length + e.value.length > t.value)
        return void g(k);
      o(k);
    }
  }
  function g(b) {
    if (r.value)
      return void r.value(b, e.value);
    operatorErrorTip(`文件超过限制个数：${t.value}个`);
  }
  return {
    inputRef: l,
    isDisabled: a,
    dragBind: s,
    selectFileHandle: f,
    openFileSelector: p
  };
}, _sfc_main$z = /* @__PURE__ */ defineComponent({
  name: "alc-upload",
  __name: "upload",
  props: /* @__PURE__ */ mergeModels(alcUploadProps, {
    fileList: {
      default: () => []
    },
    fileListModifiers: {}
  }),
  emits: /* @__PURE__ */ mergeModels(["remove", "success", "error", "change"], ["update:fileList"]),
  setup(e, { expose: o, emit: n }) {
    const t = e, r = n, a = ref(), l = ref(), s = useModel(e, "fileList"), c = useProviderConfig("state"), d = useUsePublicUrl();
    function p() {
      return localCodePrefix + (Date.now() + s.value.length);
    }
    const { open: f } = useCropperView(), { imgType: g, uploadAccept: b, tipText: k, getLimitSizeTips: x } = useAccept(), { inputRef: N, isDisabled: O, dragBind: m, selectFileHandle: ee, openFileSelector: z } = useSelectFile(s, C), P = (...se) => t.listType === "card" ? a.value.outerRemove(...se) : l.value.outerRemove(...se), V = computed(() => t.limitHide ? s.value.length < t.limit : !0), U = shallowReactive(/* @__PURE__ */ new Map()), E = shallowRef([]);
    async function C(se) {
      if (t.cropper) {
        const he = se[0];
        return void f({
          ...t.cropperProps,
          imgSrc: he,
          onConfirm: async ({ blob: ae }) => {
            const le = await ae;
            if (le) {
              const fe = new File([le], he.name, {
                type: he == null ? void 0 : he.type
              });
              (await X([fe])).length && r("change", se, s.value);
            }
          }
        });
      }
      (await X(se)).length && r("change", se, s.value);
    }
    const I = (se) => ({
      status: se.bUpSuccess ? "success" : "fail",
      msg: se.cMsg,
      name: se.cOriginName,
      previewUrl: se.cPreviewUrl,
      ...se.cUrl ? { url: se.cUrl } : {},
      ...se.cDocId ? { code: se.cDocId } : {}
    }), v = async (se) => {
      const pe = new FormData();
      return se.forEach((he) => {
        U.set(he, 0), pe.append("files", he, encodeURIComponent(he.name));
      }), apiUploadFile(
        {
          ...objPick(t, [
            "businessType",
            "businessName",
            "randomName"
          ]),
          cAccSignId: c.value.cAccSignId,
          cAllLinkUserUuid: c.value.cAllLinkUserUuid,
          cMenuName: c.value.cMenuName,
          cMobilePhone: c.value.cMobilePhone,
          progress: (he) => {
            he >= 97 || se.forEach((ae) => {
              U.set(ae, he);
            });
          }
        },
        pe,
        d.value
      ).then((he) => he.code === 1 ? he.data.map(I) : Promise.reject(he.msg));
    }, M = async (se) => {
      try {
        const pe = typeof t.httpRequest == "function";
        let he;
        pe ? he = await t.httpRequest(se) : he = await v(se);
        const ae = [], le = [];
        return he.forEach((fe) => {
          fe.status === "success" ? ae.push(fe) : le.push(fe);
        }), ae.length && !pe && r("success", ae, s.value), le.length && !pe && r("error", le[0].msg, le, s.value), he;
      } catch (pe) {
        return s.value = s.value.map((he) => se.includes(he.raw) ? {
          ...he,
          status: "fail",
          msg: "上传服务链接失败"
        } : he), r(
          "error",
          pe instanceof Error ? pe.message : pe,
          se,
          s.value
        ), !1;
      } finally {
        U.clear();
      }
    }, $ = async (se) => {
      let pe = "", he = "";
      const ae = [];
      for (let le = 0; le < se.length; le++) {
        let fe = se[le];
        if (t.compressor && g.includes(fe.type.split("/")[1]) && !fe.type.endsWith("gif") && (fe = await compressorImage(fe, "file")), +(fe.size / 1024).toFixed(2) > t.limitSize) {
          pe += `【${fe.name}】`;
          continue;
        }
        const Ce = fe.name.split(".");
        if (!b.value.includes(
          Ce.at(-1).toLowerCase()
        ) && !Ce.at(1).startsWith("blob:")) {
          he += `【${fe.name}】`;
          continue;
        }
        ae.push(fe);
      }
      return (pe || he) && (pe && operatorErrorTip(
        `${pe}超过限制大小 ${x(t.limitSize)}`
      ), he && operatorErrorTip(`${he}上传文件类型不受支持`)), ae;
    }, H = (se) => {
      const { existFileName: pe, upFile: he } = se.reduce(
        (ae, le) => {
          var Ce;
          if (~s.value.findIndex((Be) => Be.name === le.name))
            ae.existFileName.push(`${le.name}`);
          else {
            const Be = (Ce = le.name) == null ? void 0 : Ce.slice(le.name.lastIndexOf(".") + 1);
            ae.upFile.push({
              code: p(),
              name: le.name,
              raw: markRaw(le),
              url: "",
              reference: g.includes(Be) ? URL.createObjectURL(le) : "",
              status: "wait",
              type: Be,
              msg: "",
              previewUrl: ""
            });
          }
          return ae;
        },
        {
          existFileName: [],
          upFile: []
        }
      );
      if (pe.length) {
        let ae = "", le = 0;
        do {
          if (ae.length > 50) {
            ae += le + 1 < pe.length ? `等${pe.length - le + 1}个文件` : "";
            break;
          }
          ae += `【${pe[le]}】`, le++;
        } while (le < pe.length);
        pe.length && operatorErrorTip(`${ae}已存在于文件列表`);
      }
      return he;
    }, X = async (se) => {
      let pe = !0;
      if (typeof t.beforeUpload == "function" && (pe = await syncReturnBoolean(t.beforeUpload, se)), !pe)
        return [];
      se = await $(se);
      const he = H(se);
      return s.value.push(...he), se = he.map((ae) => ae.raw).filter(Boolean), se.length === 0 ? [] : t.autoUpload ? te(se) : he;
    }, te = async (se) => {
      let pe = !1;
      return s.value.forEach((he) => {
        he.status !== "success" && (he.status = se.includes(he.raw) ? "uploading" : "wait");
      }), pe = await M(se), pe || (pe = []), pe.forEach((he) => {
        const ae = s.value.find((le) => le.name === he.name);
        ae && Object.assign(ae, {
          code: he.code || ae.code,
          url: he.url || ae.url,
          status: he.status,
          msg: he.msg,
          previewUrl: he.previewUrl
        });
      }), pe;
    }, oe = (se, pe) => {
      N.value.value = "", t.syncRemove || E.value.push(pe), r("remove", se, pe);
    }, ne = (se = "wait") => {
      const pe = s.value.map((he) => he.status === se ? he.raw : !1).filter(Boolean);
      return E.value.length && P(E.value), pe.length ? te(pe) : Promise.resolve([]);
    };
    o({
      fileList: s,
      submit: () => t.autoUpload ? Promise.resolve([]) : ne(),
      retry: () => ne("fail"),
      clearFiles: async (se, pe = !1) => {
        let he;
        return se !== "success" ? (s.value = s.value.filter((ae) => ae.status !== se), he = !0) : he = await P(
          s.value.filter((ae) => ae.status === se)
        ), pe && r("change", [], s.value), he;
      },
      reset: () => {
        s.value = [], N.value && (N.value.value = "");
      },
      handleRemove: P,
      syncRemove: () => P(E.value),
      openFileSelector: z
    });
    const ie = { props: t, emits: r, cardListRef: a, textListRef: l, fileList: s, coreState: c, usePublicUrl$: d, generateCode: p, openCropperView: f, imgType: g, uploadAccept: b, tipText: k, getLimitSizeTips: x, inputRef: N, isDisabled: O, dragBind: m, selectFileHandle: ee, openFileSelector: z, outerRemove: P, limitHide$: V, progressMap: U, beDelete: E, onSelectFile: C, assemble: I, uploadFile: v, upload: M, checkFile: $, filterSameFile: H, pushList: X, uploadAndUpdateLocalList: te, onRemove: oe, submit: ne, AlcUploadCardList: UploadCardList, AlcUploadTextList: UploadTextList, UploadTrigger };
    return Object.defineProperty(ie, "__isScriptSetup", { enumerable: !1, value: !0 }), ie;
  }
}), _hoisted_1$r = { class: "alc-component-file-upload" }, _hoisted_2$m = ["name", "accept", "multiple"];
function _sfc_render$z(e, o, n, t, r, a) {
  return openBlock(), createElementBlock("div", _hoisted_1$r, [
    createElementVNode("div", mergeProps({ tabindex: "1" }, t.dragBind, {
      style: { width: "max-content", cursor: "pointer" },
      onClick: o[0] || (o[0] = (...l) => t.openFileSelector && t.openFileSelector(...l))
    }), [
      t.limitHide$ ? renderSlot(e.$slots, "trigger", normalizeProps(mergeProps({ key: 0 }, { uploadAccept: t.uploadAccept, limit: e.limit })), () => [
        createVNode(t.UploadTrigger, {
          drag: e.drag,
          "list-type": e.listType,
          "button-text": e.buttonText,
          disabled: t.isDisabled,
          "tip-text": t.tipText
        }, null, 8, ["drag", "list-type", "button-text", "disabled", "tip-text"])
      ]) : createCommentVNode("", !0)
    ], 16),
    e.showFileList ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
      e.listType === "card" ? (openBlock(), createBlock(t.AlcUploadCardList, {
        key: 0,
        ref: "cardListRef",
        "file-list": t.fileList,
        "onUpdate:fileList": o[1] || (o[1] = (l) => t.fileList = l),
        disabled: e.disabled,
        preview: e.preview,
        download: e.download,
        remove: e.remove,
        "show-status": e.showStatus,
        "use-public-url": t.usePublicUrl$,
        "upload-progress": t.progressMap,
        onRemove: t.onRemove
      }, null, 8, ["file-list", "disabled", "preview", "download", "remove", "show-status", "use-public-url", "upload-progress"])) : (openBlock(), createBlock(t.AlcUploadTextList, {
        key: 1,
        ref: "textListRef",
        "file-list": t.fileList,
        "onUpdate:fileList": o[2] || (o[2] = (l) => t.fileList = l),
        disabled: e.disabled,
        preview: e.preview,
        download: e.download,
        remove: e.remove,
        "show-status": e.showStatus,
        "use-public-url": t.usePublicUrl$,
        "upload-progress": t.progressMap,
        onRemove: t.onRemove
      }, null, 8, ["file-list", "disabled", "preview", "download", "remove", "show-status", "use-public-url", "upload-progress"]))
    ], 64)) : createCommentVNode("", !0),
    createElementVNode("input", {
      ref: "inputRef",
      type: "file",
      name: e.$props.name,
      accept: t.uploadAccept,
      multiple: e.multiple,
      style: { position: "absolute", "z-index": "-1", opacity: "0" },
      onChange: o[3] || (o[3] = (...l) => t.selectFileHandle && t.selectFileHandle(...l))
    }, null, 40, _hoisted_2$m)
  ]);
}
const Upload = /* @__PURE__ */ _export_sfc(_sfc_main$z, [["render", _sfc_render$z], ["__file", "upload.vue"]]), AlcUpload = withInstall(Upload), AlcUploadCardList = withInstall(UploadCardList), AlcUploadTextList = withInstall(UploadTextList), alcFormProps = {
  /**
   * 表单配置
   */
  schema: { type: Array, required: !0 },
  /**
   * 表单校验规则
   * @default {}
   */
  rules: {
    type: Object,
    default: () => ({})
  },
  // look: { type: Boolean, default: false },
  /**
   * 一行表单项的数量
   * @default 4
   */
  column: { type: Number, default: 4 },
  /**
   * 表单项间隙
   * @default 60
   */
  gutter: { type: Number, default: 60 },
  /**
   * 同一列的 label 是否相同宽度
   * @default false
   */
  sameLabel: { type: Boolean, default: !1 },
  /**
   * label 元素的宽度
   * @description 本属性将会覆盖 sameLabel 的效果
   */
  labelWidth: { type: [Number, String] },
  /**
   * 表单是否禁用
   * @default false
   */
  disabled: { type: Boolean, default: !1 },
  /**
   * 是否显示清除按钮
   * @default false
   */
  clearable: { type: Boolean, default: !1 },
  /**
   * 表单背景
   * @default false
   */
  background: { type: Boolean, default: !1 },
  /**
   * 是否隐藏 label
   * @default false
   */
  hideLabel: { type: Boolean, default: !1 },
  // 当有多行时，需要显示前几行
  // showLines: { type: Number, default: undefined },
  /**
   * 表单操作按钮跨度
   * @default grid / column
   */
  operationSpan: {
    type: Number,
    validator: (e) => typeof e == "number" && 0 <= e && e <= 24
  },
  /**
   * 是否自动将视图滚动到校验失败的表单项处
   * @default false
   */
  validFailScrollTo: { type: Boolean, default: !1 },
  /**
   * 注册自定义表单模块
   * @default {}
   * @todo 迁移到库模式时，应该在注册组件时提供本选项
   * @description 自定义表单模块能接受用户传入的所有非 AlcFormBasicSchema 属性，并且需要实现 change 事件
   */
  registerModule: {
    type: Object,
    default: () => ({})
  },
  /**
   * 是否输入时触发校验
   * @default false
   */
  validateEvent: { type: Boolean, default: !1 }
}, grid = 24, operationSlotName = "operation", requiredIcon = 12, tipsIcon = 18, _sfc_main$y = /* @__PURE__ */ defineComponent({
  name: "alc-form",
  inheritAttrs: !1,
  __name: "form",
  props: /* @__PURE__ */ mergeModels(alcFormProps, {
    modelValue: {
      default: () => ({})
    },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ mergeModels(["change"], ["update:modelValue"]),
  setup(e, { expose: o }) {
    const n = e, t = useSlots(), r = useModel(e, "modelValue"), a = ref(), l = shallowReactive({}), s = (V, U, E) => {
      typeof E == "function" ? E(V) : isRef(E) && (E.value = V), l[U] = V;
    }, c = {
      input: AlcInput,
      select: AlcSelect,
      date: AlcDateTime,
      refer: AlcRefer,
      number: AlcInputNumber,
      edit: AlcEdit,
      cascader: AlcCascader,
      "cascader-of-region": AlcCascaderRegion,
      region: AlcCascaderRegion2,
      icon: AlcSelectIcon,
      upload: AlcUpload,
      ...n.registerModule
    }, d = {
      small: 12,
      middle: 14,
      large: 16
    };
    function p(V) {
      return `${d[V] || d.middle}px`;
    }
    const f = async (V) => {
      var U, E;
      try {
        if (isEmptyObject(n.rules))
          return typeof V == "function" && V(!0), !0;
        try {
          const C = n.schema.map((v) => v.hide ? null : v.prop).filter(Boolean), I = Object.keys(n.rules).reduce((v, M) => (C.includes(M) && v.push(M), v), []);
          for (const v of I)
            await ((U = a.value) == null ? void 0 : U.validateField(v));
          return typeof V == "function" && V(!0), !0;
        } catch (C) {
          return n.validFailScrollTo && ((E = a.value) == null || E.scrollToField(Object.keys(C)[0])), typeof V == "function" && V(!1, C), !1;
        }
      } catch {
        return !1;
      }
    }, g = () => {
      var V;
      (V = a.value) == null || V.resetFields(), n.schema.forEach((U) => {
        U.itemType === "edit" && l[U.prop].setContent(r.value[U.prop] ?? "");
      });
    }, b = computed(() => grid / n.column), k = computed(() => {
      var E;
      let V = 0;
      const U = n.schema.reduce(
        (C, I) => {
          if (!I.hide) {
            const v = I.offset || 0, M = I.span || b.value;
            (V + M + v > grid || I.newLine) && (C.push([]), V = 0), V += M + v, C.at(-1)[V - M] = I;
          }
          return C;
        },
        [[]]
      );
      if (t[operationSlotName]) {
        const C = {
          span: n.operationSpan || b.value,
          prop: operationSlotName,
          labelWidth: 0,
          isSlots: !0
        };
        V + C.span <= grid ? (C.offset = grid - C.span - V, (E = U.at(-1)) == null || E.push(C)) : (C.offset = grid - C.span, U.push([C]));
      }
      return U;
    });
    let x = document.createElement("canvas"), N = x.getContext("2d");
    const O = window.getComputedStyle(document.body).fontFamily || "'PingFang SC', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif";
    function m(V, U) {
      return N ? (N.font = `${U} ${O}`, N.measureText(`${V}`).width) : 98;
    }
    onBeforeUnmount(() => {
      x = null, N = null;
    });
    const ee = computed(() => {
      var U;
      if (n.labelWidth)
        return Array.from({ length: grid }, () => n.labelWidth);
      if (!n.sameLabel || n.hideLabel)
        return [];
      const V = [];
      for (let E = 0; E < grid; E++) {
        const C = [];
        for (let I = 0; I < k.value.length; I++) {
          if (!k.value[I][E])
            continue;
          const v = k.value[I][E];
          let M = 12;
          v != null && v.label && v.itemType !== "checkbox" && (M += m(v.label, p(v.labelSize)));
          const $ = n.rules[v.prop];
          ($ != null && $.required || (U = $ == null ? void 0 : $.some) != null && U.call($, (H) => H.required)) && (M += requiredIcon), v.tips && (M += tipsIcon), C.push(M);
        }
        V.push(Math.max(...C));
      }
      return V;
    });
    function z(V) {
      return {
        ...objOmit(V, [
          "itemType",
          "label",
          "prop",
          "span",
          "offset",
          "newLine",
          "isSlots",
          "slots",
          "ref",
          "labelColor",
          "labelSize",
          "labelWidth",
          "tips",
          "display",
          "clearable"
        ]),
        ...V.itemType === "upload" ? {
          fileList: r.value[V.prop],
          "onUpdate:fileList": (U) => {
            r.value[V.prop] = U;
          }
        } : {}
      };
    }
    o({
      ...getInstanceMethod(a, [
        "validateField",
        "scrollToField",
        "clearValidate"
      ]),
      resetFields: g,
      validate: f,
      formData: r,
      refs: l
    });
    const P = { props: n, slots: t, formData: r, grid, operationSlotName, formRef: a, refs: l, mountRefs: s, weightTypeRef: c, labelSize: d, getLabelSize: p, validate: f, resetFields: g, defaultSpan: b, requiredIcon, tipsIcon, layout: k, get canvas() {
      return x;
    }, set canvas(V) {
      x = V;
    }, get ctx() {
      return N;
    }, set ctx(V) {
      N = V;
    }, bodyFontFamily: O, getTextWidth: m, colLabelWidth: ee, componentProp: z, get AlcDisplay() {
      return AlcDisplay;
    }, get AlcTooltip() {
      return AlcTooltip;
    }, get ElCheckbox() {
      return ElCheckbox;
    }, get ElCol() {
      return ElCol;
    }, get ElForm() {
      return ElForm;
    }, get ElFormItem() {
      return ElFormItem;
    }, get ElRow() {
      return ElRow;
    }, get isBlank() {
      return isBlank;
    } };
    return Object.defineProperty(P, "__isScriptSetup", { enumerable: !1, value: !0 }), P;
  }
});
function _sfc_render$y(e, o, n, t, r, a) {
  return openBlock(), createBlock(t.ElForm, mergeProps({
    ref: "formRef",
    "validate-on-rule-change": !1,
    "label-position": "right"
  }, e.$attrs, {
    model: t.formData,
    rules: e.rules,
    disabled: e.disabled,
    "label-width": e.hideLabel ? "0px" : e.labelWidth,
    class: [[e.$attrs.class, e.background ? "alc-cpt-form--bg" : void 0], "alc-cpt-form"],
    "label-suffix": "",
    "require-asterisk-position": "left",
    "status-icon": !1
  }), {
    default: withCtx(() => [
      (openBlock(!0), createElementBlock(Fragment, null, renderList(t.layout, (l, s) => (openBlock(), createBlock(t.ElRow, {
        key: s,
        gutter: e.gutter
      }, {
        default: withCtx(() => [
          (openBlock(!0), createElementBlock(Fragment, null, renderList(l, (c, d) => (openBlock(), createElementBlock(Fragment, {
            key: (c == null ? void 0 : c.prop) || d
          }, [
            c ? (openBlock(), createBlock(t.ElCol, {
              key: 0,
              span: c.span || t.defaultSpan,
              offset: c.offset
            }, {
              default: withCtx(() => [
                c.itemType === "checkbox" ? (openBlock(), createBlock(t.ElFormItem, {
                  key: 0,
                  prop: c.prop,
                  "label-width": c.labelWidth ?? t.colLabelWidth[d],
                  class: normalizeClass({ "alc-cpt-form-display": c.display })
                }, {
                  default: withCtx(() => [
                    c.display ? (openBlock(), createBlock(t.AlcDisplay, {
                      key: 0,
                      "model-value": t.formData[c.prop],
                      "item-type": "checkbox"
                    }, null, 8, ["model-value"])) : (openBlock(), createBlock(t.ElCheckbox, mergeProps({
                      key: 1,
                      ref_for: !0
                    }, t.componentProp(c), {
                      modelValue: t.formData[c.prop],
                      "onUpdate:modelValue": (p) => t.formData[c.prop] = p,
                      name: c.prop,
                      style: { "margin-right": "2px" },
                      onChange: (p) => e.$emit("change", {
                        prop: c.prop,
                        value: p
                      })
                    }), {
                      default: withCtx(() => [
                        t.isBlank(c.tips) ? createCommentVNode("", !0) : (openBlock(), createBlock(t.AlcTooltip, {
                          key: 0,
                          content: c.tips,
                          tabindex: null,
                          style: { "margin-right": "4px" }
                        }, null, 8, ["content"])),
                        createElementVNode("span", {
                          style: normalizeStyle([{
                            fontSize: t.getLabelSize(c.labelSize),
                            color: c.labelColor
                          }, { padding: "0 0 0 6px", height: "100%" }]),
                          class: "single-line-overflow"
                        }, toDisplayString$1(c.label), 5)
                      ]),
                      _: 2
                    }, 1040, ["modelValue", "onUpdate:modelValue", "name", "onChange"]))
                  ]),
                  _: 2
                }, 1032, ["prop", "label-width", "class"])) : (openBlock(), createBlock(t.ElFormItem, {
                  key: 1,
                  label: e.hideLabel ? "" : c.label,
                  prop: c.prop,
                  "label-width": c.labelWidth ?? t.colLabelWidth[d],
                  class: normalizeClass({
                    "alc-cpt-form-display": c.display,
                    "operation-slots": c.prop === t.operationSlotName
                  })
                }, createSlots({
                  default: withCtx(() => [
                    c.isSlots && e.$slots[c.prop] ? renderSlot(e.$slots, c.prop, { key: 0 }) : c.display ? (openBlock(), createBlock(t.AlcDisplay, {
                      key: 1,
                      "model-value": t.formData[c.prop],
                      formatter: c.formatter,
                      "item-type": c.itemType,
                      code: c.code || c.type || c.precision
                    }, null, 8, ["model-value", "formatter", "item-type", "code"])) : t.weightTypeRef[c.itemType] ? (openBlock(), createBlock(resolveDynamicComponent(t.weightTypeRef[c.itemType]), mergeProps({
                      key: 2,
                      ref_for: !0
                    }, t.componentProp(c), {
                      ref_for: !0,
                      ref: (p) => t.mountRefs(p, c.prop, c.ref),
                      modelValue: t.formData[c.prop],
                      "onUpdate:modelValue": (p) => t.formData[c.prop] = p,
                      name: c.prop,
                      clearable: c.clearable ?? e.clearable,
                      "validate-event": c.validateEvent ?? e.validateEvent,
                      style: { width: "100%" },
                      onChange: (p) => e.$emit("change", {
                        prop: c.prop,
                        value: p
                      })
                    }), createSlots({ _: 2 }, [
                      renderList(Object.keys(c.slots || {}), (p) => ({
                        name: p,
                        fn: withCtx(() => [
                          (openBlock(), createBlock(resolveDynamicComponent(c.slots[p])))
                        ])
                      }))
                    ]), 1040, ["modelValue", "onUpdate:modelValue", "name", "clearable", "validate-event", "onChange"])) : createCommentVNode("", !0)
                  ]),
                  _: 2
                }, [
                  !e.hideLabel && c.prop !== t.operationSlotName ? {
                    name: "label",
                    fn: withCtx(() => [
                      createElementVNode("span", {
                        style: normalizeStyle({
                          fontSize: t.getLabelSize(c.labelSize),
                          color: c.labelColor
                        })
                      }, toDisplayString$1(c.label), 5),
                      t.isBlank(c.tips) ? createCommentVNode("", !0) : (openBlock(), createBlock(t.AlcTooltip, {
                        key: 0,
                        content: c.tips,
                        tabindex: null
                      }, null, 8, ["content"]))
                    ]),
                    key: "0"
                  } : void 0
                ]), 1032, ["label", "prop", "label-width", "class"]))
              ]),
              _: 2
            }, 1032, ["span", "offset"])) : createCommentVNode("", !0)
          ], 64))), 128))
        ]),
        _: 2
      }, 1032, ["gutter"]))), 128))
    ]),
    _: 3
  }, 16, ["model", "rules", "disabled", "label-width", "class"]);
}
const Form = /* @__PURE__ */ _export_sfc(_sfc_main$y, [["render", _sfc_render$y], ["__file", "form.vue"]]), AlcForm = withInstall(Form), alcExportGrpProps = {
  /**
   * 数据源
   * @description 不建议使用 export 事件，流程碎片化，不易维护
   */
  dataSource: {
    type: [Array, Function],
    default: () => []
  },
  /**
   * 导出范围
   * @default 'current'
   */
  defaultScope: {
    type: String,
    default: "current"
  },
  /**
   * 数据分页大小
   * @default 50
   */
  pageSize: { type: Number, default: 50 },
  /**
   * 导出的文件名
   * @default `导出数据${Date.now()}`
   */
  fileName: { type: String, default: `导出数据${Date.now()}` },
  /**
   * 模板 code
   * @description 用模板 code 获取模板内容
   */
  code: { type: String }
}, useExportForm = (e, o) => {
  const n = ref(
    Object.assign(
      {
        pageIndex: 1,
        pageNumber: 3,
        maxSize: 1e4
      },
      e
    )
  ), t = 3, r = [
    { value: "all", label: "全部" },
    { value: "current", label: "当前页" },
    { value: "customize", label: "自定义" },
    { value: "selected", label: "选中项" }
  ], a = computed(() => [
    {
      label: "导出格式",
      prop: "format",
      itemType: "select",
      options: [
        { value: "xls", label: "EXCEL" },
        { value: "csv", label: "CSV" }
      ],
      span: 12
    },
    {
      itemType: "select",
      label: "数据范围",
      prop: "type",
      options: r,
      span: 12
    },
    {
      itemType: "number",
      label: "起始页码",
      prop: "pageIndex",
      min: 1,
      max: n.value.maxSize,
      disabled: n.value.type !== "customize",
      newLine: !0
    },
    {
      itemType: "number",
      label: "每页条数",
      prop: "pageSize",
      min: 1,
      disabled: n.value.type !== "customize",
      max: 1e4
    },
    {
      itemType: "number",
      label: "加载页数",
      prop: "pageNumber",
      min: 1,
      max: 1e3,
      disabled: n.value.type !== "customize"
    }
  ]);
  return {
    exportState: n,
    baseSchema: a,
    columns: t
  };
}, _sfc_main$x = /* @__PURE__ */ defineComponent({
  name: "alc-export-grp",
  __name: "export-grp",
  props: alcExportGrpProps,
  setup(e, { expose: o }) {
    o();
    const n = e, {
      exportState: t,
      baseSchema: r,
      columns: a
    } = useExportForm({
      type: n.defaultScope || "all",
      format: "xls",
      pageSize: n.pageSize
    });
    onDialogConfirm(l);
    async function l() {
      if (!n.code)
        return void warn$2("components/export-grp", "请提供模板 code");
      try {
        await checkGrpServerState();
        const c = typeof n.dataSource == "function" ? await n.dataSource(t.value) : n.dataSource;
        await exportByGrpTemplate(
          {
            code: n.code,
            showOptionDlg: !0,
            SameAsPrint: !1,
            type: t.value.format,
            filename: n.fileName
          },
          c
        );
      } catch (c) {
        return warn$2("components/export-grp", c), !1;
      }
    }
    const s = { props: n, exportState: t, schema: r, columns: a, exportData: l, get AlcForm() {
      return AlcForm;
    } };
    return Object.defineProperty(s, "__isScriptSetup", { enumerable: !1, value: !0 }), s;
  }
});
function _sfc_render$x(e, o, n, t, r, a) {
  return openBlock(), createBlock(t.AlcForm, {
    modelValue: t.exportState,
    "onUpdate:modelValue": o[0] || (o[0] = (l) => t.exportState = l),
    schema: t.schema,
    columns: t.columns
  }, null, 8, ["modelValue", "schema", "columns"]);
}
const AlcExportGrp = /* @__PURE__ */ _export_sfc(_sfc_main$x, [["render", _sfc_render$x], ["__file", "export-grp.vue"]]), alcExportListProps = {
  /**
   * 数据源
   * @description 不建议使用 export 事件，流程碎片化，不易维护
   */
  dataSource: {
    type: [Array, Function],
    default: () => []
  },
  /**
   * 导出范围
   * @default 'current'
   */
  defaultScope: {
    type: String,
    default: "current"
  },
  /**
   * 数据分页大小
   * @default 50
   */
  pageSize: { type: Number, default: 50 },
  /**
   * 导出的文件名
   */
  fileName: { type: String },
  /**
   * 导出的列配置
   */
  colInfo: {
    type: Object
  },
  /**
   * 导出的工作表名称
   * @default 'sheet1'
   */
  sheetName: { type: String, default: "sheet1" },
  /**
   * 导出导入组件支持的格式
   * @default false
   */
  supportImport: { type: Boolean, default: !1 },
  /**
   * 最多导出的数据量
   * @default 10000
   */
  maxSize: { type: Number, default: 1e4 }
};
function exportToExcel(e, {
  fileName: o = `导出文件_${Date.now()}`,
  sheetName: n = "sheet1",
  colInfo: t,
  format: r = "xls",
  supportImport: a
} = {}) {
  if (!isArray(e) || e.length === 0)
    return operatorErrorTip("导出数据为空"), !1;
  let l = e, s = [];
  if (isPlainObject(t)) {
    const p = Object.keys(t);
    a ? l = e.map((f) => objPick(f, p)) : l = e.map((f) => p.reduce((g, b) => (Object.hasOwn(f, b) && (isPlainObject(t[b]) ? g[b] = toDisplayString(
      t[b].fieldType,
      f[b],
      t[b].fieldTypeCode
    ) : g[b] = f[b]), g), {})), l.unshift(
      Object.entries(t).reduce((f, [g, b]) => (f[g] = `${typeof b == "string" ? b : b.label}${a ? `|${g}` : ""}`, f), {})
    ), s = Object.values(t).map((f) => isPlainObject(f) ? f : { label: f, wpx: 150 });
  }
  const c = utils.book_new(), d = utils.json_to_sheet(l, {
    skipHeader: !!t
  });
  return d["!cols"] = s, utils.book_append_sheet(c, d, n), r === "xls" ? (writeFileXLSX(c, `${o}.xlsx`, {
    type: "string",
    bookType: "xlsx"
  }), !0) : r === "csv" ? (writeFile(c, `${o}.csv`, {
    type: "string",
    bookType: "csv"
  }), !0) : (warn$2("components/xlsx", "导出格式不受支持"), !1);
}
function readExcel(e) {
  return new Promise((o, n) => {
    const t = new FileReader();
    t.readAsArrayBuffer(e), t.onload = function(r) {
      const a = read(r.target.result, {
        type: "binary"
      });
      a.SheetNames.length ? o(
        a.SheetNames.map((l) => {
          const [s, ...c] = utils.sheet_to_json(
            a.Sheets[l],
            { header: 1 }
          );
          return {
            sheetName: l,
            data: c.flatMap((d) => s.reduce((p, f, g) => (p[f] = d[g], p), markRaw({})))
          };
        })
      ) : o([]);
    }, t.onerror = n;
  });
}
const _sfc_main$w = /* @__PURE__ */ defineComponent({
  name: "alc-list-export",
  __name: "export-list",
  props: alcExportListProps,
  setup(e, { expose: o }) {
    o();
    const n = e;
    onDialogConfirm(l);
    const {
      exportState: t,
      baseSchema: r,
      columns: a
    } = useExportForm({
      type: n.defaultScope || "all",
      format: "xls",
      pageSize: n.pageSize,
      maxSize: n.maxSize
    });
    async function l() {
      if (t.value.pageNumber * t.value.pageIndex > n.maxSize) {
        operatorErrorTip(
          `最多导出 ${toDisplayString(
            "number",
            n.maxSize,
            0,
            !0
          )} 条数据，请重新设置`
        );
        return;
      }
      let c;
      if (typeof n.dataSource == "function")
        try {
          c = await n.dataSource(t.value);
        } catch (d) {
          warn$2("components/export-list", d);
          return;
        }
      else
        c = n.dataSource;
      return exportToExcel(c, {
        fileName: n.fileName,
        sheetName: n.sheetName,
        colInfo: n.colInfo,
        format: t.value.format,
        supportImport: n.supportImport
      });
    }
    const s = { props: n, exportState: t, schema: r, columns: a, exportData: l, get AlcForm() {
      return AlcForm;
    } };
    return Object.defineProperty(s, "__isScriptSetup", { enumerable: !1, value: !0 }), s;
  }
});
function _sfc_render$w(e, o, n, t, r, a) {
  return openBlock(), createBlock(t.AlcForm, {
    modelValue: t.exportState,
    "onUpdate:modelValue": o[0] || (o[0] = (l) => t.exportState = l),
    schema: t.schema,
    columns: t.columns
  }, null, 8, ["modelValue", "schema", "columns"]);
}
const AlcExportList = /* @__PURE__ */ _export_sfc(_sfc_main$w, [["render", _sfc_render$w], ["__file", "export-list.vue"]]), alcPrintGrpProps = {
  /**
   * 打印模板 code
   */
  templateCode: { type: String, default: void 0 },
  /**
   * 单据 code
   * @description 如果传入单据 code，则会获取单据的打印模板列表
   */
  voucherCode: { type: String, default: void 0 },
  /**
   * 流程实例 id
   */
  processInst: { type: String, default: void 0 },
  /**
   * 数据源
   * @description 不建议使用 export 事件，流程碎片化，不易维护
   */
  dataSource: {
    type: [Array, Function],
    default: () => []
  },
  /**
   * 打印范围
   * @default 'current'
   */
  defaultScope: {
    type: String,
    default: "current"
  },
  /**
   * 数据分页大小
   * @default 50
   */
  pageSize: { type: Number, default: 50 }
}, _sfc_main$v = /* @__PURE__ */ defineComponent({
  name: "alc-grp-print",
  __name: "print-grp",
  props: alcPrintGrpProps,
  setup(e, { expose: o }) {
    o();
    const n = e, { exportState: t, baseSchema: r, columns: a } = useExportForm({
      type: n.defaultScope || "all",
      pageSize: n.pageSize,
      preview: !1
    }), l = {
      itemType: "checkbox",
      label: "预览",
      prop: "preview"
    }, s = useProviderConfig("state");
    onDialogConfirm(b);
    const c = shallowRef([]);
    n.voucherCode && g();
    const d = ref(), p = n.voucherCode ? computed(() => [
      {
        itemType: "select",
        label: "打印模板",
        prop: "printTempUuid",
        options: c.value,
        span: 16
      },
      l
    ]) : computed(() => [...r.value, l]), f = n.voucherCode ? computed(() => ({
      printTempUuid: {
        required: !0,
        message: "请选择打印模板",
        trigger: "change"
      }
    })) : {};
    function g() {
      msGet(
        `alc-city-framework/SysVoucherTemplatePcAction/getVouchPrintTemplateList/${n.voucherCode}/${s.value.cOrgUuid}`
      ).then((x) => {
        x.code === 1 ? c.value = x.data.map((N) => (N.bOrgDefault && (t.value.printTempUuid = N.cTemplateUuid), {
          value: N.cTemplateUuid,
          label: N.cTemplateName
        })) || [] : operatorErrorTip(x.msg);
      }).catch(() => {
        apiLinkErrorTip("单据打印模板");
      });
    }
    async function b() {
      if (f.value && !await d.value.validate())
        return;
      let x;
      if (typeof n.dataSource == "function")
        try {
          x = await n.dataSource(t.value);
        } catch {
          return;
        }
      else
        x = n.dataSource;
      if (n.templateCode)
        return printByGrpTemplate(
          {
            code: n.templateCode,
            preview: t.value.preview,
            processInst: n.processInst
          },
          x
        ).then(() => !0).catch((N) => {
          N.msg && operatorErrorTip(N.msg);
        });
      if (t.value.printTempUuid)
        return printByGrpTemplate(
          {
            voucherTemplateUuid: t.value.printTempUuid,
            preview: t.value.preview,
            processInst: n.processInst
          },
          x
        ).then(() => !0).catch((N) => {
          N.msg && operatorErrorTip(N.msg);
        });
    }
    const k = { props: n, exportState: t, baseSchema: r, columns: a, previewItem: l, coreState: s, printTempList: c, formRef: d, schema: p, rules: f, getVoucherPrintTemp: g, printData: b, get AlcForm() {
      return AlcForm;
    } };
    return Object.defineProperty(k, "__isScriptSetup", { enumerable: !1, value: !0 }), k;
  }
});
function _sfc_render$v(e, o, n, t, r, a) {
  return openBlock(), createBlock(t.AlcForm, {
    ref: "formRef",
    modelValue: t.exportState,
    "onUpdate:modelValue": o[0] || (o[0] = (l) => t.exportState = l),
    schema: t.schema,
    rules: t.rules,
    columns: t.columns
  }, null, 8, ["modelValue", "schema", "rules", "columns"]);
}
const AlcPrintGrp = /* @__PURE__ */ _export_sfc(_sfc_main$v, [["render", _sfc_render$v], ["__file", "print-grp.vue"]]), _sfc_main$u = /* @__PURE__ */ defineComponent({
  name: "alc-import-data-preview",
  __name: "import-preview",
  props: {
    data: {}
  },
  setup(e, { expose: o }) {
    o();
    const n = e, t = ref(n.data[0].sheetName), r = /* @__PURE__ */ new Set([t.value]);
    watch(t, (s) => {
      r.add(s);
    });
    const a = n.data.reduce(
      (s, c) => (s[c.sheetName] = useSliceList(c.data), s),
      reactive({})
    ), l = { props: n, activeTab: t, renderList: r, paging: a, get AlcList() {
      return AlcList;
    }, get ElTabPane() {
      return ElTabPane;
    }, get ElTabs() {
      return ElTabs;
    } };
    return Object.defineProperty(l, "__isScriptSetup", { enumerable: !1, value: !0 }), l;
  }
}), _hoisted_1$q = { class: "h100 auto-height--wrap" };
function _sfc_render$u(e, o, n, t, r, a) {
  return openBlock(), createElementBlock("div", _hoisted_1$q, [
    n.data.length > 1 ? (openBlock(), createBlock(t.ElTabs, {
      key: 0,
      modelValue: t.activeTab,
      "onUpdate:modelValue": o[0] || (o[0] = (l) => t.activeTab = l)
    }, {
      default: withCtx(() => [
        (openBlock(!0), createElementBlock(Fragment, null, renderList(n.data, (l) => (openBlock(), createBlock(t.ElTabPane, {
          key: l.sheetName,
          label: l.sheetName,
          name: l.sheetName
        }, null, 8, ["label", "name"]))), 128))
      ]),
      _: 1
    }, 8, ["modelValue"])) : createCommentVNode("", !0),
    (openBlock(!0), createElementBlock(Fragment, null, renderList(n.data, (l) => (openBlock(), createElementBlock(Fragment, {
      key: l.sheetName
    }, [
      t.renderList.has(l.sheetName) ? withDirectives((openBlock(), createBlock(t.AlcList, {
        key: 0,
        "page-size": t.paging[l.sheetName].paging.pageSize,
        "onUpdate:pageSize": (s) => t.paging[l.sheetName].paging.pageSize = s,
        "current-page": t.paging[l.sheetName].paging.pageNumber,
        "onUpdate:currentPage": (s) => t.paging[l.sheetName].paging.pageNumber = s,
        schema: l.column,
        data: t.paging[l.sheetName].sliceList,
        total: t.paging[l.sheetName].total,
        class: "auto-height--target"
      }, null, 8, ["page-size", "onUpdate:pageSize", "current-page", "onUpdate:currentPage", "schema", "data", "total"])), [
        [vShow, t.activeTab === l.sheetName]
      ]) : createCommentVNode("", !0)
    ], 64))), 128))
  ]);
}
const AlcImportDataPreview = /* @__PURE__ */ _export_sfc(_sfc_main$u, [["render", _sfc_render$u], ["__file", "import-preview.vue"]]), _sfc_main$t = /* @__PURE__ */ defineComponent({
  name: "alc-import-data",
  __name: "import-data",
  props: {
    code: {},
    tableSchema: {},
    schemaTitle: {},
    preview: { type: Boolean, default: !0 },
    usePublicUrl: { type: Boolean },
    multipleSheet: { type: Boolean },
    onImportData: {}
  },
  emits: ["importData"],
  setup(e, { expose: o, emit: n }) {
    o();
    const t = e, r = n, { close: a } = useDialogState(), l = useProviderConfig("state"), s = useUsePublicUrl(), c = shallowRef([]), d = ref(0), p = ref(!1), f = ref(!1), g = ref(!1), b = ref(!1), k = (U) => {
      p.value = !1, nextTick(() => {
        p.value = !0;
      });
      const E = U.raw;
      if (!E)
        return void operatorErrorTip("请上传附件");
      if (!E.name.endsWith(".xlsx") && !E.name.endsWith(".xls"))
        return void operatorErrorTip("文件格式错误，请重新上传");
      f.value = !0, c.value = [], readExcel(E).then((C) => {
        isArray(C) && (c.value = C.reduce(
          (I, v, M) => {
            if (!v.data.length || !t.multipleSheet && M > 0)
              return I;
            const $ = {
              sheetName: v.sheetName,
              data: v.data.reduce((H, X) => (Object.values(X).some((te) => te !== void 0) && H.push(
                Object.keys(X).reduce(
                  (te, oe) => {
                    const ne = oe.split("|")[1];
                    return te[ne] = X[oe], te;
                  },
                  {}
                )
              ), H), []),
              column: []
            };
            if (t.preview) {
              const H = v.data[0];
              $.column = Object.keys(H).reduce((X, te) => {
                const [oe, ne] = te.split("|");
                return X.push({
                  itemType: typeof H[te] == "number" ? "number" : typeof H[te] == "boolean" ? "checkbox" : "input",
                  label: oe,
                  prop: ne,
                  minWidth: 156,
                  width: 156
                }), X;
              }, []);
            }
            return I.push($), I;
          },
          []
        )), d.value = 2, ElMessage.success(
          `文件解析成功${c.value.length ? "" : "，但没有合法数据"}`
        );
      }).catch(() => {
        operatorErrorTip("文件解析失败，请检查文件内容是否正确");
      }).finally(() => {
        f.value = !1;
      });
    };
    function x() {
      d.value--;
    }
    function N() {
      d.value = 1, p.value = !0;
    }
    async function O() {
      if (!t.code && !t.tableSchema)
        return void operatorErrorTip("请指定导入模板标识");
      if (g.value)
        return;
      if (g.value = !0, t.tableSchema) {
        m(t.tableSchema), g.value = !1;
        return;
      }
      let U;
      try {
        const E = await ee(t.code);
        if (E.code === 1)
          U = E.data[0].cDocId;
        else
          return g.value = !1, void operatorErrorTip(E.msg);
      } catch {
        return g.value = !1, void apiLinkErrorTip("文件档案");
      }
      apiDownloadFile(
        U,
        l.value.cAllLinkUserUuid,
        s.value,
        "d98e6fee9c5411e0b12c881b000cba999888"
      ).finally(() => {
        g.value = !1;
      });
    }
    function m(U) {
      const E = U.map((v) => `${v.label}|${v.prop}`), C = utils.book_new(), I = utils.json_to_sheet([{}], {
        header: E,
        skipHeader: !1
      });
      utils.book_append_sheet(C, I, "sheet1"), writeFileXLSX(
        C,
        `${t.schemaTitle ? `${t.schemaTitle}导入模板` : Date.now()}.xlsx`,
        {
          type: "string",
          bookType: "xlsx"
        }
      );
    }
    function ee(U) {
      return msPost(`alc-public-opm/FileInfoAction/findBycFileCode/${U}`);
    }
    function z(U) {
      c.value.length ? U() : operatorErrorTip("没有解析到合法数据");
    }
    function P() {
      r("importData", {
        data: c.value.map((U) => objPick(U, ["data", "sheetName"]))
      }), a();
    }
    const V = { props: t, emits: r, close: a, coreState: l, usePublicUrl$: s, importData: c, stepIndex: d, isUploadShow: p, uploadLoading: f, downloadLoading: g, previewDialogVisible: b, chooseExcel: k, btnPrevStepClick: x, btnNextStepClick: N, downloadTemplate: O, generateTemplate: m, getTemplateById: ee, beforePreview: z, btnImportDataClick: P, get AlcDialog() {
      return AlcDialog;
    }, get AlcDialogFooter() {
      return AlcDialogFooter;
    }, get ElButton() {
      return ElButton;
    }, get ElStep() {
      return ElStep;
    }, get ElSteps() {
      return ElSteps;
    }, get ElUpload() {
      return ElUpload;
    }, AlcImportDataPreview };
    return Object.defineProperty(V, "__isScriptSetup", { enumerable: !1, value: !0 }), V;
  }
}), _hoisted_1$p = { class: "alc-component-data-import-container" }, _hoisted_2$l = {
  key: 0,
  class: "cpt-data-import-illustrate-container"
}, _hoisted_3$i = /* @__PURE__ */ createStaticVNode('<div class="cpt-data-import-illustrate"> 1、点击 <span class="cpt-data-import-illustrate-keynote"> [下载模板] </span> ，将数据模板下载至本地，如果已有模板请直接进行下一步； </div><div class="cpt-data-import-illustrate"> 2、对模板进行数据编辑时，请勿编辑首行标题和单元格格式； </div><div class="cpt-data-import-illustrate"> 3、模板数据编辑完成后，点击 <span class="cpt-data-import-illustrate-keynote"> [下一步] </span> ，上传Excel文件。 </div>', 3), _hoisted_6$a = {
  key: 1,
  class: "cpt-data-import-illustrate-container"
}, _hoisted_7$a = /* @__PURE__ */ createElementVNode("div", { class: "cpt-data-import-illustrate" }, [
  /* @__PURE__ */ createTextVNode(" 1、点击 "),
  /* @__PURE__ */ createElementVNode("span", { class: "cpt-data-import-illustrate-keynote" }, " [上传文件] "),
  /* @__PURE__ */ createTextVNode(" ，选择上一步下载的数据模板，不要使用类型其他模板文件； ")
], -1), _hoisted_8$9 = /* @__PURE__ */ createElementVNode("div", { class: "cpt-data-import-illustrate" }, " 2、数据模板上传并解析成功后，会跳转至完成页面。 ", -1), _hoisted_9$9 = [
  _hoisted_7$a,
  _hoisted_8$9
], _hoisted_10$8 = {
  key: 2,
  class: "cpt-data-import-illustrate-container"
}, _hoisted_11$7 = /* @__PURE__ */ createElementVNode("div", { class: "cpt-data-import-illustrate" }, [
  /* @__PURE__ */ createTextVNode(" 1、点击 "),
  /* @__PURE__ */ createElementVNode("span", { class: "cpt-data-import-illustrate-keynote" }, " [上一步] "),
  /* @__PURE__ */ createTextVNode(" ，可重新选择上传数据模板文件； ")
], -1), _hoisted_12$6 = /* @__PURE__ */ createElementVNode("div", { class: "cpt-data-import-illustrate" }, [
  /* @__PURE__ */ createTextVNode(" 2、点击 "),
  /* @__PURE__ */ createElementVNode("span", { class: "cpt-data-import-illustrate-keynote" }, " [导入数据] "),
  /* @__PURE__ */ createTextVNode(" ，完成模板数据的导入。 ")
], -1), _hoisted_13$5 = {
  key: 0,
  class: "cpt-data-import-illustrate"
}, _hoisted_14$3 = /* @__PURE__ */ createElementVNode("span", { class: "cpt-data-import-illustrate-keynote" }, " [查看数据] ", -1);
function _sfc_render$t(e, o, n, t, r, a) {
  return openBlock(), createElementBlock(Fragment, null, [
    createElementVNode("div", _hoisted_1$p, [
      createVNode(t.ElSteps, {
        active: t.stepIndex,
        "align-center": ""
      }, {
        default: withCtx(() => [
          createVNode(t.ElStep, { title: "下载模板" }),
          createVNode(t.ElStep, { title: "导入Excel" }),
          createVNode(t.ElStep, { title: "完成" })
        ]),
        _: 1
      }, 8, ["active"]),
      t.stepIndex === 0 ? (openBlock(), createElementBlock("div", _hoisted_2$l, [
        _hoisted_3$i,
        createVNode(t.ElButton, {
          loading: t.downloadLoading,
          text: "",
          type: "primary",
          class: "cpt-data-import-download",
          onClick: t.downloadTemplate
        }, {
          default: withCtx(() => [
            createTextVNode(" [下载模板] ")
          ]),
          _: 1
        }, 8, ["loading"])
      ])) : createCommentVNode("", !0),
      t.stepIndex === 1 ? (openBlock(), createElementBlock("div", _hoisted_6$a, _hoisted_9$9)) : createCommentVNode("", !0),
      t.stepIndex === 2 ? (openBlock(), createElementBlock("div", _hoisted_10$8, [
        _hoisted_11$7,
        _hoisted_12$6,
        t.stepIndex === 2 && n.preview === !0 ? (openBlock(), createElementBlock("div", _hoisted_13$5, [
          createTextVNode(" 3、点击 "),
          _hoisted_14$3,
          createTextVNode(" ，可预览导入的数据。 ")
        ])) : createCommentVNode("", !0)
      ])) : createCommentVNode("", !0)
    ]),
    createVNode(t.AlcDialogFooter, null, {
      default: withCtx(() => [
        t.stepIndex === 0 ? (openBlock(), createBlock(t.ElButton, {
          key: 0,
          onClick: t.btnNextStepClick
        }, {
          default: withCtx(() => [
            createTextVNode(" 下一步 ")
          ]),
          _: 1
        })) : createCommentVNode("", !0),
        t.stepIndex === 1 || t.stepIndex === 2 ? (openBlock(), createBlock(t.ElButton, {
          key: 1,
          onClick: t.btnPrevStepClick
        }, {
          default: withCtx(() => [
            createTextVNode(" 上一步 ")
          ]),
          _: 1
        })) : createCommentVNode("", !0),
        t.stepIndex === 1 && t.isUploadShow ? (openBlock(), createBlock(t.ElUpload, {
          key: 2,
          action: "",
          accept: ".xls,.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel",
          style: { display: "inline-block", "margin-left": "10px" },
          "show-file-list": !1,
          "auto-upload": !1,
          limit: 1,
          "on-change": t.chooseExcel
        }, {
          default: withCtx(() => [
            createVNode(t.ElButton, {
              type: "primary",
              loading: t.uploadLoading
            }, {
              default: withCtx(() => [
                createTextVNode(" 上传文件 ")
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _: 1
        })) : createCommentVNode("", !0),
        t.stepIndex === 2 && n.preview === !0 ? (openBlock(), createBlock(t.AlcDialog, {
          key: 3,
          modelValue: t.previewDialogVisible,
          "onUpdate:modelValue": o[0] || (o[0] = (l) => t.previewDialogVisible = l),
          title: "预览",
          "show-footer": !1,
          "before-open": t.beforePreview,
          "show-fullscreen": "",
          "content-height-fit": "",
          "width-type": "md",
          class: "alc-cpt-data-preview"
        }, {
          reference: withCtx(() => [
            createVNode(t.ElButton, null, {
              default: withCtx(() => [
                createTextVNode("查看数据")
              ]),
              _: 1
            })
          ]),
          default: withCtx(() => [
            createVNode(t.AlcImportDataPreview, { data: t.importData }, null, 8, ["data"])
          ]),
          _: 1
        }, 8, ["modelValue"])) : createCommentVNode("", !0),
        t.stepIndex === 2 ? (openBlock(), createBlock(t.ElButton, {
          key: 4,
          type: "success",
          onClick: t.btnImportDataClick
        }, {
          default: withCtx(() => [
            createTextVNode(" 导入数据 ")
          ]),
          _: 1
        })) : createCommentVNode("", !0)
      ]),
      _: 1
    })
  ], 64);
}
const AlcImportData = /* @__PURE__ */ _export_sfc(_sfc_main$t, [["render", _sfc_render$t], ["__file", "import-data.vue"]]);
function toBoolean(e) {
  return e === "" ? e : e === "true" || e == "1";
}
function readAsArrayBuffer(e, o) {
  return new Promise((n, t) => {
    var r = new XMLHttpRequest();
    r.responseType = "blob", r.onload = function() {
      var a = new FileReader();
      a.onloadend = function() {
        n(a.result);
      }, a.readAsArrayBuffer(r.response);
    }, r.open("GET", e), r.send();
  });
}
function assertPath(e) {
  if (typeof e != "string")
    throw new TypeError("Path must be a string. Received " + JSON.stringify(e));
}
function normalizeStringPosix(e, o) {
  for (var n = "", t = 0, r = -1, a = 0, l, s = 0; s <= e.length; ++s) {
    if (s < e.length)
      l = e.charCodeAt(s);
    else {
      if (l === 47)
        break;
      l = 47;
    }
    if (l === 47) {
      if (!(r === s - 1 || a === 1)) if (r !== s - 1 && a === 2) {
        if (n.length < 2 || t !== 2 || n.charCodeAt(n.length - 1) !== 46 || n.charCodeAt(n.length - 2) !== 46) {
          if (n.length > 2) {
            var c = n.lastIndexOf("/");
            if (c !== n.length - 1) {
              c === -1 ? (n = "", t = 0) : (n = n.slice(0, c), t = n.length - 1 - n.lastIndexOf("/")), r = s, a = 0;
              continue;
            }
          } else if (n.length === 2 || n.length === 1) {
            n = "", t = 0, r = s, a = 0;
            continue;
          }
        }
        o && (n.length > 0 ? n += "/.." : n = "..", t = 2);
      } else
        n.length > 0 ? n += "/" + e.slice(r + 1, s) : n = e.slice(r + 1, s), t = s - r - 1;
      r = s, a = 0;
    } else l === 46 && a !== -1 ? ++a : a = -1;
  }
  return n;
}
function _format(e, o) {
  var n = o.dir || o.root, t = o.base || (o.name || "") + (o.ext || "");
  return n ? n === o.root ? n + t : n + e + t : t;
}
var posix = {
  // path.resolve([from ...], to)
  resolve: function() {
    for (var o = "", n = !1, t, r = arguments.length - 1; r >= -1 && !n; r--) {
      var a;
      r >= 0 ? a = arguments[r] : (t === void 0 && (t = process.cwd()), a = t), assertPath(a), a.length !== 0 && (o = a + "/" + o, n = a.charCodeAt(0) === 47);
    }
    return o = normalizeStringPosix(o, !n), n ? o.length > 0 ? "/" + o : "/" : o.length > 0 ? o : ".";
  },
  normalize: function(o) {
    if (assertPath(o), o.length === 0) return ".";
    var n = o.charCodeAt(0) === 47, t = o.charCodeAt(o.length - 1) === 47;
    return o = normalizeStringPosix(o, !n), o.length === 0 && !n && (o = "."), o.length > 0 && t && (o += "/"), n ? "/" + o : o;
  },
  isAbsolute: function(o) {
    return assertPath(o), o.length > 0 && o.charCodeAt(0) === 47;
  },
  join: function() {
    if (arguments.length === 0)
      return ".";
    for (var o, n = 0; n < arguments.length; ++n) {
      var t = arguments[n];
      assertPath(t), t.length > 0 && (o === void 0 ? o = t : o += "/" + t);
    }
    return o === void 0 ? "." : posix.normalize(o);
  },
  relative: function(o, n) {
    if (assertPath(o), assertPath(n), o === n || (o = posix.resolve(o), n = posix.resolve(n), o === n)) return "";
    for (var t = 1; t < o.length && o.charCodeAt(t) === 47; ++t)
      ;
    for (var r = o.length, a = r - t, l = 1; l < n.length && n.charCodeAt(l) === 47; ++l)
      ;
    for (var s = n.length, c = s - l, d = a < c ? a : c, p = -1, f = 0; f <= d; ++f) {
      if (f === d) {
        if (c > d) {
          if (n.charCodeAt(l + f) === 47)
            return n.slice(l + f + 1);
          if (f === 0)
            return n.slice(l + f);
        } else a > d && (o.charCodeAt(t + f) === 47 ? p = f : f === 0 && (p = 0));
        break;
      }
      var g = o.charCodeAt(t + f), b = n.charCodeAt(l + f);
      if (g !== b)
        break;
      g === 47 && (p = f);
    }
    var k = "";
    for (f = t + p + 1; f <= r; ++f)
      (f === r || o.charCodeAt(f) === 47) && (k.length === 0 ? k += ".." : k += "/..");
    return k.length > 0 ? k + n.slice(l + p) : (l += p, n.charCodeAt(l) === 47 && ++l, n.slice(l));
  },
  _makeLong: function(o) {
    return o;
  },
  dirname: function(o) {
    if (assertPath(o), o.length === 0) return ".";
    for (var n = o.charCodeAt(0), t = n === 47, r = -1, a = !0, l = o.length - 1; l >= 1; --l)
      if (n = o.charCodeAt(l), n === 47) {
        if (!a) {
          r = l;
          break;
        }
      } else
        a = !1;
    return r === -1 ? t ? "/" : "." : t && r === 1 ? "//" : o.slice(0, r);
  },
  basename: function(o, n) {
    if (n !== void 0 && typeof n != "string") throw new TypeError('"ext" argument must be a string');
    assertPath(o);
    var t = 0, r = -1, a = !0, l;
    if (n !== void 0 && n.length > 0 && n.length <= o.length) {
      if (n.length === o.length && n === o) return "";
      var s = n.length - 1, c = -1;
      for (l = o.length - 1; l >= 0; --l) {
        var d = o.charCodeAt(l);
        if (d === 47) {
          if (!a) {
            t = l + 1;
            break;
          }
        } else
          c === -1 && (a = !1, c = l + 1), s >= 0 && (d === n.charCodeAt(s) ? --s === -1 && (r = l) : (s = -1, r = c));
      }
      return t === r ? r = c : r === -1 && (r = o.length), o.slice(t, r);
    } else {
      for (l = o.length - 1; l >= 0; --l)
        if (o.charCodeAt(l) === 47) {
          if (!a) {
            t = l + 1;
            break;
          }
        } else r === -1 && (a = !1, r = l + 1);
      return r === -1 ? "" : o.slice(t, r);
    }
  },
  extname: function(o) {
    assertPath(o);
    for (var n = -1, t = 0, r = -1, a = !0, l = 0, s = o.length - 1; s >= 0; --s) {
      var c = o.charCodeAt(s);
      if (c === 47) {
        if (!a) {
          t = s + 1;
          break;
        }
        continue;
      }
      r === -1 && (a = !1, r = s + 1), c === 46 ? n === -1 ? n = s : l !== 1 && (l = 1) : n !== -1 && (l = -1);
    }
    return n === -1 || r === -1 || // We saw a non-dot character immediately before the dot
    l === 0 || // The (right-most) trimmed path component is exactly '..'
    l === 1 && n === r - 1 && n === t + 1 ? "" : o.slice(n, r);
  },
  format: function(o) {
    if (o === null || typeof o != "object")
      throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof o);
    return _format("/", o);
  },
  parse: function(o) {
    assertPath(o);
    var n = { root: "", dir: "", base: "", ext: "", name: "" };
    if (o.length === 0) return n;
    var t = o.charCodeAt(0), r = t === 47, a;
    r ? (n.root = "/", a = 1) : a = 0;
    for (var l = -1, s = 0, c = -1, d = !0, p = o.length - 1, f = 0; p >= a; --p) {
      if (t = o.charCodeAt(p), t === 47) {
        if (!d) {
          s = p + 1;
          break;
        }
        continue;
      }
      c === -1 && (d = !1, c = p + 1), t === 46 ? l === -1 ? l = p : f !== 1 && (f = 1) : l !== -1 && (f = -1);
    }
    return l === -1 || c === -1 || // We saw a non-dot character immediately before the dot
    f === 0 || // The (right-most) trimmed path component is exactly '..'
    f === 1 && l === c - 1 && l === s + 1 ? c !== -1 && (s === 0 && r ? n.base = n.name = o.slice(1, c) : n.base = n.name = o.slice(s, c)) : (s === 0 && r ? (n.name = o.slice(1, l), n.base = o.slice(1, c)) : (n.name = o.slice(s, l), n.base = o.slice(s, c)), n.ext = o.slice(l, c)), s > 0 ? n.dir = o.slice(0, s - 1) : r && (n.dir = "/"), n;
  },
  sep: "/",
  delimiter: ":",
  win32: null,
  posix: null
};
posix.posix = posix;
const extname = posix.extname, basename = posix.basename;
class Format {
  constructor() {
    let o = typeof global > "u", n = "image/png", t = "image/jpeg", r = "image/jpeg", a = "image/webp", l = "application/pdf", s = "image/svg+xml";
    Object.assign(this, {
      toMime: this.toMime.bind(this),
      fromMime: this.fromMime.bind(this),
      expected: o ? '"png", "jpg", or "webp"' : '"png", "jpg", "pdf", or "svg"',
      formats: o ? { png: n, jpg: t, jpeg: r, webp: a } : { png: n, jpg: t, jpeg: r, pdf: l, svg: s },
      mimes: o ? { [n]: "png", [t]: "jpg", [a]: "webp" } : { [n]: "png", [t]: "jpg", [l]: "pdf", [s]: "svg" }
    });
  }
  toMime(o) {
    return this.formats[(o || "").replace(/^\./, "").toLowerCase()];
  }
  fromMime(o) {
    return this.mimes[o];
  }
}
function options$1(e, {
  filename: o = "",
  extension: n = "",
  format: x,
  page: r,
  quality: a,
  matte: l,
  density: s,
  outline: c,
  archive: b
} = {}) {
  var { fromMime: p, toMime: f, expected: g } = new Format(), b = b || "canvas", k = x || n.replace(/@\d+x$/i, "") || extname(o), x = p(f(k) || k), N = f(x), O = e.length;
  if (!k)
    throw new Error(
      "Cannot determine image format (use a filename extension or 'format' argument)"
    );
  if (!x)
    throw new Error(`Unsupported file format "${k}" (expected ${g})`);
  if (!O)
    throw new RangeError(
      "Canvas has no associated contexts (try calling getContext or newPage first)"
    );
  let m, ee, z = o.replace(/{(\d*)}/g, (V, U) => (ee = !0, U = parseInt(U, 10), m = isFinite(U) ? U : isFinite(m) ? m : -1, "{}")), P = r > 0 ? r - 1 : r < 0 ? O + r : void 0;
  if (isFinite(P) && P < 0 || P >= O)
    throw new RangeError(
      O == 1 ? `Canvas only has a ‘page 1’ (${P} is out of bounds)` : `Canvas has pages 1–${O} (${P} is out of bounds)`
    );
  if (e = isFinite(P) ? [e[P]] : ee || x == "pdf" ? e : e.slice(-1), a === void 0)
    a = 0.92;
  else if (typeof a != "number" || !isFinite(a) || a < 0 || a > 1)
    throw new TypeError(
      "The quality option must be an number in the 0.0–1.0 range"
    );
  if (s === void 0) {
    let V = (n || basename(o, k)).match(/@(\d+)x$/i);
    s = V ? parseInt(V[1], 10) : 1;
  } else if (typeof s != "number" || !Number.isInteger(s) || s < 1)
    throw new TypeError("The density option must be a non-negative integer");
  return c === void 0 ? c = !0 : x == "svg" && (c = !!c), {
    filename: o,
    pattern: z,
    format: x,
    mime: N,
    pages: e,
    padding: m,
    quality: a,
    matte: l,
    density: s,
    outline: c,
    archive: b
  };
}
class Crc32 {
  static for(o) {
    return new Crc32().append(o).get();
  }
  constructor() {
    this.crc = -1;
  }
  get() {
    return ~this.crc;
  }
  append(o) {
    for (var n = this.crc | 0, t = this.table, r = 0, a = o.length | 0; r < a; r++)
      n = n >>> 8 ^ t[(n ^ o[r]) & 255];
    return this.crc = n, this;
  }
}
Crc32.prototype.table = (() => {
  var e, o, n, t = [];
  for (e = 0; e < 256; e++) {
    for (n = e, o = 0; o < 8; o++)
      n = n & 1 ? n >>> 1 ^ 3988292384 : n >>> 1;
    t[e] = n;
  }
  return t;
})();
function calloc(e) {
  let o = new Uint8Array(e), n = new DataView(o.buffer), t = {
    array: o,
    view: n,
    size: e,
    set8(r, a) {
      return n.setUint8(r, a), t;
    },
    set16(r, a) {
      return n.setUint16(r, a, !0), t;
    },
    set32(r, a) {
      return n.setUint32(r, a, !0), t;
    },
    bytes(r, a) {
      return o.set(a, r), t;
    }
  };
  return t;
}
class Zip {
  constructor(o) {
    let n = /* @__PURE__ */ new Date();
    Object.assign(this, {
      directory: o,
      offset: 0,
      files: [],
      time: (n.getHours() << 6 | n.getMinutes()) << 5 | n.getSeconds() / 2,
      date: (n.getFullYear() - 1980 << 4 | n.getMonth() + 1) << 5 | n.getDate()
    }), this.add(o);
  }
  async add(o, n) {
    let t = !n, r = Zip.encoder.encode(`${this.directory}/${t ? "" : o}`), a = new Uint8Array(t ? 0 : await n.arrayBuffer()), l = 30 + r.length, s = l + a.length, c = 16, { offset: d } = this, p = calloc(26).set32(0, 134742036).set16(6, this.time).set16(8, this.date).set32(10, Crc32.for(a)).set32(14, a.length).set32(18, a.length).set16(22, r.length);
    d += l;
    let f = calloc(l + a.length + c).set32(0, 67324752).bytes(4, p.array).bytes(30, r).bytes(l, a);
    d += a.length, f.set32(s, 134695760).bytes(s + 4, p.array.slice(10, 22)), d += c, this.files.push({ offset: d, folder: t, name: r, header: p, payload: f }), this.offset = d;
  }
  toBuffer() {
    let o = this.files.reduce(
      (f, { name: g }) => 46 + g.length + f,
      0
    ), n = calloc(o + 22), t = 0;
    for (var { offset: r, name: a, header: l, folder: s } of this.files)
      n.set32(t, 33639248).set16(t + 4, 20).bytes(t + 6, l.array).set8(t + 38, s ? 16 : 0).set32(t + 42, r).bytes(t + 46, a), t += 46 + a.length;
    n.set32(t, 101010256).set16(t + 8, this.files.length).set16(t + 10, this.files.length).set32(t + 12, o).set32(t + 16, this.offset);
    let c = new Uint8Array(this.offset + n.size), d = 0;
    for (var { payload: p } of this.files)
      c.set(p.array, d), d += p.size;
    return c.set(n.array, d), c;
  }
  get blob() {
    return new Blob([this.toBuffer()], { type: "application/zip" });
  }
}
Zip.encoder = new TextEncoder();
const asBlob = (e, o, n, t) => {
  if (t) {
    let { width: r, height: a } = e, l = Object.assign(document.createElement("canvas"), { width: r, height: a }), s = l.getContext("2d");
    s.fillStyle = t, s.fillRect(0, 0, r, a), s.drawImage(e, 0, 0), e = l;
  }
  return new Promise((r, a) => e.toBlob(r, o, n));
}, asBuffer$1 = (...e) => asBlob(...e).then((o) => o.arrayBuffer()), asDownload$1 = async (e, o, n, t, r) => {
  _download(r, await asBlob(e, o, n, t));
}, asZipDownload$1 = async (e, o, n, t, r, a, l) => {
  let s = (p) => a.replace("{}", String(p + 1).padStart(l, "0")), c = basename(r, ".zip") || "archive", d = new Zip(c);
  await Promise.all(
    e.map(async (p, f) => {
      let g = s(f);
      await d.add(g, await asBlob(p, o, n, t));
    })
  ), _download(`${c}.zip`, d.blob);
}, _download = (e, o) => {
  const n = window.URL.createObjectURL(o), t = document.createElement("a");
  t.style.display = "none", t.href = n, t.setAttribute("download", e), typeof t.download > "u" && t.setAttribute("target", "_blank"), document.body.appendChild(t), t.click(), document.body.removeChild(t), setTimeout(() => window.URL.revokeObjectURL(n), 100);
}, atScale$1 = (e, o, n) => e.map((t) => {
  if (o == 1 && !n) return t.canvas;
  let r = document.createElement("canvas"), a = r.getContext("2d"), l = t.canvas ? t.canvas : t;
  return r.width = l.width * o, r.height = l.height * o, n && (a.fillStyle = n, a.fillRect(0, 0, r.width, r.height)), a.scale(o, o), a.drawImage(l, 0, 0), r;
}), obj$1 = { asBuffer: asBuffer$1, asDownload: asDownload$1, asZipDownload: asZipDownload$1, atScale: atScale$1, options: options$1 }, { asBuffer, asDownload, asZipDownload, atScale, options } = obj$1, _toURL_ = Symbol.for("toDataURL"), loadImage$1 = (e) => new Promise(
  (o, n) => Object.assign(new Image$1(), {
    crossOrigin: "Anonymous",
    onload: o,
    onerror: n,
    src: e
  })
);
let Canvas$1 = class {
  constructor(o, n) {
    let t = document.createElement("canvas"), r = [];
    Object.defineProperty(t, "async", {
      value: !0,
      writable: !1,
      enumerable: !0
    });
    for (var [a, l] of Object.entries({
      png: () => asBuffer(t, "image/png"),
      jpg: () => asBuffer(t, "image/jpeg"),
      pages: () => r.concat(t).map((s) => s.getContext("2d"))
    }))
      Object.defineProperty(t, a, { get: l });
    return Object.assign(t, {
      width: o,
      height: n,
      newPage(...s) {
        var { width: d, height: p } = t, c = Object.assign(document.createElement("canvas"), {
          width: d,
          height: p
        });
        c.getContext("2d").drawImage(t, 0, 0), r.push(c);
        var [d, p] = s.length ? s : [d, p];
        return Object.assign(t, { width: d, height: p }).getContext("2d");
      },
      saveAs(s, c) {
        c = typeof c == "number" ? { quality: c } : c;
        let d = options(this.pages, { filename: s, ...c }), { pattern: p, padding: f, mime: g, quality: b, matte: k, density: x, archive: N } = d, O = atScale(d.pages, x);
        return f == null ? asDownload(O[0], g, b, k, s) : asZipDownload(
          O,
          g,
          b,
          k,
          N,
          p,
          f
        );
      },
      toBuffer(s = "png", c = {}) {
        c = typeof c == "number" ? { quality: c } : c;
        let d = options(this.pages, { extension: s, ...c }), { mime: p, quality: f, matte: g, pages: b, density: k } = d, x = atScale(b, k, g)[0];
        return asBuffer(x, p, f, g);
      },
      [_toURL_]: t.toDataURL.bind(t),
      toDataURL(s = "png", c = {}) {
        c = typeof c == "number" ? { quality: c } : c;
        let d = options(this.pages, { extension: s, ...c }), { mime: p, quality: f, matte: g, pages: b, density: k } = d, x = atScale(b, k, g)[0], N = x[x === t ? _toURL_ : "toDataURL"](p, f);
        return Promise.resolve(N);
      }
    });
  }
};
const {
  CanvasRenderingContext2D,
  CanvasGradient,
  CanvasPattern,
  Image: Image$1,
  ImageData,
  Path2D,
  DOMMatrix: DOMMatrix$1,
  DOMRect,
  DOMPoint
} = window, obj = {
  Canvas: Canvas$1,
  loadImage: loadImage$1,
  CanvasRenderingContext2D,
  CanvasGradient,
  CanvasPattern,
  Image: Image$1,
  ImageData,
  Path2D,
  DOMMatrix: DOMMatrix$1,
  DOMRect,
  DOMPoint
}, parse = (e, o, n = {}, t = n) => {
  if (Array.isArray(o))
    o.forEach((r) => parse(e, r, n, t));
  else if (typeof o == "function")
    o(e, n, t, parse);
  else {
    const r = Object.keys(o)[0];
    Array.isArray(o[r]) ? (t[r] = {}, parse(e, o[r], n, t[r])) : t[r] = o[r](e, n, t, parse);
  }
  return n;
}, conditional = (e, o) => (n, t, r, a) => {
  o(n, t, r) && a(n, e, t, r);
}, loop = (e, o) => (n, t, r, a) => {
  const l = [];
  let s = n.pos;
  for (; o(n, t, r); ) {
    const c = {};
    if (a(n, e, t, c), n.pos === s)
      break;
    s = n.pos, l.push(c);
  }
  return l;
}, buildStream = (e) => ({
  data: e,
  pos: 0
}), readByte = () => (e) => e.data[e.pos++], peekByte = (e = 0) => (o) => o.data[o.pos + e], readBytes = (e) => (o) => o.data.subarray(o.pos, o.pos += e), peekBytes = (e) => (o) => o.data.subarray(o.pos, o.pos + e), readString = (e) => (o) => Array.from(readBytes(e)(o)).map((n) => String.fromCharCode(n)).join(""), readUnsigned = (e) => (o) => {
  const n = readBytes(2)(o);
  return (n[1] << 8) + n[0];
}, readArray = (e, o) => (n, t, r) => {
  const a = typeof o == "function" ? o(n, t, r) : o, l = readBytes(e), s = new Array(a);
  for (var c = 0; c < a; c++)
    s[c] = l(n);
  return s;
}, subBitsTotal = (e, o, n) => {
  for (var t = 0, r = 0; r < n; r++)
    t += e[o + r] && 2 ** (n - r - 1);
  return t;
}, readBits = (e) => (o) => {
  const n = readByte()(o), t = new Array(8);
  for (var r = 0; r < 8; r++)
    t[7 - r] = !!(n & 1 << r);
  return Object.keys(e).reduce((a, l) => {
    const s = e[l];
    return s.length ? a[l] = subBitsTotal(t, s.index, s.length) : a[l] = t[s.index], a;
  }, {});
};
var subBlocksSchema = {
  blocks: (e) => {
    const n = [], t = e.data.length;
    for (var r = 0, a = readByte()(e); a !== 0 && a; a = readByte()(e)) {
      if (e.pos + a >= t) {
        const d = t - e.pos;
        n.push(readBytes(d)(e)), r += d;
        break;
      }
      n.push(readBytes(a)(e)), r += a;
    }
    const l = new Uint8Array(r);
    for (var s = 0, c = 0; c < n.length; c++)
      l.set(n[c], s), s += n[c].length;
    return l;
  }
};
const gceSchema = conditional(
  {
    gce: [
      { codes: readBytes(2) },
      { byteSize: readByte() },
      {
        extras: readBits({
          future: { index: 0, length: 3 },
          disposal: { index: 3, length: 3 },
          userInput: { index: 6 },
          transparentColorGiven: { index: 7 }
        })
      },
      { delay: readUnsigned() },
      { transparentColorIndex: readByte() },
      { terminator: readByte() }
    ]
  },
  (e) => {
    var o = peekBytes(2)(e);
    return o[0] === 33 && o[1] === 249;
  }
), imageSchema = conditional(
  {
    image: [
      { code: readByte() },
      {
        descriptor: [
          { left: readUnsigned() },
          { top: readUnsigned() },
          { width: readUnsigned() },
          { height: readUnsigned() },
          {
            lct: readBits({
              exists: { index: 0 },
              interlaced: { index: 1 },
              sort: { index: 2 },
              future: { index: 3, length: 2 },
              size: { index: 5, length: 3 }
            })
          }
        ]
      },
      conditional(
        {
          lct: readArray(3, (e, o, n) => Math.pow(2, n.descriptor.lct.size + 1))
        },
        (e, o, n) => n.descriptor.lct.exists
      ),
      { data: [{ minCodeSize: readByte() }, subBlocksSchema] }
    ]
  },
  (e) => peekByte()(e) === 44
), textSchema = conditional(
  {
    text: [
      { codes: readBytes(2) },
      { blockSize: readByte() },
      {
        preData: (e, o, n) => readBytes(n.text.blockSize)(e)
      },
      subBlocksSchema
    ]
  },
  (e) => {
    var o = peekBytes(2)(e);
    return o[0] === 33 && o[1] === 1;
  }
), applicationSchema = conditional(
  {
    application: [
      { codes: readBytes(2) },
      { blockSize: readByte() },
      { id: (e, o, n) => readString(n.blockSize)(e) },
      subBlocksSchema
    ]
  },
  (e) => {
    var o = peekBytes(2)(e);
    return o[0] === 33 && o[1] === 255;
  }
), commentSchema = conditional(
  {
    comment: [{ codes: readBytes(2) }, subBlocksSchema]
  },
  (e) => {
    var o = peekBytes(2)(e);
    return o[0] === 33 && o[1] === 254;
  }
), schema = [
  { header: [{ signature: readString(3) }, { version: readString(3) }] },
  {
    lsd: [
      { width: readUnsigned() },
      { height: readUnsigned() },
      {
        gct: readBits({
          exists: { index: 0 },
          resolution: { index: 1, length: 3 },
          sort: { index: 4 },
          size: { index: 5, length: 3 }
        })
      },
      { backgroundColorIndex: readByte() },
      { pixelAspectRatio: readByte() }
    ]
  },
  conditional(
    {
      gct: readArray(
        3,
        (e, o) => Math.pow(2, o.lsd.gct.size + 1)
      )
    },
    (e, o) => o.lsd.gct.exists
  ),
  // content frames
  {
    frames: loop(
      [gceSchema, applicationSchema, commentSchema, imageSchema, textSchema],
      (e) => {
        var o = peekByte()(e);
        return o === 33 || o === 44;
      }
    )
  }
], deinterlace = (e, o) => {
  const n = new Array(e.length), t = e.length / o, r = function(p, f) {
    const g = e.slice(f * o, (f + 1) * o);
    n.splice.apply(n, [p * o, o].concat(g));
  }, a = [0, 4, 2, 1], l = [8, 8, 4, 2];
  for (var s = 0, c = 0; c < 4; c++)
    for (var d = a[c]; d < t; d += l[c])
      r(d, s), s++;
  return n;
}, lzw = (e, o, n) => {
  const a = n;
  var l, s, c, d, p, f, g, P, b, k, z, x, V, U, C, E;
  const N = new Array(n), O = new Array(4096), m = new Array(4096), ee = new Array(4097);
  for (x = e, s = 1 << x, p = s + 1, l = s + 2, g = -1, d = x + 1, c = (1 << d) - 1, b = 0; b < s; b++)
    O[b] = 0, m[b] = b;
  var z, P, V, U, E, C;
  for (z = P = V = U = E = C = 0, k = 0; k < a; ) {
    if (U === 0) {
      if (P < d) {
        z += o[C] << P, P += 8, C++;
        continue;
      }
      if (b = z & c, z >>= d, P -= d, b > l || b == p)
        break;
      if (b == s) {
        d = x + 1, c = (1 << d) - 1, l = s + 2, g = -1;
        continue;
      }
      if (g == -1) {
        ee[U++] = m[b], g = b, V = b;
        continue;
      }
      for (f = b, b == l && (ee[U++] = V, b = g); b > s; )
        ee[U++] = m[b], b = O[b];
      V = m[b] & 255, ee[U++] = V, l < 4096 && (O[l] = g, m[l] = V, l++, !(l & c) && l < 4096 && (d++, c += l)), g = f;
    }
    U--, N[E++] = ee[U], k++;
  }
  for (k = E; k < a; k++)
    N[k] = 0;
  return N;
}, parseGIF = (e) => {
  const o = new Uint8Array(e);
  return parse(buildStream(o), schema);
}, generatePatch = (e) => {
  const o = e.pixels.length, n = new Uint8ClampedArray(o * 4);
  for (var t = 0; t < o; t++) {
    const r = t * 4, a = e.pixels[t], l = e.colorTable[a];
    n[r] = l[0], n[r + 1] = l[1], n[r + 2] = l[2], n[r + 3] = a !== e.transparentIndex ? 255 : 0;
  }
  return n;
}, decompressFrame = (e, o, n) => {
  if (!e.image) {
    console.warn("gif frame does not have associated image.");
    return;
  }
  const { image: t } = e, r = t.descriptor.width * t.descriptor.height;
  var a = lzw(t.data.minCodeSize, t.data.blocks, r);
  t.descriptor.lct.interlaced && (a = deinterlace(a, t.descriptor.width));
  const l = {
    pixels: a,
    dims: {
      top: e.image.descriptor.top,
      left: e.image.descriptor.left,
      width: e.image.descriptor.width,
      height: e.image.descriptor.height
    }
  };
  return t.descriptor.lct && t.descriptor.lct.exists ? l.colorTable = t.lct : l.colorTable = o, e.gce && (l.delay = (e.gce.delay || 10) * 10, l.disposalType = e.gce.extras.disposal, e.gce.extras.transparentColorGiven && (l.transparentIndex = e.gce.transparentColorIndex)), l.patch = generatePatch(l), l;
}, decompressFrames = (e, o) => e.frames.filter((n) => n.image).map((n) => decompressFrame(n, e.gct));
function checkQRVersion(e, o, n) {
  const t = _getUTF8Length(o), r = e - 1;
  let a = 0;
  switch (n) {
    case QRErrorCorrectLevel.L:
      a = QRCodeLimitLength[r][0];
      break;
    case QRErrorCorrectLevel.M:
      a = QRCodeLimitLength[r][1];
      break;
    case QRErrorCorrectLevel.Q:
      a = QRCodeLimitLength[r][2];
      break;
    case QRErrorCorrectLevel.H:
      a = QRCodeLimitLength[r][3];
      break;
  }
  return t <= a;
}
function _getTypeNumber(e, o) {
  for (var n = 1, t = _getUTF8Length(e), r = 0, a = QRCodeLimitLength.length; r < a; r++) {
    var l = 0;
    switch (o) {
      case QRErrorCorrectLevel.L:
        l = QRCodeLimitLength[r][0];
        break;
      case QRErrorCorrectLevel.M:
        l = QRCodeLimitLength[r][1];
        break;
      case QRErrorCorrectLevel.Q:
        l = QRCodeLimitLength[r][2];
        break;
      case QRErrorCorrectLevel.H:
        l = QRCodeLimitLength[r][3];
        break;
    }
    if (t <= l)
      break;
    n++;
  }
  if (n > QRCodeLimitLength.length)
    throw new Error("Too long data");
  return n;
}
function _getUTF8Length(e) {
  var o = encodeURI(e).toString().replace(/\%[0-9a-fA-F]{2}/g, "a");
  return o.length + (o.length != Number(e) ? 3 : 0);
}
class QR8bitByte {
  constructor(o) {
    this.mode = QRMode.MODE_8BIT_BYTE, this.parsedData = [], this.data = o;
    const n = [];
    for (let t = 0, r = this.data.length; t < r; t++) {
      const a = [], l = this.data.charCodeAt(t);
      l > 65536 ? (a[0] = 240 | (l & 1835008) >>> 18, a[1] = 128 | (l & 258048) >>> 12, a[2] = 128 | (l & 4032) >>> 6, a[3] = 128 | l & 63) : l > 2048 ? (a[0] = 224 | (l & 61440) >>> 12, a[1] = 128 | (l & 4032) >>> 6, a[2] = 128 | l & 63) : l > 128 ? (a[0] = 192 | (l & 1984) >>> 6, a[1] = 128 | l & 63) : a[0] = l, n.push(a);
    }
    this.parsedData = Array.prototype.concat.apply([], n), this.parsedData.length != this.data.length && (this.parsedData.unshift(191), this.parsedData.unshift(187), this.parsedData.unshift(239));
  }
  getLength() {
    return this.parsedData.length;
  }
  write(o) {
    for (let n = 0, t = this.parsedData.length; n < t; n++)
      o.put(this.parsedData[n], 8);
  }
}
class QRCodeModel {
  constructor(o = -1, n = QRErrorCorrectLevel.L) {
    this.moduleCount = 0, this.dataList = [], this.typeNumber = o, this.errorCorrectLevel = n, this.moduleCount = 0, this.dataList = [];
  }
  addData(o) {
    if (this.typeNumber <= 0)
      this.typeNumber = _getTypeNumber(o, this.errorCorrectLevel);
    else {
      if (this.typeNumber > 40)
        throw new Error(`Invalid QR version: ${this.typeNumber}`);
      if (!checkQRVersion(this.typeNumber, o, this.errorCorrectLevel))
        throw new Error(`Data is too long for QR version: ${this.typeNumber}`);
    }
    const n = new QR8bitByte(o);
    this.dataList.push(n), this.dataCache = void 0;
  }
  isDark(o, n) {
    if (o < 0 || this.moduleCount <= o || n < 0 || this.moduleCount <= n)
      throw new Error(`${o},${n}`);
    return this.modules[o][n];
  }
  getModuleCount() {
    return this.moduleCount;
  }
  make() {
    this.makeImpl(!1, this.getBestMaskPattern());
  }
  makeImpl(o, n) {
    this.moduleCount = this.typeNumber * 4 + 17, this.modules = new Array(this.moduleCount);
    for (let t = 0; t < this.moduleCount; t++) {
      this.modules[t] = new Array(this.moduleCount);
      for (let r = 0; r < this.moduleCount; r++)
        this.modules[t][r] = null;
    }
    this.setupPositionProbePattern(0, 0), this.setupPositionProbePattern(this.moduleCount - 7, 0), this.setupPositionProbePattern(0, this.moduleCount - 7), this.setupPositionAdjustPattern(), this.setupTimingPattern(), this.setupTypeInfo(o, n), this.typeNumber >= 7 && this.setupTypeNumber(o), this.dataCache == null && (this.dataCache = QRCodeModel.createData(this.typeNumber, this.errorCorrectLevel, this.dataList)), this.mapData(this.dataCache, n);
  }
  setupPositionProbePattern(o, n) {
    for (let t = -1; t <= 7; t++)
      if (!(o + t <= -1 || this.moduleCount <= o + t))
        for (let r = -1; r <= 7; r++)
          n + r <= -1 || this.moduleCount <= n + r || (0 <= t && t <= 6 && (r == 0 || r == 6) || 0 <= r && r <= 6 && (t == 0 || t == 6) || 2 <= t && t <= 4 && 2 <= r && r <= 4 ? this.modules[o + t][n + r] = !0 : this.modules[o + t][n + r] = !1);
  }
  getBestMaskPattern() {
    if (Number.isInteger(this.maskPattern) && Object.values(QRMaskPattern).includes(this.maskPattern))
      return this.maskPattern;
    let o = 0, n = 0;
    for (let t = 0; t < 8; t++) {
      this.makeImpl(!0, t);
      const r = QRUtil.getLostPoint(this);
      (t == 0 || o > r) && (o = r, n = t);
    }
    return n;
  }
  setupTimingPattern() {
    for (let o = 8; o < this.moduleCount - 8; o++)
      this.modules[o][6] == null && (this.modules[o][6] = o % 2 == 0);
    for (let o = 8; o < this.moduleCount - 8; o++)
      this.modules[6][o] == null && (this.modules[6][o] = o % 2 == 0);
  }
  setupPositionAdjustPattern() {
    const o = QRUtil.getPatternPosition(this.typeNumber);
    for (let n = 0; n < o.length; n++)
      for (let t = 0; t < o.length; t++) {
        const r = o[n], a = o[t];
        if (this.modules[r][a] == null)
          for (let l = -2; l <= 2; l++)
            for (let s = -2; s <= 2; s++)
              l == -2 || l == 2 || s == -2 || s == 2 || l == 0 && s == 0 ? this.modules[r + l][a + s] = !0 : this.modules[r + l][a + s] = !1;
      }
  }
  setupTypeNumber(o) {
    const n = QRUtil.getBCHTypeNumber(this.typeNumber);
    for (var t = 0; t < 18; t++) {
      var r = !o && (n >> t & 1) == 1;
      this.modules[Math.floor(t / 3)][t % 3 + this.moduleCount - 8 - 3] = r;
    }
    for (var t = 0; t < 18; t++) {
      var r = !o && (n >> t & 1) == 1;
      this.modules[t % 3 + this.moduleCount - 8 - 3][Math.floor(t / 3)] = r;
    }
  }
  setupTypeInfo(o, n) {
    const t = this.errorCorrectLevel << 3 | n, r = QRUtil.getBCHTypeInfo(t);
    for (var a = 0; a < 15; a++) {
      var l = !o && (r >> a & 1) == 1;
      a < 6 ? this.modules[a][8] = l : a < 8 ? this.modules[a + 1][8] = l : this.modules[this.moduleCount - 15 + a][8] = l;
    }
    for (var a = 0; a < 15; a++) {
      var l = !o && (r >> a & 1) == 1;
      a < 8 ? this.modules[8][this.moduleCount - a - 1] = l : a < 9 ? this.modules[8][15 - a - 1 + 1] = l : this.modules[8][15 - a - 1] = l;
    }
    this.modules[this.moduleCount - 8][8] = !o;
  }
  mapData(o, n) {
    let t = -1, r = this.moduleCount - 1, a = 7, l = 0;
    for (let s = this.moduleCount - 1; s > 0; s -= 2)
      for (s == 6 && s--; ; ) {
        for (let c = 0; c < 2; c++)
          if (this.modules[r][s - c] == null) {
            let d = !1;
            l < o.length && (d = (o[l] >>> a & 1) == 1), QRUtil.getMask(n, r, s - c) && (d = !d), this.modules[r][s - c] = d, a--, a == -1 && (l++, a = 7);
          }
        if (r += t, r < 0 || this.moduleCount <= r) {
          r -= t, t = -t;
          break;
        }
      }
  }
  static createData(o, n, t) {
    const r = QRRSBlock.getRSBlocks(o, n), a = new QRBitBuffer();
    for (var l = 0; l < t.length; l++) {
      const c = t[l];
      a.put(c.mode, 4), a.put(c.getLength(), QRUtil.getLengthInBits(c.mode, o)), c.write(a);
    }
    let s = 0;
    for (var l = 0; l < r.length; l++)
      s += r[l].dataCount;
    if (a.getLengthInBits() > s * 8)
      throw new Error(`code length overflow. (${a.getLengthInBits()}>${s * 8})`);
    for (a.getLengthInBits() + 4 <= s * 8 && a.put(0, 4); a.getLengthInBits() % 8 != 0; )
      a.putBit(!1);
    for (; !(a.getLengthInBits() >= s * 8 || (a.put(QRCodeModel.PAD0, 8), a.getLengthInBits() >= s * 8)); )
      a.put(QRCodeModel.PAD1, 8);
    return QRCodeModel.createBytes(a, r);
  }
  static createBytes(o, n) {
    let t = 0, r = 0, a = 0;
    const l = new Array(n.length), s = new Array(n.length);
    for (var c = 0; c < n.length; c++) {
      const b = n[c].dataCount, k = n[c].totalCount - b;
      r = Math.max(r, b), a = Math.max(a, k), l[c] = new Array(b);
      for (var d = 0; d < l[c].length; d++)
        l[c][d] = 255 & o.buffer[d + t];
      t += b;
      const x = QRUtil.getErrorCorrectPolynomial(k), O = new QRPolynomial(l[c], x.getLength() - 1).mod(x);
      s[c] = new Array(x.getLength() - 1);
      for (var d = 0; d < s[c].length; d++) {
        const ee = d + O.getLength() - s[c].length;
        s[c][d] = ee >= 0 ? O.get(ee) : 0;
      }
    }
    let p = 0;
    for (var d = 0; d < n.length; d++)
      p += n[d].totalCount;
    const f = new Array(p);
    let g = 0;
    for (var d = 0; d < r; d++)
      for (var c = 0; c < n.length; c++)
        d < l[c].length && (f[g++] = l[c][d]);
    for (var d = 0; d < a; d++)
      for (var c = 0; c < n.length; c++)
        d < s[c].length && (f[g++] = s[c][d]);
    return f;
  }
}
QRCodeModel.PAD0 = 236;
QRCodeModel.PAD1 = 17;
const QRErrorCorrectLevel = { L: 1, M: 0, Q: 3, H: 2 }, QRMode = { MODE_NUMBER: 1, MODE_ALPHA_NUM: 2, MODE_8BIT_BYTE: 4, MODE_KANJI: 8 }, QRMaskPattern = {
  PATTERN000: 0,
  PATTERN001: 1,
  PATTERN010: 2,
  PATTERN011: 3,
  PATTERN100: 4,
  PATTERN101: 5,
  PATTERN110: 6,
  PATTERN111: 7
};
class QRUtil {
  static getBCHTypeInfo(o) {
    let n = o << 10;
    for (; QRUtil.getBCHDigit(n) - QRUtil.getBCHDigit(QRUtil.G15) >= 0; )
      n ^= QRUtil.G15 << QRUtil.getBCHDigit(n) - QRUtil.getBCHDigit(QRUtil.G15);
    return (o << 10 | n) ^ QRUtil.G15_MASK;
  }
  static getBCHTypeNumber(o) {
    let n = o << 12;
    for (; QRUtil.getBCHDigit(n) - QRUtil.getBCHDigit(QRUtil.G18) >= 0; )
      n ^= QRUtil.G18 << QRUtil.getBCHDigit(n) - QRUtil.getBCHDigit(QRUtil.G18);
    return o << 12 | n;
  }
  static getBCHDigit(o) {
    let n = 0;
    for (; o != 0; )
      n++, o >>>= 1;
    return n;
  }
  static getPatternPosition(o) {
    return QRUtil.PATTERN_POSITION_TABLE[o - 1];
  }
  static getMask(o, n, t) {
    switch (o) {
      case QRMaskPattern.PATTERN000:
        return (n + t) % 2 == 0;
      case QRMaskPattern.PATTERN001:
        return n % 2 == 0;
      case QRMaskPattern.PATTERN010:
        return t % 3 == 0;
      case QRMaskPattern.PATTERN011:
        return (n + t) % 3 == 0;
      case QRMaskPattern.PATTERN100:
        return (Math.floor(n / 2) + Math.floor(t / 3)) % 2 == 0;
      case QRMaskPattern.PATTERN101:
        return n * t % 2 + n * t % 3 == 0;
      case QRMaskPattern.PATTERN110:
        return (n * t % 2 + n * t % 3) % 2 == 0;
      case QRMaskPattern.PATTERN111:
        return (n * t % 3 + (n + t) % 2) % 2 == 0;
      default:
        throw new Error(`bad maskPattern:${o}`);
    }
  }
  static getErrorCorrectPolynomial(o) {
    let n = new QRPolynomial([1], 0);
    for (let t = 0; t < o; t++)
      n = n.multiply(new QRPolynomial([1, QRMath.gexp(t)], 0));
    return n;
  }
  static getLengthInBits(o, n) {
    if (1 <= n && n < 10)
      switch (o) {
        case QRMode.MODE_NUMBER:
          return 10;
        case QRMode.MODE_ALPHA_NUM:
          return 9;
        case QRMode.MODE_8BIT_BYTE:
          return 8;
        case QRMode.MODE_KANJI:
          return 8;
        default:
          throw new Error(`mode:${o}`);
      }
    else if (n < 27)
      switch (o) {
        case QRMode.MODE_NUMBER:
          return 12;
        case QRMode.MODE_ALPHA_NUM:
          return 11;
        case QRMode.MODE_8BIT_BYTE:
          return 16;
        case QRMode.MODE_KANJI:
          return 10;
        default:
          throw new Error(`mode:${o}`);
      }
    else if (n < 41)
      switch (o) {
        case QRMode.MODE_NUMBER:
          return 14;
        case QRMode.MODE_ALPHA_NUM:
          return 13;
        case QRMode.MODE_8BIT_BYTE:
          return 16;
        case QRMode.MODE_KANJI:
          return 12;
        default:
          throw new Error(`mode:${o}`);
      }
    else
      throw new Error(`type:${n}`);
  }
  static getLostPoint(o) {
    const n = o.getModuleCount();
    let t = 0;
    for (var r = 0; r < n; r++)
      for (var a = 0; a < n; a++) {
        let c = 0;
        const d = o.isDark(r, a);
        for (let p = -1; p <= 1; p++)
          if (!(r + p < 0 || n <= r + p))
            for (let f = -1; f <= 1; f++)
              a + f < 0 || n <= a + f || p == 0 && f == 0 || d == o.isDark(r + p, a + f) && c++;
        c > 5 && (t += 3 + c - 5);
      }
    for (var r = 0; r < n - 1; r++)
      for (var a = 0; a < n - 1; a++) {
        let p = 0;
        o.isDark(r, a) && p++, o.isDark(r + 1, a) && p++, o.isDark(r, a + 1) && p++, o.isDark(r + 1, a + 1) && p++, (p == 0 || p == 4) && (t += 3);
      }
    for (var r = 0; r < n; r++)
      for (var a = 0; a < n - 6; a++)
        o.isDark(r, a) && !o.isDark(r, a + 1) && o.isDark(r, a + 2) && o.isDark(r, a + 3) && o.isDark(r, a + 4) && !o.isDark(r, a + 5) && o.isDark(r, a + 6) && (t += 40);
    for (var a = 0; a < n; a++)
      for (var r = 0; r < n - 6; r++)
        o.isDark(r, a) && !o.isDark(r + 1, a) && o.isDark(r + 2, a) && o.isDark(r + 3, a) && o.isDark(r + 4, a) && !o.isDark(r + 5, a) && o.isDark(r + 6, a) && (t += 40);
    let l = 0;
    for (var a = 0; a < n; a++)
      for (var r = 0; r < n; r++)
        o.isDark(r, a) && l++;
    const s = Math.abs(100 * l / n / n - 50) / 5;
    return t += s * 10, t;
  }
}
QRUtil.PATTERN_POSITION_TABLE = [
  [],
  [6, 18],
  [6, 22],
  [6, 26],
  [6, 30],
  [6, 34],
  [6, 22, 38],
  [6, 24, 42],
  [6, 26, 46],
  [6, 28, 50],
  [6, 30, 54],
  [6, 32, 58],
  [6, 34, 62],
  [6, 26, 46, 66],
  [6, 26, 48, 70],
  [6, 26, 50, 74],
  [6, 30, 54, 78],
  [6, 30, 56, 82],
  [6, 30, 58, 86],
  [6, 34, 62, 90],
  [6, 28, 50, 72, 94],
  [6, 26, 50, 74, 98],
  [6, 30, 54, 78, 102],
  [6, 28, 54, 80, 106],
  [6, 32, 58, 84, 110],
  [6, 30, 58, 86, 114],
  [6, 34, 62, 90, 118],
  [6, 26, 50, 74, 98, 122],
  [6, 30, 54, 78, 102, 126],
  [6, 26, 52, 78, 104, 130],
  [6, 30, 56, 82, 108, 134],
  [6, 34, 60, 86, 112, 138],
  [6, 30, 58, 86, 114, 142],
  [6, 34, 62, 90, 118, 146],
  [6, 30, 54, 78, 102, 126, 150],
  [6, 24, 50, 76, 102, 128, 154],
  [6, 28, 54, 80, 106, 132, 158],
  [6, 32, 58, 84, 110, 136, 162],
  [6, 26, 54, 82, 110, 138, 166],
  [6, 30, 58, 86, 114, 142, 170]
];
QRUtil.G15 = 1335;
QRUtil.G18 = 7973;
QRUtil.G15_MASK = 21522;
class QRMath {
  static glog(o) {
    if (o < 1)
      throw new Error(`glog(${o})`);
    return QRMath.LOG_TABLE[o];
  }
  static gexp(o) {
    for (; o < 0; )
      o += 255;
    for (; o >= 256; )
      o -= 255;
    return QRMath.EXP_TABLE[o];
  }
}
QRMath.EXP_TABLE = new Array(256);
QRMath.LOG_TABLE = new Array(256);
QRMath._constructor = function() {
  for (var e = 0; e < 8; e++)
    QRMath.EXP_TABLE[e] = 1 << e;
  for (var e = 8; e < 256; e++)
    QRMath.EXP_TABLE[e] = QRMath.EXP_TABLE[e - 4] ^ QRMath.EXP_TABLE[e - 5] ^ QRMath.EXP_TABLE[e - 6] ^ QRMath.EXP_TABLE[e - 8];
  for (var e = 0; e < 255; e++)
    QRMath.LOG_TABLE[QRMath.EXP_TABLE[e]] = e;
}();
class QRPolynomial {
  constructor(o, n) {
    if (o.length == null)
      throw new Error(`${o.length}/${n}`);
    let t = 0;
    for (; t < o.length && o[t] == 0; )
      t++;
    this.num = new Array(o.length - t + n);
    for (let r = 0; r < o.length - t; r++)
      this.num[r] = o[r + t];
  }
  get(o) {
    return this.num[o];
  }
  getLength() {
    return this.num.length;
  }
  multiply(o) {
    const n = new Array(this.getLength() + o.getLength() - 1);
    for (let t = 0; t < this.getLength(); t++)
      for (let r = 0; r < o.getLength(); r++)
        n[t + r] ^= QRMath.gexp(QRMath.glog(this.get(t)) + QRMath.glog(o.get(r)));
    return new QRPolynomial(n, 0);
  }
  mod(o) {
    if (this.getLength() - o.getLength() < 0)
      return this;
    const n = QRMath.glog(this.get(0)) - QRMath.glog(o.get(0)), t = new Array(this.getLength());
    for (var r = 0; r < this.getLength(); r++)
      t[r] = this.get(r);
    for (var r = 0; r < o.getLength(); r++)
      t[r] ^= QRMath.gexp(QRMath.glog(o.get(r)) + n);
    return new QRPolynomial(t, 0).mod(o);
  }
}
class QRRSBlock {
  constructor(o, n) {
    this.totalCount = o, this.dataCount = n;
  }
  static getRSBlocks(o, n) {
    const t = QRRSBlock.getRsBlockTable(o, n);
    if (t == null)
      throw new Error(`bad rs block @ typeNumber:${o}/errorCorrectLevel:${n}`);
    const r = t.length / 3, a = [];
    for (let l = 0; l < r; l++) {
      const s = t[l * 3 + 0], c = t[l * 3 + 1], d = t[l * 3 + 2];
      for (let p = 0; p < s; p++)
        a.push(new QRRSBlock(c, d));
    }
    return a;
  }
  static getRsBlockTable(o, n) {
    switch (n) {
      case QRErrorCorrectLevel.L:
        return QRRSBlock.RS_BLOCK_TABLE[(o - 1) * 4 + 0];
      case QRErrorCorrectLevel.M:
        return QRRSBlock.RS_BLOCK_TABLE[(o - 1) * 4 + 1];
      case QRErrorCorrectLevel.Q:
        return QRRSBlock.RS_BLOCK_TABLE[(o - 1) * 4 + 2];
      case QRErrorCorrectLevel.H:
        return QRRSBlock.RS_BLOCK_TABLE[(o - 1) * 4 + 3];
      default:
        return;
    }
  }
}
QRRSBlock.RS_BLOCK_TABLE = [
  [1, 26, 19],
  [1, 26, 16],
  [1, 26, 13],
  [1, 26, 9],
  [1, 44, 34],
  [1, 44, 28],
  [1, 44, 22],
  [1, 44, 16],
  [1, 70, 55],
  [1, 70, 44],
  [2, 35, 17],
  [2, 35, 13],
  [1, 100, 80],
  [2, 50, 32],
  [2, 50, 24],
  [4, 25, 9],
  [1, 134, 108],
  [2, 67, 43],
  [2, 33, 15, 2, 34, 16],
  [2, 33, 11, 2, 34, 12],
  [2, 86, 68],
  [4, 43, 27],
  [4, 43, 19],
  [4, 43, 15],
  [2, 98, 78],
  [4, 49, 31],
  [2, 32, 14, 4, 33, 15],
  [4, 39, 13, 1, 40, 14],
  [2, 121, 97],
  [2, 60, 38, 2, 61, 39],
  [4, 40, 18, 2, 41, 19],
  [4, 40, 14, 2, 41, 15],
  [2, 146, 116],
  [3, 58, 36, 2, 59, 37],
  [4, 36, 16, 4, 37, 17],
  [4, 36, 12, 4, 37, 13],
  [2, 86, 68, 2, 87, 69],
  [4, 69, 43, 1, 70, 44],
  [6, 43, 19, 2, 44, 20],
  [6, 43, 15, 2, 44, 16],
  [4, 101, 81],
  [1, 80, 50, 4, 81, 51],
  [4, 50, 22, 4, 51, 23],
  [3, 36, 12, 8, 37, 13],
  [2, 116, 92, 2, 117, 93],
  [6, 58, 36, 2, 59, 37],
  [4, 46, 20, 6, 47, 21],
  [7, 42, 14, 4, 43, 15],
  [4, 133, 107],
  [8, 59, 37, 1, 60, 38],
  [8, 44, 20, 4, 45, 21],
  [12, 33, 11, 4, 34, 12],
  [3, 145, 115, 1, 146, 116],
  [4, 64, 40, 5, 65, 41],
  [11, 36, 16, 5, 37, 17],
  [11, 36, 12, 5, 37, 13],
  [5, 109, 87, 1, 110, 88],
  [5, 65, 41, 5, 66, 42],
  [5, 54, 24, 7, 55, 25],
  [11, 36, 12],
  [5, 122, 98, 1, 123, 99],
  [7, 73, 45, 3, 74, 46],
  [15, 43, 19, 2, 44, 20],
  [3, 45, 15, 13, 46, 16],
  [1, 135, 107, 5, 136, 108],
  [10, 74, 46, 1, 75, 47],
  [1, 50, 22, 15, 51, 23],
  [2, 42, 14, 17, 43, 15],
  [5, 150, 120, 1, 151, 121],
  [9, 69, 43, 4, 70, 44],
  [17, 50, 22, 1, 51, 23],
  [2, 42, 14, 19, 43, 15],
  [3, 141, 113, 4, 142, 114],
  [3, 70, 44, 11, 71, 45],
  [17, 47, 21, 4, 48, 22],
  [9, 39, 13, 16, 40, 14],
  [3, 135, 107, 5, 136, 108],
  [3, 67, 41, 13, 68, 42],
  [15, 54, 24, 5, 55, 25],
  [15, 43, 15, 10, 44, 16],
  [4, 144, 116, 4, 145, 117],
  [17, 68, 42],
  [17, 50, 22, 6, 51, 23],
  [19, 46, 16, 6, 47, 17],
  [2, 139, 111, 7, 140, 112],
  [17, 74, 46],
  [7, 54, 24, 16, 55, 25],
  [34, 37, 13],
  [4, 151, 121, 5, 152, 122],
  [4, 75, 47, 14, 76, 48],
  [11, 54, 24, 14, 55, 25],
  [16, 45, 15, 14, 46, 16],
  [6, 147, 117, 4, 148, 118],
  [6, 73, 45, 14, 74, 46],
  [11, 54, 24, 16, 55, 25],
  [30, 46, 16, 2, 47, 17],
  [8, 132, 106, 4, 133, 107],
  [8, 75, 47, 13, 76, 48],
  [7, 54, 24, 22, 55, 25],
  [22, 45, 15, 13, 46, 16],
  [10, 142, 114, 2, 143, 115],
  [19, 74, 46, 4, 75, 47],
  [28, 50, 22, 6, 51, 23],
  [33, 46, 16, 4, 47, 17],
  [8, 152, 122, 4, 153, 123],
  [22, 73, 45, 3, 74, 46],
  [8, 53, 23, 26, 54, 24],
  [12, 45, 15, 28, 46, 16],
  [3, 147, 117, 10, 148, 118],
  [3, 73, 45, 23, 74, 46],
  [4, 54, 24, 31, 55, 25],
  [11, 45, 15, 31, 46, 16],
  [7, 146, 116, 7, 147, 117],
  [21, 73, 45, 7, 74, 46],
  [1, 53, 23, 37, 54, 24],
  [19, 45, 15, 26, 46, 16],
  [5, 145, 115, 10, 146, 116],
  [19, 75, 47, 10, 76, 48],
  [15, 54, 24, 25, 55, 25],
  [23, 45, 15, 25, 46, 16],
  [13, 145, 115, 3, 146, 116],
  [2, 74, 46, 29, 75, 47],
  [42, 54, 24, 1, 55, 25],
  [23, 45, 15, 28, 46, 16],
  [17, 145, 115],
  [10, 74, 46, 23, 75, 47],
  [10, 54, 24, 35, 55, 25],
  [19, 45, 15, 35, 46, 16],
  [17, 145, 115, 1, 146, 116],
  [14, 74, 46, 21, 75, 47],
  [29, 54, 24, 19, 55, 25],
  [11, 45, 15, 46, 46, 16],
  [13, 145, 115, 6, 146, 116],
  [14, 74, 46, 23, 75, 47],
  [44, 54, 24, 7, 55, 25],
  [59, 46, 16, 1, 47, 17],
  [12, 151, 121, 7, 152, 122],
  [12, 75, 47, 26, 76, 48],
  [39, 54, 24, 14, 55, 25],
  [22, 45, 15, 41, 46, 16],
  [6, 151, 121, 14, 152, 122],
  [6, 75, 47, 34, 76, 48],
  [46, 54, 24, 10, 55, 25],
  [2, 45, 15, 64, 46, 16],
  [17, 152, 122, 4, 153, 123],
  [29, 74, 46, 14, 75, 47],
  [49, 54, 24, 10, 55, 25],
  [24, 45, 15, 46, 46, 16],
  [4, 152, 122, 18, 153, 123],
  [13, 74, 46, 32, 75, 47],
  [48, 54, 24, 14, 55, 25],
  [42, 45, 15, 32, 46, 16],
  [20, 147, 117, 4, 148, 118],
  [40, 75, 47, 7, 76, 48],
  [43, 54, 24, 22, 55, 25],
  [10, 45, 15, 67, 46, 16],
  [19, 148, 118, 6, 149, 119],
  [18, 75, 47, 31, 76, 48],
  [34, 54, 24, 34, 55, 25],
  [20, 45, 15, 61, 46, 16]
];
class QRBitBuffer {
  constructor() {
    this.buffer = [], this.length = 0;
  }
  get(o) {
    const n = Math.floor(o / 8);
    return (this.buffer[n] >>> 7 - o % 8 & 1) == 1;
  }
  put(o, n) {
    for (let t = 0; t < n; t++)
      this.putBit((o >>> n - t - 1 & 1) == 1);
  }
  getLengthInBits() {
    return this.length;
  }
  putBit(o) {
    const n = Math.floor(this.length / 8);
    this.buffer.length <= n && this.buffer.push(0), o && (this.buffer[n] |= 128 >>> this.length % 8), this.length++;
  }
}
const QRCodeLimitLength = [
  [17, 14, 11, 7],
  [32, 26, 20, 14],
  [53, 42, 32, 24],
  [78, 62, 46, 34],
  [106, 84, 60, 44],
  [134, 106, 74, 58],
  [154, 122, 86, 64],
  [192, 152, 108, 84],
  [230, 180, 130, 98],
  [271, 213, 151, 119],
  [321, 251, 177, 137],
  [367, 287, 203, 155],
  [425, 331, 241, 177],
  [458, 362, 258, 194],
  [520, 412, 292, 220],
  [586, 450, 322, 250],
  [644, 504, 364, 280],
  [718, 560, 394, 310],
  [792, 624, 442, 338],
  [858, 666, 482, 382],
  [929, 711, 509, 403],
  [1003, 779, 565, 439],
  [1091, 857, 611, 461],
  [1171, 911, 661, 511],
  [1273, 997, 715, 535],
  [1367, 1059, 751, 593],
  [1465, 1125, 805, 625],
  [1528, 1190, 868, 658],
  [1628, 1264, 908, 698],
  [1732, 1370, 982, 742],
  [1840, 1452, 1030, 790],
  [1952, 1538, 1112, 842],
  [2068, 1628, 1168, 898],
  [2188, 1722, 1228, 958],
  [2303, 1809, 1283, 983],
  [2431, 1911, 1351, 1051],
  [2563, 1989, 1423, 1093],
  [2699, 2099, 1499, 1139],
  [2809, 2213, 1579, 1219],
  [2953, 2331, 1663, 1273]
];
var ncycles = 100, netsize = 256, maxnetpos = netsize - 1, netbiasshift = 4, intbiasshift = 16, intbias = 1 << intbiasshift, gammashift = 10, betashift = 10, beta = intbias >> betashift, betagamma = intbias << gammashift - betashift, initrad = netsize >> 3, radiusbiasshift = 6, radiusbias = 1 << radiusbiasshift, initradius = initrad * radiusbias, radiusdec = 30, alphabiasshift = 10, initalpha = 1 << alphabiasshift, radbiasshift = 8, radbias = 1 << radbiasshift, alpharadbshift = alphabiasshift + radbiasshift, alpharadbias = 1 << alpharadbshift, prime1 = 499, prime2 = 491, prime3 = 487, prime4 = 503, minpicturebytes = 3 * prime4;
function NeuQuant(e, o) {
  var n, t, r, a, l;
  function s() {
    n = [], t = new Int32Array(256), r = new Int32Array(netsize), a = new Int32Array(netsize), l = new Int32Array(netsize >> 3);
    var O, m;
    for (O = 0; O < netsize; O++)
      m = (O << netbiasshift + 8) / netsize, n[O] = new Float64Array([m, m, m, 0]), a[O] = intbias / netsize, r[O] = 0;
  }
  function c() {
    for (var O = 0; O < netsize; O++)
      n[O][0] >>= netbiasshift, n[O][1] >>= netbiasshift, n[O][2] >>= netbiasshift, n[O][3] = O;
  }
  function d(O, m, ee, z, P) {
    n[m][0] -= O * (n[m][0] - ee) / initalpha, n[m][1] -= O * (n[m][1] - z) / initalpha, n[m][2] -= O * (n[m][2] - P) / initalpha;
  }
  function p(O, m, ee, z, P) {
    for (var V = Math.abs(m - O), U = Math.min(m + O, netsize), E = m + 1, C = m - 1, I = 1, v, M; E < U || C > V; )
      M = l[I++], E < U && (v = n[E++], v[0] -= M * (v[0] - ee) / alpharadbias, v[1] -= M * (v[1] - z) / alpharadbias, v[2] -= M * (v[2] - P) / alpharadbias), C > V && (v = n[C--], v[0] -= M * (v[0] - ee) / alpharadbias, v[1] -= M * (v[1] - z) / alpharadbias, v[2] -= M * (v[2] - P) / alpharadbias);
  }
  function f(O, m, ee) {
    var z = 2147483647, P = z, V = -1, U = V, E, C, I, v, M;
    for (E = 0; E < netsize; E++)
      C = n[E], I = Math.abs(C[0] - O) + Math.abs(C[1] - m) + Math.abs(C[2] - ee), I < z && (z = I, V = E), v = I - (r[E] >> intbiasshift - netbiasshift), v < P && (P = v, U = E), M = a[E] >> betashift, a[E] -= M, r[E] += M << gammashift;
    return a[V] += beta, r[V] -= betagamma, U;
  }
  function g() {
    var O, m, ee, z, P, V, U = 0, E = 0;
    for (O = 0; O < netsize; O++) {
      for (ee = n[O], P = O, V = ee[1], m = O + 1; m < netsize; m++)
        z = n[m], z[1] < V && (P = m, V = z[1]);
      if (z = n[P], O != P && (m = z[0], z[0] = ee[0], ee[0] = m, m = z[1], z[1] = ee[1], ee[1] = m, m = z[2], z[2] = ee[2], ee[2] = m, m = z[3], z[3] = ee[3], ee[3] = m), V != U) {
        for (t[U] = E + O >> 1, m = U + 1; m < V; m++)
          t[m] = O;
        U = V, E = O;
      }
    }
    for (t[U] = E + maxnetpos >> 1, m = U + 1; m < 256; m++)
      t[m] = maxnetpos;
  }
  function b(O, m, ee) {
    for (var z, P, V, U = 1e3, E = -1, C = t[m], I = C - 1; C < netsize || I >= 0; )
      C < netsize && (P = n[C], V = P[1] - m, V >= U ? C = netsize : (C++, V < 0 && (V = -V), z = P[0] - O, z < 0 && (z = -z), V += z, V < U && (z = P[2] - ee, z < 0 && (z = -z), V += z, V < U && (U = V, E = P[3])))), I >= 0 && (P = n[I], V = m - P[1], V >= U ? I = -1 : (I--, V < 0 && (V = -V), z = P[0] - O, z < 0 && (z = -z), V += z, V < U && (z = P[2] - ee, z < 0 && (z = -z), V += z, V < U && (U = V, E = P[3]))));
    return E;
  }
  function k() {
    var O, m = e.length, ee = 30 + (o - 1) / 3, z = m / (3 * o), P = ~~(z / ncycles), V = initalpha, U = initradius, E = U >> radiusbiasshift;
    for (E <= 1 && (E = 0), O = 0; O < E; O++)
      l[O] = V * ((E * E - O * O) * radbias / (E * E));
    var C;
    m < minpicturebytes ? (o = 1, C = 3) : m % prime1 !== 0 ? C = 3 * prime1 : m % prime2 !== 0 ? C = 3 * prime2 : m % prime3 !== 0 ? C = 3 * prime3 : C = 3 * prime4;
    var I, v, M, $, H = 0;
    for (O = 0; O < z; )
      if (I = (e[H] & 255) << netbiasshift, v = (e[H + 1] & 255) << netbiasshift, M = (e[H + 2] & 255) << netbiasshift, $ = f(I, v, M), d(V, $, I, v, M), E !== 0 && p(E, $, I, v, M), H += C, H >= m && (H -= m), O++, P === 0 && (P = 1), O % P === 0)
        for (V -= V / ee, U -= U / radiusdec, E = U >> radiusbiasshift, E <= 1 && (E = 0), $ = 0; $ < E; $++)
          l[$] = V * ((E * E - $ * $) * radbias / (E * E));
  }
  function x() {
    s(), k(), c(), g();
  }
  this.buildColormap = x;
  function N() {
    for (var O = [], m = [], ee = 0; ee < netsize; ee++)
      m[n[ee][3]] = ee;
    for (var z = 0, P = 0; P < netsize; P++) {
      var V = m[P];
      O[z++] = n[V][0], O[z++] = n[V][1], O[z++] = n[V][2];
    }
    return O;
  }
  this.getColormap = N, this.lookupRGB = b;
}
var EOF = -1, BITS = 12, HSIZE = 5003, masks = [
  0,
  1,
  3,
  7,
  15,
  31,
  63,
  127,
  255,
  511,
  1023,
  2047,
  4095,
  8191,
  16383,
  32767,
  65535
];
function LZWEncoder(e, o, n, t) {
  var r = Math.max(2, t), a = new Uint8Array(256), l = new Int32Array(HSIZE), s = new Int32Array(HSIZE), c, d = 0, p, f = 0, g, b = !1, k, x, N, O, m, ee;
  function z($, H) {
    a[p++] = $, p >= 254 && C(H);
  }
  function P($) {
    V(HSIZE), f = x + 2, b = !0, M(x, $);
  }
  function V($) {
    for (var H = 0; H < $; ++H)
      l[H] = -1;
  }
  function U($, H) {
    var X, te, oe, ne, ie, se, pe;
    for (k = $, b = !1, ee = k, g = I(ee), x = 1 << $ - 1, N = x + 1, f = x + 2, p = 0, ne = v(), pe = 0, X = HSIZE; X < 65536; X *= 2)
      ++pe;
    pe = 8 - pe, se = HSIZE, V(se), M(x, H);
    e: for (; (te = v()) != EOF; ) {
      if (X = (te << BITS) + ne, oe = te << pe ^ ne, l[oe] === X) {
        ne = s[oe];
        continue;
      } else if (l[oe] >= 0) {
        ie = se - oe, oe === 0 && (ie = 1);
        do
          if ((oe -= ie) < 0 && (oe += se), l[oe] === X) {
            ne = s[oe];
            continue e;
          }
        while (l[oe] >= 0);
      }
      M(ne, H), ne = te, f < 1 << BITS ? (s[oe] = f++, l[oe] = X) : P(H);
    }
    M(ne, H), M(N, H);
  }
  function E($) {
    $.writeByte(r), O = e * o, m = 0, U(r + 1, $), $.writeByte(0);
  }
  function C($) {
    p > 0 && ($.writeByte(p), $.writeBytes(a, 0, p), p = 0);
  }
  function I($) {
    return (1 << $) - 1;
  }
  function v() {
    if (O === 0)
      return EOF;
    --O;
    var $ = n[m++];
    return $ & 255;
  }
  function M($, H) {
    for (c &= masks[d], d > 0 ? c |= $ << d : c = $, d += ee; d >= 8; )
      z(c & 255, H), c >>= 8, d -= 8;
    if ((f > g || b) && (b ? (g = I(ee = k), b = !1) : (++ee, ee == BITS ? g = 1 << BITS : g = I(ee))), $ == N) {
      for (; d > 0; )
        z(c & 255, H), c >>= 8, d -= 8;
      C(H);
    }
  }
  this.encode = E;
}
function ByteArray() {
  this.page = -1, this.pages = [], this.newPage();
}
ByteArray.pageSize = 4096;
ByteArray.charMap = {};
for (var i = 0; i < 256; i++)
  ByteArray.charMap[i] = String.fromCharCode(i);
ByteArray.prototype.newPage = function() {
  this.pages[++this.page] = new Uint8Array(ByteArray.pageSize), this.cursor = 0;
};
ByteArray.prototype.getData = function() {
  for (var e = "", o = 0; o < this.pages.length; o++)
    for (var n = 0; n < ByteArray.pageSize; n++)
      e += ByteArray.charMap[this.pages[o][n]];
  return e;
};
ByteArray.prototype.toFlattenUint8Array = function() {
  const e = [];
  for (var o = 0; o < this.pages.length; o++)
    if (o === this.pages.length - 1) {
      const t = Uint8Array.from(this.pages[o].slice(0, this.cursor));
      e.push(t);
    } else
      e.push(this.pages[o]);
  const n = new Uint8Array(e.reduce((t, r) => t + r.length, 0));
  return e.reduce((t, r) => (n.set(r, t), t + r.length), 0), n;
};
ByteArray.prototype.writeByte = function(e) {
  this.cursor >= ByteArray.pageSize && this.newPage(), this.pages[this.page][this.cursor++] = e;
};
ByteArray.prototype.writeUTFBytes = function(e) {
  for (var o = e.length, n = 0; n < o; n++)
    this.writeByte(e.charCodeAt(n));
};
ByteArray.prototype.writeBytes = function(e, o, n) {
  for (var t = n || e.length, r = o || 0; r < t; r++)
    this.writeByte(e[r]);
};
function GIFEncoder(e, o) {
  this.width = ~~e, this.height = ~~o, this.transparent = null, this.transIndex = 0, this.repeat = -1, this.delay = 0, this.image = null, this.pixels = null, this.indexedPixels = null, this.colorDepth = null, this.colorTab = null, this.neuQuant = null, this.usedEntry = new Array(), this.palSize = 7, this.dispose = -1, this.firstFrame = !0, this.sample = 10, this.dither = !1, this.globalPalette = !1, this.out = new ByteArray();
}
GIFEncoder.prototype.setDelay = function(e) {
  this.delay = Math.round(e / 10);
};
GIFEncoder.prototype.setFrameRate = function(e) {
  this.delay = Math.round(100 / e);
};
GIFEncoder.prototype.setDispose = function(e) {
  e >= 0 && (this.dispose = e);
};
GIFEncoder.prototype.setRepeat = function(e) {
  this.repeat = e;
};
GIFEncoder.prototype.setTransparent = function(e) {
  this.transparent = e;
};
GIFEncoder.prototype.addFrame = function(e) {
  this.image = e, this.colorTab = this.globalPalette && this.globalPalette.slice ? this.globalPalette : null, this.getImagePixels(), this.analyzePixels(), this.globalPalette === !0 && (this.globalPalette = this.colorTab), this.firstFrame && (this.writeHeader(), this.writeLSD(), this.writePalette(), this.repeat >= 0 && this.writeNetscapeExt()), this.writeGraphicCtrlExt(), this.writeImageDesc(), !this.firstFrame && !this.globalPalette && this.writePalette(), this.writePixels(), this.firstFrame = !1;
};
GIFEncoder.prototype.finish = function() {
  this.out.writeByte(59);
};
GIFEncoder.prototype.setQuality = function(e) {
  e < 1 && (e = 1), this.sample = e;
};
GIFEncoder.prototype.setDither = function(e) {
  e === !0 && (e = "FloydSteinberg"), this.dither = e;
};
GIFEncoder.prototype.setGlobalPalette = function(e) {
  this.globalPalette = e;
};
GIFEncoder.prototype.getGlobalPalette = function() {
  return this.globalPalette && this.globalPalette.slice && this.globalPalette.slice(0) || this.globalPalette;
};
GIFEncoder.prototype.writeHeader = function() {
  this.out.writeUTFBytes("GIF89a");
};
GIFEncoder.prototype.analyzePixels = function() {
  this.colorTab || (this.neuQuant = new NeuQuant(this.pixels, this.sample), this.neuQuant.buildColormap(), this.colorTab = this.neuQuant.getColormap()), this.dither ? this.ditherPixels(this.dither.replace("-serpentine", ""), this.dither.match(/-serpentine/) !== null) : this.indexPixels(), this.pixels = null, this.colorDepth = 8, this.palSize = 7, this.transparent !== null && (this.transIndex = this.findClosest(this.transparent, !0));
};
GIFEncoder.prototype.indexPixels = function(e) {
  var o = this.pixels.length / 3;
  this.indexedPixels = new Uint8Array(o);
  for (var n = 0, t = 0; t < o; t++) {
    var r = this.findClosestRGB(this.pixels[n++] & 255, this.pixels[n++] & 255, this.pixels[n++] & 255);
    this.usedEntry[r] = !0, this.indexedPixels[t] = r;
  }
};
GIFEncoder.prototype.ditherPixels = function(e, o) {
  var n = {
    FalseFloydSteinberg: [
      [0.375, 1, 0],
      [0.375, 0, 1],
      [0.25, 1, 1]
    ],
    FloydSteinberg: [
      [0.4375, 1, 0],
      [0.1875, -1, 1],
      [0.3125, 0, 1],
      [0.0625, 1, 1]
    ],
    Stucki: [
      [0.19047619047619047, 1, 0],
      [0.09523809523809523, 2, 0],
      [0.047619047619047616, -2, 1],
      [0.09523809523809523, -1, 1],
      [0.19047619047619047, 0, 1],
      [0.09523809523809523, 1, 1],
      [0.047619047619047616, 2, 1],
      [0.023809523809523808, -2, 2],
      [0.047619047619047616, -1, 2],
      [0.09523809523809523, 0, 2],
      [0.047619047619047616, 1, 2],
      [0.023809523809523808, 2, 2]
    ],
    Atkinson: [
      [0.125, 1, 0],
      [0.125, 2, 0],
      [0.125, -1, 1],
      [0.125, 0, 1],
      [0.125, 1, 1],
      [0.125, 0, 2]
    ]
  };
  if (!e || !n[e])
    throw "Unknown dithering kernel: " + e;
  var t = n[e], r = 0, a = this.height, l = this.width, s = this.pixels, c = o ? -1 : 1;
  this.indexedPixels = new Uint8Array(this.pixels.length / 3);
  for (var d = 0; d < a; d++) {
    o && (c = c * -1);
    for (var p = c == 1 ? 0 : l - 1, f = c == 1 ? l : 0; p !== f; p += c) {
      r = d * l + p;
      var g = r * 3, b = s[g], k = s[g + 1], x = s[g + 2];
      g = this.findClosestRGB(b, k, x), this.usedEntry[g] = !0, this.indexedPixels[r] = g, g *= 3;
      for (var N = this.colorTab[g], O = this.colorTab[g + 1], m = this.colorTab[g + 2], ee = b - N, z = k - O, P = x - m, V = c == 1 ? 0 : t.length - 1, U = c == 1 ? t.length : 0; V !== U; V += c) {
        var E = t[V][1], C = t[V][2];
        if (E + p >= 0 && E + p < l && C + d >= 0 && C + d < a) {
          var I = t[V][0];
          g = r + E + C * l, g *= 3, s[g] = Math.max(0, Math.min(255, s[g] + ee * I)), s[g + 1] = Math.max(0, Math.min(255, s[g + 1] + z * I)), s[g + 2] = Math.max(0, Math.min(255, s[g + 2] + P * I));
        }
      }
    }
  }
};
GIFEncoder.prototype.findClosest = function(e, o) {
  return this.findClosestRGB((e & 16711680) >> 16, (e & 65280) >> 8, e & 255, o);
};
GIFEncoder.prototype.findClosestRGB = function(e, o, n, t) {
  if (this.colorTab === null)
    return -1;
  if (this.neuQuant && !t)
    return this.neuQuant.lookupRGB(e, o, n);
  for (var r = 0, a = 256 * 256 * 256, l = this.colorTab.length, s = 0, c = 0; s < l; c++) {
    var d = e - (this.colorTab[s++] & 255), p = o - (this.colorTab[s++] & 255), f = n - (this.colorTab[s++] & 255), g = d * d + p * p + f * f;
    (!t || this.usedEntry[c]) && g < a && (a = g, r = c);
  }
  return r;
};
GIFEncoder.prototype.getImagePixels = function() {
  var e = this.width, o = this.height;
  this.pixels = new Uint8Array(e * o * 3);
  for (var n = this.image, t = 0, r = 0, a = 0; a < o; a++)
    for (var l = 0; l < e; l++)
      this.pixels[r++] = n[t++], this.pixels[r++] = n[t++], this.pixels[r++] = n[t++], t++;
};
GIFEncoder.prototype.writeGraphicCtrlExt = function() {
  this.out.writeByte(33), this.out.writeByte(249), this.out.writeByte(4);
  var e, o;
  this.transparent === null ? (e = 0, o = 0) : (e = 1, o = 2), this.dispose >= 0 && (o = this.dispose & 7), o <<= 2, this.out.writeByte(
    0 | // 1:3 reserved
    o | // 4:6 disposal
    0 | // 7 user input - 0 = none
    e
    // 8 transparency flag
  ), this.writeShort(this.delay), this.out.writeByte(this.transIndex), this.out.writeByte(0);
};
GIFEncoder.prototype.writeImageDesc = function() {
  this.out.writeByte(44), this.writeShort(0), this.writeShort(0), this.writeShort(this.width), this.writeShort(this.height), this.firstFrame || this.globalPalette ? this.out.writeByte(0) : this.out.writeByte(
    128 | // 4-5 reserved
    this.palSize
    // 6-8 size of color table
  );
};
GIFEncoder.prototype.writeLSD = function() {
  this.writeShort(this.width), this.writeShort(this.height), this.out.writeByte(
    240 | // 5 : gct sort flag = 0
    this.palSize
    // 6-8 : gct size
  ), this.out.writeByte(0), this.out.writeByte(0);
};
GIFEncoder.prototype.writeNetscapeExt = function() {
  this.out.writeByte(33), this.out.writeByte(255), this.out.writeByte(11), this.out.writeUTFBytes("NETSCAPE2.0"), this.out.writeByte(3), this.out.writeByte(1), this.writeShort(this.repeat), this.out.writeByte(0);
};
GIFEncoder.prototype.writePalette = function() {
  this.out.writeBytes(this.colorTab);
  for (var e = 3 * 256 - this.colorTab.length, o = 0; o < e; o++)
    this.out.writeByte(0);
};
GIFEncoder.prototype.writeShort = function(e) {
  this.out.writeByte(e & 255), this.out.writeByte(e >> 8 & 255);
};
GIFEncoder.prototype.writePixels = function() {
  var e = new LZWEncoder(this.width, this.height, this.indexedPixels, this.colorDepth);
  e.encode(this.out);
};
GIFEncoder.prototype.stream = function() {
  return this.out;
};
var __awaiter = function(e, o, n, t) {
  function r(a) {
    return a instanceof n ? a : new n(function(l) {
      l(a);
    });
  }
  return new (n || (n = Promise))(function(a, l) {
    function s(p) {
      try {
        d(t.next(p));
      } catch (f) {
        l(f);
      }
    }
    function c(p) {
      try {
        d(t.throw(p));
      } catch (f) {
        l(f);
      }
    }
    function d(p) {
      p.done ? a(p.value) : r(p.value).then(s, c);
    }
    d((t = t.apply(e, o || [])).next());
  });
};
const { Canvas } = obj, defaultScale = 0.4;
function loadImage(e) {
  if (!e)
    return;
  function o(n) {
    n.onload = null, n.onerror = null;
  }
  return new Promise(function(n, t) {
    if (e.slice(0, 4) == "data") {
      let a = new Image();
      a.onload = function() {
        n(a), o(a);
      }, a.onerror = function() {
        t("Image load error"), o(a);
      }, a.src = e;
      return;
    }
    let r = new Image();
    r.setAttribute("crossOrigin", "Anonymous"), r.onload = function() {
      n(r);
    }, r.onerror = function() {
      t("Image load error");
    }, r.src = e;
  });
}
class AwesomeQR {
  constructor(o) {
    const n = Object.assign({}, o);
    if (Object.keys(AwesomeQR.defaultOptions).forEach((t) => {
      t in n || Object.defineProperty(n, t, { value: AwesomeQR.defaultOptions[t], enumerable: !0, writable: !0 });
    }), n.components ? typeof n.components == "object" && Object.keys(AwesomeQR.defaultComponentOptions).forEach((t) => {
      t in n.components ? Object.defineProperty(n.components, t, {
        value: Object.assign(Object.assign({}, AwesomeQR.defaultComponentOptions[t]), n.components[t]),
        enumerable: !0,
        writable: !0
      }) : Object.defineProperty(n.components, t, {
        value: AwesomeQR.defaultComponentOptions[t],
        enumerable: !0,
        writable: !0
      });
    }) : n.components = AwesomeQR.defaultComponentOptions, n.dotScale !== null && n.dotScale !== void 0) {
      if (n.dotScale <= 0 || n.dotScale > 1)
        throw new Error("dotScale should be in range (0, 1].");
      n.components.data.scale = n.dotScale, n.components.timing.scale = n.dotScale, n.components.alignment.scale = n.dotScale;
    }
    this.options = n, this.canvas = new Canvas(o.size, o.size), this.canvasContext = this.canvas.getContext("2d"), this.qrCode = new QRCodeModel(-1, this.options.correctLevel), Number.isInteger(this.options.maskPattern) && (this.qrCode.maskPattern = this.options.maskPattern), Number.isInteger(this.options.version) && (this.qrCode.typeNumber = this.options.version), this.qrCode.addData(this.options.text), this.qrCode.make();
  }
  draw() {
    return new Promise((o) => this._draw().then(o));
  }
  _clear() {
    this.canvasContext.clearRect(0, 0, this.canvas.width, this.canvas.height);
  }
  static _prepareRoundedCornerClip(o, n, t, r, a, l) {
    o.beginPath(), o.moveTo(n, t), o.arcTo(n + r, t, n + r, t + a, l), o.arcTo(n + r, t + a, n, t + a, l), o.arcTo(n, t + a, n, t, l), o.arcTo(n, t, n + r, t, l), o.closePath();
  }
  static _getAverageRGB(o) {
    const t = {
      r: 0,
      g: 0,
      b: 0
    };
    let r, a, l = -4;
    const s = {
      r: 0,
      g: 0,
      b: 0
    };
    let c = 0;
    a = o.naturalHeight || o.height, r = o.naturalWidth || o.width;
    const p = new Canvas(r, a).getContext("2d");
    if (!p)
      return t;
    p.drawImage(o, 0, 0);
    let f;
    try {
      f = p.getImageData(0, 0, r, a);
    } catch {
      return t;
    }
    for (; (l += 5 * 4) < f.data.length; )
      f.data[l] > 200 || f.data[l + 1] > 200 || f.data[l + 2] > 200 || (++c, s.r += f.data[l], s.g += f.data[l + 1], s.b += f.data[l + 2]);
    return s.r = ~~(s.r / c), s.g = ~~(s.g / c), s.b = ~~(s.b / c), s;
  }
  static _drawDot(o, n, t, r, a = 0, l = 1) {
    o.fillRect((n + a) * r, (t + a) * r, l * r, l * r);
  }
  static _drawAlignProtector(o, n, t, r) {
    o.clearRect((n - 2) * r, (t - 2) * r, 5 * r, 5 * r), o.fillRect((n - 2) * r, (t - 2) * r, 5 * r, 5 * r);
  }
  static _drawAlign(o, n, t, r, a = 0, l = 1, s, c) {
    const d = o.fillStyle;
    o.fillStyle = s, new Array(4).fill(0).map((p, f) => {
      AwesomeQR._drawDot(o, n - 2 + f, t - 2, r, a, l), AwesomeQR._drawDot(o, n + 2, t - 2 + f, r, a, l), AwesomeQR._drawDot(o, n + 2 - f, t + 2, r, a, l), AwesomeQR._drawDot(o, n - 2, t + 2 - f, r, a, l);
    }), AwesomeQR._drawDot(o, n, t, r, a, l), c || (o.fillStyle = "rgba(255, 255, 255, 0.6)", new Array(2).fill(0).map((p, f) => {
      AwesomeQR._drawDot(o, n - 1 + f, t - 1, r, a, l), AwesomeQR._drawDot(o, n + 1, t - 1 + f, r, a, l), AwesomeQR._drawDot(o, n + 1 - f, t + 1, r, a, l), AwesomeQR._drawDot(o, n - 1, t + 1 - f, r, a, l);
    })), o.fillStyle = d;
  }
  _draw() {
    var o, n, t, r, a, l, s, c, d, p, f, g, b, k, x, N, O, m, ee;
    return __awaiter(this, void 0, void 0, function* () {
      const z = (o = this.qrCode) === null || o === void 0 ? void 0 : o.moduleCount, P = this.options.size;
      let V = this.options.margin;
      (V < 0 || V * 2 >= P) && (V = 0);
      const U = Math.ceil(V), E = P - 2 * V, C = this.options.whiteMargin, I = this.options.backgroundDimming, v = Math.ceil(E / z), M = v * z, $ = M + 2 * U, H = new Canvas($, $), X = H.getContext("2d");
      this._clear(), X.save(), X.translate(U, U);
      const te = new Canvas($, $), oe = te.getContext("2d");
      let ne = null, ie = [];
      if (this.options.gifBackground) {
        const xe = parseGIF(this.options.gifBackground);
        if (ne = xe, ie = decompressFrames(xe), this.options.autoColor) {
          let _e = 0, Ee = 0, re = 0, ce = 0;
          for (let ye = 0; ye < ie[0].colorTable.length; ye++) {
            const me = ie[0].colorTable[ye];
            me[0] > 200 || me[1] > 200 || me[2] > 200 || me[0] === 0 && me[1] === 0 && me[2] === 0 || (ce++, _e += me[0], Ee += me[1], re += me[2]);
          }
          _e = ~~(_e / ce), Ee = ~~(Ee / ce), re = ~~(re / ce), this.options.colorDark = `rgb(${_e},${Ee},${re})`;
        }
      } else if (this.options.backgroundImage) {
        const xe = yield loadImage(this.options.backgroundImage);
        if (this.options.autoColor) {
          const _e = AwesomeQR._getAverageRGB(xe);
          this.options.colorDark = `rgb(${_e.r},${_e.g},${_e.b})`;
        }
        oe.drawImage(xe, 0, 0, xe.width, xe.height, 0, 0, $, $), oe.rect(0, 0, $, $), oe.fillStyle = I, oe.fill();
      } else
        oe.rect(0, 0, $, $), oe.fillStyle = this.options.colorLight, oe.fill();
      const se = QRUtil.getPatternPosition(this.qrCode.typeNumber), pe = ((t = (n = this.options.components) === null || n === void 0 ? void 0 : n.data) === null || t === void 0 ? void 0 : t.scale) || defaultScale, he = (1 - pe) * 0.5;
      for (let xe = 0; xe < z; xe++)
        for (let _e = 0; _e < z; _e++) {
          const Ee = this.qrCode.isDark(xe, _e), re = _e < 8 && (xe < 8 || xe >= z - 8) || _e >= z - 8 && xe < 8, ce = xe == 6 && _e >= 8 && _e <= z - 8 || _e == 6 && xe >= 8 && xe <= z - 8;
          let ye = re || ce;
          for (let ve = 1; ve < se.length - 1; ve++)
            ye = ye || xe >= se[ve] - 2 && xe <= se[ve] + 2 && _e >= se[ve] - 2 && _e <= se[ve] + 2;
          const me = _e * v + (ye ? 0 : he * v), ue = xe * v + (ye ? 0 : he * v);
          if (X.strokeStyle = Ee ? this.options.colorDark : this.options.colorLight, X.lineWidth = 0.5, X.fillStyle = Ee ? this.options.colorDark : this.options.colorLight, se.length === 0)
            ye || X.fillRect(me, ue, (ye ? 1 : pe) * v, (ye ? 1 : pe) * v);
          else {
            const ve = _e < z - 4 && _e >= z - 4 - 5 && xe < z - 4 && xe >= z - 4 - 5;
            !ye && !ve && X.fillRect(me, ue, (ye ? 1 : pe) * v, (ye ? 1 : pe) * v);
          }
        }
      const ae = se[se.length - 1], le = this.options.colorLight;
      if (X.fillStyle = le, X.fillRect(0, 0, 8 * v, 8 * v), X.fillRect(0, (z - 8) * v, 8 * v, 8 * v), X.fillRect((z - 8) * v, 0, 8 * v, 8 * v), !((a = (r = this.options.components) === null || r === void 0 ? void 0 : r.timing) === null || a === void 0) && a.protectors && (X.fillRect(8 * v, 6 * v, (z - 8 - 8) * v, v), X.fillRect(6 * v, 8 * v, v, (z - 8 - 8) * v)), !((s = (l = this.options.components) === null || l === void 0 ? void 0 : l.cornerAlignment) === null || s === void 0) && s.protectors && AwesomeQR._drawAlignProtector(X, ae, ae, v), !((d = (c = this.options.components) === null || c === void 0 ? void 0 : c.alignment) === null || d === void 0) && d.protectors)
        for (let xe = 0; xe < se.length; xe++)
          for (let _e = 0; _e < se.length; _e++) {
            const Ee = se[_e], re = se[xe];
            if (!(Ee === 6 && (re === 6 || re === ae))) {
              if (re === 6 && (Ee === 6 || Ee === ae))
                continue;
              if (Ee === ae && re === ae)
                continue;
              AwesomeQR._drawAlignProtector(X, Ee, re, v);
            }
          }
      X.fillStyle = this.options.colorDark, X.fillRect(0, 0, 7 * v, v), X.fillRect((z - 7) * v, 0, 7 * v, v), X.fillRect(0, 6 * v, 7 * v, v), X.fillRect((z - 7) * v, 6 * v, 7 * v, v), X.fillRect(0, (z - 7) * v, 7 * v, v), X.fillRect(0, (z - 7 + 6) * v, 7 * v, v), X.fillRect(0, 0, v, 7 * v), X.fillRect(6 * v, 0, v, 7 * v), X.fillRect((z - 7) * v, 0, v, 7 * v), X.fillRect((z - 7 + 6) * v, 0, v, 7 * v), X.fillRect(0, (z - 7) * v, v, 7 * v), X.fillRect(6 * v, (z - 7) * v, v, 7 * v), X.fillRect(2 * v, 2 * v, 3 * v, 3 * v), X.fillRect((z - 7 + 2) * v, 2 * v, 3 * v, 3 * v), X.fillRect(2 * v, (z - 7 + 2) * v, 3 * v, 3 * v);
      const fe = ((f = (p = this.options.components) === null || p === void 0 ? void 0 : p.timing) === null || f === void 0 ? void 0 : f.scale) || defaultScale, Ce = (1 - fe) * 0.5;
      for (let xe = 0; xe < z - 8; xe += 2)
        AwesomeQR._drawDot(X, 8 + xe, 6, v, Ce, fe), AwesomeQR._drawDot(X, 6, 8 + xe, v, Ce, fe);
      const Be = ((b = (g = this.options.components) === null || g === void 0 ? void 0 : g.cornerAlignment) === null || b === void 0 ? void 0 : b.scale) || defaultScale, De = (1 - Be) * 0.5;
      AwesomeQR._drawAlign(X, ae, ae, v, De, Be, this.options.colorDark, ((x = (k = this.options.components) === null || k === void 0 ? void 0 : k.cornerAlignment) === null || x === void 0 ? void 0 : x.protectors) || !1);
      const Fe = ((O = (N = this.options.components) === null || N === void 0 ? void 0 : N.alignment) === null || O === void 0 ? void 0 : O.scale) || defaultScale, Me = (1 - Fe) * 0.5;
      for (let xe = 0; xe < se.length; xe++)
        for (let _e = 0; _e < se.length; _e++) {
          const Ee = se[_e], re = se[xe];
          if (!(Ee === 6 && (re === 6 || re === ae))) {
            if (re === 6 && (Ee === 6 || Ee === ae))
              continue;
            if (Ee === ae && re === ae)
              continue;
            AwesomeQR._drawAlign(X, Ee, re, v, Me, Fe, this.options.colorDark, ((ee = (m = this.options.components) === null || m === void 0 ? void 0 : m.alignment) === null || ee === void 0 ? void 0 : ee.protectors) || !1);
          }
        }
      if (C && (X.fillStyle = this.options.backgroundColor, X.fillRect(-U, -U, $, U), X.fillRect(-U, M, $, U), X.fillRect(M, -U, U, $), X.fillRect(-U, -U, U, $)), this.options.logoImage) {
        const xe = yield loadImage(this.options.logoImage);
        let _e = this.options.logoScale, Ee = this.options.logoMargin, re = this.options.logoCornerRadius;
        (_e <= 0 || _e >= 1) && (_e = 0.2), Ee < 0 && (Ee = 0), re < 0 && (re = 0);
        const ce = M * _e, ye = 0.5 * ($ - ce), me = ye;
        X.restore(), X.fillStyle = this.options.logoBackgroundColor, X.save(), AwesomeQR._prepareRoundedCornerClip(X, ye - Ee, me - Ee, ce + 2 * Ee, ce + 2 * Ee, re + Ee), X.clip();
        const ue = X.globalCompositeOperation;
        X.globalCompositeOperation = "destination-out", X.fill(), X.globalCompositeOperation = ue, X.restore(), X.save(), AwesomeQR._prepareRoundedCornerClip(X, ye, me, ce, ce, re), X.clip(), X.drawImage(xe, ye, me, ce, ce), X.restore(), X.save(), X.translate(U, U);
      }
      if (ne) {
        let xe, _e, Ee, re, ce, ye;
        if (ie.forEach(function(me) {
          xe || (xe = new GIFEncoder(P, P), xe.setDelay(me.delay), xe.setRepeat(0));
          const { width: ue, height: ve } = me.dims;
          _e || (_e = new Canvas(ue, ve), Ee = _e.getContext("2d"), Ee.rect(0, 0, _e.width, _e.height), Ee.fillStyle = "#ffffff", Ee.fill()), (!re || !ye || ue !== re.width || ve !== re.height) && (re = new Canvas(ue, ve), ce = re.getContext("2d"), ye = ce.createImageData(ue, ve)), ye.data.set(me.patch), ce.putImageData(ye, 0, 0), Ee.drawImage(re.getContext("2d").canvas, me.dims.left, me.dims.top);
          const we = new Canvas($, $), Se = we.getContext("2d");
          Se.drawImage(_e.getContext("2d").canvas, 0, 0, $, $), Se.rect(0, 0, $, $), Se.fillStyle = I, Se.fill(), Se.drawImage(H.getContext("2d").canvas, 0, 0, $, $);
          const de = new Canvas(P, P), ge = de.getContext("2d");
          ge.drawImage(we.getContext("2d").canvas, 0, 0, P, P), xe.addFrame(ge.getImageData(0, 0, de.width, de.height).data);
        }), !xe)
          throw new Error("No frames.");
        if (xe.finish(), isElement(this.canvas)) {
          const ue = xe.stream().toFlattenUint8Array().reduce((ve, we) => ve + String.fromCharCode(we), "");
          return Promise.resolve(`data:image/gif;base64,${window.btoa(ue)}`);
        }
        return Promise.resolve(Buffer.from(xe.stream().toFlattenUint8Array()));
      } else {
        oe.drawImage(H.getContext("2d").canvas, 0, 0, $, $), X.drawImage(te.getContext("2d").canvas, -U, -U, $, $);
        const xe = new Canvas(P, P);
        xe.getContext("2d").drawImage(H.getContext("2d").canvas, 0, 0, P, P), this.canvas = xe;
        const Ee = this.options.gifBackground ? "gif" : "png";
        return isElement(this.canvas) ? Promise.resolve(this.canvas.toDataURL(Ee)) : Promise.resolve(this.canvas.toBuffer(Ee));
      }
    });
  }
}
AwesomeQR.CorrectLevel = QRErrorCorrectLevel;
AwesomeQR.defaultComponentOptions = {
  data: {
    scale: 0.4
  },
  timing: {
    scale: 0.5,
    protectors: !1
  },
  alignment: {
    scale: 0.5,
    protectors: !1
  },
  cornerAlignment: {
    scale: 0.5,
    protectors: !0
  }
};
AwesomeQR.defaultOptions = {
  text: "",
  size: 400,
  margin: 20,
  colorDark: "#000000",
  colorLight: "rgba(255, 255, 255, 0.6)",
  correctLevel: QRErrorCorrectLevel.M,
  backgroundImage: void 0,
  backgroundDimming: "rgba(0,0,0,0)",
  logoImage: void 0,
  logoScale: 0.2,
  logoMargin: 4,
  logoCornerRadius: 8,
  whiteMargin: !0,
  components: AwesomeQR.defaultComponentOptions,
  autoColor: !0,
  logoBackgroundColor: "#ffffff",
  backgroundColor: "#ffffff"
};
function isElement(e) {
  try {
    return e instanceof HTMLElement;
  } catch {
    return typeof e == "object" && e.nodeType === 1 && typeof e.style == "object" && typeof e.ownerDocument == "object";
  }
}
const _sfc_main$s = {
  props: {
    text: {
      type: String,
      required: !0
    },
    qid: {
      type: String
    },
    correctLevel: {
      type: Number,
      default: 1
    },
    size: {
      type: Number,
      default: 200
    },
    margin: {
      type: Number,
      default: 20
    },
    colorDark: {
      type: String,
      default: "#000000"
    },
    colorLight: {
      type: String,
      default: "#FFFFFF"
    },
    bgSrc: {
      type: String,
      default: void 0
    },
    background: {
      type: String,
      default: "rgba(0,0,0,0)"
    },
    backgroundDimming: {
      type: String,
      default: "rgba(0,0,0,0)"
    },
    logoSrc: {
      type: String,
      default: void 0
    },
    logoBackgroundColor: {
      type: String,
      default: "rgba(255,255,255,1)"
    },
    gifBgSrc: {
      type: String,
      default: void 0
    },
    logoScale: {
      type: Number,
      default: 0.2
    },
    logoMargin: {
      type: Number,
      default: 0
    },
    logoCornerRadius: {
      type: Number,
      default: 8
    },
    whiteMargin: {
      type: [Boolean, String],
      default: !0
    },
    dotScale: {
      type: Number,
      default: 1
    },
    autoColor: {
      type: [Boolean, String],
      default: !0
    },
    binarize: {
      type: [Boolean, String],
      default: !1
    },
    binarizeThreshold: {
      type: Number,
      default: 128
    },
    callback: {
      type: Function,
      default: function() {
      }
    },
    bindElement: {
      type: Boolean,
      default: !0
    },
    backgroundColor: {
      type: String,
      default: "#FFFFFF"
    },
    components: {
      default: function() {
        return {
          data: {
            scale: 1
          },
          timing: {
            scale: 1,
            protectors: !1
          },
          alignment: {
            scale: 1,
            protectors: !1
          },
          cornerAlignment: {
            scale: 1,
            protectors: !0
          }
        };
      }
    }
  },
  name: "vue-qr",
  data() {
    return {
      imgUrl: ""
    };
  },
  watch: {
    $props: {
      deep: !0,
      handler() {
        this.main();
      }
    }
  },
  mounted() {
    this.main();
  },
  methods: {
    async main() {
      if (this.gifBgSrc) {
        const n = await readAsArrayBuffer(this.gifBgSrc), t = this.logoSrc;
        this.render(void 0, t, n);
        return;
      }
      const e = this.bgSrc, o = this.logoSrc;
      this.render(e, o);
    },
    async render(e, o, n) {
      const t = this;
      new AwesomeQR({
        gifBackground: n,
        text: t.text,
        size: t.size,
        margin: t.margin,
        colorDark: t.colorDark,
        colorLight: t.colorLight,
        backgroundColor: t.backgroundColor,
        backgroundImage: e,
        backgroundDimming: t.backgroundDimming,
        logoImage: o,
        logoScale: t.logoScale,
        logoBackgroundColor: t.logoBackgroundColor,
        correctLevel: t.correctLevel,
        logoMargin: t.logoMargin,
        logoCornerRadius: t.logoCornerRadius,
        whiteMargin: toBoolean(t.whiteMargin),
        dotScale: t.dotScale,
        autoColor: toBoolean(t.autoColor),
        binarize: toBoolean(t.binarize),
        binarizeThreshold: t.binarizeThreshold,
        components: t.components
      }).draw().then((r) => {
        this.imgUrl = r, t.callback && t.callback(r, t.qid);
      });
    }
  }
}, _hoisted_1$o = ["src"];
function _sfc_render$s(e, o, n, t, r, a) {
  return n.bindElement ? (openBlock(), createElementBlock("img", {
    key: 0,
    style: { display: "inline-block" },
    src: r.imgUrl
  }, null, 8, _hoisted_1$o)) : createCommentVNode("", !0);
}
const VueQr = /* @__PURE__ */ _export_sfc(_sfc_main$s, [["render", _sfc_render$s], ["__file", "vue-qr.vue"]]), alcQrCodeProps = {
  /**
   * 二维码内容
   */
  value: { type: String, default: void 0 },
  /**
   * 宽度
   * @default 100
   */
  size: { type: [Number, String], default: 100 },
  /**
   * 实点的颜色
   * @default '#000000'
   */
  colorDark: { type: String, default: "#000000" },
  /**
   * 空白区的颜色
   * @default '#ffffff'
   */
  colorLight: { type: String, default: "#ffffff" },
  /**
   * 二维码中心 logo
   */
  icon: { type: String, default: void 0 },
  /**
   * logo 边距
   * @default 0
   */
  iconMargin: { type: Number, default: 0 },
  /**
   * 边距
   * @default 10
   */
  margin: { type: [Number, String], default: 10 },
  /**
   * 容错级别
   * @default 0
   */
  level: {
    type: Number,
    default: 0,
    validator: (e) => [0, 1, 2, 3].includes(e)
  }
}, _sfc_main$r = /* @__PURE__ */ defineComponent({
  name: "alc-qrcode",
  inheritAttrs: !1,
  __name: "qrcode",
  props: alcQrCodeProps,
  emits: ["change"],
  setup(e, { expose: o, emit: n }) {
    o();
    const t = n, r = e, a = ref(null), l = computed(() => typeof r.size == "number" ? r.size : Number(r.size) || 100), s = computed(() => typeof r.level == "number" ? r.level : Number(r.level) || 0), c = computed(() => typeof r.margin == "number" ? r.margin : Number(r.margin) || 10), p = { emits: t, props: r, qrcode: a, realSize: l, realLevel: s, qrMargin: c, callback: (f, g) => {
      t("change", f, g);
    }, VueQr };
    return Object.defineProperty(p, "__isScriptSetup", { enumerable: !1, value: !0 }), p;
  }
});
function _sfc_render$r(e, o, n, t, r, a) {
  return e.value ? (openBlock(), createBlock(t.VueQr, mergeProps({
    key: 0,
    ref: "qrcode",
    callback: t.callback
  }, e.$attrs, {
    margin: t.qrMargin,
    text: e.value,
    size: t.realSize,
    "color-dark": e.colorDark,
    "color-light": e.colorLight,
    "logo-src": e.icon,
    "logo-margin": e.iconMargin,
    "correct-level": t.realLevel
  }), null, 16, ["margin", "text", "size", "color-dark", "color-light", "logo-src", "logo-margin", "correct-level"])) : createCommentVNode("", !0);
}
const QrCode = /* @__PURE__ */ _export_sfc(_sfc_main$r, [["render", _sfc_render$r], ["__file", "qrcode.vue"]]), AlcQrcode = withInstall(QrCode), bankIconAbc = "data:image/png;base64,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", bankIconBoc = "data:image/png;base64,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", bankIconBocom = "data:image/png;base64,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", bankIconCcb = "data:image/png;base64,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", bankIconIcbc = "data:image/png;base64,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", bankIconPsbc = "data:image/png;base64,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", bankIconCup = "data:image/png;base64,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", aliPayIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAQ/SURBVFiFvZdPaFRXFMZ/331vZqLJIssIShGysLQLFxYaqJhQpbEZWxeVuqvQSumqmxYVCyKloNCCQjcFhRYsCG3RaAShgTF0oYsssikV6iKLgCl10UUmzbzM3K+LyeTPzCQzVduzeu/ec8/3nXPuPfdc0a2U3Jcv14qSDtjeB9oJDKzMzoPnJE3bnsp6kwlGtNCNWXVSKIx7kDSecuQ4oq8rsmZBgetUw8XK23r0dARK7skvxnOYT4C0K+BWqSK+zLaH84xoqWsChXEPOok/AHufErhZZlQLx9pFo4VA/rb3SLHktfw+FxHM22EkO6KHmxIo3PUg1fjL8wZfT4I07K+MrkVijUDJPflyvE/3YV+QeAJgMwD0dLluJusNQ409ERqj+cV47l+Ag/mqMpbsrowlu4UedL0O9uYX49nGT4CVo1bf7f+PmNOFcQ9C43il8RRuf9SE7tmeah4PxHuN76j4naJadAi8gDnRxmxKGk8BJwMl9zly/GkceRZx5Dgl96X5cq2ItGmFMx5GDDePRweAewDB4T3LLTp4CwaiL1+uFdN6be9IeAYxs9G4V//bpiDoDexXtzIq6UBqa9/WVAFp1sQmAPpzd6onVvkEzy5vT643jldhIr7eyS+jvSpM1B4/j8IjNFcphl0A/Tfcv5iLf9LhDhHMhW7BJWYF85squPZT43MxVxvtBA5g2Bm2UhCalOLhrDdsq4wluyvFZEfWG7ZZ4RWZj5BuAgsAMaTX1q081dGjhuZmKZC4rCxcci4eRbxkkyLmsX/NKZksj6kejZJ7esq8tlTUJEDPxPLBSPi5K3AxlxrNgQeaZqahdjfm+B1IV/eo63FZdqQwEe/a8ZtsRDeXYHJtcYrwpPHBTgSM5oLk6RZm9vd28jFb5NF4FOlG7lb1g/XjS0VNVorhUBLCLsQZ2Hj9bsDBM6FdmZX8Fyu53UokLi+/lV4BSG8tv5a/XT3amPv7Tc1lY8mFrBheTEIYkrjSbNP2lOrNZnwM6/o98W0I4WqsxdImUViQOVM5knwNK3l3uLHSM85gn8+OpDdbVpXcl1usvSPCh9gvZ71hhwAKE9UrRu+vU60Gx0O1kC4E+3PjYaCnHs7aeE7ppfKY5ik5zS/EzxBn2xDdnAjQe8cD5THN1wnUe8DfNhgxC8gns2J6vY0nPfly7SjoHLCnHUC3RFY7ovzE8gUIrefXPFJg0pE/CBRAe7CHgf4OwC1ELF9e3p5cY0TVFgJ1r3wf/Lw64U1EP2bFcKzxt1YJR7SkVMe2LLfPCg3zIdGn68c2lOLKqB7ZYeS/INFoy5cOa3ZTAgDZET0kDftBM81zzwA/rSQMNb8J2hKAeiSyXg1BvAhU2+l0KUsQv8h6tb/Z81VqnSwUxj1IUjtt9C50+TiFJdlXicmlp3+cNsuG57n2Ce9s3KISs7aeCD+wPZX1JXe7fZ7/AycV2+KjBpLGAAAAAElFTkSuQmCC", carPayIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAYCAYAAAALQIb7AAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAB2SURBVEiJ7dbBCYAwDIXhP9IhOp4DeHGTgnq2I+gobuEWz7PisQYsfccU+kFoQi0mTcDA95ktJskBAqDzghpWLAHInmCdsZi0emEB6L2wep9+w/6HhRKXGGwS+8vBbYaLYBLHOVp+1p8Lw7WN7VtQCBOLiySWC8y9GjS/otIHAAAAAElFTkSuQmCC", fundPayIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAYAAACN1PRVAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAIsSURBVEiJrZaxThtBEIa/fzHB6a6JZFNRkAKJl0A0lClcJFKKdIllIYxCxAukSBTQYaEoSZUiRSgo8gJWXsISFBRUhyOncBHJF3F4UviCkH13Xiz/5e3MfKvd2f9GTNFKaMEAanJsYqwDq0AZiIELRMeGtB/C6eWu+kW1lLfw6KNVStfsG7xKi09TLPicLPK+11DXG1Y9sufAsUHgARkv2B+K+q8dnYyvuQxQaPBtFhCAQSDje6VlHzI2MgFqzgLJlDjo7ujNBKwS2gvE17mBUpl49v9IBbfNcDbr0RVJ0E8WWes11HUAadfNHQSjOyxdsw+gldCCWFzh196zKi4b1dIAapoO6mJ8yV0VL4FKQX55ALVS6gyFILfARrSt87yA5WM7Gd7wswgox6ZLLWhmEEC0rXO3wAaQ6RwAGOuOkddN7gT6PqBxoCDPH1cdOfdlEFjClg/oNidhq6Cry46Re2cni7AampejVENrmggLQmIHXBQV8QF6gAAuHKIzJagQ6AkC0XGC9tTAHKA3CBC03dKQUwruLQ94HxAQLw05VZp4ZGLHMxHBD4Mn3vFG62pXTQeQPOBdwfuY0L1A0NcNbyH9U/ca6krUfQvcRxL1aE+/b2EA0egHdzhn1mF0ZxaZGHgqR3YAvJ4HqNvU3t0PmdPVcsuemvFp1ulKoh75TFcwOtJkkTUZLTyfBRDLaCnhcRYo3UixVkIL/jpqxsRE/Ae4RHQE7aXh9In4H3Ez3+x9SgRVAAAAAElFTkSuQmCC", offlinePeyIcon = "data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAJ5SURBVFiFxZfRbdswEIY/0klhNX1QJ6iygT1BmAmKTFBngcaawMoETDKBO0GTCcxMEG9QdwL7JZFRQGQfJFeuLMmSLSA/IEAgefx/Hnl3pFAPa41zY7qCdaEJP941HS47JQeQ4qbN8JN/fwJDYp8PJu7JCxyqrVkuILHPJjyLDuVX+jVCytYC5KGEXeGkrlPppQ8fxkj5DQhAzME9mRsv6kpAvQdk/wUpJyk5gBsAE/UQz3YH/7nDco7lso2ASg8oHY9y4gIcSul4ZEJvumky4ecVsGpDDnUe6ImvtZaCi7Zk7QS4itXnlvX9HQgwtZbH5IwtVEeBc/cINwLhl/QuQE7LzJRe+khvBq7MrgCxqvSACb0F1l2nZAVym1yZ0Cu2Z+j7WbQEbA6xEI/Z/49MWNbnBrVhaMKzRyyXWHuFtbfACLsemvDTfM/SthGQJM8g5lgWRY/WCkgTUeKDXIE0WH7DadCCHHBpaNq4ND/U5IHXKEtCBfRQ93HbsjuA0wXYoLjmUg8o/TYuJ9+2FFrdx9F+buGnqbw3yFL6fgEtavpE6Vg1GBdkcwbFjp0tSPe9RZKR7qfS8XATFSb0FkrH16m7d/BUMF6UnIF+g/jdhvCRzJReDrN6wHaN2IfactwCAbL/kq68mDfWq42wMhx/IRFMcxHMkPz6/+svlX6rvHceLcB8966B29pBPVlZOTvZAnPjRUrHU1IvfNkZkMRPO21dCoCsduzWjb0oEbBegTdvVM1ETpiGbxpB1YWqgYDsxA6bTpDjwxjJhNQL502t3v1a/u4C8i3oyQulX6ODZ0qfZkcIcKhDnlZb9gdBIkTjp3QjpNevxvgLbP3M68d5guwAAAAASUVORK5CYII=", onlinePayIcon = "data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAgCAYAAAAMq2gFAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAH0SURBVEiJ1ZffbdswEIe/owI0TvqgTFB3gnoEeoLGE6RZoAUnsDOB6gmcTlB3AnODqBOEncAOEFQFCvP6YMU21MKSXblIf0/iv/t4R/IoCoDNii4JE1R7ICmtSBeI5Cy58a7jxWaFxTDb6hFaAqXrSUden5AwRAGRKUt13nVaAoEdFyNgSMJE7Pj7HCQl/rjw7mLRFmQDW9k3pXvhGJCVZAFgjmP8d/0z0EldB5sVtvwM1Y2yq62qeo8SeYthhmFms6K7hoyLUVk/qbXRBOTfnzoED3Qx8tlm83S9bQEi/SZHojZ0ACy5xugd0MO8uAfKg6jOu7NaCDTcDN51AlEGq1J52oVb784+NpooNR6V6enVpkZy0B4AKrkdF1fryXzofDoYhHAFvNtU6FajVr35C5Aux2iyMWCiBTMEyYnqdo7dC8TPAMnWtZHMt7wK7YHkNEP+FDrtYbiv9j4cpPELyrd1OUneoHoJBGLcuSZ7gbw7nwLTp3K5yy4Rgnfno31AzzR7x/iA4FH9ui+oWQoqVQ3lPnqmofsfQOUaabqdINuVpiBPIEmB2+OAVglj39AFIn1iHNBqrqsqLgfevcwBbPYYMMlds4G6MOX/wAFKmj8GRHKx2WOv+cwIwIgYHzAmA7qNRkX6AuWVnTA80rPl2rtO+AXYirlzX9hJIQAAAABJRU5ErkJggg==", scanPayIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEMAAAA8CAYAAAA9vgdnAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAE0SURBVGiB7dsxTgJBGIbh718pOQAmlLZ2ljbcBMMFXA8ClhYmeBhKE69AQ1z7LZHfwmi+3cTO7BB4n25mtvjzVlPshHoul3mTlVaSbvtnJ2QTB9XvD/Hqm+GL6TKv9pXeJI0HHa2MVqnrpo7tz0blp58XWug8QkjSOEIL3+jEyNRk2HnKSmnq6+qvD88RMQwxDDEMMQwxDDEMMQwxDDEMMQwxDDEMMQwxDDEAAPhXMVnlvPQQx2Kk0Lr0EMeCS5chhiGGIYYhhhkpdVd6CAAATkfn18fJY64lzcuMUsRLcx+/VwsuXYYYhhiGGIYYhhiGGIYYhhiGGIYYhhiGGIYYhhiGGKYf46PIFIVEaufrbozUk6R2yIEKalN69o1OjKaObRw0C2kz7FyD2sf38++Zv3aWpC87Oy/a+SyHhQAAAABJRU5ErkJggg==", ticketPayIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAYCAYAAAALQIb7AAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAEvSURBVEiJ7ZUtT8NQFIafQ5umgoAZSXFbgihy/2A/AIlFzCOowM8j2gSqERMY+l8QSJLNbaKiTDVbmoNYm/AR2rvAmpHwqpt7T85z3pxz7xUv0lvgku3rTrxItQUQAHttgXYa9vzN/suvwgQSP6MvSvBhXwn8jFOBxCiPwYDM3UN606HkAMehXqkQihLMAokAuvfq5q9MAK8ukYkzL18wHozUBpgFEllKvwINRmrnC8ZNIFNnZSSP7gEXlUOAo1j3rRUPwJlJCrsxQrkGUhRWGT7wVB05S06Kdb8SoINwU1tvozOlNw9k2lSTF2oXYVIX0+o92/y5Kp2aOPks856VKpz1unBIrSXDd5H/PdtAP+hZq86aB+Srzr1QU6CzfVjDxNVpZz/PvwZT4lZISvwGmEhziTDiNscAAAAASUVORK5CYII=", weChatPayIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAdCAYAAAAkXAW5AAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAOPSURBVEiJvZdNaFxVFMd/576HTdMUsujCRQpZKBRaIcWJNpiEm2RS6kJQFNJNIQuXgpUWiqAoiKSgEosNKNqdYoQushFMO5CLRmZiAgkYIYssBsyioGBokibWeee4yIdj+uajduJ/9e65H+f33rnvnnOFOuXnfWv0Z3JORJ4zpAOsDWjf6d4C7mBSFLFFM/sxORR9F06H1XrWlloDsnnvzdklsHNAXC80UAKZEJWxXFcI/wli8CffodgoZv4hHFfwIsEhb9x+Jiykdbs0Y3am9101nW0IAICZV9PZbL73rVTG8oaf8nHUbF+DvdIQ56keZTzZkAuhL5R2TXsx/l8AAMzOR0coARcegIiP6DtmHCwA3BH4rIR8Wm4UgMEZn1E0z8Pt/rolwoJi13QjGg99YQvA/+JbuMux0BWKMYCKfYAdBIBM4GQs1xly5db+fM+wrOsIkSwBfXJ21p9KVH9uoOd1hBtx5K5PPh2WyzuyBd+N6KhBZtcWOfdUrKZDVd5kWsSOmXGiDudFM8b0kPti/0np8749imzETM/vn6SmQ7GZeLAKDCyXNtxgdFivIrxeCRTTa8lmNFH+28F23OMNvWKmlzGa0mYb0i0DM72/AccqvN1q0uKOh5NhPVvw3Tj9xIwOoITITWfy0e1nw1zaxP58z7A4GQEer7D2rlbiKgAArW4teRX4OHcmTAOnny/4ts2jrIaTYT1tQlrca6hNBmZ614CWKoOKyT335P5PvV+7ccfsgbjX0FYsIitmVm3jtUeHkxeBm6nO531r/Jdeqhb3ahKR5dhgDmrsfpEr+yH8lI9dUzIs9/U9qx33ijJYdKCTdYzNZAu+e7cxkPfZuFlnxcnnPALAtvRb8VO+KWrWX6m+QRFkTtEbIm6oYSkefk/uueMC0F/ouSgiow1auG6J8WbuzPdXHYBuRtcFUqueAwOAhdKm+3DneVtn5/yJJNEfqBGWBmk1jl3nbm7ZK+9uZcKSRO4lIPUQaqDWJXIvlCe3f9WYuUyYjpzrAooHBFB04npymTBdbkyttv28b43u6zz/3Csaoa+Sx9xraXeRiiX/wEzvH0DrI7sWyUki71e7e6RWU77g20DLAVbFMW4qGbA6EpPMCTbpIvflrUxYqjU6FSISOvYaxjcJ7nLoDCuwUyOsccocT5jR5NA2xa2IsCXKcukoi5UybEXkNGO20HMRcS+j8natK1wj9DcM3XMmSGOvKgAAAABJRU5ErkJggg==", digitalCurrencyPayIcon = "data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAJVSURBVEiJrZbRcdpAEIa/VRgmbyaPATw6OhAdQAVOKghUELsCQQW4A3AFcQcoFVgdcIwRfozylmESrR8kxYcQ2GP7fxJi79/d//b+k1Bggwk8mCkaAC1eh1Qg/odMz7ERgAAkmAlo+ErSI5BpBzuRe8zAQ5fvS55DkX7jAxrq87GxIFEGawAPfEUHQHBqkQezhp4MkoUH089YW/fvPWZQFDio70ADSfCPNJBrCJBg5uSbXxZjQW52cN3Dpqf20DtFvsKU07Rmv1MD0MOmAHkhMn1RAoGog51sMJdNdP5EwO1TlC7K7rb4yw3mskiyOOCrSpQhw78QN9EV0HK7aaJ3ADukX5Em9ZB+vl5XpzqIz7FREy75f9g03GK+9LCphww9ZNjDphvMyNG9pfC9GIbYJWzsyyNR8eg7zwDfVpjInSYPLnBiMvhUchRucJhA4TdABzvmGbSxX+velxy1CUpsMbUnu40dPmCMwvxYYkX3fGxvDwTOyiBFTR3BH0hrSANHlr11FYl0UKSKi4oPpCpmf+i+22KWCj/b2EmCf4dzZg7G1EN6ABn6o0xUooMd5+PKrNLDYIf0GxBUjfNgDzIIO9jxBnMjaIWI8UdoZehov3MZ97DpFv/AOGusQkcJZtLFXisypkZzB6kiV13sIsFM6kyvdopAwwRDcYJv84OnF05ADBKXTnvK7CTB/8WRK1Igcq+/Kh4wJoOQimRuh5JPQDk99RCIQOIM1gItgbOXXDgCkWwwgRQm9t7IkKHXxcbHvPxtyKWV8qdz/b3xs0XiDK7ywuERMbgE2ARcpOoAAAAASUVORK5CYII=", payIcons = {
  // 农行
  abc: bankIconAbc,
  // 中行
  boc: bankIconBoc,
  // 交银
  bocom: bankIconBocom,
  // 建设
  ccb: bankIconCcb,
  // 工商
  icbc: bankIconIcbc,
  // 邮政
  psbc: bankIconPsbc,
  // 银联
  cup: bankIconCup,
  // 支付宝
  aliPay: aliPayIcon,
  // 微信支付
  weChatPay: weChatPayIcon,
  // 银行卡
  carPay: carPayIcon,
  // 融资支付
  fundPay: fundPayIcon,
  // 银行承兑汇票
  ticketPay: ticketPayIcon,
  // 扫码付
  scanPay: scanPayIcon,
  // 线下支付
  offlinePay: offlinePeyIcon,
  // 线上支付
  onlinePay: onlinePayIcon,
  // 数字货币支付
  digitalCurrencyPay: digitalCurrencyPayIcon
}, _sfc_main$q = /* @__PURE__ */ defineComponent({
  name: "alc-pay-view",
  inheritAttrs: !1,
  __name: "pay-view",
  props: {
    code: {},
    onFail: { type: Function },
    onSuccess: { type: Function },
    onCancel: { type: Function },
    onFlowEnd: { type: Function }
  },
  emits: ["fail", "success", "cancel", "flowEnd"],
  setup(e, { expose: o, emit: n }) {
    o();
    const t = e, r = n, a = useProviderConfig("payView", {}), l = ref(/* @__PURE__ */ new Set(["detail"])), s = ref("detail"), c = ref(!1), d = ref(""), p = ref(!1), f = useProviderConfig("state"), {
      cVendorName: g,
      totalSum: b,
      payForm: k,
      orderList: x,
      payMethodList: N
    } = U(c), { formRef: O, cMethod: m, schema: ee, rules: z } = E(), P = [
      { label: "支付项", prop: "goodsName" },
      // { label: '规格型号', prop: 'weight' },
      { label: "数量", prop: "goodsNum", align: "right" },
      // { label: '单位', prop: 'units' },
      { label: "单价", prop: "price", align: "right" },
      { label: "合计", prop: "goodsAmt", align: "right" }
      // { label: '应付金额', prop: 'goodsPayableAmt', align: 'right' },
    ];
    let V = () => {
    };
    function U(oe) {
      const ne = ref({
        cPayPhone: "",
        leaveMsg: ""
      }), ie = ref(""), se = ref(0), pe = shallowRef([]), he = shallowRef([]);
      t.code && ae(t.code);
      function ae(le) {
        oe.value = !0, msPost("alc-public-pay/PaymentAction/queryPayOrder", {
          // 交易流水
          cPaymentFlowNo: le,
          // 交易渠道: 01：PC 02：移动端
          trxChannel: "01",
          cAllLinkUserUuid: f.value.cAllLinkUserUuid
        }).then((fe) => {
          if (fe.code === 1) {
            Object.assign(
              ne.value,
              objPick(fe.data, [
                "cOrderRem",
                "cPayPhone",
                "trxIp",
                "cPayAccName",
                "bAmount"
              ])
            );
            const { cReceiverOrgName: Ce, infoDtos: Be, payMethodInfo: De } = fe.data;
            ie.value = Ce, pe.value = Be || [], he.value = (De == null ? void 0 : De.methods) || [], se.value = fe.data.bOrderAmount;
          } else
            r("fail"), operatorErrorTip(fe.msg);
        }).catch(() => {
          r("fail"), apiLinkErrorTip("获取支付订单");
        }).finally(() => {
          oe.value = !1;
        });
      }
      return {
        cVendorName: ie,
        totalSum: se,
        payForm: ne,
        orderList: pe,
        payMethodList: he
      };
    }
    function E() {
      const oe = ref(), ne = shallowRef([]), ie = {
        showPhone: [
          {
            itemType: "input",
            label: "付款手机号",
            prop: "cPayPhone"
          }
        ],
        showPayerAccount: [
          {
            itemType: "input",
            label: "账户名",
            prop: "payerName"
          },
          {
            itemType: "input",
            label: "账户号",
            prop: "payerAcctNum"
          }
        ]
      }, se = {
        mustInputPhone: {
          cPayPhone: { required: !0, message: "请输入付款手机号" }
        },
        mustInputPayerAccount: {
          payerName: { required: !0, message: "请输入账户名" },
          payerAcctNum: { required: !0, message: "请输入账户号" }
        }
      }, pe = computed(() => Object.entries(ie).reduce((le, [fe, Ce]) => (ae(fe) && le.push(...Ce), le), []).concat({
        itemType: "input",
        label: "付款留言",
        prop: "leaveMsg",
        type: "textarea",
        rows: 3,
        showWordLimit: !0
      })), he = computed(() => Object.entries(se).reduce((le, [fe, Ce]) => ae(fe) ? Object.assign(le, Ce) : le, {}));
      function ae(le) {
        return ne.value.some((fe) => fe[le]);
      }
      return {
        formRef: oe,
        cMethod: ne,
        form: k,
        schema: pe,
        rules: he
      };
    }
    function C() {
      var oe;
      (oe = v()) == null || oe.then((ne) => {
        if (p.value = !0, !!ne) {
          if (ne === "99999999") {
            I();
            return;
          }
          switch (m.value.at(-1).showType) {
            case "1":
              l.value.add("doPay"), s.value = "doPay", V = () => {
                window.open(ne.cPayUrl, "_blank");
              }, V();
              break;
            case "2":
              l.value.add("doPay"), s.value = "doPay", V = () => {
                const ie = window.open("", "_blank");
                ie && ie.document.write(`
                        <!DOCTYPE html>
                        <html lang="zh-CN">
                        <head>
                            <meta charset="UTF-8">
                            <meta http-equiv="X-UA-Compatible" content="IE=edge">
                            <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
                            <meta name="viewport" content="width=device-width, initial-scale=1.0">
                        </head>
                        <body>
                            ${ne.cPayUrl}
                            ${ne.cPayUrl.indexOf(
                  "mobilebank/CashierDeskStart.do"
                ) !== -1 ? `<script type="text/javascript">
            <!-- 主动调用邮储的 load -->
            load && load()
        <\/script>` : ""}
                        </body>
                        </html>
                    `);
              }, V();
              break;
            case "3":
              d.value = ne.cPayUrl, l.value.add("doPay"), s.value = "doPay";
              break;
            case "4":
              ElMessage.success({ message: ne, duration: 8e3 }), close == null || close(), r("flowEnd");
              break;
          }
        }
      });
    }
    function I() {
      if (m.value.at(-1).showType === "1") {
        l.value.add("doPay"), s.value = "doPay";
        const oe = `?q=${JSON.stringify({
          cReceiverOrgName: g.value,
          infoDtos: x.value,
          orgName: f.value.cOrgName
        })}`;
        V = () => {
          window.open(
            process.env.NODE_ENV === "production" ? `https://www.aolianyun.com:8128/${oe}` : `http://192.168.16.139:8067/${oe}`,
            "_blank"
          );
        }, V();
      } else
        ElMessage.success("模拟支付成功"), r("success"), r("flowEnd"), close == null || close();
    }
    async function v() {
      var oe;
      if (!((oe = m.value.at(-1)) != null && oe.cMethod))
        return operatorErrorTip("请选择支付方式"), Promise.reject();
      if (!c.value)
        return c.value = !0, await O.value.validate() ? msPost("alc-public-pay/PaymentAction/confirmPay", {
          ...k.value,
          cMethod: m.value.at(-1).cMethod,
          cPaymentFlowNo: t.code,
          cAllLinkUserUuid: f.value.cAllLinkUserUuid || ""
        }).then((ne) => ne.code === 1 ? ne.data : Promise.reject(ne)).catch((ne) => (r("fail"), ne != null && ne.msg ? operatorErrorTip(ne.msg) : apiLinkErrorTip("支付"), Promise.reject())).finally(() => {
          c.value = !1;
        }) : (c.value = !1, Promise.reject());
    }
    function M() {
      c.value || (c.value = !0, msPost("alc-public-pay/PaymentAction/completePay", {
        cPaymentFlowNo: t.code
      }).then((oe) => {
        oe.code === 1 ? (p.value = !1, r("success")) : (r("fail"), operatorErrorTip(oe.msg));
      }).catch(() => {
        r("fail"), apiLinkErrorTip("支付");
      }).finally(() => {
        r("flowEnd"), close == null || close(), c.value = !1;
      }));
    }
    function $() {
      c.value || (c.value = !0, msPost("alc-public-pay/PaymentAction/cancelPay", {
        cPaymentFlowNo: t.code
      }).then((oe) => {
        oe.code === 1 ? (p.value = !1, r("cancel")) : (r("fail"), operatorErrorTip(oe.msg));
      }).catch(() => {
        r("fail"), apiLinkErrorTip("支付");
      }).finally(() => {
        r("flowEnd"), close == null || close(), c.value = !1;
      }));
    }
    function H(oe, ne) {
      p.value || (m.value = m.value.slice(0, oe).concat(ne), ne.storeyNum === 3 && (m.value[1] = m.value[0].methods[0]), O.value.clearValidate());
    }
    function X() {
      V();
    }
    const te = { props: t, emits: r, payViewConf: a, pages: l, currentPage: s, isLoading: c, qrCodeValue: d, alreadyStart: p, coreState: f, cVendorName: g, totalSum: b, form: k, orderList: x, payMethodList: N, formRef: O, cMethod: m, schema: ee, rules: z, orderShowFields: P, get toOuterPayView() {
      return V;
    }, set toOuterPayView(oe) {
      V = oe;
    }, usePayInfo: U, usePaySchema: E, startPay: C, simulationPay: I, confirmPay: v, finishPay: M, cancelPay: $, setUseMethod: H, reToPay: X, get AlcForm() {
      return AlcForm;
    }, get AlcQrcode() {
      return AlcQrcode;
    }, get ElAlert() {
      return ElAlert;
    }, get ElButton() {
      return ElButton;
    }, get ElLink() {
      return ElLink;
    }, get ElPageHeader() {
      return ElPageHeader;
    }, get ElRadio() {
      return ElRadio;
    }, get ElRadioGroup() {
      return ElRadioGroup;
    }, get ElTabPane() {
      return ElTabPane;
    }, get ElTabs() {
      return ElTabs;
    }, get payIcons() {
      return payIcons;
    } };
    return Object.defineProperty(te, "__isScriptSetup", { enumerable: !1, value: !0 }), te;
  }
}), _hoisted_1$n = {
  key: "detail",
  class: "pay-preprocess--container"
}, _hoisted_2$k = { class: "pay__card pay-service" }, _hoisted_3$h = /* @__PURE__ */ createElementVNode("label", null, "收款方（供应商/服务商）：", -1), _hoisted_4$d = { class: "pay-service--name" }, _hoisted_5$b = { class: "pay-order--details" }, _hoisted_6$9 = { class: "pay-order--summary" }, _hoisted_7$9 = /* @__PURE__ */ createElementVNode("span", { class: "pay-order__collapse" }, null, -1), _hoisted_8$8 = ["title"], _hoisted_9$8 = { class: "pay-order--footer" }, _hoisted_10$7 = { class: "pay-order-list--detail" }, _hoisted_11$6 = { class: "detail-item" }, _hoisted_12$5 = /* @__PURE__ */ createElementVNode("span", null, "总金额：", -1), _hoisted_13$4 = { class: "pay__card" }, _hoisted_14$2 = /* @__PURE__ */ createElementVNode("div", { class: "pay-form--title" }, "请选择收款银行", -1), _hoisted_15$2 = ["src", "alt"], _hoisted_16$2 = {
  key: 0,
  class: "pay__card"
}, _hoisted_17$2 = {
  key: 0,
  class: "pay-method"
}, _hoisted_18$2 = ["src"], _hoisted_19$2 = {
  key: 1,
  class: "pay-method"
}, _hoisted_20$1 = ["src"], _hoisted_21 = { class: "pay__card pay-form" }, _hoisted_22 = /* @__PURE__ */ createElementVNode("div", { class: "pay-form--title" }, "支付信息", -1), _hoisted_23 = { class: "pay__card pay-sum_number" }, _hoisted_24 = { class: "pay__card pay-start_pay" }, _hoisted_25 = {
  key: "doPay",
  class: "pay-flow--container"
}, _hoisted_26 = { class: "pay-flow--wrap" }, _hoisted_27 = /* @__PURE__ */ createElementVNode("p", { class: "qr-highlight_tips" }, [
  /* @__PURE__ */ createTextVNode(" 订单已提交成功，请尽快完成支付 "),
  /* @__PURE__ */ createElementVNode("span", { class: "flow-secondary_tips" }, " 请使用工银手机银行、微信或支付宝扫码付款 ")
], -1), _hoisted_28 = { class: "highlight-content" }, _hoisted_29 = { class: "ar-total_tips" }, _hoisted_30 = /* @__PURE__ */ createElementVNode("sub", null, "¥", -1), _hoisted_31 = {
  key: 1,
  class: "link-highlight_tips"
}, _hoisted_32 = /* @__PURE__ */ createElementVNode("br", null, null, -1), _hoisted_33 = { class: "pay-start_pay" };
function _sfc_render$q(e, o, n, t, r, a) {
  const l = resolveDirective("loading");
  return withDirectives((openBlock(), createBlock(TransitionGroup, {
    ref: "payViewRef",
    name: "el-fade-in",
    mode: "out-in",
    tag: "div",
    class: "pay-view--container"
  }, {
    default: withCtx(() => {
      var s, c, d, p, f, g;
      return [
        withDirectives(createElementVNode("div", _hoisted_1$n, [
          createElementVNode("section", _hoisted_2$k, [
            _hoisted_3$h,
            createElementVNode("span", _hoisted_4$d, toDisplayString$1(t.cVendorName), 1)
          ]),
          (openBlock(!0), createElementBlock(Fragment, null, renderList(t.orderList, (b) => (openBlock(), createElementBlock("section", {
            key: b.orderUuid,
            class: "pay__card pay-order"
          }, [
            createElementVNode("details", _hoisted_5$b, [
              createElementVNode("summary", _hoisted_6$9, [
                createElementVNode("span", null, "订单编号：" + toDisplayString$1(b.orderCode), 1),
                _hoisted_7$9
              ])
            ]),
            (openBlock(!0), createElementBlock(Fragment, null, renderList(b.itemDtos, (k) => (openBlock(), createElementBlock("ul", {
              key: k.goodsCode,
              class: "pay-order-list--detail"
            }, [
              (openBlock(), createElementBlock(Fragment, null, renderList(t.orderShowFields, (x) => createElementVNode("li", {
                key: x.prop,
                title: k[x.prop],
                class: "detail-item single-line-overflow"
              }, [
                createElementVNode("span", null, toDisplayString$1(x.label) + "：", 1),
                createElementVNode("span", null, toDisplayString$1(k[x.prop]), 1)
              ], 8, _hoisted_8$8)), 64))
            ]))), 128)),
            createElementVNode("footer", _hoisted_9$8, [
              createElementVNode("ul", _hoisted_10$7, [
                createElementVNode("li", _hoisted_11$6, [
                  _hoisted_12$5,
                  createElementVNode("span", null, "¥" + toDisplayString$1(b.orderAmount), 1)
                ])
              ])
            ])
          ]))), 128)),
          createElementVNode("section", _hoisted_13$4, [
            _hoisted_14$2,
            createVNode(t.ElRadioGroup, {
              "model-value": (s = t.cMethod[0]) == null ? void 0 : s.methodName,
              class: "pay-bank--group"
            }, {
              default: withCtx(() => [
                (openBlock(!0), createElementBlock(Fragment, null, renderList(t.payMethodList, (b, k) => (openBlock(), createBlock(t.ElRadio, {
                  key: b.methodName,
                  value: b.methodName,
                  class: "pay-bank--item",
                  onClick: (x) => t.setUseMethod(0, b)
                }, {
                  default: withCtx(() => [
                    createElementVNode("img", {
                      src: t.payIcons[b.iocnName],
                      alt: `${b.methodName} logo`,
                      style: normalizeStyle({
                        visibility: t.payViewConf.fuzzy ? "hidden" : "visible"
                      })
                    }, null, 12, _hoisted_15$2),
                    createElementVNode("span", null, toDisplayString$1(t.payViewConf.fuzzy ? `收款银行${k + 1}` : b.methodName), 1)
                  ]),
                  _: 2
                }, 1032, ["value", "onClick"]))), 128))
              ]),
              _: 1
            }, 8, ["model-value"])
          ]),
          t.cMethod[0] && ((c = t.cMethod[0]) == null ? void 0 : c.storeyNum) !== 1 ? (openBlock(), createElementBlock("section", _hoisted_16$2, [
            t.cMethod[0].storeyNum === 2 ? (openBlock(), createElementBlock("div", _hoisted_17$2, [
              createVNode(t.ElRadioGroup, {
                "model-value": (d = t.cMethod[1]) == null ? void 0 : d.methodName,
                class: "pay-method__type"
              }, {
                default: withCtx(() => [
                  (openBlock(!0), createElementBlock(Fragment, null, renderList(t.cMethod[0].methods, (b) => (openBlock(), createBlock(t.ElRadio, {
                    key: b.methodName,
                    value: b.methodName,
                    class: "pay-method__type--item",
                    onClick: (k) => t.setUseMethod(1, b)
                  }, {
                    default: withCtx(() => [
                      createElementVNode("img", {
                        src: t.payIcons[b.iocnName],
                        alt: "支付 logo"
                      }, null, 8, _hoisted_18$2),
                      createTextVNode(" " + toDisplayString$1(b.methodName), 1)
                    ]),
                    _: 2
                  }, 1032, ["value", "onClick"]))), 128))
                ]),
                _: 1
              }, 8, ["model-value"])
            ])) : t.cMethod[0].storeyNum === 3 ? (openBlock(), createElementBlock("div", _hoisted_19$2, [
              createVNode(t.ElTabs, {
                "model-value": t.cMethod[1].cMethod
              }, {
                default: withCtx(() => [
                  (openBlock(!0), createElementBlock(Fragment, null, renderList(t.cMethod[0].methods, (b) => (openBlock(), createBlock(t.ElTabPane, {
                    key: b.methodName,
                    label: b.methodName,
                    name: b.cMethod,
                    onTabChange: (k) => t.setUseMethod(1, b)
                  }, {
                    default: withCtx(() => {
                      var k;
                      return [
                        createVNode(t.ElRadioGroup, {
                          "model-value": (k = t.cMethod[2]) == null ? void 0 : k.methodName,
                          class: "pay-method__type"
                        }, {
                          default: withCtx(() => [
                            (openBlock(!0), createElementBlock(Fragment, null, renderList(b.methods, (x) => (openBlock(), createBlock(t.ElRadio, {
                              key: x.methodName,
                              value: x.methodName,
                              class: "pay-method__type--item",
                              onClick: (N) => t.setUseMethod(2, x)
                            }, {
                              default: withCtx(() => [
                                createElementVNode("img", {
                                  src: t.payIcons[x.iocnName],
                                  alt: "pay logo"
                                }, null, 8, _hoisted_20$1),
                                createTextVNode(" " + toDisplayString$1(x.methodName), 1)
                              ]),
                              _: 2
                            }, 1032, ["value", "onClick"]))), 128))
                          ]),
                          _: 2
                        }, 1032, ["model-value"])
                      ];
                    }),
                    _: 2
                  }, 1032, ["label", "name", "onTabChange"]))), 128))
                ]),
                _: 1
              }, 8, ["model-value"])
            ])) : createCommentVNode("", !0)
          ])) : createCommentVNode("", !0),
          createElementVNode("section", _hoisted_21, [
            _hoisted_22,
            (p = t.cMethod[2]) != null && p.msg ? (openBlock(), createBlock(t.ElAlert, {
              key: 0,
              closable: !1,
              type: "warning",
              class: "pay-alert"
            }, {
              default: withCtx(() => {
                var b;
                return [
                  createTextVNode(toDisplayString$1((b = t.cMethod[2]) == null ? void 0 : b.msg), 1)
                ];
              }),
              _: 1
            })) : createCommentVNode("", !0),
            createVNode(t.AlcForm, {
              ref: "formRef",
              modelValue: t.form,
              "onUpdate:modelValue": o[0] || (o[0] = (b) => t.form = b),
              schema: t.schema,
              rules: t.rules,
              column: 1,
              disabled: t.alreadyStart,
              "same-label": ""
            }, null, 8, ["modelValue", "schema", "rules", "disabled"])
          ]),
          createElementVNode("section", _hoisted_23, " 总金额：¥ " + toDisplayString$1(t.totalSum), 1),
          createElementVNode("section", _hoisted_24, [
            createVNode(t.ElButton, {
              disabled: t.isLoading,
              onClick: t.cancelPay
            }, {
              default: withCtx(() => [
                createTextVNode(" 取消支付 ")
              ]),
              _: 1
            }, 8, ["disabled"]),
            createVNode(t.ElButton, {
              disabled: t.isLoading || t.alreadyStart,
              type: "primary",
              onClick: t.startPay
            }, {
              default: withCtx(() => [
                createTextVNode(" 发起支付 ")
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ], 512), [
          [vShow, t.currentPage === "detail"]
        ]),
        t.pages.has("doPay") ? withDirectives((openBlock(), createElementBlock("div", _hoisted_25, [
          createVNode(t.ElPageHeader, {
            title: "返回详情",
            onBack: o[1] || (o[1] = (b) => t.currentPage = "detail")
          }),
          createElementVNode("div", _hoisted_26, [
            createElementVNode("div", {
              class: normalizeClass(["pay-flow--content", [((f = t.cMethod.at(-1)) == null ? void 0 : f.showType) === "3" ? "qr" : "link"]])
            }, [
              ((g = t.cMethod.at(-1)) == null ? void 0 : g.showType) === "3" ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                _hoisted_27,
                createElementVNode("div", _hoisted_28, [
                  createVNode(t.AlcQrcode, {
                    value: t.qrCodeValue,
                    size: 180,
                    level: 3,
                    margin: 0
                  }, null, 8, ["value"])
                ]),
                createElementVNode("p", _hoisted_29, [
                  _hoisted_30,
                  createTextVNode(toDisplayString$1(t.totalSum), 1)
                ])
              ], 64)) : (openBlock(), createElementBlock("p", _hoisted_31, [
                createTextVNode(" 若没有自动跳转请 "),
                createVNode(t.ElLink, {
                  type: "primary",
                  onClick: withModifiers(t.reToPay, ["prevent"])
                }, {
                  default: withCtx(() => [
                    createTextVNode(" 点击本链接在新页面完成支付 ")
                  ]),
                  _: 1
                }),
                _hoisted_32,
                createTextVNode(" 支付完成前不要关闭本窗口，完成支付后根据您的情况操作以下按钮 ")
              ])),
              createElementVNode("div", _hoisted_33, [
                createVNode(t.ElButton, {
                  disabled: t.isLoading,
                  type: "info",
                  onClick: t.cancelPay
                }, {
                  default: withCtx(() => [
                    createTextVNode(" 取消付款 ")
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                createVNode(t.ElButton, {
                  disabled: t.isLoading,
                  type: "primary",
                  onClick: t.finishPay
                }, {
                  default: withCtx(() => [
                    createTextVNode(" 付款完成 ")
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ], 2)
          ])
        ], 512)), [
          [vShow, t.currentPage === "doPay"]
        ]) : createCommentVNode("", !0)
      ];
    }),
    _: 1
  })), [
    [l, t.isLoading]
  ]);
}
const AlcPayView = /* @__PURE__ */ _export_sfc(_sfc_main$q, [["render", _sfc_render$q], ["__file", "pay-view.vue"]]);
/*!
 * Cropper.js v1.6.1
 * https://fengyuanchen.github.io/cropperjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2023-09-17T03:44:19.860Z
 */
function Hi(e, o) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(e);
    o && (t = t.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, t);
  }
  return n;
}
function pt(e) {
  for (var o = 1; o < arguments.length; o++) {
    var n = arguments[o] != null ? arguments[o] : {};
    o % 2 ? Hi(Object(n), !0).forEach(function(t) {
      St(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Hi(Object(n)).forEach(function(t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }
  return e;
}
function bi(e) {
  "@babel/helpers - typeof";
  return bi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o) {
    return typeof o;
  } : function(o) {
    return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, bi(e);
}
function Ot(e, o) {
  if (!(e instanceof o))
    throw new TypeError("Cannot call a class as a function");
}
function qi(e, o) {
  for (var n = 0; n < o.length; n++) {
    var t = o[n];
    t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, st(t.key), t);
  }
}
function Nt(e, o, n) {
  return o && qi(e.prototype, o), n && qi(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function St(e, o, n) {
  return o = st(o), o in e ? Object.defineProperty(e, o, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[o] = n, e;
}
function rt(e) {
  return Rt(e) || _t(e) || It(e) || Lt();
}
function Rt(e) {
  if (Array.isArray(e))
    return wi(e);
}
function _t(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function It(e, o) {
  if (e) {
    if (typeof e == "string")
      return wi(e, o);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return wi(e, o);
  }
}
function wi(e, o) {
  (o == null || o > e.length) && (o = e.length);
  for (var n = 0, t = new Array(o); n < o; n++)
    t[n] = e[n];
  return t;
}
function Lt() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Bt(e, o) {
  if (typeof e != "object" || e === null)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var t = n.call(e, o || "default");
    if (typeof t != "object")
      return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (o === "string" ? String : Number)(e);
}
function st(e) {
  var o = Bt(e, "string");
  return typeof o == "symbol" ? o : String(o);
}
var hi = typeof window < "u" && typeof window.document < "u", B = hi ? window : {}, Ai = hi && B.document.documentElement ? "ontouchstart" in B.document.documentElement : !1, Ti = hi ? "PointerEvent" in B : !1, w = "cropper", Oi = "all", ct = "crop", lt = "move", dt = "zoom", G = "e", F = "w", Z = "s", q = "n", ai = "ne", ei = "nw", ni = "se", oi = "sw", yi = "".concat(w, "-crop"), Yi = "".concat(w, "-disabled"), T = "".concat(w, "-hidden"), Wi = "".concat(w, "-hide"), Pt = "".concat(w, "-invisible"), mi = "".concat(w, "-modal"), ki = "".concat(w, "-move"), ri = "".concat(w, "Action"), li = "".concat(w, "Preview"), Ni = "crop", mt = "move", ht = "none", Di = "crop", Ei = "cropend", Mi = "cropmove", zi = "cropstart", Ui = "dblclick", Xt = Ai ? "touchstart" : "mousedown", Ht = Ai ? "touchmove" : "mousemove", qt = Ai ? "touchend touchcancel" : "mouseup", Vi = Ti ? "pointerdown" : Xt, $i = Ti ? "pointermove" : Ht, Gi = Ti ? "pointerup pointercancel" : qt, Fi = "ready", Qi = "resize", Zi = "wheel", ji = "zoom", Ki = "image/jpeg", Yt = /^e|w|s|n|se|sw|ne|nw|all|crop|move|zoom$/, Wt = /^data:/, Ut = /^data:image\/jpeg;base64,/, Vt = /^img|canvas$/i, vt = 200, ft = 100, Ji = {
  // Define the view mode of the cropper
  viewMode: 0,
  // 0, 1, 2, 3
  // Define the dragging mode of the cropper
  dragMode: Ni,
  // 'crop', 'move' or 'none'
  // Define the initial aspect ratio of the crop box
  initialAspectRatio: NaN,
  // Define the aspect ratio of the crop box
  aspectRatio: NaN,
  // An object with the previous cropping result data
  data: null,
  // A selector for adding extra containers to preview
  preview: "",
  // Re-render the cropper when resize the window
  responsive: !0,
  // Restore the cropped area after resize the window
  restore: !0,
  // Check if the current image is a cross-origin image
  checkCrossOrigin: !0,
  // Check the current image's Exif Orientation information
  checkOrientation: !0,
  // Show the black modal
  modal: !0,
  // Show the dashed lines for guiding
  guides: !0,
  // Show the center indicator for guiding
  center: !0,
  // Show the white modal to highlight the crop box
  highlight: !0,
  // Show the grid background
  background: !0,
  // Enable to crop the image automatically when initialize
  autoCrop: !0,
  // Define the percentage of automatic cropping area when initializes
  autoCropArea: 0.8,
  // Enable to move the image
  movable: !0,
  // Enable to rotate the image
  rotatable: !0,
  // Enable to scale the image
  scalable: !0,
  // Enable to zoom the image
  zoomable: !0,
  // Enable to zoom the image by dragging touch
  zoomOnTouch: !0,
  // Enable to zoom the image by wheeling mouse
  zoomOnWheel: !0,
  // Define zoom ratio when zoom the image by wheeling mouse
  wheelZoomRatio: 0.1,
  // Enable to move the crop box
  cropBoxMovable: !0,
  // Enable to resize the crop box
  cropBoxResizable: !0,
  // Toggle drag mode between "crop" and "move" when click twice on the cropper
  toggleDragModeOnDblclick: !0,
  // Size limitation
  minCanvasWidth: 0,
  minCanvasHeight: 0,
  minCropBoxWidth: 0,
  minCropBoxHeight: 0,
  minContainerWidth: vt,
  minContainerHeight: ft,
  // Shortcuts of events
  ready: null,
  cropstart: null,
  cropmove: null,
  cropend: null,
  crop: null,
  zoom: null
}, $t = '<div class="cropper-container" touch-action="none"><div class="cropper-wrap-box"><div class="cropper-canvas"></div></div><div class="cropper-drag-box"></div><div class="cropper-crop-box"><span class="cropper-view-box"></span><span class="cropper-dashed dashed-h"></span><span class="cropper-dashed dashed-v"></span><span class="cropper-center"></span><span class="cropper-face"></span><span class="cropper-line line-e" data-cropper-action="e"></span><span class="cropper-line line-n" data-cropper-action="n"></span><span class="cropper-line line-w" data-cropper-action="w"></span><span class="cropper-line line-s" data-cropper-action="s"></span><span class="cropper-point point-e" data-cropper-action="e"></span><span class="cropper-point point-n" data-cropper-action="n"></span><span class="cropper-point point-w" data-cropper-action="w"></span><span class="cropper-point point-s" data-cropper-action="s"></span><span class="cropper-point point-ne" data-cropper-action="ne"></span><span class="cropper-point point-nw" data-cropper-action="nw"></span><span class="cropper-point point-sw" data-cropper-action="sw"></span><span class="cropper-point point-se" data-cropper-action="se"></span></div></div>', Gt = Number.isNaN || B.isNaN;
function u(e) {
  return typeof e == "number" && !Gt(e);
}
var it = function(e) {
  return e > 0 && e < 1 / 0;
};
function gi(e) {
  return typeof e > "u";
}
function Q(e) {
  return bi(e) === "object" && e !== null;
}
var Ft = Object.prototype.hasOwnProperty;
function K(e) {
  if (!Q(e))
    return !1;
  try {
    var o = e.constructor, n = o.prototype;
    return o && n && Ft.call(n, "isPrototypeOf");
  } catch {
    return !1;
  }
}
function A(e) {
  return typeof e == "function";
}
var Qt = Array.prototype.slice;
function ut(e) {
  return Array.from ? Array.from(e) : Qt.call(e);
}
function D(e, o) {
  return e && A(o) && (Array.isArray(e) || u(e.length) ? ut(e).forEach(function(n, t) {
    o.call(e, n, t, e);
  }) : Q(e) && Object.keys(e).forEach(function(n) {
    o.call(e, e[n], n, e);
  })), e;
}
var y = Object.assign || function(e) {
  for (var o = arguments.length, n = new Array(o > 1 ? o - 1 : 0), t = 1; t < o; t++)
    n[t - 1] = arguments[t];
  return Q(e) && n.length > 0 && n.forEach(function(r) {
    Q(r) && Object.keys(r).forEach(function(a) {
      e[a] = r[a];
    });
  }), e;
}, Zt = /\.\d*(?:0|9){12}\d*$/;
function ii(e) {
  var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1e11;
  return Zt.test(e) ? Math.round(e * o) / o : e;
}
var Kt = /^width|height|left|top|marginLeft|marginTop$/;
function Y(e, o) {
  var n = e.style;
  D(o, function(t, r) {
    Kt.test(r) && u(t) && (t = "".concat(t, "px")), n[r] = t;
  });
}
function Jt(e, o) {
  return e.classList ? e.classList.contains(o) : e.className.indexOf(o) > -1;
}
function j(e, o) {
  if (o) {
    if (u(e.length)) {
      D(e, function(t) {
        j(t, o);
      });
      return;
    }
    if (e.classList) {
      e.classList.add(o);
      return;
    }
    var n = e.className.trim();
    n ? n.indexOf(o) < 0 && (e.className = "".concat(n, " ").concat(o)) : e.className = o;
  }
}
function L(e, o) {
  if (o) {
    if (u(e.length)) {
      D(e, function(n) {
        L(n, o);
      });
      return;
    }
    if (e.classList) {
      e.classList.remove(o);
      return;
    }
    e.className.indexOf(o) >= 0 && (e.className = e.className.replace(o, ""));
  }
}
function J(e, o, n) {
  if (o) {
    if (u(e.length)) {
      D(e, function(t) {
        J(t, o, n);
      });
      return;
    }
    n ? j(e, o) : L(e, o);
  }
}
var ia = /([a-z\d])([A-Z])/g;
function Si(e) {
  return e.replace(ia, "$1-$2").toLowerCase();
}
function Ci(e, o) {
  return Q(e[o]) ? e[o] : e.dataset ? e.dataset[o] : e.getAttribute("data-".concat(Si(o)));
}
function si(e, o, n) {
  Q(n) ? e[o] = n : e.dataset ? e.dataset[o] = n : e.setAttribute("data-".concat(Si(o)), n);
}
function ta(e, o) {
  if (Q(e[o]))
    try {
      delete e[o];
    } catch {
      e[o] = void 0;
    }
  else if (e.dataset)
    try {
      delete e.dataset[o];
    } catch {
      e.dataset[o] = void 0;
    }
  else
    e.removeAttribute("data-".concat(Si(o)));
}
var gt = /\s\s*/, xt = function() {
  var e = !1;
  if (hi) {
    var o = !1, n = function() {
    }, t = Object.defineProperty({}, "once", {
      get: function() {
        return e = !0, o;
      },
      /**
       * This setter can fix a `TypeError` in strict mode
       * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only}
       * @param {boolean} value - The value to set
       */
      set: function(r) {
        o = r;
      }
    });
    B.addEventListener("test", n, t), B.removeEventListener("test", n, t);
  }
  return e;
}();
function _(e, o, n) {
  var t = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, r = n;
  o.trim().split(gt).forEach(function(a) {
    if (!xt) {
      var l = e.listeners;
      l && l[a] && l[a][n] && (r = l[a][n], delete l[a][n], Object.keys(l[a]).length === 0 && delete l[a], Object.keys(l).length === 0 && delete e.listeners);
    }
    e.removeEventListener(a, r, t);
  });
}
function R(e, o, n) {
  var t = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, r = n;
  o.trim().split(gt).forEach(function(a) {
    if (t.once && !xt) {
      var l = e.listeners, s = l === void 0 ? {} : l;
      r = function() {
        delete s[a][n], e.removeEventListener(a, r, t);
        for (var c = arguments.length, d = new Array(c), p = 0; p < c; p++)
          d[p] = arguments[p];
        n.apply(e, d);
      }, s[a] || (s[a] = {}), s[a][n] && e.removeEventListener(a, s[a][n], t), s[a][n] = r, e.listeners = s;
    }
    e.addEventListener(a, r, t);
  });
}
function ti(e, o, n) {
  var t;
  return A(Event) && A(CustomEvent) ? t = new CustomEvent(o, {
    detail: n,
    bubbles: !0,
    cancelable: !0
  }) : (t = document.createEvent("CustomEvent"), t.initCustomEvent(o, !0, !0, n)), e.dispatchEvent(t);
}
function bt(e) {
  var o = e.getBoundingClientRect();
  return {
    left: o.left + (window.pageXOffset - document.documentElement.clientLeft),
    top: o.top + (window.pageYOffset - document.documentElement.clientTop)
  };
}
var xi = B.location, aa = /^(\w+:)\/\/([^:/?#]*):?(\d*)/i;
function tt(e) {
  var o = e.match(aa);
  return o !== null && (o[1] !== xi.protocol || o[2] !== xi.hostname || o[3] !== xi.port);
}
function at(e) {
  var o = "timestamp=".concat((/* @__PURE__ */ new Date()).getTime());
  return e + (e.indexOf("?") === -1 ? "?" : "&") + o;
}
function pi(e) {
  var o = e.rotate, n = e.scaleX, t = e.scaleY, r = e.translateX, a = e.translateY, l = [];
  u(r) && r !== 0 && l.push("translateX(".concat(r, "px)")), u(a) && a !== 0 && l.push("translateY(".concat(a, "px)")), u(o) && o !== 0 && l.push("rotate(".concat(o, "deg)")), u(n) && n !== 1 && l.push("scaleX(".concat(n, ")")), u(t) && t !== 1 && l.push("scaleY(".concat(t, ")"));
  var s = l.length ? l.join(" ") : "none";
  return {
    WebkitTransform: s,
    msTransform: s,
    transform: s
  };
}
function ea(e) {
  var o = pt({}, e), n = 0;
  return D(e, function(t, r) {
    delete o[r], D(o, function(a) {
      var l = Math.abs(t.startX - a.startX), s = Math.abs(t.startY - a.startY), c = Math.abs(t.endX - a.endX), d = Math.abs(t.endY - a.endY), p = Math.sqrt(l * l + s * s), f = Math.sqrt(c * c + d * d), g = (f - p) / p;
      Math.abs(g) > Math.abs(n) && (n = g);
    });
  }), n;
}
function di(e, o) {
  var n = e.pageX, t = e.pageY, r = {
    endX: n,
    endY: t
  };
  return o ? r : pt({
    startX: n,
    startY: t
  }, r);
}
function na(e) {
  var o = 0, n = 0, t = 0;
  return D(e, function(r) {
    var a = r.startX, l = r.startY;
    o += a, n += l, t += 1;
  }), o /= t, n /= t, {
    pageX: o,
    pageY: n
  };
}
function W(e) {
  var o = e.aspectRatio, n = e.height, t = e.width, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "contain", a = it(t), l = it(n);
  if (a && l) {
    var s = n * o;
    r === "contain" && s > t || r === "cover" && s < t ? n = t / o : t = n * o;
  } else
    a ? n = t / o : l && (t = n * o);
  return {
    width: t,
    height: n
  };
}
function oa(e) {
  var o = e.width, n = e.height, t = e.degree;
  if (t = Math.abs(t) % 180, t === 90)
    return {
      width: n,
      height: o
    };
  var r = t % 90 * Math.PI / 180, a = Math.sin(r), l = Math.cos(r), s = o * l + n * a, c = o * a + n * l;
  return t > 90 ? {
    width: c,
    height: s
  } : {
    width: s,
    height: c
  };
}
function pa(e, o, n, t) {
  var r = o.aspectRatio, a = o.naturalWidth, l = o.naturalHeight, s = o.rotate, c = s === void 0 ? 0 : s, d = o.scaleX, p = d === void 0 ? 1 : d, f = o.scaleY, g = f === void 0 ? 1 : f, b = n.aspectRatio, k = n.naturalWidth, x = n.naturalHeight, N = t.fillColor, O = N === void 0 ? "transparent" : N, m = t.imageSmoothingEnabled, ee = m === void 0 ? !0 : m, z = t.imageSmoothingQuality, P = z === void 0 ? "low" : z, V = t.maxWidth, U = V === void 0 ? 1 / 0 : V, E = t.maxHeight, C = E === void 0 ? 1 / 0 : E, I = t.minWidth, v = I === void 0 ? 0 : I, M = t.minHeight, $ = M === void 0 ? 0 : M, H = document.createElement("canvas"), X = H.getContext("2d"), te = W({
    aspectRatio: b,
    width: U,
    height: C
  }), oe = W({
    aspectRatio: b,
    width: v,
    height: $
  }, "cover"), ne = Math.min(te.width, Math.max(oe.width, k)), ie = Math.min(te.height, Math.max(oe.height, x)), se = W({
    aspectRatio: r,
    width: U,
    height: C
  }), pe = W({
    aspectRatio: r,
    width: v,
    height: $
  }, "cover"), he = Math.min(se.width, Math.max(pe.width, a)), ae = Math.min(se.height, Math.max(pe.height, l)), le = [-he / 2, -ae / 2, he, ae];
  return H.width = ii(ne), H.height = ii(ie), X.fillStyle = O, X.fillRect(0, 0, ne, ie), X.save(), X.translate(ne / 2, ie / 2), X.rotate(c * Math.PI / 180), X.scale(p, g), X.imageSmoothingEnabled = ee, X.imageSmoothingQuality = P, X.drawImage.apply(X, [e].concat(rt(le.map(function(fe) {
    return Math.floor(ii(fe));
  })))), X.restore(), H;
}
var wt = String.fromCharCode;
function ra(e, o, n) {
  var t = "";
  n += o;
  for (var r = o; r < n; r += 1)
    t += wt(e.getUint8(r));
  return t;
}
var sa = /^data:.*,/;
function ca(e) {
  var o = e.replace(sa, ""), n = atob(o), t = new ArrayBuffer(n.length), r = new Uint8Array(t);
  return D(r, function(a, l) {
    r[l] = n.charCodeAt(l);
  }), t;
}
function la(e, o) {
  for (var n = [], t = 8192, r = new Uint8Array(e); r.length > 0; )
    n.push(wt.apply(null, ut(r.subarray(0, t)))), r = r.subarray(t);
  return "data:".concat(o, ";base64,").concat(btoa(n.join("")));
}
function da(e) {
  var o = new DataView(e), n;
  try {
    var t, r, a;
    if (o.getUint8(0) === 255 && o.getUint8(1) === 216)
      for (var l = o.byteLength, s = 2; s + 1 < l; ) {
        if (o.getUint8(s) === 255 && o.getUint8(s + 1) === 225) {
          r = s;
          break;
        }
        s += 1;
      }
    if (r) {
      var c = r + 4, d = r + 10;
      if (ra(o, c, 4) === "Exif") {
        var p = o.getUint16(d);
        if (t = p === 18761, (t || p === 19789) && o.getUint16(d + 2, t) === 42) {
          var f = o.getUint32(d + 4, t);
          f >= 8 && (a = d + f);
        }
      }
    }
    if (a) {
      var g = o.getUint16(a, t), b, k;
      for (k = 0; k < g; k += 1)
        if (b = a + k * 12 + 2, o.getUint16(b, t) === 274) {
          b += 8, n = o.getUint16(b, t), o.setUint16(b, 1, t);
          break;
        }
    }
  } catch {
    n = 1;
  }
  return n;
}
function ma(e) {
  var o = 0, n = 1, t = 1;
  switch (e) {
    case 2:
      n = -1;
      break;
    case 3:
      o = -180;
      break;
    case 4:
      t = -1;
      break;
    case 5:
      o = 90, t = -1;
      break;
    case 6:
      o = 90;
      break;
    case 7:
      o = 90, n = -1;
      break;
    case 8:
      o = -90;
      break;
  }
  return {
    rotate: o,
    scaleX: n,
    scaleY: t
  };
}
var ha = {
  render: function() {
    this.initContainer(), this.initCanvas(), this.initCropBox(), this.renderCanvas(), this.cropped && this.renderCropBox();
  },
  initContainer: function() {
    var e = this.element, o = this.options, n = this.container, t = this.cropper, r = Number(o.minContainerWidth), a = Number(o.minContainerHeight);
    j(t, T), L(e, T);
    var l = {
      width: Math.max(n.offsetWidth, r >= 0 ? r : vt),
      height: Math.max(n.offsetHeight, a >= 0 ? a : ft)
    };
    this.containerData = l, Y(t, {
      width: l.width,
      height: l.height
    }), j(e, T), L(t, T);
  },
  // Canvas (image wrapper)
  initCanvas: function() {
    var e = this.containerData, o = this.imageData, n = this.options.viewMode, t = Math.abs(o.rotate) % 180 === 90, r = t ? o.naturalHeight : o.naturalWidth, a = t ? o.naturalWidth : o.naturalHeight, l = r / a, s = e.width, c = e.height;
    e.height * l > e.width ? n === 3 ? s = e.height * l : c = e.width / l : n === 3 ? c = e.width / l : s = e.height * l;
    var d = {
      aspectRatio: l,
      naturalWidth: r,
      naturalHeight: a,
      width: s,
      height: c
    };
    this.canvasData = d, this.limited = n === 1 || n === 2, this.limitCanvas(!0, !0), d.width = Math.min(Math.max(d.width, d.minWidth), d.maxWidth), d.height = Math.min(Math.max(d.height, d.minHeight), d.maxHeight), d.left = (e.width - d.width) / 2, d.top = (e.height - d.height) / 2, d.oldLeft = d.left, d.oldTop = d.top, this.initialCanvasData = y({}, d);
  },
  limitCanvas: function(e, o) {
    var n = this.options, t = this.containerData, r = this.canvasData, a = this.cropBoxData, l = n.viewMode, s = r.aspectRatio, c = this.cropped && a;
    if (e) {
      var d = Number(n.minCanvasWidth) || 0, p = Number(n.minCanvasHeight) || 0;
      l > 1 ? (d = Math.max(d, t.width), p = Math.max(p, t.height), l === 3 && (p * s > d ? d = p * s : p = d / s)) : l > 0 && (d ? d = Math.max(d, c ? a.width : 0) : p ? p = Math.max(p, c ? a.height : 0) : c && (d = a.width, p = a.height, p * s > d ? d = p * s : p = d / s));
      var f = W({
        aspectRatio: s,
        width: d,
        height: p
      });
      d = f.width, p = f.height, r.minWidth = d, r.minHeight = p, r.maxWidth = 1 / 0, r.maxHeight = 1 / 0;
    }
    if (o)
      if (l > (c ? 0 : 1)) {
        var g = t.width - r.width, b = t.height - r.height;
        r.minLeft = Math.min(0, g), r.minTop = Math.min(0, b), r.maxLeft = Math.max(0, g), r.maxTop = Math.max(0, b), c && this.limited && (r.minLeft = Math.min(a.left, a.left + (a.width - r.width)), r.minTop = Math.min(a.top, a.top + (a.height - r.height)), r.maxLeft = a.left, r.maxTop = a.top, l === 2 && (r.width >= t.width && (r.minLeft = Math.min(0, g), r.maxLeft = Math.max(0, g)), r.height >= t.height && (r.minTop = Math.min(0, b), r.maxTop = Math.max(0, b))));
      } else
        r.minLeft = -r.width, r.minTop = -r.height, r.maxLeft = t.width, r.maxTop = t.height;
  },
  renderCanvas: function(e, o) {
    var n = this.canvasData, t = this.imageData;
    if (o) {
      var r = oa({
        width: t.naturalWidth * Math.abs(t.scaleX || 1),
        height: t.naturalHeight * Math.abs(t.scaleY || 1),
        degree: t.rotate || 0
      }), a = r.width, l = r.height, s = n.width * (a / n.naturalWidth), c = n.height * (l / n.naturalHeight);
      n.left -= (s - n.width) / 2, n.top -= (c - n.height) / 2, n.width = s, n.height = c, n.aspectRatio = a / l, n.naturalWidth = a, n.naturalHeight = l, this.limitCanvas(!0, !1);
    }
    (n.width > n.maxWidth || n.width < n.minWidth) && (n.left = n.oldLeft), (n.height > n.maxHeight || n.height < n.minHeight) && (n.top = n.oldTop), n.width = Math.min(Math.max(n.width, n.minWidth), n.maxWidth), n.height = Math.min(Math.max(n.height, n.minHeight), n.maxHeight), this.limitCanvas(!1, !0), n.left = Math.min(Math.max(n.left, n.minLeft), n.maxLeft), n.top = Math.min(Math.max(n.top, n.minTop), n.maxTop), n.oldLeft = n.left, n.oldTop = n.top, Y(this.canvas, y({
      width: n.width,
      height: n.height
    }, pi({
      translateX: n.left,
      translateY: n.top
    }))), this.renderImage(e), this.cropped && this.limited && this.limitCropBox(!0, !0);
  },
  renderImage: function(e) {
    var o = this.canvasData, n = this.imageData, t = n.naturalWidth * (o.width / o.naturalWidth), r = n.naturalHeight * (o.height / o.naturalHeight);
    y(n, {
      width: t,
      height: r,
      left: (o.width - t) / 2,
      top: (o.height - r) / 2
    }), Y(this.image, y({
      width: n.width,
      height: n.height
    }, pi(y({
      translateX: n.left,
      translateY: n.top
    }, n)))), e && this.output();
  },
  initCropBox: function() {
    var e = this.options, o = this.canvasData, n = e.aspectRatio || e.initialAspectRatio, t = Number(e.autoCropArea) || 0.8, r = {
      width: o.width,
      height: o.height
    };
    n && (o.height * n > o.width ? r.height = r.width / n : r.width = r.height * n), this.cropBoxData = r, this.limitCropBox(!0, !0), r.width = Math.min(Math.max(r.width, r.minWidth), r.maxWidth), r.height = Math.min(Math.max(r.height, r.minHeight), r.maxHeight), r.width = Math.max(r.minWidth, r.width * t), r.height = Math.max(r.minHeight, r.height * t), r.left = o.left + (o.width - r.width) / 2, r.top = o.top + (o.height - r.height) / 2, r.oldLeft = r.left, r.oldTop = r.top, this.initialCropBoxData = y({}, r);
  },
  limitCropBox: function(e, o) {
    var n = this.options, t = this.containerData, r = this.canvasData, a = this.cropBoxData, l = this.limited, s = n.aspectRatio;
    if (e) {
      var c = Number(n.minCropBoxWidth) || 0, d = Number(n.minCropBoxHeight) || 0, p = l ? Math.min(t.width, r.width, r.width + r.left, t.width - r.left) : t.width, f = l ? Math.min(t.height, r.height, r.height + r.top, t.height - r.top) : t.height;
      c = Math.min(c, t.width), d = Math.min(d, t.height), s && (c && d ? d * s > c ? d = c / s : c = d * s : c ? d = c / s : d && (c = d * s), f * s > p ? f = p / s : p = f * s), a.minWidth = Math.min(c, p), a.minHeight = Math.min(d, f), a.maxWidth = p, a.maxHeight = f;
    }
    o && (l ? (a.minLeft = Math.max(0, r.left), a.minTop = Math.max(0, r.top), a.maxLeft = Math.min(t.width, r.left + r.width) - a.width, a.maxTop = Math.min(t.height, r.top + r.height) - a.height) : (a.minLeft = 0, a.minTop = 0, a.maxLeft = t.width - a.width, a.maxTop = t.height - a.height));
  },
  renderCropBox: function() {
    var e = this.options, o = this.containerData, n = this.cropBoxData;
    (n.width > n.maxWidth || n.width < n.minWidth) && (n.left = n.oldLeft), (n.height > n.maxHeight || n.height < n.minHeight) && (n.top = n.oldTop), n.width = Math.min(Math.max(n.width, n.minWidth), n.maxWidth), n.height = Math.min(Math.max(n.height, n.minHeight), n.maxHeight), this.limitCropBox(!1, !0), n.left = Math.min(Math.max(n.left, n.minLeft), n.maxLeft), n.top = Math.min(Math.max(n.top, n.minTop), n.maxTop), n.oldLeft = n.left, n.oldTop = n.top, e.movable && e.cropBoxMovable && si(this.face, ri, n.width >= o.width && n.height >= o.height ? lt : Oi), Y(this.cropBox, y({
      width: n.width,
      height: n.height
    }, pi({
      translateX: n.left,
      translateY: n.top
    }))), this.cropped && this.limited && this.limitCanvas(!0, !0), this.disabled || this.output();
  },
  output: function() {
    this.preview(), ti(this.element, Di, this.getData());
  }
}, va = {
  initPreview: function() {
    var e = this.element, o = this.crossOrigin, n = this.options.preview, t = o ? this.crossOriginUrl : this.url, r = e.alt || "The image to preview", a = document.createElement("img");
    if (o && (a.crossOrigin = o), a.src = t, a.alt = r, this.viewBox.appendChild(a), this.viewBoxImage = a, !!n) {
      var l = n;
      typeof n == "string" ? l = e.ownerDocument.querySelectorAll(n) : n.querySelector && (l = [n]), this.previews = l, D(l, function(s) {
        var c = document.createElement("img");
        si(s, li, {
          width: s.offsetWidth,
          height: s.offsetHeight,
          html: s.innerHTML
        }), o && (c.crossOrigin = o), c.src = t, c.alt = r, c.style.cssText = 'display:block;width:100%;height:auto;min-width:0!important;min-height:0!important;max-width:none!important;max-height:none!important;image-orientation:0deg!important;"', s.innerHTML = "", s.appendChild(c);
      });
    }
  },
  resetPreview: function() {
    D(this.previews, function(e) {
      var o = Ci(e, li);
      Y(e, {
        width: o.width,
        height: o.height
      }), e.innerHTML = o.html, ta(e, li);
    });
  },
  preview: function() {
    var e = this.imageData, o = this.canvasData, n = this.cropBoxData, t = n.width, r = n.height, a = e.width, l = e.height, s = n.left - o.left - e.left, c = n.top - o.top - e.top;
    !this.cropped || this.disabled || (Y(this.viewBoxImage, y({
      width: a,
      height: l
    }, pi(y({
      translateX: -s,
      translateY: -c
    }, e)))), D(this.previews, function(d) {
      var p = Ci(d, li), f = p.width, g = p.height, b = f, k = g, x = 1;
      t && (x = f / t, k = r * x), r && k > g && (x = g / r, b = t * x, k = g), Y(d, {
        width: b,
        height: k
      }), Y(d.getElementsByTagName("img")[0], y({
        width: a * x,
        height: l * x
      }, pi(y({
        translateX: -s * x,
        translateY: -c * x
      }, e))));
    }));
  }
}, fa = {
  bind: function() {
    var e = this.element, o = this.options, n = this.cropper;
    A(o.cropstart) && R(e, zi, o.cropstart), A(o.cropmove) && R(e, Mi, o.cropmove), A(o.cropend) && R(e, Ei, o.cropend), A(o.crop) && R(e, Di, o.crop), A(o.zoom) && R(e, ji, o.zoom), R(n, Vi, this.onCropStart = this.cropStart.bind(this)), o.zoomable && o.zoomOnWheel && R(n, Zi, this.onWheel = this.wheel.bind(this), {
      passive: !1,
      capture: !0
    }), o.toggleDragModeOnDblclick && R(n, Ui, this.onDblclick = this.dblclick.bind(this)), R(e.ownerDocument, $i, this.onCropMove = this.cropMove.bind(this)), R(e.ownerDocument, Gi, this.onCropEnd = this.cropEnd.bind(this)), o.responsive && R(window, Qi, this.onResize = this.resize.bind(this));
  },
  unbind: function() {
    var e = this.element, o = this.options, n = this.cropper;
    A(o.cropstart) && _(e, zi, o.cropstart), A(o.cropmove) && _(e, Mi, o.cropmove), A(o.cropend) && _(e, Ei, o.cropend), A(o.crop) && _(e, Di, o.crop), A(o.zoom) && _(e, ji, o.zoom), _(n, Vi, this.onCropStart), o.zoomable && o.zoomOnWheel && _(n, Zi, this.onWheel, {
      passive: !1,
      capture: !0
    }), o.toggleDragModeOnDblclick && _(n, Ui, this.onDblclick), _(e.ownerDocument, $i, this.onCropMove), _(e.ownerDocument, Gi, this.onCropEnd), o.responsive && _(window, Qi, this.onResize);
  }
}, ua = {
  resize: function() {
    if (!this.disabled) {
      var e = this.options, o = this.container, n = this.containerData, t = o.offsetWidth / n.width, r = o.offsetHeight / n.height, a = Math.abs(t - 1) > Math.abs(r - 1) ? t : r;
      if (a !== 1) {
        var l, s;
        e.restore && (l = this.getCanvasData(), s = this.getCropBoxData()), this.render(), e.restore && (this.setCanvasData(D(l, function(c, d) {
          l[d] = c * a;
        })), this.setCropBoxData(D(s, function(c, d) {
          s[d] = c * a;
        })));
      }
    }
  },
  dblclick: function() {
    this.disabled || this.options.dragMode === ht || this.setDragMode(Jt(this.dragBox, yi) ? mt : Ni);
  },
  wheel: function(e) {
    var o = this, n = Number(this.options.wheelZoomRatio) || 0.1, t = 1;
    this.disabled || (e.preventDefault(), !this.wheeling && (this.wheeling = !0, setTimeout(function() {
      o.wheeling = !1;
    }, 50), e.deltaY ? t = e.deltaY > 0 ? 1 : -1 : e.wheelDelta ? t = -e.wheelDelta / 120 : e.detail && (t = e.detail > 0 ? 1 : -1), this.zoom(-t * n, e)));
  },
  cropStart: function(e) {
    var o = e.buttons, n = e.button;
    if (!(this.disabled || (e.type === "mousedown" || e.type === "pointerdown" && e.pointerType === "mouse") && // No primary button (Usually the left button)
    (u(o) && o !== 1 || u(n) && n !== 0 || e.ctrlKey))) {
      var t = this.options, r = this.pointers, a;
      e.changedTouches ? D(e.changedTouches, function(l) {
        r[l.identifier] = di(l);
      }) : r[e.pointerId || 0] = di(e), Object.keys(r).length > 1 && t.zoomable && t.zoomOnTouch ? a = dt : a = Ci(e.target, ri), Yt.test(a) && ti(this.element, zi, {
        originalEvent: e,
        action: a
      }) !== !1 && (e.preventDefault(), this.action = a, this.cropping = !1, a === ct && (this.cropping = !0, j(this.dragBox, mi)));
    }
  },
  cropMove: function(e) {
    var o = this.action;
    if (!(this.disabled || !o)) {
      var n = this.pointers;
      e.preventDefault(), ti(this.element, Mi, {
        originalEvent: e,
        action: o
      }) !== !1 && (e.changedTouches ? D(e.changedTouches, function(t) {
        y(n[t.identifier] || {}, di(t, !0));
      }) : y(n[e.pointerId || 0] || {}, di(e, !0)), this.change(e));
    }
  },
  cropEnd: function(e) {
    if (!this.disabled) {
      var o = this.action, n = this.pointers;
      e.changedTouches ? D(e.changedTouches, function(t) {
        delete n[t.identifier];
      }) : delete n[e.pointerId || 0], o && (e.preventDefault(), Object.keys(n).length || (this.action = ""), this.cropping && (this.cropping = !1, J(this.dragBox, mi, this.cropped && this.options.modal)), ti(this.element, Ei, {
        originalEvent: e,
        action: o
      }));
    }
  }
}, ga = {
  change: function(e) {
    var o = this.options, n = this.canvasData, t = this.containerData, r = this.cropBoxData, a = this.pointers, l = this.action, s = o.aspectRatio, c = r.left, d = r.top, p = r.width, f = r.height, g = c + p, b = d + f, k = 0, x = 0, N = t.width, O = t.height, m = !0, ee;
    !s && e.shiftKey && (s = p && f ? p / f : 1), this.limited && (k = r.minLeft, x = r.minTop, N = k + Math.min(t.width, n.width, n.left + n.width), O = x + Math.min(t.height, n.height, n.top + n.height));
    var z = a[Object.keys(a)[0]], P = {
      x: z.endX - z.startX,
      y: z.endY - z.startY
    }, V = function(U) {
      switch (U) {
        case G:
          g + P.x > N && (P.x = N - g);
          break;
        case F:
          c + P.x < k && (P.x = k - c);
          break;
        case q:
          d + P.y < x && (P.y = x - d);
          break;
        case Z:
          b + P.y > O && (P.y = O - b);
          break;
      }
    };
    switch (l) {
      case Oi:
        c += P.x, d += P.y;
        break;
      case G:
        if (P.x >= 0 && (g >= N || s && (d <= x || b >= O))) {
          m = !1;
          break;
        }
        V(G), p += P.x, p < 0 && (l = F, p = -p, c -= p), s && (f = p / s, d += (r.height - f) / 2);
        break;
      case q:
        if (P.y <= 0 && (d <= x || s && (c <= k || g >= N))) {
          m = !1;
          break;
        }
        V(q), f -= P.y, d += P.y, f < 0 && (l = Z, f = -f, d -= f), s && (p = f * s, c += (r.width - p) / 2);
        break;
      case F:
        if (P.x <= 0 && (c <= k || s && (d <= x || b >= O))) {
          m = !1;
          break;
        }
        V(F), p -= P.x, c += P.x, p < 0 && (l = G, p = -p, c -= p), s && (f = p / s, d += (r.height - f) / 2);
        break;
      case Z:
        if (P.y >= 0 && (b >= O || s && (c <= k || g >= N))) {
          m = !1;
          break;
        }
        V(Z), f += P.y, f < 0 && (l = q, f = -f, d -= f), s && (p = f * s, c += (r.width - p) / 2);
        break;
      case ai:
        if (s) {
          if (P.y <= 0 && (d <= x || g >= N)) {
            m = !1;
            break;
          }
          V(q), f -= P.y, d += P.y, p = f * s;
        } else
          V(q), V(G), P.x >= 0 ? g < N ? p += P.x : P.y <= 0 && d <= x && (m = !1) : p += P.x, P.y <= 0 ? d > x && (f -= P.y, d += P.y) : (f -= P.y, d += P.y);
        p < 0 && f < 0 ? (l = oi, f = -f, p = -p, d -= f, c -= p) : p < 0 ? (l = ei, p = -p, c -= p) : f < 0 && (l = ni, f = -f, d -= f);
        break;
      case ei:
        if (s) {
          if (P.y <= 0 && (d <= x || c <= k)) {
            m = !1;
            break;
          }
          V(q), f -= P.y, d += P.y, p = f * s, c += r.width - p;
        } else
          V(q), V(F), P.x <= 0 ? c > k ? (p -= P.x, c += P.x) : P.y <= 0 && d <= x && (m = !1) : (p -= P.x, c += P.x), P.y <= 0 ? d > x && (f -= P.y, d += P.y) : (f -= P.y, d += P.y);
        p < 0 && f < 0 ? (l = ni, f = -f, p = -p, d -= f, c -= p) : p < 0 ? (l = ai, p = -p, c -= p) : f < 0 && (l = oi, f = -f, d -= f);
        break;
      case oi:
        if (s) {
          if (P.x <= 0 && (c <= k || b >= O)) {
            m = !1;
            break;
          }
          V(F), p -= P.x, c += P.x, f = p / s;
        } else
          V(Z), V(F), P.x <= 0 ? c > k ? (p -= P.x, c += P.x) : P.y >= 0 && b >= O && (m = !1) : (p -= P.x, c += P.x), P.y >= 0 ? b < O && (f += P.y) : f += P.y;
        p < 0 && f < 0 ? (l = ai, f = -f, p = -p, d -= f, c -= p) : p < 0 ? (l = ni, p = -p, c -= p) : f < 0 && (l = ei, f = -f, d -= f);
        break;
      case ni:
        if (s) {
          if (P.x >= 0 && (g >= N || b >= O)) {
            m = !1;
            break;
          }
          V(G), p += P.x, f = p / s;
        } else
          V(Z), V(G), P.x >= 0 ? g < N ? p += P.x : P.y >= 0 && b >= O && (m = !1) : p += P.x, P.y >= 0 ? b < O && (f += P.y) : f += P.y;
        p < 0 && f < 0 ? (l = ei, f = -f, p = -p, d -= f, c -= p) : p < 0 ? (l = oi, p = -p, c -= p) : f < 0 && (l = ai, f = -f, d -= f);
        break;
      case lt:
        this.move(P.x, P.y), m = !1;
        break;
      case dt:
        this.zoom(ea(a), e), m = !1;
        break;
      case ct:
        if (!P.x || !P.y) {
          m = !1;
          break;
        }
        ee = bt(this.cropper), c = z.startX - ee.left, d = z.startY - ee.top, p = r.minWidth, f = r.minHeight, P.x > 0 ? l = P.y > 0 ? ni : ai : P.x < 0 && (c -= p, l = P.y > 0 ? oi : ei), P.y < 0 && (d -= f), this.cropped || (L(this.cropBox, T), this.cropped = !0, this.limited && this.limitCropBox(!0, !0));
        break;
    }
    m && (r.width = p, r.height = f, r.left = c, r.top = d, this.action = l, this.renderCropBox()), D(a, function(U) {
      U.startX = U.endX, U.startY = U.endY;
    });
  }
}, xa = {
  // Show the crop box manually
  crop: function() {
    return this.ready && !this.cropped && !this.disabled && (this.cropped = !0, this.limitCropBox(!0, !0), this.options.modal && j(this.dragBox, mi), L(this.cropBox, T), this.setCropBoxData(this.initialCropBoxData)), this;
  },
  // Reset the image and crop box to their initial states
  reset: function() {
    return this.ready && !this.disabled && (this.imageData = y({}, this.initialImageData), this.canvasData = y({}, this.initialCanvasData), this.cropBoxData = y({}, this.initialCropBoxData), this.renderCanvas(), this.cropped && this.renderCropBox()), this;
  },
  // Clear the crop box
  clear: function() {
    return this.cropped && !this.disabled && (y(this.cropBoxData, {
      left: 0,
      top: 0,
      width: 0,
      height: 0
    }), this.cropped = !1, this.renderCropBox(), this.limitCanvas(!0, !0), this.renderCanvas(), L(this.dragBox, mi), j(this.cropBox, T)), this;
  },
  /**
   * Replace the image's src and rebuild the cropper
   * @param {string} url - The new URL.
   * @param {boolean} [hasSameSize] - Indicate if the new image has the same size as the old one.
   * @returns {Cropper} this
   */
  replace: function(e) {
    var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    return !this.disabled && e && (this.isImg && (this.element.src = e), o ? (this.url = e, this.image.src = e, this.ready && (this.viewBoxImage.src = e, D(this.previews, function(n) {
      n.getElementsByTagName("img")[0].src = e;
    }))) : (this.isImg && (this.replaced = !0), this.options.data = null, this.uncreate(), this.load(e))), this;
  },
  // Enable (unfreeze) the cropper
  enable: function() {
    return this.ready && this.disabled && (this.disabled = !1, L(this.cropper, Yi)), this;
  },
  // Disable (freeze) the cropper
  disable: function() {
    return this.ready && !this.disabled && (this.disabled = !0, j(this.cropper, Yi)), this;
  },
  /**
   * Destroy the cropper and remove the instance from the image
   * @returns {Cropper} this
   */
  destroy: function() {
    var e = this.element;
    return e[w] ? (e[w] = void 0, this.isImg && this.replaced && (e.src = this.originalUrl), this.uncreate(), this) : this;
  },
  /**
   * Move the canvas with relative offsets
   * @param {number} offsetX - The relative offset distance on the x-axis.
   * @param {number} [offsetY=offsetX] - The relative offset distance on the y-axis.
   * @returns {Cropper} this
   */
  move: function(e) {
    var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, n = this.canvasData, t = n.left, r = n.top;
    return this.moveTo(gi(e) ? e : t + Number(e), gi(o) ? o : r + Number(o));
  },
  /**
   * Move the canvas to an absolute point
   * @param {number} x - The x-axis coordinate.
   * @param {number} [y=x] - The y-axis coordinate.
   * @returns {Cropper} this
   */
  moveTo: function(e) {
    var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, n = this.canvasData, t = !1;
    return e = Number(e), o = Number(o), this.ready && !this.disabled && this.options.movable && (u(e) && (n.left = e, t = !0), u(o) && (n.top = o, t = !0), t && this.renderCanvas(!0)), this;
  },
  /**
   * Zoom the canvas with a relative ratio
   * @param {number} ratio - The target ratio.
   * @param {Event} _originalEvent - The original event if any.
   * @returns {Cropper} this
   */
  zoom: function(e, o) {
    var n = this.canvasData;
    return e = Number(e), e < 0 ? e = 1 / (1 - e) : e = 1 + e, this.zoomTo(n.width * e / n.naturalWidth, null, o);
  },
  /**
   * Zoom the canvas to an absolute ratio
   * @param {number} ratio - The target ratio.
   * @param {Object} pivot - The zoom pivot point coordinate.
   * @param {Event} _originalEvent - The original event if any.
   * @returns {Cropper} this
   */
  zoomTo: function(e, o, n) {
    var t = this.options, r = this.canvasData, a = r.width, l = r.height, s = r.naturalWidth, c = r.naturalHeight;
    if (e = Number(e), e >= 0 && this.ready && !this.disabled && t.zoomable) {
      var d = s * e, p = c * e;
      if (ti(this.element, ji, {
        ratio: e,
        oldRatio: a / s,
        originalEvent: n
      }) === !1)
        return this;
      if (n) {
        var f = this.pointers, g = bt(this.cropper), b = f && Object.keys(f).length ? na(f) : {
          pageX: n.pageX,
          pageY: n.pageY
        };
        r.left -= (d - a) * ((b.pageX - g.left - r.left) / a), r.top -= (p - l) * ((b.pageY - g.top - r.top) / l);
      } else
        K(o) && u(o.x) && u(o.y) ? (r.left -= (d - a) * ((o.x - r.left) / a), r.top -= (p - l) * ((o.y - r.top) / l)) : (r.left -= (d - a) / 2, r.top -= (p - l) / 2);
      r.width = d, r.height = p, this.renderCanvas(!0);
    }
    return this;
  },
  /**
   * Rotate the canvas with a relative degree
   * @param {number} degree - The rotate degree.
   * @returns {Cropper} this
   */
  rotate: function(e) {
    return this.rotateTo((this.imageData.rotate || 0) + Number(e));
  },
  /**
   * Rotate the canvas to an absolute degree
   * @param {number} degree - The rotate degree.
   * @returns {Cropper} this
   */
  rotateTo: function(e) {
    return e = Number(e), u(e) && this.ready && !this.disabled && this.options.rotatable && (this.imageData.rotate = e % 360, this.renderCanvas(!0, !0)), this;
  },
  /**
   * Scale the image on the x-axis.
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @returns {Cropper} this
   */
  scaleX: function(e) {
    var o = this.imageData.scaleY;
    return this.scale(e, u(o) ? o : 1);
  },
  /**
   * Scale the image on the y-axis.
   * @param {number} scaleY - The scale ratio on the y-axis.
   * @returns {Cropper} this
   */
  scaleY: function(e) {
    var o = this.imageData.scaleX;
    return this.scale(u(o) ? o : 1, e);
  },
  /**
   * Scale the image
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @param {number} [scaleY=scaleX] - The scale ratio on the y-axis.
   * @returns {Cropper} this
   */
  scale: function(e) {
    var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, n = this.imageData, t = !1;
    return e = Number(e), o = Number(o), this.ready && !this.disabled && this.options.scalable && (u(e) && (n.scaleX = e, t = !0), u(o) && (n.scaleY = o, t = !0), t && this.renderCanvas(!0, !0)), this;
  },
  /**
   * Get the cropped area position and size data (base on the original image)
   * @param {boolean} [rounded=false] - Indicate if round the data values or not.
   * @returns {Object} The result cropped data.
   */
  getData: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, o = this.options, n = this.imageData, t = this.canvasData, r = this.cropBoxData, a;
    if (this.ready && this.cropped) {
      a = {
        x: r.left - t.left,
        y: r.top - t.top,
        width: r.width,
        height: r.height
      };
      var l = n.width / n.naturalWidth;
      if (D(a, function(d, p) {
        a[p] = d / l;
      }), e) {
        var s = Math.round(a.y + a.height), c = Math.round(a.x + a.width);
        a.x = Math.round(a.x), a.y = Math.round(a.y), a.width = c - a.x, a.height = s - a.y;
      }
    } else
      a = {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      };
    return o.rotatable && (a.rotate = n.rotate || 0), o.scalable && (a.scaleX = n.scaleX || 1, a.scaleY = n.scaleY || 1), a;
  },
  /**
   * Set the cropped area position and size with new data
   * @param {Object} data - The new data.
   * @returns {Cropper} this
   */
  setData: function(e) {
    var o = this.options, n = this.imageData, t = this.canvasData, r = {};
    if (this.ready && !this.disabled && K(e)) {
      var a = !1;
      o.rotatable && u(e.rotate) && e.rotate !== n.rotate && (n.rotate = e.rotate, a = !0), o.scalable && (u(e.scaleX) && e.scaleX !== n.scaleX && (n.scaleX = e.scaleX, a = !0), u(e.scaleY) && e.scaleY !== n.scaleY && (n.scaleY = e.scaleY, a = !0)), a && this.renderCanvas(!0, !0);
      var l = n.width / n.naturalWidth;
      u(e.x) && (r.left = e.x * l + t.left), u(e.y) && (r.top = e.y * l + t.top), u(e.width) && (r.width = e.width * l), u(e.height) && (r.height = e.height * l), this.setCropBoxData(r);
    }
    return this;
  },
  /**
   * Get the container size data.
   * @returns {Object} The result container data.
   */
  getContainerData: function() {
    return this.ready ? y({}, this.containerData) : {};
  },
  /**
   * Get the image position and size data.
   * @returns {Object} The result image data.
   */
  getImageData: function() {
    return this.sized ? y({}, this.imageData) : {};
  },
  /**
   * Get the canvas position and size data.
   * @returns {Object} The result canvas data.
   */
  getCanvasData: function() {
    var e = this.canvasData, o = {};
    return this.ready && D(["left", "top", "width", "height", "naturalWidth", "naturalHeight"], function(n) {
      o[n] = e[n];
    }), o;
  },
  /**
   * Set the canvas position and size with new data.
   * @param {Object} data - The new canvas data.
   * @returns {Cropper} this
   */
  setCanvasData: function(e) {
    var o = this.canvasData, n = o.aspectRatio;
    return this.ready && !this.disabled && K(e) && (u(e.left) && (o.left = e.left), u(e.top) && (o.top = e.top), u(e.width) ? (o.width = e.width, o.height = e.width / n) : u(e.height) && (o.height = e.height, o.width = e.height * n), this.renderCanvas(!0)), this;
  },
  /**
   * Get the crop box position and size data.
   * @returns {Object} The result crop box data.
   */
  getCropBoxData: function() {
    var e = this.cropBoxData, o;
    return this.ready && this.cropped && (o = {
      left: e.left,
      top: e.top,
      width: e.width,
      height: e.height
    }), o || {};
  },
  /**
   * Set the crop box position and size with new data.
   * @param {Object} data - The new crop box data.
   * @returns {Cropper} this
   */
  setCropBoxData: function(e) {
    var o = this.cropBoxData, n = this.options.aspectRatio, t, r;
    return this.ready && this.cropped && !this.disabled && K(e) && (u(e.left) && (o.left = e.left), u(e.top) && (o.top = e.top), u(e.width) && e.width !== o.width && (t = !0, o.width = e.width), u(e.height) && e.height !== o.height && (r = !0, o.height = e.height), n && (t ? o.height = o.width / n : r && (o.width = o.height * n)), this.renderCropBox()), this;
  },
  /**
   * Get a canvas drawn the cropped image.
   * @param {Object} [options={}] - The config options.
   * @returns {HTMLCanvasElement} - The result canvas.
   */
  getCroppedCanvas: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!this.ready || !window.HTMLCanvasElement)
      return null;
    var o = this.canvasData, n = pa(this.image, this.imageData, o, e);
    if (!this.cropped)
      return n;
    var t = this.getData(e.rounded), r = t.x, a = t.y, l = t.width, s = t.height, c = n.width / Math.floor(o.naturalWidth);
    c !== 1 && (r *= c, a *= c, l *= c, s *= c);
    var d = l / s, p = W({
      aspectRatio: d,
      width: e.maxWidth || 1 / 0,
      height: e.maxHeight || 1 / 0
    }), f = W({
      aspectRatio: d,
      width: e.minWidth || 0,
      height: e.minHeight || 0
    }, "cover"), g = W({
      aspectRatio: d,
      width: e.width || (c !== 1 ? n.width : l),
      height: e.height || (c !== 1 ? n.height : s)
    }), b = g.width, k = g.height;
    b = Math.min(p.width, Math.max(f.width, b)), k = Math.min(p.height, Math.max(f.height, k));
    var x = document.createElement("canvas"), N = x.getContext("2d");
    x.width = ii(b), x.height = ii(k), N.fillStyle = e.fillColor || "transparent", N.fillRect(0, 0, b, k);
    var O = e.imageSmoothingEnabled, m = O === void 0 ? !0 : O, ee = e.imageSmoothingQuality;
    N.imageSmoothingEnabled = m, ee && (N.imageSmoothingQuality = ee);
    var z = n.width, P = n.height, V = r, U = a, E, C, I, v, M, $;
    V <= -l || V > z ? (V = 0, E = 0, I = 0, M = 0) : V <= 0 ? (I = -V, V = 0, E = Math.min(z, l + V), M = E) : V <= z && (I = 0, E = Math.min(l, z - V), M = E), E <= 0 || U <= -s || U > P ? (U = 0, C = 0, v = 0, $ = 0) : U <= 0 ? (v = -U, U = 0, C = Math.min(P, s + U), $ = C) : U <= P && (v = 0, C = Math.min(s, P - U), $ = C);
    var H = [V, U, E, C];
    if (M > 0 && $ > 0) {
      var X = b / l;
      H.push(I * X, v * X, M * X, $ * X);
    }
    return N.drawImage.apply(N, [n].concat(rt(H.map(function(te) {
      return Math.floor(ii(te));
    })))), x;
  },
  /**
   * Change the aspect ratio of the crop box.
   * @param {number} aspectRatio - The new aspect ratio.
   * @returns {Cropper} this
   */
  setAspectRatio: function(e) {
    var o = this.options;
    return !this.disabled && !gi(e) && (o.aspectRatio = Math.max(0, e) || NaN, this.ready && (this.initCropBox(), this.cropped && this.renderCropBox())), this;
  },
  /**
   * Change the drag mode.
   * @param {string} mode - The new drag mode.
   * @returns {Cropper} this
   */
  setDragMode: function(e) {
    var o = this.options, n = this.dragBox, t = this.face;
    if (this.ready && !this.disabled) {
      var r = e === Ni, a = o.movable && e === mt;
      e = r || a ? e : ht, o.dragMode = e, si(n, ri, e), J(n, yi, r), J(n, ki, a), o.cropBoxMovable || (si(t, ri, e), J(t, yi, r), J(t, ki, a));
    }
    return this;
  }
}, ba = B.Cropper, yt = /* @__PURE__ */ function() {
  function e(o) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (Ot(this, e), !o || !Vt.test(o.tagName))
      throw new Error("The first argument is required and must be an <img> or <canvas> element.");
    this.element = o, this.options = y({}, Ji, K(n) && n), this.cropped = !1, this.disabled = !1, this.pointers = {}, this.ready = !1, this.reloading = !1, this.replaced = !1, this.sized = !1, this.sizing = !1, this.init();
  }
  return Nt(e, [{
    key: "init",
    value: function() {
      var o = this.element, n = o.tagName.toLowerCase(), t;
      if (!o[w]) {
        if (o[w] = this, n === "img") {
          if (this.isImg = !0, t = o.getAttribute("src") || "", this.originalUrl = t, !t)
            return;
          t = o.src;
        } else
          n === "canvas" && window.HTMLCanvasElement && (t = o.toDataURL());
        this.load(t);
      }
    }
  }, {
    key: "load",
    value: function(o) {
      var n = this;
      if (o) {
        this.url = o, this.imageData = {};
        var t = this.element, r = this.options;
        if (!r.rotatable && !r.scalable && (r.checkOrientation = !1), !r.checkOrientation || !window.ArrayBuffer) {
          this.clone();
          return;
        }
        if (Wt.test(o)) {
          Ut.test(o) ? this.read(ca(o)) : this.clone();
          return;
        }
        var a = new XMLHttpRequest(), l = this.clone.bind(this);
        this.reloading = !0, this.xhr = a, a.onabort = l, a.onerror = l, a.ontimeout = l, a.onprogress = function() {
          a.getResponseHeader("content-type") !== Ki && a.abort();
        }, a.onload = function() {
          n.read(a.response);
        }, a.onloadend = function() {
          n.reloading = !1, n.xhr = null;
        }, r.checkCrossOrigin && tt(o) && t.crossOrigin && (o = at(o)), a.open("GET", o, !0), a.responseType = "arraybuffer", a.withCredentials = t.crossOrigin === "use-credentials", a.send();
      }
    }
  }, {
    key: "read",
    value: function(o) {
      var n = this.options, t = this.imageData, r = da(o), a = 0, l = 1, s = 1;
      if (r > 1) {
        this.url = la(o, Ki);
        var c = ma(r);
        a = c.rotate, l = c.scaleX, s = c.scaleY;
      }
      n.rotatable && (t.rotate = a), n.scalable && (t.scaleX = l, t.scaleY = s), this.clone();
    }
  }, {
    key: "clone",
    value: function() {
      var o = this.element, n = this.url, t = o.crossOrigin, r = n;
      this.options.checkCrossOrigin && tt(n) && (t || (t = "anonymous"), r = at(n)), this.crossOrigin = t, this.crossOriginUrl = r;
      var a = document.createElement("img");
      t && (a.crossOrigin = t), a.src = r || n, a.alt = o.alt || "The image to crop", this.image = a, a.onload = this.start.bind(this), a.onerror = this.stop.bind(this), j(a, Wi), o.parentNode.insertBefore(a, o.nextSibling);
    }
  }, {
    key: "start",
    value: function() {
      var o = this, n = this.image;
      n.onload = null, n.onerror = null, this.sizing = !0;
      var t = B.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(B.navigator.userAgent), r = function(s, c) {
        y(o.imageData, {
          naturalWidth: s,
          naturalHeight: c,
          aspectRatio: s / c
        }), o.initialImageData = y({}, o.imageData), o.sizing = !1, o.sized = !0, o.build();
      };
      if (n.naturalWidth && !t) {
        r(n.naturalWidth, n.naturalHeight);
        return;
      }
      var a = document.createElement("img"), l = document.body || document.documentElement;
      this.sizingImage = a, a.onload = function() {
        r(a.width, a.height), t || l.removeChild(a);
      }, a.src = n.src, t || (a.style.cssText = "left:0;max-height:none!important;max-width:none!important;min-height:0!important;min-width:0!important;opacity:0;position:absolute;top:0;z-index:-1;", l.appendChild(a));
    }
  }, {
    key: "stop",
    value: function() {
      var o = this.image;
      o.onload = null, o.onerror = null, o.parentNode.removeChild(o), this.image = null;
    }
  }, {
    key: "build",
    value: function() {
      if (!(!this.sized || this.ready)) {
        var o = this.element, n = this.options, t = this.image, r = o.parentNode, a = document.createElement("div");
        a.innerHTML = $t;
        var l = a.querySelector(".".concat(w, "-container")), s = l.querySelector(".".concat(w, "-canvas")), c = l.querySelector(".".concat(w, "-drag-box")), d = l.querySelector(".".concat(w, "-crop-box")), p = d.querySelector(".".concat(w, "-face"));
        this.container = r, this.cropper = l, this.canvas = s, this.dragBox = c, this.cropBox = d, this.viewBox = l.querySelector(".".concat(w, "-view-box")), this.face = p, s.appendChild(t), j(o, T), r.insertBefore(l, o.nextSibling), L(t, Wi), this.initPreview(), this.bind(), n.initialAspectRatio = Math.max(0, n.initialAspectRatio) || NaN, n.aspectRatio = Math.max(0, n.aspectRatio) || NaN, n.viewMode = Math.max(0, Math.min(3, Math.round(n.viewMode))) || 0, j(d, T), n.guides || j(d.getElementsByClassName("".concat(w, "-dashed")), T), n.center || j(d.getElementsByClassName("".concat(w, "-center")), T), n.background && j(l, "".concat(w, "-bg")), n.highlight || j(p, Pt), n.cropBoxMovable && (j(p, ki), si(p, ri, Oi)), n.cropBoxResizable || (j(d.getElementsByClassName("".concat(w, "-line")), T), j(d.getElementsByClassName("".concat(w, "-point")), T)), this.render(), this.ready = !0, this.setDragMode(n.dragMode), n.autoCrop && this.crop(), this.setData(n.data), A(n.ready) && R(o, Fi, n.ready, {
          once: !0
        }), ti(o, Fi);
      }
    }
  }, {
    key: "unbuild",
    value: function() {
      if (this.ready) {
        this.ready = !1, this.unbind(), this.resetPreview();
        var o = this.cropper.parentNode;
        o && o.removeChild(this.cropper), L(this.element, T);
      }
    }
  }, {
    key: "uncreate",
    value: function() {
      this.ready ? (this.unbuild(), this.ready = !1, this.cropped = !1) : this.sizing ? (this.sizingImage.onload = null, this.sizing = !1, this.sized = !1) : this.reloading ? (this.xhr.onabort = null, this.xhr.abort()) : this.image && this.stop();
    }
    /**
     * Get the no conflict cropper class.
     * @returns {Cropper} The cropper class.
     */
  }], [{
    key: "noConflict",
    value: function() {
      return window.Cropper = ba, e;
    }
    /**
     * Change the default options.
     * @param {Object} options - The new default options.
     */
  }, {
    key: "setDefaults",
    value: function(o) {
      y(Ji, K(o) && o);
    }
  }]), e;
}();
y(yt.prototype, ha, va, fa, ua, ga, xa);
function wa(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function vi() {
  this._types = /* @__PURE__ */ Object.create(null), this._extensions = /* @__PURE__ */ Object.create(null);
  for (let e = 0; e < arguments.length; e++)
    this.define(arguments[e]);
  this.define = this.define.bind(this), this.getType = this.getType.bind(this), this.getExtension = this.getExtension.bind(this);
}
vi.prototype.define = function(e, o) {
  for (let n in e) {
    let t = e[n].map(function(r) {
      return r.toLowerCase();
    });
    n = n.toLowerCase();
    for (let r = 0; r < t.length; r++) {
      const a = t[r];
      if (a[0] !== "*") {
        if (!o && a in this._types)
          throw new Error(
            'Attempt to change mapping for "' + a + '" extension from "' + this._types[a] + '" to "' + n + '". Pass `force=true` to allow this, otherwise remove "' + a + '" from the list of extensions for "' + n + '".'
          );
        this._types[a] = n;
      }
    }
    if (o || !this._extensions[n]) {
      const r = t[0];
      this._extensions[n] = r[0] !== "*" ? r : r.substr(1);
    }
  }
};
vi.prototype.getType = function(e) {
  e = String(e);
  let o = e.replace(/^.*[/\\]/, "").toLowerCase(), n = o.replace(/^.*\./, "").toLowerCase(), t = o.length < e.length;
  return (n.length < o.length - 1 || !t) && this._types[n] || null;
};
vi.prototype.getExtension = function(e) {
  return e = /^\s*([^;\s]*)/.test(e) && RegExp.$1, e && this._extensions[e.toLowerCase()] || null;
};
var ya = vi, ka = { "application/andrew-inset": ["ez"], "application/applixware": ["aw"], "application/atom+xml": ["atom"], "application/atomcat+xml": ["atomcat"], "application/atomdeleted+xml": ["atomdeleted"], "application/atomsvc+xml": ["atomsvc"], "application/atsc-dwd+xml": ["dwd"], "application/atsc-held+xml": ["held"], "application/atsc-rsat+xml": ["rsat"], "application/bdoc": ["bdoc"], "application/calendar+xml": ["xcs"], "application/ccxml+xml": ["ccxml"], "application/cdfx+xml": ["cdfx"], "application/cdmi-capability": ["cdmia"], "application/cdmi-container": ["cdmic"], "application/cdmi-domain": ["cdmid"], "application/cdmi-object": ["cdmio"], "application/cdmi-queue": ["cdmiq"], "application/cu-seeme": ["cu"], "application/dash+xml": ["mpd"], "application/davmount+xml": ["davmount"], "application/docbook+xml": ["dbk"], "application/dssc+der": ["dssc"], "application/dssc+xml": ["xdssc"], "application/ecmascript": ["es", "ecma"], "application/emma+xml": ["emma"], "application/emotionml+xml": ["emotionml"], "application/epub+zip": ["epub"], "application/exi": ["exi"], "application/express": ["exp"], "application/fdt+xml": ["fdt"], "application/font-tdpfr": ["pfr"], "application/geo+json": ["geojson"], "application/gml+xml": ["gml"], "application/gpx+xml": ["gpx"], "application/gxf": ["gxf"], "application/gzip": ["gz"], "application/hjson": ["hjson"], "application/hyperstudio": ["stk"], "application/inkml+xml": ["ink", "inkml"], "application/ipfix": ["ipfix"], "application/its+xml": ["its"], "application/java-archive": ["jar", "war", "ear"], "application/java-serialized-object": ["ser"], "application/java-vm": ["class"], "application/javascript": ["js", "mjs"], "application/json": ["json", "map"], "application/json5": ["json5"], "application/jsonml+json": ["jsonml"], "application/ld+json": ["jsonld"], "application/lgr+xml": ["lgr"], "application/lost+xml": ["lostxml"], "application/mac-binhex40": ["hqx"], "application/mac-compactpro": ["cpt"], "application/mads+xml": ["mads"], "application/manifest+json": ["webmanifest"], "application/marc": ["mrc"], "application/marcxml+xml": ["mrcx"], "application/mathematica": ["ma", "nb", "mb"], "application/mathml+xml": ["mathml"], "application/mbox": ["mbox"], "application/mediaservercontrol+xml": ["mscml"], "application/metalink+xml": ["metalink"], "application/metalink4+xml": ["meta4"], "application/mets+xml": ["mets"], "application/mmt-aei+xml": ["maei"], "application/mmt-usd+xml": ["musd"], "application/mods+xml": ["mods"], "application/mp21": ["m21", "mp21"], "application/mp4": ["mp4s", "m4p"], "application/msword": ["doc", "dot"], "application/mxf": ["mxf"], "application/n-quads": ["nq"], "application/n-triples": ["nt"], "application/node": ["cjs"], "application/octet-stream": ["bin", "dms", "lrf", "mar", "so", "dist", "distz", "pkg", "bpk", "dump", "elc", "deploy", "exe", "dll", "deb", "dmg", "iso", "img", "msi", "msp", "msm", "buffer"], "application/oda": ["oda"], "application/oebps-package+xml": ["opf"], "application/ogg": ["ogx"], "application/omdoc+xml": ["omdoc"], "application/onenote": ["onetoc", "onetoc2", "onetmp", "onepkg"], "application/oxps": ["oxps"], "application/p2p-overlay+xml": ["relo"], "application/patch-ops-error+xml": ["xer"], "application/pdf": ["pdf"], "application/pgp-encrypted": ["pgp"], "application/pgp-signature": ["asc", "sig"], "application/pics-rules": ["prf"], "application/pkcs10": ["p10"], "application/pkcs7-mime": ["p7m", "p7c"], "application/pkcs7-signature": ["p7s"], "application/pkcs8": ["p8"], "application/pkix-attr-cert": ["ac"], "application/pkix-cert": ["cer"], "application/pkix-crl": ["crl"], "application/pkix-pkipath": ["pkipath"], "application/pkixcmp": ["pki"], "application/pls+xml": ["pls"], "application/postscript": ["ai", "eps", "ps"], "application/provenance+xml": ["provx"], "application/pskc+xml": ["pskcxml"], "application/raml+yaml": ["raml"], "application/rdf+xml": ["rdf", "owl"], "application/reginfo+xml": ["rif"], "application/relax-ng-compact-syntax": ["rnc"], "application/resource-lists+xml": ["rl"], "application/resource-lists-diff+xml": ["rld"], "application/rls-services+xml": ["rs"], "application/route-apd+xml": ["rapd"], "application/route-s-tsid+xml": ["sls"], "application/route-usd+xml": ["rusd"], "application/rpki-ghostbusters": ["gbr"], "application/rpki-manifest": ["mft"], "application/rpki-roa": ["roa"], "application/rsd+xml": ["rsd"], "application/rss+xml": ["rss"], "application/rtf": ["rtf"], "application/sbml+xml": ["sbml"], "application/scvp-cv-request": ["scq"], "application/scvp-cv-response": ["scs"], "application/scvp-vp-request": ["spq"], "application/scvp-vp-response": ["spp"], "application/sdp": ["sdp"], "application/senml+xml": ["senmlx"], "application/sensml+xml": ["sensmlx"], "application/set-payment-initiation": ["setpay"], "application/set-registration-initiation": ["setreg"], "application/shf+xml": ["shf"], "application/sieve": ["siv", "sieve"], "application/smil+xml": ["smi", "smil"], "application/sparql-query": ["rq"], "application/sparql-results+xml": ["srx"], "application/srgs": ["gram"], "application/srgs+xml": ["grxml"], "application/sru+xml": ["sru"], "application/ssdl+xml": ["ssdl"], "application/ssml+xml": ["ssml"], "application/swid+xml": ["swidtag"], "application/tei+xml": ["tei", "teicorpus"], "application/thraud+xml": ["tfi"], "application/timestamped-data": ["tsd"], "application/toml": ["toml"], "application/trig": ["trig"], "application/ttml+xml": ["ttml"], "application/ubjson": ["ubj"], "application/urc-ressheet+xml": ["rsheet"], "application/urc-targetdesc+xml": ["td"], "application/voicexml+xml": ["vxml"], "application/wasm": ["wasm"], "application/widget": ["wgt"], "application/winhlp": ["hlp"], "application/wsdl+xml": ["wsdl"], "application/wspolicy+xml": ["wspolicy"], "application/xaml+xml": ["xaml"], "application/xcap-att+xml": ["xav"], "application/xcap-caps+xml": ["xca"], "application/xcap-diff+xml": ["xdf"], "application/xcap-el+xml": ["xel"], "application/xcap-ns+xml": ["xns"], "application/xenc+xml": ["xenc"], "application/xhtml+xml": ["xhtml", "xht"], "application/xliff+xml": ["xlf"], "application/xml": ["xml", "xsl", "xsd", "rng"], "application/xml-dtd": ["dtd"], "application/xop+xml": ["xop"], "application/xproc+xml": ["xpl"], "application/xslt+xml": ["*xsl", "xslt"], "application/xspf+xml": ["xspf"], "application/xv+xml": ["mxml", "xhvml", "xvml", "xvm"], "application/yang": ["yang"], "application/yin+xml": ["yin"], "application/zip": ["zip"], "audio/3gpp": ["*3gpp"], "audio/adpcm": ["adp"], "audio/amr": ["amr"], "audio/basic": ["au", "snd"], "audio/midi": ["mid", "midi", "kar", "rmi"], "audio/mobile-xmf": ["mxmf"], "audio/mp3": ["*mp3"], "audio/mp4": ["m4a", "mp4a"], "audio/mpeg": ["mpga", "mp2", "mp2a", "mp3", "m2a", "m3a"], "audio/ogg": ["oga", "ogg", "spx", "opus"], "audio/s3m": ["s3m"], "audio/silk": ["sil"], "audio/wav": ["wav"], "audio/wave": ["*wav"], "audio/webm": ["weba"], "audio/xm": ["xm"], "font/collection": ["ttc"], "font/otf": ["otf"], "font/ttf": ["ttf"], "font/woff": ["woff"], "font/woff2": ["woff2"], "image/aces": ["exr"], "image/apng": ["apng"], "image/avif": ["avif"], "image/bmp": ["bmp"], "image/cgm": ["cgm"], "image/dicom-rle": ["drle"], "image/emf": ["emf"], "image/fits": ["fits"], "image/g3fax": ["g3"], "image/gif": ["gif"], "image/heic": ["heic"], "image/heic-sequence": ["heics"], "image/heif": ["heif"], "image/heif-sequence": ["heifs"], "image/hej2k": ["hej2"], "image/hsj2": ["hsj2"], "image/ief": ["ief"], "image/jls": ["jls"], "image/jp2": ["jp2", "jpg2"], "image/jpeg": ["jpeg", "jpg", "jpe"], "image/jph": ["jph"], "image/jphc": ["jhc"], "image/jpm": ["jpm"], "image/jpx": ["jpx", "jpf"], "image/jxr": ["jxr"], "image/jxra": ["jxra"], "image/jxrs": ["jxrs"], "image/jxs": ["jxs"], "image/jxsc": ["jxsc"], "image/jxsi": ["jxsi"], "image/jxss": ["jxss"], "image/ktx": ["ktx"], "image/ktx2": ["ktx2"], "image/png": ["png"], "image/sgi": ["sgi"], "image/svg+xml": ["svg", "svgz"], "image/t38": ["t38"], "image/tiff": ["tif", "tiff"], "image/tiff-fx": ["tfx"], "image/webp": ["webp"], "image/wmf": ["wmf"], "message/disposition-notification": ["disposition-notification"], "message/global": ["u8msg"], "message/global-delivery-status": ["u8dsn"], "message/global-disposition-notification": ["u8mdn"], "message/global-headers": ["u8hdr"], "message/rfc822": ["eml", "mime"], "model/3mf": ["3mf"], "model/gltf+json": ["gltf"], "model/gltf-binary": ["glb"], "model/iges": ["igs", "iges"], "model/mesh": ["msh", "mesh", "silo"], "model/mtl": ["mtl"], "model/obj": ["obj"], "model/step+xml": ["stpx"], "model/step+zip": ["stpz"], "model/step-xml+zip": ["stpxz"], "model/stl": ["stl"], "model/vrml": ["wrl", "vrml"], "model/x3d+binary": ["*x3db", "x3dbz"], "model/x3d+fastinfoset": ["x3db"], "model/x3d+vrml": ["*x3dv", "x3dvz"], "model/x3d+xml": ["x3d", "x3dz"], "model/x3d-vrml": ["x3dv"], "text/cache-manifest": ["appcache", "manifest"], "text/calendar": ["ics", "ifb"], "text/coffeescript": ["coffee", "litcoffee"], "text/css": ["css"], "text/csv": ["csv"], "text/html": ["html", "htm", "shtml"], "text/jade": ["jade"], "text/jsx": ["jsx"], "text/less": ["less"], "text/markdown": ["markdown", "md"], "text/mathml": ["mml"], "text/mdx": ["mdx"], "text/n3": ["n3"], "text/plain": ["txt", "text", "conf", "def", "list", "log", "in", "ini"], "text/richtext": ["rtx"], "text/rtf": ["*rtf"], "text/sgml": ["sgml", "sgm"], "text/shex": ["shex"], "text/slim": ["slim", "slm"], "text/spdx": ["spdx"], "text/stylus": ["stylus", "styl"], "text/tab-separated-values": ["tsv"], "text/troff": ["t", "tr", "roff", "man", "me", "ms"], "text/turtle": ["ttl"], "text/uri-list": ["uri", "uris", "urls"], "text/vcard": ["vcard"], "text/vtt": ["vtt"], "text/xml": ["*xml"], "text/yaml": ["yaml", "yml"], "video/3gpp": ["3gp", "3gpp"], "video/3gpp2": ["3g2"], "video/h261": ["h261"], "video/h263": ["h263"], "video/h264": ["h264"], "video/iso.segment": ["m4s"], "video/jpeg": ["jpgv"], "video/jpm": ["*jpm", "jpgm"], "video/mj2": ["mj2", "mjp2"], "video/mp2t": ["ts"], "video/mp4": ["mp4", "mp4v", "mpg4"], "video/mpeg": ["mpeg", "mpg", "mpe", "m1v", "m2v"], "video/ogg": ["ogv"], "video/quicktime": ["qt", "mov"], "video/webm": ["webm"] }, Da = { "application/prs.cww": ["cww"], "application/vnd.1000minds.decision-model+xml": ["1km"], "application/vnd.3gpp.pic-bw-large": ["plb"], "application/vnd.3gpp.pic-bw-small": ["psb"], "application/vnd.3gpp.pic-bw-var": ["pvb"], "application/vnd.3gpp2.tcap": ["tcap"], "application/vnd.3m.post-it-notes": ["pwn"], "application/vnd.accpac.simply.aso": ["aso"], "application/vnd.accpac.simply.imp": ["imp"], "application/vnd.acucobol": ["acu"], "application/vnd.acucorp": ["atc", "acutc"], "application/vnd.adobe.air-application-installer-package+zip": ["air"], "application/vnd.adobe.formscentral.fcdt": ["fcdt"], "application/vnd.adobe.fxp": ["fxp", "fxpl"], "application/vnd.adobe.xdp+xml": ["xdp"], "application/vnd.adobe.xfdf": ["xfdf"], "application/vnd.ahead.space": ["ahead"], "application/vnd.airzip.filesecure.azf": ["azf"], "application/vnd.airzip.filesecure.azs": ["azs"], "application/vnd.amazon.ebook": ["azw"], "application/vnd.americandynamics.acc": ["acc"], "application/vnd.amiga.ami": ["ami"], "application/vnd.android.package-archive": ["apk"], "application/vnd.anser-web-certificate-issue-initiation": ["cii"], "application/vnd.anser-web-funds-transfer-initiation": ["fti"], "application/vnd.antix.game-component": ["atx"], "application/vnd.apple.installer+xml": ["mpkg"], "application/vnd.apple.keynote": ["key"], "application/vnd.apple.mpegurl": ["m3u8"], "application/vnd.apple.numbers": ["numbers"], "application/vnd.apple.pages": ["pages"], "application/vnd.apple.pkpass": ["pkpass"], "application/vnd.aristanetworks.swi": ["swi"], "application/vnd.astraea-software.iota": ["iota"], "application/vnd.audiograph": ["aep"], "application/vnd.balsamiq.bmml+xml": ["bmml"], "application/vnd.blueice.multipass": ["mpm"], "application/vnd.bmi": ["bmi"], "application/vnd.businessobjects": ["rep"], "application/vnd.chemdraw+xml": ["cdxml"], "application/vnd.chipnuts.karaoke-mmd": ["mmd"], "application/vnd.cinderella": ["cdy"], "application/vnd.citationstyles.style+xml": ["csl"], "application/vnd.claymore": ["cla"], "application/vnd.cloanto.rp9": ["rp9"], "application/vnd.clonk.c4group": ["c4g", "c4d", "c4f", "c4p", "c4u"], "application/vnd.cluetrust.cartomobile-config": ["c11amc"], "application/vnd.cluetrust.cartomobile-config-pkg": ["c11amz"], "application/vnd.commonspace": ["csp"], "application/vnd.contact.cmsg": ["cdbcmsg"], "application/vnd.cosmocaller": ["cmc"], "application/vnd.crick.clicker": ["clkx"], "application/vnd.crick.clicker.keyboard": ["clkk"], "application/vnd.crick.clicker.palette": ["clkp"], "application/vnd.crick.clicker.template": ["clkt"], "application/vnd.crick.clicker.wordbank": ["clkw"], "application/vnd.criticaltools.wbs+xml": ["wbs"], "application/vnd.ctc-posml": ["pml"], "application/vnd.cups-ppd": ["ppd"], "application/vnd.curl.car": ["car"], "application/vnd.curl.pcurl": ["pcurl"], "application/vnd.dart": ["dart"], "application/vnd.data-vision.rdz": ["rdz"], "application/vnd.dbf": ["dbf"], "application/vnd.dece.data": ["uvf", "uvvf", "uvd", "uvvd"], "application/vnd.dece.ttml+xml": ["uvt", "uvvt"], "application/vnd.dece.unspecified": ["uvx", "uvvx"], "application/vnd.dece.zip": ["uvz", "uvvz"], "application/vnd.denovo.fcselayout-link": ["fe_launch"], "application/vnd.dna": ["dna"], "application/vnd.dolby.mlp": ["mlp"], "application/vnd.dpgraph": ["dpg"], "application/vnd.dreamfactory": ["dfac"], "application/vnd.ds-keypoint": ["kpxx"], "application/vnd.dvb.ait": ["ait"], "application/vnd.dvb.service": ["svc"], "application/vnd.dynageo": ["geo"], "application/vnd.ecowin.chart": ["mag"], "application/vnd.enliven": ["nml"], "application/vnd.epson.esf": ["esf"], "application/vnd.epson.msf": ["msf"], "application/vnd.epson.quickanime": ["qam"], "application/vnd.epson.salt": ["slt"], "application/vnd.epson.ssf": ["ssf"], "application/vnd.eszigno3+xml": ["es3", "et3"], "application/vnd.ezpix-album": ["ez2"], "application/vnd.ezpix-package": ["ez3"], "application/vnd.fdf": ["fdf"], "application/vnd.fdsn.mseed": ["mseed"], "application/vnd.fdsn.seed": ["seed", "dataless"], "application/vnd.flographit": ["gph"], "application/vnd.fluxtime.clip": ["ftc"], "application/vnd.framemaker": ["fm", "frame", "maker", "book"], "application/vnd.frogans.fnc": ["fnc"], "application/vnd.frogans.ltf": ["ltf"], "application/vnd.fsc.weblaunch": ["fsc"], "application/vnd.fujitsu.oasys": ["oas"], "application/vnd.fujitsu.oasys2": ["oa2"], "application/vnd.fujitsu.oasys3": ["oa3"], "application/vnd.fujitsu.oasysgp": ["fg5"], "application/vnd.fujitsu.oasysprs": ["bh2"], "application/vnd.fujixerox.ddd": ["ddd"], "application/vnd.fujixerox.docuworks": ["xdw"], "application/vnd.fujixerox.docuworks.binder": ["xbd"], "application/vnd.fuzzysheet": ["fzs"], "application/vnd.genomatix.tuxedo": ["txd"], "application/vnd.geogebra.file": ["ggb"], "application/vnd.geogebra.tool": ["ggt"], "application/vnd.geometry-explorer": ["gex", "gre"], "application/vnd.geonext": ["gxt"], "application/vnd.geoplan": ["g2w"], "application/vnd.geospace": ["g3w"], "application/vnd.gmx": ["gmx"], "application/vnd.google-apps.document": ["gdoc"], "application/vnd.google-apps.presentation": ["gslides"], "application/vnd.google-apps.spreadsheet": ["gsheet"], "application/vnd.google-earth.kml+xml": ["kml"], "application/vnd.google-earth.kmz": ["kmz"], "application/vnd.grafeq": ["gqf", "gqs"], "application/vnd.groove-account": ["gac"], "application/vnd.groove-help": ["ghf"], "application/vnd.groove-identity-message": ["gim"], "application/vnd.groove-injector": ["grv"], "application/vnd.groove-tool-message": ["gtm"], "application/vnd.groove-tool-template": ["tpl"], "application/vnd.groove-vcard": ["vcg"], "application/vnd.hal+xml": ["hal"], "application/vnd.handheld-entertainment+xml": ["zmm"], "application/vnd.hbci": ["hbci"], "application/vnd.hhe.lesson-player": ["les"], "application/vnd.hp-hpgl": ["hpgl"], "application/vnd.hp-hpid": ["hpid"], "application/vnd.hp-hps": ["hps"], "application/vnd.hp-jlyt": ["jlt"], "application/vnd.hp-pcl": ["pcl"], "application/vnd.hp-pclxl": ["pclxl"], "application/vnd.hydrostatix.sof-data": ["sfd-hdstx"], "application/vnd.ibm.minipay": ["mpy"], "application/vnd.ibm.modcap": ["afp", "listafp", "list3820"], "application/vnd.ibm.rights-management": ["irm"], "application/vnd.ibm.secure-container": ["sc"], "application/vnd.iccprofile": ["icc", "icm"], "application/vnd.igloader": ["igl"], "application/vnd.immervision-ivp": ["ivp"], "application/vnd.immervision-ivu": ["ivu"], "application/vnd.insors.igm": ["igm"], "application/vnd.intercon.formnet": ["xpw", "xpx"], "application/vnd.intergeo": ["i2g"], "application/vnd.intu.qbo": ["qbo"], "application/vnd.intu.qfx": ["qfx"], "application/vnd.ipunplugged.rcprofile": ["rcprofile"], "application/vnd.irepository.package+xml": ["irp"], "application/vnd.is-xpr": ["xpr"], "application/vnd.isac.fcs": ["fcs"], "application/vnd.jam": ["jam"], "application/vnd.jcp.javame.midlet-rms": ["rms"], "application/vnd.jisp": ["jisp"], "application/vnd.joost.joda-archive": ["joda"], "application/vnd.kahootz": ["ktz", "ktr"], "application/vnd.kde.karbon": ["karbon"], "application/vnd.kde.kchart": ["chrt"], "application/vnd.kde.kformula": ["kfo"], "application/vnd.kde.kivio": ["flw"], "application/vnd.kde.kontour": ["kon"], "application/vnd.kde.kpresenter": ["kpr", "kpt"], "application/vnd.kde.kspread": ["ksp"], "application/vnd.kde.kword": ["kwd", "kwt"], "application/vnd.kenameaapp": ["htke"], "application/vnd.kidspiration": ["kia"], "application/vnd.kinar": ["kne", "knp"], "application/vnd.koan": ["skp", "skd", "skt", "skm"], "application/vnd.kodak-descriptor": ["sse"], "application/vnd.las.las+xml": ["lasxml"], "application/vnd.llamagraphics.life-balance.desktop": ["lbd"], "application/vnd.llamagraphics.life-balance.exchange+xml": ["lbe"], "application/vnd.lotus-1-2-3": ["123"], "application/vnd.lotus-approach": ["apr"], "application/vnd.lotus-freelance": ["pre"], "application/vnd.lotus-notes": ["nsf"], "application/vnd.lotus-organizer": ["org"], "application/vnd.lotus-screencam": ["scm"], "application/vnd.lotus-wordpro": ["lwp"], "application/vnd.macports.portpkg": ["portpkg"], "application/vnd.mapbox-vector-tile": ["mvt"], "application/vnd.mcd": ["mcd"], "application/vnd.medcalcdata": ["mc1"], "application/vnd.mediastation.cdkey": ["cdkey"], "application/vnd.mfer": ["mwf"], "application/vnd.mfmp": ["mfm"], "application/vnd.micrografx.flo": ["flo"], "application/vnd.micrografx.igx": ["igx"], "application/vnd.mif": ["mif"], "application/vnd.mobius.daf": ["daf"], "application/vnd.mobius.dis": ["dis"], "application/vnd.mobius.mbk": ["mbk"], "application/vnd.mobius.mqy": ["mqy"], "application/vnd.mobius.msl": ["msl"], "application/vnd.mobius.plc": ["plc"], "application/vnd.mobius.txf": ["txf"], "application/vnd.mophun.application": ["mpn"], "application/vnd.mophun.certificate": ["mpc"], "application/vnd.mozilla.xul+xml": ["xul"], "application/vnd.ms-artgalry": ["cil"], "application/vnd.ms-cab-compressed": ["cab"], "application/vnd.ms-excel": ["xls", "xlm", "xla", "xlc", "xlt", "xlw"], "application/vnd.ms-excel.addin.macroenabled.12": ["xlam"], "application/vnd.ms-excel.sheet.binary.macroenabled.12": ["xlsb"], "application/vnd.ms-excel.sheet.macroenabled.12": ["xlsm"], "application/vnd.ms-excel.template.macroenabled.12": ["xltm"], "application/vnd.ms-fontobject": ["eot"], "application/vnd.ms-htmlhelp": ["chm"], "application/vnd.ms-ims": ["ims"], "application/vnd.ms-lrm": ["lrm"], "application/vnd.ms-officetheme": ["thmx"], "application/vnd.ms-outlook": ["msg"], "application/vnd.ms-pki.seccat": ["cat"], "application/vnd.ms-pki.stl": ["*stl"], "application/vnd.ms-powerpoint": ["ppt", "pps", "pot"], "application/vnd.ms-powerpoint.addin.macroenabled.12": ["ppam"], "application/vnd.ms-powerpoint.presentation.macroenabled.12": ["pptm"], "application/vnd.ms-powerpoint.slide.macroenabled.12": ["sldm"], "application/vnd.ms-powerpoint.slideshow.macroenabled.12": ["ppsm"], "application/vnd.ms-powerpoint.template.macroenabled.12": ["potm"], "application/vnd.ms-project": ["mpp", "mpt"], "application/vnd.ms-word.document.macroenabled.12": ["docm"], "application/vnd.ms-word.template.macroenabled.12": ["dotm"], "application/vnd.ms-works": ["wps", "wks", "wcm", "wdb"], "application/vnd.ms-wpl": ["wpl"], "application/vnd.ms-xpsdocument": ["xps"], "application/vnd.mseq": ["mseq"], "application/vnd.musician": ["mus"], "application/vnd.muvee.style": ["msty"], "application/vnd.mynfc": ["taglet"], "application/vnd.neurolanguage.nlu": ["nlu"], "application/vnd.nitf": ["ntf", "nitf"], "application/vnd.noblenet-directory": ["nnd"], "application/vnd.noblenet-sealer": ["nns"], "application/vnd.noblenet-web": ["nnw"], "application/vnd.nokia.n-gage.ac+xml": ["*ac"], "application/vnd.nokia.n-gage.data": ["ngdat"], "application/vnd.nokia.n-gage.symbian.install": ["n-gage"], "application/vnd.nokia.radio-preset": ["rpst"], "application/vnd.nokia.radio-presets": ["rpss"], "application/vnd.novadigm.edm": ["edm"], "application/vnd.novadigm.edx": ["edx"], "application/vnd.novadigm.ext": ["ext"], "application/vnd.oasis.opendocument.chart": ["odc"], "application/vnd.oasis.opendocument.chart-template": ["otc"], "application/vnd.oasis.opendocument.database": ["odb"], "application/vnd.oasis.opendocument.formula": ["odf"], "application/vnd.oasis.opendocument.formula-template": ["odft"], "application/vnd.oasis.opendocument.graphics": ["odg"], "application/vnd.oasis.opendocument.graphics-template": ["otg"], "application/vnd.oasis.opendocument.image": ["odi"], "application/vnd.oasis.opendocument.image-template": ["oti"], "application/vnd.oasis.opendocument.presentation": ["odp"], "application/vnd.oasis.opendocument.presentation-template": ["otp"], "application/vnd.oasis.opendocument.spreadsheet": ["ods"], "application/vnd.oasis.opendocument.spreadsheet-template": ["ots"], "application/vnd.oasis.opendocument.text": ["odt"], "application/vnd.oasis.opendocument.text-master": ["odm"], "application/vnd.oasis.opendocument.text-template": ["ott"], "application/vnd.oasis.opendocument.text-web": ["oth"], "application/vnd.olpc-sugar": ["xo"], "application/vnd.oma.dd2+xml": ["dd2"], "application/vnd.openblox.game+xml": ["obgx"], "application/vnd.openofficeorg.extension": ["oxt"], "application/vnd.openstreetmap.data+xml": ["osm"], "application/vnd.openxmlformats-officedocument.presentationml.presentation": ["pptx"], "application/vnd.openxmlformats-officedocument.presentationml.slide": ["sldx"], "application/vnd.openxmlformats-officedocument.presentationml.slideshow": ["ppsx"], "application/vnd.openxmlformats-officedocument.presentationml.template": ["potx"], "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": ["xlsx"], "application/vnd.openxmlformats-officedocument.spreadsheetml.template": ["xltx"], "application/vnd.openxmlformats-officedocument.wordprocessingml.document": ["docx"], "application/vnd.openxmlformats-officedocument.wordprocessingml.template": ["dotx"], "application/vnd.osgeo.mapguide.package": ["mgp"], "application/vnd.osgi.dp": ["dp"], "application/vnd.osgi.subsystem": ["esa"], "application/vnd.palm": ["pdb", "pqa", "oprc"], "application/vnd.pawaafile": ["paw"], "application/vnd.pg.format": ["str"], "application/vnd.pg.osasli": ["ei6"], "application/vnd.picsel": ["efif"], "application/vnd.pmi.widget": ["wg"], "application/vnd.pocketlearn": ["plf"], "application/vnd.powerbuilder6": ["pbd"], "application/vnd.previewsystems.box": ["box"], "application/vnd.proteus.magazine": ["mgz"], "application/vnd.publishare-delta-tree": ["qps"], "application/vnd.pvi.ptid1": ["ptid"], "application/vnd.quark.quarkxpress": ["qxd", "qxt", "qwd", "qwt", "qxl", "qxb"], "application/vnd.rar": ["rar"], "application/vnd.realvnc.bed": ["bed"], "application/vnd.recordare.musicxml": ["mxl"], "application/vnd.recordare.musicxml+xml": ["musicxml"], "application/vnd.rig.cryptonote": ["cryptonote"], "application/vnd.rim.cod": ["cod"], "application/vnd.rn-realmedia": ["rm"], "application/vnd.rn-realmedia-vbr": ["rmvb"], "application/vnd.route66.link66+xml": ["link66"], "application/vnd.sailingtracker.track": ["st"], "application/vnd.seemail": ["see"], "application/vnd.sema": ["sema"], "application/vnd.semd": ["semd"], "application/vnd.semf": ["semf"], "application/vnd.shana.informed.formdata": ["ifm"], "application/vnd.shana.informed.formtemplate": ["itp"], "application/vnd.shana.informed.interchange": ["iif"], "application/vnd.shana.informed.package": ["ipk"], "application/vnd.simtech-mindmapper": ["twd", "twds"], "application/vnd.smaf": ["mmf"], "application/vnd.smart.teacher": ["teacher"], "application/vnd.software602.filler.form+xml": ["fo"], "application/vnd.solent.sdkm+xml": ["sdkm", "sdkd"], "application/vnd.spotfire.dxp": ["dxp"], "application/vnd.spotfire.sfs": ["sfs"], "application/vnd.stardivision.calc": ["sdc"], "application/vnd.stardivision.draw": ["sda"], "application/vnd.stardivision.impress": ["sdd"], "application/vnd.stardivision.math": ["smf"], "application/vnd.stardivision.writer": ["sdw", "vor"], "application/vnd.stardivision.writer-global": ["sgl"], "application/vnd.stepmania.package": ["smzip"], "application/vnd.stepmania.stepchart": ["sm"], "application/vnd.sun.wadl+xml": ["wadl"], "application/vnd.sun.xml.calc": ["sxc"], "application/vnd.sun.xml.calc.template": ["stc"], "application/vnd.sun.xml.draw": ["sxd"], "application/vnd.sun.xml.draw.template": ["std"], "application/vnd.sun.xml.impress": ["sxi"], "application/vnd.sun.xml.impress.template": ["sti"], "application/vnd.sun.xml.math": ["sxm"], "application/vnd.sun.xml.writer": ["sxw"], "application/vnd.sun.xml.writer.global": ["sxg"], "application/vnd.sun.xml.writer.template": ["stw"], "application/vnd.sus-calendar": ["sus", "susp"], "application/vnd.svd": ["svd"], "application/vnd.symbian.install": ["sis", "sisx"], "application/vnd.syncml+xml": ["xsm"], "application/vnd.syncml.dm+wbxml": ["bdm"], "application/vnd.syncml.dm+xml": ["xdm"], "application/vnd.syncml.dmddf+xml": ["ddf"], "application/vnd.tao.intent-module-archive": ["tao"], "application/vnd.tcpdump.pcap": ["pcap", "cap", "dmp"], "application/vnd.tmobile-livetv": ["tmo"], "application/vnd.trid.tpt": ["tpt"], "application/vnd.triscape.mxs": ["mxs"], "application/vnd.trueapp": ["tra"], "application/vnd.ufdl": ["ufd", "ufdl"], "application/vnd.uiq.theme": ["utz"], "application/vnd.umajin": ["umj"], "application/vnd.unity": ["unityweb"], "application/vnd.uoml+xml": ["uoml"], "application/vnd.vcx": ["vcx"], "application/vnd.visio": ["vsd", "vst", "vss", "vsw"], "application/vnd.visionary": ["vis"], "application/vnd.vsf": ["vsf"], "application/vnd.wap.wbxml": ["wbxml"], "application/vnd.wap.wmlc": ["wmlc"], "application/vnd.wap.wmlscriptc": ["wmlsc"], "application/vnd.webturbo": ["wtb"], "application/vnd.wolfram.player": ["nbp"], "application/vnd.wordperfect": ["wpd"], "application/vnd.wqd": ["wqd"], "application/vnd.wt.stf": ["stf"], "application/vnd.xara": ["xar"], "application/vnd.xfdl": ["xfdl"], "application/vnd.yamaha.hv-dic": ["hvd"], "application/vnd.yamaha.hv-script": ["hvs"], "application/vnd.yamaha.hv-voice": ["hvp"], "application/vnd.yamaha.openscoreformat": ["osf"], "application/vnd.yamaha.openscoreformat.osfpvg+xml": ["osfpvg"], "application/vnd.yamaha.smaf-audio": ["saf"], "application/vnd.yamaha.smaf-phrase": ["spf"], "application/vnd.yellowriver-custom-menu": ["cmp"], "application/vnd.zul": ["zir", "zirz"], "application/vnd.zzazz.deck+xml": ["zaz"], "application/x-7z-compressed": ["7z"], "application/x-abiword": ["abw"], "application/x-ace-compressed": ["ace"], "application/x-apple-diskimage": ["*dmg"], "application/x-arj": ["arj"], "application/x-authorware-bin": ["aab", "x32", "u32", "vox"], "application/x-authorware-map": ["aam"], "application/x-authorware-seg": ["aas"], "application/x-bcpio": ["bcpio"], "application/x-bdoc": ["*bdoc"], "application/x-bittorrent": ["torrent"], "application/x-blorb": ["blb", "blorb"], "application/x-bzip": ["bz"], "application/x-bzip2": ["bz2", "boz"], "application/x-cbr": ["cbr", "cba", "cbt", "cbz", "cb7"], "application/x-cdlink": ["vcd"], "application/x-cfs-compressed": ["cfs"], "application/x-chat": ["chat"], "application/x-chess-pgn": ["pgn"], "application/x-chrome-extension": ["crx"], "application/x-cocoa": ["cco"], "application/x-conference": ["nsc"], "application/x-cpio": ["cpio"], "application/x-csh": ["csh"], "application/x-debian-package": ["*deb", "udeb"], "application/x-dgc-compressed": ["dgc"], "application/x-director": ["dir", "dcr", "dxr", "cst", "cct", "cxt", "w3d", "fgd", "swa"], "application/x-doom": ["wad"], "application/x-dtbncx+xml": ["ncx"], "application/x-dtbook+xml": ["dtb"], "application/x-dtbresource+xml": ["res"], "application/x-dvi": ["dvi"], "application/x-envoy": ["evy"], "application/x-eva": ["eva"], "application/x-font-bdf": ["bdf"], "application/x-font-ghostscript": ["gsf"], "application/x-font-linux-psf": ["psf"], "application/x-font-pcf": ["pcf"], "application/x-font-snf": ["snf"], "application/x-font-type1": ["pfa", "pfb", "pfm", "afm"], "application/x-freearc": ["arc"], "application/x-futuresplash": ["spl"], "application/x-gca-compressed": ["gca"], "application/x-glulx": ["ulx"], "application/x-gnumeric": ["gnumeric"], "application/x-gramps-xml": ["gramps"], "application/x-gtar": ["gtar"], "application/x-hdf": ["hdf"], "application/x-httpd-php": ["php"], "application/x-install-instructions": ["install"], "application/x-iso9660-image": ["*iso"], "application/x-iwork-keynote-sffkey": ["*key"], "application/x-iwork-numbers-sffnumbers": ["*numbers"], "application/x-iwork-pages-sffpages": ["*pages"], "application/x-java-archive-diff": ["jardiff"], "application/x-java-jnlp-file": ["jnlp"], "application/x-keepass2": ["kdbx"], "application/x-latex": ["latex"], "application/x-lua-bytecode": ["luac"], "application/x-lzh-compressed": ["lzh", "lha"], "application/x-makeself": ["run"], "application/x-mie": ["mie"], "application/x-mobipocket-ebook": ["prc", "mobi"], "application/x-ms-application": ["application"], "application/x-ms-shortcut": ["lnk"], "application/x-ms-wmd": ["wmd"], "application/x-ms-wmz": ["wmz"], "application/x-ms-xbap": ["xbap"], "application/x-msaccess": ["mdb"], "application/x-msbinder": ["obd"], "application/x-mscardfile": ["crd"], "application/x-msclip": ["clp"], "application/x-msdos-program": ["*exe"], "application/x-msdownload": ["*exe", "*dll", "com", "bat", "*msi"], "application/x-msmediaview": ["mvb", "m13", "m14"], "application/x-msmetafile": ["*wmf", "*wmz", "*emf", "emz"], "application/x-msmoney": ["mny"], "application/x-mspublisher": ["pub"], "application/x-msschedule": ["scd"], "application/x-msterminal": ["trm"], "application/x-mswrite": ["wri"], "application/x-netcdf": ["nc", "cdf"], "application/x-ns-proxy-autoconfig": ["pac"], "application/x-nzb": ["nzb"], "application/x-perl": ["pl", "pm"], "application/x-pilot": ["*prc", "*pdb"], "application/x-pkcs12": ["p12", "pfx"], "application/x-pkcs7-certificates": ["p7b", "spc"], "application/x-pkcs7-certreqresp": ["p7r"], "application/x-rar-compressed": ["*rar"], "application/x-redhat-package-manager": ["rpm"], "application/x-research-info-systems": ["ris"], "application/x-sea": ["sea"], "application/x-sh": ["sh"], "application/x-shar": ["shar"], "application/x-shockwave-flash": ["swf"], "application/x-silverlight-app": ["xap"], "application/x-sql": ["sql"], "application/x-stuffit": ["sit"], "application/x-stuffitx": ["sitx"], "application/x-subrip": ["srt"], "application/x-sv4cpio": ["sv4cpio"], "application/x-sv4crc": ["sv4crc"], "application/x-t3vm-image": ["t3"], "application/x-tads": ["gam"], "application/x-tar": ["tar"], "application/x-tcl": ["tcl", "tk"], "application/x-tex": ["tex"], "application/x-tex-tfm": ["tfm"], "application/x-texinfo": ["texinfo", "texi"], "application/x-tgif": ["*obj"], "application/x-ustar": ["ustar"], "application/x-virtualbox-hdd": ["hdd"], "application/x-virtualbox-ova": ["ova"], "application/x-virtualbox-ovf": ["ovf"], "application/x-virtualbox-vbox": ["vbox"], "application/x-virtualbox-vbox-extpack": ["vbox-extpack"], "application/x-virtualbox-vdi": ["vdi"], "application/x-virtualbox-vhd": ["vhd"], "application/x-virtualbox-vmdk": ["vmdk"], "application/x-wais-source": ["src"], "application/x-web-app-manifest+json": ["webapp"], "application/x-x509-ca-cert": ["der", "crt", "pem"], "application/x-xfig": ["fig"], "application/x-xliff+xml": ["*xlf"], "application/x-xpinstall": ["xpi"], "application/x-xz": ["xz"], "application/x-zmachine": ["z1", "z2", "z3", "z4", "z5", "z6", "z7", "z8"], "audio/vnd.dece.audio": ["uva", "uvva"], "audio/vnd.digital-winds": ["eol"], "audio/vnd.dra": ["dra"], "audio/vnd.dts": ["dts"], "audio/vnd.dts.hd": ["dtshd"], "audio/vnd.lucent.voice": ["lvp"], "audio/vnd.ms-playready.media.pya": ["pya"], "audio/vnd.nuera.ecelp4800": ["ecelp4800"], "audio/vnd.nuera.ecelp7470": ["ecelp7470"], "audio/vnd.nuera.ecelp9600": ["ecelp9600"], "audio/vnd.rip": ["rip"], "audio/x-aac": ["aac"], "audio/x-aiff": ["aif", "aiff", "aifc"], "audio/x-caf": ["caf"], "audio/x-flac": ["flac"], "audio/x-m4a": ["*m4a"], "audio/x-matroska": ["mka"], "audio/x-mpegurl": ["m3u"], "audio/x-ms-wax": ["wax"], "audio/x-ms-wma": ["wma"], "audio/x-pn-realaudio": ["ram", "ra"], "audio/x-pn-realaudio-plugin": ["rmp"], "audio/x-realaudio": ["*ra"], "audio/x-wav": ["*wav"], "chemical/x-cdx": ["cdx"], "chemical/x-cif": ["cif"], "chemical/x-cmdf": ["cmdf"], "chemical/x-cml": ["cml"], "chemical/x-csml": ["csml"], "chemical/x-xyz": ["xyz"], "image/prs.btif": ["btif"], "image/prs.pti": ["pti"], "image/vnd.adobe.photoshop": ["psd"], "image/vnd.airzip.accelerator.azv": ["azv"], "image/vnd.dece.graphic": ["uvi", "uvvi", "uvg", "uvvg"], "image/vnd.djvu": ["djvu", "djv"], "image/vnd.dvb.subtitle": ["*sub"], "image/vnd.dwg": ["dwg"], "image/vnd.dxf": ["dxf"], "image/vnd.fastbidsheet": ["fbs"], "image/vnd.fpx": ["fpx"], "image/vnd.fst": ["fst"], "image/vnd.fujixerox.edmics-mmr": ["mmr"], "image/vnd.fujixerox.edmics-rlc": ["rlc"], "image/vnd.microsoft.icon": ["ico"], "image/vnd.ms-dds": ["dds"], "image/vnd.ms-modi": ["mdi"], "image/vnd.ms-photo": ["wdp"], "image/vnd.net-fpx": ["npx"], "image/vnd.pco.b16": ["b16"], "image/vnd.tencent.tap": ["tap"], "image/vnd.valve.source.texture": ["vtf"], "image/vnd.wap.wbmp": ["wbmp"], "image/vnd.xiff": ["xif"], "image/vnd.zbrush.pcx": ["pcx"], "image/x-3ds": ["3ds"], "image/x-cmu-raster": ["ras"], "image/x-cmx": ["cmx"], "image/x-freehand": ["fh", "fhc", "fh4", "fh5", "fh7"], "image/x-icon": ["*ico"], "image/x-jng": ["jng"], "image/x-mrsid-image": ["sid"], "image/x-ms-bmp": ["*bmp"], "image/x-pcx": ["*pcx"], "image/x-pict": ["pic", "pct"], "image/x-portable-anymap": ["pnm"], "image/x-portable-bitmap": ["pbm"], "image/x-portable-graymap": ["pgm"], "image/x-portable-pixmap": ["ppm"], "image/x-rgb": ["rgb"], "image/x-tga": ["tga"], "image/x-xbitmap": ["xbm"], "image/x-xpixmap": ["xpm"], "image/x-xwindowdump": ["xwd"], "message/vnd.wfa.wsc": ["wsc"], "model/vnd.collada+xml": ["dae"], "model/vnd.dwf": ["dwf"], "model/vnd.gdl": ["gdl"], "model/vnd.gtw": ["gtw"], "model/vnd.mts": ["mts"], "model/vnd.opengex": ["ogex"], "model/vnd.parasolid.transmit.binary": ["x_b"], "model/vnd.parasolid.transmit.text": ["x_t"], "model/vnd.sap.vds": ["vds"], "model/vnd.usdz+zip": ["usdz"], "model/vnd.valve.source.compiled-map": ["bsp"], "model/vnd.vtu": ["vtu"], "text/prs.lines.tag": ["dsc"], "text/vnd.curl": ["curl"], "text/vnd.curl.dcurl": ["dcurl"], "text/vnd.curl.mcurl": ["mcurl"], "text/vnd.curl.scurl": ["scurl"], "text/vnd.dvb.subtitle": ["sub"], "text/vnd.fly": ["fly"], "text/vnd.fmi.flexstor": ["flx"], "text/vnd.graphviz": ["gv"], "text/vnd.in3d.3dml": ["3dml"], "text/vnd.in3d.spot": ["spot"], "text/vnd.sun.j2me.app-descriptor": ["jad"], "text/vnd.wap.wml": ["wml"], "text/vnd.wap.wmlscript": ["wmls"], "text/x-asm": ["s", "asm"], "text/x-c": ["c", "cc", "cxx", "cpp", "h", "hh", "dic"], "text/x-component": ["htc"], "text/x-fortran": ["f", "for", "f77", "f90"], "text/x-handlebars-template": ["hbs"], "text/x-java-source": ["java"], "text/x-lua": ["lua"], "text/x-markdown": ["mkd"], "text/x-nfo": ["nfo"], "text/x-opml": ["opml"], "text/x-org": ["*org"], "text/x-pascal": ["p", "pas"], "text/x-processing": ["pde"], "text/x-sass": ["sass"], "text/x-scss": ["scss"], "text/x-setext": ["etx"], "text/x-sfv": ["sfv"], "text/x-suse-ymp": ["ymp"], "text/x-uuencode": ["uu"], "text/x-vcalendar": ["vcs"], "text/x-vcard": ["vcf"], "video/vnd.dece.hd": ["uvh", "uvvh"], "video/vnd.dece.mobile": ["uvm", "uvvm"], "video/vnd.dece.pd": ["uvp", "uvvp"], "video/vnd.dece.sd": ["uvs", "uvvs"], "video/vnd.dece.video": ["uvv", "uvvv"], "video/vnd.dvb.file": ["dvb"], "video/vnd.fvt": ["fvt"], "video/vnd.mpegurl": ["mxu", "m4u"], "video/vnd.ms-playready.media.pyv": ["pyv"], "video/vnd.uvvu.mp4": ["uvu", "uvvu"], "video/vnd.vivo": ["viv"], "video/x-f4v": ["f4v"], "video/x-fli": ["fli"], "video/x-flv": ["flv"], "video/x-m4v": ["m4v"], "video/x-matroska": ["mkv", "mk3d", "mks"], "video/x-mng": ["mng"], "video/x-ms-asf": ["asf", "asx"], "video/x-ms-vob": ["vob"], "video/x-ms-wm": ["wm"], "video/x-ms-wmv": ["wmv"], "video/x-ms-wmx": ["wmx"], "video/x-ms-wvx": ["wvx"], "video/x-msvideo": ["avi"], "video/x-sgi-movie": ["movie"], "video/x-smv": ["smv"], "x-conference/x-cooltalk": ["ice"] };
let Ea = ya;
var Ma = new Ea(ka, Da);
const za = /* @__PURE__ */ wa(Ma);
function ja(e) {
  return Object.prototype.toString.call(e).slice(8, -1).toLowerCase();
}
function kt(e) {
  return ja(e) === "object";
}
const Dt = typeof window < "u";
Dt && navigator.userAgent.toLowerCase();
function Ca(e) {
  return e.startsWith("data") && e.includes("base64") ? e.split(",")[0].replace(/data:(.*);base64/, "$1") : za.getType(e) || "";
}
function Et({ type: e, id: o, resource: n }) {
  return new Promise((t, r) => {
    if (!Dt || document.querySelector(o)) {
      r();
      return;
    }
    function a(l) {
      l.addEventListener("load", t), l.addEventListener("error", r), l.addEventListener("abort", r);
    }
    switch (e) {
      case "js": {
        const l = document.createElement("script");
        l.async = !0, l.src = n, a(l), document.head.appendChild(l);
        break;
      }
      case "css": {
        const l = document.createElement("link");
        l.id = o, l.rel = "stylesheet", l.href = n, a(l), document.head.appendChild(l);
        break;
      }
      case "style": {
        const l = document.createElement("style");
        l.id = o, a(l), document.head.appendChild(l), l.appendChild(document.createTextNode(n));
        break;
      }
    }
  });
}
function Aa() {
  return process.env.NODE_ENV;
}
Aa();
function Ri(e) {
  return process.env.NODE_ENV === e;
}
Ri("development");
Ri("test");
Ri("production");
function et({
  mode: e,
  dataURI: o
}) {
  return e === "round" ? "image/png" : Ca(o);
}
function nt(e) {
  const o = document.createElement("canvas"), n = o.getContext("2d");
  if (!n)
    return o;
  const { width: t, height: r } = e;
  return o.width = t, o.height = r, n.imageSmoothingEnabled = !0, n.drawImage(e, 0, 0, t, r), n.globalCompositeOperation = "destination-in", n.beginPath(), n.arc(
    t / 2,
    r / 2,
    Math.min(t, r) / 2,
    0,
    2 * Math.PI,
    !0
  ), n.fill(), o;
}
function ot(e, o = {}) {
  if (!kt(e))
    return o;
  const { mode: n, width: t, height: r } = e;
  switch (n) {
    case "fixedSize":
    case "round": {
      o.width = t, o.height = r;
      break;
    }
  }
  return o;
}
const Ta = {
  /**
   * The source of the image to be cropped
   * @description The value of the `src` attribute of `<img src="" />`
   */
  img: {
    type: String,
    required: !0,
    default: ""
  },
  /**
   * Style Sheet for Crop Box
   */
  boxStyle: {
    type: Object,
    required: !1,
    default: () => ({})
  },
  /**
   * Options for cropperjs
   * @see https://github.com/fengyuanchen/cropperjs#options
   */
  options: {
    type: Object,
    required: !1,
    default: () => ({})
  },
  /**
   * Some preset modes provided by this plugin
   */
  presetMode: {
    type: Object,
    required: !1,
    default: () => ({})
  }
}, Oa = `/*!
 * Cropper.js v1.6.1
 * https://fengyuanchen.github.io/cropperjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2023-09-17T03:44:17.565Z
 */.cropper-container{direction:ltr;font-size:0;line-height:0;position:relative;-ms-touch-action:none;touch-action:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.cropper-container img{backface-visibility:hidden;display:block;height:100%;image-orientation:0deg;max-height:none!important;max-width:none!important;min-height:0!important;min-width:0!important;width:100%}.cropper-wrap-box,.cropper-canvas,.cropper-drag-box,.cropper-crop-box,.cropper-modal{bottom:0;left:0;position:absolute;right:0;top:0}.cropper-wrap-box,.cropper-canvas{overflow:hidden}.cropper-drag-box{background-color:#fff;opacity:0}.cropper-modal{background-color:#000;opacity:.5}.cropper-view-box{display:block;height:100%;outline:1px solid #39f;outline-color:#3399ffbf;overflow:hidden;width:100%}.cropper-dashed{border:0 dashed #eee;display:block;opacity:.5;position:absolute}.cropper-dashed.dashed-h{border-bottom-width:1px;border-top-width:1px;height:calc(100% / 3);left:0;top:calc(100% / 3);width:100%}.cropper-dashed.dashed-v{border-left-width:1px;border-right-width:1px;height:100%;left:calc(100% / 3);top:0;width:calc(100% / 3)}.cropper-center{display:block;height:0;left:50%;opacity:.75;position:absolute;top:50%;width:0}.cropper-center:before,.cropper-center:after{background-color:#eee;content:" ";display:block;position:absolute}.cropper-center:before{height:1px;left:-3px;top:0;width:7px}.cropper-center:after{height:7px;left:0;top:-3px;width:1px}.cropper-face,.cropper-line,.cropper-point{display:block;height:100%;opacity:.1;position:absolute;width:100%}.cropper-face{background-color:#fff;left:0;top:0}.cropper-line{background-color:#39f}.cropper-line.line-e{cursor:ew-resize;right:-3px;top:0;width:5px}.cropper-line.line-n{cursor:ns-resize;height:5px;left:0;top:-3px}.cropper-line.line-w{cursor:ew-resize;left:-3px;top:0;width:5px}.cropper-line.line-s{bottom:-3px;cursor:ns-resize;height:5px;left:0}.cropper-point{background-color:#39f;height:5px;opacity:.75;width:5px}.cropper-point.point-e{cursor:ew-resize;margin-top:-3px;right:-3px;top:50%}.cropper-point.point-n{cursor:ns-resize;left:50%;margin-left:-3px;top:-3px}.cropper-point.point-w{cursor:ew-resize;left:-3px;margin-top:-3px;top:50%}.cropper-point.point-s{bottom:-3px;cursor:s-resize;left:50%;margin-left:-3px}.cropper-point.point-ne{cursor:nesw-resize;right:-3px;top:-3px}.cropper-point.point-nw{cursor:nwse-resize;left:-3px;top:-3px}.cropper-point.point-sw{bottom:-3px;cursor:nesw-resize;left:-3px}.cropper-point.point-se{bottom:-3px;cursor:nwse-resize;height:20px;opacity:1;right:-3px;width:20px}@media (min-width: 768px){.cropper-point.point-se{height:15px;width:15px}}@media (min-width: 992px){.cropper-point.point-se{height:10px;width:10px}}@media (min-width: 1200px){.cropper-point.point-se{height:5px;opacity:.75;width:5px}}.cropper-point.point-se:before{background-color:#39f;bottom:-50%;content:" ";display:block;height:200%;opacity:0;position:absolute;right:-50%;width:200%}.cropper-invisible{opacity:0}.cropper-bg{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC)}.cropper-hide{display:block;height:0;position:absolute;width:0}.cropper-hidden{display:none!important}.cropper-move{cursor:move}.cropper-crop{cursor:crosshair}.cropper-disabled .cropper-drag-box,.cropper-disabled .cropper-face,.cropper-disabled .cropper-line,.cropper-disabled .cropper-point{cursor:not-allowed}
`, Na = `.vue--picture-cropper__wrap{width:100%;height:100%;margin:0}.vue--picture-cropper__img{display:block;width:auto;height:auto;max-width:100%;max-height:100%}.vue--picture-cropper__wrap-round .cropper-view-box,.vue--picture-cropper__wrap-round .cropper-face{border-radius:50%}
`;
Et({
  type: "style",
  id: "cropperjs",
  resource: Oa
}).catch((e) => {
  console.log(e);
});
Et({
  type: "style",
  id: "vue-picture-cropper",
  resource: Na
}).catch((e) => {
  console.log(e);
});
let S;
const Ra = /* @__PURE__ */ defineComponent({
  name: "VuePictureCropper",
  props: Ta,
  setup(e) {
    const o = ref(), n = ref("");
    async function t() {
      await nextTick();
      const d = window.setInterval(() => {
        if (o.value)
          try {
            S = new yt(o.value, e.options), window.clearInterval(d), a(), n.value = et({
              mode: e.presetMode.mode,
              dataURI: e.img
            }), o.value.addEventListener("ready", () => {
              r();
            });
          } catch (p) {
            console.log(p);
          }
      }, 10);
    }
    function r() {
      if (!kt(e.presetMode))
        return;
      const {
        mode: d,
        width: p,
        height: f
      } = e.presetMode;
      switch (d) {
        case "fixedSize":
        case "round": {
          S.setCropBoxData({
            width: p,
            height: f
          });
          break;
        }
      }
    }
    function a() {
      S.getDataURL = l, S.getBlob = s, S.getFile = c;
    }
    function l(d = {}) {
      d = ot(e.presetMode, d);
      try {
        let p = S.getCroppedCanvas(d);
        return e.presetMode.mode === "round" && (p = nt(p)), p.toDataURL(n.value);
      } catch {
        return "";
      }
    }
    async function s(d = {}) {
      return d = ot(e.presetMode, d), new Promise((p) => {
        try {
          let f = S.getCroppedCanvas(d);
          e.presetMode.mode === "round" && (f = nt(f)), f.toBlob((g) => {
            p(g);
          }, n.value);
        } catch {
          p(null);
        }
      });
    }
    async function c(d = {}) {
      const {
        fileName: p
      } = d, f = n.value.replace(/image\//, ""), g = p ? `${p}.${f}` : `cropped-${Date.now()}.${f}`, b = await s(d);
      return b ? new File([b], g, {
        type: n.value
      }) : null;
    }
    return watch(() => e.img, async () => {
      if (!S) {
        await t();
        return;
      }
      try {
        S.replace(e.img), n.value = et({
          mode: e.presetMode.mode,
          dataURI: e.img
        }), a();
      } catch (d) {
        console.log(d);
      }
    }, {
      immediate: !0
    }), onBeforeUnmount(() => {
      S && (S.destroy(), S = null);
    }), () => createVNode("div", {
      class: `vue--picture-cropper__wrap ${e.presetMode.mode === "round" ? "vue--picture-cropper__wrap-round" : ""}`,
      style: e.boxStyle
    }, [createVNode("img", {
      ref: o,
      class: "vue--picture-cropper__img",
      src: e.img
    }, null)]);
  }
}), _sfc_main$p = /* @__PURE__ */ defineComponent({
  __name: "picture-cropper",
  props: {
    imgSrc: {},
    shape: { default: "fixedSize" },
    aspectRatio: { default: 16 / 9 },
    suggestSize: { default: "" },
    resizable: { type: Boolean, default: !0 },
    onChange: {},
    onReset: {},
    onConfirm: {}
  },
  emits: ["change", "reset", "confirm"],
  setup(e, { expose: o, emit: n }) {
    const t = e, r = n, { close: a } = useDialogState(), l = shallowRef(null), s = ref(), c = ref(), d = computed(() => {
      var P;
      if (t.shape === "round")
        return "140px";
      const [m = 1, ee = 1] = t.suggestSize.split("/").map(Number);
      return `${(((P = l.value) == null ? void 0 : P.getBoundingClientRect().width) || m) / m * ee}px`;
    }), p = computed(() => t.shape === "round" ? 1 : t.aspectRatio);
    watch(
      () => t.imgSrc,
      (m) => {
        typeof m == "string" ? s.value = m : m instanceof Blob ? s.value = URL.createObjectURL(m) : warn$2(
          "alc-picture-cropper",
          `不支持的 imgSrc 类型 “${Object.prototype.toString.call(t.imgSrc).slice(8, -1)}”`
        );
      },
      { immediate: !0 }
    ), onUnmounted(() => {
      typeof t.imgSrc != "string" && s.value && URL.revokeObjectURL(s.value);
    });
    const f = () => {
      S == null || S.reset(), setTimeout(() => {
        x(), r("reset", c.value);
      }, 100);
    }, g = () => S == null ? void 0 : S.getDataURL({ imageSmoothingQuality: "high" }), b = () => S == null ? void 0 : S.getBlob({ imageSmoothingQuality: "high" }), k = () => S == null ? void 0 : S.getFile({ imageSmoothingQuality: "high" }), x = () => {
      c.value = g(), r("change", c.value);
    }, N = () => {
      a(), r("confirm", {
        url: g(),
        blob: b(),
        file: k()
      });
    };
    o({
      cropper: S,
      getImgUrl: g,
      getImgBlob: b,
      getImgFile: k,
      reset: f
    });
    const O = { props: t, emits: r, close: a, viewDiv: l, img: s, resImg: c, zoomHeight: d, proxyAspectRatio: p, reset: f, getImgUrl: g, getImgBlob: b, getImgFile: k, onCrop: x, confirm: N, get AlcDialogFooter() {
      return AlcDialogFooter;
    }, get ElButton() {
      return ElButton;
    }, get VuePictureCropper() {
      return Ra;
    } };
    return Object.defineProperty(O, "__isScriptSetup", { enumerable: !1, value: !0 }), O;
  }
}), _hoisted_1$m = { class: "alc-component-picture-cropper" }, _hoisted_2$j = { class: "cropper-preview" }, _hoisted_3$g = /* @__PURE__ */ createElementVNode("span", null, "图片预览", -1), _hoisted_4$c = ["src"], _hoisted_5$a = { key: 0 };
function _sfc_render$p(e, o, n, t, r, a) {
  return openBlock(), createElementBlock(Fragment, null, [
    createElementVNode("div", _hoisted_1$m, [
      createVNode(t.VuePictureCropper, mergeProps(e.$attrs, {
        img: t.img,
        "box-style": {
          width: "66%"
        },
        options: {
          viewMode: 1,
          dragMode: "move",
          aspectRatio: t.proxyAspectRatio,
          cropBoxResizable: n.resizable
        },
        "preset-mode": {
          mode: n.shape
        },
        onReady: t.onCrop,
        onZoom: t.onCrop,
        onCropend: t.onCrop
      }), null, 16, ["img", "options", "preset-mode"]),
      createElementVNode("div", _hoisted_2$j, [
        _hoisted_3$g,
        withDirectives(createElementVNode("div", {
          ref: "viewDiv",
          style: normalizeStyle({
            width: n.shape === "fixedSize" ? "100%" : t.zoomHeight,
            height: t.zoomHeight,
            alignSelf: "center",
            ...n.shape === "round" ? {
              borderRadius: "50%",
              boxShadow: "0px 0px 16px -2px #666"
            } : {}
          })
        }, [
          createElementVNode("img", {
            src: t.resImg,
            alt: "裁切后的图片",
            style: { width: "100%", height: "100%", "object-fit": "contain", "-webkit-user-drag": "none" }
          }, null, 8, _hoisted_4$c)
        ], 4), [
          [vShow, t.resImg]
        ]),
        createElementVNode("div", null, [
          n.suggestSize ? (openBlock(), createElementBlock("span", _hoisted_5$a, [
            createTextVNode(" 建议尺寸为 "),
            createElementVNode("b", null, toDisplayString$1(n.suggestSize), 1)
          ])) : createCommentVNode("", !0)
        ])
      ])
    ]),
    createVNode(t.AlcDialogFooter, null, {
      default: withCtx(() => [
        createVNode(t.ElButton, { onClick: t.reset }, {
          default: withCtx(() => [
            createTextVNode("重置")
          ]),
          _: 1
        }),
        createVNode(t.ElButton, {
          type: "primary",
          onClick: t.confirm
        }, {
          default: withCtx(() => [
            createTextVNode("确定")
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64);
}
const AlcPictureCropper = /* @__PURE__ */ _export_sfc(_sfc_main$p, [["render", _sfc_render$p], ["__file", "picture-cropper.vue"]]), _sfc_main$o = /* @__PURE__ */ defineComponent({
  name: "alc-wx-msg-template",
  __name: "wx-msg-template",
  props: {
    paramsCode: {},
    system: { type: Boolean }
  },
  setup(e, { expose: o }) {
    o();
    const n = e, t = useProviderConfig("state"), r = computed(() => n.system ? "public" : t.value.cOrgUuid), a = shallowRef([]), l = shallowRef(), s = shallowRef([]);
    Promise.all([
      n.system ? k() : b(),
      x(),
      O()
    ]).then(([M, $, H]) => {
      a.value = M.map((X) => ({
        ...X,
        content: X.content.replaceAll(".DATA", "")
      })), s.value = $, H && (g(H.cTemplateId), l.value && setTimeout(() => {
        Object.entries(c[l.value.templateId]).forEach(
          ([X, te]) => {
            te.innerHTML = H.templateDataMap[X].replace(
              /ALD{[^}]+}/gi,
              (oe) => {
                var se, pe;
                const ne = oe.replace(/ALD{|}/gi, ""), ie = (pe = (se = s.value) == null ? void 0 : se.find(
                  (he) => he.cField === ne
                )) == null ? void 0 : pe.cFieldName;
                return ie ? P(ie) : oe;
              }
            );
          }
        ), ElMessage.success("已自动帮您定位到上次编辑的模板");
      }));
    });
    let c = {}, d, p;
    onDialogConfirm(async () => {
      const M = Object.entries(
        c[l.value.templateId]
      ).reduce(
        (H, [X, te]) => (H[X] = [...te.childNodes].reduce((oe, ne) => {
          var ie;
          if (ne.nodeType === Node.TEXT_NODE)
            return oe + ne.textContent;
          if (ne.nodeType === Node.ELEMENT_NODE && ne instanceof HTMLInputElement) {
            const se = (ie = s.value) == null ? void 0 : ie.find((pe) => pe.cFieldName === ne.value);
            if (se)
              return `${oe}ALD{${se.cField}}`;
          }
          return oe;
        }, ""), H),
        {}
      );
      return await N(M) || Object.assign(
        {
          templateDataMap: M
        },
        l.value
      );
    });
    function f() {
      const M = window.getSelection();
      M && M.rangeCount && (p = M.getRangeAt(0));
    }
    function g(M) {
      l.value = a.value.find(($) => $.templateId === M);
    }
    function b() {
      return msGet(
        `alc-public-message/WechatAction/getTemplateListByOrg/${r.value}`
      ).then((M) => M.code === 1 ? M.data : (operatorErrorTip(M.msg), [])).catch(() => (apiLinkErrorTip("微信消息模板"), []));
    }
    function k() {
      return msGet(
        "alc-public-message/WechatAction/getTemplateListSystem"
      ).then((M) => M.code === 1 ? M.data : (operatorErrorTip(M.msg), [])).catch(() => (apiLinkErrorTip("微信消息模板"), []));
    }
    function x() {
      return msGet(
        `alc-public-message/BusinessFieldTypeAction/getBusinessField/${n.paramsCode}`
      ).then((M) => M.code === 1 ? M.data.fieldList : (operatorErrorTip(M.msg), [])).catch(() => (apiLinkErrorTip("微信消息模板参数"), []));
    }
    function N(M) {
      return msPost(
        "alc-public-message/WechatTemplateConfigAction/saveTemplateConfig",
        {
          templateDataMap: M,
          cBusinessId: n.paramsCode,
          cTemplateId: l.value.templateId,
          cOrgUuid: r.value,
          cAccUuid: n.system ? "public" : t.value.cOrgUuid
        }
      ).then(($) => $.code === 1 ? !0 : (operatorErrorTip($.msg), !1)).catch(() => (apiLinkErrorTip("微信消息模板配置"), !1));
    }
    function O() {
      return msGet(
        `alc-public-message/WechatTemplateConfigAction/getTemplateConfigByBusinessId/${n.paramsCode}/${r.value}`
      ).then((M) => {
        if (M.code === 1)
          return M.data;
        operatorErrorTip(M.msg);
      }).catch(() => {
        apiLinkErrorTip("微信消息模板配置");
      });
    }
    function m() {
      c[l.value.templateId][d].focus();
      const M = window.getSelection();
      return M == null || M.selectAllChildren(
        c[l.value.templateId][d]
      ), M == null || M.collapseToEnd(), M;
    }
    function ee(M) {
      return M.primaryIndustry ? `${M.primaryIndustry}${M.deputyIndustry ? "/" : ""}${M.deputyIndustry}` : "";
    }
    function z(M) {
      if (!l.value)
        return operatorErrorTip("请先选择模板");
      V(P(M.cFieldName));
    }
    function P(M) {
      return `&nbsp;<input value="${M}" type="button" class="ElTag ElTag--light ElTag--small">&nbsp;`;
    }
    function V(M) {
      var X;
      let $;
      const H = window.getSelection();
      if (H) {
        p && (H.removeAllRanges(), H.addRange(p), $ = H.getRangeAt(0)), $ || ($ = (X = m()) == null ? void 0 : X.getRangeAt(0));
        const te = $.createContextualFragment(M), oe = te.lastChild;
        $.insertNode(te), oe && ($ = $.cloneRange(), $.setStartAfter(oe), $.collapse(!0), H.removeAllRanges(), H.addRange($), p = $);
      }
    }
    function U(M) {
      if (M.code === "Enter" && M.preventDefault(), M.code === "Backspace") {
        const $ = window.getSelection();
        if ($ && $.rangeCount) {
          const H = $.getRangeAt(0);
          if (H.startOffset === 0) {
            const X = H.startContainer.previousSibling;
            X instanceof HTMLInputElement && X.type === "button" && X.remove();
          }
        }
      }
    }
    function E(M) {
      var H;
      M.preventDefault();
      let $ = ((H = M.clipboardData) == null ? void 0 : H.getData("text/plain")) || "";
      $ = $.replace(/\s/g, " "), document.execCommand("insertText", !1, $);
    }
    const C = ({
      templateId: M,
      paramsName: $,
      typeName: H,
      explain: X
    }) => /* @__PURE__ */ React.createElement("div", { class: "params-wrap" }, /* @__PURE__ */ React.createElement(ElTag, { type: "info", size: "small", class: "params-type" }, H, /* @__PURE__ */ React.createElement(AlcTooltip, { content: X, "show-after": 300 })), /* @__PURE__ */ React.createElement(
      "span",
      {
        ref: (te) => {
          te && (c[M] || (c[M] = {}), c[M][$] = te);
        },
        class: "edit-context",
        contenteditable: "true",
        onKeydown: U,
        onClick: (te) => {
          var ne;
          d = $;
          const oe = te.currentTarget;
          if (oe.childNodes.length === 1 && ((ne = oe.firstChild) == null ? void 0 : ne.nodeType) !== Node.TEXT_NODE && m(), te.target instanceof HTMLInputElement) {
            const ie = window.getSelection();
            if (ie) {
              const se = ie.getRangeAt(0);
              se.setStartAfter(te.target), se.collapse(!0), ie.removeAllRanges(), ie.addRange(se);
            }
          }
          f();
        },
        onKeyup: () => {
          d = $, f();
        },
        onPaste: E
      }
    ), /* @__PURE__ */ React.createElement(
      "i",
      {
        class: "ri-close-circle-line content-clean",
        onClick: () => {
          c[M][$].innerHTML = "";
        }
      }
    )), v = { props: n, store: t, orgUuid: r, tempList: a, currentTemp: l, paramsList: s, get spanRef() {
      return c;
    }, set spanRef(M) {
      c = M;
    }, get currentParamName() {
      return d;
    }, set currentParamName(M) {
      d = M;
    }, get savedRange() {
      return p;
    }, set savedRange(M) {
      p = M;
    }, upSelection: f, setCurrentTemp: g, getAccMsgTemp: b, getSystemMsgTemp: k, getParams: x, saveTemplateConfig: N, getTemplateConfig: O, keepCursorEnd: m, getIndustry: ee, onAddItem: z, getInputHtml: P, pasteHtmlAtCaret: V, onKeydown: U, onPaste: E, ParamsEditContext: C, ParamsEditor: (M) => M.currentTemp.content.split(`
`).flatMap(($) => /* @__PURE__ */ React.createElement("div", { style: "height: 28px; display: flex; flex-flow: row wrap" }, $.split(/{{|}}/).reduce(
      (H, X, te) => (te % 2 === 0 ? H.push([X]) : X && H.at(-1).push(X), H),
      []
    ).map(([H, X]) => {
      const te = M.currentTemp.paramList.find(
        (oe) => oe.key === X
      );
      return /* @__PURE__ */ React.createElement("div", { style: "display: inline-flex" }, /* @__PURE__ */ React.createElement("span", { style: "white-space: nowrap" }, H), te ? /* @__PURE__ */ React.createElement(
        C,
        {
          templateId: M.currentTemp.templateId,
          paramsName: X,
          typeName: te.typeName,
          explain: te.explain
        }
      ) : void 0);
    }))), get ElTabPane() {
      return ElTabPane;
    }, get ElTabs() {
      return ElTabs;
    }, get ElTag() {
      return ElTag;
    }, get AlcSplitView() {
      return AlcSplitView;
    } };
    return Object.defineProperty(v, "__isScriptSetup", { enumerable: !1, value: !0 }), v;
  }
}), _hoisted_1$l = { class: "auto-height--wrap h100 alc-components-wx-msg-temp" }, _hoisted_2$i = { class: "params-list" }, _hoisted_3$f = { class: "msg-temp--item" }, _hoisted_4$b = { class: "temp-item--label" }, _hoisted_5$9 = ["title"], _hoisted_6$8 = { class: "temp-content example" }, _hoisted_7$8 = { class: "temp-content" };
function _sfc_render$o(e, o, n, t, r, a) {
  var l;
  return openBlock(), createElementBlock("div", _hoisted_1$l, [
    createElementVNode("div", _hoisted_2$i, [
      createTextVNode(" 可选参数 "),
      (openBlock(!0), createElementBlock(Fragment, null, renderList(t.paramsList, (s) => (openBlock(), createBlock(t.ElTag, {
        key: s.cField,
        onClick: (c) => t.onAddItem(s)
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString$1(s.cFieldName), 1)
        ]),
        _: 2
      }, 1032, ["onClick"]))), 128))
    ]),
    createVNode(t.ElTabs, {
      "model-value": (l = t.currentTemp) == null ? void 0 : l.templateId,
      "onUpdate:modelValue": t.setCurrentTemp,
      "tab-position": "left",
      class: "auto-height--target"
    }, {
      default: withCtx(() => [
        (openBlock(!0), createElementBlock(Fragment, null, renderList(t.tempList, (s) => (openBlock(), createBlock(t.ElTabPane, {
          key: s.templateId,
          name: s.templateId,
          lazy: ""
        }, {
          label: withCtx(() => [
            createElementVNode("div", _hoisted_3$f, [
              createElementVNode("span", _hoisted_4$b, toDisplayString$1(s.title), 1),
              s.primaryIndustry ? (openBlock(), createElementBlock("i", {
                key: 0,
                title: t.getIndustry(s),
                class: "temp-item--industry single-line-overflow"
              }, toDisplayString$1(t.getIndustry(s)), 9, _hoisted_5$9)) : createCommentVNode("", !0)
            ])
          ]),
          default: withCtx(() => [
            createVNode(t.AlcSplitView, {
              class: "auto-height--target",
              horizontal: !1,
              "first-init": "300px",
              "first-wrap": "",
              "last-wrap": "",
              reverse: ""
            }, {
              first: withCtx(() => [
                createElementVNode("div", _hoisted_6$8, toDisplayString$1(s.example), 1)
              ]),
              last: withCtx(() => [
                createElementVNode("div", _hoisted_7$8, [
                  createVNode(t.ParamsEditor, mergeProps({ ref_for: !0 }, { currentTemp: s }), null, 16)
                ])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["name"]))), 128))
      ]),
      _: 1
    }, 8, ["model-value"])
  ]);
}
const AlcWxMsgTemplate = /* @__PURE__ */ _export_sfc(_sfc_main$o, [["render", _sfc_render$o], ["__file", "wx-msg-template.vue"]]);
function tryOnScopeDispose(e) {
  return getCurrentScope() ? (onScopeDispose(e), !0) : !1;
}
function toValue(e) {
  return typeof e == "function" ? e() : unref(e);
}
const isClient = typeof window < "u" && typeof document < "u", isDef$1 = (e) => typeof e < "u", toString = Object.prototype.toString, isObject = (e) => toString.call(e) === "[object Object]", noop$2 = () => {
};
function createFilterWrapper(e, o) {
  function n(...t) {
    return new Promise((r, a) => {
      Promise.resolve(e(() => o.apply(this, t), { fn: o, thisArg: this, args: t })).then(r).catch(a);
    });
  }
  return n;
}
const bypassFilter = (e) => e();
function pausableFilter(e = bypassFilter) {
  const o = ref(!0);
  function n() {
    o.value = !1;
  }
  function t() {
    o.value = !0;
  }
  const r = (...a) => {
    o.value && e(...a);
  };
  return { isActive: readonly(o), pause: n, resume: t, eventFilter: r };
}
function promiseTimeout(e, o = !1, n = "Timeout") {
  return new Promise((t, r) => {
    setTimeout(o ? () => r(n) : t, e);
  });
}
function watchWithFilter(e, o, n = {}) {
  const {
    eventFilter: t = bypassFilter,
    ...r
  } = n;
  return watch(
    e,
    createFilterWrapper(
      t,
      o
    ),
    r
  );
}
function watchPausable(e, o, n = {}) {
  const {
    eventFilter: t,
    ...r
  } = n, { eventFilter: a, pause: l, resume: s, isActive: c } = pausableFilter(t);
  return { stop: watchWithFilter(
    e,
    o,
    {
      ...r,
      eventFilter: a
    }
  ), pause: l, resume: s, isActive: c };
}
function toRefs(e, o = {}) {
  if (!isRef(e))
    return toRefs$1(e);
  const n = Array.isArray(e.value) ? Array.from({ length: e.value.length }) : {};
  for (const t in e.value)
    n[t] = customRef(() => ({
      get() {
        return e.value[t];
      },
      set(r) {
        var a;
        if ((a = toValue(o.replaceRef)) != null ? a : !0)
          if (Array.isArray(e.value)) {
            const s = [...e.value];
            s[t] = r, e.value = s;
          } else {
            const s = { ...e.value, [t]: r };
            Object.setPrototypeOf(s, Object.getPrototypeOf(e.value)), e.value = s;
          }
        else
          e.value[t] = r;
      }
    }));
  return n;
}
function createUntil(e, o = !1) {
  function n(f, { flush: g = "sync", deep: b = !1, timeout: k, throwOnTimeout: x } = {}) {
    let N = null;
    const m = [new Promise((ee) => {
      N = watch(
        e,
        (z) => {
          f(z) !== o && (N == null || N(), ee(z));
        },
        {
          flush: g,
          deep: b,
          immediate: !0
        }
      );
    })];
    return k != null && m.push(
      promiseTimeout(k, x).then(() => toValue(e)).finally(() => N == null ? void 0 : N())
    ), Promise.race(m);
  }
  function t(f, g) {
    if (!isRef(f))
      return n((z) => z === f, g);
    const { flush: b = "sync", deep: k = !1, timeout: x, throwOnTimeout: N } = g ?? {};
    let O = null;
    const ee = [new Promise((z) => {
      O = watch(
        [e, f],
        ([P, V]) => {
          o !== (P === V) && (O == null || O(), z(P));
        },
        {
          flush: b,
          deep: k,
          immediate: !0
        }
      );
    })];
    return x != null && ee.push(
      promiseTimeout(x, N).then(() => toValue(e)).finally(() => (O == null || O(), toValue(e)))
    ), Promise.race(ee);
  }
  function r(f) {
    return n((g) => !!g, f);
  }
  function a(f) {
    return t(null, f);
  }
  function l(f) {
    return t(void 0, f);
  }
  function s(f) {
    return n(Number.isNaN, f);
  }
  function c(f, g) {
    return n((b) => {
      const k = Array.from(b);
      return k.includes(f) || k.includes(toValue(f));
    }, g);
  }
  function d(f) {
    return p(1, f);
  }
  function p(f = 1, g) {
    let b = -1;
    return n(() => (b += 1, b >= f), g);
  }
  return Array.isArray(toValue(e)) ? {
    toMatch: n,
    toContains: c,
    changed: d,
    changedTimes: p,
    get not() {
      return createUntil(e, !o);
    }
  } : {
    toMatch: n,
    toBe: t,
    toBeTruthy: r,
    toBeNull: a,
    toBeNaN: s,
    toBeUndefined: l,
    changed: d,
    changedTimes: p,
    get not() {
      return createUntil(e, !o);
    }
  };
}
function until(e) {
  return createUntil(e);
}
function unrefElement(e) {
  var o;
  const n = toValue(e);
  return (o = n == null ? void 0 : n.$el) != null ? o : n;
}
const defaultWindow = isClient ? window : void 0;
function useEventListener(...e) {
  let o, n, t, r;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([n, t, r] = e, o = defaultWindow) : [o, n, t, r] = e, !o)
    return noop$2;
  Array.isArray(n) || (n = [n]), Array.isArray(t) || (t = [t]);
  const a = [], l = () => {
    a.forEach((p) => p()), a.length = 0;
  }, s = (p, f, g, b) => (p.addEventListener(f, g, b), () => p.removeEventListener(f, g, b)), c = watch(
    () => [unrefElement(o), toValue(r)],
    ([p, f]) => {
      if (l(), !p)
        return;
      const g = isObject(f) ? { ...f } : f;
      a.push(
        ...n.flatMap((b) => t.map((k) => s(p, b, k, g)))
      );
    },
    { immediate: !0, flush: "post" }
  ), d = () => {
    c(), l();
  };
  return tryOnScopeDispose(d), d;
}
function createKeyPredicate$1(e) {
  return typeof e == "function" ? e : typeof e == "string" ? (o) => o.key === e : Array.isArray(e) ? (o) => e.includes(o.key) : () => !0;
}
function onKeyStroke(...e) {
  let o, n, t = {};
  e.length === 3 ? (o = e[0], n = e[1], t = e[2]) : e.length === 2 ? typeof e[1] == "object" ? (o = !0, n = e[0], t = e[1]) : (o = e[0], n = e[1]) : (o = !0, n = e[0]);
  const {
    target: r = defaultWindow,
    eventName: a = "keydown",
    passive: l = !1,
    dedupe: s = !1
  } = t, c = createKeyPredicate$1(o);
  return useEventListener(r, a, (p) => {
    p.repeat && toValue(s) || c(p) && n(p);
  }, l);
}
function cloneFnJSON(e) {
  return JSON.parse(JSON.stringify(e));
}
function useVModel(e, o, n, t = {}) {
  var r, a, l;
  const {
    clone: s = !1,
    passive: c = !1,
    eventName: d,
    deep: p = !1,
    defaultValue: f,
    shouldEmit: g
  } = t, b = getCurrentInstance(), k = n || (b == null ? void 0 : b.emit) || ((r = b == null ? void 0 : b.$emit) == null ? void 0 : r.bind(b)) || ((l = (a = b == null ? void 0 : b.proxy) == null ? void 0 : a.$emit) == null ? void 0 : l.bind(b == null ? void 0 : b.proxy));
  let x = d;
  o || (o = "modelValue"), x = x || `update:${o.toString()}`;
  const N = (ee) => s ? typeof s == "function" ? s(ee) : cloneFnJSON(ee) : ee, O = () => isDef$1(e[o]) ? N(e[o]) : f, m = (ee) => {
    g ? g(ee) && k(x, ee) : k(x, ee);
  };
  if (c) {
    const ee = O(), z = ref(ee);
    let P = !1;
    return watch(
      () => e[o],
      (V) => {
        P || (P = !0, z.value = N(V), nextTick(() => P = !1));
      }
    ), watch(
      z,
      (V) => {
        !P && (V !== e[o] || p) && m(V);
      },
      { deep: p }
    ), z;
  } else
    return computed({
      get() {
        return O();
      },
      set(ee) {
        m(ee);
      }
    });
}
var noop$1 = { value: () => {
} };
function dispatch() {
  for (var e = 0, o = arguments.length, n = {}, t; e < o; ++e) {
    if (!(t = arguments[e] + "") || t in n || /[\s.]/.test(t))
      throw new Error("illegal type: " + t);
    n[t] = [];
  }
  return new Dispatch(n);
}
function Dispatch(e) {
  this._ = e;
}
function parseTypenames$1(e, o) {
  return e.trim().split(/^|\s+/).map(function(n) {
    var t = "", r = n.indexOf(".");
    if (r >= 0 && (t = n.slice(r + 1), n = n.slice(0, r)), n && !o.hasOwnProperty(n))
      throw new Error("unknown type: " + n);
    return { type: n, name: t };
  });
}
Dispatch.prototype = dispatch.prototype = {
  constructor: Dispatch,
  on: function(e, o) {
    var n = this._, t = parseTypenames$1(e + "", n), r, a = -1, l = t.length;
    if (arguments.length < 2) {
      for (; ++a < l; )
        if ((r = (e = t[a]).type) && (r = get$1(n[r], e.name)))
          return r;
      return;
    }
    if (o != null && typeof o != "function")
      throw new Error("invalid callback: " + o);
    for (; ++a < l; )
      if (r = (e = t[a]).type)
        n[r] = set$1(n[r], e.name, o);
      else if (o == null)
        for (r in n)
          n[r] = set$1(n[r], e.name, null);
    return this;
  },
  copy: function() {
    var e = {}, o = this._;
    for (var n in o)
      e[n] = o[n].slice();
    return new Dispatch(e);
  },
  call: function(e, o) {
    if ((r = arguments.length - 2) > 0)
      for (var n = new Array(r), t = 0, r, a; t < r; ++t)
        n[t] = arguments[t + 2];
    if (!this._.hasOwnProperty(e))
      throw new Error("unknown type: " + e);
    for (a = this._[e], t = 0, r = a.length; t < r; ++t)
      a[t].value.apply(o, n);
  },
  apply: function(e, o, n) {
    if (!this._.hasOwnProperty(e))
      throw new Error("unknown type: " + e);
    for (var t = this._[e], r = 0, a = t.length; r < a; ++r)
      t[r].value.apply(o, n);
  }
};
function get$1(e, o) {
  for (var n = 0, t = e.length, r; n < t; ++n)
    if ((r = e[n]).name === o)
      return r.value;
}
function set$1(e, o, n) {
  for (var t = 0, r = e.length; t < r; ++t)
    if (e[t].name === o) {
      e[t] = noop$1, e = e.slice(0, t).concat(e.slice(t + 1));
      break;
    }
  return n != null && e.push({ name: o, value: n }), e;
}
var xhtml = "http://www.w3.org/1999/xhtml";
const namespaces = {
  svg: "http://www.w3.org/2000/svg",
  xhtml,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};
function namespace(e) {
  var o = e += "", n = o.indexOf(":");
  return n >= 0 && (o = e.slice(0, n)) !== "xmlns" && (e = e.slice(n + 1)), namespaces.hasOwnProperty(o) ? { space: namespaces[o], local: e } : e;
}
function creatorInherit(e) {
  return function() {
    var o = this.ownerDocument, n = this.namespaceURI;
    return n === xhtml && o.documentElement.namespaceURI === xhtml ? o.createElement(e) : o.createElementNS(n, e);
  };
}
function creatorFixed(e) {
  return function() {
    return this.ownerDocument.createElementNS(e.space, e.local);
  };
}
function creator(e) {
  var o = namespace(e);
  return (o.local ? creatorFixed : creatorInherit)(o);
}
function none() {
}
function selector(e) {
  return e == null ? none : function() {
    return this.querySelector(e);
  };
}
function selection_select(e) {
  typeof e != "function" && (e = selector(e));
  for (var o = this._groups, n = o.length, t = new Array(n), r = 0; r < n; ++r)
    for (var a = o[r], l = a.length, s = t[r] = new Array(l), c, d, p = 0; p < l; ++p)
      (c = a[p]) && (d = e.call(c, c.__data__, p, a)) && ("__data__" in c && (d.__data__ = c.__data__), s[p] = d);
  return new Selection$1(t, this._parents);
}
function array(e) {
  return e == null ? [] : Array.isArray(e) ? e : Array.from(e);
}
function empty() {
  return [];
}
function selectorAll(e) {
  return e == null ? empty : function() {
    return this.querySelectorAll(e);
  };
}
function arrayAll(e) {
  return function() {
    return array(e.apply(this, arguments));
  };
}
function selection_selectAll(e) {
  typeof e == "function" ? e = arrayAll(e) : e = selectorAll(e);
  for (var o = this._groups, n = o.length, t = [], r = [], a = 0; a < n; ++a)
    for (var l = o[a], s = l.length, c, d = 0; d < s; ++d)
      (c = l[d]) && (t.push(e.call(c, c.__data__, d, l)), r.push(c));
  return new Selection$1(t, r);
}
function matcher(e) {
  return function() {
    return this.matches(e);
  };
}
function childMatcher(e) {
  return function(o) {
    return o.matches(e);
  };
}
var find = Array.prototype.find;
function childFind(e) {
  return function() {
    return find.call(this.children, e);
  };
}
function childFirst() {
  return this.firstElementChild;
}
function selection_selectChild(e) {
  return this.select(e == null ? childFirst : childFind(typeof e == "function" ? e : childMatcher(e)));
}
var filter = Array.prototype.filter;
function children() {
  return Array.from(this.children);
}
function childrenFilter(e) {
  return function() {
    return filter.call(this.children, e);
  };
}
function selection_selectChildren(e) {
  return this.selectAll(e == null ? children : childrenFilter(typeof e == "function" ? e : childMatcher(e)));
}
function selection_filter(e) {
  typeof e != "function" && (e = matcher(e));
  for (var o = this._groups, n = o.length, t = new Array(n), r = 0; r < n; ++r)
    for (var a = o[r], l = a.length, s = t[r] = [], c, d = 0; d < l; ++d)
      (c = a[d]) && e.call(c, c.__data__, d, a) && s.push(c);
  return new Selection$1(t, this._parents);
}
function sparse(e) {
  return new Array(e.length);
}
function selection_enter() {
  return new Selection$1(this._enter || this._groups.map(sparse), this._parents);
}
function EnterNode(e, o) {
  this.ownerDocument = e.ownerDocument, this.namespaceURI = e.namespaceURI, this._next = null, this._parent = e, this.__data__ = o;
}
EnterNode.prototype = {
  constructor: EnterNode,
  appendChild: function(e) {
    return this._parent.insertBefore(e, this._next);
  },
  insertBefore: function(e, o) {
    return this._parent.insertBefore(e, o);
  },
  querySelector: function(e) {
    return this._parent.querySelector(e);
  },
  querySelectorAll: function(e) {
    return this._parent.querySelectorAll(e);
  }
};
function constant$3(e) {
  return function() {
    return e;
  };
}
function bindIndex(e, o, n, t, r, a) {
  for (var l = 0, s, c = o.length, d = a.length; l < d; ++l)
    (s = o[l]) ? (s.__data__ = a[l], t[l] = s) : n[l] = new EnterNode(e, a[l]);
  for (; l < c; ++l)
    (s = o[l]) && (r[l] = s);
}
function bindKey(e, o, n, t, r, a, l) {
  var s, c, d = /* @__PURE__ */ new Map(), p = o.length, f = a.length, g = new Array(p), b;
  for (s = 0; s < p; ++s)
    (c = o[s]) && (g[s] = b = l.call(c, c.__data__, s, o) + "", d.has(b) ? r[s] = c : d.set(b, c));
  for (s = 0; s < f; ++s)
    b = l.call(e, a[s], s, a) + "", (c = d.get(b)) ? (t[s] = c, c.__data__ = a[s], d.delete(b)) : n[s] = new EnterNode(e, a[s]);
  for (s = 0; s < p; ++s)
    (c = o[s]) && d.get(g[s]) === c && (r[s] = c);
}
function datum(e) {
  return e.__data__;
}
function selection_data(e, o) {
  if (!arguments.length)
    return Array.from(this, datum);
  var n = o ? bindKey : bindIndex, t = this._parents, r = this._groups;
  typeof e != "function" && (e = constant$3(e));
  for (var a = r.length, l = new Array(a), s = new Array(a), c = new Array(a), d = 0; d < a; ++d) {
    var p = t[d], f = r[d], g = f.length, b = arraylike(e.call(p, p && p.__data__, d, t)), k = b.length, x = s[d] = new Array(k), N = l[d] = new Array(k), O = c[d] = new Array(g);
    n(p, f, x, N, O, b, o);
    for (var m = 0, ee = 0, z, P; m < k; ++m)
      if (z = x[m]) {
        for (m >= ee && (ee = m + 1); !(P = N[ee]) && ++ee < k; )
          ;
        z._next = P || null;
      }
  }
  return l = new Selection$1(l, t), l._enter = s, l._exit = c, l;
}
function arraylike(e) {
  return typeof e == "object" && "length" in e ? e : Array.from(e);
}
function selection_exit() {
  return new Selection$1(this._exit || this._groups.map(sparse), this._parents);
}
function selection_join(e, o, n) {
  var t = this.enter(), r = this, a = this.exit();
  return typeof e == "function" ? (t = e(t), t && (t = t.selection())) : t = t.append(e + ""), o != null && (r = o(r), r && (r = r.selection())), n == null ? a.remove() : n(a), t && r ? t.merge(r).order() : r;
}
function selection_merge(e) {
  for (var o = e.selection ? e.selection() : e, n = this._groups, t = o._groups, r = n.length, a = t.length, l = Math.min(r, a), s = new Array(r), c = 0; c < l; ++c)
    for (var d = n[c], p = t[c], f = d.length, g = s[c] = new Array(f), b, k = 0; k < f; ++k)
      (b = d[k] || p[k]) && (g[k] = b);
  for (; c < r; ++c)
    s[c] = n[c];
  return new Selection$1(s, this._parents);
}
function selection_order() {
  for (var e = this._groups, o = -1, n = e.length; ++o < n; )
    for (var t = e[o], r = t.length - 1, a = t[r], l; --r >= 0; )
      (l = t[r]) && (a && l.compareDocumentPosition(a) ^ 4 && a.parentNode.insertBefore(l, a), a = l);
  return this;
}
function selection_sort(e) {
  e || (e = ascending);
  function o(f, g) {
    return f && g ? e(f.__data__, g.__data__) : !f - !g;
  }
  for (var n = this._groups, t = n.length, r = new Array(t), a = 0; a < t; ++a) {
    for (var l = n[a], s = l.length, c = r[a] = new Array(s), d, p = 0; p < s; ++p)
      (d = l[p]) && (c[p] = d);
    c.sort(o);
  }
  return new Selection$1(r, this._parents).order();
}
function ascending(e, o) {
  return e < o ? -1 : e > o ? 1 : e >= o ? 0 : NaN;
}
function selection_call() {
  var e = arguments[0];
  return arguments[0] = this, e.apply(null, arguments), this;
}
function selection_nodes() {
  return Array.from(this);
}
function selection_node() {
  for (var e = this._groups, o = 0, n = e.length; o < n; ++o)
    for (var t = e[o], r = 0, a = t.length; r < a; ++r) {
      var l = t[r];
      if (l)
        return l;
    }
  return null;
}
function selection_size() {
  let e = 0;
  for (const o of this)
    ++e;
  return e;
}
function selection_empty() {
  return !this.node();
}
function selection_each(e) {
  for (var o = this._groups, n = 0, t = o.length; n < t; ++n)
    for (var r = o[n], a = 0, l = r.length, s; a < l; ++a)
      (s = r[a]) && e.call(s, s.__data__, a, r);
  return this;
}
function attrRemove$1(e) {
  return function() {
    this.removeAttribute(e);
  };
}
function attrRemoveNS$1(e) {
  return function() {
    this.removeAttributeNS(e.space, e.local);
  };
}
function attrConstant$1(e, o) {
  return function() {
    this.setAttribute(e, o);
  };
}
function attrConstantNS$1(e, o) {
  return function() {
    this.setAttributeNS(e.space, e.local, o);
  };
}
function attrFunction$1(e, o) {
  return function() {
    var n = o.apply(this, arguments);
    n == null ? this.removeAttribute(e) : this.setAttribute(e, n);
  };
}
function attrFunctionNS$1(e, o) {
  return function() {
    var n = o.apply(this, arguments);
    n == null ? this.removeAttributeNS(e.space, e.local) : this.setAttributeNS(e.space, e.local, n);
  };
}
function selection_attr(e, o) {
  var n = namespace(e);
  if (arguments.length < 2) {
    var t = this.node();
    return n.local ? t.getAttributeNS(n.space, n.local) : t.getAttribute(n);
  }
  return this.each((o == null ? n.local ? attrRemoveNS$1 : attrRemove$1 : typeof o == "function" ? n.local ? attrFunctionNS$1 : attrFunction$1 : n.local ? attrConstantNS$1 : attrConstant$1)(n, o));
}
function defaultView(e) {
  return e.ownerDocument && e.ownerDocument.defaultView || e.document && e || e.defaultView;
}
function styleRemove$1(e) {
  return function() {
    this.style.removeProperty(e);
  };
}
function styleConstant$1(e, o, n) {
  return function() {
    this.style.setProperty(e, o, n);
  };
}
function styleFunction$1(e, o, n) {
  return function() {
    var t = o.apply(this, arguments);
    t == null ? this.style.removeProperty(e) : this.style.setProperty(e, t, n);
  };
}
function selection_style(e, o, n) {
  return arguments.length > 1 ? this.each((o == null ? styleRemove$1 : typeof o == "function" ? styleFunction$1 : styleConstant$1)(e, o, n ?? "")) : styleValue(this.node(), e);
}
function styleValue(e, o) {
  return e.style.getPropertyValue(o) || defaultView(e).getComputedStyle(e, null).getPropertyValue(o);
}
function propertyRemove(e) {
  return function() {
    delete this[e];
  };
}
function propertyConstant(e, o) {
  return function() {
    this[e] = o;
  };
}
function propertyFunction(e, o) {
  return function() {
    var n = o.apply(this, arguments);
    n == null ? delete this[e] : this[e] = n;
  };
}
function selection_property(e, o) {
  return arguments.length > 1 ? this.each((o == null ? propertyRemove : typeof o == "function" ? propertyFunction : propertyConstant)(e, o)) : this.node()[e];
}
function classArray(e) {
  return e.trim().split(/^|\s+/);
}
function classList(e) {
  return e.classList || new ClassList(e);
}
function ClassList(e) {
  this._node = e, this._names = classArray(e.getAttribute("class") || "");
}
ClassList.prototype = {
  add: function(e) {
    var o = this._names.indexOf(e);
    o < 0 && (this._names.push(e), this._node.setAttribute("class", this._names.join(" ")));
  },
  remove: function(e) {
    var o = this._names.indexOf(e);
    o >= 0 && (this._names.splice(o, 1), this._node.setAttribute("class", this._names.join(" ")));
  },
  contains: function(e) {
    return this._names.indexOf(e) >= 0;
  }
};
function classedAdd(e, o) {
  for (var n = classList(e), t = -1, r = o.length; ++t < r; )
    n.add(o[t]);
}
function classedRemove(e, o) {
  for (var n = classList(e), t = -1, r = o.length; ++t < r; )
    n.remove(o[t]);
}
function classedTrue(e) {
  return function() {
    classedAdd(this, e);
  };
}
function classedFalse(e) {
  return function() {
    classedRemove(this, e);
  };
}
function classedFunction(e, o) {
  return function() {
    (o.apply(this, arguments) ? classedAdd : classedRemove)(this, e);
  };
}
function selection_classed(e, o) {
  var n = classArray(e + "");
  if (arguments.length < 2) {
    for (var t = classList(this.node()), r = -1, a = n.length; ++r < a; )
      if (!t.contains(n[r]))
        return !1;
    return !0;
  }
  return this.each((typeof o == "function" ? classedFunction : o ? classedTrue : classedFalse)(n, o));
}
function textRemove() {
  this.textContent = "";
}
function textConstant$1(e) {
  return function() {
    this.textContent = e;
  };
}
function textFunction$1(e) {
  return function() {
    var o = e.apply(this, arguments);
    this.textContent = o ?? "";
  };
}
function selection_text(e) {
  return arguments.length ? this.each(e == null ? textRemove : (typeof e == "function" ? textFunction$1 : textConstant$1)(e)) : this.node().textContent;
}
function htmlRemove() {
  this.innerHTML = "";
}
function htmlConstant(e) {
  return function() {
    this.innerHTML = e;
  };
}
function htmlFunction(e) {
  return function() {
    var o = e.apply(this, arguments);
    this.innerHTML = o ?? "";
  };
}
function selection_html(e) {
  return arguments.length ? this.each(e == null ? htmlRemove : (typeof e == "function" ? htmlFunction : htmlConstant)(e)) : this.node().innerHTML;
}
function raise() {
  this.nextSibling && this.parentNode.appendChild(this);
}
function selection_raise() {
  return this.each(raise);
}
function lower() {
  this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function selection_lower() {
  return this.each(lower);
}
function selection_append(e) {
  var o = typeof e == "function" ? e : creator(e);
  return this.select(function() {
    return this.appendChild(o.apply(this, arguments));
  });
}
function constantNull() {
  return null;
}
function selection_insert(e, o) {
  var n = typeof e == "function" ? e : creator(e), t = o == null ? constantNull : typeof o == "function" ? o : selector(o);
  return this.select(function() {
    return this.insertBefore(n.apply(this, arguments), t.apply(this, arguments) || null);
  });
}
function remove() {
  var e = this.parentNode;
  e && e.removeChild(this);
}
function selection_remove() {
  return this.each(remove);
}
function selection_cloneShallow() {
  var e = this.cloneNode(!1), o = this.parentNode;
  return o ? o.insertBefore(e, this.nextSibling) : e;
}
function selection_cloneDeep() {
  var e = this.cloneNode(!0), o = this.parentNode;
  return o ? o.insertBefore(e, this.nextSibling) : e;
}
function selection_clone(e) {
  return this.select(e ? selection_cloneDeep : selection_cloneShallow);
}
function selection_datum(e) {
  return arguments.length ? this.property("__data__", e) : this.node().__data__;
}
function contextListener(e) {
  return function(o) {
    e.call(this, o, this.__data__);
  };
}
function parseTypenames(e) {
  return e.trim().split(/^|\s+/).map(function(o) {
    var n = "", t = o.indexOf(".");
    return t >= 0 && (n = o.slice(t + 1), o = o.slice(0, t)), { type: o, name: n };
  });
}
function onRemove(e) {
  return function() {
    var o = this.__on;
    if (o) {
      for (var n = 0, t = -1, r = o.length, a; n < r; ++n)
        a = o[n], (!e.type || a.type === e.type) && a.name === e.name ? this.removeEventListener(a.type, a.listener, a.options) : o[++t] = a;
      ++t ? o.length = t : delete this.__on;
    }
  };
}
function onAdd(e, o, n) {
  return function() {
    var t = this.__on, r, a = contextListener(o);
    if (t) {
      for (var l = 0, s = t.length; l < s; ++l)
        if ((r = t[l]).type === e.type && r.name === e.name) {
          this.removeEventListener(r.type, r.listener, r.options), this.addEventListener(r.type, r.listener = a, r.options = n), r.value = o;
          return;
        }
    }
    this.addEventListener(e.type, a, n), r = { type: e.type, name: e.name, value: o, listener: a, options: n }, t ? t.push(r) : this.__on = [r];
  };
}
function selection_on(e, o, n) {
  var t = parseTypenames(e + ""), r, a = t.length, l;
  if (arguments.length < 2) {
    var s = this.node().__on;
    if (s) {
      for (var c = 0, d = s.length, p; c < d; ++c)
        for (r = 0, p = s[c]; r < a; ++r)
          if ((l = t[r]).type === p.type && l.name === p.name)
            return p.value;
    }
    return;
  }
  for (s = o ? onAdd : onRemove, r = 0; r < a; ++r)
    this.each(s(t[r], o, n));
  return this;
}
function dispatchEvent(e, o, n) {
  var t = defaultView(e), r = t.CustomEvent;
  typeof r == "function" ? r = new r(o, n) : (r = t.document.createEvent("Event"), n ? (r.initEvent(o, n.bubbles, n.cancelable), r.detail = n.detail) : r.initEvent(o, !1, !1)), e.dispatchEvent(r);
}
function dispatchConstant(e, o) {
  return function() {
    return dispatchEvent(this, e, o);
  };
}
function dispatchFunction(e, o) {
  return function() {
    return dispatchEvent(this, e, o.apply(this, arguments));
  };
}
function selection_dispatch(e, o) {
  return this.each((typeof o == "function" ? dispatchFunction : dispatchConstant)(e, o));
}
function* selection_iterator() {
  for (var e = this._groups, o = 0, n = e.length; o < n; ++o)
    for (var t = e[o], r = 0, a = t.length, l; r < a; ++r)
      (l = t[r]) && (yield l);
}
var root = [null];
function Selection$1(e, o) {
  this._groups = e, this._parents = o;
}
function selection() {
  return new Selection$1([[document.documentElement]], root);
}
function selection_selection() {
  return this;
}
Selection$1.prototype = selection.prototype = {
  constructor: Selection$1,
  select: selection_select,
  selectAll: selection_selectAll,
  selectChild: selection_selectChild,
  selectChildren: selection_selectChildren,
  filter: selection_filter,
  data: selection_data,
  enter: selection_enter,
  exit: selection_exit,
  join: selection_join,
  merge: selection_merge,
  selection: selection_selection,
  order: selection_order,
  sort: selection_sort,
  call: selection_call,
  nodes: selection_nodes,
  node: selection_node,
  size: selection_size,
  empty: selection_empty,
  each: selection_each,
  attr: selection_attr,
  style: selection_style,
  property: selection_property,
  classed: selection_classed,
  text: selection_text,
  html: selection_html,
  raise: selection_raise,
  lower: selection_lower,
  append: selection_append,
  insert: selection_insert,
  remove: selection_remove,
  clone: selection_clone,
  datum: selection_datum,
  on: selection_on,
  dispatch: selection_dispatch,
  [Symbol.iterator]: selection_iterator
};
function select(e) {
  return typeof e == "string" ? new Selection$1([[document.querySelector(e)]], [document.documentElement]) : new Selection$1([[e]], root);
}
function sourceEvent(e) {
  let o;
  for (; o = e.sourceEvent; )
    e = o;
  return e;
}
function pointer(e, o) {
  if (e = sourceEvent(e), o === void 0 && (o = e.currentTarget), o) {
    var n = o.ownerSVGElement || o;
    if (n.createSVGPoint) {
      var t = n.createSVGPoint();
      return t.x = e.clientX, t.y = e.clientY, t = t.matrixTransform(o.getScreenCTM().inverse()), [t.x, t.y];
    }
    if (o.getBoundingClientRect) {
      var r = o.getBoundingClientRect();
      return [e.clientX - r.left - o.clientLeft, e.clientY - r.top - o.clientTop];
    }
  }
  return [e.pageX, e.pageY];
}
const nonpassive = { passive: !1 }, nonpassivecapture = { capture: !0, passive: !1 };
function nopropagation$1(e) {
  e.stopImmediatePropagation();
}
function noevent$1(e) {
  e.preventDefault(), e.stopImmediatePropagation();
}
function dragDisable(e) {
  var o = e.document.documentElement, n = select(e).on("dragstart.drag", noevent$1, nonpassivecapture);
  "onselectstart" in o ? n.on("selectstart.drag", noevent$1, nonpassivecapture) : (o.__noselect = o.style.MozUserSelect, o.style.MozUserSelect = "none");
}
function yesdrag(e, o) {
  var n = e.document.documentElement, t = select(e).on("dragstart.drag", null);
  o && (t.on("click.drag", noevent$1, nonpassivecapture), setTimeout(function() {
    t.on("click.drag", null);
  }, 0)), "onselectstart" in n ? t.on("selectstart.drag", null) : (n.style.MozUserSelect = n.__noselect, delete n.__noselect);
}
const constant$2 = (e) => () => e;
function DragEvent(e, {
  sourceEvent: o,
  subject: n,
  target: t,
  identifier: r,
  active: a,
  x: l,
  y: s,
  dx: c,
  dy: d,
  dispatch: p
}) {
  Object.defineProperties(this, {
    type: { value: e, enumerable: !0, configurable: !0 },
    sourceEvent: { value: o, enumerable: !0, configurable: !0 },
    subject: { value: n, enumerable: !0, configurable: !0 },
    target: { value: t, enumerable: !0, configurable: !0 },
    identifier: { value: r, enumerable: !0, configurable: !0 },
    active: { value: a, enumerable: !0, configurable: !0 },
    x: { value: l, enumerable: !0, configurable: !0 },
    y: { value: s, enumerable: !0, configurable: !0 },
    dx: { value: c, enumerable: !0, configurable: !0 },
    dy: { value: d, enumerable: !0, configurable: !0 },
    _: { value: p }
  });
}
DragEvent.prototype.on = function() {
  var e = this._.on.apply(this._, arguments);
  return e === this._ ? this : e;
};
function defaultFilter$1(e) {
  return !e.ctrlKey && !e.button;
}
function defaultContainer() {
  return this.parentNode;
}
function defaultSubject(e, o) {
  return o ?? { x: e.x, y: e.y };
}
function defaultTouchable$1() {
  return navigator.maxTouchPoints || "ontouchstart" in this;
}
function drag() {
  var e = defaultFilter$1, o = defaultContainer, n = defaultSubject, t = defaultTouchable$1, r = {}, a = dispatch("start", "drag", "end"), l = 0, s, c, d, p, f = 0;
  function g(z) {
    z.on("mousedown.drag", b).filter(t).on("touchstart.drag", N).on("touchmove.drag", O, nonpassive).on("touchend.drag touchcancel.drag", m).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  function b(z, P) {
    if (!(p || !e.call(this, z, P))) {
      var V = ee(this, o.call(this, z, P), z, P, "mouse");
      V && (select(z.view).on("mousemove.drag", k, nonpassivecapture).on("mouseup.drag", x, nonpassivecapture), dragDisable(z.view), nopropagation$1(z), d = !1, s = z.clientX, c = z.clientY, V("start", z));
    }
  }
  function k(z) {
    if (noevent$1(z), !d) {
      var P = z.clientX - s, V = z.clientY - c;
      d = P * P + V * V > f;
    }
    r.mouse("drag", z);
  }
  function x(z) {
    select(z.view).on("mousemove.drag mouseup.drag", null), yesdrag(z.view, d), noevent$1(z), r.mouse("end", z);
  }
  function N(z, P) {
    if (e.call(this, z, P)) {
      var V = z.changedTouches, U = o.call(this, z, P), E = V.length, C, I;
      for (C = 0; C < E; ++C)
        (I = ee(this, U, z, P, V[C].identifier, V[C])) && (nopropagation$1(z), I("start", z, V[C]));
    }
  }
  function O(z) {
    var P = z.changedTouches, V = P.length, U, E;
    for (U = 0; U < V; ++U)
      (E = r[P[U].identifier]) && (noevent$1(z), E("drag", z, P[U]));
  }
  function m(z) {
    var P = z.changedTouches, V = P.length, U, E;
    for (p && clearTimeout(p), p = setTimeout(function() {
      p = null;
    }, 500), U = 0; U < V; ++U)
      (E = r[P[U].identifier]) && (nopropagation$1(z), E("end", z, P[U]));
  }
  function ee(z, P, V, U, E, C) {
    var I = a.copy(), v = pointer(C || V, P), M, $, H;
    if ((H = n.call(z, new DragEvent("beforestart", {
      sourceEvent: V,
      target: g,
      identifier: E,
      active: l,
      x: v[0],
      y: v[1],
      dx: 0,
      dy: 0,
      dispatch: I
    }), U)) != null)
      return M = H.x - v[0] || 0, $ = H.y - v[1] || 0, function X(te, oe, ne) {
        var ie = v, se;
        switch (te) {
          case "start":
            r[E] = X, se = l++;
            break;
          case "end":
            delete r[E], --l;
          case "drag":
            v = pointer(ne || oe, P), se = l;
            break;
        }
        I.call(
          te,
          z,
          new DragEvent(te, {
            sourceEvent: oe,
            subject: H,
            target: g,
            identifier: E,
            active: se,
            x: v[0] + M,
            y: v[1] + $,
            dx: v[0] - ie[0],
            dy: v[1] - ie[1],
            dispatch: I
          }),
          U
        );
      };
  }
  return g.filter = function(z) {
    return arguments.length ? (e = typeof z == "function" ? z : constant$2(!!z), g) : e;
  }, g.container = function(z) {
    return arguments.length ? (o = typeof z == "function" ? z : constant$2(z), g) : o;
  }, g.subject = function(z) {
    return arguments.length ? (n = typeof z == "function" ? z : constant$2(z), g) : n;
  }, g.touchable = function(z) {
    return arguments.length ? (t = typeof z == "function" ? z : constant$2(!!z), g) : t;
  }, g.on = function() {
    var z = a.on.apply(a, arguments);
    return z === a ? g : z;
  }, g.clickDistance = function(z) {
    return arguments.length ? (f = (z = +z) * z, g) : Math.sqrt(f);
  }, g;
}
function define(e, o, n) {
  e.prototype = o.prototype = n, n.constructor = e;
}
function extend(e, o) {
  var n = Object.create(e.prototype);
  for (var t in o)
    n[t] = o[t];
  return n;
}
function Color() {
}
var darker = 0.7, brighter = 1 / darker, reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`), named = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
define(Color, color, {
  copy(e) {
    return Object.assign(new this.constructor(), this, e);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: color_formatHex,
  // Deprecated! Use color.formatHex.
  formatHex: color_formatHex,
  formatHex8: color_formatHex8,
  formatHsl: color_formatHsl,
  formatRgb: color_formatRgb,
  toString: color_formatRgb
});
function color_formatHex() {
  return this.rgb().formatHex();
}
function color_formatHex8() {
  return this.rgb().formatHex8();
}
function color_formatHsl() {
  return hslConvert(this).formatHsl();
}
function color_formatRgb() {
  return this.rgb().formatRgb();
}
function color(e) {
  var o, n;
  return e = (e + "").trim().toLowerCase(), (o = reHex.exec(e)) ? (n = o[1].length, o = parseInt(o[1], 16), n === 6 ? rgbn(o) : n === 3 ? new Rgb(o >> 8 & 15 | o >> 4 & 240, o >> 4 & 15 | o & 240, (o & 15) << 4 | o & 15, 1) : n === 8 ? rgba(o >> 24 & 255, o >> 16 & 255, o >> 8 & 255, (o & 255) / 255) : n === 4 ? rgba(o >> 12 & 15 | o >> 8 & 240, o >> 8 & 15 | o >> 4 & 240, o >> 4 & 15 | o & 240, ((o & 15) << 4 | o & 15) / 255) : null) : (o = reRgbInteger.exec(e)) ? new Rgb(o[1], o[2], o[3], 1) : (o = reRgbPercent.exec(e)) ? new Rgb(o[1] * 255 / 100, o[2] * 255 / 100, o[3] * 255 / 100, 1) : (o = reRgbaInteger.exec(e)) ? rgba(o[1], o[2], o[3], o[4]) : (o = reRgbaPercent.exec(e)) ? rgba(o[1] * 255 / 100, o[2] * 255 / 100, o[3] * 255 / 100, o[4]) : (o = reHslPercent.exec(e)) ? hsla(o[1], o[2] / 100, o[3] / 100, 1) : (o = reHslaPercent.exec(e)) ? hsla(o[1], o[2] / 100, o[3] / 100, o[4]) : named.hasOwnProperty(e) ? rgbn(named[e]) : e === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(e) {
  return new Rgb(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
}
function rgba(e, o, n, t) {
  return t <= 0 && (e = o = n = NaN), new Rgb(e, o, n, t);
}
function rgbConvert(e) {
  return e instanceof Color || (e = color(e)), e ? (e = e.rgb(), new Rgb(e.r, e.g, e.b, e.opacity)) : new Rgb();
}
function rgb(e, o, n, t) {
  return arguments.length === 1 ? rgbConvert(e) : new Rgb(e, o, n, t ?? 1);
}
function Rgb(e, o, n, t) {
  this.r = +e, this.g = +o, this.b = +n, this.opacity = +t;
}
define(Rgb, rgb, extend(Color, {
  brighter(e) {
    return e = e == null ? brighter : Math.pow(brighter, e), new Rgb(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? darker : Math.pow(darker, e), new Rgb(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: rgb_formatHex,
  // Deprecated! Use color.formatHex.
  formatHex: rgb_formatHex,
  formatHex8: rgb_formatHex8,
  formatRgb: rgb_formatRgb,
  toString: rgb_formatRgb
}));
function rgb_formatHex() {
  return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
  return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
  const e = clampa(this.opacity);
  return `${e === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${e === 1 ? ")" : `, ${e})`}`;
}
function clampa(e) {
  return isNaN(e) ? 1 : Math.max(0, Math.min(1, e));
}
function clampi(e) {
  return Math.max(0, Math.min(255, Math.round(e) || 0));
}
function hex(e) {
  return e = clampi(e), (e < 16 ? "0" : "") + e.toString(16);
}
function hsla(e, o, n, t) {
  return t <= 0 ? e = o = n = NaN : n <= 0 || n >= 1 ? e = o = NaN : o <= 0 && (e = NaN), new Hsl(e, o, n, t);
}
function hslConvert(e) {
  if (e instanceof Hsl)
    return new Hsl(e.h, e.s, e.l, e.opacity);
  if (e instanceof Color || (e = color(e)), !e)
    return new Hsl();
  if (e instanceof Hsl)
    return e;
  e = e.rgb();
  var o = e.r / 255, n = e.g / 255, t = e.b / 255, r = Math.min(o, n, t), a = Math.max(o, n, t), l = NaN, s = a - r, c = (a + r) / 2;
  return s ? (o === a ? l = (n - t) / s + (n < t) * 6 : n === a ? l = (t - o) / s + 2 : l = (o - n) / s + 4, s /= c < 0.5 ? a + r : 2 - a - r, l *= 60) : s = c > 0 && c < 1 ? 0 : l, new Hsl(l, s, c, e.opacity);
}
function hsl(e, o, n, t) {
  return arguments.length === 1 ? hslConvert(e) : new Hsl(e, o, n, t ?? 1);
}
function Hsl(e, o, n, t) {
  this.h = +e, this.s = +o, this.l = +n, this.opacity = +t;
}
define(Hsl, hsl, extend(Color, {
  brighter(e) {
    return e = e == null ? brighter : Math.pow(brighter, e), new Hsl(this.h, this.s, this.l * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? darker : Math.pow(darker, e), new Hsl(this.h, this.s, this.l * e, this.opacity);
  },
  rgb() {
    var e = this.h % 360 + (this.h < 0) * 360, o = isNaN(e) || isNaN(this.s) ? 0 : this.s, n = this.l, t = n + (n < 0.5 ? n : 1 - n) * o, r = 2 * n - t;
    return new Rgb(
      hsl2rgb(e >= 240 ? e - 240 : e + 120, r, t),
      hsl2rgb(e, r, t),
      hsl2rgb(e < 120 ? e + 240 : e - 120, r, t),
      this.opacity
    );
  },
  clamp() {
    return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const e = clampa(this.opacity);
    return `${e === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${e === 1 ? ")" : `, ${e})`}`;
  }
}));
function clamph(e) {
  return e = (e || 0) % 360, e < 0 ? e + 360 : e;
}
function clampt(e) {
  return Math.max(0, Math.min(1, e || 0));
}
function hsl2rgb(e, o, n) {
  return (e < 60 ? o + (n - o) * e / 60 : e < 180 ? n : e < 240 ? o + (n - o) * (240 - e) / 60 : o) * 255;
}
const constant$1 = (e) => () => e;
function linear(e, o) {
  return function(n) {
    return e + n * o;
  };
}
function exponential(e, o, n) {
  return e = Math.pow(e, n), o = Math.pow(o, n) - e, n = 1 / n, function(t) {
    return Math.pow(e + t * o, n);
  };
}
function gamma(e) {
  return (e = +e) == 1 ? nogamma : function(o, n) {
    return n - o ? exponential(o, n, e) : constant$1(isNaN(o) ? n : o);
  };
}
function nogamma(e, o) {
  var n = o - e;
  return n ? linear(e, n) : constant$1(isNaN(e) ? o : e);
}
const interpolateRgb = function e(o) {
  var n = gamma(o);
  function t(r, a) {
    var l = n((r = rgb(r)).r, (a = rgb(a)).r), s = n(r.g, a.g), c = n(r.b, a.b), d = nogamma(r.opacity, a.opacity);
    return function(p) {
      return r.r = l(p), r.g = s(p), r.b = c(p), r.opacity = d(p), r + "";
    };
  }
  return t.gamma = e, t;
}(1);
function interpolateNumber(e, o) {
  return e = +e, o = +o, function(n) {
    return e * (1 - n) + o * n;
  };
}
var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, reB = new RegExp(reA.source, "g");
function zero(e) {
  return function() {
    return e;
  };
}
function one(e) {
  return function(o) {
    return e(o) + "";
  };
}
function interpolateString(e, o) {
  var n = reA.lastIndex = reB.lastIndex = 0, t, r, a, l = -1, s = [], c = [];
  for (e = e + "", o = o + ""; (t = reA.exec(e)) && (r = reB.exec(o)); )
    (a = r.index) > n && (a = o.slice(n, a), s[l] ? s[l] += a : s[++l] = a), (t = t[0]) === (r = r[0]) ? s[l] ? s[l] += r : s[++l] = r : (s[++l] = null, c.push({ i: l, x: interpolateNumber(t, r) })), n = reB.lastIndex;
  return n < o.length && (a = o.slice(n), s[l] ? s[l] += a : s[++l] = a), s.length < 2 ? c[0] ? one(c[0].x) : zero(o) : (o = c.length, function(d) {
    for (var p = 0, f; p < o; ++p)
      s[(f = c[p]).i] = f.x(d);
    return s.join("");
  });
}
var degrees = 180 / Math.PI, identity$1 = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};
function decompose(e, o, n, t, r, a) {
  var l, s, c;
  return (l = Math.sqrt(e * e + o * o)) && (e /= l, o /= l), (c = e * n + o * t) && (n -= e * c, t -= o * c), (s = Math.sqrt(n * n + t * t)) && (n /= s, t /= s, c /= s), e * t < o * n && (e = -e, o = -o, c = -c, l = -l), {
    translateX: r,
    translateY: a,
    rotate: Math.atan2(o, e) * degrees,
    skewX: Math.atan(c) * degrees,
    scaleX: l,
    scaleY: s
  };
}
var svgNode;
function parseCss(e) {
  const o = new (typeof DOMMatrix == "function" ? DOMMatrix : WebKitCSSMatrix)(e + "");
  return o.isIdentity ? identity$1 : decompose(o.a, o.b, o.c, o.d, o.e, o.f);
}
function parseSvg(e) {
  return e == null || (svgNode || (svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g")), svgNode.setAttribute("transform", e), !(e = svgNode.transform.baseVal.consolidate())) ? identity$1 : (e = e.matrix, decompose(e.a, e.b, e.c, e.d, e.e, e.f));
}
function interpolateTransform(e, o, n, t) {
  function r(d) {
    return d.length ? d.pop() + " " : "";
  }
  function a(d, p, f, g, b, k) {
    if (d !== f || p !== g) {
      var x = b.push("translate(", null, o, null, n);
      k.push({ i: x - 4, x: interpolateNumber(d, f) }, { i: x - 2, x: interpolateNumber(p, g) });
    } else (f || g) && b.push("translate(" + f + o + g + n);
  }
  function l(d, p, f, g) {
    d !== p ? (d - p > 180 ? p += 360 : p - d > 180 && (d += 360), g.push({ i: f.push(r(f) + "rotate(", null, t) - 2, x: interpolateNumber(d, p) })) : p && f.push(r(f) + "rotate(" + p + t);
  }
  function s(d, p, f, g) {
    d !== p ? g.push({ i: f.push(r(f) + "skewX(", null, t) - 2, x: interpolateNumber(d, p) }) : p && f.push(r(f) + "skewX(" + p + t);
  }
  function c(d, p, f, g, b, k) {
    if (d !== f || p !== g) {
      var x = b.push(r(b) + "scale(", null, ",", null, ")");
      k.push({ i: x - 4, x: interpolateNumber(d, f) }, { i: x - 2, x: interpolateNumber(p, g) });
    } else (f !== 1 || g !== 1) && b.push(r(b) + "scale(" + f + "," + g + ")");
  }
  return function(d, p) {
    var f = [], g = [];
    return d = e(d), p = e(p), a(d.translateX, d.translateY, p.translateX, p.translateY, f, g), l(d.rotate, p.rotate, f, g), s(d.skewX, p.skewX, f, g), c(d.scaleX, d.scaleY, p.scaleX, p.scaleY, f, g), d = p = null, function(b) {
      for (var k = -1, x = g.length, N; ++k < x; )
        f[(N = g[k]).i] = N.x(b);
      return f.join("");
    };
  };
}
var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)"), interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")"), epsilon2 = 1e-12;
function cosh(e) {
  return ((e = Math.exp(e)) + 1 / e) / 2;
}
function sinh(e) {
  return ((e = Math.exp(e)) - 1 / e) / 2;
}
function tanh(e) {
  return ((e = Math.exp(2 * e)) - 1) / (e + 1);
}
const interpolateZoom = function e(o, n, t) {
  function r(a, l) {
    var s = a[0], c = a[1], d = a[2], p = l[0], f = l[1], g = l[2], b = p - s, k = f - c, x = b * b + k * k, N, O;
    if (x < epsilon2)
      O = Math.log(g / d) / o, N = function(U) {
        return [
          s + U * b,
          c + U * k,
          d * Math.exp(o * U * O)
        ];
      };
    else {
      var m = Math.sqrt(x), ee = (g * g - d * d + t * x) / (2 * d * n * m), z = (g * g - d * d - t * x) / (2 * g * n * m), P = Math.log(Math.sqrt(ee * ee + 1) - ee), V = Math.log(Math.sqrt(z * z + 1) - z);
      O = (V - P) / o, N = function(U) {
        var E = U * O, C = cosh(P), I = d / (n * m) * (C * tanh(o * E + P) - sinh(P));
        return [
          s + I * b,
          c + I * k,
          d * C / cosh(o * E + P)
        ];
      };
    }
    return N.duration = O * 1e3 * o / Math.SQRT2, N;
  }
  return r.rho = function(a) {
    var l = Math.max(1e-3, +a), s = l * l, c = s * s;
    return e(l, s, c);
  }, r;
}(Math.SQRT2, 2, 4);
var frame = 0, timeout$1 = 0, interval = 0, pokeDelay = 1e3, taskHead, taskTail, clockLast = 0, clockNow = 0, clockSkew = 0, clock = typeof performance == "object" && performance.now ? performance : Date, setFrame = typeof window == "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(e) {
  setTimeout(e, 17);
};
function now() {
  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}
function clearNow() {
  clockNow = 0;
}
function Timer() {
  this._call = this._time = this._next = null;
}
Timer.prototype = timer.prototype = {
  constructor: Timer,
  restart: function(e, o, n) {
    if (typeof e != "function")
      throw new TypeError("callback is not a function");
    n = (n == null ? now() : +n) + (o == null ? 0 : +o), !this._next && taskTail !== this && (taskTail ? taskTail._next = this : taskHead = this, taskTail = this), this._call = e, this._time = n, sleep();
  },
  stop: function() {
    this._call && (this._call = null, this._time = 1 / 0, sleep());
  }
};
function timer(e, o, n) {
  var t = new Timer();
  return t.restart(e, o, n), t;
}
function timerFlush() {
  now(), ++frame;
  for (var e = taskHead, o; e; )
    (o = clockNow - e._time) >= 0 && e._call.call(void 0, o), e = e._next;
  --frame;
}
function wake() {
  clockNow = (clockLast = clock.now()) + clockSkew, frame = timeout$1 = 0;
  try {
    timerFlush();
  } finally {
    frame = 0, nap(), clockNow = 0;
  }
}
function poke() {
  var e = clock.now(), o = e - clockLast;
  o > pokeDelay && (clockSkew -= o, clockLast = e);
}
function nap() {
  for (var e, o = taskHead, n, t = 1 / 0; o; )
    o._call ? (t > o._time && (t = o._time), e = o, o = o._next) : (n = o._next, o._next = null, o = e ? e._next = n : taskHead = n);
  taskTail = e, sleep(t);
}
function sleep(e) {
  if (!frame) {
    timeout$1 && (timeout$1 = clearTimeout(timeout$1));
    var o = e - clockNow;
    o > 24 ? (e < 1 / 0 && (timeout$1 = setTimeout(wake, e - clock.now() - clockSkew)), interval && (interval = clearInterval(interval))) : (interval || (clockLast = clock.now(), interval = setInterval(poke, pokeDelay)), frame = 1, setFrame(wake));
  }
}
function timeout(e, o, n) {
  var t = new Timer();
  return o = o == null ? 0 : +o, t.restart((r) => {
    t.stop(), e(r + o);
  }, o, n), t;
}
var emptyOn = dispatch("start", "end", "cancel", "interrupt"), emptyTween = [], CREATED = 0, SCHEDULED = 1, STARTING = 2, STARTED = 3, RUNNING = 4, ENDING = 5, ENDED = 6;
function schedule(e, o, n, t, r, a) {
  var l = e.__transition;
  if (!l)
    e.__transition = {};
  else if (n in l)
    return;
  create(e, n, {
    name: o,
    index: t,
    // For context during callback.
    group: r,
    // For context during callback.
    on: emptyOn,
    tween: emptyTween,
    time: a.time,
    delay: a.delay,
    duration: a.duration,
    ease: a.ease,
    timer: null,
    state: CREATED
  });
}
function init(e, o) {
  var n = get(e, o);
  if (n.state > CREATED)
    throw new Error("too late; already scheduled");
  return n;
}
function set(e, o) {
  var n = get(e, o);
  if (n.state > STARTED)
    throw new Error("too late; already running");
  return n;
}
function get(e, o) {
  var n = e.__transition;
  if (!n || !(n = n[o]))
    throw new Error("transition not found");
  return n;
}
function create(e, o, n) {
  var t = e.__transition, r;
  t[o] = n, n.timer = timer(a, 0, n.time);
  function a(d) {
    n.state = SCHEDULED, n.timer.restart(l, n.delay, n.time), n.delay <= d && l(d - n.delay);
  }
  function l(d) {
    var p, f, g, b;
    if (n.state !== SCHEDULED)
      return c();
    for (p in t)
      if (b = t[p], b.name === n.name) {
        if (b.state === STARTED)
          return timeout(l);
        b.state === RUNNING ? (b.state = ENDED, b.timer.stop(), b.on.call("interrupt", e, e.__data__, b.index, b.group), delete t[p]) : +p < o && (b.state = ENDED, b.timer.stop(), b.on.call("cancel", e, e.__data__, b.index, b.group), delete t[p]);
      }
    if (timeout(function() {
      n.state === STARTED && (n.state = RUNNING, n.timer.restart(s, n.delay, n.time), s(d));
    }), n.state = STARTING, n.on.call("start", e, e.__data__, n.index, n.group), n.state === STARTING) {
      for (n.state = STARTED, r = new Array(g = n.tween.length), p = 0, f = -1; p < g; ++p)
        (b = n.tween[p].value.call(e, e.__data__, n.index, n.group)) && (r[++f] = b);
      r.length = f + 1;
    }
  }
  function s(d) {
    for (var p = d < n.duration ? n.ease.call(null, d / n.duration) : (n.timer.restart(c), n.state = ENDING, 1), f = -1, g = r.length; ++f < g; )
      r[f].call(e, p);
    n.state === ENDING && (n.on.call("end", e, e.__data__, n.index, n.group), c());
  }
  function c() {
    n.state = ENDED, n.timer.stop(), delete t[o];
    for (var d in t)
      return;
    delete e.__transition;
  }
}
function interrupt(e, o) {
  var n = e.__transition, t, r, a = !0, l;
  if (n) {
    o = o == null ? null : o + "";
    for (l in n) {
      if ((t = n[l]).name !== o) {
        a = !1;
        continue;
      }
      r = t.state > STARTING && t.state < ENDING, t.state = ENDED, t.timer.stop(), t.on.call(r ? "interrupt" : "cancel", e, e.__data__, t.index, t.group), delete n[l];
    }
    a && delete e.__transition;
  }
}
function selection_interrupt(e) {
  return this.each(function() {
    interrupt(this, e);
  });
}
function tweenRemove(e, o) {
  var n, t;
  return function() {
    var r = set(this, e), a = r.tween;
    if (a !== n) {
      t = n = a;
      for (var l = 0, s = t.length; l < s; ++l)
        if (t[l].name === o) {
          t = t.slice(), t.splice(l, 1);
          break;
        }
    }
    r.tween = t;
  };
}
function tweenFunction(e, o, n) {
  var t, r;
  if (typeof n != "function")
    throw new Error();
  return function() {
    var a = set(this, e), l = a.tween;
    if (l !== t) {
      r = (t = l).slice();
      for (var s = { name: o, value: n }, c = 0, d = r.length; c < d; ++c)
        if (r[c].name === o) {
          r[c] = s;
          break;
        }
      c === d && r.push(s);
    }
    a.tween = r;
  };
}
function transition_tween(e, o) {
  var n = this._id;
  if (e += "", arguments.length < 2) {
    for (var t = get(this.node(), n).tween, r = 0, a = t.length, l; r < a; ++r)
      if ((l = t[r]).name === e)
        return l.value;
    return null;
  }
  return this.each((o == null ? tweenRemove : tweenFunction)(n, e, o));
}
function tweenValue(e, o, n) {
  var t = e._id;
  return e.each(function() {
    var r = set(this, t);
    (r.value || (r.value = {}))[o] = n.apply(this, arguments);
  }), function(r) {
    return get(r, t).value[o];
  };
}
function interpolate(e, o) {
  var n;
  return (typeof o == "number" ? interpolateNumber : o instanceof color ? interpolateRgb : (n = color(o)) ? (o = n, interpolateRgb) : interpolateString)(e, o);
}
function attrRemove(e) {
  return function() {
    this.removeAttribute(e);
  };
}
function attrRemoveNS(e) {
  return function() {
    this.removeAttributeNS(e.space, e.local);
  };
}
function attrConstant(e, o, n) {
  var t, r = n + "", a;
  return function() {
    var l = this.getAttribute(e);
    return l === r ? null : l === t ? a : a = o(t = l, n);
  };
}
function attrConstantNS(e, o, n) {
  var t, r = n + "", a;
  return function() {
    var l = this.getAttributeNS(e.space, e.local);
    return l === r ? null : l === t ? a : a = o(t = l, n);
  };
}
function attrFunction(e, o, n) {
  var t, r, a;
  return function() {
    var l, s = n(this), c;
    return s == null ? void this.removeAttribute(e) : (l = this.getAttribute(e), c = s + "", l === c ? null : l === t && c === r ? a : (r = c, a = o(t = l, s)));
  };
}
function attrFunctionNS(e, o, n) {
  var t, r, a;
  return function() {
    var l, s = n(this), c;
    return s == null ? void this.removeAttributeNS(e.space, e.local) : (l = this.getAttributeNS(e.space, e.local), c = s + "", l === c ? null : l === t && c === r ? a : (r = c, a = o(t = l, s)));
  };
}
function transition_attr(e, o) {
  var n = namespace(e), t = n === "transform" ? interpolateTransformSvg : interpolate;
  return this.attrTween(e, typeof o == "function" ? (n.local ? attrFunctionNS : attrFunction)(n, t, tweenValue(this, "attr." + e, o)) : o == null ? (n.local ? attrRemoveNS : attrRemove)(n) : (n.local ? attrConstantNS : attrConstant)(n, t, o));
}
function attrInterpolate(e, o) {
  return function(n) {
    this.setAttribute(e, o.call(this, n));
  };
}
function attrInterpolateNS(e, o) {
  return function(n) {
    this.setAttributeNS(e.space, e.local, o.call(this, n));
  };
}
function attrTweenNS(e, o) {
  var n, t;
  function r() {
    var a = o.apply(this, arguments);
    return a !== t && (n = (t = a) && attrInterpolateNS(e, a)), n;
  }
  return r._value = o, r;
}
function attrTween(e, o) {
  var n, t;
  function r() {
    var a = o.apply(this, arguments);
    return a !== t && (n = (t = a) && attrInterpolate(e, a)), n;
  }
  return r._value = o, r;
}
function transition_attrTween(e, o) {
  var n = "attr." + e;
  if (arguments.length < 2)
    return (n = this.tween(n)) && n._value;
  if (o == null)
    return this.tween(n, null);
  if (typeof o != "function")
    throw new Error();
  var t = namespace(e);
  return this.tween(n, (t.local ? attrTweenNS : attrTween)(t, o));
}
function delayFunction(e, o) {
  return function() {
    init(this, e).delay = +o.apply(this, arguments);
  };
}
function delayConstant(e, o) {
  return o = +o, function() {
    init(this, e).delay = o;
  };
}
function transition_delay(e) {
  var o = this._id;
  return arguments.length ? this.each((typeof e == "function" ? delayFunction : delayConstant)(o, e)) : get(this.node(), o).delay;
}
function durationFunction(e, o) {
  return function() {
    set(this, e).duration = +o.apply(this, arguments);
  };
}
function durationConstant(e, o) {
  return o = +o, function() {
    set(this, e).duration = o;
  };
}
function transition_duration(e) {
  var o = this._id;
  return arguments.length ? this.each((typeof e == "function" ? durationFunction : durationConstant)(o, e)) : get(this.node(), o).duration;
}
function easeConstant(e, o) {
  if (typeof o != "function")
    throw new Error();
  return function() {
    set(this, e).ease = o;
  };
}
function transition_ease(e) {
  var o = this._id;
  return arguments.length ? this.each(easeConstant(o, e)) : get(this.node(), o).ease;
}
function easeVarying(e, o) {
  return function() {
    var n = o.apply(this, arguments);
    if (typeof n != "function")
      throw new Error();
    set(this, e).ease = n;
  };
}
function transition_easeVarying(e) {
  if (typeof e != "function")
    throw new Error();
  return this.each(easeVarying(this._id, e));
}
function transition_filter(e) {
  typeof e != "function" && (e = matcher(e));
  for (var o = this._groups, n = o.length, t = new Array(n), r = 0; r < n; ++r)
    for (var a = o[r], l = a.length, s = t[r] = [], c, d = 0; d < l; ++d)
      (c = a[d]) && e.call(c, c.__data__, d, a) && s.push(c);
  return new Transition(t, this._parents, this._name, this._id);
}
function transition_merge(e) {
  if (e._id !== this._id)
    throw new Error();
  for (var o = this._groups, n = e._groups, t = o.length, r = n.length, a = Math.min(t, r), l = new Array(t), s = 0; s < a; ++s)
    for (var c = o[s], d = n[s], p = c.length, f = l[s] = new Array(p), g, b = 0; b < p; ++b)
      (g = c[b] || d[b]) && (f[b] = g);
  for (; s < t; ++s)
    l[s] = o[s];
  return new Transition(l, this._parents, this._name, this._id);
}
function start(e) {
  return (e + "").trim().split(/^|\s+/).every(function(o) {
    var n = o.indexOf(".");
    return n >= 0 && (o = o.slice(0, n)), !o || o === "start";
  });
}
function onFunction(e, o, n) {
  var t, r, a = start(o) ? init : set;
  return function() {
    var l = a(this, e), s = l.on;
    s !== t && (r = (t = s).copy()).on(o, n), l.on = r;
  };
}
function transition_on(e, o) {
  var n = this._id;
  return arguments.length < 2 ? get(this.node(), n).on.on(e) : this.each(onFunction(n, e, o));
}
function removeFunction(e) {
  return function() {
    var o = this.parentNode;
    for (var n in this.__transition)
      if (+n !== e)
        return;
    o && o.removeChild(this);
  };
}
function transition_remove() {
  return this.on("end.remove", removeFunction(this._id));
}
function transition_select(e) {
  var o = this._name, n = this._id;
  typeof e != "function" && (e = selector(e));
  for (var t = this._groups, r = t.length, a = new Array(r), l = 0; l < r; ++l)
    for (var s = t[l], c = s.length, d = a[l] = new Array(c), p, f, g = 0; g < c; ++g)
      (p = s[g]) && (f = e.call(p, p.__data__, g, s)) && ("__data__" in p && (f.__data__ = p.__data__), d[g] = f, schedule(d[g], o, n, g, d, get(p, n)));
  return new Transition(a, this._parents, o, n);
}
function transition_selectAll(e) {
  var o = this._name, n = this._id;
  typeof e != "function" && (e = selectorAll(e));
  for (var t = this._groups, r = t.length, a = [], l = [], s = 0; s < r; ++s)
    for (var c = t[s], d = c.length, p, f = 0; f < d; ++f)
      if (p = c[f]) {
        for (var g = e.call(p, p.__data__, f, c), b, k = get(p, n), x = 0, N = g.length; x < N; ++x)
          (b = g[x]) && schedule(b, o, n, x, g, k);
        a.push(g), l.push(p);
      }
  return new Transition(a, l, o, n);
}
var Selection = selection.prototype.constructor;
function transition_selection() {
  return new Selection(this._groups, this._parents);
}
function styleNull(e, o) {
  var n, t, r;
  return function() {
    var a = styleValue(this, e), l = (this.style.removeProperty(e), styleValue(this, e));
    return a === l ? null : a === n && l === t ? r : r = o(n = a, t = l);
  };
}
function styleRemove(e) {
  return function() {
    this.style.removeProperty(e);
  };
}
function styleConstant(e, o, n) {
  var t, r = n + "", a;
  return function() {
    var l = styleValue(this, e);
    return l === r ? null : l === t ? a : a = o(t = l, n);
  };
}
function styleFunction(e, o, n) {
  var t, r, a;
  return function() {
    var l = styleValue(this, e), s = n(this), c = s + "";
    return s == null && (c = s = (this.style.removeProperty(e), styleValue(this, e))), l === c ? null : l === t && c === r ? a : (r = c, a = o(t = l, s));
  };
}
function styleMaybeRemove(e, o) {
  var n, t, r, a = "style." + o, l = "end." + a, s;
  return function() {
    var c = set(this, e), d = c.on, p = c.value[a] == null ? s || (s = styleRemove(o)) : void 0;
    (d !== n || r !== p) && (t = (n = d).copy()).on(l, r = p), c.on = t;
  };
}
function transition_style(e, o, n) {
  var t = (e += "") == "transform" ? interpolateTransformCss : interpolate;
  return o == null ? this.styleTween(e, styleNull(e, t)).on("end.style." + e, styleRemove(e)) : typeof o == "function" ? this.styleTween(e, styleFunction(e, t, tweenValue(this, "style." + e, o))).each(styleMaybeRemove(this._id, e)) : this.styleTween(e, styleConstant(e, t, o), n).on("end.style." + e, null);
}
function styleInterpolate(e, o, n) {
  return function(t) {
    this.style.setProperty(e, o.call(this, t), n);
  };
}
function styleTween(e, o, n) {
  var t, r;
  function a() {
    var l = o.apply(this, arguments);
    return l !== r && (t = (r = l) && styleInterpolate(e, l, n)), t;
  }
  return a._value = o, a;
}
function transition_styleTween(e, o, n) {
  var t = "style." + (e += "");
  if (arguments.length < 2)
    return (t = this.tween(t)) && t._value;
  if (o == null)
    return this.tween(t, null);
  if (typeof o != "function")
    throw new Error();
  return this.tween(t, styleTween(e, o, n ?? ""));
}
function textConstant(e) {
  return function() {
    this.textContent = e;
  };
}
function textFunction(e) {
  return function() {
    var o = e(this);
    this.textContent = o ?? "";
  };
}
function transition_text(e) {
  return this.tween("text", typeof e == "function" ? textFunction(tweenValue(this, "text", e)) : textConstant(e == null ? "" : e + ""));
}
function textInterpolate(e) {
  return function(o) {
    this.textContent = e.call(this, o);
  };
}
function textTween(e) {
  var o, n;
  function t() {
    var r = e.apply(this, arguments);
    return r !== n && (o = (n = r) && textInterpolate(r)), o;
  }
  return t._value = e, t;
}
function transition_textTween(e) {
  var o = "text";
  if (arguments.length < 1)
    return (o = this.tween(o)) && o._value;
  if (e == null)
    return this.tween(o, null);
  if (typeof e != "function")
    throw new Error();
  return this.tween(o, textTween(e));
}
function transition_transition() {
  for (var e = this._name, o = this._id, n = newId(), t = this._groups, r = t.length, a = 0; a < r; ++a)
    for (var l = t[a], s = l.length, c, d = 0; d < s; ++d)
      if (c = l[d]) {
        var p = get(c, o);
        schedule(c, e, n, d, l, {
          time: p.time + p.delay + p.duration,
          delay: 0,
          duration: p.duration,
          ease: p.ease
        });
      }
  return new Transition(t, this._parents, e, n);
}
function transition_end() {
  var e, o, n = this, t = n._id, r = n.size();
  return new Promise(function(a, l) {
    var s = { value: l }, c = { value: function() {
      --r === 0 && a();
    } };
    n.each(function() {
      var d = set(this, t), p = d.on;
      p !== e && (o = (e = p).copy(), o._.cancel.push(s), o._.interrupt.push(s), o._.end.push(c)), d.on = o;
    }), r === 0 && a();
  });
}
var id = 0;
function Transition(e, o, n, t) {
  this._groups = e, this._parents = o, this._name = n, this._id = t;
}
function newId() {
  return ++id;
}
var selection_prototype = selection.prototype;
Transition.prototype = {
  constructor: Transition,
  select: transition_select,
  selectAll: transition_selectAll,
  selectChild: selection_prototype.selectChild,
  selectChildren: selection_prototype.selectChildren,
  filter: transition_filter,
  merge: transition_merge,
  selection: transition_selection,
  transition: transition_transition,
  call: selection_prototype.call,
  nodes: selection_prototype.nodes,
  node: selection_prototype.node,
  size: selection_prototype.size,
  empty: selection_prototype.empty,
  each: selection_prototype.each,
  on: transition_on,
  attr: transition_attr,
  attrTween: transition_attrTween,
  style: transition_style,
  styleTween: transition_styleTween,
  text: transition_text,
  textTween: transition_textTween,
  remove: transition_remove,
  tween: transition_tween,
  delay: transition_delay,
  duration: transition_duration,
  ease: transition_ease,
  easeVarying: transition_easeVarying,
  end: transition_end,
  [Symbol.iterator]: selection_prototype[Symbol.iterator]
};
function cubicInOut(e) {
  return ((e *= 2) <= 1 ? e * e * e : (e -= 2) * e * e + 2) / 2;
}
var defaultTiming = {
  time: null,
  // Set on use.
  delay: 0,
  duration: 250,
  ease: cubicInOut
};
function inherit(e, o) {
  for (var n; !(n = e.__transition) || !(n = n[o]); )
    if (!(e = e.parentNode))
      throw new Error(`transition ${o} not found`);
  return n;
}
function selection_transition(e) {
  var o, n;
  e instanceof Transition ? (o = e._id, e = e._name) : (o = newId(), (n = defaultTiming).time = now(), e = e == null ? null : e + "");
  for (var t = this._groups, r = t.length, a = 0; a < r; ++a)
    for (var l = t[a], s = l.length, c, d = 0; d < s; ++d)
      (c = l[d]) && schedule(c, e, o, d, l, n || inherit(c, o));
  return new Transition(t, this._parents, e, o);
}
selection.prototype.interrupt = selection_interrupt;
selection.prototype.transition = selection_transition;
const constant = (e) => () => e;
function ZoomEvent(e, {
  sourceEvent: o,
  target: n,
  transform: t,
  dispatch: r
}) {
  Object.defineProperties(this, {
    type: { value: e, enumerable: !0, configurable: !0 },
    sourceEvent: { value: o, enumerable: !0, configurable: !0 },
    target: { value: n, enumerable: !0, configurable: !0 },
    transform: { value: t, enumerable: !0, configurable: !0 },
    _: { value: r }
  });
}
function Transform(e, o, n) {
  this.k = e, this.x = o, this.y = n;
}
Transform.prototype = {
  constructor: Transform,
  scale: function(e) {
    return e === 1 ? this : new Transform(this.k * e, this.x, this.y);
  },
  translate: function(e, o) {
    return e === 0 & o === 0 ? this : new Transform(this.k, this.x + this.k * e, this.y + this.k * o);
  },
  apply: function(e) {
    return [e[0] * this.k + this.x, e[1] * this.k + this.y];
  },
  applyX: function(e) {
    return e * this.k + this.x;
  },
  applyY: function(e) {
    return e * this.k + this.y;
  },
  invert: function(e) {
    return [(e[0] - this.x) / this.k, (e[1] - this.y) / this.k];
  },
  invertX: function(e) {
    return (e - this.x) / this.k;
  },
  invertY: function(e) {
    return (e - this.y) / this.k;
  },
  rescaleX: function(e) {
    return e.copy().domain(e.range().map(this.invertX, this).map(e.invert, e));
  },
  rescaleY: function(e) {
    return e.copy().domain(e.range().map(this.invertY, this).map(e.invert, e));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};
var identity = new Transform(1, 0, 0);
Transform.prototype;
function nopropagation(e) {
  e.stopImmediatePropagation();
}
function noevent(e) {
  e.preventDefault(), e.stopImmediatePropagation();
}
function defaultFilter(e) {
  return (!e.ctrlKey || e.type === "wheel") && !e.button;
}
function defaultExtent() {
  var e = this;
  return e instanceof SVGElement ? (e = e.ownerSVGElement || e, e.hasAttribute("viewBox") ? (e = e.viewBox.baseVal, [[e.x, e.y], [e.x + e.width, e.y + e.height]]) : [[0, 0], [e.width.baseVal.value, e.height.baseVal.value]]) : [[0, 0], [e.clientWidth, e.clientHeight]];
}
function defaultTransform() {
  return this.__zoom || identity;
}
function defaultWheelDelta(e) {
  return -e.deltaY * (e.deltaMode === 1 ? 0.05 : e.deltaMode ? 1 : 2e-3) * (e.ctrlKey ? 10 : 1);
}
function defaultTouchable() {
  return navigator.maxTouchPoints || "ontouchstart" in this;
}
function defaultConstrain(e, o, n) {
  var t = e.invertX(o[0][0]) - n[0][0], r = e.invertX(o[1][0]) - n[1][0], a = e.invertY(o[0][1]) - n[0][1], l = e.invertY(o[1][1]) - n[1][1];
  return e.translate(
    r > t ? (t + r) / 2 : Math.min(0, t) || Math.max(0, r),
    l > a ? (a + l) / 2 : Math.min(0, a) || Math.max(0, l)
  );
}
function zoom() {
  var e = defaultFilter, o = defaultExtent, n = defaultConstrain, t = defaultWheelDelta, r = defaultTouchable, a = [0, 1 / 0], l = [[-1 / 0, -1 / 0], [1 / 0, 1 / 0]], s = 250, c = interpolateZoom, d = dispatch("start", "zoom", "end"), p, f, g, b = 500, k = 150, x = 0, N = 10;
  function O(H) {
    H.property("__zoom", defaultTransform).on("wheel.zoom", E, { passive: !1 }).on("mousedown.zoom", C).on("dblclick.zoom", I).filter(r).on("touchstart.zoom", v).on("touchmove.zoom", M).on("touchend.zoom touchcancel.zoom", $).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  O.transform = function(H, X, te, oe) {
    var ne = H.selection ? H.selection() : H;
    ne.property("__zoom", defaultTransform), H !== ne ? P(H, X, te, oe) : ne.interrupt().each(function() {
      V(this, arguments).event(oe).start().zoom(null, typeof X == "function" ? X.apply(this, arguments) : X).end();
    });
  }, O.scaleBy = function(H, X, te, oe) {
    O.scaleTo(H, function() {
      var ne = this.__zoom.k, ie = typeof X == "function" ? X.apply(this, arguments) : X;
      return ne * ie;
    }, te, oe);
  }, O.scaleTo = function(H, X, te, oe) {
    O.transform(H, function() {
      var ne = o.apply(this, arguments), ie = this.__zoom, se = te == null ? z(ne) : typeof te == "function" ? te.apply(this, arguments) : te, pe = ie.invert(se), he = typeof X == "function" ? X.apply(this, arguments) : X;
      return n(ee(m(ie, he), se, pe), ne, l);
    }, te, oe);
  }, O.translateBy = function(H, X, te, oe) {
    O.transform(H, function() {
      return n(this.__zoom.translate(
        typeof X == "function" ? X.apply(this, arguments) : X,
        typeof te == "function" ? te.apply(this, arguments) : te
      ), o.apply(this, arguments), l);
    }, null, oe);
  }, O.translateTo = function(H, X, te, oe, ne) {
    O.transform(H, function() {
      var ie = o.apply(this, arguments), se = this.__zoom, pe = oe == null ? z(ie) : typeof oe == "function" ? oe.apply(this, arguments) : oe;
      return n(identity.translate(pe[0], pe[1]).scale(se.k).translate(
        typeof X == "function" ? -X.apply(this, arguments) : -X,
        typeof te == "function" ? -te.apply(this, arguments) : -te
      ), ie, l);
    }, oe, ne);
  };
  function m(H, X) {
    return X = Math.max(a[0], Math.min(a[1], X)), X === H.k ? H : new Transform(X, H.x, H.y);
  }
  function ee(H, X, te) {
    var oe = X[0] - te[0] * H.k, ne = X[1] - te[1] * H.k;
    return oe === H.x && ne === H.y ? H : new Transform(H.k, oe, ne);
  }
  function z(H) {
    return [(+H[0][0] + +H[1][0]) / 2, (+H[0][1] + +H[1][1]) / 2];
  }
  function P(H, X, te, oe) {
    H.on("start.zoom", function() {
      V(this, arguments).event(oe).start();
    }).on("interrupt.zoom end.zoom", function() {
      V(this, arguments).event(oe).end();
    }).tween("zoom", function() {
      var ne = this, ie = arguments, se = V(ne, ie).event(oe), pe = o.apply(ne, ie), he = te == null ? z(pe) : typeof te == "function" ? te.apply(ne, ie) : te, ae = Math.max(pe[1][0] - pe[0][0], pe[1][1] - pe[0][1]), le = ne.__zoom, fe = typeof X == "function" ? X.apply(ne, ie) : X, Ce = c(le.invert(he).concat(ae / le.k), fe.invert(he).concat(ae / fe.k));
      return function(Be) {
        if (Be === 1)
          Be = fe;
        else {
          var De = Ce(Be), Fe = ae / De[2];
          Be = new Transform(Fe, he[0] - De[0] * Fe, he[1] - De[1] * Fe);
        }
        se.zoom(null, Be);
      };
    });
  }
  function V(H, X, te) {
    return !te && H.__zooming || new U(H, X);
  }
  function U(H, X) {
    this.that = H, this.args = X, this.active = 0, this.sourceEvent = null, this.extent = o.apply(H, X), this.taps = 0;
  }
  U.prototype = {
    event: function(H) {
      return H && (this.sourceEvent = H), this;
    },
    start: function() {
      return ++this.active === 1 && (this.that.__zooming = this, this.emit("start")), this;
    },
    zoom: function(H, X) {
      return this.mouse && H !== "mouse" && (this.mouse[1] = X.invert(this.mouse[0])), this.touch0 && H !== "touch" && (this.touch0[1] = X.invert(this.touch0[0])), this.touch1 && H !== "touch" && (this.touch1[1] = X.invert(this.touch1[0])), this.that.__zoom = X, this.emit("zoom"), this;
    },
    end: function() {
      return --this.active === 0 && (delete this.that.__zooming, this.emit("end")), this;
    },
    emit: function(H) {
      var X = select(this.that).datum();
      d.call(
        H,
        this.that,
        new ZoomEvent(H, {
          sourceEvent: this.sourceEvent,
          target: O,
          type: H,
          transform: this.that.__zoom,
          dispatch: d
        }),
        X
      );
    }
  };
  function E(H, ...X) {
    if (!e.apply(this, arguments))
      return;
    var te = V(this, X).event(H), oe = this.__zoom, ne = Math.max(a[0], Math.min(a[1], oe.k * Math.pow(2, t.apply(this, arguments)))), ie = pointer(H);
    if (te.wheel)
      (te.mouse[0][0] !== ie[0] || te.mouse[0][1] !== ie[1]) && (te.mouse[1] = oe.invert(te.mouse[0] = ie)), clearTimeout(te.wheel);
    else {
      if (oe.k === ne)
        return;
      te.mouse = [ie, oe.invert(ie)], interrupt(this), te.start();
    }
    noevent(H), te.wheel = setTimeout(se, k), te.zoom("mouse", n(ee(m(oe, ne), te.mouse[0], te.mouse[1]), te.extent, l));
    function se() {
      te.wheel = null, te.end();
    }
  }
  function C(H, ...X) {
    if (g || !e.apply(this, arguments))
      return;
    var te = H.currentTarget, oe = V(this, X, !0).event(H), ne = select(H.view).on("mousemove.zoom", he, !0).on("mouseup.zoom", ae, !0), ie = pointer(H, te), se = H.clientX, pe = H.clientY;
    dragDisable(H.view), nopropagation(H), oe.mouse = [ie, this.__zoom.invert(ie)], interrupt(this), oe.start();
    function he(le) {
      if (noevent(le), !oe.moved) {
        var fe = le.clientX - se, Ce = le.clientY - pe;
        oe.moved = fe * fe + Ce * Ce > x;
      }
      oe.event(le).zoom("mouse", n(ee(oe.that.__zoom, oe.mouse[0] = pointer(le, te), oe.mouse[1]), oe.extent, l));
    }
    function ae(le) {
      ne.on("mousemove.zoom mouseup.zoom", null), yesdrag(le.view, oe.moved), noevent(le), oe.event(le).end();
    }
  }
  function I(H, ...X) {
    if (e.apply(this, arguments)) {
      var te = this.__zoom, oe = pointer(H.changedTouches ? H.changedTouches[0] : H, this), ne = te.invert(oe), ie = te.k * (H.shiftKey ? 0.5 : 2), se = n(ee(m(te, ie), oe, ne), o.apply(this, X), l);
      noevent(H), s > 0 ? select(this).transition().duration(s).call(P, se, oe, H) : select(this).call(O.transform, se, oe, H);
    }
  }
  function v(H, ...X) {
    if (e.apply(this, arguments)) {
      var te = H.touches, oe = te.length, ne = V(this, X, H.changedTouches.length === oe).event(H), ie, se, pe, he;
      for (nopropagation(H), se = 0; se < oe; ++se)
        pe = te[se], he = pointer(pe, this), he = [he, this.__zoom.invert(he), pe.identifier], ne.touch0 ? !ne.touch1 && ne.touch0[2] !== he[2] && (ne.touch1 = he, ne.taps = 0) : (ne.touch0 = he, ie = !0, ne.taps = 1 + !!p);
      p && (p = clearTimeout(p)), ie && (ne.taps < 2 && (f = he[0], p = setTimeout(function() {
        p = null;
      }, b)), interrupt(this), ne.start());
    }
  }
  function M(H, ...X) {
    if (this.__zooming) {
      var te = V(this, X).event(H), oe = H.changedTouches, ne = oe.length, ie, se, pe, he;
      for (noevent(H), ie = 0; ie < ne; ++ie)
        se = oe[ie], pe = pointer(se, this), te.touch0 && te.touch0[2] === se.identifier ? te.touch0[0] = pe : te.touch1 && te.touch1[2] === se.identifier && (te.touch1[0] = pe);
      if (se = te.that.__zoom, te.touch1) {
        var ae = te.touch0[0], le = te.touch0[1], fe = te.touch1[0], Ce = te.touch1[1], Be = (Be = fe[0] - ae[0]) * Be + (Be = fe[1] - ae[1]) * Be, De = (De = Ce[0] - le[0]) * De + (De = Ce[1] - le[1]) * De;
        se = m(se, Math.sqrt(Be / De)), pe = [(ae[0] + fe[0]) / 2, (ae[1] + fe[1]) / 2], he = [(le[0] + Ce[0]) / 2, (le[1] + Ce[1]) / 2];
      } else if (te.touch0)
        pe = te.touch0[0], he = te.touch0[1];
      else
        return;
      te.zoom("touch", n(ee(se, pe, he), te.extent, l));
    }
  }
  function $(H, ...X) {
    if (this.__zooming) {
      var te = V(this, X).event(H), oe = H.changedTouches, ne = oe.length, ie, se;
      for (nopropagation(H), g && clearTimeout(g), g = setTimeout(function() {
        g = null;
      }, b), ie = 0; ie < ne; ++ie)
        se = oe[ie], te.touch0 && te.touch0[2] === se.identifier ? delete te.touch0 : te.touch1 && te.touch1[2] === se.identifier && delete te.touch1;
      if (te.touch1 && !te.touch0 && (te.touch0 = te.touch1, delete te.touch1), te.touch0)
        te.touch0[1] = this.__zoom.invert(te.touch0[0]);
      else if (te.end(), te.taps === 2 && (se = pointer(se, this), Math.hypot(f[0] - se[0], f[1] - se[1]) < N)) {
        var pe = select(this).on("dblclick.zoom");
        pe && pe.apply(this, arguments);
      }
    }
  }
  return O.wheelDelta = function(H) {
    return arguments.length ? (t = typeof H == "function" ? H : constant(+H), O) : t;
  }, O.filter = function(H) {
    return arguments.length ? (e = typeof H == "function" ? H : constant(!!H), O) : e;
  }, O.touchable = function(H) {
    return arguments.length ? (r = typeof H == "function" ? H : constant(!!H), O) : r;
  }, O.extent = function(H) {
    return arguments.length ? (o = typeof H == "function" ? H : constant([[+H[0][0], +H[0][1]], [+H[1][0], +H[1][1]]]), O) : o;
  }, O.scaleExtent = function(H) {
    return arguments.length ? (a[0] = +H[0], a[1] = +H[1], O) : [a[0], a[1]];
  }, O.translateExtent = function(H) {
    return arguments.length ? (l[0][0] = +H[0][0], l[1][0] = +H[1][0], l[0][1] = +H[0][1], l[1][1] = +H[1][1], O) : [[l[0][0], l[0][1]], [l[1][0], l[1][1]]];
  }, O.constrain = function(H) {
    return arguments.length ? (n = H, O) : n;
  }, O.duration = function(H) {
    return arguments.length ? (s = +H, O) : s;
  }, O.interpolate = function(H) {
    return arguments.length ? (c = H, O) : c;
  }, O.on = function() {
    var H = d.on.apply(d, arguments);
    return H === d ? O : H;
  }, O.clickDistance = function(H) {
    return arguments.length ? (x = (H = +H) * H, O) : Math.sqrt(x);
  }, O.tapDistance = function(H) {
    return arguments.length ? (N = +H, O) : N;
  }, O;
}
var Position = /* @__PURE__ */ ((e) => (e.Left = "left", e.Top = "top", e.Right = "right", e.Bottom = "bottom", e))(Position || {}), SelectionMode = /* @__PURE__ */ ((e) => (e.Partial = "partial", e.Full = "full", e))(SelectionMode || {}), ConnectionLineType = /* @__PURE__ */ ((e) => (e.Bezier = "default", e.SimpleBezier = "simple-bezier", e.Straight = "straight", e.Step = "step", e.SmoothStep = "smoothstep", e))(ConnectionLineType || {}), ConnectionMode = /* @__PURE__ */ ((e) => (e.Strict = "strict", e.Loose = "loose", e))(ConnectionMode || {}), MarkerType = /* @__PURE__ */ ((e) => (e.Arrow = "arrow", e.ArrowClosed = "arrowclosed", e))(MarkerType || {}), PanOnScrollMode = /* @__PURE__ */ ((e) => (e.Free = "free", e.Vertical = "vertical", e.Horizontal = "horizontal", e))(PanOnScrollMode || {});
function isInputDOMNode(e) {
  var o, n;
  const t = ((n = (o = e.composedPath) == null ? void 0 : o.call(e)) == null ? void 0 : n[0]) || e.target, r = typeof (t == null ? void 0 : t.hasAttribute) == "function" ? t.hasAttribute("contenteditable") : !1, a = typeof (t == null ? void 0 : t.closest) == "function" ? t.closest(".nokey") : null;
  return ["INPUT", "SELECT", "TEXTAREA"].includes(t == null ? void 0 : t.nodeName) || r || !!a;
}
function wasModifierPressed(e) {
  return e.ctrlKey || e.metaKey || e.shiftKey;
}
function isKeyMatch(e, o, n, t) {
  const r = o.split("+").map((a) => a.trim().toLowerCase());
  return r.length === 1 ? e.toLowerCase() === o.toLowerCase() : (t ? n.delete(e.toLowerCase()) : n.add(e.toLowerCase()), r.every(
    (a, l) => n.has(a) && Array.from(n.values())[l] === r[l]
  ));
}
function createKeyPredicate(e, o) {
  return (n) => {
    if (!n.code && !n.key)
      return !1;
    const t = useKeyOrCode(n.code, e);
    return Array.isArray(e) ? e.some((r) => isKeyMatch(n[t], r, o, n.type === "keyup")) : isKeyMatch(n[t], e, o, n.type === "keyup");
  };
}
function useKeyOrCode(e, o) {
  return typeof o == "string" ? e === o ? "code" : "key" : o.includes(e) ? "code" : "key";
}
function useKeyPress(e, o) {
  const n = toRef(() => toValue$2(o == null ? void 0 : o.actInsideInputWithModifier) ?? !1), t = toRef(() => toValue$2(o == null ? void 0 : o.target) ?? window), r = ref(toValue$2(e) === !0);
  let a = !1;
  const l = /* @__PURE__ */ new Set();
  let s = d(toValue$2(e));
  watch(
    () => toValue$2(e),
    (p, f) => {
      typeof f == "boolean" && typeof p != "boolean" && c(), s = d(p);
    },
    {
      immediate: !0
    }
  ), onMounted(() => {
    useEventListener(window, ["blur", "contextmenu"], c);
  }), onKeyStroke(
    (...p) => s(...p),
    (p) => {
      a = wasModifierPressed(p), !((!a || a && !n.value) && isInputDOMNode(p)) && (p.preventDefault(), r.value = !0);
    },
    { eventName: "keydown", target: t }
  ), onKeyStroke(
    (...p) => s(...p),
    (p) => {
      if (r.value) {
        if ((!a || a && !n.value) && isInputDOMNode(p))
          return;
        c();
      }
    },
    { eventName: "keyup", target: t }
  );
  function c() {
    a = !1, l.clear(), r.value = !1;
  }
  function d(p) {
    return p === null ? (c(), () => !1) : typeof p == "boolean" ? (c(), r.value = p, () => !1) : Array.isArray(p) || typeof p == "string" ? createKeyPredicate(p, l) : p;
  }
  return r;
}
const ARIA_NODE_DESC_KEY = "vue-flow__node-desc", ARIA_EDGE_DESC_KEY = "vue-flow__edge-desc", ARIA_LIVE_MESSAGE = "vue-flow__aria-live", elementSelectionKeys = ["Enter", " ", "Escape"], arrowKeyDiffs = {
  ArrowUp: { x: 0, y: -1 },
  ArrowDown: { x: 0, y: 1 },
  ArrowLeft: { x: -1, y: 0 },
  ArrowRight: { x: 1, y: 0 }
};
function nodeToRect(e) {
  return {
    ...e.computedPosition || { x: 0, y: 0 },
    width: e.dimensions.width || 0,
    height: e.dimensions.height || 0
  };
}
function getOverlappingArea(e, o) {
  const n = Math.max(0, Math.min(e.x + e.width, o.x + o.width) - Math.max(e.x, o.x)), t = Math.max(0, Math.min(e.y + e.height, o.y + o.height) - Math.max(e.y, o.y));
  return Math.ceil(n * t);
}
function getDimensions(e) {
  return {
    width: e.offsetWidth,
    height: e.offsetHeight
  };
}
function clamp(e, o = 0, n = 1) {
  return Math.min(Math.max(e, o), n);
}
function clampPosition(e, o) {
  return {
    x: clamp(e.x, o[0][0], o[1][0]),
    y: clamp(e.y, o[0][1], o[1][1])
  };
}
function getHostForElement(e) {
  const o = e.getRootNode();
  return "elementFromPoint" in o ? o : window.document;
}
function isEdge(e) {
  return e && typeof e == "object" && "id" in e && "source" in e && "target" in e;
}
function isNode(e) {
  return e && typeof e == "object" && "id" in e && "position" in e && !isEdge(e);
}
function isGraphNode(e) {
  return isNode(e) && "computedPosition" in e;
}
function isNumeric(e) {
  return !Number.isNaN(e) && Number.isFinite(e);
}
function isRect(e) {
  return isNumeric(e.width) && isNumeric(e.height) && isNumeric(e.x) && isNumeric(e.y);
}
function parseNode(e, o, n) {
  const t = {
    id: e.id.toString(),
    type: e.type ?? "default",
    dimensions: markRaw({
      width: 0,
      height: 0
    }),
    computedPosition: markRaw({
      z: 0,
      ...e.position
    }),
    // todo: shouldn't be defined initially, as we want to use handleBounds to check if a node was actually initialized or not
    handleBounds: {
      source: [],
      target: []
    },
    draggable: void 0,
    selectable: void 0,
    connectable: void 0,
    focusable: void 0,
    selected: !1,
    dragging: !1,
    resizing: !1,
    initialized: !1,
    isParent: !1,
    position: {
      x: 0,
      y: 0
    },
    data: isDef(e.data) ? e.data : {},
    events: markRaw(isDef(e.events) ? e.events : {})
  };
  return Object.assign(o ?? t, e, { id: e.id.toString(), parentNode: n });
}
function parseEdge(e, o, n) {
  var t, r;
  const a = {
    id: e.id.toString(),
    type: e.type ?? (o == null ? void 0 : o.type) ?? "default",
    source: e.source.toString(),
    target: e.target.toString(),
    sourceHandle: (t = e.sourceHandle) == null ? void 0 : t.toString(),
    targetHandle: (r = e.targetHandle) == null ? void 0 : r.toString(),
    updatable: e.updatable ?? (n == null ? void 0 : n.updatable),
    selectable: e.selectable ?? (n == null ? void 0 : n.selectable),
    focusable: e.focusable ?? (n == null ? void 0 : n.focusable),
    data: isDef(e.data) ? e.data : {},
    events: markRaw(isDef(e.events) ? e.events : {}),
    label: e.label ?? "",
    interactionWidth: e.interactionWidth ?? (n == null ? void 0 : n.interactionWidth),
    ...n ?? {}
  };
  return Object.assign(o ?? a, e, { id: e.id.toString() });
}
function getConnectedElements(e, o, n, t) {
  const r = typeof e == "string" ? e : e.id, a = /* @__PURE__ */ new Set(), l = t === "source" ? "target" : "source";
  for (const s of n)
    s[l] === r && a.add(s[t]);
  return o.filter((s) => a.has(s.id));
}
function getOutgoers(...e) {
  if (e.length === 3) {
    const [a, l, s] = e;
    return getConnectedElements(a, l, s, "target");
  }
  const [o, n] = e, t = typeof o == "string" ? o : o.id;
  return n.filter((a) => isEdge(a) && a.source === t).map((a) => n.find((l) => isNode(l) && l.id === a.target));
}
function getIncomers(...e) {
  if (e.length === 3) {
    const [a, l, s] = e;
    return getConnectedElements(a, l, s, "source");
  }
  const [o, n] = e, t = typeof o == "string" ? o : o.id;
  return n.filter((a) => isEdge(a) && a.target === t).map((a) => n.find((l) => isNode(l) && l.id === a.source));
}
function getEdgeId({ source: e, sourceHandle: o, target: n, targetHandle: t }) {
  return `vueflow__edge-${e}${o ?? ""}-${n}${t ?? ""}`;
}
function connectionExists(e, o) {
  return o.some(
    (n) => isEdge(n) && n.source === e.source && n.target === e.target && (n.sourceHandle === e.sourceHandle || !n.sourceHandle && !e.sourceHandle) && (n.targetHandle === e.targetHandle || !n.targetHandle && !e.targetHandle)
  );
}
function rendererPointToPoint({ x: e, y: o }, { x: n, y: t, zoom: r }) {
  return {
    x: e * r + n,
    y: o * r + t
  };
}
function pointToRendererPoint({ x: e, y: o }, { x: n, y: t, zoom: r }, a = !1, [l, s] = [1, 1]) {
  const c = {
    x: (e - n) / r,
    y: (o - t) / r
  };
  return a ? {
    x: l * Math.round(c.x / l),
    y: s * Math.round(c.y / s)
  } : c;
}
function getBoundsOfBoxes(e, o) {
  return {
    x: Math.min(e.x, o.x),
    y: Math.min(e.y, o.y),
    x2: Math.max(e.x2, o.x2),
    y2: Math.max(e.y2, o.y2)
  };
}
function rectToBox({ x: e, y: o, width: n, height: t }) {
  return {
    x: e,
    y: o,
    x2: e + n,
    y2: o + t
  };
}
function boxToRect({ x: e, y: o, x2: n, y2: t }) {
  return {
    x: e,
    y: o,
    width: n - e,
    height: t - o
  };
}
function getRectOfNodes(e) {
  let o = {
    x: Number.POSITIVE_INFINITY,
    y: Number.POSITIVE_INFINITY,
    x2: Number.NEGATIVE_INFINITY,
    y2: Number.NEGATIVE_INFINITY
  };
  for (let n = 0; n < e.length; n++) {
    const t = e[n];
    o = getBoundsOfBoxes(
      o,
      rectToBox({
        ...t.computedPosition,
        ...t.dimensions
      })
    );
  }
  return boxToRect(o);
}
function getNodesInside(e, o, n = { x: 0, y: 0, zoom: 1 }, t = !1, r = !1) {
  const a = {
    ...pointToRendererPoint(o, n),
    width: o.width / n.zoom,
    height: o.height / n.zoom
  }, l = [];
  for (const s of e) {
    const { dimensions: c, selectable: d = !0, hidden: p = !1 } = s, f = c.width ?? s.width ?? null, g = c.height ?? s.height ?? null;
    if (r && !d || p)
      continue;
    const b = getOverlappingArea(a, nodeToRect(s)), k = f === null || g === null, x = t && b > 0, N = (f ?? 0) * (g ?? 0);
    (k || x || b >= N || s.dragging) && l.push(s);
  }
  return l;
}
function getConnectedEdges(e, o) {
  const n = /* @__PURE__ */ new Set();
  if (typeof e == "string")
    n.add(e);
  else if (e.length >= 1)
    for (const t of e)
      n.add(t.id);
  return o.filter((t) => n.has(t.source) || n.has(t.target));
}
function getTransformForBounds(e, o, n, t, r, a = 0.1, l = { x: 0, y: 0 }) {
  const s = o / (e.width * (1 + a)), c = n / (e.height * (1 + a)), d = Math.min(s, c), p = clamp(d, t, r), f = e.x + e.width / 2, g = e.y + e.height / 2, b = o / 2 - f * p + (l.x ?? 0), k = n / 2 - g * p + (l.y ?? 0);
  return { x: b, y: k, zoom: p };
}
function getXYZPos(e, o) {
  return {
    x: o.x + e.x,
    y: o.y + e.y,
    z: (e.z > o.z ? e.z : o.z) + 1
  };
}
function isParentSelected(e, o) {
  if (!e.parentNode)
    return !1;
  const n = o(e.parentNode);
  return n ? n.selected ? !0 : isParentSelected(n, o) : !1;
}
function getMarkerId(e, o) {
  return typeof e > "u" ? "" : typeof e == "string" ? e : `${o ? `${o}__` : ""}${Object.keys(e).sort().map((t) => `${t}=${e[t]}`).join("&")}`;
}
function calcAutoPanVelocity(e, o, n) {
  return e < o ? clamp(Math.abs(e - o), 1, o) / o : e > n ? -clamp(Math.abs(e - n), 1, o) / o : 0;
}
function calcAutoPan(e, o, n = 15, t = 40) {
  const r = calcAutoPanVelocity(e.x, t, o.width - t) * n, a = calcAutoPanVelocity(e.y, t, o.height - t) * n;
  return [r, a];
}
function handleParentExpand(e, o) {
  if (o) {
    const n = e.position.x + e.dimensions.width - o.dimensions.width, t = e.position.y + e.dimensions.height - o.dimensions.height;
    if (n > 0 || t > 0 || e.position.x < 0 || e.position.y < 0) {
      let r = {};
      if (typeof o.style == "function" ? r = { ...o.style(o) } : o.style && (r = { ...o.style }), r.width = r.width ?? `${o.dimensions.width}px`, r.height = r.height ?? `${o.dimensions.height}px`, n > 0)
        if (typeof r.width == "string") {
          const a = Number(r.width.replace("px", ""));
          r.width = `${a + n}px`;
        } else
          r.width += n;
      if (t > 0)
        if (typeof r.height == "string") {
          const a = Number(r.height.replace("px", ""));
          r.height = `${a + t}px`;
        } else
          r.height += t;
      if (e.position.x < 0) {
        const a = Math.abs(e.position.x);
        if (o.position.x = o.position.x - a, typeof r.width == "string") {
          const l = Number(r.width.replace("px", ""));
          r.width = `${l + a}px`;
        } else
          r.width += a;
        e.position.x = 0;
      }
      if (e.position.y < 0) {
        const a = Math.abs(e.position.y);
        if (o.position.y = o.position.y - a, typeof r.height == "string") {
          const l = Number(r.height.replace("px", ""));
          r.height = `${l + a}px`;
        } else
          r.height += a;
        e.position.y = 0;
      }
      o.dimensions.width = Number(r.width.toString().replace("px", "")), o.dimensions.height = Number(r.height.toString().replace("px", "")), typeof o.style == "function" ? o.style = (a) => {
        const l = o.style;
        return {
          ...l(a),
          ...r
        };
      } : o.style = {
        ...o.style,
        ...r
      };
    }
  }
}
function applyChanges(e, o) {
  var n, t;
  const r = e.filter((l) => l.type === "add" || l.type === "remove");
  for (const l of r)
    if (l.type === "add")
      o.findIndex((c) => c.id === l.item.id) === -1 && o.push(l.item);
    else if (l.type === "remove") {
      const s = o.findIndex((c) => c.id === l.id);
      s !== -1 && o.splice(s, 1);
    }
  const a = o.map((l) => l.id);
  for (const l of o)
    for (const s of e)
      if (s.id === l.id)
        switch (s.type) {
          case "select":
            l.selected = s.selected;
            break;
          case "position":
            if (isGraphNode(l) && (typeof s.position < "u" && (l.position = s.position), typeof s.dragging < "u" && (l.dragging = s.dragging), l.expandParent && l.parentNode)) {
              const c = o[a.indexOf(l.parentNode)];
              c && isGraphNode(c) && handleParentExpand(l, c);
            }
            break;
          case "dimensions":
            if (isGraphNode(l) && (typeof s.dimensions < "u" && (l.dimensions = s.dimensions), typeof s.updateStyle < "u" && (l.style = {
              ...l.style || {},
              width: `${(n = s.dimensions) == null ? void 0 : n.width}px`,
              height: `${(t = s.dimensions) == null ? void 0 : t.height}px`
            }), typeof s.resizing < "u" && (l.resizing = s.resizing), l.expandParent && l.parentNode)) {
              const c = o[a.indexOf(l.parentNode)];
              c && isGraphNode(c) && (!!c.dimensions.width && !!c.dimensions.height ? handleParentExpand(l, c) : nextTick(() => {
                handleParentExpand(l, c);
              }));
            }
            break;
        }
  return o;
}
function createSelectionChange(e, o) {
  return {
    id: e,
    type: "select",
    selected: o
  };
}
function createAdditionChange(e) {
  return {
    item: e,
    type: "add"
  };
}
function createNodeRemoveChange(e) {
  return {
    id: e,
    type: "remove"
  };
}
function createEdgeRemoveChange(e, o, n, t, r) {
  return {
    id: e,
    source: o,
    target: n,
    sourceHandle: t || null,
    targetHandle: r || null,
    type: "remove"
  };
}
function getSelectionChanges(e, o = /* @__PURE__ */ new Set(), n = !1) {
  const t = [];
  for (const [r, a] of e) {
    const l = o.has(r);
    !(a.selected === void 0 && !l) && a.selected !== l && (n && (a.selected = l), t.push(createSelectionChange(a.id, l)));
  }
  return t;
}
function createExtendedEventHook(e) {
  const o = /* @__PURE__ */ new Set();
  let n = !1;
  const t = () => o.size > 0;
  e && (n = !0, o.add(e));
  const r = (s) => {
    o.delete(s);
  };
  return {
    on: (s) => {
      e && n && o.delete(e), o.add(s);
      const c = () => {
        r(s), e && n && o.add(e);
      };
      return tryOnScopeDispose(c), {
        off: c
      };
    },
    off: r,
    trigger: (s) => Promise.all(Array.from(o).map((c) => c(s))),
    hasListeners: t,
    fns: o
  };
}
function hasSelector(e, o, n) {
  let t = e;
  do {
    if (t && t.matches(o))
      return !0;
    if (t === n)
      return !1;
    t = t.parentElement;
  } while (t);
  return !1;
}
function getDragItems(e, o, n, t, r) {
  var a, l;
  const s = [];
  for (const c of e)
    (c.selected || c.id === r) && (!c.parentNode || !isParentSelected(c, t)) && (c.draggable || o && typeof c.draggable > "u") && s.push(
      markRaw({
        id: c.id,
        position: c.position || { x: 0, y: 0 },
        distance: {
          x: n.x - ((a = c.computedPosition) == null ? void 0 : a.x) || 0,
          y: n.y - ((l = c.computedPosition) == null ? void 0 : l.y) || 0
        },
        from: c.computedPosition,
        extent: c.extent,
        parentNode: c.parentNode,
        dimensions: c.dimensions,
        expandParent: c.expandParent
      })
    );
  return s;
}
function getEventHandlerParams({
  id: e,
  dragItems: o,
  findNode: n
}) {
  const t = [];
  for (const r of o) {
    const a = n(r.id);
    a && t.push(a);
  }
  return [e ? t.find((r) => r.id === e) : t[0], t];
}
function getExtentPadding(e) {
  if (Array.isArray(e))
    switch (e.length) {
      case 1:
        return [e[0], e[0], e[0], e[0]];
      case 2:
        return [e[0], e[1], e[0], e[1]];
      case 3:
        return [e[0], e[1], e[2], e[1]];
      case 4:
        return e;
      default:
        return [0, 0, 0, 0];
    }
  return [e, e, e, e];
}
function getParentExtent(e, o, n) {
  const [t, r, a, l] = typeof e != "string" ? getExtentPadding(e.padding) : [0, 0, 0, 0];
  return n && typeof n.computedPosition.x < "u" && typeof n.computedPosition.y < "u" && typeof n.dimensions.width < "u" && typeof n.dimensions.height < "u" ? [
    [n.computedPosition.x + l, n.computedPosition.y + t],
    [
      n.computedPosition.x + n.dimensions.width - r,
      n.computedPosition.y + n.dimensions.height - a
    ]
  ] : !1;
}
function getExtent(e, o, n, t) {
  let r = e.extent || n;
  if ((r === "parent" || !Array.isArray(r) && (r == null ? void 0 : r.range) === "parent") && !e.expandParent)
    if (e.parentNode && t && e.dimensions.width && e.dimensions.height) {
      const a = getParentExtent(r, e, t);
      a && (r = a);
    } else
      o(new VueFlowError(ErrorCode.NODE_EXTENT_INVALID, e.id)), r = n;
  else if (Array.isArray(r)) {
    const a = (t == null ? void 0 : t.computedPosition.x) || 0, l = (t == null ? void 0 : t.computedPosition.y) || 0;
    r = [
      [r[0][0] + a, r[0][1] + l],
      [r[1][0] + a, r[1][1] + l]
    ];
  } else if (r !== "parent" && (r != null && r.range) && Array.isArray(r.range)) {
    const [a, l, s, c] = getExtentPadding(r.padding), d = (t == null ? void 0 : t.computedPosition.x) || 0, p = (t == null ? void 0 : t.computedPosition.y) || 0;
    r = [
      [r.range[0][0] + d + c, r.range[0][1] + p + a],
      [r.range[1][0] + d - l, r.range[1][1] + p - s]
    ];
  }
  return r === "parent" ? [
    [Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY],
    [Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY]
  ] : r;
}
function clampNodeExtent({ width: e, height: o }, n) {
  return [n[0], [n[1][0] - (e || 0), n[1][1] - (o || 0)]];
}
function calcNextPosition(e, o, n, t, r) {
  const a = clampNodeExtent(e.dimensions, getExtent(e, n, t, r)), l = clampPosition(o, a);
  return {
    position: {
      x: l.x - ((r == null ? void 0 : r.computedPosition.x) || 0),
      y: l.y - ((r == null ? void 0 : r.computedPosition.y) || 0)
    },
    computedPosition: l
  };
}
function getHandlePosition(e, o, n = Position.Left) {
  const t = ((o == null ? void 0 : o.x) ?? 0) + e.computedPosition.x, r = ((o == null ? void 0 : o.y) ?? 0) + e.computedPosition.y, { width: a, height: l } = o ?? getNodeDimensions(e);
  switch ((o == null ? void 0 : o.position) ?? n) {
    case Position.Top:
      return {
        x: t + a / 2,
        y: r
      };
    case Position.Right:
      return {
        x: t + a,
        y: r + l / 2
      };
    case Position.Bottom:
      return {
        x: t + a / 2,
        y: r + l
      };
    case Position.Left:
      return {
        x: t,
        y: r + l / 2
      };
  }
}
function getHandle(e = [], o) {
  return e.length && (o ? e.find((n) => n.id === o) : e[0]) || null;
}
function isEdgeVisible({
  sourcePos: e,
  targetPos: o,
  sourceWidth: n,
  sourceHeight: t,
  targetWidth: r,
  targetHeight: a,
  width: l,
  height: s,
  viewport: c
}) {
  const d = {
    x: Math.min(e.x, o.x),
    y: Math.min(e.y, o.y),
    x2: Math.max(e.x + n, o.x + r),
    y2: Math.max(e.y + t, o.y + a)
  };
  d.x === d.x2 && (d.x2 += 1), d.y === d.y2 && (d.y2 += 1);
  const p = rectToBox({
    x: (0 - c.x) / c.zoom,
    y: (0 - c.y) / c.zoom,
    width: l / c.zoom,
    height: s / c.zoom
  }), f = Math.max(0, Math.min(p.x2, d.x2) - Math.max(p.x, d.x)), g = Math.max(0, Math.min(p.y2, d.y2) - Math.max(p.y, d.y));
  return Math.ceil(f * g) > 0;
}
function getEdgeZIndex(e, o, n = !1) {
  const t = typeof e.zIndex == "number";
  let r = t ? e.zIndex : 0;
  const a = o(e.source), l = o(e.target);
  return !a || !l ? 0 : (n && (r = t ? e.zIndex : Math.max(a.computedPosition.z || 0, l.computedPosition.z || 0)), r);
}
var ErrorCode = /* @__PURE__ */ ((e) => (e.MISSING_STYLES = "MISSING_STYLES", e.MISSING_VIEWPORT_DIMENSIONS = "MISSING_VIEWPORT_DIMENSIONS", e.NODE_INVALID = "NODE_INVALID", e.NODE_NOT_FOUND = "NODE_NOT_FOUND", e.NODE_MISSING_PARENT = "NODE_MISSING_PARENT", e.NODE_TYPE_MISSING = "NODE_TYPE_MISSING", e.NODE_EXTENT_INVALID = "NODE_EXTENT_INVALID", e.EDGE_INVALID = "EDGE_INVALID", e.EDGE_NOT_FOUND = "EDGE_NOT_FOUND", e.EDGE_SOURCE_MISSING = "EDGE_SOURCE_MISSING", e.EDGE_TARGET_MISSING = "EDGE_TARGET_MISSING", e.EDGE_TYPE_MISSING = "EDGE_TYPE_MISSING", e.EDGE_SOURCE_TARGET_SAME = "EDGE_SOURCE_TARGET_SAME", e.EDGE_SOURCE_TARGET_MISSING = "EDGE_SOURCE_TARGET_MISSING", e.EDGE_ORPHANED = "EDGE_ORPHANED", e.USEVUEFLOW_OPTIONS = "USEVUEFLOW_OPTIONS", e))(ErrorCode || {});
const messages = {
  MISSING_STYLES: () => "It seems that you haven't loaded the necessary styles. Please import '@vue-flow/core/dist/style.css' to ensure that the graph is rendered correctly",
  MISSING_VIEWPORT_DIMENSIONS: () => "The Vue Flow parent container needs a width and a height to render the graph",
  NODE_INVALID: (e) => `Node is invalid
Node: ${e}`,
  NODE_NOT_FOUND: (e) => `Node not found
Node: ${e}`,
  NODE_MISSING_PARENT: (e, o) => `Node is missing a parent
Node: ${e}
Parent: ${o}`,
  NODE_TYPE_MISSING: (e) => `Node type is missing
Type: ${e}`,
  NODE_EXTENT_INVALID: (e) => `Only child nodes can use a parent extent
Node: ${e}`,
  EDGE_INVALID: (e) => `An edge needs a source and a target
Edge: ${e}`,
  EDGE_SOURCE_MISSING: (e, o) => `Edge source is missing
Edge: ${e} 
Source: ${o}`,
  EDGE_TARGET_MISSING: (e, o) => `Edge target is missing
Edge: ${e} 
Target: ${o}`,
  EDGE_TYPE_MISSING: (e) => `Edge type is missing
Type: ${e}`,
  EDGE_SOURCE_TARGET_SAME: (e, o, n) => `Edge source and target are the same
Edge: ${e} 
Source: ${o} 
Target: ${n}`,
  EDGE_SOURCE_TARGET_MISSING: (e, o, n) => `Edge source or target is missing
Edge: ${e} 
Source: ${o} 
Target: ${n}`,
  EDGE_ORPHANED: (e) => `Edge was orphaned (suddenly missing source or target) and has been removed
Edge: ${e}`,
  EDGE_NOT_FOUND: (e) => `Edge not found
Edge: ${e}`,
  // deprecation errors
  USEVUEFLOW_OPTIONS: () => "The options parameter is deprecated and will be removed in the next major version. Please use the id parameter instead"
};
class VueFlowError extends Error {
  constructor(o, ...n) {
    var t;
    super((t = messages[o]) == null ? void 0 : t.call(messages, ...n)), this.name = "VueFlowError", this.code = o, this.args = n;
  }
}
function isMouseEvent(e) {
  return "clientX" in e;
}
function getEventPosition(e, o) {
  var n, t;
  const r = isMouseEvent(e), a = r ? e.clientX : (n = e.touches) == null ? void 0 : n[0].clientX, l = r ? e.clientY : (t = e.touches) == null ? void 0 : t[0].clientY;
  return {
    x: a - ((o == null ? void 0 : o.left) ?? 0),
    y: l - ((o == null ? void 0 : o.top) ?? 0)
  };
}
const isMacOs = () => {
  var e;
  return typeof navigator < "u" && ((e = navigator == null ? void 0 : navigator.userAgent) == null ? void 0 : e.indexOf("Mac")) >= 0;
};
function getNodeDimensions(e) {
  var o, n;
  return {
    width: ((o = e.dimensions) == null ? void 0 : o.width) ?? e.width ?? 0,
    height: ((n = e.dimensions) == null ? void 0 : n.height) ?? e.height ?? 0
  };
}
function defaultValidHandleResult() {
  return {
    handleDomNode: null,
    isValid: !1,
    connection: { source: "", target: "", sourceHandle: null, targetHandle: null },
    endHandle: null
  };
}
function resetRecentHandle(e) {
  e == null || e.classList.remove("valid", "connecting", "vue-flow__handle-valid", "vue-flow__handle-connecting");
}
function getHandles(e, o, n, t) {
  const r = [];
  for (const a of o[n] || [])
    if (`${e.id}-${a.id}-${n}` !== t) {
      const { x: l, y: s } = getHandlePosition(e, a);
      r.push({
        id: a.id || null,
        type: n,
        nodeId: e.id,
        x: l,
        y: s
      });
    }
  return r;
}
function getClosestHandle(e, o, n, t, r, a) {
  const { x: l, y: s } = getEventPosition(e), d = o.elementsFromPoint(l, s).find((k) => k.classList.contains("vue-flow__handle"));
  if (d) {
    const k = d.getAttribute("data-nodeid");
    if (k) {
      const x = getHandleType(void 0, d), N = d.getAttribute("data-handleid"), O = a({ nodeId: k, id: N, type: x });
      if (O) {
        const m = r.find((ee) => ee.nodeId === k && ee.type === x && ee.id === N);
        return {
          handle: {
            id: N,
            type: x,
            nodeId: k,
            x: (m == null ? void 0 : m.x) || n.x,
            y: (m == null ? void 0 : m.y) || n.y
          },
          validHandleResult: O
        };
      }
    }
  }
  let p = [], f = Number.POSITIVE_INFINITY;
  for (const k of r) {
    const x = Math.sqrt((k.x - n.x) ** 2 + (k.y - n.y) ** 2);
    if (x <= t) {
      const N = a(k);
      x <= f && (x < f ? p = [{ handle: k, validHandleResult: N }] : x === f && p.push({
        handle: k,
        validHandleResult: N
      }), f = x);
    }
  }
  if (!p.length)
    return { handle: null, validHandleResult: defaultValidHandleResult() };
  if (p.length === 1)
    return p[0];
  const g = p.some(({ validHandleResult: k }) => k.isValid), b = p.some(({ handle: k }) => k.type === "target");
  return p.find(
    ({ handle: k, validHandleResult: x }) => b ? k.type === "target" : g ? x.isValid : !0
  ) || p[0];
}
function isValidHandle(e, o, n, t, r, a, l, s, c, d, p) {
  const f = a === "target", g = s.querySelector(`.vue-flow__handle[data-id="${o == null ? void 0 : o.nodeId}-${o == null ? void 0 : o.id}-${o == null ? void 0 : o.type}"]`), { x: b, y: k } = getEventPosition(e), x = s.elementFromPoint(b, k), N = x != null && x.classList.contains("vue-flow__handle") ? x : g, O = defaultValidHandleResult();
  if (N) {
    O.handleDomNode = N;
    const m = getHandleType(void 0, N), ee = N.getAttribute("data-nodeid"), z = N.getAttribute("data-handleid"), P = N.classList.contains("connectable"), V = N.classList.contains("connectableend"), U = {
      source: f ? ee : t,
      sourceHandle: f ? z : r,
      target: f ? t : ee,
      targetHandle: f ? r : z
    };
    O.connection = U, P && V && (n === ConnectionMode.Strict ? f && m === "source" || !f && m === "target" : ee !== t || z !== r) && (O.isValid = l(U, {
      edges: c,
      nodes: d,
      sourceNode: p(U.source),
      targetNode: p(U.target)
    }), O.endHandle = {
      nodeId: ee,
      handleId: z,
      type: m,
      position: O.isValid ? N.getAttribute("data-handlepos") : null
    });
  }
  return O;
}
function getHandleLookup({ nodes: e, nodeId: o, handleId: n, handleType: t }) {
  const r = [];
  for (let a = 0; a < e.length; a++) {
    const l = e[a], { handleBounds: s } = l;
    let c = [], d = [];
    s && (c = getHandles(l, s, "source", `${o}-${n}-${t}`), d = getHandles(l, s, "target", `${o}-${n}-${t}`)), r.push(...c, ...d);
  }
  return r;
}
function getHandleType(e, o) {
  return e || (o != null && o.classList.contains("target") ? "target" : o != null && o.classList.contains("source") ? "source" : null);
}
function getConnectionStatus(e, o) {
  let n = null;
  return o ? n = "valid" : e && !o && (n = "invalid"), n;
}
const productionEnvs = ["production", "prod"];
function warn$1(e, ...o) {
  isDev() && console.warn(`[Vue Flow]: ${e}`, ...o);
}
function isDev() {
  return !productionEnvs.includes(process.env.NODE_ENV || "");
}
function getHandleBounds(e, o, n, t) {
  const r = o.querySelectorAll(`.vue-flow__handle${e}`);
  return Array.from(r).map((l) => {
    const s = l.getBoundingClientRect();
    return {
      id: l.getAttribute("data-handleid"),
      position: l.getAttribute("data-handlepos"),
      x: (s.left - n.left) / t,
      y: (s.top - n.top) / t,
      ...getDimensions(l)
    };
  });
}
function handleNodeClick(e, o, n, t, r, a = !1, l) {
  r.value = !1, e.selected ? (a || e.selected && o) && (t([e]), nextTick(() => {
    l.blur();
  })) : n([e]);
}
function isDef(e) {
  return typeof unref(e) < "u";
}
function addEdgeToStore(e, o, n, t) {
  if (!e || !e.source || !e.target)
    return n(new VueFlowError(ErrorCode.EDGE_INVALID, (e == null ? void 0 : e.id) ?? "[ID UNKNOWN]")), !1;
  let r;
  return isEdge(e) ? r = e : r = {
    ...e,
    id: getEdgeId(e)
  }, r = parseEdge(r, void 0, t), connectionExists(r, o) ? !1 : r;
}
function updateEdgeAction(e, o, n, t, r, a) {
  if (!o.source || !o.target)
    return a(new VueFlowError(ErrorCode.EDGE_INVALID, e.id)), !1;
  const l = t(e.id);
  if (!l)
    return a(new VueFlowError(ErrorCode.EDGE_NOT_FOUND, e.id)), !1;
  const { id: s, ...c } = e, d = {
    ...c,
    id: r ? getEdgeId(o) : s,
    source: o.source,
    target: o.target,
    sourceHandle: o.sourceHandle,
    targetHandle: o.targetHandle
  };
  return n.splice(n.indexOf(l), 1, d), d;
}
function createGraphNodes(e, o, n) {
  const t = {}, r = [];
  for (let a = 0; a < e.length; ++a) {
    const l = e[a];
    if (!isNode(l)) {
      n(
        new VueFlowError(ErrorCode.NODE_INVALID, l == null ? void 0 : l.id) || `[ID UNKNOWN|INDEX ${a}]`
      );
      continue;
    }
    const s = parseNode(l, o(l.id), l.parentNode);
    l.parentNode && (t[l.parentNode] = !0), r[a] = s;
  }
  for (const a of r) {
    const l = o(a.parentNode) || r.find((s) => s.id === a.parentNode);
    a.parentNode && !l && n(new VueFlowError(ErrorCode.NODE_MISSING_PARENT, a.id, a.parentNode)), (a.parentNode || t[a.id]) && (t[a.id] && (a.isParent = !0), l && (l.isParent = !0));
  }
  return r;
}
function updateConnectionLookup(e, o) {
  e.clear();
  for (const n of o) {
    const { id: t, source: r, target: a, sourceHandle: l = null, targetHandle: s = null } = n, c = `${r}-source-${l}`, d = `${a}-target-${s}`, p = e.get(c) || /* @__PURE__ */ new Map(), f = e.get(d) || /* @__PURE__ */ new Map(), g = markRaw({ edgeId: t, source: r, target: a, sourceHandle: l, targetHandle: s });
    e.set(c, p.set(`${a}-${s}`, g)), e.set(d, f.set(`${r}-${l}`, g));
  }
}
function createGraphEdges(e, o, n, t, r, a, l, s) {
  const c = [];
  for (const d of e) {
    const p = isEdge(d) ? d : addEdgeToStore(d, s, r, a);
    if (!p)
      continue;
    const f = n(p.source), g = n(p.target);
    if (!f || !g) {
      r(new VueFlowError(ErrorCode.EDGE_SOURCE_TARGET_MISSING, p.id, p.source, p.target));
      continue;
    }
    if (!f) {
      r(new VueFlowError(ErrorCode.EDGE_SOURCE_MISSING, p.id, p.source));
      continue;
    }
    if (!g) {
      r(new VueFlowError(ErrorCode.EDGE_TARGET_MISSING, p.id, p.target));
      continue;
    }
    if (o && !o(p, {
      edges: s,
      nodes: l,
      sourceNode: f,
      targetNode: g
    })) {
      r(new VueFlowError(ErrorCode.EDGE_INVALID, p.id));
      continue;
    }
    const b = t(p.id);
    c.push({
      ...parseEdge(p, b, a),
      sourceNode: f,
      targetNode: g
    });
  }
  return c;
}
const VueFlow = Symbol("vueFlow"), NodeId = Symbol("nodeId"), NodeRef = Symbol("nodeRef"), EdgeId = Symbol("edgeId"), EdgeRef = Symbol("edgeRef"), Slots = Symbol("slots");
function useDrag(e) {
  const {
    vueFlowRef: o,
    snapToGrid: n,
    snapGrid: t,
    noDragClassName: r,
    nodes: a,
    nodeExtent: l,
    nodeDragThreshold: s,
    viewport: c,
    autoPanOnNodeDrag: d,
    autoPanSpeed: p,
    nodesDraggable: f,
    panBy: g,
    findNode: b,
    multiSelectionActive: k,
    nodesSelectionActive: x,
    selectNodesOnDrag: N,
    removeSelectedElements: O,
    addSelectedNodes: m,
    updateNodePositions: ee,
    emits: z
  } = useVueFlow(), { onStart: P, onDrag: V, onStop: U, onClick: E, el: C, disabled: I, id: v, selectable: M, dragHandle: $ } = e, H = ref(!1);
  let X = [], te, oe = null, ne = { x: void 0, y: void 0 }, ie = { x: 0, y: 0 }, se = null, pe = !1, he = 0, ae = !1;
  const le = useGetPointerPosition(), fe = ({ x: xe, y: _e }) => {
    ne = { x: xe, y: _e };
    let Ee = !1;
    if (X = X.map((re) => {
      const ce = { x: xe - re.distance.x, y: _e - re.distance.y };
      n.value && (ce.x = t.value[0] * Math.round(ce.x / t.value[0]), ce.y = t.value[1] * Math.round(ce.y / t.value[1]));
      const { computedPosition: ye } = calcNextPosition(
        re,
        ce,
        z.error,
        l.value,
        re.parentNode ? b(re.parentNode) : void 0
      );
      return Ee = Ee || re.position.x !== ye.x || re.position.y !== ye.y, re.position = ye, re;
    }), !!Ee && (ee(X, !0, !0), H.value = !0, se)) {
      const [re, ce] = getEventHandlerParams({
        id: v,
        dragItems: X,
        findNode: b
      });
      V({ event: se, node: re, nodes: ce });
    }
  }, Ce = () => {
    if (!oe)
      return;
    const [xe, _e] = calcAutoPan(ie, oe, p.value);
    if (xe !== 0 || _e !== 0) {
      const Ee = {
        x: (ne.x ?? 0) - xe / c.value.zoom,
        y: (ne.y ?? 0) - _e / c.value.zoom
      };
      g({ x: xe, y: _e }) && fe(Ee);
    }
    he = requestAnimationFrame(Ce);
  }, Be = (xe, _e) => {
    pe = !0;
    const Ee = b(v);
    !N.value && !k.value && Ee && (Ee.selected || O()), Ee && toValue$2(M) && N.value && handleNodeClick(
      Ee,
      k.value,
      m,
      O,
      x,
      !1,
      _e
    );
    const re = le(xe);
    if (ne = re, X = getDragItems(a.value, f.value, re, b, v), X.length) {
      const [ce, ye] = getEventHandlerParams({
        id: v,
        dragItems: X,
        findNode: b
      });
      P({ event: xe.sourceEvent, node: ce, nodes: ye });
    }
  }, De = (xe, _e) => {
    var Ee;
    xe.sourceEvent.type === "touchmove" && xe.sourceEvent.touches.length > 1 || (s.value === 0 && Be(xe, _e), ne = le(xe), oe = ((Ee = o.value) == null ? void 0 : Ee.getBoundingClientRect()) || null, ie = getEventPosition(xe.sourceEvent, oe));
  }, Fe = (xe, _e) => {
    const Ee = le(xe);
    if (!ae && pe && d.value && (ae = !0, Ce()), !pe) {
      const re = Ee.xSnapped - (ne.x ?? 0), ce = Ee.ySnapped - (ne.y ?? 0);
      Math.sqrt(re * re + ce * ce) > s.value && Be(xe, _e);
    }
    (ne.x !== Ee.xSnapped || ne.y !== Ee.ySnapped) && X.length && pe && (se = xe.sourceEvent, ie = getEventPosition(xe.sourceEvent, oe), fe(Ee));
  }, Me = (xe) => {
    if (!pe) {
      const _e = le(xe), Ee = _e.xSnapped - (ne.x ?? 0), re = _e.ySnapped - (ne.y ?? 0), ce = Math.sqrt(Ee * Ee + re * re);
      ce !== 0 && ce <= s.value && (E == null || E(xe.sourceEvent));
      return;
    }
    if (H.value = !1, ae = !1, pe = !1, cancelAnimationFrame(he), X.length) {
      ee(X, !1, !1);
      const [_e, Ee] = getEventHandlerParams({
        id: v,
        dragItems: X,
        findNode: b
      });
      U({ event: xe.sourceEvent, node: _e, nodes: Ee });
    }
  };
  return watch([() => toValue$2(I), C], ([xe, _e], Ee, re) => {
    if (_e) {
      const ce = select(_e);
      xe || (te = drag().on("start", (ye) => De(ye, _e)).on("drag", (ye) => Fe(ye, _e)).on("end", (ye) => Me(ye)).filter((ye) => {
        const me = ye.target, ue = toValue$2($);
        return !ye.button && (!r.value || !hasSelector(me, `.${r.value}`, _e) && (!ue || hasSelector(me, ue, _e)));
      }), ce.call(te)), re(() => {
        ce.on(".drag", null), te && (te.on("start", null), te.on("drag", null), te.on("end", null));
      });
    }
  }), H;
}
function createEdgeHooks() {
  return {
    doubleClick: createExtendedEventHook(),
    click: createExtendedEventHook(),
    mouseEnter: createExtendedEventHook(),
    mouseMove: createExtendedEventHook(),
    mouseLeave: createExtendedEventHook(),
    contextMenu: createExtendedEventHook(),
    updateStart: createExtendedEventHook(),
    update: createExtendedEventHook(),
    updateEnd: createExtendedEventHook()
  };
}
function useEdgeHooks(e, o) {
  const n = createEdgeHooks();
  return n.doubleClick.on((t) => {
    var r, a;
    o.edgeDoubleClick(t), (a = (r = e.events) == null ? void 0 : r.doubleClick) == null || a.call(r, t);
  }), n.click.on((t) => {
    var r, a;
    o.edgeClick(t), (a = (r = e.events) == null ? void 0 : r.click) == null || a.call(r, t);
  }), n.mouseEnter.on((t) => {
    var r, a;
    o.edgeMouseEnter(t), (a = (r = e.events) == null ? void 0 : r.mouseEnter) == null || a.call(r, t);
  }), n.mouseMove.on((t) => {
    var r, a;
    o.edgeMouseMove(t), (a = (r = e.events) == null ? void 0 : r.mouseMove) == null || a.call(r, t);
  }), n.mouseLeave.on((t) => {
    var r, a;
    o.edgeMouseLeave(t), (a = (r = e.events) == null ? void 0 : r.mouseLeave) == null || a.call(r, t);
  }), n.contextMenu.on((t) => {
    var r, a;
    o.edgeContextMenu(t), (a = (r = e.events) == null ? void 0 : r.contextMenu) == null || a.call(r, t);
  }), n.updateStart.on((t) => {
    var r, a;
    o.edgeUpdateStart(t), (a = (r = e.events) == null ? void 0 : r.updateStart) == null || a.call(r, t);
  }), n.update.on((t) => {
    var r, a;
    o.edgeUpdate(t), (a = (r = e.events) == null ? void 0 : r.update) == null || a.call(r, t);
  }), n.updateEnd.on((t) => {
    var r, a;
    o.edgeUpdateEnd(t), (a = (r = e.events) == null ? void 0 : r.updateEnd) == null || a.call(r, t);
  }), Object.entries(n).reduce(
    (t, [r, a]) => (t.emit[r] = a.trigger, t.on[r] = a.on, t),
    { emit: {}, on: {} }
  );
}
function useGetPointerPosition() {
  const { viewport: e, snapGrid: o, snapToGrid: n } = useVueFlow();
  return ({ sourceEvent: t }) => {
    const r = t.touches ? t.touches[0].clientX : t.clientX, a = t.touches ? t.touches[0].clientY : t.clientY, l = {
      x: (r - e.value.x) / e.value.zoom,
      y: (a - e.value.y) / e.value.zoom
    };
    return {
      xSnapped: n.value ? o.value[0] * Math.round(l.x / o.value[0]) : l.x,
      ySnapped: n.value ? o.value[1] * Math.round(l.y / o.value[1]) : l.y,
      ...l
    };
  };
}
function alwaysValid() {
  return !0;
}
function useHandle({
  handleId: e,
  nodeId: o,
  type: n,
  isValidConnection: t,
  edgeUpdaterType: r,
  onEdgeUpdate: a,
  onEdgeUpdateEnd: l
}) {
  const {
    vueFlowRef: s,
    connectionMode: c,
    connectionRadius: d,
    connectOnClick: p,
    connectionClickStartHandle: f,
    nodesConnectable: g,
    autoPanOnConnect: b,
    autoPanSpeed: k,
    findNode: x,
    panBy: N,
    startConnection: O,
    updateConnection: m,
    endConnection: ee,
    emits: z,
    viewport: P,
    edges: V,
    nodes: U,
    isValidConnection: E
  } = useVueFlow();
  let C = null, I = !1, v = null, M = null;
  function $(X) {
    var te;
    const oe = toValue$2(n) === "target", ne = isMouseEvent(X), ie = getHostForElement(X.target);
    if (ne && X.button === 0 || !ne) {
      let se = function(ye) {
        _e = getEventPosition(ye, Me);
        const { handle: me, validHandleResult: ue } = getClosestHandle(
          ye,
          ie,
          pointToRendererPoint(_e, P.value, !1, [1, 1]),
          d.value,
          re,
          (ve) => isValidHandle(
            ye,
            ve,
            c.value,
            toValue$2(o),
            toValue$2(e),
            oe ? "target" : "source",
            ae,
            ie,
            V.value,
            U.value,
            x
          )
        );
        if (le = me, Ee || (ce(), Ee = !0), C = ue.connection, I = ue.isValid, v = ue.handleDomNode, !(I && le && (M != null && M.endHandle) && ue.endHandle && M.endHandle.type === ue.endHandle.type && M.endHandle.nodeId === ue.endHandle.nodeId && M.endHandle.handleId === ue.endHandle.handleId)) {
          if (m(
            le && I ? rendererPointToPoint(
              {
                x: le.x,
                y: le.y
              },
              P.value
            ) : _e,
            ue.endHandle,
            getConnectionStatus(!!le, I)
          ), M = ue, !le && !I && !v)
            return resetRecentHandle(xe);
          C && C.source !== C.target && v && (resetRecentHandle(xe), xe = v, v.classList.add("connecting", "vue-flow__handle-connecting"), v.classList.toggle("valid", I), v.classList.toggle("vue-flow__handle-valid", I));
        }
      }, pe = function(ye) {
        (le || v) && C && I && (a ? a(ye, C) : z.connect(C)), z.connectEnd(ye), r && (l == null || l(ye)), resetRecentHandle(xe), cancelAnimationFrame(fe), ee(ye), Ee = !1, I = !1, C = null, v = null, ie.removeEventListener("mousemove", se), ie.removeEventListener("mouseup", pe), ie.removeEventListener("touchmove", se), ie.removeEventListener("touchend", pe);
      };
      const he = x(toValue$2(o));
      let ae = toValue$2(t) || E.value || alwaysValid;
      !ae && he && (ae = (oe ? he.isValidSourcePos : he.isValidTargetPos) || alwaysValid);
      let le, fe = 0;
      const { x: Ce, y: Be } = getEventPosition(X), De = ie == null ? void 0 : ie.elementFromPoint(Ce, Be), Fe = getHandleType(toValue$2(r), De), Me = (te = s.value) == null ? void 0 : te.getBoundingClientRect();
      if (!Me || !Fe)
        return;
      let xe, _e = getEventPosition(X, Me), Ee = !1;
      const re = getHandleLookup({
        nodes: U.value,
        nodeId: toValue$2(o),
        handleId: toValue$2(e),
        handleType: Fe
      }), ce = () => {
        if (!b.value)
          return;
        const [ye, me] = calcAutoPan(_e, Me, k.value);
        N({ x: ye, y: me }), fe = requestAnimationFrame(ce);
      };
      O(
        {
          nodeId: toValue$2(o),
          handleId: toValue$2(e),
          type: Fe,
          position: (De == null ? void 0 : De.getAttribute("data-handlepos")) || Position.Top
        },
        {
          x: Ce - Me.left,
          y: Be - Me.top
        }
      ), z.connectStart({ event: X, nodeId: toValue$2(o), handleId: toValue$2(e), handleType: Fe }), ie.addEventListener("mousemove", se), ie.addEventListener("mouseup", pe), ie.addEventListener("touchmove", se), ie.addEventListener("touchend", pe);
    }
  }
  function H(X) {
    if (!p.value)
      return;
    const te = toValue$2(n) === "target";
    if (!f.value)
      z.clickConnectStart({ event: X, nodeId: toValue$2(o), handleId: toValue$2(e) }), O({ nodeId: toValue$2(o), type: toValue$2(n), handleId: toValue$2(e) }, void 0, !0);
    else {
      let oe = toValue$2(t) || E.value || alwaysValid;
      const ne = x(toValue$2(o));
      if (!oe && ne && (oe = (te ? ne.isValidSourcePos : ne.isValidTargetPos) || alwaysValid), ne && (typeof ne.connectable > "u" ? g.value : ne.connectable) === !1)
        return;
      const ie = getHostForElement(X.target), { connection: se, isValid: pe } = isValidHandle(
        X,
        {
          nodeId: toValue$2(o),
          id: toValue$2(e),
          type: toValue$2(n)
        },
        c.value,
        f.value.nodeId,
        f.value.handleId || null,
        f.value.type,
        oe,
        ie,
        V.value,
        U.value,
        x
      ), he = se.source === se.target;
      pe && !he && z.connect(se), z.clickConnectEnd(X), ee(X, !0);
    }
  }
  return {
    handlePointerDown: $,
    handleClick: H
  };
}
function useNodeId() {
  return inject(NodeId, "");
}
function useNode(e) {
  const o = e ?? useNodeId() ?? "", n = inject(NodeRef, ref(null)), { findNode: t, edges: r, emits: a } = useVueFlow(), l = t(o);
  return l || a.error(new VueFlowError(ErrorCode.NODE_NOT_FOUND, o)), {
    id: o,
    nodeEl: n,
    node: l,
    parentNode: computed(() => t(l.parentNode)),
    connectedEdges: computed(() => getConnectedEdges([l], r.value))
  };
}
function createNodeHooks() {
  return {
    doubleClick: createExtendedEventHook(),
    click: createExtendedEventHook(),
    mouseEnter: createExtendedEventHook(),
    mouseMove: createExtendedEventHook(),
    mouseLeave: createExtendedEventHook(),
    contextMenu: createExtendedEventHook(),
    dragStart: createExtendedEventHook(),
    drag: createExtendedEventHook(),
    dragStop: createExtendedEventHook()
  };
}
function useNodeHooks(e, o) {
  const n = createNodeHooks();
  return n.doubleClick.on((t) => {
    var r, a;
    o.nodeDoubleClick(t), (a = (r = e.events) == null ? void 0 : r.doubleClick) == null || a.call(r, t);
  }), n.click.on((t) => {
    var r, a;
    o.nodeClick(t), (a = (r = e.events) == null ? void 0 : r.click) == null || a.call(r, t);
  }), n.mouseEnter.on((t) => {
    var r, a;
    o.nodeMouseEnter(t), (a = (r = e.events) == null ? void 0 : r.mouseEnter) == null || a.call(r, t);
  }), n.mouseMove.on((t) => {
    var r, a;
    o.nodeMouseMove(t), (a = (r = e.events) == null ? void 0 : r.mouseMove) == null || a.call(r, t);
  }), n.mouseLeave.on((t) => {
    var r, a;
    o.nodeMouseLeave(t), (a = (r = e.events) == null ? void 0 : r.mouseLeave) == null || a.call(r, t);
  }), n.contextMenu.on((t) => {
    var r, a;
    o.nodeContextMenu(t), (a = (r = e.events) == null ? void 0 : r.contextMenu) == null || a.call(r, t);
  }), n.dragStart.on((t) => {
    var r, a;
    o.nodeDragStart(t), (a = (r = e.events) == null ? void 0 : r.dragStart) == null || a.call(r, t);
  }), n.drag.on((t) => {
    var r, a;
    o.nodeDrag(t), (a = (r = e.events) == null ? void 0 : r.drag) == null || a.call(r, t);
  }), n.dragStop.on((t) => {
    var r, a;
    o.nodeDragStop(t), (a = (r = e.events) == null ? void 0 : r.dragStop) == null || a.call(r, t);
  }), Object.entries(n).reduce(
    (t, [r, a]) => (t.emit[r] = a.trigger, t.on[r] = a.on, t),
    { emit: {}, on: {} }
  );
}
function useUpdateNodePositions() {
  const { getSelectedNodes: e, nodeExtent: o, updateNodePositions: n, findNode: t, snapGrid: r, snapToGrid: a, nodesDraggable: l, emits: s } = useVueFlow();
  return (c, d = !1) => {
    const p = a.value ? r.value[0] : 5, f = a.value ? r.value[1] : 5, g = d ? 4 : 1, b = c.x * p * g, k = c.y * f * g, x = [];
    for (const N of e.value)
      if (N.draggable || l && typeof N.draggable > "u") {
        const O = { x: N.computedPosition.x + b, y: N.computedPosition.y + k }, { computedPosition: m } = calcNextPosition(
          N,
          O,
          s.error,
          o.value,
          N.parentNode ? t(N.parentNode) : void 0
        );
        x.push({
          id: N.id,
          position: m,
          from: N.position,
          distance: { x: c.x, y: c.y },
          dimensions: N.dimensions
        });
      }
    n(x, !0, !1);
  };
}
const DEFAULT_PADDING = 0.1;
function noop() {
  return warn$1("Viewport not initialized yet."), Promise.resolve(!1);
}
const initialViewportHelper = {
  zoomIn: noop,
  zoomOut: noop,
  zoomTo: noop,
  fitView: noop,
  setCenter: noop,
  fitBounds: noop,
  project: (e) => e,
  screenToFlowCoordinate: (e) => e,
  flowToScreenCoordinate: (e) => e,
  setViewport: noop,
  setTransform: noop,
  getViewport: () => ({ x: 0, y: 0, zoom: 1 }),
  getTransform: () => ({ x: 0, y: 0, zoom: 1 }),
  viewportInitialized: !1
};
function useViewportHelper(e) {
  function o(t, r) {
    return new Promise((a) => {
      e.d3Selection && e.d3Zoom ? e.d3Zoom.scaleBy(
        transition(e.d3Selection, r, () => {
          a(!0);
        }),
        t
      ) : a(!1);
    });
  }
  function n(t, r, a, l) {
    return new Promise((s) => {
      const { x: c, y: d } = clampPosition({ x: -t, y: -r }, e.translateExtent), p = identity.translate(-c, -d).scale(a);
      e.d3Selection && e.d3Zoom ? e.d3Zoom.transform(
        transition(e.d3Selection, l, () => {
          s(!0);
        }),
        p
      ) : s(!1);
    });
  }
  return computed(() => e.d3Zoom && e.d3Selection && e.dimensions.width && e.dimensions.height ? {
    viewportInitialized: !0,
    // todo: allow passing scale as option
    zoomIn: (r) => o(1.2, r == null ? void 0 : r.duration),
    zoomOut: (r) => o(1 / 1.2, r == null ? void 0 : r.duration),
    zoomTo: (r, a) => new Promise((l) => {
      e.d3Selection && e.d3Zoom ? e.d3Zoom.scaleTo(
        transition(e.d3Selection, a == null ? void 0 : a.duration, () => {
          l(!0);
        }),
        r
      ) : l(!1);
    }),
    setViewport: (r, a) => n(r.x, r.y, r.zoom, a == null ? void 0 : a.duration),
    setTransform: (r, a) => n(r.x, r.y, r.zoom, a == null ? void 0 : a.duration),
    getViewport: () => ({
      x: e.viewport.x,
      y: e.viewport.y,
      zoom: e.viewport.zoom
    }),
    getTransform: () => ({
      x: e.viewport.x,
      y: e.viewport.y,
      zoom: e.viewport.zoom
    }),
    fitView: (r = {
      padding: DEFAULT_PADDING,
      includeHiddenNodes: !1,
      duration: 0
    }) => {
      var a, l;
      const s = [];
      for (const g of e.nodes)
        g.dimensions.width && g.dimensions.height && ((r == null ? void 0 : r.includeHiddenNodes) || !g.hidden) && (!((a = r.nodes) != null && a.length) || (l = r.nodes) != null && l.length && r.nodes.includes(g.id)) && s.push(g);
      if (!s.length)
        return Promise.resolve(!1);
      const c = getRectOfNodes(s), { x: d, y: p, zoom: f } = getTransformForBounds(
        c,
        e.dimensions.width,
        e.dimensions.height,
        r.minZoom ?? e.minZoom,
        r.maxZoom ?? e.maxZoom,
        r.padding ?? DEFAULT_PADDING,
        r.offset
      );
      return n(d, p, f, r == null ? void 0 : r.duration);
    },
    setCenter: (r, a, l) => {
      const s = typeof (l == null ? void 0 : l.zoom) < "u" ? l.zoom : e.maxZoom, c = e.dimensions.width / 2 - r * s, d = e.dimensions.height / 2 - a * s;
      return n(c, d, s, l == null ? void 0 : l.duration);
    },
    fitBounds: (r, a = { padding: DEFAULT_PADDING }) => {
      const { x: l, y: s, zoom: c } = getTransformForBounds(
        r,
        e.dimensions.width,
        e.dimensions.height,
        e.minZoom,
        e.maxZoom,
        a.padding
      );
      return n(l, s, c, a == null ? void 0 : a.duration);
    },
    project: (r) => pointToRendererPoint(r, e.viewport, e.snapToGrid, e.snapGrid),
    screenToFlowCoordinate: (r) => {
      if (e.vueFlowRef) {
        const { x: a, y: l } = e.vueFlowRef.getBoundingClientRect(), s = {
          x: r.x - a,
          y: r.y - l
        };
        return pointToRendererPoint(s, e.viewport, e.snapToGrid, e.snapGrid);
      }
      return { x: 0, y: 0 };
    },
    flowToScreenCoordinate: (r) => {
      if (e.vueFlowRef) {
        const { x: a, y: l } = e.vueFlowRef.getBoundingClientRect(), s = {
          x: r.x + a,
          y: r.y + l
        };
        return rendererPointToPoint(s, e.viewport);
      }
      return { x: 0, y: 0 };
    }
  } : initialViewportHelper);
}
function transition(e, o = 0, n) {
  return e.transition().duration(o).on("end", n);
}
function useWatchProps(e, o, n) {
  const t = effectScope(!0);
  return t.run(() => {
    const r = () => {
      t.run(() => {
        let x, N, O = !!(n.nodes.value.length || n.edges.value.length);
        x = watchPausable([e.modelValue, () => {
          var m, ee;
          return (ee = (m = e.modelValue) == null ? void 0 : m.value) == null ? void 0 : ee.length;
        }], ([m]) => {
          m && Array.isArray(m) && (N == null || N.pause(), n.setElements(m), !N && !O && m.length ? O = !0 : N == null || N.resume());
        }), N = watchPausable(
          [n.nodes, n.edges, () => n.edges.value.length, () => n.nodes.value.length],
          ([m, ee]) => {
            var z;
            (z = e.modelValue) != null && z.value && Array.isArray(e.modelValue.value) && (x == null || x.pause(), e.modelValue.value = [...m, ...ee], nextTick(() => {
              x == null || x.resume();
            }));
          },
          { immediate: O }
        ), onScopeDispose(() => {
          x == null || x.stop(), N == null || N.stop();
        });
      });
    }, a = () => {
      t.run(() => {
        let x, N, O = !!n.nodes.value.length;
        x = watchPausable([e.nodes, () => {
          var m, ee;
          return (ee = (m = e.nodes) == null ? void 0 : m.value) == null ? void 0 : ee.length;
        }], ([m]) => {
          m && Array.isArray(m) && (N == null || N.pause(), n.setNodes(m), !N && !O && m.length ? O = !0 : N == null || N.resume());
        }), N = watchPausable(
          [n.nodes, () => n.nodes.value.length],
          ([m]) => {
            var ee;
            (ee = e.nodes) != null && ee.value && Array.isArray(e.nodes.value) && (x == null || x.pause(), e.nodes.value = [...m], nextTick(() => {
              x == null || x.resume();
            }));
          },
          { immediate: O }
        ), onScopeDispose(() => {
          x == null || x.stop(), N == null || N.stop();
        });
      });
    }, l = () => {
      t.run(() => {
        let x, N, O = !!n.edges.value.length;
        x = watchPausable([e.edges, () => {
          var m, ee;
          return (ee = (m = e.edges) == null ? void 0 : m.value) == null ? void 0 : ee.length;
        }], ([m]) => {
          m && Array.isArray(m) && (N == null || N.pause(), n.setEdges(m), !N && !O && m.length ? O = !0 : N == null || N.resume());
        }), N = watchPausable(
          [n.edges, () => n.edges.value.length],
          ([m]) => {
            var ee;
            (ee = e.edges) != null && ee.value && Array.isArray(e.edges.value) && (x == null || x.pause(), e.edges.value = [...m], nextTick(() => {
              x == null || x.resume();
            }));
          },
          { immediate: O }
        ), onScopeDispose(() => {
          x == null || x.stop(), N == null || N.stop();
        });
      });
    }, s = () => {
      t.run(() => {
        watch(
          () => o.maxZoom,
          () => {
            o.maxZoom && isDef(o.maxZoom) && n.setMaxZoom(o.maxZoom);
          },
          {
            immediate: !0
          }
        );
      });
    }, c = () => {
      t.run(() => {
        watch(
          () => o.minZoom,
          () => {
            o.minZoom && isDef(o.minZoom) && n.setMinZoom(o.minZoom);
          },
          { immediate: !0 }
        );
      });
    }, d = () => {
      t.run(() => {
        watch(
          () => o.translateExtent,
          () => {
            o.translateExtent && isDef(o.translateExtent) && n.setTranslateExtent(o.translateExtent);
          },
          {
            immediate: !0
          }
        );
      });
    }, p = () => {
      t.run(() => {
        watch(
          () => o.nodeExtent,
          () => {
            o.nodeExtent && isDef(o.nodeExtent) && n.setNodeExtent(o.nodeExtent);
          },
          {
            immediate: !0
          }
        );
      });
    }, f = () => {
      t.run(() => {
        watch(
          () => o.applyDefault,
          () => {
            isDef(o.applyDefault) && (n.applyDefault.value = o.applyDefault);
          },
          {
            immediate: !0
          }
        );
      });
    }, g = () => {
      t.run(() => {
        const x = async (N) => {
          let O = N;
          typeof o.autoConnect == "function" && (O = await o.autoConnect(N)), O !== !1 && n.addEdges([O]);
        };
        watch(
          () => o.autoConnect,
          () => {
            isDef(o.autoConnect) && (n.autoConnect.value = o.autoConnect);
          },
          { immediate: !0 }
        ), watch(
          n.autoConnect,
          (N, O, m) => {
            N ? n.onConnect(x) : n.hooks.value.connect.off(x), m(() => {
              n.hooks.value.connect.off(x);
            });
          },
          { immediate: !0 }
        );
      });
    }, b = () => {
      const x = [
        "id",
        "modelValue",
        "translateExtent",
        "nodeExtent",
        "edges",
        "nodes",
        "maxZoom",
        "minZoom",
        "applyDefault",
        "autoConnect"
      ];
      for (const N of Object.keys(o)) {
        const O = N;
        if (!x.includes(O)) {
          const m = toRef(() => o[O]), ee = n[O];
          isRef(ee) && t.run(() => {
            watch(
              m,
              (z) => {
                isDef(z) && (ee.value = z);
              },
              { immediate: !0 }
            );
          });
        }
      }
    };
    (() => {
      r(), a(), l(), c(), s(), d(), p(), f(), g(), b();
    })();
  }), () => t.stop();
}
function createHooks() {
  return {
    edgesChange: createExtendedEventHook(),
    nodesChange: createExtendedEventHook(),
    nodeDoubleClick: createExtendedEventHook(),
    nodeClick: createExtendedEventHook(),
    nodeMouseEnter: createExtendedEventHook(),
    nodeMouseMove: createExtendedEventHook(),
    nodeMouseLeave: createExtendedEventHook(),
    nodeContextMenu: createExtendedEventHook(),
    nodeDragStart: createExtendedEventHook(),
    nodeDrag: createExtendedEventHook(),
    nodeDragStop: createExtendedEventHook(),
    nodesInitialized: createExtendedEventHook(),
    miniMapNodeClick: createExtendedEventHook(),
    miniMapNodeDoubleClick: createExtendedEventHook(),
    miniMapNodeMouseEnter: createExtendedEventHook(),
    miniMapNodeMouseMove: createExtendedEventHook(),
    miniMapNodeMouseLeave: createExtendedEventHook(),
    connect: createExtendedEventHook(),
    connectStart: createExtendedEventHook(),
    connectEnd: createExtendedEventHook(),
    clickConnectStart: createExtendedEventHook(),
    clickConnectEnd: createExtendedEventHook(),
    paneReady: createExtendedEventHook(),
    init: createExtendedEventHook(),
    move: createExtendedEventHook(),
    moveStart: createExtendedEventHook(),
    moveEnd: createExtendedEventHook(),
    selectionDragStart: createExtendedEventHook(),
    selectionDrag: createExtendedEventHook(),
    selectionDragStop: createExtendedEventHook(),
    selectionContextMenu: createExtendedEventHook(),
    selectionStart: createExtendedEventHook(),
    selectionEnd: createExtendedEventHook(),
    viewportChangeStart: createExtendedEventHook(),
    viewportChange: createExtendedEventHook(),
    viewportChangeEnd: createExtendedEventHook(),
    paneScroll: createExtendedEventHook(),
    paneClick: createExtendedEventHook(),
    paneContextMenu: createExtendedEventHook(),
    paneMouseEnter: createExtendedEventHook(),
    paneMouseMove: createExtendedEventHook(),
    paneMouseLeave: createExtendedEventHook(),
    edgeContextMenu: createExtendedEventHook(),
    edgeMouseEnter: createExtendedEventHook(),
    edgeMouseMove: createExtendedEventHook(),
    edgeMouseLeave: createExtendedEventHook(),
    edgeDoubleClick: createExtendedEventHook(),
    edgeClick: createExtendedEventHook(),
    edgeUpdateStart: createExtendedEventHook(),
    edgeUpdate: createExtendedEventHook(),
    edgeUpdateEnd: createExtendedEventHook(),
    updateNodeInternals: createExtendedEventHook(),
    error: createExtendedEventHook((e) => warn$1(e.message))
  };
}
function useHooks(e, o) {
  onBeforeMount(() => {
    for (const [n, t] of Object.entries(o.value)) {
      const r = (a) => {
        e(n, a);
      };
      t.fns.add(r), tryOnScopeDispose(() => {
        t.off(r);
      });
    }
  });
}
function useState() {
  return {
    vueFlowRef: null,
    viewportRef: null,
    nodes: [],
    edges: [],
    connectionLookup: /* @__PURE__ */ new Map(),
    nodeTypes: {},
    edgeTypes: {},
    initialized: !1,
    dimensions: {
      width: 0,
      height: 0
    },
    viewport: { x: 0, y: 0, zoom: 1 },
    d3Zoom: null,
    d3Selection: null,
    d3ZoomHandler: null,
    minZoom: 0.5,
    maxZoom: 2,
    translateExtent: [
      [Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY],
      [Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY]
    ],
    nodeExtent: [
      [Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY],
      [Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY]
    ],
    selectionMode: SelectionMode.Full,
    paneDragging: !1,
    preventScrolling: !0,
    zoomOnScroll: !0,
    zoomOnPinch: !0,
    zoomOnDoubleClick: !0,
    panOnScroll: !1,
    panOnScrollSpeed: 0.5,
    panOnScrollMode: PanOnScrollMode.Free,
    paneClickDistance: 0,
    panOnDrag: !0,
    edgeUpdaterRadius: 10,
    onlyRenderVisibleElements: !1,
    defaultViewport: { x: 0, y: 0, zoom: 1 },
    nodesSelectionActive: !1,
    userSelectionActive: !1,
    userSelectionRect: null,
    defaultMarkerColor: "#b1b1b7",
    connectionLineStyle: {},
    connectionLineType: null,
    connectionLineOptions: {
      type: ConnectionLineType.Bezier,
      style: {}
    },
    connectionMode: ConnectionMode.Loose,
    connectionStartHandle: null,
    connectionEndHandle: null,
    connectionClickStartHandle: null,
    connectionPosition: { x: Number.NaN, y: Number.NaN },
    connectionRadius: 20,
    connectOnClick: !0,
    connectionStatus: null,
    isValidConnection: null,
    snapGrid: [15, 15],
    snapToGrid: !1,
    edgesUpdatable: !1,
    edgesFocusable: !0,
    nodesFocusable: !0,
    nodesConnectable: !0,
    nodesDraggable: !0,
    nodeDragThreshold: 1,
    elementsSelectable: !0,
    selectNodesOnDrag: !0,
    multiSelectionActive: !1,
    selectionKeyCode: "Shift",
    multiSelectionKeyCode: isMacOs() ? "Meta" : "Control",
    zoomActivationKeyCode: isMacOs() ? "Meta" : "Control",
    deleteKeyCode: "Backspace",
    panActivationKeyCode: "Space",
    hooks: createHooks(),
    applyDefault: !0,
    autoConnect: !1,
    fitViewOnInit: !1,
    fitViewOnInitDone: !1,
    noDragClassName: "nodrag",
    noWheelClassName: "nowheel",
    noPanClassName: "nopan",
    defaultEdgeOptions: void 0,
    elevateEdgesOnSelect: !1,
    elevateNodesOnSelect: !0,
    autoPanOnNodeDrag: !0,
    autoPanOnConnect: !0,
    autoPanSpeed: 15,
    disableKeyboardA11y: !1,
    ariaLiveMessage: ""
  };
}
const storeOptionsToSkip = [
  "id",
  "vueFlowRef",
  "viewportRef",
  "initialized",
  "modelValue",
  "nodes",
  "edges",
  "maxZoom",
  "minZoom",
  "translateExtent",
  "hooks",
  "defaultEdgeOptions"
];
function useActions(e, o, n) {
  const t = useViewportHelper(e), r = (re) => {
    const ce = re ?? [];
    e.hooks.updateNodeInternals.trigger(ce);
  }, a = (re) => getIncomers(re, e.nodes, e.edges), l = (re) => getOutgoers(re, e.nodes, e.edges), s = (re) => getConnectedEdges(re, e.edges), c = ({ id: re, type: ce, nodeId: ye }) => {
    var me;
    return Array.from(((me = e.connectionLookup.get(`${ye}-${ce}-${re ?? null}`)) == null ? void 0 : me.values()) ?? []);
  }, d = (re) => {
    if (re)
      return o.value.get(re);
  }, p = (re) => {
    if (re)
      return n.value.get(re);
  }, f = (re, ce, ye) => {
    var me, ue;
    const ve = [];
    for (const we of re) {
      const Se = {
        id: we.id,
        type: "position",
        dragging: ye,
        from: we.from
      };
      if (ce && (Se.position = we.position, we.parentNode)) {
        const de = d(we.parentNode);
        Se.position = {
          x: Se.position.x - (((me = de == null ? void 0 : de.computedPosition) == null ? void 0 : me.x) ?? 0),
          y: Se.position.y - (((ue = de == null ? void 0 : de.computedPosition) == null ? void 0 : ue.y) ?? 0)
        };
      }
      ve.push(Se);
    }
    ve != null && ve.length && e.hooks.nodesChange.trigger(ve);
  }, g = (re) => {
    if (!e.vueFlowRef)
      return;
    const ce = e.vueFlowRef.querySelector(".vue-flow__transformationpane");
    if (!ce)
      return;
    const ye = window.getComputedStyle(ce), { m22: me } = new window.DOMMatrixReadOnly(ye.transform), ue = [];
    for (let ve = 0; ve < re.length; ++ve) {
      const we = re[ve], Se = d(we.id);
      if (Se) {
        const de = getDimensions(we.nodeElement);
        if (!!(de.width && de.height && (Se.dimensions.width !== de.width || Se.dimensions.height !== de.height || we.forceUpdate))) {
          const be = we.nodeElement.getBoundingClientRect();
          Se.dimensions = de, Se.handleBounds.source = getHandleBounds(".source", we.nodeElement, be, me), Se.handleBounds.target = getHandleBounds(".target", we.nodeElement, be, me), ue.push({
            id: Se.id,
            type: "dimensions",
            dimensions: de
          });
        }
      }
    }
    !e.fitViewOnInitDone && e.fitViewOnInit && t.value.fitView().then(() => {
      e.fitViewOnInitDone = !0;
    }), ue.length && e.hooks.nodesChange.trigger(ue);
  }, b = (re, ce) => {
    const ye = /* @__PURE__ */ new Set(), me = /* @__PURE__ */ new Set();
    for (const we of re)
      isNode(we) ? ye.add(we.id) : isEdge(we) && me.add(we.id);
    const ue = getSelectionChanges(o.value, ye, !0), ve = getSelectionChanges(n.value, me);
    if (e.multiSelectionActive) {
      for (const we of ye)
        ue.push(createSelectionChange(we, ce));
      for (const we of me)
        ve.push(createSelectionChange(we, ce));
    }
    ue.length && e.hooks.nodesChange.trigger(ue), ve.length && e.hooks.edgesChange.trigger(ve);
  }, k = (re) => {
    if (e.multiSelectionActive) {
      const ce = re.map((ye) => createSelectionChange(ye.id, !0));
      e.hooks.nodesChange.trigger(ce);
      return;
    }
    e.hooks.nodesChange.trigger(getSelectionChanges(o.value, new Set(re.map((ce) => ce.id)), !0)), e.hooks.edgesChange.trigger(getSelectionChanges(n.value));
  }, x = (re) => {
    if (e.multiSelectionActive) {
      const ce = re.map((ye) => createSelectionChange(ye.id, !0));
      e.hooks.edgesChange.trigger(ce);
      return;
    }
    e.hooks.edgesChange.trigger(getSelectionChanges(n.value, new Set(re.map((ce) => ce.id)))), e.hooks.nodesChange.trigger(getSelectionChanges(o.value, /* @__PURE__ */ new Set(), !0));
  }, N = (re) => {
    b(re, !0);
  }, O = (re) => {
    const ye = (re || e.nodes).map((me) => (me.selected = !1, createSelectionChange(me.id, !1)));
    e.hooks.nodesChange.trigger(ye);
  }, m = (re) => {
    const ye = (re || e.edges).map((me) => (me.selected = !1, createSelectionChange(me.id, !1)));
    e.hooks.edgesChange.trigger(ye);
  }, ee = (re) => {
    if (!re || !re.length)
      return b([], !1);
    const ce = re.reduce(
      (ye, me) => {
        const ue = createSelectionChange(me.id, !1);
        return isNode(me) ? ye.nodes.push(ue) : ye.edges.push(ue), ye;
      },
      { nodes: [], edges: [] }
    );
    ce.nodes.length && e.hooks.nodesChange.trigger(ce.nodes), ce.edges.length && e.hooks.edgesChange.trigger(ce.edges);
  }, z = (re) => {
    var ce;
    (ce = e.d3Zoom) == null || ce.scaleExtent([re, e.maxZoom]), e.minZoom = re;
  }, P = (re) => {
    var ce;
    (ce = e.d3Zoom) == null || ce.scaleExtent([e.minZoom, re]), e.maxZoom = re;
  }, V = (re) => {
    var ce;
    (ce = e.d3Zoom) == null || ce.translateExtent(re), e.translateExtent = re;
  }, U = (re) => {
    e.nodeExtent = re, r();
  }, E = (re) => {
    var ce;
    (ce = e.d3Zoom) == null || ce.clickDistance(re);
  }, C = (re) => {
    e.nodesDraggable = re, e.nodesConnectable = re, e.elementsSelectable = re;
  }, I = (re) => {
    const ce = re instanceof Function ? re(e.nodes) : re;
    !e.initialized && !ce.length || (e.nodes = createGraphNodes(ce, d, e.hooks.error.trigger));
  }, v = (re) => {
    const ce = re instanceof Function ? re(e.edges) : re;
    if (!e.initialized && !ce.length)
      return;
    const ye = createGraphEdges(
      ce,
      e.isValidConnection,
      d,
      p,
      e.hooks.error.trigger,
      e.defaultEdgeOptions,
      e.nodes,
      e.edges
    );
    updateConnectionLookup(e.connectionLookup, ye), e.edges = ye;
  }, M = (re) => {
    const ce = re instanceof Function ? re([...e.nodes, ...e.edges]) : re;
    !e.initialized && !ce.length || (I(ce.filter(isNode)), v(ce.filter(isEdge)));
  }, $ = (re) => {
    let ce = re instanceof Function ? re(e.nodes) : re;
    ce = Array.isArray(ce) ? ce : [ce];
    const ye = createGraphNodes(ce, d, e.hooks.error.trigger), me = [];
    for (const ue of ye)
      me.push(createAdditionChange(ue));
    me.length && e.hooks.nodesChange.trigger(me);
  }, H = (re) => {
    let ce = re instanceof Function ? re(e.edges) : re;
    ce = Array.isArray(ce) ? ce : [ce];
    const ye = createGraphEdges(
      ce,
      e.isValidConnection,
      d,
      p,
      e.hooks.error.trigger,
      e.defaultEdgeOptions,
      e.nodes,
      e.edges
    ), me = [];
    for (const ue of ye)
      me.push(createAdditionChange(ue));
    me.length && e.hooks.edgesChange.trigger(me);
  }, X = (re, ce = !0, ye = !1) => {
    const me = re instanceof Function ? re(e.nodes) : re, ue = Array.isArray(me) ? me : [me], ve = [], we = [];
    function Se(ge) {
      const be = s(ge);
      for (const ke of be)
        (!isDef(ke.deletable) || ke.deletable) && we.push(createEdgeRemoveChange(ke.id, ke.source, ke.target, ke.sourceHandle, ke.targetHandle));
    }
    function de(ge) {
      const be = [];
      for (const ke of e.nodes)
        ke.parentNode === ge && be.push(ke);
      if (be.length) {
        for (const ke of be)
          ve.push(createNodeRemoveChange(ke.id));
        ce && Se(be);
        for (const ke of be)
          de(ke.id);
      }
    }
    for (const ge of ue) {
      const be = typeof ge == "string" ? d(ge) : ge;
      be && (isDef(be.deletable) && !be.deletable || (ve.push(createNodeRemoveChange(be.id)), ce && Se([be]), ye && de(be.id)));
    }
    we.length && e.hooks.edgesChange.trigger(we), ve.length && e.hooks.nodesChange.trigger(ve);
  }, te = (re) => {
    const ce = re instanceof Function ? re(e.edges) : re, ye = Array.isArray(ce) ? ce : [ce], me = [];
    for (const ue of ye) {
      const ve = typeof ue == "string" ? p(ue) : ue;
      ve && (isDef(ve.deletable) && !ve.deletable || me.push(
        createEdgeRemoveChange(
          typeof ue == "string" ? ue : ue.id,
          ve.source,
          ve.target,
          ve.sourceHandle,
          ve.targetHandle
        )
      ));
    }
    e.hooks.edgesChange.trigger(me);
  }, oe = (re, ce, ye = !0) => updateEdgeAction(re, ce, e.edges, p, ye, e.hooks.error.trigger), ne = (re, ce, ye = { replace: !1 }) => {
    const me = p(re);
    if (!me)
      return;
    const ue = typeof ce == "function" ? ce(me) : ce;
    me.data = ye.replace ? ue : { ...me.data, ...ue };
  }, ie = (re) => applyChanges(re, e.nodes), se = (re) => {
    const ce = applyChanges(re, e.edges);
    return updateConnectionLookup(e.connectionLookup, ce), ce;
  }, pe = (re, ce, ye = { replace: !1 }) => {
    const me = d(re);
    if (!me)
      return;
    const ue = typeof ce == "function" ? ce(me) : ce;
    ye.replace ? e.nodes.splice(e.nodes.indexOf(me), 1, ue) : Object.assign(me, ue);
  }, he = (re, ce, ye = { replace: !1 }) => {
    const me = d(re);
    if (!me)
      return;
    const ue = typeof ce == "function" ? ce(me) : ce;
    me.data = ye.replace ? ue : { ...me.data, ...ue };
  }, ae = (re, ce, ye = !1) => {
    ye ? e.connectionClickStartHandle = re : e.connectionStartHandle = re, e.connectionEndHandle = null, e.connectionStatus = null, ce && (e.connectionPosition = ce);
  }, le = (re, ce = null, ye = null) => {
    e.connectionStartHandle && (e.connectionPosition = re, e.connectionEndHandle = ce, e.connectionStatus = ye);
  }, fe = (re, ce) => {
    e.connectionPosition = { x: Number.NaN, y: Number.NaN }, e.connectionEndHandle = null, e.connectionStatus = null, ce ? e.connectionClickStartHandle = null : e.connectionStartHandle = null;
  }, Ce = (re) => {
    const ce = isRect(re), ye = ce ? null : isGraphNode(re) ? re : d(re.id);
    return !ce && !ye ? [null, null, ce] : [ce ? re : nodeToRect(ye), ye, ce];
  }, Be = (re, ce = !0, ye = e.nodes) => {
    const [me, ue, ve] = Ce(re);
    if (!me)
      return [];
    const we = [];
    for (const Se of ye || e.nodes) {
      if (!ve && (Se.id === ue.id || !Se.computedPosition))
        continue;
      const de = nodeToRect(Se), ge = getOverlappingArea(de, me);
      (ce && ge > 0 || ge >= Number(me.width) * Number(me.height)) && we.push(Se);
    }
    return we;
  }, De = (re, ce, ye = !0) => {
    const [me] = Ce(re);
    if (!me)
      return !1;
    const ue = getOverlappingArea(me, ce);
    return ye && ue > 0 || ue >= Number(me.width) * Number(me.height);
  }, Fe = (re) => {
    const { viewport: ce, dimensions: ye, d3Zoom: me, d3Selection: ue, translateExtent: ve } = e;
    if (!me || !ue || !re.x && !re.y)
      return !1;
    const we = identity.translate(ce.x + re.x, ce.y + re.y).scale(ce.zoom), Se = [
      [0, 0],
      [ye.width, ye.height]
    ], de = me.constrain()(we, Se, ve), ge = e.viewport.x !== de.x || e.viewport.y !== de.y || e.viewport.zoom !== de.k;
    return me.transform(ue, de), ge;
  }, Me = (re) => {
    const ce = re instanceof Function ? re(e) : re, ye = [
      "d3Zoom",
      "d3Selection",
      "d3ZoomHandler",
      "viewportRef",
      "vueFlowRef",
      "dimensions",
      "hooks"
    ];
    isDef(ce.defaultEdgeOptions) && (e.defaultEdgeOptions = ce.defaultEdgeOptions);
    const me = ce.modelValue || ce.nodes || ce.edges ? [] : void 0;
    me && (ce.modelValue && me.push(...ce.modelValue), ce.nodes && me.push(...ce.nodes), ce.edges && me.push(...ce.edges), M(me));
    const ue = () => {
      isDef(ce.maxZoom) && P(ce.maxZoom), isDef(ce.minZoom) && z(ce.minZoom), isDef(ce.translateExtent) && V(ce.translateExtent);
    };
    for (const ve of Object.keys(ce)) {
      const we = ve, Se = ce[we];
      ![...storeOptionsToSkip, ...ye].includes(we) && isDef(Se) && (e[we] = Se);
    }
    until(() => e.d3Zoom).not.toBeNull().then(ue), e.initialized || (e.initialized = !0);
  };
  return {
    updateNodePositions: f,
    updateNodeDimensions: g,
    setElements: M,
    setNodes: I,
    setEdges: v,
    addNodes: $,
    addEdges: H,
    removeNodes: X,
    removeEdges: te,
    findNode: d,
    findEdge: p,
    updateEdge: oe,
    updateEdgeData: ne,
    updateNode: pe,
    updateNodeData: he,
    applyEdgeChanges: se,
    applyNodeChanges: ie,
    addSelectedElements: N,
    addSelectedNodes: k,
    addSelectedEdges: x,
    setMinZoom: z,
    setMaxZoom: P,
    setTranslateExtent: V,
    setNodeExtent: U,
    setPaneClickDistance: E,
    removeSelectedElements: ee,
    removeSelectedNodes: O,
    removeSelectedEdges: m,
    startConnection: ae,
    updateConnection: le,
    endConnection: fe,
    setInteractive: C,
    setState: Me,
    getIntersectingNodes: Be,
    getIncomers: a,
    getOutgoers: l,
    getConnectedEdges: s,
    getHandleConnections: c,
    isNodeIntersecting: De,
    panBy: Fe,
    fitView: (re) => t.value.fitView(re),
    zoomIn: (re) => t.value.zoomIn(re),
    zoomOut: (re) => t.value.zoomOut(re),
    zoomTo: (re, ce) => t.value.zoomTo(re, ce),
    setViewport: (re, ce) => t.value.setViewport(re, ce),
    setTransform: (re, ce) => t.value.setTransform(re, ce),
    getViewport: () => t.value.getViewport(),
    getTransform: () => t.value.getTransform(),
    setCenter: (re, ce, ye) => t.value.setCenter(re, ce, ye),
    fitBounds: (re, ce) => t.value.fitBounds(re, ce),
    project: (re) => t.value.project(re),
    screenToFlowCoordinate: (re) => t.value.screenToFlowCoordinate(re),
    flowToScreenCoordinate: (re) => t.value.flowToScreenCoordinate(re),
    toObject: () => {
      const re = [], ce = [];
      for (const ye of e.nodes) {
        const {
          computedPosition: me,
          handleBounds: ue,
          selected: ve,
          dimensions: we,
          isParent: Se,
          resizing: de,
          dragging: ge,
          events: be,
          ...ke
        } = ye;
        re.push(ke);
      }
      for (const ye of e.edges) {
        const { selected: me, sourceNode: ue, targetNode: ve, events: we, ...Se } = ye;
        ce.push(Se);
      }
      return JSON.parse(
        JSON.stringify({
          nodes: re,
          edges: ce,
          position: [e.viewport.x, e.viewport.y],
          zoom: e.viewport.zoom,
          viewport: e.viewport
        })
      );
    },
    fromObject: (re) => new Promise((ce) => {
      const { nodes: ye, edges: me, position: ue, zoom: ve, viewport: we } = re;
      if (ye && I(ye), me && v(me), we != null && we.x && (we != null && we.y) || ue) {
        const Se = (we == null ? void 0 : we.x) || ue[0], de = (we == null ? void 0 : we.y) || ue[1], ge = (we == null ? void 0 : we.zoom) || ve || e.viewport.zoom;
        return until(() => t.value.viewportInitialized).toBe(!0).then(() => {
          t.value.setViewport({
            x: Se,
            y: de,
            zoom: ge
          }).then(() => {
            ce(!0);
          });
        });
      } else
        ce(!0);
    }),
    updateNodeInternals: r,
    viewportHelper: t,
    $reset: () => {
      const re = useState();
      if (e.edges = [], e.nodes = [], e.d3Zoom && e.d3Selection) {
        const ce = identity.translate(re.defaultViewport.x ?? 0, re.defaultViewport.y ?? 0).scale(clamp(re.defaultViewport.zoom ?? 1, re.minZoom, re.maxZoom)), ye = e.viewportRef.getBoundingClientRect(), me = [
          [0, 0],
          [ye.width, ye.height]
        ], ue = e.d3Zoom.constrain()(ce, me, re.translateExtent);
        e.d3Zoom.transform(e.d3Selection, ue);
      }
      Me(re);
    },
    $destroy: () => {
    }
  };
}
const _hoisted_1$9$1 = ["data-id", "data-handleid", "data-nodeid", "data-handlepos"], __default__$f = {
  name: "Handle",
  compatConfig: { MODE: 3 }
}, _sfc_main$f$1 = /* @__PURE__ */ defineComponent({
  ...__default__$f,
  props: {
    id: { default: null },
    type: {},
    position: { default: () => Position.Top },
    isValidConnection: { type: Function },
    connectable: { type: [Boolean, Number, String, Function], default: void 0 },
    connectableStart: { type: Boolean, default: !0 },
    connectableEnd: { type: Boolean, default: !0 }
  },
  setup(e, { expose: o }) {
    const n = createPropsRestProxy(e, ["position", "connectable", "connectableStart", "connectableEnd", "id"]), t = toRef(() => n.type ?? "source"), r = toRef(() => n.isValidConnection ?? null), {
      connectionStartHandle: a,
      connectionClickStartHandle: l,
      connectionEndHandle: s,
      vueFlowRef: c,
      nodesConnectable: d,
      noDragClassName: p,
      noPanClassName: f
    } = useVueFlow(), { id: g, node: b, nodeEl: k, connectedEdges: x } = useNode(), N = ref(), O = toRef(() => typeof e.connectableStart < "u" ? e.connectableStart : !0), m = toRef(() => typeof e.connectableEnd < "u" ? e.connectableEnd : !0), ee = toRef(
      () => {
        var I, v, M, $, H, X;
        return ((I = a.value) == null ? void 0 : I.nodeId) === g && ((v = a.value) == null ? void 0 : v.handleId) === e.id && ((M = a.value) == null ? void 0 : M.type) === t.value || (($ = s.value) == null ? void 0 : $.nodeId) === g && ((H = s.value) == null ? void 0 : H.handleId) === e.id && ((X = s.value) == null ? void 0 : X.type) === t.value;
      }
    ), z = toRef(
      () => {
        var I, v, M;
        return ((I = l.value) == null ? void 0 : I.nodeId) === g && ((v = l.value) == null ? void 0 : v.handleId) === e.id && ((M = l.value) == null ? void 0 : M.type) === t.value;
      }
    ), { handlePointerDown: P, handleClick: V } = useHandle({
      nodeId: g,
      handleId: e.id,
      isValidConnection: r,
      type: t
    }), U = computed(() => typeof e.connectable == "string" && e.connectable === "single" ? !x.value.some((I) => {
      const v = I[`${t.value}Handle`];
      return I[t.value] !== g ? !1 : v ? v === e.id : !0;
    }) : typeof e.connectable == "number" ? x.value.filter((I) => {
      const v = I[`${t.value}Handle`];
      return I[t.value] !== g ? !1 : v ? v === e.id : !0;
    }).length < e.connectable : typeof e.connectable == "function" ? e.connectable(b, x.value) : isDef(e.connectable) ? e.connectable : d.value);
    onMounted(() => {
      var I;
      if (!b.dimensions.width || !b.dimensions.height)
        return;
      const v = (I = b.handleBounds[t.value]) == null ? void 0 : I.find((ne) => ne.id === e.id);
      if (!c.value || v)
        return;
      const M = c.value.querySelector(".vue-flow__transformationpane");
      if (!k.value || !N.value || !M || !e.id)
        return;
      const $ = k.value.getBoundingClientRect(), H = N.value.getBoundingClientRect(), X = window.getComputedStyle(M), { m22: te } = new window.DOMMatrixReadOnly(X.transform), oe = {
        id: e.id,
        position: e.position,
        x: (H.left - $.left) / te,
        y: (H.top - $.top) / te,
        ...getDimensions(N.value)
      };
      b.handleBounds[t.value] = [...b.handleBounds[t.value] ?? [], oe];
    }), onUnmounted(() => {
      const I = b.handleBounds[t.value];
      I && (b.handleBounds[t.value] = I.filter((v) => v.id !== e.id));
    });
    function E(I) {
      const v = isMouseEvent(I);
      U.value && O.value && (v && I.button === 0 || !v) && P(I);
    }
    function C(I) {
      !g || !l.value && !O.value || U.value && V(I);
    }
    return o({
      handleClick: V,
      handlePointerDown: P,
      onClick: C,
      onPointerDown: E
    }), (I, v) => (openBlock(), createElementBlock("div", {
      ref_key: "handle",
      ref: N,
      "data-id": `${unref(g)}-${e.id}-${t.value}`,
      "data-handleid": e.id,
      "data-nodeid": unref(g),
      "data-handlepos": I.position,
      class: normalizeClass(["vue-flow__handle", [
        `vue-flow__handle-${I.position}`,
        `vue-flow__handle-${e.id}`,
        unref(p),
        unref(f),
        t.value,
        {
          connectable: U.value,
          connecting: z.value,
          connectablestart: O.value,
          connectableend: m.value,
          connectionindicator: U.value && (O.value && !ee.value || m.value && ee.value)
        }
      ]]),
      onMousedown: E,
      onTouchstartPassive: E,
      onClick: C
    }, [
      renderSlot(I.$slots, "default", { id: I.id })
    ], 42, _hoisted_1$9$1));
  }
}), DefaultNode = function({
  sourcePosition: e = Position.Bottom,
  targetPosition: o = Position.Top,
  label: n,
  connectable: t = !0,
  isValidTargetPos: r,
  isValidSourcePos: a,
  data: l
}) {
  const s = l.label || n;
  return [
    h(_sfc_main$f$1, { type: "target", position: o, connectable: t, isValidConnection: r }),
    typeof s != "string" && s ? h(s) : h("div", { innerHTML: s }),
    h(_sfc_main$f$1, { type: "source", position: e, connectable: t, isValidConnection: a })
  ];
};
DefaultNode.props = ["sourcePosition", "targetPosition", "label", "isValidTargetPos", "isValidSourcePos", "connectable", "data"];
DefaultNode.inheritAttrs = !1;
DefaultNode.compatConfig = { MODE: 3 };
const DefaultNode$1 = DefaultNode, OutputNode = function({
  targetPosition: e = Position.Top,
  label: o,
  connectable: n = !0,
  isValidTargetPos: t,
  data: r
}) {
  const a = r.label || o;
  return [
    h(_sfc_main$f$1, { type: "target", position: e, connectable: n, isValidConnection: t }),
    typeof a != "string" && a ? h(a) : h("div", { innerHTML: a })
  ];
};
OutputNode.props = ["targetPosition", "label", "isValidTargetPos", "connectable", "data"];
OutputNode.inheritAttrs = !1;
OutputNode.compatConfig = { MODE: 3 };
const OutputNode$1 = OutputNode, InputNode = function({
  sourcePosition: e = Position.Bottom,
  label: o,
  connectable: n = !0,
  isValidSourcePos: t,
  data: r
}) {
  const a = r.label || o;
  return [
    typeof a != "string" && a ? h(a) : h("div", { innerHTML: a }),
    h(_sfc_main$f$1, { type: "source", position: e, connectable: n, isValidConnection: t })
  ];
};
InputNode.props = ["sourcePosition", "label", "isValidSourcePos", "connectable", "data"];
InputNode.inheritAttrs = !1;
InputNode.compatConfig = { MODE: 3 };
const InputNode$1 = InputNode, _hoisted_1$8$1 = ["transform"], _hoisted_2$2$1 = ["width", "height", "x", "y", "rx", "ry"], _hoisted_3$1$1 = ["y"], __default__$e = {
  name: "EdgeText",
  compatConfig: { MODE: 3 }
}, _sfc_main$e$1 = /* @__PURE__ */ defineComponent({
  ...__default__$e,
  props: {
    x: {},
    y: {},
    label: {},
    labelStyle: { default: () => ({}) },
    labelShowBg: { type: Boolean, default: !0 },
    labelBgStyle: { default: () => ({}) },
    labelBgPadding: { default: () => [2, 4] },
    labelBgBorderRadius: { default: 2 }
  },
  setup(e) {
    const o = ref({ x: 0, y: 0, width: 0, height: 0 }), n = ref(null), t = computed(() => `translate(${e.x - o.value.width / 2} ${e.y - o.value.height / 2})`);
    onMounted(r), watch([() => e.x, () => e.y, n, () => e.label], r);
    function r() {
      if (!n.value)
        return;
      const a = n.value.getBBox();
      (a.width !== o.value.width || a.height !== o.value.height) && (o.value = a);
    }
    return (a, l) => (openBlock(), createElementBlock("g", {
      transform: t.value,
      class: "vue-flow__edge-textwrapper"
    }, [
      a.labelShowBg ? (openBlock(), createElementBlock("rect", {
        key: 0,
        class: "vue-flow__edge-textbg",
        width: `${o.value.width + 2 * a.labelBgPadding[0]}px`,
        height: `${o.value.height + 2 * a.labelBgPadding[1]}px`,
        x: -a.labelBgPadding[0],
        y: -a.labelBgPadding[1],
        style: normalizeStyle(a.labelBgStyle),
        rx: a.labelBgBorderRadius,
        ry: a.labelBgBorderRadius
      }, null, 12, _hoisted_2$2$1)) : createCommentVNode("", !0),
      createElementVNode("text", mergeProps(a.$attrs, {
        ref_key: "el",
        ref: n,
        class: "vue-flow__edge-text",
        y: o.value.height / 2,
        dy: "0.3em",
        style: a.labelStyle
      }), [
        renderSlot(a.$slots, "default", {}, () => [
          typeof a.label != "string" ? (openBlock(), createBlock(resolveDynamicComponent(a.label), { key: 0 })) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
            createTextVNode(toDisplayString$1(a.label), 1)
          ], 64))
        ])
      ], 16, _hoisted_3$1$1)
    ], 8, _hoisted_1$8$1));
  }
}), _hoisted_1$7$1 = ["id", "d", "marker-end", "marker-start"], _hoisted_2$1$1 = ["d", "stroke-width"], __default__$d = {
  name: "BaseEdge",
  inheritAttrs: !1,
  compatConfig: { MODE: 3 }
}, _sfc_main$d$1 = /* @__PURE__ */ defineComponent({
  ...__default__$d,
  props: {
    id: {},
    labelX: {},
    labelY: {},
    path: {},
    label: {},
    markerStart: {},
    markerEnd: {},
    interactionWidth: { default: 20 },
    style: {},
    labelStyle: {},
    labelShowBg: { type: Boolean, default: !0 },
    labelBgStyle: {},
    labelBgPadding: {},
    labelBgBorderRadius: {}
  },
  setup(e, { expose: o }) {
    const n = createPropsRestProxy(e, ["interactionWidth", "labelShowBg"]), t = ref(null), r = ref(null), a = ref(null), l = useAttrs();
    return o({
      pathEl: t,
      interactionEl: r,
      labelEl: a
    }), (s, c) => (openBlock(), createElementBlock(Fragment, null, [
      createElementVNode("path", {
        id: s.id,
        ref_key: "pathEl",
        ref: t,
        d: s.path,
        style: normalizeStyle(n.style),
        class: normalizeClass(["vue-flow__edge-path", unref(l).class]),
        "marker-end": s.markerEnd,
        "marker-start": s.markerStart
      }, null, 14, _hoisted_1$7$1),
      s.interactionWidth ? (openBlock(), createElementBlock("path", {
        key: 0,
        ref_key: "interactionEl",
        ref: r,
        fill: "none",
        d: s.path,
        "stroke-width": s.interactionWidth,
        "stroke-opacity": 0,
        class: "vue-flow__edge-interaction"
      }, null, 8, _hoisted_2$1$1)) : createCommentVNode("", !0),
      s.label && s.labelX && s.labelY ? (openBlock(), createBlock(_sfc_main$e$1, {
        key: 1,
        ref_key: "labelEl",
        ref: a,
        x: s.labelX,
        y: s.labelY,
        label: s.label,
        "label-show-bg": s.labelShowBg,
        "label-bg-style": s.labelBgStyle,
        "label-bg-padding": s.labelBgPadding,
        "label-bg-border-radius": s.labelBgBorderRadius,
        "label-style": s.labelStyle
      }, null, 8, ["x", "y", "label", "label-show-bg", "label-bg-style", "label-bg-padding", "label-bg-border-radius", "label-style"])) : createCommentVNode("", !0)
    ], 64));
  }
});
function getSimpleEdgeCenter({
  sourceX: e,
  sourceY: o,
  targetX: n,
  targetY: t
}) {
  const r = Math.abs(n - e) / 2, a = n < e ? n + r : n - r, l = Math.abs(t - o) / 2, s = t < o ? t + l : t - l;
  return [a, s, r, l];
}
function getBezierEdgeCenter({
  sourceX: e,
  sourceY: o,
  targetX: n,
  targetY: t,
  sourceControlX: r,
  sourceControlY: a,
  targetControlX: l,
  targetControlY: s
}) {
  const c = e * 0.125 + r * 0.375 + l * 0.375 + n * 0.125, d = o * 0.125 + a * 0.375 + s * 0.375 + t * 0.125, p = Math.abs(c - e), f = Math.abs(d - o);
  return [c, d, p, f];
}
function calculateControlOffset(e, o) {
  return e >= 0 ? 0.5 * e : o * 25 * Math.sqrt(-e);
}
function getControlWithCurvature({ pos: e, x1: o, y1: n, x2: t, y2: r, c: a }) {
  let l, s;
  switch (e) {
    case Position.Left:
      l = o - calculateControlOffset(o - t, a), s = n;
      break;
    case Position.Right:
      l = o + calculateControlOffset(t - o, a), s = n;
      break;
    case Position.Top:
      l = o, s = n - calculateControlOffset(n - r, a);
      break;
    case Position.Bottom:
      l = o, s = n + calculateControlOffset(r - n, a);
      break;
  }
  return [l, s];
}
function getBezierPath(e) {
  const {
    sourceX: o,
    sourceY: n,
    sourcePosition: t = Position.Bottom,
    targetX: r,
    targetY: a,
    targetPosition: l = Position.Top,
    curvature: s = 0.25
  } = e, [c, d] = getControlWithCurvature({
    pos: t,
    x1: o,
    y1: n,
    x2: r,
    y2: a,
    c: s
  }), [p, f] = getControlWithCurvature({
    pos: l,
    x1: r,
    y1: a,
    x2: o,
    y2: n,
    c: s
  }), [g, b, k, x] = getBezierEdgeCenter({
    sourceX: o,
    sourceY: n,
    targetX: r,
    targetY: a,
    sourceControlX: c,
    sourceControlY: d,
    targetControlX: p,
    targetControlY: f
  });
  return [
    `M${o},${n} C${c},${d} ${p},${f} ${r},${a}`,
    g,
    b,
    k,
    x
  ];
}
function getControl({ pos: e, x1: o, y1: n, x2: t, y2: r }) {
  let a, l;
  switch (e) {
    case Position.Left:
    case Position.Right:
      a = 0.5 * (o + t), l = n;
      break;
    case Position.Top:
    case Position.Bottom:
      a = o, l = 0.5 * (n + r);
      break;
  }
  return [a, l];
}
function getSimpleBezierPath(e) {
  const {
    sourceX: o,
    sourceY: n,
    sourcePosition: t = Position.Bottom,
    targetX: r,
    targetY: a,
    targetPosition: l = Position.Top
  } = e, [s, c] = getControl({
    pos: t,
    x1: o,
    y1: n,
    x2: r,
    y2: a
  }), [d, p] = getControl({
    pos: l,
    x1: r,
    y1: a,
    x2: o,
    y2: n
  }), [f, g, b, k] = getBezierEdgeCenter({
    sourceX: o,
    sourceY: n,
    targetX: r,
    targetY: a,
    sourceControlX: s,
    sourceControlY: c,
    targetControlX: d,
    targetControlY: p
  });
  return [
    `M${o},${n} C${s},${c} ${d},${p} ${r},${a}`,
    f,
    g,
    b,
    k
  ];
}
const handleDirections = {
  [Position.Left]: { x: -1, y: 0 },
  [Position.Right]: { x: 1, y: 0 },
  [Position.Top]: { x: 0, y: -1 },
  [Position.Bottom]: { x: 0, y: 1 }
};
function getDirection({
  source: e,
  sourcePosition: o = Position.Bottom,
  target: n
}) {
  return o === Position.Left || o === Position.Right ? e.x < n.x ? { x: 1, y: 0 } : { x: -1, y: 0 } : e.y < n.y ? { x: 0, y: 1 } : { x: 0, y: -1 };
}
function distance(e, o) {
  return Math.sqrt((o.x - e.x) ** 2 + (o.y - e.y) ** 2);
}
function getPoints({
  source: e,
  sourcePosition: o = Position.Bottom,
  target: n,
  targetPosition: t = Position.Top,
  center: r,
  offset: a
}) {
  const l = handleDirections[o], s = handleDirections[t], c = { x: e.x + l.x * a, y: e.y + l.y * a }, d = { x: n.x + s.x * a, y: n.y + s.y * a }, p = getDirection({
    source: c,
    sourcePosition: o,
    target: d
  }), f = p.x !== 0 ? "x" : "y", g = p[f];
  let b, k, x;
  const N = { x: 0, y: 0 }, O = { x: 0, y: 0 }, [m, ee, z, P] = getSimpleEdgeCenter({
    sourceX: e.x,
    sourceY: e.y,
    targetX: n.x,
    targetY: n.y
  });
  if (l[f] * s[f] === -1) {
    k = r.x ?? m, x = r.y ?? ee;
    const U = [
      { x: k, y: c.y },
      { x: k, y: d.y }
    ], E = [
      { x: c.x, y: x },
      { x: d.x, y: x }
    ];
    l[f] === g ? b = f === "x" ? U : E : b = f === "x" ? E : U;
  } else {
    const U = [{ x: c.x, y: d.y }], E = [{ x: d.x, y: c.y }];
    if (f === "x" ? b = l.x === g ? E : U : b = l.y === g ? U : E, o === t) {
      const $ = Math.abs(e[f] - n[f]);
      if ($ <= a) {
        const H = Math.min(a - 1, a - $);
        l[f] === g ? N[f] = (c[f] > e[f] ? -1 : 1) * H : O[f] = (d[f] > n[f] ? -1 : 1) * H;
      }
    }
    if (o !== t) {
      const $ = f === "x" ? "y" : "x", H = l[f] === s[$], X = c[$] > d[$], te = c[$] < d[$];
      (l[f] === 1 && (!H && X || H && te) || l[f] !== 1 && (!H && te || H && X)) && (b = f === "x" ? U : E);
    }
    const C = { x: c.x + N.x, y: c.y + N.y }, I = { x: d.x + O.x, y: d.y + O.y }, v = Math.max(Math.abs(C.x - b[0].x), Math.abs(I.x - b[0].x)), M = Math.max(Math.abs(C.y - b[0].y), Math.abs(I.y - b[0].y));
    v >= M ? (k = (C.x + I.x) / 2, x = b[0].y) : (k = b[0].x, x = (C.y + I.y) / 2);
  }
  return [[
    e,
    { x: c.x + N.x, y: c.y + N.y },
    ...b,
    { x: d.x + O.x, y: d.y + O.y },
    n
  ], k, x, z, P];
}
function getBend(e, o, n, t) {
  const r = Math.min(distance(e, o) / 2, distance(o, n) / 2, t), { x: a, y: l } = o;
  if (e.x === a && a === n.x || e.y === l && l === n.y)
    return `L${a} ${l}`;
  if (e.y === l) {
    const d = e.x < n.x ? -1 : 1, p = e.y < n.y ? 1 : -1;
    return `L ${a + r * d},${l}Q ${a},${l} ${a},${l + r * p}`;
  }
  const s = e.x < n.x ? 1 : -1, c = e.y < n.y ? -1 : 1;
  return `L ${a},${l + r * c}Q ${a},${l} ${a + r * s},${l}`;
}
function getSmoothStepPath(e) {
  const {
    sourceX: o,
    sourceY: n,
    sourcePosition: t = Position.Bottom,
    targetX: r,
    targetY: a,
    targetPosition: l = Position.Top,
    borderRadius: s = 5,
    centerX: c,
    centerY: d,
    offset: p = 20
  } = e, [f, g, b, k, x] = getPoints({
    source: { x: o, y: n },
    sourcePosition: t,
    target: { x: r, y: a },
    targetPosition: l,
    center: { x: c, y: d },
    offset: p
  });
  return [f.reduce((O, m, ee) => {
    let z;
    return ee > 0 && ee < f.length - 1 ? z = getBend(f[ee - 1], m, f[ee + 1], s) : z = `${ee === 0 ? "M" : "L"}${m.x} ${m.y}`, O += z, O;
  }, ""), g, b, k, x];
}
function getStraightPath(e) {
  const { sourceX: o, sourceY: n, targetX: t, targetY: r } = e, [a, l, s, c] = getSimpleEdgeCenter({
    sourceX: o,
    sourceY: n,
    targetX: t,
    targetY: r
  });
  return [`M ${o},${n}L ${t},${r}`, a, l, s, c];
}
const StraightEdge = defineComponent({
  name: "StraightEdge",
  props: [
    "label",
    "labelStyle",
    "labelShowBg",
    "labelBgStyle",
    "labelBgPadding",
    "labelBgBorderRadius",
    "sourceY",
    "sourceX",
    "targetX",
    "targetY",
    "markerEnd",
    "markerStart",
    "interactionWidth"
  ],
  compatConfig: { MODE: 3 },
  setup(e, { attrs: o }) {
    return () => {
      const [n, t, r] = getStraightPath(e);
      return h(_sfc_main$d$1, {
        path: n,
        labelX: t,
        labelY: r,
        ...o,
        ...e
      });
    };
  }
}), StraightEdge$1 = StraightEdge, SmoothStepEdge = defineComponent({
  name: "SmoothStepEdge",
  props: [
    "sourcePosition",
    "targetPosition",
    "label",
    "labelStyle",
    "labelShowBg",
    "labelBgStyle",
    "labelBgPadding",
    "labelBgBorderRadius",
    "sourceY",
    "sourceX",
    "targetX",
    "targetY",
    "borderRadius",
    "markerEnd",
    "markerStart",
    "interactionWidth",
    "offset"
  ],
  compatConfig: { MODE: 3 },
  setup(e, { attrs: o }) {
    return () => {
      const [n, t, r] = getSmoothStepPath({
        ...e,
        sourcePosition: e.sourcePosition ?? Position.Bottom,
        targetPosition: e.targetPosition ?? Position.Top
      });
      return h(_sfc_main$d$1, {
        path: n,
        labelX: t,
        labelY: r,
        ...o,
        ...e
      });
    };
  }
}), SmoothStepEdge$1 = SmoothStepEdge, StepEdge = defineComponent({
  name: "StepEdge",
  props: [
    "sourcePosition",
    "targetPosition",
    "label",
    "labelStyle",
    "labelShowBg",
    "labelBgStyle",
    "labelBgPadding",
    "labelBgBorderRadius",
    "sourceY",
    "sourceX",
    "targetX",
    "targetY",
    "markerEnd",
    "markerStart",
    "interactionWidth"
  ],
  setup(e, { attrs: o }) {
    return () => h(SmoothStepEdge$1, { ...e, ...o, borderRadius: 0 });
  }
}), StepEdge$1 = StepEdge, BezierEdge = defineComponent({
  name: "BezierEdge",
  props: [
    "sourcePosition",
    "targetPosition",
    "label",
    "labelStyle",
    "labelShowBg",
    "labelBgStyle",
    "labelBgPadding",
    "labelBgBorderRadius",
    "sourceY",
    "sourceX",
    "targetX",
    "targetY",
    "curvature",
    "markerEnd",
    "markerStart",
    "interactionWidth"
  ],
  compatConfig: { MODE: 3 },
  setup(e, { attrs: o }) {
    return () => {
      const [n, t, r] = getBezierPath({
        ...e,
        sourcePosition: e.sourcePosition ?? Position.Bottom,
        targetPosition: e.targetPosition ?? Position.Top
      });
      return h(_sfc_main$d$1, {
        path: n,
        labelX: t,
        labelY: r,
        ...o,
        ...e
      });
    };
  }
}), BezierEdge$1 = BezierEdge, SimpleBezierEdge = defineComponent({
  name: "SimpleBezierEdge",
  props: [
    "sourcePosition",
    "targetPosition",
    "label",
    "labelStyle",
    "labelShowBg",
    "labelBgStyle",
    "labelBgPadding",
    "labelBgBorderRadius",
    "sourceY",
    "sourceX",
    "targetX",
    "targetY",
    "markerEnd",
    "markerStart",
    "interactionWidth"
  ],
  compatConfig: { MODE: 3 },
  setup(e, { attrs: o }) {
    return () => {
      const [n, t, r] = getSimpleBezierPath({
        ...e,
        sourcePosition: e.sourcePosition ?? Position.Bottom,
        targetPosition: e.targetPosition ?? Position.Top
      });
      return h(_sfc_main$d$1, {
        path: n,
        labelX: t,
        labelY: r,
        ...o,
        ...e
      });
    };
  }
}), SimpleBezierEdge$1 = SimpleBezierEdge, defaultNodeTypes = {
  input: InputNode$1,
  default: DefaultNode$1,
  output: OutputNode$1
}, defaultEdgeTypes = {
  default: BezierEdge$1,
  straight: StraightEdge$1,
  step: StepEdge$1,
  smoothstep: SmoothStepEdge$1,
  simplebezier: SimpleBezierEdge$1
};
function useGetters(e, o, n) {
  const t = computed(() => (x) => o.value.get(x)), r = computed(() => (x) => n.value.get(x)), a = computed(() => {
    const x = {
      ...defaultEdgeTypes,
      ...e.edgeTypes
    }, N = Object.keys(x);
    for (const O of e.edges)
      O.type && !N.includes(O.type) && (x[O.type] = O.type);
    return x;
  }), l = computed(() => {
    const x = {
      ...defaultNodeTypes,
      ...e.nodeTypes
    }, N = Object.keys(x);
    for (const O of e.nodes)
      O.type && !N.includes(O.type) && (x[O.type] = O.type);
    return x;
  }), s = computed(() => e.onlyRenderVisibleElements ? getNodesInside(
    e.nodes,
    {
      x: 0,
      y: 0,
      width: e.dimensions.width,
      height: e.dimensions.height
    },
    e.viewport,
    !0
  ) : e.nodes), c = computed(() => {
    if (e.onlyRenderVisibleElements) {
      const x = [];
      for (const N of e.edges) {
        const O = o.value.get(N.source), m = o.value.get(N.target);
        isEdgeVisible({
          sourcePos: O.computedPosition || { x: 0, y: 0 },
          targetPos: m.computedPosition || { x: 0, y: 0 },
          sourceWidth: O.dimensions.width,
          sourceHeight: O.dimensions.height,
          targetWidth: m.dimensions.width,
          targetHeight: m.dimensions.height,
          width: e.dimensions.width,
          height: e.dimensions.height,
          viewport: e.viewport
        }) && x.push(N);
      }
      return x;
    }
    return e.edges;
  }), d = computed(() => [...s.value, ...c.value]), p = computed(() => {
    const x = [];
    for (const N of e.nodes)
      N.selected && x.push(N);
    return x;
  }), f = computed(() => {
    const x = [];
    for (const N of e.edges)
      N.selected && x.push(N);
    return x;
  }), g = computed(() => [
    ...p.value,
    ...f.value
  ]), b = computed(() => {
    const x = [];
    for (const N of e.nodes)
      N.dimensions.width && N.dimensions.height && N.handleBounds !== void 0 && x.push(N);
    return x;
  }), k = computed(
    () => s.value.length > 0 && b.value.length === s.value.length
  );
  return {
    getNode: t,
    getEdge: r,
    getElements: d,
    getEdgeTypes: a,
    getNodeTypes: l,
    getEdges: c,
    getNodes: s,
    getSelectedElements: g,
    getSelectedNodes: p,
    getSelectedEdges: f,
    getNodesInitialized: b,
    areNodesInitialized: k
  };
}
class Storage {
  constructor() {
    this.currentId = 0, this.flows = /* @__PURE__ */ new Map();
  }
  static getInstance() {
    var o;
    const n = (o = getCurrentInstance()) == null ? void 0 : o.appContext.app, t = (n == null ? void 0 : n.config.globalProperties.$vueFlowStorage) ?? Storage.instance;
    return Storage.instance = t ?? new Storage(), n && (n.config.globalProperties.$vueFlowStorage = Storage.instance), Storage.instance;
  }
  set(o, n) {
    return this.flows.set(o, n);
  }
  get(o) {
    return this.flows.get(o);
  }
  remove(o) {
    return this.flows.delete(o);
  }
  create(o, n) {
    const t = useState(), r = reactive(t), a = {};
    for (const [g, b] of Object.entries(r.hooks)) {
      const k = `on${g.charAt(0).toUpperCase() + g.slice(1)}`;
      a[k] = b.on;
    }
    const l = {};
    for (const [g, b] of Object.entries(r.hooks))
      l[g] = b.trigger;
    const s = computed(() => {
      const g = /* @__PURE__ */ new Map();
      for (const b of r.nodes)
        g.set(b.id, b);
      return g;
    }), c = computed(() => {
      const g = /* @__PURE__ */ new Map();
      for (const b of r.edges)
        g.set(b.id, b);
      return g;
    }), d = useGetters(r, s, c), p = useActions(r, s, c);
    p.setState({ ...r, ...n });
    const f = {
      ...a,
      ...d,
      ...p,
      ...toRefs(r),
      nodeLookup: s,
      edgeLookup: c,
      emits: l,
      id: o,
      vueFlowVersion: "1.41.0",
      $destroy: () => {
        this.remove(o);
      }
    };
    return this.set(o, f), f;
  }
  getId() {
    return `vue-flow-${this.currentId++}`;
  }
}
function useVueFlow(e) {
  const o = Storage.getInstance(), n = getCurrentScope(), t = typeof e == "object", r = t ? e : { id: e }, a = r.id, l = a ?? (n == null ? void 0 : n.vueFlowId);
  let s;
  if (n) {
    const c = inject(VueFlow, null);
    typeof c < "u" && c !== null && (!l || c.id === l) && (s = c);
  }
  if (s || l && (s = o.get(l)), !s || l && s.id !== l) {
    const c = a ?? o.getId(), d = o.create(c, r);
    s = d, (n ?? effectScope(!0)).run(() => {
      watch(
        d.applyDefault,
        (f, g, b) => {
          const k = (N) => {
            d.applyNodeChanges(N);
          }, x = (N) => {
            d.applyEdgeChanges(N);
          };
          f ? (d.onNodesChange(k), d.onEdgesChange(x)) : (d.hooks.value.nodesChange.off(k), d.hooks.value.edgesChange.off(x)), b(() => {
            d.hooks.value.nodesChange.off(k), d.hooks.value.edgesChange.off(x);
          });
        },
        { immediate: !0 }
      ), tryOnScopeDispose(() => {
        if (s) {
          const f = o.get(s.id);
          f ? f.$destroy() : warn$1(`No store instance found for id ${s.id} in storage.`);
        }
      });
    });
  } else
    t && s.setState(r);
  if (n && (provide(VueFlow, s), n.vueFlowId = s.id), t) {
    const c = getCurrentInstance();
    (c == null ? void 0 : c.type.name) !== "VueFlow" && s.emits.error(new VueFlowError(ErrorCode.USEVUEFLOW_OPTIONS));
  }
  return s;
}
function useResizeHandler(e) {
  const { emits: o, dimensions: n } = useVueFlow();
  let t;
  onMounted(() => {
    const r = e.value, a = () => {
      if (!r)
        return;
      const l = getDimensions(r);
      (l.width === 0 || l.height === 0) && o.error(new VueFlowError(ErrorCode.MISSING_VIEWPORT_DIMENSIONS)), n.value = { width: l.width || 500, height: l.height || 500 };
    };
    a(), window.addEventListener("resize", a), r && (t = new ResizeObserver(() => a()), t.observe(r)), onBeforeUnmount(() => {
      window.removeEventListener("resize", a), t && r && t.unobserve(r);
    });
  });
}
const __default__$c = {
  name: "UserSelection",
  compatConfig: { MODE: 3 }
}, _sfc_main$c$1 = /* @__PURE__ */ defineComponent({
  ...__default__$c,
  props: {
    userSelectionRect: {}
  },
  setup(e) {
    return (o, n) => (openBlock(), createElementBlock("div", {
      class: "vue-flow__selection vue-flow__container",
      style: normalizeStyle({
        width: `${o.userSelectionRect.width}px`,
        height: `${o.userSelectionRect.height}px`,
        transform: `translate(${o.userSelectionRect.x}px, ${o.userSelectionRect.y}px)`
      })
    }, null, 4));
  }
}), _hoisted_1$6$1 = ["tabIndex"], __default__$b = {
  name: "NodesSelection",
  compatConfig: { MODE: 3 }
}, _sfc_main$b$1 = /* @__PURE__ */ defineComponent({
  ...__default__$b,
  setup(e) {
    const { emits: o, viewport: n, getSelectedNodes: t, noPanClassName: r, disableKeyboardA11y: a, userSelectionActive: l } = useVueFlow(), s = useUpdateNodePositions(), c = ref(null), d = useDrag({
      el: c,
      onStart(k) {
        o.selectionDragStart(k);
      },
      onDrag(k) {
        o.selectionDrag(k);
      },
      onStop(k) {
        o.selectionDragStop(k);
      }
    });
    onMounted(() => {
      var k;
      a.value || (k = c.value) == null || k.focus({ preventScroll: !0 });
    });
    const p = computed(() => getRectOfNodes(t.value)), f = computed(() => ({
      width: `${p.value.width}px`,
      height: `${p.value.height}px`,
      top: `${p.value.y}px`,
      left: `${p.value.x}px`
    }));
    function g(k) {
      o.selectionContextMenu({ event: k, nodes: t.value });
    }
    function b(k) {
      a || arrowKeyDiffs[k.key] && s(
        {
          x: arrowKeyDiffs[k.key].x,
          y: arrowKeyDiffs[k.key].y
        },
        k.shiftKey
      );
    }
    return (k, x) => !unref(l) && p.value.width && p.value.height ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: normalizeClass(["vue-flow__nodesselection vue-flow__container", unref(r)]),
      style: normalizeStyle({ transform: `translate(${unref(n).x}px,${unref(n).y}px) scale(${unref(n).zoom})` })
    }, [
      createElementVNode("div", {
        ref_key: "el",
        ref: c,
        class: normalizeClass([{ dragging: unref(d) }, "vue-flow__nodesselection-rect"]),
        style: normalizeStyle(f.value),
        tabIndex: unref(a) ? void 0 : -1,
        onContextmenu: g,
        onKeydown: b
      }, null, 46, _hoisted_1$6$1)
    ], 6)) : createCommentVNode("", !0);
  }
});
function getMousePosition(e, o) {
  return {
    x: e.clientX - o.left,
    y: e.clientY - o.top
  };
}
const __default__$a = {
  name: "Pane",
  compatConfig: { MODE: 3 }
}, _sfc_main$a$1 = /* @__PURE__ */ defineComponent({
  ...__default__$a,
  props: {
    isSelecting: { type: Boolean },
    selectionKeyPressed: { type: Boolean }
  },
  setup(e) {
    const {
      vueFlowRef: o,
      nodes: n,
      viewport: t,
      emits: r,
      userSelectionActive: a,
      removeSelectedElements: l,
      panOnDrag: s,
      userSelectionRect: c,
      elementsSelectable: d,
      nodesSelectionActive: p,
      getSelectedEdges: f,
      getSelectedNodes: g,
      removeNodes: b,
      removeEdges: k,
      selectionMode: x,
      deleteKeyCode: N,
      multiSelectionKeyCode: O,
      multiSelectionActive: m,
      edgeLookup: ee,
      nodeLookup: z
    } = useVueFlow(), P = ref(null), V = ref(0), U = ref(0), E = ref(), C = ref(/* @__PURE__ */ new Map()), I = toRef(() => d.value && (e.isSelecting || a.value));
    let v = !1, M = !1;
    const $ = useKeyPress(N, { actInsideInputWithModifier: !1 }), H = useKeyPress(O);
    watch($, (ae) => {
      ae && (b(g.value), k(f.value), p.value = !1);
    }), watch(H, (ae) => {
      m.value = ae;
    });
    function X(ae, le) {
      return (fe) => {
        fe.target === le && (ae == null || ae(fe));
      };
    }
    function te() {
      a.value = !1, c.value = null, V.value = 0, U.value = 0;
    }
    function oe(ae) {
      if (v) {
        v = !1;
        return;
      }
      r.paneClick(ae), l(), p.value = !1;
    }
    function ne(ae) {
      var le;
      if (Array.isArray(s.value) && ((le = s.value) != null && le.includes(2))) {
        ae.preventDefault();
        return;
      }
      r.paneContextMenu(ae);
    }
    function ie(ae) {
      r.paneScroll(ae);
    }
    function se(ae) {
      var le, fe, Ce, Be, De;
      if (E.value = (le = o.value) == null ? void 0 : le.getBoundingClientRect(), !d.value || !e.isSelecting || ae.button !== 0 || ae.target !== P.value || !E.value)
        return;
      (Ce = (fe = ae.target) == null ? void 0 : fe.setPointerCapture) == null || Ce.call(fe, ae.pointerId);
      const { x: Fe, y: Me } = getMousePosition(ae, E.value);
      M = !0, v = !1, C.value = /* @__PURE__ */ new Map();
      for (const [xe, _e] of ee.value)
        C.value.set(_e.source, ((Be = C.value.get(_e.source)) == null ? void 0 : Be.add(xe)) || /* @__PURE__ */ new Set([xe])), C.value.set(_e.target, ((De = C.value.get(_e.target)) == null ? void 0 : De.add(xe)) || /* @__PURE__ */ new Set([xe]));
      l(), c.value = {
        width: 0,
        height: 0,
        startX: Fe,
        startY: Me,
        x: Fe,
        y: Me
      }, r.selectionStart(ae);
    }
    function pe(ae) {
      if (!E.value || !c.value)
        return;
      v = !0;
      const { x: le, y: fe } = getEventPosition(ae, E.value), { startX: Ce = 0, startY: Be = 0 } = c.value, De = {
        startX: Ce,
        startY: Be,
        x: le < Ce ? le : Ce,
        y: fe < Be ? fe : Be,
        width: Math.abs(le - Ce),
        height: Math.abs(fe - Be)
      }, Fe = getNodesInside(
        n.value,
        De,
        t.value,
        x.value === SelectionMode.Partial,
        !0
      ), Me = /* @__PURE__ */ new Set(), xe = /* @__PURE__ */ new Set();
      for (const _e of Fe) {
        xe.add(_e.id);
        const Ee = C.value.get(_e.id);
        if (Ee)
          for (const re of Ee)
            Me.add(re);
      }
      if (V.value !== xe.size) {
        V.value = xe.size;
        const _e = getSelectionChanges(z.value, xe, !0);
        r.nodesChange(_e);
      }
      if (U.value !== Me.size) {
        U.value = Me.size;
        const _e = getSelectionChanges(ee.value, Me);
        r.edgesChange(_e);
      }
      c.value = De, a.value = !0, p.value = !1;
    }
    function he(ae) {
      var le;
      ae.button !== 0 || !M || ((le = ae.target) == null || le.releasePointerCapture(ae.pointerId), !a.value && c.value && ae.target === P.value && oe(ae), V.value > 0 && (p.value = !0), te(), r.selectionEnd(ae), e.selectionKeyPressed && (v = !1), M = !1);
    }
    return (ae, le) => (openBlock(), createElementBlock("div", {
      ref_key: "container",
      ref: P,
      class: normalizeClass(["vue-flow__pane vue-flow__container", { selection: ae.isSelecting }]),
      onClick: le[0] || (le[0] = (fe) => I.value ? void 0 : X(oe, P.value)(fe)),
      onContextmenu: le[1] || (le[1] = (fe) => X(ne, P.value)(fe)),
      onWheelPassive: le[2] || (le[2] = (fe) => X(ie, P.value)(fe)),
      onPointerenter: le[3] || (le[3] = (fe) => I.value ? void 0 : unref(r).paneMouseEnter(fe)),
      onPointerdown: le[4] || (le[4] = (fe) => I.value ? se(fe) : unref(r).paneMouseMove(fe)),
      onPointermove: le[5] || (le[5] = (fe) => I.value ? pe(fe) : unref(r).paneMouseMove(fe)),
      onPointerup: le[6] || (le[6] = (fe) => I.value ? he(fe) : void 0),
      onPointerleave: le[7] || (le[7] = (fe) => unref(r).paneMouseLeave(fe))
    }, [
      renderSlot(ae.$slots, "default"),
      unref(a) && unref(c) ? (openBlock(), createBlock(_sfc_main$c$1, {
        key: 0,
        "user-selection-rect": unref(c)
      }, null, 8, ["user-selection-rect"])) : createCommentVNode("", !0),
      unref(p) && unref(g).length ? (openBlock(), createBlock(_sfc_main$b$1, { key: 1 })) : createCommentVNode("", !0)
    ], 34));
  }
}), __default__$9 = {
  name: "Transform",
  compatConfig: { MODE: 3 }
}, _sfc_main$9$1 = /* @__PURE__ */ defineComponent({
  ...__default__$9,
  setup(e) {
    const { viewport: o, fitViewOnInit: n, fitViewOnInitDone: t } = useVueFlow(), r = computed(() => n.value ? !t.value : !1), a = computed(() => `translate(${o.value.x}px,${o.value.y}px) scale(${o.value.zoom})`);
    return (l, s) => (openBlock(), createElementBlock("div", {
      class: "vue-flow__transformationpane vue-flow__container",
      style: normalizeStyle({ transform: a.value, opacity: r.value ? 0 : void 0 })
    }, [
      renderSlot(l.$slots, "default")
    ], 4));
  }
}), __default__$8 = {
  name: "Viewport",
  compatConfig: { MODE: 3 }
}, _sfc_main$8$1 = /* @__PURE__ */ defineComponent({
  ...__default__$8,
  setup(e) {
    const {
      minZoom: o,
      maxZoom: n,
      defaultViewport: t,
      translateExtent: r,
      zoomActivationKeyCode: a,
      selectionKeyCode: l,
      panActivationKeyCode: s,
      panOnScroll: c,
      panOnScrollMode: d,
      panOnScrollSpeed: p,
      panOnDrag: f,
      zoomOnDoubleClick: g,
      zoomOnPinch: b,
      zoomOnScroll: k,
      preventScrolling: x,
      noWheelClassName: N,
      noPanClassName: O,
      emits: m,
      connectionStartHandle: ee,
      userSelectionActive: z,
      paneDragging: P,
      d3Zoom: V,
      d3Selection: U,
      d3ZoomHandler: E,
      viewport: C,
      viewportRef: I,
      paneClickDistance: v
    } = useVueFlow();
    useResizeHandler(I);
    const M = ref(!1), $ = ref(!1);
    let H = null, X = !1, te = 0, oe = {
      x: 0,
      y: 0,
      zoom: 0
    };
    const ne = useKeyPress(s), ie = useKeyPress(l), se = useKeyPress(a), pe = toRef(() => !ie.value && (ne.value || f.value)), he = toRef(() => ne.value || c.value), ae = toRef(() => ie.value || l.value === !0 && pe.value !== !0);
    onMounted(() => {
      if (!I.value) {
        warn$1("Viewport element is missing");
        return;
      }
      const Fe = I.value, Me = Fe.getBoundingClientRect(), xe = zoom().clickDistance(v.value).scaleExtent([o.value, n.value]).translateExtent(r.value), _e = select(Fe).call(xe), Ee = _e.on("wheel.zoom"), re = identity.translate(t.value.x ?? 0, t.value.y ?? 0).scale(clamp(t.value.zoom ?? 1, o.value, n.value)), ce = [
        [0, 0],
        [Me.width, Me.height]
      ], ye = xe.constrain()(re, ce, r.value);
      xe.transform(_e, ye), xe.wheelDelta(fe), V.value = xe, U.value = _e, E.value = Ee, C.value = { x: ye.x, y: ye.y, zoom: ye.k }, xe.on("start", (me) => {
        var ue;
        if (!me.sourceEvent)
          return null;
        te = me.sourceEvent.button, M.value = !0;
        const ve = Be(me.transform);
        ((ue = me.sourceEvent) == null ? void 0 : ue.type) === "mousedown" && (P.value = !0), oe = ve, m.viewportChangeStart(ve), m.moveStart({ event: me, flowTransform: ve });
      }), xe.on("end", (me) => {
        if (!me.sourceEvent)
          return null;
        if (M.value = !1, P.value = !1, le(pe.value, te ?? 0) && !X && m.paneContextMenu(me.sourceEvent), X = !1, Ce(oe, me.transform)) {
          const ue = Be(me.transform);
          oe = ue, m.viewportChangeEnd(ue), m.moveEnd({ event: me, flowTransform: ue });
        }
      }), xe.filter((me) => {
        var ue, ve, we;
        const Se = se.value || k.value, de = b.value && me.ctrlKey, ge = me.button;
        if ((pe.value === !0 || Array.isArray(pe.value) && pe.value.includes(1)) && ge === 1 && me.type === "mousedown" && ((ue = me.target) != null && ue.closest(".vue-flow__node") || (ve = me.target) != null && ve.closest(".vue-flow__edge")))
          return !0;
        if (!pe.value && !Se && !he.value && !g.value && !b.value || z.value || !g.value && me.type === "dblclick" || De(me, N.value) && me.type === "wheel" || De(me, O.value) && (me.type !== "wheel" || he.value && me.type === "wheel" && !se.value) || !b.value && me.ctrlKey && me.type === "wheel" || !Se && !he.value && !de && me.type === "wheel")
          return !1;
        if (!b && me.type === "touchstart" && ((we = me.touches) == null ? void 0 : we.length) > 1)
          return me.preventDefault(), !1;
        if (!pe.value && (me.type === "mousedown" || me.type === "touchstart") || Array.isArray(pe.value) && !pe.value.includes(ge) && (me.type === "mousedown" || me.type === "touchstart"))
          return !1;
        const be = Array.isArray(pe.value) && pe.value.includes(ge) || !ge || ge <= 1;
        return (!me.ctrlKey || me.type === "wheel") && be;
      }), watch(
        [z, pe],
        () => {
          z.value && !M.value ? xe.on("zoom", null) : z.value || xe.on("zoom", (me) => {
            C.value = { x: me.transform.x, y: me.transform.y, zoom: me.transform.k };
            const ue = Be(me.transform);
            X = le(pe.value, te ?? 0), m.viewportChange(ue), m.move({ event: me, flowTransform: ue });
          });
        },
        { immediate: !0 }
      ), watch(
        [z, he, d, se, b, x, N],
        () => {
          he.value && !se.value && !z.value ? _e.on(
            "wheel.zoom",
            (me) => {
              if (De(me, N.value))
                return !1;
              const ue = se.value || k.value, ve = b.value && me.ctrlKey;
              if (!(!x.value || he.value || ue || ve))
                return !1;
              me.preventDefault(), me.stopImmediatePropagation();
              const Se = _e.property("__zoom").k || 1, de = isMacOs();
              if (me.ctrlKey && b.value && de) {
                const Oe = pointer(me), Pe = fe(me), Te = Se * 2 ** Pe;
                xe.scaleTo(_e, Te, Oe, me);
                return;
              }
              const ge = me.deltaMode === 1 ? 20 : 1;
              let be = d.value === PanOnScrollMode.Vertical ? 0 : me.deltaX * ge, ke = d.value === PanOnScrollMode.Horizontal ? 0 : me.deltaY * ge;
              !de && me.shiftKey && d.value !== PanOnScrollMode.Vertical && !be && ke && (be = ke, ke = 0), xe.translateBy(
                _e,
                -(be / Se) * p.value,
                -(ke / Se) * p.value
              );
              const Ne = Be(_e.property("__zoom"));
              H && clearTimeout(H), $.value ? (m.move({ event: me, flowTransform: Ne }), m.viewportChange(Ne), H = setTimeout(() => {
                m.moveEnd({ event: me, flowTransform: Ne }), m.viewportChangeEnd(Ne), $.value = !1;
              }, 150)) : ($.value = !0, m.moveStart({ event: me, flowTransform: Ne }), m.viewportChangeStart(Ne));
            },
            { passive: !1 }
          ) : typeof Ee < "u" && _e.on(
            "wheel.zoom",
            function(me, ue) {
              const ve = !x.value && me.type === "wheel" && !me.ctrlKey, we = se.value || k.value, Se = b.value && me.ctrlKey;
              if (!we && !c.value && !Se && me.type === "wheel" || ve || De(me, N.value))
                return null;
              me.preventDefault(), Ee.call(this, me, ue);
            },
            { passive: !1 }
          );
        },
        { immediate: !0 }
      );
    });
    function le(Fe, Me) {
      return Me === 2 && Array.isArray(Fe) && Fe.includes(2);
    }
    function fe(Fe) {
      const Me = Fe.ctrlKey && isMacOs() ? 10 : 1;
      return -Fe.deltaY * (Fe.deltaMode === 1 ? 0.05 : Fe.deltaMode ? 1 : 2e-3) * Me;
    }
    function Ce(Fe, Me) {
      return Fe.x !== Me.x && !Number.isNaN(Me.x) || Fe.y !== Me.y && !Number.isNaN(Me.y) || Fe.zoom !== Me.k && !Number.isNaN(Me.k);
    }
    function Be(Fe) {
      return {
        x: Fe.x,
        y: Fe.y,
        zoom: Fe.k
      };
    }
    function De(Fe, Me) {
      return Fe.target.closest(`.${Me}`);
    }
    return (Fe, Me) => (openBlock(), createElementBlock("div", {
      ref_key: "viewportRef",
      ref: I,
      class: "vue-flow__viewport vue-flow__container"
    }, [
      createVNode(_sfc_main$a$1, {
        "is-selecting": ae.value,
        "selection-key-pressed": unref(ie),
        class: normalizeClass({
          connecting: !!unref(ee),
          dragging: unref(P),
          draggable: unref(f) === !0 || Array.isArray(unref(f)) && unref(f).includes(0)
        })
      }, {
        default: withCtx(() => [
          createVNode(_sfc_main$9$1, null, {
            default: withCtx(() => [
              renderSlot(Fe.$slots, "default")
            ]),
            _: 3
          })
        ]),
        _: 3
      }, 8, ["is-selecting", "selection-key-pressed", "class"])
    ], 512));
  }
}), _hoisted_1$5$1 = ["id"], _hoisted_2$h = ["id"], _hoisted_3$e = ["id"], __default__$7 = {
  name: "A11yDescriptions",
  compatConfig: { MODE: 3 }
}, _sfc_main$7$1 = /* @__PURE__ */ defineComponent({
  ...__default__$7,
  setup(e) {
    const { id: o, disableKeyboardA11y: n, ariaLiveMessage: t } = useVueFlow();
    return (r, a) => (openBlock(), createElementBlock(Fragment, null, [
      createElementVNode("div", {
        id: `${unref(ARIA_NODE_DESC_KEY)}-${unref(o)}`,
        style: { display: "none" }
      }, " Press enter or space to select a node. " + toDisplayString$1(unref(n) ? "" : "You can then use the arrow keys to move the node around.") + " You can then use the arrow keys to move the node around, press delete to remove it and press escape to cancel. ", 9, _hoisted_1$5$1),
      createElementVNode("div", {
        id: `${unref(ARIA_EDGE_DESC_KEY)}-${unref(o)}`,
        style: { display: "none" }
      }, " Press enter or space to select an edge. You can then press delete to remove it or press escape to cancel. ", 8, _hoisted_2$h),
      unref(n) ? createCommentVNode("", !0) : (openBlock(), createElementBlock("div", {
        key: 0,
        id: `${unref(ARIA_LIVE_MESSAGE)}-${unref(o)}`,
        "aria-live": "assertive",
        "aria-atomic": "true",
        style: { position: "absolute", width: "1px", height: "1px", margin: "-1px", border: "0", padding: "0", overflow: "hidden", clip: "rect(0px, 0px, 0px, 0px)", "clip-path": "inset(100%)" }
      }, toDisplayString$1(unref(t)), 9, _hoisted_3$e))
    ], 64));
  }
});
function useOnInitHandler() {
  const e = useVueFlow();
  watch(
    () => e.viewportHelper.value.viewportInitialized,
    (o) => {
      o && setTimeout(() => {
        e.emits.init(e), e.emits.paneReady(e);
      }, 1);
    }
  );
}
function shiftX(e, o, n) {
  return n === Position.Left ? e - o : n === Position.Right ? e + o : e;
}
function shiftY(e, o, n) {
  return n === Position.Top ? e - o : n === Position.Bottom ? e + o : e;
}
const EdgeAnchor = function({
  radius: e = 10,
  centerX: o = 0,
  centerY: n = 0,
  position: t = Position.Top,
  type: r
}) {
  return h("circle", {
    class: `vue-flow__edgeupdater vue-flow__edgeupdater-${r}`,
    cx: shiftX(o, e, t),
    cy: shiftY(n, e, t),
    r: e,
    stroke: "transparent",
    fill: "transparent"
  });
};
EdgeAnchor.props = ["radius", "centerX", "centerY", "position", "type"];
EdgeAnchor.compatConfig = { MODE: 3 };
const EdgeAnchor$1 = EdgeAnchor, EdgeWrapper = defineComponent({
  name: "Edge",
  compatConfig: { MODE: 3 },
  props: ["id"],
  setup(e) {
    const {
      id: o,
      addSelectedEdges: n,
      connectionMode: t,
      edgeUpdaterRadius: r,
      emits: a,
      nodesSelectionActive: l,
      noPanClassName: s,
      getEdgeTypes: c,
      removeSelectedEdges: d,
      findEdge: p,
      findNode: f,
      isValidConnection: g,
      multiSelectionActive: b,
      disableKeyboardA11y: k,
      elementsSelectable: x,
      edgesUpdatable: N,
      edgesFocusable: O
    } = useVueFlow(), m = computed(() => p(e.id)), ee = useEdgeHooks(m.value, a), z = inject(Slots), P = getCurrentInstance(), V = ref(!1), U = ref(!1), E = ref(""), C = ref(null), I = ref("source"), v = ref(null), M = toRef(
      () => typeof m.value.selectable > "u" ? x.value : m.value.selectable
    ), $ = toRef(() => typeof m.value.updatable > "u" ? N.value : m.value.updatable), H = toRef(() => typeof m.value.focusable > "u" ? O.value : m.value.focusable);
    provide(EdgeId, e.id), provide(EdgeRef, v);
    const X = computed(() => m.value.class instanceof Function ? m.value.class(m.value) : m.value.class), te = computed(() => m.value.style instanceof Function ? m.value.style(m.value) : m.value.style), oe = computed(() => {
      const Ee = m.value.type || "default", re = z == null ? void 0 : z[`edge-${Ee}`];
      if (re)
        return re;
      let ce = m.value.template ?? c.value[Ee];
      if (typeof ce == "string" && P) {
        const ye = Object.keys(P.appContext.components);
        ye && ye.includes(Ee) && (ce = resolveComponent(Ee, !1));
      }
      return ce && typeof ce != "string" ? ce : (a.error(new VueFlowError(ErrorCode.EDGE_TYPE_MISSING, ce)), !1);
    }), { handlePointerDown: ne } = useHandle({
      nodeId: E,
      handleId: C,
      type: I,
      isValidConnection: g,
      edgeUpdaterType: I,
      onEdgeUpdate: pe,
      onEdgeUpdateEnd: he
    });
    return () => {
      const Ee = f(m.value.source), re = f(m.value.target), ce = "pathOptions" in m.value ? m.value.pathOptions : {};
      if (!Ee && !re)
        return a.error(new VueFlowError(ErrorCode.EDGE_SOURCE_TARGET_MISSING, m.value.id, m.value.source, m.value.target)), null;
      if (!Ee)
        return a.error(new VueFlowError(ErrorCode.EDGE_SOURCE_MISSING, m.value.id, m.value.source)), null;
      if (!re)
        return a.error(new VueFlowError(ErrorCode.EDGE_TARGET_MISSING, m.value.id, m.value.target)), null;
      if (!m.value || m.value.hidden || Ee.hidden || re.hidden)
        return null;
      let ye;
      t.value === ConnectionMode.Strict ? ye = Ee.handleBounds.source : ye = [...Ee.handleBounds.source || [], ...Ee.handleBounds.target || []];
      const me = getHandle(ye, m.value.sourceHandle);
      let ue;
      t.value === ConnectionMode.Strict ? ue = re.handleBounds.target : ue = [...re.handleBounds.target || [], ...re.handleBounds.source || []];
      const ve = getHandle(ue, m.value.targetHandle), we = (me == null ? void 0 : me.position) || Position.Bottom, Se = (ve == null ? void 0 : ve.position) || Position.Top, { x: de, y: ge } = getHandlePosition(Ee, me, we), { x: be, y: ke } = getHandlePosition(re, ve, Se);
      return m.value.sourceX = de, m.value.sourceY = ge, m.value.targetX = be, m.value.targetY = ke, h(
        "g",
        {
          ref: v,
          key: e.id,
          "data-id": e.id,
          class: [
            "vue-flow__edge",
            `vue-flow__edge-${oe.value === !1 ? "default" : m.value.type || "default"}`,
            s.value,
            X.value,
            {
              updating: V.value,
              selected: m.value.selected,
              animated: m.value.animated,
              inactive: !M.value
            }
          ],
          onClick: le,
          onContextmenu: fe,
          onDblclick: Ce,
          onMouseenter: Be,
          onMousemove: De,
          onMouseleave: Fe,
          onKeyDown: H.value ? _e : void 0,
          tabIndex: H.value ? 0 : void 0,
          "aria-label": m.value.ariaLabel === null ? void 0 : m.value.ariaLabel || `Edge from ${m.value.source} to ${m.value.target}`,
          "aria-describedby": H.value ? `${ARIA_EDGE_DESC_KEY}-${o}` : void 0,
          role: H.value ? "button" : "img"
        },
        [
          U.value ? null : h(oe.value === !1 ? c.value.default : oe.value, {
            id: e.id,
            sourceNode: Ee,
            targetNode: re,
            source: m.value.source,
            target: m.value.target,
            type: m.value.type,
            updatable: $.value,
            selected: m.value.selected,
            animated: m.value.animated,
            label: m.value.label,
            labelStyle: m.value.labelStyle,
            labelShowBg: m.value.labelShowBg,
            labelBgStyle: m.value.labelBgStyle,
            labelBgPadding: m.value.labelBgPadding,
            labelBgBorderRadius: m.value.labelBgBorderRadius,
            data: m.value.data,
            events: { ...m.value.events, ...ee.on },
            style: te.value,
            markerStart: `url('#${getMarkerId(m.value.markerStart, o)}')`,
            markerEnd: `url('#${getMarkerId(m.value.markerEnd, o)}')`,
            sourcePosition: we,
            targetPosition: Se,
            sourceX: de,
            sourceY: ge,
            targetX: be,
            targetY: ke,
            sourceHandleId: m.value.sourceHandle,
            targetHandleId: m.value.targetHandle,
            interactionWidth: m.value.interactionWidth,
            ...ce
          }),
          [
            $.value === "source" || $.value === !0 ? [
              h(
                "g",
                {
                  onMousedown: Me,
                  onMouseenter: ie,
                  onMouseout: se
                },
                h(EdgeAnchor$1, {
                  position: we,
                  centerX: de,
                  centerY: ge,
                  radius: r.value,
                  type: "source",
                  "data-type": "source"
                })
              )
            ] : null,
            $.value === "target" || $.value === !0 ? [
              h(
                "g",
                {
                  onMousedown: xe,
                  onMouseenter: ie,
                  onMouseout: se
                },
                h(EdgeAnchor$1, {
                  position: Se,
                  centerX: be,
                  centerY: ke,
                  radius: r.value,
                  type: "target",
                  "data-type": "target"
                })
              )
            ] : null
          ]
        ]
      );
    };
    function ie() {
      V.value = !0;
    }
    function se() {
      V.value = !1;
    }
    function pe(Ee, re) {
      ee.emit.update({ event: Ee, edge: m.value, connection: re });
    }
    function he(Ee) {
      ee.emit.updateEnd({ event: Ee, edge: m.value }), U.value = !1;
    }
    function ae(Ee, re) {
      Ee.button === 0 && (U.value = !0, E.value = re ? m.value.target : m.value.source, C.value = (re ? m.value.targetHandle : m.value.sourceHandle) ?? "", I.value = re ? "target" : "source", ee.emit.updateStart({ event: Ee, edge: m.value }), ne(Ee));
    }
    function le(Ee) {
      var re;
      const ce = { event: Ee, edge: m.value };
      M.value && (l.value = !1, m.value.selected && b.value ? (d([m.value]), (re = v.value) == null || re.blur()) : n([m.value])), ee.emit.click(ce);
    }
    function fe(Ee) {
      ee.emit.contextMenu({ event: Ee, edge: m.value });
    }
    function Ce(Ee) {
      ee.emit.doubleClick({ event: Ee, edge: m.value });
    }
    function Be(Ee) {
      ee.emit.mouseEnter({ event: Ee, edge: m.value });
    }
    function De(Ee) {
      ee.emit.mouseMove({ event: Ee, edge: m.value });
    }
    function Fe(Ee) {
      ee.emit.mouseLeave({ event: Ee, edge: m.value });
    }
    function Me(Ee) {
      ae(Ee, !0);
    }
    function xe(Ee) {
      ae(Ee, !1);
    }
    function _e(Ee) {
      var re;
      !k.value && elementSelectionKeys.includes(Ee.key) && M.value && (Ee.key === "Escape" ? ((re = v.value) == null || re.blur(), d([p(e.id)])) : n([p(e.id)]));
    }
  }
}), EdgeWrapper$1 = EdgeWrapper, oppositePosition = {
  [Position.Left]: Position.Right,
  [Position.Right]: Position.Left,
  [Position.Top]: Position.Bottom,
  [Position.Bottom]: Position.Top
}, ConnectionLine = defineComponent({
  name: "ConnectionLine",
  compatConfig: { MODE: 3 },
  setup() {
    var e;
    const {
      id: o,
      connectionMode: n,
      connectionStartHandle: t,
      connectionEndHandle: r,
      connectionPosition: a,
      connectionLineType: l,
      connectionLineStyle: s,
      connectionLineOptions: c,
      connectionStatus: d,
      viewport: p,
      findNode: f
    } = useVueFlow(), g = (e = inject(Slots)) == null ? void 0 : e["connection-line"], b = computed(() => {
      var m;
      return f((m = t.value) == null ? void 0 : m.nodeId);
    }), k = computed(() => {
      var m;
      return f((m = r.value) == null ? void 0 : m.nodeId) ?? null;
    }), x = computed(() => ({
      x: (a.value.x - p.value.x) / p.value.zoom,
      y: (a.value.y - p.value.y) / p.value.zoom
    })), N = computed(
      () => c.value.markerStart ? `url(#${getMarkerId(c.value.markerStart, o)})` : ""
    ), O = computed(
      () => c.value.markerEnd ? `url(#${getMarkerId(c.value.markerEnd, o)})` : ""
    );
    return () => {
      var m, ee, z, P;
      if (!b.value || !t.value)
        return null;
      const V = t.value.handleId, U = t.value.type, E = b.value.handleBounds;
      let C = E == null ? void 0 : E[U];
      if (n.value === ConnectionMode.Loose && (C = C || (E == null ? void 0 : E[U === "source" ? "target" : "source"])), !C)
        return null;
      const I = (V ? C.find((ie) => ie.id === V) : C[0]) ?? null, v = (I == null ? void 0 : I.position) || Position.Top, { x: M, y: $ } = getHandlePosition(b.value, I, v);
      let H = null;
      k.value && ((m = r.value) != null && m.handleId) && (n.value === ConnectionMode.Strict ? H = ((ee = k.value.handleBounds[U === "source" ? "target" : "source"]) == null ? void 0 : ee.find(
        (ie) => {
          var se;
          return ie.id === ((se = r.value) == null ? void 0 : se.handleId);
        }
      )) || null : H = ((z = [...k.value.handleBounds.source || [], ...k.value.handleBounds.target || []]) == null ? void 0 : z.find(
        (ie) => {
          var se;
          return ie.id === ((se = r.value) == null ? void 0 : se.handleId);
        }
      )) || null);
      const X = ((P = r.value) == null ? void 0 : P.position) ?? (v ? oppositePosition[v] : null);
      if (!v || !X)
        return null;
      const te = l.value ?? c.value.type ?? ConnectionLineType.Bezier;
      let oe = "";
      const ne = {
        sourceX: M,
        sourceY: $,
        sourcePosition: v,
        targetX: x.value.x,
        targetY: x.value.y,
        targetPosition: X
      };
      return te === ConnectionLineType.Bezier ? [oe] = getBezierPath(ne) : te === ConnectionLineType.Step ? [oe] = getSmoothStepPath({
        ...ne,
        borderRadius: 0
      }) : te === ConnectionLineType.SmoothStep ? [oe] = getSmoothStepPath(ne) : te === ConnectionLineType.SimpleBezier ? [oe] = getSimpleBezierPath(ne) : oe = `M${M},${$} ${x.value.x},${x.value.y}`, h(
        "svg",
        { class: "vue-flow__edges vue-flow__connectionline vue-flow__container" },
        h(
          "g",
          { class: "vue-flow__connection" },
          g ? h(g, {
            sourceX: M,
            sourceY: $,
            sourcePosition: v,
            targetX: x.value.x,
            targetY: x.value.y,
            targetPosition: X,
            sourceNode: b.value,
            sourceHandle: I,
            targetNode: k.value,
            targetHandle: H,
            markerEnd: O.value,
            markerStart: N.value,
            connectionStatus: d.value
          }) : h("path", {
            d: oe,
            class: [c.value.class, d, "vue-flow__connection-path"],
            style: {
              ...s.value,
              ...c.value.style
            },
            "marker-end": O.value,
            "marker-start": N.value
          })
        )
      );
    };
  }
}), ConnectionLine$1 = ConnectionLine, _hoisted_1$4$1 = ["id", "markerWidth", "markerHeight", "markerUnits", "orient"], __default__$6 = {
  name: "MarkerType",
  compatConfig: { MODE: 3 }
}, _sfc_main$6$1 = /* @__PURE__ */ defineComponent({
  ...__default__$6,
  props: {
    id: {},
    type: {},
    color: { default: "none" },
    width: { default: 12.5 },
    height: { default: 12.5 },
    markerUnits: { default: "strokeWidth" },
    orient: { default: "auto-start-reverse" },
    strokeWidth: { default: 1 }
  },
  setup(e) {
    return (o, n) => (openBlock(), createElementBlock("marker", {
      id: o.id,
      class: "vue-flow__arrowhead",
      viewBox: "-10 -10 20 20",
      refX: "0",
      refY: "0",
      markerWidth: `${o.width}`,
      markerHeight: `${o.height}`,
      markerUnits: o.markerUnits,
      orient: o.orient
    }, [
      o.type === unref(MarkerType).ArrowClosed ? (openBlock(), createElementBlock("polyline", {
        key: 0,
        style: normalizeStyle({
          stroke: o.color,
          fill: o.color,
          strokeWidth: o.strokeWidth
        }),
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        points: "-5,-4 0,0 -5,4 -5,-4"
      }, null, 4)) : createCommentVNode("", !0),
      o.type === unref(MarkerType).Arrow ? (openBlock(), createElementBlock("polyline", {
        key: 1,
        style: normalizeStyle({
          stroke: o.color,
          strokeWidth: o.strokeWidth
        }),
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        fill: "none",
        points: "-5,-4 0,0 -5,4"
      }, null, 4)) : createCommentVNode("", !0)
    ], 8, _hoisted_1$4$1));
  }
}), _hoisted_1$3$1 = { class: "vue-flow__marker vue-flow__container" }, __default__$5 = {
  name: "MarkerDefinitions",
  compatConfig: { MODE: 3 }
}, _sfc_main$5$1 = /* @__PURE__ */ defineComponent({
  ...__default__$5,
  setup(e) {
    const { id: o, edges: n, connectionLineOptions: t, defaultMarkerColor: r } = useVueFlow(), a = computed(() => {
      const l = /* @__PURE__ */ new Set(), s = [], c = (d) => {
        if (d) {
          const p = getMarkerId(d, o);
          l.has(p) || (typeof d == "object" ? s.push({ ...d, id: p, color: d.color || r.value }) : s.push({ id: p, color: r.value, type: d }), l.add(p));
        }
      };
      for (const d of [t.value.markerEnd, t.value.markerStart])
        c(d);
      for (const d of n.value)
        for (const p of [d.markerStart, d.markerEnd])
          c(p);
      return s.sort((d, p) => d.id.localeCompare(p.id));
    });
    return (l, s) => (openBlock(), createElementBlock("svg", _hoisted_1$3$1, [
      createElementVNode("defs", null, [
        (openBlock(!0), createElementBlock(Fragment, null, renderList(a.value, (c) => (openBlock(), createBlock(_sfc_main$6$1, {
          id: c.id,
          key: c.id,
          type: c.type,
          color: c.color,
          width: c.width,
          height: c.height,
          markerUnits: c.markerUnits,
          "stroke-width": c.strokeWidth,
          orient: c.orient
        }, null, 8, ["id", "type", "color", "width", "height", "markerUnits", "stroke-width", "orient"]))), 128))
      ])
    ]));
  }
}), __default__$4 = {
  name: "Edges",
  compatConfig: { MODE: 3 }
}, _sfc_main$4$1 = /* @__PURE__ */ defineComponent({
  ...__default__$4,
  setup(e) {
    const { findNode: o, getEdges: n, elevateEdgesOnSelect: t } = useVueFlow();
    return (r, a) => (openBlock(), createElementBlock(Fragment, null, [
      createVNode(_sfc_main$5$1),
      (openBlock(!0), createElementBlock(Fragment, null, renderList(unref(n), (l) => (openBlock(), createElementBlock("svg", {
        key: l.id,
        class: "vue-flow__edges vue-flow__container",
        style: normalizeStyle({ zIndex: unref(getEdgeZIndex)(l, unref(o), unref(t)) })
      }, [
        createVNode(unref(EdgeWrapper$1), {
          id: l.id
        }, null, 8, ["id"])
      ], 4))), 128)),
      createVNode(unref(ConnectionLine$1))
    ], 64));
  }
}), NodeWrapper = defineComponent({
  name: "Node",
  compatConfig: { MODE: 3 },
  props: ["id", "resizeObserver"],
  setup(e) {
    const {
      id: o,
      noPanClassName: n,
      selectNodesOnDrag: t,
      nodesSelectionActive: r,
      multiSelectionActive: a,
      emits: l,
      removeSelectedNodes: s,
      addSelectedNodes: c,
      updateNodeDimensions: d,
      onUpdateNodeInternals: p,
      getNodeTypes: f,
      nodeExtent: g,
      elevateNodesOnSelect: b,
      disableKeyboardA11y: k,
      ariaLiveMessage: x,
      snapToGrid: N,
      snapGrid: O,
      nodeDragThreshold: m,
      nodesDraggable: ee,
      elementsSelectable: z,
      nodesConnectable: P,
      nodesFocusable: V
    } = useVueFlow(), U = ref(null);
    provide(NodeRef, U), provide(NodeId, e.id);
    const E = inject(Slots), C = getCurrentInstance(), I = useUpdateNodePositions(), { node: v, parentNode: M } = useNode(e.id), $ = toRef(() => typeof v.draggable > "u" ? ee.value : v.draggable), H = toRef(() => typeof v.selectable > "u" ? z.value : v.selectable), X = toRef(() => typeof v.connectable > "u" ? P.value : v.connectable), te = toRef(() => typeof v.focusable > "u" ? V.value : v.focusable), oe = toRef(() => !!v.dimensions.width && !!v.dimensions.height), ne = computed(() => {
      const re = v.type || "default", ce = E == null ? void 0 : E[`node-${re}`];
      if (ce)
        return ce;
      let ye = v.template || f.value[re];
      if (typeof ye == "string" && C) {
        const me = Object.keys(C.appContext.components);
        me && me.includes(re) && (ye = resolveComponent(re, !1));
      }
      return ye && typeof ye != "string" ? ye : (l.error(new VueFlowError(ErrorCode.NODE_TYPE_MISSING, ye)), !1);
    }), { emit: ie, on: se } = useNodeHooks(v, l), pe = useDrag({
      id: e.id,
      el: U,
      disabled: () => !$.value,
      selectable: H,
      dragHandle: () => v.dragHandle,
      onStart(re) {
        ie.dragStart(re);
      },
      onDrag(re) {
        ie.drag(re);
      },
      onStop(re) {
        ie.dragStop(re);
      },
      onClick(re) {
        _e(re);
      }
    }), he = computed(() => v.class instanceof Function ? v.class(v) : v.class), ae = computed(() => {
      const re = (v.style instanceof Function ? v.style(v) : v.style) || {}, ce = v.width instanceof Function ? v.width(v) : v.width, ye = v.height instanceof Function ? v.height(v) : v.height;
      return ce && (re.width = typeof ce == "string" ? ce : `${ce}px`), ye && (re.height = typeof ye == "string" ? ye : `${ye}px`), re;
    }), le = toRef(() => Number(v.zIndex ?? ae.value.zIndex ?? 0));
    return p((re) => {
      (re.includes(e.id) || !re.length) && Ce();
    }), onMounted(() => {
      watch(
        () => v.hidden,
        (re = !1, ce, ye) => {
          !re && U.value && (e.resizeObserver.observe(U.value), ye(() => {
            U.value && e.resizeObserver.unobserve(U.value);
          }));
        },
        { immediate: !0, flush: "post" }
      );
    }), watch([() => v.type, () => v.sourcePosition, () => v.targetPosition], () => {
      nextTick(() => {
        d([{ id: e.id, nodeElement: U.value, forceUpdate: !0 }]);
      });
    }), watch(
      [
        () => v.position.x,
        () => v.position.y,
        () => {
          var re;
          return (re = M.value) == null ? void 0 : re.computedPosition.x;
        },
        () => {
          var re;
          return (re = M.value) == null ? void 0 : re.computedPosition.y;
        },
        () => {
          var re;
          return (re = M.value) == null ? void 0 : re.computedPosition.z;
        },
        le,
        () => v.selected,
        () => v.dimensions.height,
        () => v.dimensions.width,
        () => {
          var re;
          return (re = M.value) == null ? void 0 : re.dimensions.height;
        },
        () => {
          var re;
          return (re = M.value) == null ? void 0 : re.dimensions.width;
        }
      ],
      ([re, ce, ye, me, ue, ve]) => {
        const we = {
          x: re,
          y: ce,
          z: ve + (b.value && v.selected ? 1e3 : 0)
        };
        typeof ye < "u" && typeof me < "u" ? v.computedPosition = getXYZPos({ x: ye, y: me, z: ue }, we) : v.computedPosition = we;
      },
      { flush: "post", immediate: !0 }
    ), watch([() => v.extent, g], ([re, ce], [ye, me]) => {
      (re !== ye || ce !== me) && fe();
    }), v.extent === "parent" || typeof v.extent == "object" && "range" in v.extent && v.extent.range === "parent" ? until(() => oe).toBe(!0).then(fe) : fe(), () => v.hidden ? null : h(
      "div",
      {
        ref: U,
        "data-id": v.id,
        class: [
          "vue-flow__node",
          `vue-flow__node-${ne.value === !1 ? "default" : v.type || "default"}`,
          {
            [n.value]: $.value,
            dragging: pe == null ? void 0 : pe.value,
            draggable: $.value,
            selected: v.selected,
            selectable: H.value,
            parent: v.isParent
          },
          he.value
        ],
        style: {
          visibility: oe.value ? "visible" : "hidden",
          zIndex: v.computedPosition.z ?? le.value,
          transform: `translate(${v.computedPosition.x}px,${v.computedPosition.y}px)`,
          pointerEvents: H.value || $.value ? "all" : "none",
          ...ae.value
        },
        tabIndex: te.value ? 0 : void 0,
        role: te.value ? "button" : void 0,
        "aria-describedby": k.value ? void 0 : `${ARIA_NODE_DESC_KEY}-${o}`,
        "aria-label": v.ariaLabel,
        onMouseenter: Be,
        onMousemove: De,
        onMouseleave: Fe,
        onContextmenu: Me,
        onClick: _e,
        onDblclick: xe,
        onKeydown: Ee
      },
      [
        h(ne.value === !1 ? f.value.default : ne.value, {
          id: v.id,
          type: v.type,
          data: v.data,
          events: { ...v.events, ...se },
          selected: v.selected,
          resizing: v.resizing,
          dragging: pe.value,
          connectable: X.value,
          position: v.computedPosition,
          dimensions: v.dimensions,
          isValidTargetPos: v.isValidTargetPos,
          isValidSourcePos: v.isValidSourcePos,
          parent: v.parentNode,
          parentNodeId: v.parentNode,
          zIndex: v.computedPosition.z ?? le.value,
          targetPosition: v.targetPosition,
          sourcePosition: v.sourcePosition,
          label: v.label,
          dragHandle: v.dragHandle,
          onUpdateNodeInternals: Ce
        })
      ]
    );
    function fe() {
      const re = v.computedPosition;
      N.value && (re.x = O.value[0] * Math.round(re.x / O.value[0]), re.y = O.value[1] * Math.round(re.y / O.value[1]));
      const { computedPosition: ce, position: ye } = calcNextPosition(v, re, l.error, g.value, M.value);
      (v.computedPosition.x !== ce.x || v.computedPosition.y !== ce.y) && (v.computedPosition = { ...v.computedPosition, ...ce }), (v.position.x !== ye.x || v.position.y !== ye.y) && (v.position = ye);
    }
    function Ce() {
      U.value && d([{ id: e.id, nodeElement: U.value, forceUpdate: !0 }]);
    }
    function Be(re) {
      pe != null && pe.value || ie.mouseEnter({ event: re, node: v });
    }
    function De(re) {
      pe != null && pe.value || ie.mouseMove({ event: re, node: v });
    }
    function Fe(re) {
      pe != null && pe.value || ie.mouseLeave({ event: re, node: v });
    }
    function Me(re) {
      return ie.contextMenu({ event: re, node: v });
    }
    function xe(re) {
      return ie.doubleClick({ event: re, node: v });
    }
    function _e(re) {
      H.value && (!t.value || !$.value || m.value > 0) && handleNodeClick(
        v,
        a.value,
        c,
        s,
        r,
        !1,
        U.value
      ), ie.click({ event: re, node: v });
    }
    function Ee(re) {
      if (!(isInputDOMNode(re) || k.value))
        if (elementSelectionKeys.includes(re.key) && H.value) {
          const ce = re.key === "Escape";
          handleNodeClick(
            v,
            a.value,
            c,
            s,
            r,
            ce,
            U.value
          );
        } else $.value && v.selected && arrowKeyDiffs[re.key] && (x.value = `Moved selected node ${re.key.replace("Arrow", "").toLowerCase()}. New position, x: ${~~v.position.x}, y: ${~~v.position.y}`, I(
          {
            x: arrowKeyDiffs[re.key].x,
            y: arrowKeyDiffs[re.key].y
          },
          re.shiftKey
        ));
    }
  }
}), NodeWrapper$1 = NodeWrapper;
function useNodesInitialized(e = { includeHiddenNodes: !1 }) {
  const { nodes: o } = useVueFlow();
  return computed(() => {
    if (o.value.length === 0)
      return !1;
    for (const n of o.value)
      if ((e.includeHiddenNodes || !n.hidden) && ((n == null ? void 0 : n.handleBounds) === void 0 || n.dimensions.width === 0 || n.dimensions.height === 0))
        return !1;
    return !0;
  });
}
const _hoisted_1$1$1 = { class: "vue-flow__nodes vue-flow__container" }, __default__$2 = {
  name: "Nodes",
  compatConfig: { MODE: 3 }
}, _sfc_main$2$1 = /* @__PURE__ */ defineComponent({
  ...__default__$2,
  setup(e) {
    const { getNodes: o, updateNodeDimensions: n, emits: t } = useVueFlow(), r = useNodesInitialized(), a = ref();
    return watch(
      r,
      (l) => {
        l && nextTick(() => {
          t.nodesInitialized(o.value);
        });
      },
      { immediate: !0 }
    ), onMounted(() => {
      a.value = new ResizeObserver((l) => {
        const s = l.map((c) => ({
          id: c.target.getAttribute("data-id"),
          nodeElement: c.target,
          forceUpdate: !0
        }));
        nextTick(() => n(s));
      });
    }), onBeforeUnmount(() => {
      var l;
      return (l = a.value) == null ? void 0 : l.disconnect();
    }), (l, s) => (openBlock(), createElementBlock("div", _hoisted_1$1$1, [
      a.value ? (openBlock(!0), createElementBlock(Fragment, { key: 0 }, renderList(unref(o), (c, d, p, f) => {
        const g = [c.id];
        if (f && f.key === c.id && isMemoSame(f, g))
          return f;
        const b = (openBlock(), createBlock(unref(NodeWrapper$1), {
          id: c.id,
          key: c.id,
          "resize-observer": a.value
        }, null, 8, ["id", "resize-observer"]));
        return b.memo = g, b;
      }, s, 0), 128)) : createCommentVNode("", !0)
    ]));
  }
});
function useStylesLoadedWarning() {
  const { emits: e } = useVueFlow();
  onMounted(() => {
    if (isDev()) {
      const o = document.querySelector(".vue-flow__pane");
      o && window.getComputedStyle(o).zIndex !== "1" && e.error(new VueFlowError(ErrorCode.MISSING_STYLES));
    }
  });
}
const _hoisted_1$k = /* @__PURE__ */ createElementVNode("div", { class: "vue-flow__edge-labels" }, null, -1), __default__$1 = {
  name: "VueFlow",
  compatConfig: { MODE: 3 }
}, _sfc_main$1$1 = /* @__PURE__ */ defineComponent({
  ...__default__$1,
  props: {
    id: {},
    modelValue: {},
    nodes: {},
    edges: {},
    edgeTypes: {},
    nodeTypes: {},
    connectionMode: {},
    connectionLineType: {},
    connectionLineStyle: { default: void 0 },
    connectionLineOptions: { default: void 0 },
    connectionRadius: {},
    isValidConnection: { type: [Function, null], default: void 0 },
    deleteKeyCode: { default: void 0 },
    selectionKeyCode: { default: void 0 },
    multiSelectionKeyCode: { default: void 0 },
    zoomActivationKeyCode: { default: void 0 },
    panActivationKeyCode: { default: void 0 },
    snapToGrid: { type: Boolean, default: void 0 },
    snapGrid: {},
    onlyRenderVisibleElements: { type: Boolean, default: void 0 },
    edgesUpdatable: { type: [Boolean, String], default: void 0 },
    nodesDraggable: { type: Boolean, default: void 0 },
    nodesConnectable: { type: Boolean, default: void 0 },
    nodeDragThreshold: {},
    elementsSelectable: { type: Boolean, default: void 0 },
    selectNodesOnDrag: { type: Boolean, default: void 0 },
    panOnDrag: { type: [Boolean, Array], default: void 0 },
    minZoom: {},
    maxZoom: {},
    defaultViewport: {},
    translateExtent: {},
    nodeExtent: {},
    defaultMarkerColor: {},
    zoomOnScroll: { type: Boolean, default: void 0 },
    zoomOnPinch: { type: Boolean, default: void 0 },
    panOnScroll: { type: Boolean, default: void 0 },
    panOnScrollSpeed: {},
    panOnScrollMode: {},
    paneClickDistance: {},
    zoomOnDoubleClick: { type: Boolean, default: void 0 },
    preventScrolling: { type: Boolean, default: void 0 },
    selectionMode: {},
    edgeUpdaterRadius: {},
    fitViewOnInit: { type: Boolean, default: void 0 },
    connectOnClick: { type: Boolean, default: void 0 },
    applyDefault: { type: Boolean, default: void 0 },
    autoConnect: { type: [Boolean, Function], default: void 0 },
    noDragClassName: {},
    noWheelClassName: {},
    noPanClassName: {},
    defaultEdgeOptions: {},
    elevateEdgesOnSelect: { type: Boolean, default: void 0 },
    elevateNodesOnSelect: { type: Boolean, default: void 0 },
    disableKeyboardA11y: { type: Boolean, default: void 0 },
    edgesFocusable: { type: Boolean, default: void 0 },
    nodesFocusable: { type: Boolean, default: void 0 },
    autoPanOnConnect: { type: Boolean, default: void 0 },
    autoPanOnNodeDrag: { type: Boolean, default: void 0 },
    autoPanSpeed: {}
  },
  emits: ["nodesChange", "edgesChange", "nodesInitialized", "paneReady", "init", "updateNodeInternals", "error", "connect", "connectStart", "connectEnd", "clickConnectStart", "clickConnectEnd", "moveStart", "move", "moveEnd", "selectionDragStart", "selectionDrag", "selectionDragStop", "selectionContextMenu", "selectionStart", "selectionEnd", "viewportChangeStart", "viewportChange", "viewportChangeEnd", "paneScroll", "paneClick", "paneContextMenu", "paneMouseEnter", "paneMouseMove", "paneMouseLeave", "edgeUpdate", "edgeContextMenu", "edgeMouseEnter", "edgeMouseMove", "edgeMouseLeave", "edgeDoubleClick", "edgeClick", "edgeUpdateStart", "edgeUpdateEnd", "nodeContextMenu", "nodeMouseEnter", "nodeMouseMove", "nodeMouseLeave", "nodeDoubleClick", "nodeClick", "nodeDragStart", "nodeDrag", "nodeDragStop", "miniMapNodeClick", "miniMapNodeDoubleClick", "miniMapNodeMouseEnter", "miniMapNodeMouseMove", "miniMapNodeMouseLeave", "update:modelValue", "update:nodes", "update:edges"],
  setup(e, { expose: o, emit: n }) {
    const t = e, r = useSlots(), a = useVModel(t, "modelValue", n), l = useVModel(t, "nodes", n), s = useVModel(t, "edges", n), c = useVueFlow(t), d = useWatchProps({ modelValue: a, nodes: l, edges: s }, t, c);
    return useHooks(n, c.hooks), useOnInitHandler(), useStylesLoadedWarning(), provide(Slots, r), onUnmounted(() => {
      d();
    }), o(c), (p, f) => (openBlock(), createElementBlock("div", {
      ref: unref(c).vueFlowRef,
      class: "vue-flow"
    }, [
      createVNode(_sfc_main$8$1, null, {
        default: withCtx(() => [
          createVNode(_sfc_main$4$1),
          _hoisted_1$k,
          createVNode(_sfc_main$2$1),
          renderSlot(p.$slots, "zoom-pane")
        ]),
        _: 3
      }),
      renderSlot(p.$slots, "default"),
      createVNode(_sfc_main$7$1)
    ], 512));
  }
}), upStreamColor = "#67b4a0", lowerStreamColor = "#3880d4", waitExecColor = "#cccccc", skipColor = "#f8e3c5", lineWidth = 6, commentLineWidth = 2, opacity = 88, _sfc_main$n = /* @__PURE__ */ defineComponent({
  name: "alc-voucher-flow",
  inheritAttrs: !1,
  __name: "voucher-flow",
  props: {
    title: {},
    flowId: {},
    flowType: {}
  },
  setup(e, { expose: o }) {
    o();
    const n = e, t = useDialogState({
      title: n.title
    });
    watch(() => t.fullscreen.value, k);
    const r = useProviderConfig("state"), a = ref(), l = ref([]), s = ref(!1), c = ref(!0);
    useVueFlow({
      connectionLineType: ConnectionLineType.SmoothStep,
      panOnScrollMode: PanOnScrollMode.Vertical
    });
    const d = [
      { id: "1", label: "请购单", partOf: "up" },
      { id: "3", label: "发起询价", partOf: "up" },
      { id: "4", label: "询报价", partOf: "up" },
      { id: "5", label: "确定报价", partOf: "up" },
      { id: "6", label: "发起合同", partOf: "up" },
      { id: "7", label: "签署合同", partOf: "lower" },
      { id: "8", label: "采购订单", partOf: "up" },
      { id: "9", label: "销售订单", partOf: "lower" },
      { id: "18", label: "发票开具", partOf: "up" },
      { id: "10", label: "采购付款", partOf: "up", canIgnore: !0 },
      { id: "11", label: "销售收款", partOf: "lower", canIgnore: !0 },
      { id: "12", label: "发货单", partOf: "lower" },
      { id: "13", label: "出库单", partOf: "lower" },
      { id: "14", label: "到货单", partOf: "up" },
      { id: "15", label: "采购入库", partOf: "up" },
      { id: "16", label: "采购退货", partOf: "up" },
      { id: "17", label: "销售补货", partOf: "lower" }
    ];
    d.forEach((N, O) => {
      N.step = `${O + 1}`.padStart(2, "0");
    }), b();
    function p(N) {
      const O = {};
      return N.status === "wait" ? (O.backgroundColor = "#fff", O.themeColor = waitExecColor, O.border = `1px solid ${waitExecColor}`) : N.status === "skip" ? (O.backgroundColor = "#fff", O.themeColor = skipColor, O.border = `1px solid ${skipColor}`) : N.partOf === "up" ? O.backgroundColor = upStreamColor : N.partOf === "lower" && (O.backgroundColor = lowerStreamColor), {
        borderRadius: "50%",
        themeColor: O.themeColor || O.backgroundColor,
        ...O
      };
    }
    function f(N) {
      const O = {
        stroke: upStreamColor + opacity
      };
      return N.status === "wait" ? O.stroke = waitExecColor + opacity : N.status === "skip" ? O.stroke = skipColor + opacity : N.partOf === "up" ? O.stroke = upStreamColor + opacity : N.partOf === "lower" && (O.stroke = lowerStreamColor + opacity), {
        strokeWidth: lineWidth,
        ...O
      };
    }
    function g(N) {
      const O = N.find((v) => v.label === "采购退货"), m = N.find((v) => v.label === "销售订单"), ee = N.find((v) => v.label === "采购付款"), z = {
        sourceHandle: "bottom",
        targetHandle: "top"
      }, P = {
        sourceHandle: "right",
        targetHandle: "left"
      }, V = {
        sourceHandle: "left",
        targetHandle: "right"
      }, U = a.value.$el.offsetWidth, E = 126, C = 124, I = 16;
      return N.reduce(
        (v, M, $, H) => {
          if ($ !== 0) {
            if (v.mode === "vertical") {
              v.dir = v.dir === "right" ? "left" : "right", v.mode = "horizontal";
              const ie = v.list.at(-1);
              [ie.sourceHandle, ie.targetHandle] = [
                "bottom",
                "top"
              ];
            }
            if (v.dir === "right") {
              const ie = v.position.x + C;
              if (ie < U - C)
                v.position.x = ie;
              else {
                v.position.y += E, v.mode = "vertical";
                const se = v.list.at(-1), pe = v.list.at(-2);
                [se.sourceHandle, se.targetHandle] = [
                  "right",
                  "top"
                ], pe.position.x += I * 1.5;
              }
            } else if (v.dir === "left") {
              const ie = v.position.x - C;
              if (ie > C)
                v.position.x = ie;
              else {
                v.position.y += E, v.mode = "vertical";
                const se = v.list.at(-1), pe = v.list.at(-2);
                [se.sourceHandle, se.targetHandle] = [
                  "left",
                  "top"
                ], pe.position.x -= C;
              }
            }
          }
          const X = $ === 0 || $ === H.length - 1, te = p(M), oe = {
            id: M.id,
            type: X ? "edge-node" : "circle-node",
            position: { ...v.position },
            style: {
              ...M.style || {},
              ...te
            },
            data: {
              step: M.step,
              labelSide: "right",
              title: X ? $ === 0 ? "开始" : "结束" : M.label,
              desc: M.desc,
              color: te.themeColor
            }
          };
          v.list.push(oe);
          const ne = H[$ - 1];
          if (ne && v.list.push({
            id: `line-${ne.id}_${M.id}`,
            type: "straight",
            source: ne.id,
            target: M.id,
            ...v.mode === "horizontal" ? v.dir === "right" ? P : V : z,
            style: {
              ...f(ne),
              // 可略过的节点虚线示意，可略过节点的上下游连接线也是虚线
              ...M.canIgnore || ne.canIgnore ? {
                strokeDasharray: "5,5",
                strokeWidth: "2",
                // 可略过节点的上游节点和下游节点都点亮执行完毕时才能点亮
                ...ne.status !== "executed" || M.status !== "executed" ? {
                  stroke: "#f5f5f5"
                } : {}
              } : {}
            }
          }), M.label) {
            const ie = `comment_${M.id}`;
            v.list.push(
              {
                id: ie,
                type: "comment-node",
                position: {
                  x: oe.position.x - (M.status === "skip" ? 8 : 9),
                  y: oe.position.y + 48
                },
                data: {
                  step: M.step,
                  labelSide: "right",
                  title: M.label,
                  desc: M.desc,
                  color: oe.style.themeColor
                }
              },
              {
                id: `line-${M.id}_${ie}`,
                source: M.id,
                target: ie,
                ...v.mode === "horizontal" ? z : P,
                style: {
                  ...f(M),
                  strokeDasharray: void 0,
                  strokeWidth: commentLineWidth
                }
              }
            );
          }
          return v;
        },
        {
          // 节点信息
          list: [],
          // 当前节点的 position
          position: { x: C, y: 50 },
          mode: "horizontal",
          dir: "right"
        }
      ).list.concat([
        // 增加图例节点
        {
          id: "legend",
          type: "legend-node",
          position: { x: 0, y: 0 },
          style: { width: "100%", textAlign: "center" }
        },
        // 销售订单节点已执行并且采购付款已执行时不渲染销售订单至发货单的连接线
        ...(m == null ? void 0 : m.status) === "executed" && (ee == null ? void 0 : ee.status) === "skip" ? [
          {
            id: "skip-line",
            source: "9",
            target: "12",
            sourceHandle: "bottom",
            targetHandle: "top",
            style: {
              stroke: lowerStreamColor + opacity,
              strokeWidth: 4
            }
          }
        ] : [],
        // 采购退货节点执行时连接发货单节点
        ...(O == null ? void 0 : O.status) === "executed" ? [
          {
            id: "back",
            source: "17",
            target: "12",
            animated: !0
          }
        ] : []
      ]);
    }
    function b() {
      return s.value = !0, msPost("alc-biz-industry/Track/getTrackListByTypeAndUuid", {
        cVouchType: n.flowType,
        cUuid: n.flowId,
        cOrgUuid: r.value.cOrgUuid,
        cAccUuid: r.value.cAccUuid
        // cVouchType: 'PurchaseOrder',
        // cUuid: '6c981c34379e43949c22ea8a7090d259',
        // cOrgUuid: 'org1246f796c43a74c119b78ecba63b24882',
        // cAccUuid: 'u5d1246f796c43a74c119b78ecba63b24882',
      }).then((N) => {
        var O;
        if (N.code === 1) {
          if ((O = N.data) != null && O.length) {
            c.value = !0;
            const m = N.data, ee = d.reduce((z, P) => {
              const V = m.find((U) => U.cVouchTypeName === P.label);
              if (V) {
                let U;
                V.bExist ? U = "executed" : V.bExsitDownVouch ? V.cVouchTypeName === "采购付款" || V.cVouchTypeName === "销售收款" ? m.find((I) => I.cVouchTypeName === "销售订单") && (U = "executed") : !V.bExist && V.bExsitDownVouch && (U = "skip") : U = "wait";
                const E = {
                  ...P,
                  status: U,
                  desc: V.text
                };
                z.push(E);
              } else
                z.push({
                  ...P,
                  status: P.label === "销售补货" ? "wait" : "skip"
                });
              return z;
            }, []);
            ee.unshift({
              id: "start",
              status: "executed",
              style: { backgroundColor: upStreamColor }
            }), ee.push({
              id: "end",
              status: ee.at(-1).status
            }), l.value = g(ee);
          } else
            c.value = !1;
          return N.data;
        } else
          return c.value = !1, operatorErrorTip(N.msg), Promise.reject(N);
      }).catch(() => {
        c.value = !1, apiLinkErrorTip("单据流程");
      }).finally(() => {
        s.value = !1;
      });
    }
    function k() {
      var N;
      (N = a.value) == null || N.setTransform({
        x: 0,
        y: 0,
        zoom: 1
      });
    }
    const x = { props: n, dialogState: t, store: r, flowRef: a, elements: l, isLoading: s, hasElements: c, upStreamColor, lowerStreamColor, waitExecColor, skipColor, lineWidth, commentLineWidth, opacity, processNode: d, getNodeStyle: p, getLineStyle: f, generateNode: g, fetchFlowData: b, resetPosition: k, get Handle() {
      return _sfc_main$f$1;
    }, get Position() {
      return Position;
    }, get VueFlow() {
      return _sfc_main$1$1;
    }, get ElEmpty() {
      return ElEmpty;
    } };
    return Object.defineProperty(x, "__isScriptSetup", { enumerable: !1, value: !0 }), x;
  }
}), _hoisted_1$j = { style: { height: "calc(100% - 8px)", "max-width": "768px", margin: "0 auto", "padding-top": "8px" } }, _hoisted_2$g = { style: { height: "6px", width: "6px" } }, _hoisted_3$d = { style: { position: "relative" } }, _hoisted_4$a = {
  key: 0,
  width: "24px",
  height: "24px",
  xmlns: "http://www.w3.org/2000/svg"
}, _hoisted_5$8 = ["fill"], _hoisted_6$7 = {
  x: "50%",
  y: "50%",
  "text-anchor": "middle",
  dy: ".3em",
  "font-size": "14px",
  fill: "#fff"
}, _hoisted_7$7 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100px",
  height: "14px"
}, _hoisted_8$7 = ["fill"], _hoisted_9$7 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg"
}, _hoisted_10$6 = {
  width: "100",
  height: "46"
}, _hoisted_11$5 = ["title"], _hoisted_12$4 = {
  height: "36",
  width: "570",
  style: { "background-color": "#f8f8f8", "border-radius": "8px" },
  xmlns: "http://www.w3.org/2000/svg"
}, _hoisted_13$3 = /* @__PURE__ */ createElementVNode("text", {
  x: "60",
  y: "20",
  "font-size": "10",
  "alignment-baseline": "central"
}, " 已执行（下游） ", -1), _hoisted_14$1 = /* @__PURE__ */ createElementVNode("text", {
  x: "180",
  y: "20",
  "font-size": "10",
  "alignment-baseline": "central"
}, " 已执行（上游） ", -1), _hoisted_15$1 = /* @__PURE__ */ createElementVNode("text", {
  x: "300",
  y: "20",
  "font-size": "10",
  "alignment-baseline": "central"
}, " 待执行 ", -1), _hoisted_16$1 = /* @__PURE__ */ createElementVNode("text", {
  x: "390",
  y: "20",
  "font-size": "10",
  "alignment-baseline": "central"
}, " 跳过阶段 ", -1), _hoisted_17$1 = /* @__PURE__ */ createElementVNode("text", {
  x: "490",
  y: "20",
  "font-size": "10",
  "alignment-baseline": "central"
}, " 跳转下一环节 ", -1), _hoisted_18$1 = { style: { height: "6px", width: "6px" } }, _hoisted_19$1 = {
  width: "36px",
  height: "24px",
  xmlns: "http://www.w3.org/2000/svg",
  style: { position: "absolute", top: "1em", left: "50%", transform: "translateX(-50%)" }
}, _hoisted_20 = {
  x: "50%",
  y: "50%",
  "text-anchor": "middle",
  "font-size": "12px"
};
function _sfc_render$n(e, o, n, t, r, a) {
  const l = resolveDirective("loading");
  return withDirectives((openBlock(), createElementBlock("div", _hoisted_1$j, [
    t.hasElements ? (openBlock(), createBlock(t.VueFlow, {
      key: 0,
      ref: "flowRef",
      modelValue: t.elements,
      "onUpdate:modelValue": o[0] || (o[0] = (s) => t.elements = s),
      "nodes-draggable": !1,
      "fit-view-on-init": !1,
      "prevent-scrolling": "",
      "panel-position": "top-center"
    }, {
      "node-circle-node": withCtx(() => [
        createElementVNode("div", _hoisted_2$g, [
          createVNode(t.Handle, {
            id: "right",
            type: "source",
            position: t.Position.Right,
            style: { visibility: "hidden", width: "0", height: "0", left: "0" }
          }, null, 8, ["position"]),
          createVNode(t.Handle, {
            id: "left",
            type: "target",
            position: t.Position.Left,
            style: { visibility: "hidden", width: "0", height: "0", left: "-1px" }
          }, null, 8, ["position"]),
          createVNode(t.Handle, {
            id: "bottom",
            type: "target",
            position: t.Position.Bottom,
            style: { visibility: "hidden", width: "0", height: "0", top: "0", right: "0" }
          }, null, 8, ["position"]),
          createVNode(t.Handle, {
            id: "top",
            type: "target",
            position: t.Position.Top,
            style: { visibility: "hidden", width: "0", height: "0", top: "0", right: "0" }
          }, null, 8, ["position"])
        ])
      ]),
      "node-comment-node": withCtx(({ data: s }) => [
        createElementVNode("div", _hoisted_3$d, [
          s.step ? (openBlock(), createElementBlock("svg", _hoisted_4$a, [
            createElementVNode("circle", {
              cx: "12",
              cy: "12",
              r: "12",
              fill: s.color
            }, null, 8, _hoisted_5$8),
            createElementVNode("text", _hoisted_6$7, toDisplayString$1(s.step), 1)
          ])) : createCommentVNode("", !0),
          createElementVNode("div", {
            style: normalizeStyle([
              { position: "absolute", top: "0" },
              s.labelSide === "right" ? {
                left: "32px"
              } : { right: "32px" }
            ])
          }, [
            (openBlock(), createElementBlock("svg", _hoisted_7$7, [
              createElementVNode("text", {
                x: "0",
                y: "10",
                "font-size": "12",
                fill: s.color,
                style: { "font-weight": "500" }
              }, toDisplayString$1(s.title), 9, _hoisted_8$7)
            ])),
            s.desc ? (openBlock(), createElementBlock("svg", _hoisted_9$7, [
              (openBlock(), createElementBlock("foreignObject", _hoisted_10$6, [
                createElementVNode("p", {
                  title: s.desc,
                  style: normalizeStyle([{ color: s.color }, { "--line-clamp": "3", "font-size": "10px", margin: "0" }]),
                  class: "text-ellipsis"
                }, toDisplayString$1(s.desc), 13, _hoisted_11$5)
              ]))
            ])) : createCommentVNode("", !0)
          ], 4),
          createVNode(t.Handle, {
            id: "right",
            type: "source",
            position: t.Position.Right,
            style: { visibility: "hidden", width: "0", height: "0" }
          }, null, 8, ["position"]),
          createVNode(t.Handle, {
            id: "left",
            type: "target",
            position: t.Position.Left,
            style: { visibility: "hidden", width: "0", height: "0" }
          }, null, 8, ["position"]),
          createVNode(t.Handle, {
            id: "bottom",
            type: "target",
            position: t.Position.Bottom,
            style: { visibility: "hidden", width: "0", height: "0" }
          }, null, 8, ["position"]),
          createVNode(t.Handle, {
            id: "top",
            type: "target",
            position: t.Position.Top,
            style: { visibility: "hidden", width: "0", height: "0" }
          }, null, 8, ["position"])
        ])
      ]),
      "node-legend-node": withCtx(() => [
        (openBlock(), createElementBlock("svg", _hoisted_12$4, [
          createElementVNode("line", {
            x1: "20",
            y1: "20",
            x2: "50",
            y2: "20",
            "stroke-width": "4",
            stroke: t.upStreamColor,
            "stroke-linecap": "round"
          }),
          _hoisted_13$3,
          createElementVNode("line", {
            x1: "140",
            y1: "20",
            x2: "170",
            y2: "20",
            "stroke-width": "4",
            stroke: t.lowerStreamColor,
            "stroke-linecap": "round"
          }),
          _hoisted_14$1,
          createElementVNode("line", {
            x1: "260",
            y1: "20",
            x2: "290",
            y2: "20",
            "stroke-width": "4",
            stroke: t.waitExecColor,
            "stroke-linecap": "round"
          }),
          _hoisted_15$1,
          createElementVNode("line", {
            x1: "350",
            y1: "20",
            x2: "380",
            y2: "20",
            "stroke-width": "4",
            stroke: t.skipColor,
            "stroke-linecap": "round"
          }),
          _hoisted_16$1,
          createElementVNode("line", {
            x1: "450",
            y1: "20",
            x2: "480",
            y2: "20",
            "stroke-width": "2",
            stroke: t.waitExecColor,
            "stroke-dasharray": "3,5",
            "stroke-linecap": "round"
          }),
          _hoisted_17$1
        ]))
      ]),
      "node-edge-node": withCtx(({ data: s }) => [
        createElementVNode("div", _hoisted_18$1, [
          (openBlock(), createElementBlock("svg", _hoisted_19$1, [
            createElementVNode("text", _hoisted_20, toDisplayString$1(s.title), 1)
          ])),
          createVNode(t.Handle, {
            id: "right",
            type: "source",
            position: t.Position.Right,
            style: { visibility: "hidden", width: "0", height: "0", left: "0" }
          }, null, 8, ["position"]),
          createVNode(t.Handle, {
            id: "left",
            type: "target",
            position: t.Position.Left,
            style: { visibility: "hidden", width: "0", height: "0", left: "0" }
          }, null, 8, ["position"]),
          createVNode(t.Handle, {
            id: "bottom",
            type: "target",
            position: t.Position.Bottom,
            style: { visibility: "hidden", width: "0", height: "0", top: "0", right: "0" }
          }, null, 8, ["position"]),
          createVNode(t.Handle, {
            id: "top",
            type: "target",
            position: t.Position.Top,
            style: { visibility: "hidden", width: "0", height: "0", top: "0", right: "0" }
          }, null, 8, ["position"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])) : (openBlock(), createBlock(t.ElEmpty, {
      key: 1,
      description: "暂无数据"
    }))
  ])), [
    [l, t.isLoading]
  ]);
}
const AlcVoucherFlow = /* @__PURE__ */ _export_sfc(_sfc_main$n, [["render", _sfc_render$n], ["__file", "voucher-flow.vue"]]), _sfc_main$m = /* @__PURE__ */ defineComponent({
  name: "alc-invoice-list",
  __name: "invoice-list",
  props: {
    type: {},
    invoiceApplyUuid: {}
  },
  emits: ["toVoucher"],
  setup(e, { expose: o, emit: n }) {
    o();
    const t = e, r = n, { close: a } = useDialogState(), l = [
      { label: "数电发票号码", prop: "invoiceNo" },
      { label: "开票时间", prop: "invoiceTime" },
      ...t.type === "audit" ? [
        { label: "发票单号", prop: "cVouchCode" },
        {
          label: "发票状态",
          prop: "invoiceStatus",
          itemType: "select",
          code: "InvoiceStatus"
        }
      ] : []
    ], s = shallowRef([]);
    msPost(
      `alc-invoice/InvoiceApplyInfoAction/getInvoiceListForSource/${t.invoiceApplyUuid}`
    ).then((p) => {
      p.code === 1 ? s.value = p.data || [] : (operatorErrorTip(p.msg), a());
    }).catch(() => {
      apiLinkErrorTip("电子发票"), a();
    });
    function c(p) {
      isQiankun() ? visitOuterPage({
        path: "/electronic-invoice/output-management/Invoice-issuance",
        query: {
          params: encryptAES(
            JSON.stringify({ state: 3, orderUUID: p })
          )
        }
      }) : r("toVoucher", {
        path: "/electronic-invoice/output-management/Invoice-issuance",
        query: encryptAES(
          JSON.stringify({ state: 3, orderUUID: p })
        )
      });
    }
    const d = { props: t, emits: r, close: a, schema: l, invoiceList: s, openInvoiceVoucher: c, get AlcListNext() {
      return AlcListNext;
    }, get ElLink() {
      return ElLink;
    } };
    return Object.defineProperty(d, "__isScriptSetup", { enumerable: !1, value: !0 }), d;
  }
});
function _sfc_render$m(e, o, n, t, r, a) {
  return openBlock(), createBlock(t.AlcListNext, {
    data: t.invoiceList,
    schema: t.schema
  }, {
    invoiceNo: withCtx(({ row: l }) => [
      createVNode(t.ElLink, {
        href: l.pdfPath,
        target: "_blank"
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString$1(l.invoiceNo), 1)
        ]),
        _: 2
      }, 1032, ["href"])
    ]),
    cVouchCode: withCtx(({ row: l }) => [
      createVNode(t.ElLink, {
        onClick: (s) => t.openInvoiceVoucher(l.cIimUuid)
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString$1(l.cVouchCode), 1)
        ]),
        _: 2
      }, 1032, ["onClick"])
    ]),
    _: 1
  }, 8, ["data"]);
}
const InvoiceList = /* @__PURE__ */ _export_sfc(_sfc_main$m, [["render", _sfc_render$m], ["__file", "invoice-list.vue"]]), AlcInvoiceList = withInstall(InvoiceList), _sfc_main$l = /* @__PURE__ */ defineComponent({
  name: "alc-invoice-apply",
  __name: "invoice-apply",
  props: {
    invoiceBusinessType: {},
    packageType: {},
    businessKeys: {},
    packageList: {},
    cOrgUuid: {},
    cAccUuid: {},
    cPartnerUuid: {}
  },
  emits: ["done"],
  setup(e, { expose: o, emit: n }) {
    o();
    const t = e, r = n, { close: a } = useDialogState(), l = useProviderConfig("state"), s = ref([]), { formData: c, schema: d, rules: p, buyerTypeChange: f, invoiceTypeChange: g } = O(), { packageList$: b, invoiceTotal: k, isLoading: x } = m(), { invoiceType: N } = ee();
    function O() {
      msPost(`alc-invoice/InvoiceInfoAction/getHeader/${l.value.cOrgUuid}`).then((M) => {
        if (M.code === 1) {
          const $ = M.data[0];
          $ && (U = {
            buyerName: $.cName,
            buyerTaxNo: $.cTaxNo,
            buyerAddress: $.cAddress,
            buyerTel: $.cTel,
            buyerBankName: $.cBankName,
            buyerBankAccount: $.cBankAccount,
            receiverTel: l.value.cMobilePhone,
            cEmail: $.cEmail
          }), V.value = {
            ...U,
            buyerType: "01"
          };
        } else
          operatorErrorTip(M.msg);
      }).catch(() => {
        apiLinkErrorTip("发票默认信息");
      });
      const P = `<div>
        <p>电子发票开具成功后，会以以下两种方式通知接收手机号</p>
        <ol>
            <li>短信通知</li>
            <li>
                微信公众号通知（请在发票开具前，关注微信公众号“奥链平台”，关注后，
                <br> 在菜单栏-我的-手机号绑定 用接收手机号绑定成功后，就可以接收发票开具成功通知）
                <br>
                <img style="height: 100px" src="data:image/jpeg;base64,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" alt="">
            </li>
        </ol>
        <p>重要说明</p>
        <ol>
            <li>接收手机号不填写，不会通知</li>
            <li>短信条数不足，短信不会通知</li>
            <li>接收手机号未关注“奥链平台”微信你公众号或手机号未绑定，微信公众号不会通知</li>
        </ol>
    </div>`, V = ref({});
      let U = {};
      const E = {
        invoice: computed(() => [
          { isSlots: !0, label: "发票类型", prop: "invoiceType" },
          { isSlots: !0, label: "抬头类型", prop: "buyerType" },
          {
            isSlots: !0,
            label: "发票内容",
            prop: "invoiceContentType"
          },
          { itemType: "input", label: "抬头名称", prop: "buyerName" },
          ...V.value.buyerType !== "03" ? [
            {
              itemType: "input",
              label: "企业税号",
              prop: "buyerTaxNo"
            },
            {
              itemType: "input",
              label: "注册地址",
              prop: "buyerAddress"
            },
            {
              itemType: "input",
              label: "注册电话",
              prop: "buyerTel"
            },
            {
              itemType: "input",
              label: "开户银行",
              prop: "buyerBankName"
            },
            {
              itemType: "input",
              label: "银行账号",
              prop: "buyerBankAccount"
            }
          ] : [],
          {
            itemType: "input",
            label: "接收手机号",
            prop: "receiverTel",
            tips: P
          },
          { itemType: "input", label: "收票邮箱", prop: "cEmail" },
          { itemType: "input", label: "备注", prop: "remark" }
        ]),
        express: computed(() => [
          { itemType: "checkbox", label: "是否邮寄", prop: "bSend" },
          ...V.value.bSend ? [
            {
              itemType: "input",
              label: "收件人",
              prop: "receiver"
            },
            {
              itemType: "input",
              label: "收件人电话",
              prop: "reiciveTel"
            },
            {
              itemType: "region",
              label: "所在地区",
              prop: "reiciveArea",
              separator: "-"
            },
            {
              itemType: "input",
              label: "详细地址",
              prop: "reiciveAddress"
            }
          ] : []
        ])
      }, C = computed(() => ({
        invoiceType: {
          required: !0,
          message: "请选择发票类型",
          trigger: "change"
        },
        buyerType: {
          required: !0,
          message: "请选择抬头类型",
          trigger: "change"
        },
        invoiceContentType: {
          required: !0,
          message: "请选择发票内容",
          trigger: "change"
        },
        buyerName: {
          required: !0,
          message: "请填写抬头名称",
          trigger: "blur"
        },
        buyerTaxNo: {
          required: !0,
          message: "请填写企业税号",
          trigger: "blur"
        },
        ...V.value.bSend && {
          receiver: {
            required: !0,
            message: "请填写收件人",
            trigger: "blur"
          },
          reiciveTel: {
            required: !0,
            message: "请填写收件人电话",
            trigger: "blur"
          },
          reiciveArea: {
            required: !0,
            message: "请选择所在地区",
            trigger: "change"
          },
          reiciveAddress: {
            required: !0,
            message: "请填写详细地址",
            trigger: "blur"
          }
        }
      }));
      function I(M) {
        M === "01" ? Object.assign(V.value, U) : Object.keys(U).forEach(($) => {
          V.value[$] = void 0;
        });
      }
      function v(M) {
        M === "001" && (V.value.buyerType = "01", I(V.value.buyerType));
      }
      return {
        formData: V,
        schema: E,
        rules: C,
        buyerTypeChange: I,
        invoiceTypeChange: v
      };
    }
    function m() {
      const P = ref(!1), V = !!t.packageList, U = shallowRef(
        V ? t.packageList : []
      ), E = computed(() => {
        const C = U.value.reduce((I, v) => I.plus(v.money), BigNumber(0));
        return formatNumber(C, 2, !0);
      });
      return V || (P.value = !0, msPost("alc-public-opm/PlatformInvoiceAction/getAppPackage", {
        appPackageType: t.packageType,
        cAccUuid: l.value.cAccUuid,
        cOrgUuid: l.value.cOrgUuid,
        listBusinessKey: t.businessKeys
      }).then((C) => {
        C.code === 1 ? U.value = C.data || [] : (a(), operatorErrorTip(C.msg));
      }).catch(() => {
        a(), apiLinkErrorTip("电子发票");
      }).finally(() => {
        P.value = !1;
      })), {
        isLoading: P,
        packageList$: U,
        invoiceTotal: E
      };
    }
    function ee() {
      const P = ref([]);
      return msPost("alc-invoice/OrderSettingsAction/getInvoiceApplySetting", {
        bIsRootOperator: !t.cAccUuid,
        cOrgUuid: t.cOrgUuid,
        cAccUuid: t.cAccUuid,
        cPartnerUuid: t.cPartnerUuid
      }).then((V) => {
        var C, I, v;
        if (V.code !== 1 || !V.data || V.data.code !== 1)
          return void operatorErrorTip(((C = V.data) == null ? void 0 : C.msg) || V.msg);
        if (!((v = (I = V.data) == null ? void 0 : I.data) != null && v.IS_INVOICING_SUPPORTED))
          return void operatorErrorTip("当前业务不支持开票");
        const [
          { IS_ELECTRONIC_ORDINARY_INVOICE: U },
          { IS_ELECTRONIC_PROFESSIONAL_INVOICE: E }
        ] = V.data.data.child;
        P.value = [
          U && "ordinary",
          E && "pro"
        ];
      }).catch(() => {
        apiLinkErrorTip("发票申请");
      }), {
        invoiceType: P
      };
    }
    onDialogConfirm(async () => {
      var V;
      if (x.value)
        return;
      if ((await Promise.all(
        s.value.map((U) => U.validate())
      )).every(Boolean))
        return msPost(
          "alc-public-opm/PlatformInvoiceAction/savePlatformInvoiceApply",
          {
            ...c.value,
            reiciveArea: (V = c.value.reiciveArea) == null ? void 0 : V.join("-"),
            invoiceBusinessType: t.invoiceBusinessType,
            cAccUuid: l.value.cAccUuid,
            cOrgUuid: l.value.cOrgUuid,
            cOrgName: l.value.cOrgName,
            // cOperatorOrgUuid: state.value.cOwnOperatorUuid,
            listAppPackage: b.value
          }
        ).then((U) => {
          if (U.code === 1)
            return ElMessage.success("申请成功"), r("done"), !0;
          operatorErrorTip(U.msg);
        }).catch(() => {
          apiLinkErrorTip("电子发票");
        });
    });
    const z = { props: t, emits: r, close: a, state: l, formRefs: s, formData: c, schema: d, rules: p, buyerTypeChange: f, invoiceTypeChange: g, packageList$: b, invoiceTotal: k, isLoading: x, invoiceType: N, useSchema: O, usePackageList: m, useInvoiceType: ee, get ElRadioButton() {
      return ElRadioButton;
    }, get ElRadioGroup() {
      return ElRadioGroup;
    }, get AlcAreaTitle() {
      return AlcAreaTitle;
    }, get AlcForm() {
      return AlcForm;
    } };
    return Object.defineProperty(z, "__isScriptSetup", { enumerable: !1, value: !0 }), z;
  }
}), _hoisted_1$i = { style: { padding: "8px 16px" } };
function _sfc_render$l(e, o, n, t, r, a) {
  const l = resolveComponent("alc-tooltip"), s = resolveDirective("loading");
  return withDirectives((openBlock(), createElementBlock("div", _hoisted_1$i, [
    createVNode(t.AlcAreaTitle, {
      title: "订单信息",
      "extra-align": "left"
    }, {
      extra: withCtx(() => {
        var c, d;
        return [
          createTextVNode(" 已选 " + toDisplayString$1(((c = n.businessKeys) == null ? void 0 : c.length) ?? ((d = n.packageList) == null ? void 0 : d.length)) + " 个订单， 发票金额（含税）共：¥" + toDisplayString$1(t.invoiceTotal), 1)
        ];
      }),
      _: 1
    }),
    createVNode(t.AlcForm, {
      ref: (c) => t.formRefs.push(c),
      modelValue: t.formData,
      "onUpdate:modelValue": o[0] || (o[0] = (c) => t.formData = c),
      schema: [
        { itemType: "checkbox", label: "相同物料合并", prop: "bMerge" }
      ],
      rules: t.rules,
      column: 1,
      "label-width": "100px"
    }, null, 8, ["modelValue", "rules"]),
    createVNode(t.AlcAreaTitle, { title: "发票信息" }),
    createVNode(t.AlcForm, {
      ref: (c) => t.formRefs.push(c),
      modelValue: t.formData,
      "onUpdate:modelValue": o[4] || (o[4] = (c) => t.formData = c),
      schema: t.schema.invoice.value,
      rules: t.rules,
      column: 1,
      "label-width": "100px"
    }, {
      invoiceType: withCtx(() => [
        createVNode(t.ElRadioGroup, {
          modelValue: t.formData.invoiceType,
          "onUpdate:modelValue": o[1] || (o[1] = (c) => t.formData.invoiceType = c),
          onChange: t.invoiceTypeChange
        }, {
          default: withCtx(() => [
            createVNode(t.ElRadioButton, {
              label: "电子发票(普通发票)",
              value: "002",
              disabled: !t.invoiceType.includes("ordinary")
            }, null, 8, ["disabled"]),
            createVNode(t.ElRadioButton, {
              label: "电子发票(增值税专用发票)",
              value: "001",
              disabled: !t.invoiceType.includes("pro")
            }, null, 8, ["disabled"])
          ]),
          _: 1
        }, 8, ["modelValue", "onChange"])
      ]),
      buyerType: withCtx(() => [
        createVNode(t.ElRadioGroup, {
          modelValue: t.formData.buyerType,
          "onUpdate:modelValue": o[2] || (o[2] = (c) => t.formData.buyerType = c),
          onChange: t.buyerTypeChange
        }, {
          default: withCtx(() => [
            createVNode(t.ElRadioButton, {
              label: "企业",
              value: "01"
            }),
            createVNode(t.ElRadioButton, {
              disabled: t.formData.invoiceType === "001",
              label: "个人",
              value: "03"
            }, null, 8, ["disabled"])
          ]),
          _: 1
        }, 8, ["modelValue", "onChange"])
      ]),
      invoiceContentType: withCtx(() => [
        createVNode(t.ElRadioGroup, {
          modelValue: t.formData.invoiceContentType,
          "onUpdate:modelValue": o[3] || (o[3] = (c) => t.formData.invoiceContentType = c)
        }, {
          default: withCtx(() => [
            createVNode(t.ElRadioButton, {
              label: "明细",
              value: "1"
            }),
            createVNode(t.ElRadioButton, { value: "2" }, {
              default: withCtx(() => [
                createTextVNode(" 类别 "),
                createVNode(l, { content: "发票内容将显示应用所属类别" })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue", "schema", "rules"]),
    createVNode(t.AlcAreaTitle, { title: "邮寄信息" }),
    createVNode(t.AlcForm, {
      ref: (c) => t.formRefs.push(c),
      modelValue: t.formData,
      "onUpdate:modelValue": o[5] || (o[5] = (c) => t.formData = c),
      schema: t.schema.express.value,
      rules: t.rules,
      column: 1,
      "label-width": "100px"
    }, null, 8, ["modelValue", "schema", "rules"])
  ])), [
    [s, t.isLoading]
  ]);
}
const InvoiceApply = /* @__PURE__ */ _export_sfc(_sfc_main$l, [["render", _sfc_render$l], ["__file", "invoice-apply.vue"]]), AlcInvoiceApply = withInstall(InvoiceApply), alcPicturePreviewProps = {
  /**
   * 当前激活的图片索引
   * @default 0
   */
  active: { type: Number, default: 0 },
  /**
   * 图片列表
   */
  list: {
    type: Array,
    required: !0
  },
  /**
   * 是否显示工具栏
   * @default true
   */
  toolbar: { type: Boolean, default: !0 },
  /**
   * 自动切换时的时间间隔，单位为毫秒
   * @default 3000
   */
  interval: { type: Number, default: 3e3 }
}, useCounter = (e = 1, { min: o = -1 / 0, max: n = 1 / 0, step: t = 1 } = {}) => {
  const r = ref(e);
  return {
    counter: r,
    inc(a = t) {
      var s;
      const l = 10 ** (((s = String(0.25).split(".")[1]) == null ? void 0 : s.length) || 0);
      r.value = Math.min(
        n,
        (r.value * l + a * l) / l
      );
    },
    dec(a = t) {
      var s;
      const l = 10 ** (((s = String(0.25).split(".")[1]) == null ? void 0 : s.length) || 0);
      r.value = Math.max(
        o,
        (r.value * l - a * l) / l
      );
    },
    get() {
      return r.value;
    },
    set(a) {
      r.value = Math.min(n, Math.max(o, a));
    },
    reset(a = e) {
      this.set(a), e = r.value;
    }
  };
}, _sfc_main$k = /* @__PURE__ */ defineComponent({
  name: "alc-picture-preview",
  inheritAttrs: !1,
  __name: "picture-preview",
  props: alcPicturePreviewProps,
  emits: ["change", "close"],
  setup(e, { expose: o, emit: n }) {
    const t = e, r = n, { counter: a, ...l } = useCounter(1, {
      min: 0.01,
      max: 8,
      step: 0.1
    }), { counter: s, ...c } = useCounter(0, {
      step: 90
    }), d = {
      effect: "light",
      placement: "top"
    }, { close: p } = useDialogState(), f = `alc-picture-preview_${Date.now()}`, g = shallowRef(), b = ref(0), k = ref(!1), x = ref(!1), N = computed(() => t.list.map((ae) => ae instanceof Blob ? URL.createObjectURL(ae) : ae)), O = ref(!1), m = ref(0), ee = ref(0), z = ref(""), P = ref(!1), V = computed(() => ({
      transform: `translate(${m.value}px, ${ee.value}px) scale(${a.value}) rotate(${s.value}deg)`,
      transformOrigin: z.value,
      transition: O.value ? "none" : "all 0.25s cubic-bezier(0.55, 0, 0.1, 1)",
      cursor: P.value ? "grab" : "default"
    })), U = ref(!1), E = debounce(() => {
      U.value = !1;
    }, 1500);
    watch(a, () => {
      U.value || (U.value = !0), E();
    }), watch(
      () => t.active,
      (ae) => {
        b.value = ae, ae >= 0 && ae < N.value.length && nextTick(() => {
          var le;
          (le = g.value) == null || le.setActiveItem(ae);
        });
      },
      { immediate: !0 }
    ), useEventListener$1(document, "wheel", C, { passive: !0 }), useEventListener$1(document, "keyup", te, { passive: !0 }), onPageLeave(() => {
      N.value.forEach((ae) => {
        ae.startsWith("blob:") && URL.revokeObjectURL(ae);
      }), l.reset(), c.reset(), ne();
    });
    function C(ae) {
      let le = 0.1;
      a.value < 0.1 && a.value >= 0.01 ? le = 0.01 : a.value < 0.2 && a.value >= 0.1 ? le = 0.02 : a.value < 0.5 && a.value >= 0.2 ? le = 0.05 : a.value < 8 && a.value >= 5 ? le = 0.5 : a.value < 5 && a.value >= 2 && (le = 0.25), ae.deltaY > 0 ? l.dec(le) : l.inc(le), a.value <= 1 && ne();
    }
    let I, v;
    const M = (ae) => {
      if (a.value <= 1 || I === ae.clientX && v === ae.clientY)
        return;
      ({ clientX: I, clientY: v } = ae);
      const { left: le, top: fe, width: Ce, height: Be } = ae.currentTarget.getBoundingClientRect();
      z.value = `${(I - le) / Ce * 100}% ${(v - fe) / Be * 100}%`;
    };
    let $ = 0, H = 0;
    const X = (ae) => {
      if (!P.value)
        return;
      O.value = !0, document.addEventListener("mousemove", le), document.addEventListener(
        "mouseup",
        () => {
          O.value = !1, $ = m.value, H = ee.value, document.removeEventListener("mousemove", le);
        },
        { once: !0 }
      );
      function le(fe) {
        m.value = $ + (fe.clientX - ae.clientX), ee.value = H + (fe.clientY - ae.clientY);
      }
    };
    function te(ae) {
      var le, fe;
      ["=", "+"].includes(ae.key) ? l.inc() : ae.key === "-" ? l.dec() : ae.key === "ArrowLeft" ? (le = g.value) == null || le.prev() : ae.key === "ArrowRight" ? (fe = g.value) == null || fe.next() : ae.key === "Escape" && p();
    }
    function oe() {
      var le;
      const ae = (le = document.querySelectorAll(
        `.${f} .el-carousel__item`
      )) == null ? void 0 : le[b.value];
      if (ae) {
        const { clientWidth: fe, clientHeight: Ce } = ae, { width: Be, height: De } = ae.querySelector("img");
        l.set(Math.min(fe / Be, Ce / De));
      }
    }
    function ne() {
      m.value = 0, ee.value = 0, z.value = "", $ = 0, H = 0;
    }
    function ie(...ae) {
      l.reset(), c.reset(), b.value = ae[0], ne(), se(ae[0]), r("change", ...ae);
    }
    function se(ae) {
      const le = g.value.$el.querySelector(
        `.el-carousel__item:nth-of-type(${ae + 1}) > .preview-img__wrap > img`
      );
      P.value = le instanceof HTMLImageElement && le.getBoundingClientRect().top <= 54;
    }
    const pe = {
      play() {
        k.value = !0, x.value = !0;
      },
      pause() {
        k.value = !1, x.value = !1;
      }
    };
    o({
      scaleHandle: l,
      rotateHandle: c,
      autoplayHandle: pe,
      prev: () => {
        var ae;
        (ae = g.value) == null || ae.prev();
      },
      next: () => {
        var ae;
        (ae = g.value) == null || ae.next();
      },
      setActiveItem: (ae) => {
        var le;
        (le = g.value) == null || le.setActiveItem(ae);
      }
    });
    const he = { props: t, emits: r, scale: a, scaleHandle: l, rotate: s, rotateHandle: c, tooltipProps: d, close: p, handleClass: f, carouselRef: g, dynamicActive: b, autoplay: k, loop: x, imgStrList: N, isDragging: O, transitionX: m, transitionY: ee, transformOrigin: z, canDrag: P, imgStyle: V, scaleMutation: U, run: E, onMouseWheel: C, get clientX() {
      return I;
    }, set clientX(ae) {
      I = ae;
    }, get clientY() {
      return v;
    }, set clientY(ae) {
      v = ae;
    }, onWheelDisposeTransform: M, get oldTransitionX() {
      return $;
    }, set oldTransitionX(ae) {
      $ = ae;
    }, get oldTransitionY() {
      return H;
    }, set oldTransitionY(ae) {
      H = ae;
    }, onMouseDown: X, onKeyUp: te, imgAutoFill: oe, resetImgPosition: ne, onChange: ie, updateCanDrag: se, autoplayHandle: pe, get AlcDialogFooter() {
      return AlcDialogFooter;
    }, get ElCarousel() {
      return ElCarousel;
    }, get ElCarouselItem() {
      return ElCarouselItem;
    }, get ElDivider() {
      return ElDivider;
    }, get ElTooltip() {
      return ElTooltip;
    } };
    return Object.defineProperty(he, "__isScriptSetup", { enumerable: !1, value: !0 }), he;
  }
}), _hoisted_1$h = ["src", "alt"], _hoisted_2$f = {
  key: 1,
  class: "ri-image-line",
  style: { "font-size": "128px" }
}, _hoisted_3$c = { class: "scale-text" }, _hoisted_4$9 = {
  key: 0,
  class: "footer-toolbar"
}, _hoisted_5$7 = { class: "toolbar" }, _hoisted_6$6 = /* @__PURE__ */ createElementVNode("i", { class: "ri-slideshow-4-line" }, null, -1), _hoisted_7$6 = /* @__PURE__ */ createElementVNode("i", { class: "ri-gradienter-line" }, null, -1), _hoisted_8$6 = /* @__PURE__ */ createElementVNode("i", { class: "ri-zoom-in-line" }, null, -1), _hoisted_9$6 = /* @__PURE__ */ createElementVNode("i", { class: "ri-zoom-out-line" }, null, -1), _hoisted_10$5 = /* @__PURE__ */ createElementVNode("i", {
  class: "ri-restart-line",
  style: { transform: "rotateY(180deg)" }
}, null, -1), _hoisted_11$4 = /* @__PURE__ */ createElementVNode("i", { class: "ri-restart-line" }, null, -1), _hoisted_12$3 = /* @__PURE__ */ createElementVNode("i", { class: "ri-coupon-4-fill" }, null, -1), _hoisted_13$2 = /* @__PURE__ */ createElementVNode("i", { class: "ri-aspect-ratio-line" }, null, -1);
function _sfc_render$k(e, o, n, t, r, a) {
  return openBlock(), createElementBlock(Fragment, null, [
    createVNode(t.ElCarousel, {
      ref: "carouselRef",
      autoplay: t.autoplay,
      loop: t.loop,
      "initial-index": t.dynamicActive,
      interval: e.interval,
      class: normalizeClass(t.handleClass),
      trigger: "click",
      "indicator-position": "none",
      onChange: t.onChange
    }, {
      default: withCtx(() => [
        (openBlock(!0), createElementBlock(Fragment, null, renderList(t.imgStrList, (l, s) => (openBlock(), createBlock(t.ElCarouselItem, { key: s }, {
          default: withCtx(() => [
            createElementVNode("div", {
              style: normalizeStyle([t.imgStyle, { "will-change": "transform" }]),
              class: "preview-img__wrap",
              onMousedown: t.onMouseDown,
              onWheel: t.onWheelDisposeTransform
            }, [
              l ? (openBlock(), createElementBlock("img", {
                key: 0,
                src: l,
                alt: `轮播图${s}`,
                style: { "-webkit-user-drag": "none" }
              }, null, 8, _hoisted_1$h)) : (openBlock(), createElementBlock("i", _hoisted_2$f))
            ], 36)
          ]),
          _: 2
        }, 1024))), 128))
      ]),
      _: 1
    }, 8, ["autoplay", "loop", "initial-index", "interval"]),
    e.toolbar ? (openBlock(), createBlock(Transition$1, {
      key: 0,
      name: "el-fade-in",
      mode: "out-in"
    }, {
      default: withCtx(() => [
        withDirectives(createElementVNode("div", _hoisted_3$c, [
          createElementVNode("span", null, toDisplayString$1(Number.parseInt(t.scale * 100 + "")) + "% ", 1)
        ], 512), [
          [vShow, t.scaleMutation]
        ])
      ]),
      _: 1
    })) : createCommentVNode("", !0),
    createVNode(t.AlcDialogFooter, null, {
      default: withCtx(() => [
        e.toolbar ? (openBlock(), createElementBlock("div", _hoisted_4$9, [
          createElementVNode("div", _hoisted_5$7, [
            e.list.length > 1 ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
              createElementVNode("span", null, toDisplayString$1(t.dynamicActive + 1) + " / " + toDisplayString$1(e.list.length), 1),
              createVNode(t.ElDivider, { direction: "vertical" }),
              createVNode(Transition$1, {
                name: "el-fade-in",
                mode: "out-in"
              }, {
                default: withCtx(() => [
                  t.autoplay === !1 ? (openBlock(), createElementBlock("button", {
                    key: 0,
                    class: "el-button is-link",
                    onClick: o[0] || (o[0] = (l) => t.autoplayHandle.play())
                  }, [
                    createVNode(t.ElTooltip, mergeProps({ content: "自动播放" }, t.tooltipProps), {
                      default: withCtx(() => [
                        _hoisted_6$6
                      ]),
                      _: 1
                    }, 16)
                  ])) : (openBlock(), createElementBlock("button", {
                    key: 1,
                    class: "el-button is-link",
                    onClick: o[1] || (o[1] = (l) => t.autoplayHandle.pause())
                  }, [
                    createVNode(t.ElTooltip, mergeProps({ content: "停止播放" }, t.tooltipProps), {
                      default: withCtx(() => [
                        _hoisted_7$6
                      ]),
                      _: 1
                    }, 16)
                  ]))
                ]),
                _: 1
              })
            ], 64)) : createCommentVNode("", !0),
            createElementVNode("button", {
              class: "el-button is-link",
              onClick: o[2] || (o[2] = (l) => t.scaleHandle.inc()),
              onKeyupCapture: o[3] || (o[3] = withKeys((l) => t.scaleHandle.inc(), ["arrow-up"]))
            }, [
              createVNode(t.ElTooltip, mergeProps({ content: "放大" }, t.tooltipProps), {
                default: withCtx(() => [
                  _hoisted_8$6
                ]),
                _: 1
              }, 16)
            ], 32),
            createElementVNode("button", {
              class: "el-button is-link",
              onClick: o[4] || (o[4] = (l) => t.scaleHandle.dec()),
              onKeyupCapture: o[5] || (o[5] = withKeys((l) => t.scaleHandle.dec(), ["arrow-down"]))
            }, [
              createVNode(t.ElTooltip, {
                content: "缩小",
                effect: "light",
                placement: "top"
              }, {
                default: withCtx(() => [
                  _hoisted_9$6
                ]),
                _: 1
              })
            ], 32),
            createElementVNode("button", {
              class: "el-button is-link",
              onClick: o[6] || (o[6] = (l) => t.rotateHandle.inc())
            }, [
              createVNode(t.ElTooltip, {
                content: "向左旋转",
                effect: "light",
                placement: "top"
              }, {
                default: withCtx(() => [
                  _hoisted_10$5
                ]),
                _: 1
              })
            ]),
            createElementVNode("button", {
              class: "el-button is-link",
              onClick: o[7] || (o[7] = (l) => t.rotateHandle.dec())
            }, [
              createVNode(t.ElTooltip, {
                content: "向右旋转",
                effect: "light",
                placement: "top"
              }, {
                default: withCtx(() => [
                  _hoisted_11$4
                ]),
                _: 1
              })
            ]),
            createVNode(Transition$1, {
              name: "fade",
              mode: "out-in"
            }, {
              default: withCtx(() => [
                t.scale !== 1 || t.rotate % 360 !== 0 ? (openBlock(), createElementBlock("button", {
                  key: 0,
                  class: "el-button is-link",
                  onClick: o[8] || (o[8] = (l) => (t.resetImgPosition(), t.rotateHandle.reset(), t.scaleHandle.reset()))
                }, [
                  createVNode(t.ElTooltip, {
                    content: "实际大小",
                    effect: "light",
                    placement: "top"
                  }, {
                    default: withCtx(() => [
                      _hoisted_12$3
                    ]),
                    _: 1
                  })
                ])) : (openBlock(), createElementBlock("button", {
                  key: 1,
                  class: "el-button is-link",
                  onClick: t.imgAutoFill
                }, [
                  createVNode(t.ElTooltip, {
                    content: "适应屏幕",
                    effect: "light",
                    placement: "top"
                  }, {
                    default: withCtx(() => [
                      _hoisted_13$2
                    ]),
                    _: 1
                  })
                ]))
              ]),
              _: 1
            }),
            e.$slots.toolbar ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              createVNode(t.ElDivider, { direction: "vertical" }),
              renderSlot(e.$slots, "toolbar", normalizeProps(guardReactiveProps({
                index: t.dynamicActive,
                active: e.list[t.dynamicActive],
                list: e.list
              })))
            ], 64)) : createCommentVNode("", !0)
          ])
        ])) : createCommentVNode("", !0)
      ]),
      _: 3
    })
  ], 64);
}
const PicturePreview = /* @__PURE__ */ _export_sfc(_sfc_main$k, [["render", _sfc_render$k], ["__file", "picture-preview.vue"]]), AlcPicturePreview = withInstall(PicturePreview), useDialogOpen = (e, o) => {
  const n = getCurrentInstance();
  n && onBeforeUnmount(p);
  const t = `alc-dialog__${createUuid()}`;
  let r;
  n || (r = d);
  const a = shallowReactive({}), l = createVNode(
    AlcDialog,
    mergeProps(o || {}, { onClose: r }),
    {
      default: () => createVNode(e, a)
    }
    // 1 << 3 | 1 << 5,
  );
  l.appContext = (n == null ? void 0 : n.appContext) || appInstance._context;
  let s = l;
  function c(f) {
    var k;
    let g = document.querySelector(`.${t}`);
    g || (g = document.createElement("div"), g.className = t, document.body.append(g)), Object.assign(
      a,
      Object.keys(a).reduce((x, N) => (x[N] = void 0, x), {}),
      f
    );
    let b;
    if (typeof (o == null ? void 0 : o.onConfirm) != "function") {
      let x;
      b = new Promise((N) => {
        x = N;
      }), s = cloneVNode(l, {
        onConfirm: x
        // onClose: rj,
      });
    }
    return render$1(s, g), typeof (o == null ? void 0 : o.beforeOpen) == "function" ? o == null || o.beforeOpen(() => {
      var x;
      s.component && ((x = s.component.exposed) == null || x.open());
    }) : s.component && ((k = s.component.exposed) == null || k.open()), b;
  }
  function d() {
    var f, g;
    (g = (f = s.component) == null ? void 0 : f.exposed) == null || g.close(), (!n || o != null && o.destroyOnClose) && p();
  }
  function p() {
    const f = document.querySelector(`.${t}`);
    f && (render$1(null, f), document.body.removeChild(f));
  }
  return {
    open: c,
    close: d
  };
}, useCropperView = () => useDialogOpen(AlcPictureCropper, {
  title: "图片裁切",
  widthType: "xs"
});
function usePayView() {
  return useDialogOpen(AlcPayView, {
    title: "支付中心",
    widthType: "lg",
    showFooter: !1,
    showFullscreen: !0,
    contentHeightFit: !0
  });
}
function useSetWxMsgTemp() {
  return useDialogOpen(AlcWxMsgTemplate, {
    title: "设置微信消息参数",
    contentHeightFit: !0
  });
}
function useVoucherFlow() {
  return useDialogOpen(AlcVoucherFlow, {
    title: "单据流程图",
    widthType: "lg",
    showFullscreen: !0,
    contentHeightFit: !0,
    showFooter: !1
  });
}
function usePreviewView() {
  return useDialogOpen(AlcPicturePreview, {
    fullscreen: !0,
    class: "alc-component-picture-preview",
    appendToBody: !0
  });
}
function useInvoiceApply() {
  return useDialogOpen(AlcInvoiceApply, {
    title: "发票申请",
    widthType: "xs",
    confirmButtonText: "申请"
  });
}
function useInvoiceList() {
  return useDialogOpen(AlcInvoiceList, {
    title: "查看发票",
    showFooter: !1
  });
}
function openAlert(e = "", { title: o = "系统提示", autoClose: n = !0, ...t } = {}, r) {
  let a = 10;
  const l = n ? p(a) : "确定", s = `alert_win_${Date.now()}`, c = `${s}_ok`, d = ElMessageBox.alert(e, o, {
    ...t,
    type: "warning",
    customClass: s,
    confirmButtonClass: c,
    confirmButtonText: l,
    closeOnClickModal: !1,
    closeOnPressEscape: !1,
    showClose: !1,
    ...typeof r == "function" && {
      callback: (g) => {
        g === "confirm" && r();
      }
    }
  });
  function p(g) {
    return `确定 ( ${g} s后关闭)`;
  }
  function f() {
    return new Promise((g) => {
      setTimeout(g, 1e3);
    });
  }
  return n && nextTick(() => {
    const g = document.querySelector(`.${c} span`);
    g instanceof HTMLSpanElement && (async () => {
      for (; a; )
        await f(), g.textContent = p(--a);
      g.click();
    })();
  }), d;
}
function openConfirm(e = "", { title: o = "系统提示", ...n } = {}, t) {
  return ElMessageBox.confirm(e, o, {
    distinguishCancelAndClose: !0,
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    ...n,
    type: "warning",
    showClose: !1,
    closeOnClickModal: !1,
    closeOnPressEscape: !1,
    ...typeof t == "function" && {
      callback: (r) => {
        (r === "confirm" || r === "cancel") && t({
          action: r
        });
      }
    }
  });
}
function openPrompt(e = "", { isValidate: o = !1, title: n = "", ...t } = {}, r) {
  return ElMessageBox.prompt(e, n, {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    distinguishCancelAndClose: !0,
    beforeClose: (a, l, s) => {
      (a === "confirm" || a === "cancel") && r !== void 0 && r({
        action: a,
        inputValue: l.inputValue,
        done: s
      }), a === "confirm" && !o && s(), a !== "confirm" && s();
    },
    ...t,
    showClose: !1,
    closeOnClickModal: !1,
    closeOnPressEscape: !1
  });
}
function warn(e, ...o) {
  return warn$2(`components-pc/${e}`, ...o);
}
function formatDateByType(e, o) {
  if (e)
    switch (o) {
      case "year":
        return formatDate(e, "yyyy");
      case "month":
        return formatDate(e, "yyyy-MM");
      case "date":
        return formatDate(e, "yyyy-MM-dd");
      case "datetime":
        return formatDate(e, "yyyy-MM-dd HH:mm:ss");
      case "time":
        return formatDate(e, "HH:mm:ss");
      default:
        return formatDate(e, "yyyy-MM-dd");
    }
  return "";
}
function toDisplayString(e, o, n, t) {
  var r, a, l;
  switch (e) {
    case "Select":
    case "select":
      return isArray(n) ? ((r = n.find((s) => s.value === String(o))) == null ? void 0 : r.label) || "" : ((l = (a = globalConfig.value.dict[n]) == null ? void 0 : a.find((s) => s.value === String(o))) == null ? void 0 : l.label) || "";
    case "Date":
    case "date":
      return isArray(o) ? `${formatDateByType(
        o[0],
        n
      )} ～ ${formatDateByType(o[1], n)}` : formatDateByType(o, n);
    case "Number":
    case "number":
      return formatNumber(
        o,
        n != null ? +n : -1,
        t
      );
    case "checkbox":
    case "Checkbox":
      return o ? "是" : "否";
    default:
      return o;
  }
}
function getDisplayStringFormatCode(e) {
  switch (e.itemType) {
    case "number":
      return e.code ?? e.precision;
    case "date":
      return e.code || e.type;
    case "select":
      return e.code || e.options;
    case "refer":
      return e.code;
    default:
      return;
  }
}
function authLogin(e) {
  window.open(createAuthLoginUrl(e), "_blank");
}
function createAuthLoginUrl(e) {
  const {
    deployUrl: o,
    state: { token: n }
  } = useProviderConfig().value;
  return `${o}openapi/alc-open-public-opm/oauth/oauthlogin${toQueryParams(
    {
      client_id: e.appId,
      extras_param: JSON.stringify(
        e.extrasParam || {
          menuRoute: e.menuRoute,
          data: e.data
        }
      ),
      device: e.device || 1,
      token: n
    }
  )}`;
}
function visitWorkflowPage(e) {
  apiGetWorkFlowByVoucher({
    cWfToolTypeCode: "albpm",
    displayType: "pc",
    processInstId: e
  }).then((o) => {
    if (o.code === 1 && o.data.openUrlFragment)
      return visitOuterPage(o.data.openUrlFragment);
    operatorErrorTip(o.msg);
  }).catch(() => {
    operatorErrorTip("获取工作流信息");
  });
}
function shouldShowTooltip(e) {
  if (!e.childNodes.length)
    return;
  const o = document.createRange();
  o.setStart(e, 0), o.setEnd(e, e.childNodes.length);
  const { width: n, height: t } = o.getBoundingClientRect(), { width: r, height: a } = e.getBoundingClientRect(), { top: l, left: s, right: c, bottom: d } = getPadding(e), p = s + c, f = l + d;
  return isGreaterThan(n + p, r) || isGreaterThan(t + f, a) || isGreaterThan(e.scrollWidth, r);
}
function isGreaterThan(e, o, n = 0.03) {
  return e - o > n;
}
function getPadding(e) {
  const o = window.getComputedStyle(e, null), n = Number.parseInt(o.paddingLeft, 10) || 0, t = Number.parseInt(o.paddingRight, 10) || 0, r = Number.parseInt(o.paddingTop, 10) || 0, a = Number.parseInt(o.paddingBottom, 10) || 0;
  return {
    left: n,
    right: t,
    top: r,
    bottom: a
  };
}
function attachEvent(e) {
  return e.target || (e.target = document), e.target.addEventListener(
    e.eventName,
    e.callback,
    e.options
  ), () => {
    e.target.removeEventListener(
      e.eventName,
      e.callback,
      e.options
    );
  };
}
const AlcAccessControl = withInstall(AccessControl), _sfc_main$j = /* @__PURE__ */ defineComponent({
  name: "alc-api-request-error",
  __name: "api-request-error",
  props: {
    info: {}
  },
  setup(e, { expose: o }) {
    o();
    const n = {};
    return Object.defineProperty(n, "__isScriptSetup", { enumerable: !1, value: !0 }), n;
  }
}), _hoisted_1$g = { class: "api-request-overrun-warning--container" }, _hoisted_2$e = { class: "api-request-overrun-warning--header" }, _hoisted_3$b = { class: "api-request-overrun-warning--content" }, _hoisted_4$8 = { key: 0 };
function _sfc_render$j(e, o, n, t, r, a) {
  return openBlock(), createElementBlock("div", _hoisted_1$g, [
    createElementVNode("div", _hoisted_2$e, toDisplayString$1(n.info.pageTitle), 1),
    createElementVNode("div", _hoisted_3$b, [
      createElementVNode("p", null, toDisplayString$1(n.info.msgDesc), 1),
      n.info.reason ? (openBlock(), createElementBlock("p", _hoisted_4$8, toDisplayString$1(n.info.reason), 1)) : createCommentVNode("", !0),
      createTextVNode(" 如何解决： "),
      createElementVNode("ul", null, [
        (openBlock(!0), createElementBlock(Fragment, null, renderList(n.info.todo, (l, s) => (openBlock(), createElementBlock("li", { key: s }, toDisplayString$1(l), 1))), 128))
      ]),
      createElementVNode("p", null, [
        createElementVNode("b", null, toDisplayString$1(n.info.ip), 1)
      ])
    ])
  ]);
}
const ApiRequestError = /* @__PURE__ */ _export_sfc(_sfc_main$j, [["render", _sfc_render$j], ["__file", "api-request-error.vue"]]), AlcApiRequestError = withInstall(ApiRequestError);
function getDefaultExportFromCjs(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var barcodes = {}, CODE39$1 = {}, Barcode$2 = {};
Object.defineProperty(Barcode$2, "__esModule", {
  value: !0
});
function _classCallCheck$s(e, o) {
  if (!(e instanceof o))
    throw new TypeError("Cannot call a class as a function");
}
var Barcode$1 = function e(o, n) {
  _classCallCheck$s(this, e), this.data = o, this.text = n.text || o, this.options = n;
};
Barcode$2.default = Barcode$1;
Object.defineProperty(CODE39$1, "__esModule", {
  value: !0
});
CODE39$1.CODE39 = void 0;
var _createClass$l = /* @__PURE__ */ function() {
  function e(o, n) {
    for (var t = 0; t < n.length; t++) {
      var r = n[t];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(o, r.key, r);
    }
  }
  return function(o, n, t) {
    return n && e(o.prototype, n), t && e(o, t), o;
  };
}(), _Barcode2$b = Barcode$2, _Barcode3$b = _interopRequireDefault$x(_Barcode2$b);
function _interopRequireDefault$x(e) {
  return e && e.__esModule ? e : { default: e };
}
function _classCallCheck$r(e, o) {
  if (!(e instanceof o))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$n(e, o) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o && (typeof o == "object" || typeof o == "function") ? o : e;
}
function _inherits$n(e, o) {
  if (typeof o != "function" && o !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof o);
  e.prototype = Object.create(o && o.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), o && (Object.setPrototypeOf ? Object.setPrototypeOf(e, o) : e.__proto__ = o);
}
var CODE39 = function(e) {
  _inherits$n(o, e);
  function o(n, t) {
    return _classCallCheck$r(this, o), n = n.toUpperCase(), t.mod43 && (n += getCharacter(mod43checksum(n))), _possibleConstructorReturn$n(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, n, t));
  }
  return _createClass$l(o, [{
    key: "encode",
    value: function() {
      for (var t = getEncoding("*"), r = 0; r < this.data.length; r++)
        t += getEncoding(this.data[r]) + "0";
      return t += getEncoding("*"), {
        data: t,
        text: this.text
      };
    }
  }, {
    key: "valid",
    value: function() {
      return this.data.search(/^[0-9A-Z\-\.\ \$\/\+\%]+$/) !== -1;
    }
  }]), o;
}(_Barcode3$b.default), characters = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "-", ".", " ", "$", "/", "+", "%", "*"], encodings = [20957, 29783, 23639, 30485, 20951, 29813, 23669, 20855, 29789, 23645, 29975, 23831, 30533, 22295, 30149, 24005, 21623, 29981, 23837, 22301, 30023, 23879, 30545, 22343, 30161, 24017, 21959, 30065, 23921, 22385, 29015, 18263, 29141, 17879, 29045, 18293, 17783, 29021, 18269, 17477, 17489, 17681, 20753, 35770];
function getEncoding(e) {
  return getBinary(characterValue(e));
}
function getBinary(e) {
  return encodings[e].toString(2);
}
function getCharacter(e) {
  return characters[e];
}
function characterValue(e) {
  return characters.indexOf(e);
}
function mod43checksum(e) {
  for (var o = 0, n = 0; n < e.length; n++)
    o += characterValue(e[n]);
  return o = o % 43, o;
}
CODE39$1.CODE39 = CODE39;
var CODE128$2 = {}, CODE128_AUTO = {}, CODE128$1 = {}, constants$2 = {};
Object.defineProperty(constants$2, "__esModule", {
  value: !0
});
var _SET_BY_CODE;
function _defineProperty(e, o, n) {
  return o in e ? Object.defineProperty(e, o, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[o] = n, e;
}
var SET_A = constants$2.SET_A = 0, SET_B = constants$2.SET_B = 1, SET_C = constants$2.SET_C = 2;
constants$2.SHIFT = 98;
var START_A = constants$2.START_A = 103, START_B = constants$2.START_B = 104, START_C = constants$2.START_C = 105;
constants$2.MODULO = 103;
constants$2.STOP = 106;
constants$2.FNC1 = 207;
constants$2.SET_BY_CODE = (_SET_BY_CODE = {}, _defineProperty(_SET_BY_CODE, START_A, SET_A), _defineProperty(_SET_BY_CODE, START_B, SET_B), _defineProperty(_SET_BY_CODE, START_C, SET_C), _SET_BY_CODE);
constants$2.SWAP = {
  101: SET_A,
  100: SET_B,
  99: SET_C
};
constants$2.A_START_CHAR = "Ð";
constants$2.B_START_CHAR = "Ñ";
constants$2.C_START_CHAR = "Ò";
constants$2.A_CHARS = "[\0-_È-Ï]";
constants$2.B_CHARS = "[ -È-Ï]";
constants$2.C_CHARS = "(Ï*[0-9]{2}Ï*)";
constants$2.BARS = [11011001100, 11001101100, 11001100110, 10010011e3, 10010001100, 10001001100, 10011001e3, 10011000100, 10001100100, 11001001e3, 11001000100, 11000100100, 10110011100, 10011011100, 10011001110, 10111001100, 10011101100, 10011100110, 11001110010, 11001011100, 11001001110, 11011100100, 11001110100, 11101101110, 11101001100, 11100101100, 11100100110, 11101100100, 11100110100, 11100110010, 11011011e3, 11011000110, 11000110110, 10100011e3, 10001011e3, 10001000110, 10110001e3, 10001101e3, 10001100010, 11010001e3, 11000101e3, 11000100010, 10110111e3, 10110001110, 10001101110, 10111011e3, 10111000110, 10001110110, 11101110110, 11010001110, 11000101110, 11011101e3, 11011100010, 11011101110, 11101011e3, 11101000110, 11100010110, 11101101e3, 11101100010, 11100011010, 11101111010, 11001000010, 11110001010, 1010011e4, 10100001100, 1001011e4, 10010000110, 10000101100, 10000100110, 1011001e4, 10110000100, 1001101e4, 10011000010, 10000110100, 10000110010, 11000010010, 1100101e4, 11110111010, 11000010100, 10001111010, 10100111100, 10010111100, 10010011110, 10111100100, 10011110100, 10011110010, 11110100100, 11110010100, 11110010010, 11011011110, 11011110110, 11110110110, 10101111e3, 10100011110, 10001011110, 10111101e3, 10111100010, 11110101e3, 11110100010, 10111011110, 10111101110, 11101011110, 11110101110, 11010000100, 1101001e4, 11010011100, 1100011101011];
Object.defineProperty(CODE128$1, "__esModule", {
  value: !0
});
var _createClass$k = /* @__PURE__ */ function() {
  function e(o, n) {
    for (var t = 0; t < n.length; t++) {
      var r = n[t];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(o, r.key, r);
    }
  }
  return function(o, n, t) {
    return n && e(o.prototype, n), t && e(o, t), o;
  };
}(), _Barcode2$a = Barcode$2, _Barcode3$a = _interopRequireDefault$w(_Barcode2$a), _constants$a = constants$2;
function _interopRequireDefault$w(e) {
  return e && e.__esModule ? e : { default: e };
}
function _classCallCheck$q(e, o) {
  if (!(e instanceof o))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$m(e, o) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o && (typeof o == "object" || typeof o == "function") ? o : e;
}
function _inherits$m(e, o) {
  if (typeof o != "function" && o !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof o);
  e.prototype = Object.create(o && o.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), o && (Object.setPrototypeOf ? Object.setPrototypeOf(e, o) : e.__proto__ = o);
}
var CODE128 = function(e) {
  _inherits$m(o, e);
  function o(n, t) {
    _classCallCheck$q(this, o);
    var r = _possibleConstructorReturn$m(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, n.substring(1), t));
    return r.bytes = n.split("").map(function(a) {
      return a.charCodeAt(0);
    }), r;
  }
  return _createClass$k(o, [{
    key: "valid",
    value: function() {
      return /^[\x00-\x7F\xC8-\xD3]+$/.test(this.data);
    }
    // The public encoding function
  }, {
    key: "encode",
    value: function() {
      var t = this.bytes, r = t.shift() - 105, a = _constants$a.SET_BY_CODE[r];
      if (a === void 0)
        throw new RangeError("The encoding does not start with a start character.");
      this.shouldEncodeAsEan128() === !0 && t.unshift(_constants$a.FNC1);
      var l = o.next(t, 1, a);
      return {
        text: this.text === this.data ? this.text.replace(/[^\x20-\x7E]/g, "") : this.text,
        data: (
          // Add the start bits
          o.getBar(r) + // Add the encoded bits
          l.result + // Add the checksum
          o.getBar((l.checksum + r) % _constants$a.MODULO) + // Add the end bits
          o.getBar(_constants$a.STOP)
        )
      };
    }
    // GS1-128/EAN-128
  }, {
    key: "shouldEncodeAsEan128",
    value: function() {
      var t = this.options.ean128 || !1;
      return typeof t == "string" && (t = t.toLowerCase() === "true"), t;
    }
    // Get a bar symbol by index
  }], [{
    key: "getBar",
    value: function(t) {
      return _constants$a.BARS[t] ? _constants$a.BARS[t].toString() : "";
    }
    // Correct an index by a set and shift it from the bytes array
  }, {
    key: "correctIndex",
    value: function(t, r) {
      if (r === _constants$a.SET_A) {
        var a = t.shift();
        return a < 32 ? a + 64 : a - 32;
      } else return r === _constants$a.SET_B ? t.shift() - 32 : (t.shift() - 48) * 10 + t.shift() - 48;
    }
  }, {
    key: "next",
    value: function(t, r, a) {
      if (!t.length)
        return { result: "", checksum: 0 };
      var l = void 0, s = void 0;
      if (t[0] >= 200) {
        s = t.shift() - 105;
        var c = _constants$a.SWAP[s];
        c !== void 0 ? l = o.next(t, r + 1, c) : ((a === _constants$a.SET_A || a === _constants$a.SET_B) && s === _constants$a.SHIFT && (t[0] = a === _constants$a.SET_A ? t[0] > 95 ? t[0] - 96 : t[0] : t[0] < 32 ? t[0] + 96 : t[0]), l = o.next(t, r + 1, a));
      } else
        s = o.correctIndex(t, a), l = o.next(t, r + 1, a);
      var d = o.getBar(s), p = s * r;
      return {
        result: d + l.result,
        checksum: p + l.checksum
      };
    }
  }]), o;
}(_Barcode3$a.default);
CODE128$1.default = CODE128;
var auto = {};
Object.defineProperty(auto, "__esModule", {
  value: !0
});
var _constants$9 = constants$2, matchSetALength = function(o) {
  return o.match(new RegExp("^" + _constants$9.A_CHARS + "*"))[0].length;
}, matchSetBLength = function(o) {
  return o.match(new RegExp("^" + _constants$9.B_CHARS + "*"))[0].length;
}, matchSetC = function(o) {
  return o.match(new RegExp("^" + _constants$9.C_CHARS + "*"))[0];
};
function autoSelectFromAB(e, o) {
  var n = o ? _constants$9.A_CHARS : _constants$9.B_CHARS, t = e.match(new RegExp("^(" + n + "+?)(([0-9]{2}){2,})([^0-9]|$)"));
  if (t)
    return t[1] + "Ì" + autoSelectFromC(e.substring(t[1].length));
  var r = e.match(new RegExp("^" + n + "+"))[0];
  return r.length === e.length ? e : r + String.fromCharCode(o ? 205 : 206) + autoSelectFromAB(e.substring(r.length), !o);
}
function autoSelectFromC(e) {
  var o = matchSetC(e), n = o.length;
  if (n === e.length)
    return e;
  e = e.substring(n);
  var t = matchSetALength(e) >= matchSetBLength(e);
  return o + String.fromCharCode(t ? 206 : 205) + autoSelectFromAB(e, t);
}
auto.default = function(e) {
  var o = void 0, n = matchSetC(e).length;
  if (n >= 2)
    o = _constants$9.C_START_CHAR + autoSelectFromC(e);
  else {
    var t = matchSetALength(e) > matchSetBLength(e);
    o = (t ? _constants$9.A_START_CHAR : _constants$9.B_START_CHAR) + autoSelectFromAB(e, t);
  }
  return o.replace(
    /[\xCD\xCE]([^])[\xCD\xCE]/,
    // Any sequence between 205 and 206 characters
    function(r, a) {
      return "Ë" + a;
    }
  );
};
Object.defineProperty(CODE128_AUTO, "__esModule", {
  value: !0
});
var _CODE2$4 = CODE128$1, _CODE3$3 = _interopRequireDefault$v(_CODE2$4), _auto = auto, _auto2 = _interopRequireDefault$v(_auto);
function _interopRequireDefault$v(e) {
  return e && e.__esModule ? e : { default: e };
}
function _classCallCheck$p(e, o) {
  if (!(e instanceof o))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$l(e, o) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o && (typeof o == "object" || typeof o == "function") ? o : e;
}
function _inherits$l(e, o) {
  if (typeof o != "function" && o !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof o);
  e.prototype = Object.create(o && o.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), o && (Object.setPrototypeOf ? Object.setPrototypeOf(e, o) : e.__proto__ = o);
}
var CODE128AUTO = function(e) {
  _inherits$l(o, e);
  function o(n, t) {
    if (_classCallCheck$p(this, o), /^[\x00-\x7F\xC8-\xD3]+$/.test(n))
      var r = _possibleConstructorReturn$l(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, (0, _auto2.default)(n), t));
    else
      var r = _possibleConstructorReturn$l(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, n, t));
    return _possibleConstructorReturn$l(r);
  }
  return o;
}(_CODE3$3.default);
CODE128_AUTO.default = CODE128AUTO;
var CODE128A$1 = {};
Object.defineProperty(CODE128A$1, "__esModule", {
  value: !0
});
var _createClass$j = /* @__PURE__ */ function() {
  function e(o, n) {
    for (var t = 0; t < n.length; t++) {
      var r = n[t];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(o, r.key, r);
    }
  }
  return function(o, n, t) {
    return n && e(o.prototype, n), t && e(o, t), o;
  };
}(), _CODE2$3 = CODE128$1, _CODE3$2 = _interopRequireDefault$u(_CODE2$3), _constants$8 = constants$2;
function _interopRequireDefault$u(e) {
  return e && e.__esModule ? e : { default: e };
}
function _classCallCheck$o(e, o) {
  if (!(e instanceof o))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$k(e, o) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o && (typeof o == "object" || typeof o == "function") ? o : e;
}
function _inherits$k(e, o) {
  if (typeof o != "function" && o !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof o);
  e.prototype = Object.create(o && o.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), o && (Object.setPrototypeOf ? Object.setPrototypeOf(e, o) : e.__proto__ = o);
}
var CODE128A = function(e) {
  _inherits$k(o, e);
  function o(n, t) {
    return _classCallCheck$o(this, o), _possibleConstructorReturn$k(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, _constants$8.A_START_CHAR + n, t));
  }
  return _createClass$j(o, [{
    key: "valid",
    value: function() {
      return new RegExp("^" + _constants$8.A_CHARS + "+$").test(this.data);
    }
  }]), o;
}(_CODE3$2.default);
CODE128A$1.default = CODE128A;
var CODE128B$1 = {};
Object.defineProperty(CODE128B$1, "__esModule", {
  value: !0
});
var _createClass$i = /* @__PURE__ */ function() {
  function e(o, n) {
    for (var t = 0; t < n.length; t++) {
      var r = n[t];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(o, r.key, r);
    }
  }
  return function(o, n, t) {
    return n && e(o.prototype, n), t && e(o, t), o;
  };
}(), _CODE2$2 = CODE128$1, _CODE3$1 = _interopRequireDefault$t(_CODE2$2), _constants$7 = constants$2;
function _interopRequireDefault$t(e) {
  return e && e.__esModule ? e : { default: e };
}
function _classCallCheck$n(e, o) {
  if (!(e instanceof o))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$j(e, o) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o && (typeof o == "object" || typeof o == "function") ? o : e;
}
function _inherits$j(e, o) {
  if (typeof o != "function" && o !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof o);
  e.prototype = Object.create(o && o.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), o && (Object.setPrototypeOf ? Object.setPrototypeOf(e, o) : e.__proto__ = o);
}
var CODE128B = function(e) {
  _inherits$j(o, e);
  function o(n, t) {
    return _classCallCheck$n(this, o), _possibleConstructorReturn$j(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, _constants$7.B_START_CHAR + n, t));
  }
  return _createClass$i(o, [{
    key: "valid",
    value: function() {
      return new RegExp("^" + _constants$7.B_CHARS + "+$").test(this.data);
    }
  }]), o;
}(_CODE3$1.default);
CODE128B$1.default = CODE128B;
var CODE128C$1 = {};
Object.defineProperty(CODE128C$1, "__esModule", {
  value: !0
});
var _createClass$h = /* @__PURE__ */ function() {
  function e(o, n) {
    for (var t = 0; t < n.length; t++) {
      var r = n[t];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(o, r.key, r);
    }
  }
  return function(o, n, t) {
    return n && e(o.prototype, n), t && e(o, t), o;
  };
}(), _CODE2$1 = CODE128$1, _CODE3 = _interopRequireDefault$s(_CODE2$1), _constants$6 = constants$2;
function _interopRequireDefault$s(e) {
  return e && e.__esModule ? e : { default: e };
}
function _classCallCheck$m(e, o) {
  if (!(e instanceof o))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$i(e, o) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o && (typeof o == "object" || typeof o == "function") ? o : e;
}
function _inherits$i(e, o) {
  if (typeof o != "function" && o !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof o);
  e.prototype = Object.create(o && o.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), o && (Object.setPrototypeOf ? Object.setPrototypeOf(e, o) : e.__proto__ = o);
}
var CODE128C = function(e) {
  _inherits$i(o, e);
  function o(n, t) {
    return _classCallCheck$m(this, o), _possibleConstructorReturn$i(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, _constants$6.C_START_CHAR + n, t));
  }
  return _createClass$h(o, [{
    key: "valid",
    value: function() {
      return new RegExp("^" + _constants$6.C_CHARS + "+$").test(this.data);
    }
  }]), o;
}(_CODE3.default);
CODE128C$1.default = CODE128C;
Object.defineProperty(CODE128$2, "__esModule", {
  value: !0
});
CODE128$2.CODE128C = CODE128$2.CODE128B = CODE128$2.CODE128A = CODE128$2.CODE128 = void 0;
var _CODE128_AUTO = CODE128_AUTO, _CODE128_AUTO2 = _interopRequireDefault$r(_CODE128_AUTO), _CODE128A = CODE128A$1, _CODE128A2 = _interopRequireDefault$r(_CODE128A), _CODE128B = CODE128B$1, _CODE128B2 = _interopRequireDefault$r(_CODE128B), _CODE128C = CODE128C$1, _CODE128C2 = _interopRequireDefault$r(_CODE128C);
function _interopRequireDefault$r(e) {
  return e && e.__esModule ? e : { default: e };
}
CODE128$2.CODE128 = _CODE128_AUTO2.default;
CODE128$2.CODE128A = _CODE128A2.default;
CODE128$2.CODE128B = _CODE128B2.default;
CODE128$2.CODE128C = _CODE128C2.default;
var EAN_UPC = {}, EAN13$1 = {}, constants$1 = {};
Object.defineProperty(constants$1, "__esModule", {
  value: !0
});
constants$1.SIDE_BIN = "101";
constants$1.MIDDLE_BIN = "01010";
constants$1.BINARIES = {
  L: [
    // The L (left) type of encoding
    "0001101",
    "0011001",
    "0010011",
    "0111101",
    "0100011",
    "0110001",
    "0101111",
    "0111011",
    "0110111",
    "0001011"
  ],
  G: [
    // The G type of encoding
    "0100111",
    "0110011",
    "0011011",
    "0100001",
    "0011101",
    "0111001",
    "0000101",
    "0010001",
    "0001001",
    "0010111"
  ],
  R: [
    // The R (right) type of encoding
    "1110010",
    "1100110",
    "1101100",
    "1000010",
    "1011100",
    "1001110",
    "1010000",
    "1000100",
    "1001000",
    "1110100"
  ],
  O: [
    // The O (odd) encoding for UPC-E
    "0001101",
    "0011001",
    "0010011",
    "0111101",
    "0100011",
    "0110001",
    "0101111",
    "0111011",
    "0110111",
    "0001011"
  ],
  E: [
    // The E (even) encoding for UPC-E
    "0100111",
    "0110011",
    "0011011",
    "0100001",
    "0011101",
    "0111001",
    "0000101",
    "0010001",
    "0001001",
    "0010111"
  ]
};
constants$1.EAN2_STRUCTURE = ["LL", "LG", "GL", "GG"];
constants$1.EAN5_STRUCTURE = ["GGLLL", "GLGLL", "GLLGL", "GLLLG", "LGGLL", "LLGGL", "LLLGG", "LGLGL", "LGLLG", "LLGLG"];
constants$1.EAN13_STRUCTURE = ["LLLLLL", "LLGLGG", "LLGGLG", "LLGGGL", "LGLLGG", "LGGLLG", "LGGGLL", "LGLGLG", "LGLGGL", "LGGLGL"];
var EAN$1 = {}, encoder = {};
Object.defineProperty(encoder, "__esModule", {
  value: !0
});
var _constants$5 = constants$1, encode$1 = function(o, n, t) {
  var r = o.split("").map(function(l, s) {
    return _constants$5.BINARIES[n[s]];
  }).map(function(l, s) {
    return l ? l[o[s]] : "";
  });
  if (t) {
    var a = o.length - 1;
    r = r.map(function(l, s) {
      return s < a ? l + t : l;
    });
  }
  return r.join("");
};
encoder.default = encode$1;
Object.defineProperty(EAN$1, "__esModule", {
  value: !0
});
var _createClass$g = /* @__PURE__ */ function() {
  function e(o, n) {
    for (var t = 0; t < n.length; t++) {
      var r = n[t];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(o, r.key, r);
    }
  }
  return function(o, n, t) {
    return n && e(o.prototype, n), t && e(o, t), o;
  };
}(), _constants$4 = constants$1, _encoder$4 = encoder, _encoder2$4 = _interopRequireDefault$q(_encoder$4), _Barcode2$9 = Barcode$2, _Barcode3$9 = _interopRequireDefault$q(_Barcode2$9);
function _interopRequireDefault$q(e) {
  return e && e.__esModule ? e : { default: e };
}
function _classCallCheck$l(e, o) {
  if (!(e instanceof o))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$h(e, o) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o && (typeof o == "object" || typeof o == "function") ? o : e;
}
function _inherits$h(e, o) {
  if (typeof o != "function" && o !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof o);
  e.prototype = Object.create(o && o.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), o && (Object.setPrototypeOf ? Object.setPrototypeOf(e, o) : e.__proto__ = o);
}
var EAN = function(e) {
  _inherits$h(o, e);
  function o(n, t) {
    _classCallCheck$l(this, o);
    var r = _possibleConstructorReturn$h(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, n, t));
    return r.fontSize = !t.flat && t.fontSize > t.width * 10 ? t.width * 10 : t.fontSize, r.guardHeight = t.height + r.fontSize / 2 + t.textMargin, r;
  }
  return _createClass$g(o, [{
    key: "encode",
    value: function() {
      return this.options.flat ? this.encodeFlat() : this.encodeGuarded();
    }
  }, {
    key: "leftText",
    value: function(t, r) {
      return this.text.substr(t, r);
    }
  }, {
    key: "leftEncode",
    value: function(t, r) {
      return (0, _encoder2$4.default)(t, r);
    }
  }, {
    key: "rightText",
    value: function(t, r) {
      return this.text.substr(t, r);
    }
  }, {
    key: "rightEncode",
    value: function(t, r) {
      return (0, _encoder2$4.default)(t, r);
    }
  }, {
    key: "encodeGuarded",
    value: function() {
      var t = { fontSize: this.fontSize }, r = { height: this.guardHeight };
      return [{ data: _constants$4.SIDE_BIN, options: r }, { data: this.leftEncode(), text: this.leftText(), options: t }, { data: _constants$4.MIDDLE_BIN, options: r }, { data: this.rightEncode(), text: this.rightText(), options: t }, { data: _constants$4.SIDE_BIN, options: r }];
    }
  }, {
    key: "encodeFlat",
    value: function() {
      var t = [_constants$4.SIDE_BIN, this.leftEncode(), _constants$4.MIDDLE_BIN, this.rightEncode(), _constants$4.SIDE_BIN];
      return {
        data: t.join(""),
        text: this.text
      };
    }
  }]), o;
}(_Barcode3$9.default);
EAN$1.default = EAN;
Object.defineProperty(EAN13$1, "__esModule", {
  value: !0
});
var _createClass$f = /* @__PURE__ */ function() {
  function e(o, n) {
    for (var t = 0; t < n.length; t++) {
      var r = n[t];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(o, r.key, r);
    }
  }
  return function(o, n, t) {
    return n && e(o.prototype, n), t && e(o, t), o;
  };
}(), _get$1 = function e(o, n, t) {
  o === null && (o = Function.prototype);
  var r = Object.getOwnPropertyDescriptor(o, n);
  if (r === void 0) {
    var a = Object.getPrototypeOf(o);
    return a === null ? void 0 : e(a, n, t);
  } else {
    if ("value" in r)
      return r.value;
    var l = r.get;
    return l === void 0 ? void 0 : l.call(t);
  }
}, _constants$3 = constants$1, _EAN2$2 = EAN$1, _EAN3$2 = _interopRequireDefault$p(_EAN2$2);
function _interopRequireDefault$p(e) {
  return e && e.__esModule ? e : { default: e };
}
function _classCallCheck$k(e, o) {
  if (!(e instanceof o))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$g(e, o) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o && (typeof o == "object" || typeof o == "function") ? o : e;
}
function _inherits$g(e, o) {
  if (typeof o != "function" && o !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof o);
  e.prototype = Object.create(o && o.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), o && (Object.setPrototypeOf ? Object.setPrototypeOf(e, o) : e.__proto__ = o);
}
var checksum$4 = function(o) {
  var n = o.substr(0, 12).split("").map(function(t) {
    return +t;
  }).reduce(function(t, r, a) {
    return a % 2 ? t + r * 3 : t + r;
  }, 0);
  return (10 - n % 10) % 10;
}, EAN13 = function(e) {
  _inherits$g(o, e);
  function o(n, t) {
    _classCallCheck$k(this, o), n.search(/^[0-9]{12}$/) !== -1 && (n += checksum$4(n));
    var r = _possibleConstructorReturn$g(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, n, t));
    return r.lastChar = t.lastChar, r;
  }
  return _createClass$f(o, [{
    key: "valid",
    value: function() {
      return this.data.search(/^[0-9]{13}$/) !== -1 && +this.data[12] === checksum$4(this.data);
    }
  }, {
    key: "leftText",
    value: function() {
      return _get$1(o.prototype.__proto__ || Object.getPrototypeOf(o.prototype), "leftText", this).call(this, 1, 6);
    }
  }, {
    key: "leftEncode",
    value: function() {
      var t = this.data.substr(1, 6), r = _constants$3.EAN13_STRUCTURE[this.data[0]];
      return _get$1(o.prototype.__proto__ || Object.getPrototypeOf(o.prototype), "leftEncode", this).call(this, t, r);
    }
  }, {
    key: "rightText",
    value: function() {
      return _get$1(o.prototype.__proto__ || Object.getPrototypeOf(o.prototype), "rightText", this).call(this, 7, 6);
    }
  }, {
    key: "rightEncode",
    value: function() {
      var t = this.data.substr(7, 6);
      return _get$1(o.prototype.__proto__ || Object.getPrototypeOf(o.prototype), "rightEncode", this).call(this, t, "RRRRRR");
    }
    // The "standard" way of printing EAN13 barcodes with guard bars
  }, {
    key: "encodeGuarded",
    value: function() {
      var t = _get$1(o.prototype.__proto__ || Object.getPrototypeOf(o.prototype), "encodeGuarded", this).call(this);
      return this.options.displayValue && (t.unshift({
        data: "000000000000",
        text: this.text.substr(0, 1),
        options: { textAlign: "left", fontSize: this.fontSize }
      }), this.options.lastChar && (t.push({
        data: "00"
      }), t.push({
        data: "00000",
        text: this.options.lastChar,
        options: { fontSize: this.fontSize }
      }))), t;
    }
  }]), o;
}(_EAN3$2.default);
EAN13$1.default = EAN13;
var EAN8$1 = {};
Object.defineProperty(EAN8$1, "__esModule", {
  value: !0
});
var _createClass$e = /* @__PURE__ */ function() {
  function e(o, n) {
    for (var t = 0; t < n.length; t++) {
      var r = n[t];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(o, r.key, r);
    }
  }
  return function(o, n, t) {
    return n && e(o.prototype, n), t && e(o, t), o;
  };
}(), _get = function e(o, n, t) {
  o === null && (o = Function.prototype);
  var r = Object.getOwnPropertyDescriptor(o, n);
  if (r === void 0) {
    var a = Object.getPrototypeOf(o);
    return a === null ? void 0 : e(a, n, t);
  } else {
    if ("value" in r)
      return r.value;
    var l = r.get;
    return l === void 0 ? void 0 : l.call(t);
  }
}, _EAN2$1 = EAN$1, _EAN3$1 = _interopRequireDefault$o(_EAN2$1);
function _interopRequireDefault$o(e) {
  return e && e.__esModule ? e : { default: e };
}
function _classCallCheck$j(e, o) {
  if (!(e instanceof o))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$f(e, o) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o && (typeof o == "object" || typeof o == "function") ? o : e;
}
function _inherits$f(e, o) {
  if (typeof o != "function" && o !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof o);
  e.prototype = Object.create(o && o.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), o && (Object.setPrototypeOf ? Object.setPrototypeOf(e, o) : e.__proto__ = o);
}
var checksum$3 = function(o) {
  var n = o.substr(0, 7).split("").map(function(t) {
    return +t;
  }).reduce(function(t, r, a) {
    return a % 2 ? t + r : t + r * 3;
  }, 0);
  return (10 - n % 10) % 10;
}, EAN8 = function(e) {
  _inherits$f(o, e);
  function o(n, t) {
    return _classCallCheck$j(this, o), n.search(/^[0-9]{7}$/) !== -1 && (n += checksum$3(n)), _possibleConstructorReturn$f(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, n, t));
  }
  return _createClass$e(o, [{
    key: "valid",
    value: function() {
      return this.data.search(/^[0-9]{8}$/) !== -1 && +this.data[7] === checksum$3(this.data);
    }
  }, {
    key: "leftText",
    value: function() {
      return _get(o.prototype.__proto__ || Object.getPrototypeOf(o.prototype), "leftText", this).call(this, 0, 4);
    }
  }, {
    key: "leftEncode",
    value: function() {
      var t = this.data.substr(0, 4);
      return _get(o.prototype.__proto__ || Object.getPrototypeOf(o.prototype), "leftEncode", this).call(this, t, "LLLL");
    }
  }, {
    key: "rightText",
    value: function() {
      return _get(o.prototype.__proto__ || Object.getPrototypeOf(o.prototype), "rightText", this).call(this, 4, 4);
    }
  }, {
    key: "rightEncode",
    value: function() {
      var t = this.data.substr(4, 4);
      return _get(o.prototype.__proto__ || Object.getPrototypeOf(o.prototype), "rightEncode", this).call(this, t, "RRRR");
    }
  }]), o;
}(_EAN3$1.default);
EAN8$1.default = EAN8;
var EAN5$1 = {};
Object.defineProperty(EAN5$1, "__esModule", {
  value: !0
});
var _createClass$d = /* @__PURE__ */ function() {
  function e(o, n) {
    for (var t = 0; t < n.length; t++) {
      var r = n[t];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(o, r.key, r);
    }
  }
  return function(o, n, t) {
    return n && e(o.prototype, n), t && e(o, t), o;
  };
}(), _constants$2 = constants$1, _encoder$3 = encoder, _encoder2$3 = _interopRequireDefault$n(_encoder$3), _Barcode2$8 = Barcode$2, _Barcode3$8 = _interopRequireDefault$n(_Barcode2$8);
function _interopRequireDefault$n(e) {
  return e && e.__esModule ? e : { default: e };
}
function _classCallCheck$i(e, o) {
  if (!(e instanceof o))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$e(e, o) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o && (typeof o == "object" || typeof o == "function") ? o : e;
}
function _inherits$e(e, o) {
  if (typeof o != "function" && o !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof o);
  e.prototype = Object.create(o && o.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), o && (Object.setPrototypeOf ? Object.setPrototypeOf(e, o) : e.__proto__ = o);
}
var checksum$2 = function(o) {
  var n = o.split("").map(function(t) {
    return +t;
  }).reduce(function(t, r, a) {
    return a % 2 ? t + r * 9 : t + r * 3;
  }, 0);
  return n % 10;
}, EAN5 = function(e) {
  _inherits$e(o, e);
  function o(n, t) {
    return _classCallCheck$i(this, o), _possibleConstructorReturn$e(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, n, t));
  }
  return _createClass$d(o, [{
    key: "valid",
    value: function() {
      return this.data.search(/^[0-9]{5}$/) !== -1;
    }
  }, {
    key: "encode",
    value: function() {
      var t = _constants$2.EAN5_STRUCTURE[checksum$2(this.data)];
      return {
        data: "1011" + (0, _encoder2$3.default)(this.data, t, "01"),
        text: this.text
      };
    }
  }]), o;
}(_Barcode3$8.default);
EAN5$1.default = EAN5;
var EAN2$1 = {};
Object.defineProperty(EAN2$1, "__esModule", {
  value: !0
});
var _createClass$c = /* @__PURE__ */ function() {
  function e(o, n) {
    for (var t = 0; t < n.length; t++) {
      var r = n[t];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(o, r.key, r);
    }
  }
  return function(o, n, t) {
    return n && e(o.prototype, n), t && e(o, t), o;
  };
}(), _constants$1 = constants$1, _encoder$2 = encoder, _encoder2$2 = _interopRequireDefault$m(_encoder$2), _Barcode2$7 = Barcode$2, _Barcode3$7 = _interopRequireDefault$m(_Barcode2$7);
function _interopRequireDefault$m(e) {
  return e && e.__esModule ? e : { default: e };
}
function _classCallCheck$h(e, o) {
  if (!(e instanceof o))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$d(e, o) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o && (typeof o == "object" || typeof o == "function") ? o : e;
}
function _inherits$d(e, o) {
  if (typeof o != "function" && o !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof o);
  e.prototype = Object.create(o && o.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), o && (Object.setPrototypeOf ? Object.setPrototypeOf(e, o) : e.__proto__ = o);
}
var EAN2 = function(e) {
  _inherits$d(o, e);
  function o(n, t) {
    return _classCallCheck$h(this, o), _possibleConstructorReturn$d(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, n, t));
  }
  return _createClass$c(o, [{
    key: "valid",
    value: function() {
      return this.data.search(/^[0-9]{2}$/) !== -1;
    }
  }, {
    key: "encode",
    value: function() {
      var t = _constants$1.EAN2_STRUCTURE[parseInt(this.data) % 4];
      return {
        // Start bits + Encode the two digits with 01 in between
        data: "1011" + (0, _encoder2$2.default)(this.data, t, "01"),
        text: this.text
      };
    }
  }]), o;
}(_Barcode3$7.default);
EAN2$1.default = EAN2;
var UPC$1 = {};
Object.defineProperty(UPC$1, "__esModule", {
  value: !0
});
var _createClass$b = /* @__PURE__ */ function() {
  function e(o, n) {
    for (var t = 0; t < n.length; t++) {
      var r = n[t];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(o, r.key, r);
    }
  }
  return function(o, n, t) {
    return n && e(o.prototype, n), t && e(o, t), o;
  };
}();
UPC$1.checksum = checksum$1;
var _encoder$1 = encoder, _encoder2$1 = _interopRequireDefault$l(_encoder$1), _Barcode2$6 = Barcode$2, _Barcode3$6 = _interopRequireDefault$l(_Barcode2$6);
function _interopRequireDefault$l(e) {
  return e && e.__esModule ? e : { default: e };
}
function _classCallCheck$g(e, o) {
  if (!(e instanceof o))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$c(e, o) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o && (typeof o == "object" || typeof o == "function") ? o : e;
}
function _inherits$c(e, o) {
  if (typeof o != "function" && o !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof o);
  e.prototype = Object.create(o && o.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), o && (Object.setPrototypeOf ? Object.setPrototypeOf(e, o) : e.__proto__ = o);
}
var UPC = function(e) {
  _inherits$c(o, e);
  function o(n, t) {
    _classCallCheck$g(this, o), n.search(/^[0-9]{11}$/) !== -1 && (n += checksum$1(n));
    var r = _possibleConstructorReturn$c(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, n, t));
    return r.displayValue = t.displayValue, t.fontSize > t.width * 10 ? r.fontSize = t.width * 10 : r.fontSize = t.fontSize, r.guardHeight = t.height + r.fontSize / 2 + t.textMargin, r;
  }
  return _createClass$b(o, [{
    key: "valid",
    value: function() {
      return this.data.search(/^[0-9]{12}$/) !== -1 && this.data[11] == checksum$1(this.data);
    }
  }, {
    key: "encode",
    value: function() {
      return this.options.flat ? this.flatEncoding() : this.guardedEncoding();
    }
  }, {
    key: "flatEncoding",
    value: function() {
      var t = "";
      return t += "101", t += (0, _encoder2$1.default)(this.data.substr(0, 6), "LLLLLL"), t += "01010", t += (0, _encoder2$1.default)(this.data.substr(6, 6), "RRRRRR"), t += "101", {
        data: t,
        text: this.text
      };
    }
  }, {
    key: "guardedEncoding",
    value: function() {
      var t = [];
      return this.displayValue && t.push({
        data: "00000000",
        text: this.text.substr(0, 1),
        options: { textAlign: "left", fontSize: this.fontSize }
      }), t.push({
        data: "101" + (0, _encoder2$1.default)(this.data[0], "L"),
        options: { height: this.guardHeight }
      }), t.push({
        data: (0, _encoder2$1.default)(this.data.substr(1, 5), "LLLLL"),
        text: this.text.substr(1, 5),
        options: { fontSize: this.fontSize }
      }), t.push({
        data: "01010",
        options: { height: this.guardHeight }
      }), t.push({
        data: (0, _encoder2$1.default)(this.data.substr(6, 5), "RRRRR"),
        text: this.text.substr(6, 5),
        options: { fontSize: this.fontSize }
      }), t.push({
        data: (0, _encoder2$1.default)(this.data[11], "R") + "101",
        options: { height: this.guardHeight }
      }), this.displayValue && t.push({
        data: "00000000",
        text: this.text.substr(11, 1),
        options: { textAlign: "right", fontSize: this.fontSize }
      }), t;
    }
  }]), o;
}(_Barcode3$6.default);
function checksum$1(e) {
  var o = 0, n;
  for (n = 1; n < 11; n += 2)
    o += parseInt(e[n]);
  for (n = 0; n < 11; n += 2)
    o += parseInt(e[n]) * 3;
  return (10 - o % 10) % 10;
}
UPC$1.default = UPC;
var UPCE$1 = {};
Object.defineProperty(UPCE$1, "__esModule", {
  value: !0
});
var _createClass$a = /* @__PURE__ */ function() {
  function e(o, n) {
    for (var t = 0; t < n.length; t++) {
      var r = n[t];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(o, r.key, r);
    }
  }
  return function(o, n, t) {
    return n && e(o.prototype, n), t && e(o, t), o;
  };
}(), _encoder = encoder, _encoder2 = _interopRequireDefault$k(_encoder), _Barcode2$5 = Barcode$2, _Barcode3$5 = _interopRequireDefault$k(_Barcode2$5), _UPC$1 = UPC$1;
function _interopRequireDefault$k(e) {
  return e && e.__esModule ? e : { default: e };
}
function _classCallCheck$f(e, o) {
  if (!(e instanceof o))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$b(e, o) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o && (typeof o == "object" || typeof o == "function") ? o : e;
}
function _inherits$b(e, o) {
  if (typeof o != "function" && o !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof o);
  e.prototype = Object.create(o && o.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), o && (Object.setPrototypeOf ? Object.setPrototypeOf(e, o) : e.__proto__ = o);
}
var EXPANSIONS = ["XX00000XXX", "XX10000XXX", "XX20000XXX", "XXX00000XX", "XXXX00000X", "XXXXX00005", "XXXXX00006", "XXXXX00007", "XXXXX00008", "XXXXX00009"], PARITIES = [["EEEOOO", "OOOEEE"], ["EEOEOO", "OOEOEE"], ["EEOOEO", "OOEEOE"], ["EEOOOE", "OOEEEO"], ["EOEEOO", "OEOOEE"], ["EOOEEO", "OEEOOE"], ["EOOOEE", "OEEEOO"], ["EOEOEO", "OEOEOE"], ["EOEOOE", "OEOEEO"], ["EOOEOE", "OEEOEO"]], UPCE = function(e) {
  _inherits$b(o, e);
  function o(n, t) {
    _classCallCheck$f(this, o);
    var r = _possibleConstructorReturn$b(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, n, t));
    if (r.isValid = !1, n.search(/^[0-9]{6}$/) !== -1)
      r.middleDigits = n, r.upcA = expandToUPCA(n, "0"), r.text = t.text || "" + r.upcA[0] + n + r.upcA[r.upcA.length - 1], r.isValid = !0;
    else if (n.search(/^[01][0-9]{7}$/) !== -1)
      if (r.middleDigits = n.substring(1, n.length - 1), r.upcA = expandToUPCA(r.middleDigits, n[0]), r.upcA[r.upcA.length - 1] === n[n.length - 1])
        r.isValid = !0;
      else
        return _possibleConstructorReturn$b(r);
    else
      return _possibleConstructorReturn$b(r);
    return r.displayValue = t.displayValue, t.fontSize > t.width * 10 ? r.fontSize = t.width * 10 : r.fontSize = t.fontSize, r.guardHeight = t.height + r.fontSize / 2 + t.textMargin, r;
  }
  return _createClass$a(o, [{
    key: "valid",
    value: function() {
      return this.isValid;
    }
  }, {
    key: "encode",
    value: function() {
      return this.options.flat ? this.flatEncoding() : this.guardedEncoding();
    }
  }, {
    key: "flatEncoding",
    value: function() {
      var t = "";
      return t += "101", t += this.encodeMiddleDigits(), t += "010101", {
        data: t,
        text: this.text
      };
    }
  }, {
    key: "guardedEncoding",
    value: function() {
      var t = [];
      return this.displayValue && t.push({
        data: "00000000",
        text: this.text[0],
        options: { textAlign: "left", fontSize: this.fontSize }
      }), t.push({
        data: "101",
        options: { height: this.guardHeight }
      }), t.push({
        data: this.encodeMiddleDigits(),
        text: this.text.substring(1, 7),
        options: { fontSize: this.fontSize }
      }), t.push({
        data: "010101",
        options: { height: this.guardHeight }
      }), this.displayValue && t.push({
        data: "00000000",
        text: this.text[7],
        options: { textAlign: "right", fontSize: this.fontSize }
      }), t;
    }
  }, {
    key: "encodeMiddleDigits",
    value: function() {
      var t = this.upcA[0], r = this.upcA[this.upcA.length - 1], a = PARITIES[parseInt(r)][parseInt(t)];
      return (0, _encoder2.default)(this.middleDigits, a);
    }
  }]), o;
}(_Barcode3$5.default);
function expandToUPCA(e, o) {
  for (var n = parseInt(e[e.length - 1]), t = EXPANSIONS[n], r = "", a = 0, l = 0; l < t.length; l++) {
    var s = t[l];
    s === "X" ? r += e[a++] : r += s;
  }
  return r = "" + o + r, "" + r + (0, _UPC$1.checksum)(r);
}
UPCE$1.default = UPCE;
Object.defineProperty(EAN_UPC, "__esModule", {
  value: !0
});
EAN_UPC.UPCE = EAN_UPC.UPC = EAN_UPC.EAN2 = EAN_UPC.EAN5 = EAN_UPC.EAN8 = EAN_UPC.EAN13 = void 0;
var _EAN = EAN13$1, _EAN2 = _interopRequireDefault$j(_EAN), _EAN3 = EAN8$1, _EAN4 = _interopRequireDefault$j(_EAN3), _EAN5 = EAN5$1, _EAN6 = _interopRequireDefault$j(_EAN5), _EAN7 = EAN2$1, _EAN8 = _interopRequireDefault$j(_EAN7), _UPC = UPC$1, _UPC2 = _interopRequireDefault$j(_UPC), _UPCE = UPCE$1, _UPCE2 = _interopRequireDefault$j(_UPCE);
function _interopRequireDefault$j(e) {
  return e && e.__esModule ? e : { default: e };
}
EAN_UPC.EAN13 = _EAN2.default;
EAN_UPC.EAN8 = _EAN4.default;
EAN_UPC.EAN5 = _EAN6.default;
EAN_UPC.EAN2 = _EAN8.default;
EAN_UPC.UPC = _UPC2.default;
EAN_UPC.UPCE = _UPCE2.default;
var ITF$2 = {}, ITF$1 = {}, constants = {};
Object.defineProperty(constants, "__esModule", {
  value: !0
});
constants.START_BIN = "1010";
constants.END_BIN = "11101";
constants.BINARIES = ["00110", "10001", "01001", "11000", "00101", "10100", "01100", "00011", "10010", "01010"];
Object.defineProperty(ITF$1, "__esModule", {
  value: !0
});
var _createClass$9 = /* @__PURE__ */ function() {
  function e(o, n) {
    for (var t = 0; t < n.length; t++) {
      var r = n[t];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(o, r.key, r);
    }
  }
  return function(o, n, t) {
    return n && e(o.prototype, n), t && e(o, t), o;
  };
}(), _constants = constants, _Barcode2$4 = Barcode$2, _Barcode3$4 = _interopRequireDefault$i(_Barcode2$4);
function _interopRequireDefault$i(e) {
  return e && e.__esModule ? e : { default: e };
}
function _classCallCheck$e(e, o) {
  if (!(e instanceof o))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$a(e, o) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o && (typeof o == "object" || typeof o == "function") ? o : e;
}
function _inherits$a(e, o) {
  if (typeof o != "function" && o !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof o);
  e.prototype = Object.create(o && o.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), o && (Object.setPrototypeOf ? Object.setPrototypeOf(e, o) : e.__proto__ = o);
}
var ITF = function(e) {
  _inherits$a(o, e);
  function o() {
    return _classCallCheck$e(this, o), _possibleConstructorReturn$a(this, (o.__proto__ || Object.getPrototypeOf(o)).apply(this, arguments));
  }
  return _createClass$9(o, [{
    key: "valid",
    value: function() {
      return this.data.search(/^([0-9]{2})+$/) !== -1;
    }
  }, {
    key: "encode",
    value: function() {
      var t = this, r = this.data.match(/.{2}/g).map(function(a) {
        return t.encodePair(a);
      }).join("");
      return {
        data: _constants.START_BIN + r + _constants.END_BIN,
        text: this.text
      };
    }
    // Calculate the data of a number pair
  }, {
    key: "encodePair",
    value: function(t) {
      var r = _constants.BINARIES[t[1]];
      return _constants.BINARIES[t[0]].split("").map(function(a, l) {
        return (a === "1" ? "111" : "1") + (r[l] === "1" ? "000" : "0");
      }).join("");
    }
  }]), o;
}(_Barcode3$4.default);
ITF$1.default = ITF;
var ITF14$1 = {};
Object.defineProperty(ITF14$1, "__esModule", {
  value: !0
});
var _createClass$8 = /* @__PURE__ */ function() {
  function e(o, n) {
    for (var t = 0; t < n.length; t++) {
      var r = n[t];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(o, r.key, r);
    }
  }
  return function(o, n, t) {
    return n && e(o.prototype, n), t && e(o, t), o;
  };
}(), _ITF2$1 = ITF$1, _ITF3$1 = _interopRequireDefault$h(_ITF2$1);
function _interopRequireDefault$h(e) {
  return e && e.__esModule ? e : { default: e };
}
function _classCallCheck$d(e, o) {
  if (!(e instanceof o))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$9(e, o) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o && (typeof o == "object" || typeof o == "function") ? o : e;
}
function _inherits$9(e, o) {
  if (typeof o != "function" && o !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof o);
  e.prototype = Object.create(o && o.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), o && (Object.setPrototypeOf ? Object.setPrototypeOf(e, o) : e.__proto__ = o);
}
var checksum = function(o) {
  var n = o.substr(0, 13).split("").map(function(t) {
    return parseInt(t, 10);
  }).reduce(function(t, r, a) {
    return t + r * (3 - a % 2 * 2);
  }, 0);
  return Math.ceil(n / 10) * 10 - n;
}, ITF14 = function(e) {
  _inherits$9(o, e);
  function o(n, t) {
    return _classCallCheck$d(this, o), n.search(/^[0-9]{13}$/) !== -1 && (n += checksum(n)), _possibleConstructorReturn$9(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, n, t));
  }
  return _createClass$8(o, [{
    key: "valid",
    value: function() {
      return this.data.search(/^[0-9]{14}$/) !== -1 && +this.data[13] === checksum(this.data);
    }
  }]), o;
}(_ITF3$1.default);
ITF14$1.default = ITF14;
Object.defineProperty(ITF$2, "__esModule", {
  value: !0
});
ITF$2.ITF14 = ITF$2.ITF = void 0;
var _ITF$1 = ITF$1, _ITF2 = _interopRequireDefault$g(_ITF$1), _ITF3 = ITF14$1, _ITF4 = _interopRequireDefault$g(_ITF3);
function _interopRequireDefault$g(e) {
  return e && e.__esModule ? e : { default: e };
}
ITF$2.ITF = _ITF2.default;
ITF$2.ITF14 = _ITF4.default;
var MSI$2 = {}, MSI$1 = {};
Object.defineProperty(MSI$1, "__esModule", {
  value: !0
});
var _createClass$7 = /* @__PURE__ */ function() {
  function e(o, n) {
    for (var t = 0; t < n.length; t++) {
      var r = n[t];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(o, r.key, r);
    }
  }
  return function(o, n, t) {
    return n && e(o.prototype, n), t && e(o, t), o;
  };
}(), _Barcode2$3 = Barcode$2, _Barcode3$3 = _interopRequireDefault$f(_Barcode2$3);
function _interopRequireDefault$f(e) {
  return e && e.__esModule ? e : { default: e };
}
function _classCallCheck$c(e, o) {
  if (!(e instanceof o))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$8(e, o) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o && (typeof o == "object" || typeof o == "function") ? o : e;
}
function _inherits$8(e, o) {
  if (typeof o != "function" && o !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof o);
  e.prototype = Object.create(o && o.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), o && (Object.setPrototypeOf ? Object.setPrototypeOf(e, o) : e.__proto__ = o);
}
var MSI = function(e) {
  _inherits$8(o, e);
  function o(n, t) {
    return _classCallCheck$c(this, o), _possibleConstructorReturn$8(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, n, t));
  }
  return _createClass$7(o, [{
    key: "encode",
    value: function() {
      for (var t = "110", r = 0; r < this.data.length; r++) {
        var a = parseInt(this.data[r]), l = a.toString(2);
        l = addZeroes(l, 4 - l.length);
        for (var s = 0; s < l.length; s++)
          t += l[s] == "0" ? "100" : "110";
      }
      return t += "1001", {
        data: t,
        text: this.text
      };
    }
  }, {
    key: "valid",
    value: function() {
      return this.data.search(/^[0-9]+$/) !== -1;
    }
  }]), o;
}(_Barcode3$3.default);
function addZeroes(e, o) {
  for (var n = 0; n < o; n++)
    e = "0" + e;
  return e;
}
MSI$1.default = MSI;
var MSI10$1 = {}, checksums = {};
Object.defineProperty(checksums, "__esModule", {
  value: !0
});
checksums.mod10 = mod10;
checksums.mod11 = mod11;
function mod10(e) {
  for (var o = 0, n = 0; n < e.length; n++) {
    var t = parseInt(e[n]);
    (n + e.length) % 2 === 0 ? o += t : o += t * 2 % 10 + Math.floor(t * 2 / 10);
  }
  return (10 - o % 10) % 10;
}
function mod11(e) {
  for (var o = 0, n = [2, 3, 4, 5, 6, 7], t = 0; t < e.length; t++) {
    var r = parseInt(e[e.length - 1 - t]);
    o += n[t % n.length] * r;
  }
  return (11 - o % 11) % 11;
}
Object.defineProperty(MSI10$1, "__esModule", {
  value: !0
});
var _MSI2$4 = MSI$1, _MSI3$4 = _interopRequireDefault$e(_MSI2$4), _checksums$3 = checksums;
function _interopRequireDefault$e(e) {
  return e && e.__esModule ? e : { default: e };
}
function _classCallCheck$b(e, o) {
  if (!(e instanceof o))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$7(e, o) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o && (typeof o == "object" || typeof o == "function") ? o : e;
}
function _inherits$7(e, o) {
  if (typeof o != "function" && o !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof o);
  e.prototype = Object.create(o && o.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), o && (Object.setPrototypeOf ? Object.setPrototypeOf(e, o) : e.__proto__ = o);
}
var MSI10 = function(e) {
  _inherits$7(o, e);
  function o(n, t) {
    return _classCallCheck$b(this, o), _possibleConstructorReturn$7(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, n + (0, _checksums$3.mod10)(n), t));
  }
  return o;
}(_MSI3$4.default);
MSI10$1.default = MSI10;
var MSI11$1 = {};
Object.defineProperty(MSI11$1, "__esModule", {
  value: !0
});
var _MSI2$3 = MSI$1, _MSI3$3 = _interopRequireDefault$d(_MSI2$3), _checksums$2 = checksums;
function _interopRequireDefault$d(e) {
  return e && e.__esModule ? e : { default: e };
}
function _classCallCheck$a(e, o) {
  if (!(e instanceof o))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$6(e, o) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o && (typeof o == "object" || typeof o == "function") ? o : e;
}
function _inherits$6(e, o) {
  if (typeof o != "function" && o !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof o);
  e.prototype = Object.create(o && o.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), o && (Object.setPrototypeOf ? Object.setPrototypeOf(e, o) : e.__proto__ = o);
}
var MSI11 = function(e) {
  _inherits$6(o, e);
  function o(n, t) {
    return _classCallCheck$a(this, o), _possibleConstructorReturn$6(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, n + (0, _checksums$2.mod11)(n), t));
  }
  return o;
}(_MSI3$3.default);
MSI11$1.default = MSI11;
var MSI1010$1 = {};
Object.defineProperty(MSI1010$1, "__esModule", {
  value: !0
});
var _MSI2$2 = MSI$1, _MSI3$2 = _interopRequireDefault$c(_MSI2$2), _checksums$1 = checksums;
function _interopRequireDefault$c(e) {
  return e && e.__esModule ? e : { default: e };
}
function _classCallCheck$9(e, o) {
  if (!(e instanceof o))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$5(e, o) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o && (typeof o == "object" || typeof o == "function") ? o : e;
}
function _inherits$5(e, o) {
  if (typeof o != "function" && o !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof o);
  e.prototype = Object.create(o && o.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), o && (Object.setPrototypeOf ? Object.setPrototypeOf(e, o) : e.__proto__ = o);
}
var MSI1010 = function(e) {
  _inherits$5(o, e);
  function o(n, t) {
    return _classCallCheck$9(this, o), n += (0, _checksums$1.mod10)(n), n += (0, _checksums$1.mod10)(n), _possibleConstructorReturn$5(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, n, t));
  }
  return o;
}(_MSI3$2.default);
MSI1010$1.default = MSI1010;
var MSI1110$1 = {};
Object.defineProperty(MSI1110$1, "__esModule", {
  value: !0
});
var _MSI2$1 = MSI$1, _MSI3$1 = _interopRequireDefault$b(_MSI2$1), _checksums = checksums;
function _interopRequireDefault$b(e) {
  return e && e.__esModule ? e : { default: e };
}
function _classCallCheck$8(e, o) {
  if (!(e instanceof o))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$4(e, o) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o && (typeof o == "object" || typeof o == "function") ? o : e;
}
function _inherits$4(e, o) {
  if (typeof o != "function" && o !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof o);
  e.prototype = Object.create(o && o.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), o && (Object.setPrototypeOf ? Object.setPrototypeOf(e, o) : e.__proto__ = o);
}
var MSI1110 = function(e) {
  _inherits$4(o, e);
  function o(n, t) {
    return _classCallCheck$8(this, o), n += (0, _checksums.mod11)(n), n += (0, _checksums.mod10)(n), _possibleConstructorReturn$4(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, n, t));
  }
  return o;
}(_MSI3$1.default);
MSI1110$1.default = MSI1110;
Object.defineProperty(MSI$2, "__esModule", {
  value: !0
});
MSI$2.MSI1110 = MSI$2.MSI1010 = MSI$2.MSI11 = MSI$2.MSI10 = MSI$2.MSI = void 0;
var _MSI$1 = MSI$1, _MSI2 = _interopRequireDefault$a(_MSI$1), _MSI3 = MSI10$1, _MSI4 = _interopRequireDefault$a(_MSI3), _MSI5 = MSI11$1, _MSI6 = _interopRequireDefault$a(_MSI5), _MSI7 = MSI1010$1, _MSI8 = _interopRequireDefault$a(_MSI7), _MSI9 = MSI1110$1, _MSI10 = _interopRequireDefault$a(_MSI9);
function _interopRequireDefault$a(e) {
  return e && e.__esModule ? e : { default: e };
}
MSI$2.MSI = _MSI2.default;
MSI$2.MSI10 = _MSI4.default;
MSI$2.MSI11 = _MSI6.default;
MSI$2.MSI1010 = _MSI8.default;
MSI$2.MSI1110 = _MSI10.default;
var pharmacode$1 = {};
Object.defineProperty(pharmacode$1, "__esModule", {
  value: !0
});
pharmacode$1.pharmacode = void 0;
var _createClass$6 = /* @__PURE__ */ function() {
  function e(o, n) {
    for (var t = 0; t < n.length; t++) {
      var r = n[t];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(o, r.key, r);
    }
  }
  return function(o, n, t) {
    return n && e(o.prototype, n), t && e(o, t), o;
  };
}(), _Barcode2$2 = Barcode$2, _Barcode3$2 = _interopRequireDefault$9(_Barcode2$2);
function _interopRequireDefault$9(e) {
  return e && e.__esModule ? e : { default: e };
}
function _classCallCheck$7(e, o) {
  if (!(e instanceof o))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$3(e, o) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o && (typeof o == "object" || typeof o == "function") ? o : e;
}
function _inherits$3(e, o) {
  if (typeof o != "function" && o !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof o);
  e.prototype = Object.create(o && o.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), o && (Object.setPrototypeOf ? Object.setPrototypeOf(e, o) : e.__proto__ = o);
}
var pharmacode = function(e) {
  _inherits$3(o, e);
  function o(n, t) {
    _classCallCheck$7(this, o);
    var r = _possibleConstructorReturn$3(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, n, t));
    return r.number = parseInt(n, 10), r;
  }
  return _createClass$6(o, [{
    key: "encode",
    value: function() {
      for (var t = this.number, r = ""; !isNaN(t) && t != 0; )
        t % 2 === 0 ? (r = "11100" + r, t = (t - 2) / 2) : (r = "100" + r, t = (t - 1) / 2);
      return r = r.slice(0, -2), {
        data: r,
        text: this.text
      };
    }
  }, {
    key: "valid",
    value: function() {
      return this.number >= 3 && this.number <= 131070;
    }
  }]), o;
}(_Barcode3$2.default);
pharmacode$1.pharmacode = pharmacode;
var codabar$1 = {};
Object.defineProperty(codabar$1, "__esModule", {
  value: !0
});
codabar$1.codabar = void 0;
var _createClass$5 = /* @__PURE__ */ function() {
  function e(o, n) {
    for (var t = 0; t < n.length; t++) {
      var r = n[t];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(o, r.key, r);
    }
  }
  return function(o, n, t) {
    return n && e(o.prototype, n), t && e(o, t), o;
  };
}(), _Barcode2$1 = Barcode$2, _Barcode3$1 = _interopRequireDefault$8(_Barcode2$1);
function _interopRequireDefault$8(e) {
  return e && e.__esModule ? e : { default: e };
}
function _classCallCheck$6(e, o) {
  if (!(e instanceof o))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$2(e, o) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o && (typeof o == "object" || typeof o == "function") ? o : e;
}
function _inherits$2(e, o) {
  if (typeof o != "function" && o !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof o);
  e.prototype = Object.create(o && o.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), o && (Object.setPrototypeOf ? Object.setPrototypeOf(e, o) : e.__proto__ = o);
}
var codabar = function(e) {
  _inherits$2(o, e);
  function o(n, t) {
    _classCallCheck$6(this, o), n.search(/^[0-9\-\$\:\.\+\/]+$/) === 0 && (n = "A" + n + "A");
    var r = _possibleConstructorReturn$2(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, n.toUpperCase(), t));
    return r.text = r.options.text || r.text.replace(/[A-D]/g, ""), r;
  }
  return _createClass$5(o, [{
    key: "valid",
    value: function() {
      return this.data.search(/^[A-D][0-9\-\$\:\.\+\/]+[A-D]$/) !== -1;
    }
  }, {
    key: "encode",
    value: function() {
      for (var t = [], r = this.getEncodings(), a = 0; a < this.data.length; a++)
        t.push(r[this.data.charAt(a)]), a !== this.data.length - 1 && t.push("0");
      return {
        text: this.text,
        data: t.join("")
      };
    }
  }, {
    key: "getEncodings",
    value: function() {
      return {
        0: "101010011",
        1: "101011001",
        2: "101001011",
        3: "110010101",
        4: "101101001",
        5: "110101001",
        6: "100101011",
        7: "100101101",
        8: "100110101",
        9: "110100101",
        "-": "101001101",
        $: "101100101",
        ":": "1101011011",
        "/": "1101101011",
        ".": "1101101101",
        "+": "1011011011",
        A: "1011001001",
        B: "1001001011",
        C: "1010010011",
        D: "1010011001"
      };
    }
  }]), o;
}(_Barcode3$1.default);
codabar$1.codabar = codabar;
var GenericBarcode$1 = {};
Object.defineProperty(GenericBarcode$1, "__esModule", {
  value: !0
});
GenericBarcode$1.GenericBarcode = void 0;
var _createClass$4 = /* @__PURE__ */ function() {
  function e(o, n) {
    for (var t = 0; t < n.length; t++) {
      var r = n[t];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(o, r.key, r);
    }
  }
  return function(o, n, t) {
    return n && e(o.prototype, n), t && e(o, t), o;
  };
}(), _Barcode2 = Barcode$2, _Barcode3 = _interopRequireDefault$7(_Barcode2);
function _interopRequireDefault$7(e) {
  return e && e.__esModule ? e : { default: e };
}
function _classCallCheck$5(e, o) {
  if (!(e instanceof o))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$1(e, o) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o && (typeof o == "object" || typeof o == "function") ? o : e;
}
function _inherits$1(e, o) {
  if (typeof o != "function" && o !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof o);
  e.prototype = Object.create(o && o.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), o && (Object.setPrototypeOf ? Object.setPrototypeOf(e, o) : e.__proto__ = o);
}
var GenericBarcode = function(e) {
  _inherits$1(o, e);
  function o(n, t) {
    return _classCallCheck$5(this, o), _possibleConstructorReturn$1(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, n, t));
  }
  return _createClass$4(o, [{
    key: "encode",
    value: function() {
      return {
        data: "10101010101010101010101010101010101010101",
        text: this.text
      };
    }
    // Resturn true/false if the string provided is valid for this encoder
  }, {
    key: "valid",
    value: function() {
      return !0;
    }
  }]), o;
}(_Barcode3.default);
GenericBarcode$1.GenericBarcode = GenericBarcode;
Object.defineProperty(barcodes, "__esModule", {
  value: !0
});
var _CODE = CODE39$1, _CODE2 = CODE128$2, _EAN_UPC = EAN_UPC, _ITF = ITF$2, _MSI = MSI$2, _pharmacode = pharmacode$1, _codabar = codabar$1, _GenericBarcode = GenericBarcode$1;
barcodes.default = {
  CODE39: _CODE.CODE39,
  CODE128: _CODE2.CODE128,
  CODE128A: _CODE2.CODE128A,
  CODE128B: _CODE2.CODE128B,
  CODE128C: _CODE2.CODE128C,
  EAN13: _EAN_UPC.EAN13,
  EAN8: _EAN_UPC.EAN8,
  EAN5: _EAN_UPC.EAN5,
  EAN2: _EAN_UPC.EAN2,
  UPC: _EAN_UPC.UPC,
  UPCE: _EAN_UPC.UPCE,
  ITF14: _ITF.ITF14,
  ITF: _ITF.ITF,
  MSI: _MSI.MSI,
  MSI10: _MSI.MSI10,
  MSI11: _MSI.MSI11,
  MSI1010: _MSI.MSI1010,
  MSI1110: _MSI.MSI1110,
  pharmacode: _pharmacode.pharmacode,
  codabar: _codabar.codabar,
  GenericBarcode: _GenericBarcode.GenericBarcode
};
var merge = {};
Object.defineProperty(merge, "__esModule", {
  value: !0
});
var _extends = Object.assign || function(e) {
  for (var o = 1; o < arguments.length; o++) {
    var n = arguments[o];
    for (var t in n)
      Object.prototype.hasOwnProperty.call(n, t) && (e[t] = n[t]);
  }
  return e;
};
merge.default = function(e, o) {
  return _extends({}, e, o);
};
var linearizeEncodings$1 = {};
Object.defineProperty(linearizeEncodings$1, "__esModule", {
  value: !0
});
linearizeEncodings$1.default = linearizeEncodings;
function linearizeEncodings(e) {
  var o = [];
  function n(t) {
    if (Array.isArray(t))
      for (var r = 0; r < t.length; r++)
        n(t[r]);
    else
      t.text = t.text || "", t.data = t.data || "", o.push(t);
  }
  return n(e), o;
}
var fixOptions$1 = {};
Object.defineProperty(fixOptions$1, "__esModule", {
  value: !0
});
fixOptions$1.default = fixOptions;
function fixOptions(e) {
  return e.marginTop = e.marginTop || e.margin, e.marginBottom = e.marginBottom || e.margin, e.marginRight = e.marginRight || e.margin, e.marginLeft = e.marginLeft || e.margin, e;
}
var getRenderProperties$1 = {}, getOptionsFromElement$1 = {}, optionsFromStrings$1 = {};
Object.defineProperty(optionsFromStrings$1, "__esModule", {
  value: !0
});
optionsFromStrings$1.default = optionsFromStrings;
function optionsFromStrings(e) {
  var o = ["width", "height", "textMargin", "fontSize", "margin", "marginTop", "marginBottom", "marginLeft", "marginRight"];
  for (var n in o)
    o.hasOwnProperty(n) && (n = o[n], typeof e[n] == "string" && (e[n] = parseInt(e[n], 10)));
  return typeof e.displayValue == "string" && (e.displayValue = e.displayValue != "false"), e;
}
var defaults$1 = {};
Object.defineProperty(defaults$1, "__esModule", {
  value: !0
});
var defaults = {
  width: 2,
  height: 100,
  format: "auto",
  displayValue: !0,
  fontOptions: "",
  font: "monospace",
  text: void 0,
  textAlign: "center",
  textPosition: "bottom",
  textMargin: 2,
  fontSize: 20,
  background: "#ffffff",
  lineColor: "#000000",
  margin: 10,
  marginTop: void 0,
  marginBottom: void 0,
  marginLeft: void 0,
  marginRight: void 0,
  valid: function() {
  }
};
defaults$1.default = defaults;
Object.defineProperty(getOptionsFromElement$1, "__esModule", {
  value: !0
});
var _optionsFromStrings$1 = optionsFromStrings$1, _optionsFromStrings2$1 = _interopRequireDefault$6(_optionsFromStrings$1), _defaults$1 = defaults$1, _defaults2$1 = _interopRequireDefault$6(_defaults$1);
function _interopRequireDefault$6(e) {
  return e && e.__esModule ? e : { default: e };
}
function getOptionsFromElement(e) {
  var o = {};
  for (var n in _defaults2$1.default)
    _defaults2$1.default.hasOwnProperty(n) && (e.hasAttribute("jsbarcode-" + n.toLowerCase()) && (o[n] = e.getAttribute("jsbarcode-" + n.toLowerCase())), e.hasAttribute("data-" + n.toLowerCase()) && (o[n] = e.getAttribute("data-" + n.toLowerCase())));
  return o.value = e.getAttribute("jsbarcode-value") || e.getAttribute("data-value"), o = (0, _optionsFromStrings2$1.default)(o), o;
}
getOptionsFromElement$1.default = getOptionsFromElement;
var renderers = {}, canvas = {}, shared = {};
Object.defineProperty(shared, "__esModule", {
  value: !0
});
shared.getTotalWidthOfEncodings = shared.calculateEncodingAttributes = shared.getBarcodePadding = shared.getEncodingHeight = shared.getMaximumHeightOfEncodings = void 0;
var _merge$3 = merge, _merge2$3 = _interopRequireDefault$5(_merge$3);
function _interopRequireDefault$5(e) {
  return e && e.__esModule ? e : { default: e };
}
function getEncodingHeight(e, o) {
  return o.height + (o.displayValue && e.text.length > 0 ? o.fontSize + o.textMargin : 0) + o.marginTop + o.marginBottom;
}
function getBarcodePadding(e, o, n) {
  if (n.displayValue && o < e) {
    if (n.textAlign == "center")
      return Math.floor((e - o) / 2);
    if (n.textAlign == "left")
      return 0;
    if (n.textAlign == "right")
      return Math.floor(e - o);
  }
  return 0;
}
function calculateEncodingAttributes(e, o, n) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t], a = (0, _merge2$3.default)(o, r.options), l;
    a.displayValue ? l = messureText(r.text, a, n) : l = 0;
    var s = r.data.length * a.width;
    r.width = Math.ceil(Math.max(l, s)), r.height = getEncodingHeight(r, a), r.barcodePadding = getBarcodePadding(l, s, a);
  }
}
function getTotalWidthOfEncodings(e) {
  for (var o = 0, n = 0; n < e.length; n++)
    o += e[n].width;
  return o;
}
function getMaximumHeightOfEncodings(e) {
  for (var o = 0, n = 0; n < e.length; n++)
    e[n].height > o && (o = e[n].height);
  return o;
}
function messureText(e, o, n) {
  var t;
  if (n)
    t = n;
  else if (typeof document < "u")
    t = document.createElement("canvas").getContext("2d");
  else
    return 0;
  t.font = o.fontOptions + " " + o.fontSize + "px " + o.font;
  var r = t.measureText(e);
  if (!r)
    return 0;
  var a = r.width;
  return a;
}
shared.getMaximumHeightOfEncodings = getMaximumHeightOfEncodings;
shared.getEncodingHeight = getEncodingHeight;
shared.getBarcodePadding = getBarcodePadding;
shared.calculateEncodingAttributes = calculateEncodingAttributes;
shared.getTotalWidthOfEncodings = getTotalWidthOfEncodings;
Object.defineProperty(canvas, "__esModule", {
  value: !0
});
var _createClass$3 = /* @__PURE__ */ function() {
  function e(o, n) {
    for (var t = 0; t < n.length; t++) {
      var r = n[t];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(o, r.key, r);
    }
  }
  return function(o, n, t) {
    return n && e(o.prototype, n), t && e(o, t), o;
  };
}(), _merge$2 = merge, _merge2$2 = _interopRequireDefault$4(_merge$2), _shared$1 = shared;
function _interopRequireDefault$4(e) {
  return e && e.__esModule ? e : { default: e };
}
function _classCallCheck$4(e, o) {
  if (!(e instanceof o))
    throw new TypeError("Cannot call a class as a function");
}
var CanvasRenderer = function() {
  function e(o, n, t) {
    _classCallCheck$4(this, e), this.canvas = o, this.encodings = n, this.options = t;
  }
  return _createClass$3(e, [{
    key: "render",
    value: function() {
      if (!this.canvas.getContext)
        throw new Error("The browser does not support canvas.");
      this.prepareCanvas();
      for (var n = 0; n < this.encodings.length; n++) {
        var t = (0, _merge2$2.default)(this.options, this.encodings[n].options);
        this.drawCanvasBarcode(t, this.encodings[n]), this.drawCanvasText(t, this.encodings[n]), this.moveCanvasDrawing(this.encodings[n]);
      }
      this.restoreCanvas();
    }
  }, {
    key: "prepareCanvas",
    value: function() {
      var n = this.canvas.getContext("2d");
      n.save(), (0, _shared$1.calculateEncodingAttributes)(this.encodings, this.options, n);
      var t = (0, _shared$1.getTotalWidthOfEncodings)(this.encodings), r = (0, _shared$1.getMaximumHeightOfEncodings)(this.encodings);
      this.canvas.width = t + this.options.marginLeft + this.options.marginRight, this.canvas.height = r, n.clearRect(0, 0, this.canvas.width, this.canvas.height), this.options.background && (n.fillStyle = this.options.background, n.fillRect(0, 0, this.canvas.width, this.canvas.height)), n.translate(this.options.marginLeft, 0);
    }
  }, {
    key: "drawCanvasBarcode",
    value: function(n, t) {
      var r = this.canvas.getContext("2d"), a = t.data, l;
      n.textPosition == "top" ? l = n.marginTop + n.fontSize + n.textMargin : l = n.marginTop, r.fillStyle = n.lineColor;
      for (var s = 0; s < a.length; s++) {
        var c = s * n.width + t.barcodePadding;
        a[s] === "1" ? r.fillRect(c, l, n.width, n.height) : a[s] && r.fillRect(c, l, n.width, n.height * a[s]);
      }
    }
  }, {
    key: "drawCanvasText",
    value: function(n, t) {
      var r = this.canvas.getContext("2d"), a = n.fontOptions + " " + n.fontSize + "px " + n.font;
      if (n.displayValue) {
        var l, s;
        n.textPosition == "top" ? s = n.marginTop + n.fontSize - n.textMargin : s = n.height + n.textMargin + n.marginTop + n.fontSize, r.font = a, n.textAlign == "left" || t.barcodePadding > 0 ? (l = 0, r.textAlign = "left") : n.textAlign == "right" ? (l = t.width - 1, r.textAlign = "right") : (l = t.width / 2, r.textAlign = "center"), r.fillText(t.text, l, s);
      }
    }
  }, {
    key: "moveCanvasDrawing",
    value: function(n) {
      var t = this.canvas.getContext("2d");
      t.translate(n.width, 0);
    }
  }, {
    key: "restoreCanvas",
    value: function() {
      var n = this.canvas.getContext("2d");
      n.restore();
    }
  }]), e;
}();
canvas.default = CanvasRenderer;
var svg = {};
Object.defineProperty(svg, "__esModule", {
  value: !0
});
var _createClass$2 = /* @__PURE__ */ function() {
  function e(o, n) {
    for (var t = 0; t < n.length; t++) {
      var r = n[t];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(o, r.key, r);
    }
  }
  return function(o, n, t) {
    return n && e(o.prototype, n), t && e(o, t), o;
  };
}(), _merge$1 = merge, _merge2$1 = _interopRequireDefault$3(_merge$1), _shared = shared;
function _interopRequireDefault$3(e) {
  return e && e.__esModule ? e : { default: e };
}
function _classCallCheck$3(e, o) {
  if (!(e instanceof o))
    throw new TypeError("Cannot call a class as a function");
}
var svgns = "http://www.w3.org/2000/svg", SVGRenderer = function() {
  function e(o, n, t) {
    _classCallCheck$3(this, e), this.svg = o, this.encodings = n, this.options = t, this.document = t.xmlDocument || document;
  }
  return _createClass$2(e, [{
    key: "render",
    value: function() {
      var n = this.options.marginLeft;
      this.prepareSVG();
      for (var t = 0; t < this.encodings.length; t++) {
        var r = this.encodings[t], a = (0, _merge2$1.default)(this.options, r.options), l = this.createGroup(n, a.marginTop, this.svg);
        this.setGroupOptions(l, a), this.drawSvgBarcode(l, a, r), this.drawSVGText(l, a, r), n += r.width;
      }
    }
  }, {
    key: "prepareSVG",
    value: function() {
      for (; this.svg.firstChild; )
        this.svg.removeChild(this.svg.firstChild);
      (0, _shared.calculateEncodingAttributes)(this.encodings, this.options);
      var n = (0, _shared.getTotalWidthOfEncodings)(this.encodings), t = (0, _shared.getMaximumHeightOfEncodings)(this.encodings), r = n + this.options.marginLeft + this.options.marginRight;
      this.setSvgAttributes(r, t), this.options.background && this.drawRect(0, 0, r, t, this.svg).setAttribute("style", "fill:" + this.options.background + ";");
    }
  }, {
    key: "drawSvgBarcode",
    value: function(n, t, r) {
      var a = r.data, l;
      t.textPosition == "top" ? l = t.fontSize + t.textMargin : l = 0;
      for (var s = 0, c = 0, d = 0; d < a.length; d++)
        c = d * t.width + r.barcodePadding, a[d] === "1" ? s++ : s > 0 && (this.drawRect(c - t.width * s, l, t.width * s, t.height, n), s = 0);
      s > 0 && this.drawRect(c - t.width * (s - 1), l, t.width * s, t.height, n);
    }
  }, {
    key: "drawSVGText",
    value: function(n, t, r) {
      var a = this.document.createElementNS(svgns, "text");
      if (t.displayValue) {
        var l, s;
        a.setAttribute("style", "font:" + t.fontOptions + " " + t.fontSize + "px " + t.font), t.textPosition == "top" ? s = t.fontSize - t.textMargin : s = t.height + t.textMargin + t.fontSize, t.textAlign == "left" || r.barcodePadding > 0 ? (l = 0, a.setAttribute("text-anchor", "start")) : t.textAlign == "right" ? (l = r.width - 1, a.setAttribute("text-anchor", "end")) : (l = r.width / 2, a.setAttribute("text-anchor", "middle")), a.setAttribute("x", l), a.setAttribute("y", s), a.appendChild(this.document.createTextNode(r.text)), n.appendChild(a);
      }
    }
  }, {
    key: "setSvgAttributes",
    value: function(n, t) {
      var r = this.svg;
      r.setAttribute("width", n + "px"), r.setAttribute("height", t + "px"), r.setAttribute("x", "0px"), r.setAttribute("y", "0px"), r.setAttribute("viewBox", "0 0 " + n + " " + t), r.setAttribute("xmlns", svgns), r.setAttribute("version", "1.1"), r.setAttribute("style", "transform: translate(0,0)");
    }
  }, {
    key: "createGroup",
    value: function(n, t, r) {
      var a = this.document.createElementNS(svgns, "g");
      return a.setAttribute("transform", "translate(" + n + ", " + t + ")"), r.appendChild(a), a;
    }
  }, {
    key: "setGroupOptions",
    value: function(n, t) {
      n.setAttribute("style", "fill:" + t.lineColor + ";");
    }
  }, {
    key: "drawRect",
    value: function(n, t, r, a, l) {
      var s = this.document.createElementNS(svgns, "rect");
      return s.setAttribute("x", n), s.setAttribute("y", t), s.setAttribute("width", r), s.setAttribute("height", a), l.appendChild(s), s;
    }
  }]), e;
}();
svg.default = SVGRenderer;
var object = {};
Object.defineProperty(object, "__esModule", {
  value: !0
});
var _createClass$1 = /* @__PURE__ */ function() {
  function e(o, n) {
    for (var t = 0; t < n.length; t++) {
      var r = n[t];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(o, r.key, r);
    }
  }
  return function(o, n, t) {
    return n && e(o.prototype, n), t && e(o, t), o;
  };
}();
function _classCallCheck$2(e, o) {
  if (!(e instanceof o))
    throw new TypeError("Cannot call a class as a function");
}
var ObjectRenderer = function() {
  function e(o, n, t) {
    _classCallCheck$2(this, e), this.object = o, this.encodings = n, this.options = t;
  }
  return _createClass$1(e, [{
    key: "render",
    value: function() {
      this.object.encodings = this.encodings;
    }
  }]), e;
}();
object.default = ObjectRenderer;
Object.defineProperty(renderers, "__esModule", {
  value: !0
});
var _canvas = canvas, _canvas2 = _interopRequireDefault$2(_canvas), _svg = svg, _svg2 = _interopRequireDefault$2(_svg), _object = object, _object2 = _interopRequireDefault$2(_object);
function _interopRequireDefault$2(e) {
  return e && e.__esModule ? e : { default: e };
}
renderers.default = { CanvasRenderer: _canvas2.default, SVGRenderer: _svg2.default, ObjectRenderer: _object2.default };
var exceptions = {};
Object.defineProperty(exceptions, "__esModule", {
  value: !0
});
function _classCallCheck$1(e, o) {
  if (!(e instanceof o))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(e, o) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o && (typeof o == "object" || typeof o == "function") ? o : e;
}
function _inherits(e, o) {
  if (typeof o != "function" && o !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof o);
  e.prototype = Object.create(o && o.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), o && (Object.setPrototypeOf ? Object.setPrototypeOf(e, o) : e.__proto__ = o);
}
var InvalidInputException = function(e) {
  _inherits(o, e);
  function o(n, t) {
    _classCallCheck$1(this, o);
    var r = _possibleConstructorReturn(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this));
    return r.name = "InvalidInputException", r.symbology = n, r.input = t, r.message = '"' + r.input + '" is not a valid input for ' + r.symbology, r;
  }
  return o;
}(Error), InvalidElementException = function(e) {
  _inherits(o, e);
  function o() {
    _classCallCheck$1(this, o);
    var n = _possibleConstructorReturn(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this));
    return n.name = "InvalidElementException", n.message = "Not supported type to render on", n;
  }
  return o;
}(Error), NoElementException = function(e) {
  _inherits(o, e);
  function o() {
    _classCallCheck$1(this, o);
    var n = _possibleConstructorReturn(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this));
    return n.name = "NoElementException", n.message = "No element to render on.", n;
  }
  return o;
}(Error);
exceptions.InvalidInputException = InvalidInputException;
exceptions.InvalidElementException = InvalidElementException;
exceptions.NoElementException = NoElementException;
Object.defineProperty(getRenderProperties$1, "__esModule", {
  value: !0
});
var _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
  return typeof e;
} : function(e) {
  return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
}, _getOptionsFromElement = getOptionsFromElement$1, _getOptionsFromElement2 = _interopRequireDefault$1(_getOptionsFromElement), _renderers = renderers, _renderers2 = _interopRequireDefault$1(_renderers), _exceptions$1 = exceptions;
function _interopRequireDefault$1(e) {
  return e && e.__esModule ? e : { default: e };
}
function getRenderProperties(e) {
  if (typeof e == "string")
    return querySelectedRenderProperties(e);
  if (Array.isArray(e)) {
    for (var o = [], n = 0; n < e.length; n++)
      o.push(getRenderProperties(e[n]));
    return o;
  } else {
    if (typeof HTMLCanvasElement < "u" && e instanceof HTMLImageElement)
      return newCanvasRenderProperties(e);
    if (e && e.nodeName && e.nodeName.toLowerCase() === "svg" || typeof SVGElement < "u" && e instanceof SVGElement)
      return {
        element: e,
        options: (0, _getOptionsFromElement2.default)(e),
        renderer: _renderers2.default.SVGRenderer
      };
    if (typeof HTMLCanvasElement < "u" && e instanceof HTMLCanvasElement)
      return {
        element: e,
        options: (0, _getOptionsFromElement2.default)(e),
        renderer: _renderers2.default.CanvasRenderer
      };
    if (e && e.getContext)
      return {
        element: e,
        renderer: _renderers2.default.CanvasRenderer
      };
    if (e && (typeof e > "u" ? "undefined" : _typeof(e)) === "object" && !e.nodeName)
      return {
        element: e,
        renderer: _renderers2.default.ObjectRenderer
      };
    throw new _exceptions$1.InvalidElementException();
  }
}
function querySelectedRenderProperties(e) {
  var o = document.querySelectorAll(e);
  if (o.length !== 0) {
    for (var n = [], t = 0; t < o.length; t++)
      n.push(getRenderProperties(o[t]));
    return n;
  }
}
function newCanvasRenderProperties(e) {
  var o = document.createElement("canvas");
  return {
    element: o,
    options: (0, _getOptionsFromElement2.default)(e),
    renderer: _renderers2.default.CanvasRenderer,
    afterRender: function() {
      e.setAttribute("src", o.toDataURL());
    }
  };
}
getRenderProperties$1.default = getRenderProperties;
var ErrorHandler$1 = {};
Object.defineProperty(ErrorHandler$1, "__esModule", {
  value: !0
});
var _createClass = /* @__PURE__ */ function() {
  function e(o, n) {
    for (var t = 0; t < n.length; t++) {
      var r = n[t];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(o, r.key, r);
    }
  }
  return function(o, n, t) {
    return n && e(o.prototype, n), t && e(o, t), o;
  };
}();
function _classCallCheck(e, o) {
  if (!(e instanceof o))
    throw new TypeError("Cannot call a class as a function");
}
var ErrorHandler = function() {
  function e(o) {
    _classCallCheck(this, e), this.api = o;
  }
  return _createClass(e, [{
    key: "handleCatch",
    value: function(n) {
      if (n.name === "InvalidInputException")
        if (this.api._options.valid !== this.api._defaults.valid)
          this.api._options.valid(!1);
        else
          throw n.message;
      else
        throw n;
      this.api.render = function() {
      };
    }
  }, {
    key: "wrapBarcodeCall",
    value: function(n) {
      try {
        var t = n.apply(void 0, arguments);
        return this.api._options.valid(!0), t;
      } catch (r) {
        return this.handleCatch(r), this.api;
      }
    }
  }]), e;
}();
ErrorHandler$1.default = ErrorHandler;
var _barcodes = barcodes, _barcodes2 = _interopRequireDefault(_barcodes), _merge = merge, _merge2 = _interopRequireDefault(_merge), _linearizeEncodings = linearizeEncodings$1, _linearizeEncodings2 = _interopRequireDefault(_linearizeEncodings), _fixOptions = fixOptions$1, _fixOptions2 = _interopRequireDefault(_fixOptions), _getRenderProperties = getRenderProperties$1, _getRenderProperties2 = _interopRequireDefault(_getRenderProperties), _optionsFromStrings = optionsFromStrings$1, _optionsFromStrings2 = _interopRequireDefault(_optionsFromStrings), _ErrorHandler = ErrorHandler$1, _ErrorHandler2 = _interopRequireDefault(_ErrorHandler), _exceptions = exceptions, _defaults = defaults$1, _defaults2 = _interopRequireDefault(_defaults);
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : { default: e };
}
var API = function() {
}, JsBarcode = function(o, n, t) {
  var r = new API();
  if (typeof o > "u")
    throw Error("No element to render on was provided.");
  return r._renderProperties = (0, _getRenderProperties2.default)(o), r._encodings = [], r._options = _defaults2.default, r._errorHandler = new _ErrorHandler2.default(r), typeof n < "u" && (t = t || {}, t.format || (t.format = autoSelectBarcode()), r.options(t)[t.format](n, t).render()), r;
};
JsBarcode.getModule = function(e) {
  return _barcodes2.default[e];
};
for (var name in _barcodes2.default)
  _barcodes2.default.hasOwnProperty(name) && registerBarcode(_barcodes2.default, name);
function registerBarcode(e, o) {
  API.prototype[o] = API.prototype[o.toUpperCase()] = API.prototype[o.toLowerCase()] = function(n, t) {
    var r = this;
    return r._errorHandler.wrapBarcodeCall(function() {
      t.text = typeof t.text > "u" ? void 0 : "" + t.text;
      var a = (0, _merge2.default)(r._options, t);
      a = (0, _optionsFromStrings2.default)(a);
      var l = e[o], s = encode(n, l, a);
      return r._encodings.push(s), r;
    });
  };
}
function encode(e, o, n) {
  e = "" + e;
  var t = new o(e, n);
  if (!t.valid())
    throw new _exceptions.InvalidInputException(t.constructor.name, e);
  var r = t.encode();
  r = (0, _linearizeEncodings2.default)(r);
  for (var a = 0; a < r.length; a++)
    r[a].options = (0, _merge2.default)(n, r[a].options);
  return r;
}
function autoSelectBarcode() {
  return _barcodes2.default.CODE128 ? "CODE128" : Object.keys(_barcodes2.default)[0];
}
API.prototype.options = function(e) {
  return this._options = (0, _merge2.default)(this._options, e), this;
};
API.prototype.blank = function(e) {
  var o = new Array(e + 1).join("0");
  return this._encodings.push({ data: o }), this;
};
API.prototype.init = function() {
  if (this._renderProperties) {
    Array.isArray(this._renderProperties) || (this._renderProperties = [this._renderProperties]);
    var e;
    for (var o in this._renderProperties) {
      e = this._renderProperties[o];
      var n = (0, _merge2.default)(this._options, e.options);
      n.format == "auto" && (n.format = autoSelectBarcode()), this._errorHandler.wrapBarcodeCall(function() {
        var t = n.value, r = _barcodes2.default[n.format.toUpperCase()], a = encode(t, r, n);
        render(e, a, n);
      });
    }
  }
};
API.prototype.render = function() {
  if (!this._renderProperties)
    throw new _exceptions.NoElementException();
  if (Array.isArray(this._renderProperties))
    for (var e = 0; e < this._renderProperties.length; e++)
      render(this._renderProperties[e], this._encodings, this._options);
  else
    render(this._renderProperties, this._encodings, this._options);
  return this;
};
API.prototype._defaults = _defaults2.default;
function render(e, o, n) {
  o = (0, _linearizeEncodings2.default)(o);
  for (var t = 0; t < o.length; t++)
    o[t].options = (0, _merge2.default)(n, o[t].options), (0, _fixOptions2.default)(o[t].options);
  (0, _fixOptions2.default)(n);
  var r = e.renderer, a = new r(e.element, o, n);
  a.render(), e.afterRender && e.afterRender();
}
typeof window < "u" && (window.JsBarcode = JsBarcode);
typeof jQuery < "u" && (jQuery.fn.JsBarcode = function(e, o) {
  var n = [];
  return jQuery(this).each(function() {
    n.push(this);
  }), JsBarcode(n, e, o);
});
var JsBarcode_1 = JsBarcode;
const jsbarcode = /* @__PURE__ */ getDefaultExportFromCjs(JsBarcode_1), alcBarcodeProps = {
  /**
   * 输出类型
   * @default 'svg'
   */
  output: {
    type: String,
    default: "svg"
  },
  /**
   * 条码值
   */
  value: {
    type: [String, Number],
    required: !0
  },
  /**
   * 条码整体宽度
   * @default undefined
   */
  width: {
    type: Number,
    default: void 0
  },
  /**
   * 条码实线的宽度
   * @default 2
   */
  lineWidth: {
    type: Number,
    default: 2
  },
  /**
   * 条码高度（不包含显示文本）
   * @default 100
   */
  height: {
    type: Number,
    default: 100
  },
  /**
   * 条码编码类型
   * @default 'CODE128'
   */
  format: {
    type: String,
    default: "CODE128"
  },
  /**
   * 条码实线的颜色
   * @default '#000000'
   */
  colorDark: {
    type: String,
    default: "#000000"
  },
  /**
   * 背景色
   * @default '#ffffff'
   */
  colorLight: {
    type: String,
    default: "#ffffff"
  },
  /**
   * 文本对齐方式
   * @default 'center'
   */
  textAlign: {
    type: String,
    default: "center"
  },
  /**
   * 文本位置
   * @default 'bottom'
   */
  textPosition: {
    type: String,
    default: "bottom"
  },
  /**
   * 是否条码值
   * @default false
   */
  displayValue: {
    type: Boolean,
    default: !1
  },
  /**
   * 字体
   * @default 'monospace'
   */
  font: {
    type: String,
    default: "monospace"
  },
  /**
   * 粗体、斜体、粗体和斜体
   * @default undefined
   */
  fontOptions: {
    type: String,
    default: void 0
  },
  /**
   * 文字大小
   * @default 12
   */
  fontSize: {
    type: Number,
    default: 12
  },
  /**
   * 条码整体外边距
   * @default 10
   */
  margin: {
    type: Number,
    default: 10
  },
  /**
   * 文本和条码间距
   * @default 2
   */
  textMargin: {
    type: Number,
    default: 2
  },
  /**
   * 是否水平条码
   * @description 设为 false 只有在编码规则为 EAN8/EAN13 时生效
   * @default true
   */
  flat: {
    type: Boolean,
    default: !0
  }
}, _sfc_main$i = /* @__PURE__ */ defineComponent({
  name: "alc-barcode",
  inheritAttrs: !1,
  __name: "barcode",
  props: alcBarcodeProps,
  setup(e, { expose: o }) {
    const n = e, t = ref(), r = `alc-barcode-${Date.now()}`;
    watch(
      () => n,
      (l) => {
        nextTick(() => {
          if (jsbarcode(`#${r}`, String(l.value), {
            format: l.format,
            width: l.lineWidth,
            height: l.height,
            displayValue: l.displayValue,
            font: l.font,
            fontSize: l.fontSize,
            fontOptions: l.fontOptions,
            textAlign: l.textAlign,
            textMargin: l.textMargin,
            textPosition: l.textPosition,
            margin: l.margin,
            flat: l.flat || ["EAN8", "EAN13"].includes(l.format) && !1,
            lineColor: l.colorDark,
            background: l.colorLight
          }), l.width && t.value) {
            if (l.output === "svg") {
              const { width: s, height: c } = t.value.getBBox(), d = c / s;
              t.value.style.height = `${l.width * d}px`;
            }
            t.value.style.width = `${l.width}px`;
          }
        });
      },
      {
        immediate: !0,
        deep: !0
      }
    ), o({
      el: t
    });
    const a = { props: n, barcode: t, id: r };
    return Object.defineProperty(a, "__isScriptSetup", { enumerable: !1, value: !0 }), a;
  }
});
function _sfc_render$i(e, o, n, t, r, a) {
  return openBlock(), createBlock(resolveDynamicComponent(e.output), {
    id: t.id,
    ref: "barcode"
  }, null, 512);
}
const Barcode = /* @__PURE__ */ _export_sfc(_sfc_main$i, [["render", _sfc_render$i], ["__file", "barcode.vue"]]), AlcBarcode = withInstall(Barcode), alcButtonListProps = {
  /**
   * 按钮数据
   * @default []
   */
  data: {
    type: Array,
    default: () => []
  },
  /**
   * 按钮大小
   * @default 'default'
   */
  size: {
    type: String,
    default: "default"
  },
  /**
   * 按钮类型
   * @default ''
   */
  type: {
    type: String,
    default: ""
  },
  /**
   * 是否是 plain 按钮
   * @default false
   */
  plain: { type: Boolean, default: !1 },
  /**
   * 是否禁用
   * @default {}
   */
  disabled: {
    type: Object,
    default: () => ({})
  },
  /**
   * 是否隐藏
   * @default {}
   */
  hide: {
    type: Object,
    default: () => ({})
  }
}, _sfc_main$h = /* @__PURE__ */ defineComponent({
  name: "alc-button-list",
  inheritAttrs: !1,
  __name: "button-list",
  props: alcButtonListProps,
  setup(e, { expose: o }) {
    o();
    const t = { showState: reactive([]), get ElButton() {
      return ElButton;
    }, get ElDropdown() {
      return ElDropdown;
    }, get ElDropdownMenu() {
      return ElDropdownMenu;
    } };
    return Object.defineProperty(t, "__isScriptSetup", { enumerable: !1, value: !0 }), t;
  }
}), _hoisted_1$f = { class: "command-item" }, _hoisted_2$d = {
  key: 1,
  class: "command-item"
}, _hoisted_3$a = { key: 1 };
function _sfc_render$h(e, o, n, t, r, a) {
  const l = resolveComponent("ElDropdownItem");
  return openBlock(!0), createElementBlock(Fragment, null, renderList(e.data, (s, c) => {
    var d;
    return openBlock(), createElementBlock(Fragment, {
      key: `${s.command}-${c}`
    }, [
      (d = s.child) != null && d.length && !e.hide[s.command] ? (openBlock(), createBlock(t.ElDropdown, {
        key: 0,
        disabled: e.disabled[s.command],
        size: e.size,
        placement: "bottom-end",
        trigger: "click",
        onCommand: (p) => e.disabled[s.command] || e.$emit("command", p),
        onVisibleChange: (p) => t.showState[c] = p
      }, createSlots({
        default: withCtx(() => [
          createVNode(t.ElButton, {
            disabled: e.disabled[s.command],
            type: e.type,
            plain: e.plain
          }, {
            default: withCtx(() => [
              s.label ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                createTextVNode(toDisplayString$1(s.label), 1)
              ], 64)) : createCommentVNode("", !0),
              createElementVNode("i", {
                class: normalizeClass(s.icon || "ri-arrow-down-s-line"),
                style: normalizeStyle({ marginLeft: s.label ? "4px" : void 0 })
              }, null, 6)
            ]),
            _: 2
          }, 1032, ["disabled", "type", "plain"])
        ]),
        _: 2
      }, [
        t.showState[c] ? {
          name: "dropdown",
          fn: withCtx(() => [
            createVNode(t.ElDropdownMenu, null, {
              default: withCtx(() => [
                (openBlock(!0), createElementBlock(Fragment, null, renderList(s.child, (p, f) => (openBlock(), createBlock(l, {
                  key: `${p.command}-${f}`,
                  command: p,
                  disabled: e.disabled[p.command]
                }, {
                  default: withCtx(() => {
                    var g;
                    return [
                      (g = p.child) != null && g.length && !e.hide[s.command] ? (openBlock(), createBlock(t.ElDropdown, {
                        key: 0,
                        disabled: e.disabled[p.command],
                        "hide-on-click": !1,
                        placement: "right-start",
                        size: e.size,
                        trigger: "hover",
                        onCommand: (b) => e.disabled[p.command] || e.$emit("command", b)
                      }, {
                        dropdown: withCtx(() => [
                          createVNode(t.ElDropdownMenu, null, {
                            default: withCtx(() => [
                              (openBlock(!0), createElementBlock(Fragment, null, renderList(p.child, (b, k) => (openBlock(), createBlock(l, {
                                key: `${b.command}-${k}`,
                                command: b,
                                disabled: e.disabled[b.command]
                              }, {
                                default: withCtx(() => [
                                  createElementVNode("div", _hoisted_1$f, [
                                    createElementVNode("i", {
                                      class: normalizeClass(
                                        b.icon || "ri-function-line"
                                      )
                                    }, null, 2),
                                    createElementVNode("span", null, toDisplayString$1(b.label), 1)
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["command", "disabled"]))), 128))
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        default: withCtx(() => [
                          createElementVNode("div", {
                            class: "command-item",
                            onClick: o[0] || (o[0] = withModifiers(() => {
                            }, ["stop"]))
                          }, [
                            createElementVNode("i", {
                              class: normalizeClass(p.icon || "ri-function-line")
                            }, null, 2),
                            createElementVNode("span", null, toDisplayString$1(p.label), 1)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["disabled", "size", "onCommand"])) : (openBlock(), createElementBlock("div", _hoisted_2$d, [
                        createElementVNode("i", {
                          class: normalizeClass(p.icon || "ri-function-line")
                        }, null, 2),
                        createElementVNode("span", null, toDisplayString$1(p.label), 1)
                      ]))
                    ];
                  }),
                  _: 2
                }, 1032, ["command", "disabled"]))), 128))
              ]),
              _: 2
            }, 1024)
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["disabled", "size", "onCommand", "onVisibleChange"])) : e.hide[s.command] ? createCommentVNode("", !0) : (openBlock(), createBlock(t.ElButton, {
        key: 1,
        type: s.type || e.type,
        size: e.size,
        plain: e.plain,
        disabled: e.disabled[s.command],
        onClick: (p) => e.disabled[s.command] || e.$emit("command", s)
      }, {
        default: withCtx(() => [
          s.icon ? (openBlock(), createElementBlock("i", {
            key: 0,
            class: normalizeClass(s.icon),
            style: { "margin-right": "2px" }
          }, null, 2)) : createCommentVNode("", !0),
          s.label ? (openBlock(), createElementBlock("span", _hoisted_3$a, toDisplayString$1(s.label), 1)) : createCommentVNode("", !0)
        ]),
        _: 2
      }, 1032, ["type", "size", "plain", "disabled", "onClick"]))
    ], 64);
  }), 128);
}
const ButtonList = /* @__PURE__ */ _export_sfc(_sfc_main$h, [["render", _sfc_render$h], ["__scopeId", "data-v-03006f20"], ["__file", "button-list.vue"]]), AlcButtonList = withInstall(ButtonList), _sfc_main$g = /* @__PURE__ */ defineComponent({
  name: "alc-config-provider",
  __name: "config-provider",
  props: {
    state: {},
    appName: {},
    appRoutePrefix: {},
    deployUrl: {},
    payView: {},
    oss: {}
  },
  setup(e, { expose: o }) {
    o();
    const n = e, t = useGlobalConfig(n);
    useSameZIndex(), isQiankun() && onRouteArgumentsChange((a) => {
      a.path.startsWith(`${t.value.appRoutePrefix}/`) && (t.value.routerArguments || (t.value.routerArguments = {}), t.value.routerArguments[a.path] = a.args);
    });
    const r = { props: n, globalConfig: t };
    return Object.defineProperty(r, "__isScriptSetup", { enumerable: !1, value: !0 }), r;
  }
});
function _sfc_render$g(e, o, n, t, r, a) {
  return renderSlot(e.$slots, "default");
}
const ConfigProvider = /* @__PURE__ */ _export_sfc(_sfc_main$g, [["render", _sfc_render$g], ["__file", "config-provider.vue"]]), AlcConfigProvider = withInstall(ConfigProvider), alcDateIntervalProps = {
  ...objPick(alcDateTimeProps, [
    "type",
    "readonly",
    "defaultTime",
    "disabledDate",
    "disabledHours",
    "disabledMinutes",
    "disabledSeconds"
  ]),
  /**
   * 自定义快捷选项
   */
  shortcuts: {
    type: Array
  },
  /**
   * 是否显示清除按钮
   * @default false
   */
  clearable: { type: Boolean, default: !1 }
}, _sfc_main$f = /* @__PURE__ */ defineComponent({
  name: "alc-date-interval",
  __name: "date-interval",
  props: /* @__PURE__ */ mergeModels(alcDateIntervalProps, {
    modelValue: {
      default: () => [/* @__PURE__ */ new Date(), /* @__PURE__ */ new Date()]
    },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ mergeModels(["change"], ["update:modelValue"]),
  setup(e, { expose: o, emit: n }) {
    useCssVars((k) => ({
      e1594080: c.value,
      "6cbd811c": d.value
    }));
    const t = e, r = n, a = useModel(e, "modelValue");
    let l;
    t.shortcuts ? l = t.shortcuts : t.type === "month" ? l = [1, 3, 6, 12].map((k) => ({
      label: `近 ${k} 月`,
      value: new Date(Date.now() - k * 1e3 * 60 * 60 * 24 * 30)
    })) : t.type === "time" ? l = [1, 6, 12, 24].map((k) => ({
      label: `近 ${k} 小时`,
      value: new Date(Date.now() - k * 1e3 * 60 * 60)
    })) : l = [1, 7, 15, 30].map((k) => ({
      label: `近 ${k} 天`,
      value: new Date(Date.now() - k * 1e3 * 60 * 60 * 24)
    }));
    const s = ref(), c = ref("0px"), d = ref("0px"), p = debounce(f, 200);
    watch(
      a,
      (k) => {
        k ? t.type === "time" ? p(k) : f(k) : c.value = "0px";
      },
      { immediate: !0 }
    );
    function f(k) {
      nextTick(() => {
        var N;
        const x = l.findIndex((O) => O.value === k[0]);
        if (~x) {
          const O = (N = s.value) == null ? void 0 : N.querySelector(
            `.shortcuts-date:nth-child(${x + 1})`
          );
          O instanceof HTMLSpanElement && (d.value = `${O.offsetLeft - 16}px`, c.value = `${O.getBoundingClientRect().width | 0}px`);
        } else
          c.value = "0px";
      });
    }
    function g(k) {
      var x;
      ((x = a.value) == null ? void 0 : x[0]) !== k.value && (a.value = [k.value, /* @__PURE__ */ new Date()], r("change", a.value));
    }
    o({
      instanceRef: s,
      dateValue: a
    });
    const b = { props: t, emits: r, dateValue: a, get intervals() {
      return l;
    }, set intervals(k) {
      l = k;
    }, elRef: s, width: c, x: d, run: p, updateActive: f, changeDate: g, get AlcDateTime() {
      return AlcDateTime;
    } };
    return Object.defineProperty(b, "__isScriptSetup", { enumerable: !1, value: !0 }), b;
  }
}), _hoisted_1$e = {
  ref: "elRef",
  class: "alc-cpt-date-interval"
}, _hoisted_2$c = ["onClick", "innerHTML"];
function _sfc_render$f(e, o, n, t, r, a) {
  return openBlock(), createElementBlock("div", _hoisted_1$e, [
    (openBlock(!0), createElementBlock(Fragment, null, renderList(t.intervals, (l, s) => (openBlock(), createElementBlock("span", {
      key: s,
      class: "shortcuts-date",
      onClick: (c) => e.readonly || t.changeDate(l),
      innerHTML: l.label
    }, null, 8, _hoisted_2$c))), 128)),
    createVNode(t.AlcDateTime, {
      modelValue: t.dateValue,
      "onUpdate:modelValue": o[0] || (o[0] = (l) => t.dateValue = l),
      type: e.type,
      readonly: e.readonly,
      "default-time": e.defaultTime,
      "disabled-date": e.disabledDate,
      "disabled-hours": e.disabledHours,
      "disabled-minutes": e.disabledMinutes,
      "disabled-seconds": e.disabledSeconds,
      clearable: e.clearable,
      size: "small",
      range: "",
      "start-placeholder": "自定义开始时间",
      "end-placeholder": "自定义结束时间",
      onChange: o[1] || (o[1] = (l) => e.$emit("change", l))
    }, null, 8, ["modelValue", "type", "readonly", "default-time", "disabled-date", "disabled-hours", "disabled-minutes", "disabled-seconds", "clearable"])
  ], 512);
}
const dateIntervalVue = /* @__PURE__ */ _export_sfc(_sfc_main$f, [["render", _sfc_render$f], ["__scopeId", "data-v-5b70fc6c"], ["__file", "date-interval.vue"]]), AlcDateInterval = withInstall(dateIntervalVue);
var FixedDir = /* @__PURE__ */ ((e) => (e.LEFT = "left", e.RIGHT = "right", e))(FixedDir || {});
const headerHeight = 38, _sfc_main$e = /* @__PURE__ */ defineComponent({
  name: "alc-list-v",
  __name: "list-v",
  props: {
    data: {},
    expandedRowKeys: {},
    cache: {},
    estimatedRowHeight: {},
    headerClass: {},
    headerProps: {},
    footerHeight: {},
    rowClass: {},
    rowKey: {},
    cellProps: {},
    dataGetter: {},
    fixedData: {},
    expandColumnKey: {},
    defaultExpandedRowKeys: {},
    hScrollbarSize: {},
    vScrollbarSize: {},
    sortBy: {},
    title: {},
    loading: { type: Boolean },
    stripe: { type: Boolean },
    border: { type: Boolean },
    height: { default: "100%" },
    maxHeight: {},
    schema: {},
    operation: {},
    operationWidth: { default: 112 },
    operationTips: {},
    multiple: { type: Boolean },
    selectable: {},
    reserveSelection: { type: Boolean },
    showHeader: { type: Boolean, default: !0 },
    showIndex: { type: Boolean, default: !0 },
    index: {},
    expandable: { type: Boolean },
    highlightCurrent: { default: "row" },
    disabled: { type: Boolean },
    showSummary: { type: Boolean },
    colMerge: {},
    rowMerge: {},
    rowHeight: { default: 36 },
    rowProps: {},
    cellClass: {},
    cellStyle: {},
    headerCellProps: {},
    draggable: { type: Boolean },
    class: {},
    tableClass: {}
  },
  emits: ["update:data", "select", "selectAll", "selectionChange", "currentChange", "cellClick", "cellDblclick", "cellContextmenu", "rowClick", "rowDblclick", "rowContextmenu", "drop", "headerDrop", "update:expandedRowKeys"],
  setup(e, { expose: o, emit: n }) {
    const t = e, r = n, a = useSlots(), l = [
      "data",
      "expandedRowKeys",
      "cache",
      "estimatedRowHeight",
      "headerClass",
      "headerProps",
      "footerHeight",
      "rowClass",
      "rowKey",
      "cellProps",
      "dataGetter",
      "fixedData",
      "expandColumnKey",
      "defaultExpandedRowKeys",
      "hScrollbarSize",
      "vScrollbarSize",
      "sortBy"
    ], s = useModel(t, "data"), c = useModel(t, "expandedRowKeys"), d = ref();
    onMounted(() => {
      const ue = d.value.$el.querySelector(
        ".el-table-v2__body > div > div"
      );
      ue && (ue.ondragover = (ve) => {
        ve.preventDefault();
      }, ue.ondrop = (ve) => {
        ve.preventDefault();
      }), setTimeout(() => {
        const ve = d.value.$el.querySelector(
          ".el-table-v2__header-row"
        );
        ve && (ve.ondragover = (we) => {
          we.preventDefault();
        }, ve.ondrop = (we) => {
          we.preventDefault();
        });
      });
    });
    const p = {
      key: "$index",
      width: 48,
      prop: "__index",
      align: "center",
      fixed: FixedDir.LEFT,
      class: "alc-list-v__index",
      label: "序号",
      headerCellRenderer: () => a.indexHeader ? a.indexHeader() : /* @__PURE__ */ React.createElement(React.Fragment, null, "序号"),
      // 把 if 判断提升到循环外面，避免每次循环都判断
      cellRenderer: typeof t.index == "function" ? (ue) => /* @__PURE__ */ React.createElement(React.Fragment, null, t.index(ue.rowIndex)) : (ue) => /* @__PURE__ */ React.createElement(React.Fragment, null, ue.rowIndex + 1)
    }, f = ref(!1), g = shallowRef({}), b = {
      key: "$ops",
      prop: "__ops",
      title: "操作",
      align: "center",
      width: typeof t.operationWidth == "string" ? Number.parseInt(t.operationWidth) : t.operationWidth,
      fixed: FixedDir.RIGHT,
      tips: t.operationTips
    }, k = { ...b };
    b.headerCellRenderer = () => De(k, !1);
    const x = (ue) => {
      g.value = {
        ...g.value,
        ...ue
      }, f.value = !0;
    };
    b.cellRenderer = ({ rowData: ue, rowIndex: ve }) => /* @__PURE__ */ React.createElement(
      AlcTableOperation,
      {
        operations: t.operation,
        disabled: t.disabled,
        scope: {
          row: ue,
          $index: ve
        },
        onOpenConfirmPopover: x
      }
    );
    const N = ref();
    watch(N, (ue, ve) => {
      ue && r(
        "currentChange",
        s.value[ue],
        ve && s.value[ve]
      );
    });
    const O = ({
      value: ue,
      intermediate: ve = !1,
      onChange: we
    }) => /* @__PURE__ */ React.createElement(
      ElCheckbox,
      {
        onChange: we,
        modelValue: ue,
        indeterminate: ve
      }
    ), m = reactive(/* @__PURE__ */ new Set()), ee = computed(() => s.value.filter((ue, ve) => m.has(xe(ue, ve))));
    watch(
      () => m,
      () => {
        r("selectionChange", ee.value);
      },
      { deep: !0 }
    ), t.reserveSelection || watch(s, () => {
      m.clear();
    });
    const z = {
      key: "$selection",
      width: 48,
      prop: "__selection",
      align: "center",
      fixed: FixedDir.LEFT,
      cellRenderer: ({ rowData: ue, rowIndex: ve }) => {
        const we = xe(ue, ve), Se = (de) => {
          de ? m.add(we) : m.delete(we), r("select", de ? ue : void 0, ee.value);
        };
        return /* @__PURE__ */ React.createElement(
          O,
          {
            value: m.has(we),
            disabled: typeof t.selectable == "function" ? !t.selectable(ue, ve) : !1,
            onChange: Se
          }
        );
      },
      headerCellRenderer: () => {
        const ue = s.value;
        let ve, we, Se;
        return t.rowKey ? (ve = (de) => {
          ue.forEach((ge, be) => {
            if (!(typeof t.selectable == "function" && !t.selectable(ge, be)))
              return de ? m.add(ge[t.rowKey]) : m.delete(ge[t.rowKey]);
          }), r("selectAll", ee.value);
        }, we = ue.every((de) => m.has(de[t.rowKey])), Se = ue.some((de) => m.has(de[t.rowKey]))) : (ve = (de) => {
          ue.forEach((ge, be) => {
            if (!(typeof t.selectable == "function" && !t.selectable(ge, be)))
              return de ? m.add(be) : m.delete(be);
          }), r("selectAll", ee.value);
        }, we = ue.every((de, ge) => m.has(ge)), Se = ue.some((de, ge) => m.has(ge))), /* @__PURE__ */ React.createElement(
          O,
          {
            value: we,
            intermediate: Se && !we,
            onChange: ve
          }
        );
      }
    }, P = shallowRef([]), V = shallowRef(/* @__PURE__ */ new WeakMap()), U = new ResizeObserver((ue) => {
      for (const ve of ue) {
        const we = ve.target, { width: Se } = we.getBoundingClientRect();
        console.log(
          "%c alc-list-v.vue:target.dataset.resizeable =>",
          "background: linear-gradient(139deg, #fb8817, #ff4b01, #c12127, #e02aff); padding: 2px 4px; border-radius: 4px; color: #fff",
          we.dataset.resizeable
        ), console.log(
          `%c alc-list-v.vue: ${Se}px=>`,
          "background: linear-gradient(139deg, #fb8817, #ff4b01, #c12127, #e02aff); padding: 2px 4px; border-radius: 4px; color: #fff",
          `${Se}px`
        );
      }
    });
    watch(
      () => t.schema,
      (ue, ve) => {
        var we;
        P.value = I(ue), t.multiple && (P.value[0].unshift(z), V.value.set(z, z.width)), t.showIndex && (P.value[0].unshift(p), V.value.set(p, p.width)), (we = t.operation) != null && we.length && (P.value[0].push(b), V.value.set(b, b.width)), ue !== ve && (U.disconnect(), nextTick(() => {
          d.value.$el.querySelectorAll(".el-table-v2__header [data-resizeable]").forEach((de) => {
            U.observe(de);
          });
        }));
      },
      { immediate: !0 }
    );
    const E = computed(() => C(P.value[0]).map((ue) => {
      const ve = ue.prop || ue.key, we = {
        width: 156,
        ...ue,
        // el-table-v2 需要 title 显示标题
        title: ue.title || ue.label,
        prop: ve,
        // el-table-v2 需要 key 作为唯一标识
        key: ve,
        // el-table-v2 需要 dataKey 对照显示的数据
        dataKey: ve,
        align: ue.align || Me(ue.itemType)
      };
      return t.showHeader && (we.headerCellRenderer || (we.headerCellRenderer = () => De(we))), we.cellRenderer || (we.cellRenderer = (Se) => a.cell ? a.cell({ ...Se, item: we }) : we.prop && a[we.prop] ? a[we.prop](Se) : Fe(Se, we)), we;
    }));
    function C(ue) {
      return ue.reduce((ve, we) => {
        var Se;
        return (Se = we.children) != null && Se.length ? ve.push(...C(we.children)) : ve.push(we), ve;
      }, []);
    }
    function I(ue) {
      const ve = [];
      function we(Se, de, ge = { value: 0 }) {
        var be;
        for (let ke = 0; ke < Se.length; ke++) {
          const Ne = Se[ke];
          de[ge.value] || (de[ge.value] = []), de[ge.value].push(Ne), V.value.set(Ne, Ne.width), (be = Ne.children) != null && be.length && (ge.value++, we(Ne.children, de, ge), V.value.set(
            Ne,
            Ne.children.reduce(
              (Oe, Pe) => Oe + (V.value.get(Pe) || 0),
              0
            )
          )), ke === Se.length - 1 && ge.value--;
        }
      }
      return we(ue, ve), ve;
    }
    function v(ue) {
      return ue.split(",").reduce(
        (ve, we, Se, de) => (+we - 1 === +de[Se - 1] ? ve.at(-1).push(we) : ve.push([we]), ve),
        []
      );
    }
    const M = /* @__PURE__ */ new Map(), $ = ({
      rowData: ue,
      rowIndex: ve,
      cells: we
    }) => {
      if (t.rowMerge) {
        const Se = Object.entries(t.rowMerge);
        for (const [de, ge] of Se) {
          const be = Number(de), ke = M.get(be);
          if (ve > 1 && ke && we[be]) {
            const Te = we[be].props.style;
            we[be] = /* @__PURE__ */ React.createElement(
              "div",
              {
                style: {
                  ...Te,
                  width: `${Te.width}px`,
                  zIndex: -1
                }
              }
            );
            const Le = ke - 1;
            Le ? M.set(be, Le) : M.delete(be);
            continue;
          }
          let Ne = 1;
          for (; ve + Ne < s.value.length && s.value[ve + Ne][ge] === ue[ge]; )
            Ne++;
          if (Ne === 1 || !we[be])
            continue;
          const Oe = we[be], Pe = {
            ...Oe.props.style,
            backgroundColor: "var(--el-color-danger-light-3)",
            height: `${Ne * t.rowHeight}px`,
            alignSelf: "flex-start",
            zIndex: 1
          };
          we[be] = cloneVNode(Oe, { style: Pe }), M.set(be, Ne - 1);
        }
      }
      if (t.colMerge) {
        const Se = Object.entries(t.colMerge);
        for (const [de, ge] of Se) {
          if (!ge({ rowData: ue, rowIndex: ve }))
            continue;
          const be = v(de);
          for (const ke of be) {
            const Ne = ke.shift();
            if (!we[Ne])
              continue;
            const Oe = we[Ne].props.style;
            let Pe = Number.parseInt(Oe.width);
            for (; ke.length; ) {
              const Te = ke.shift();
              we[Te] && (Pe += Number.parseInt(
                we[Te].props.style.width
              ), we[Te] = null);
            }
            we[Ne] = cloneVNode(
              we[Ne],
              {
                style: {
                  ...Oe,
                  width: `${Pe}px`,
                  backgroundColor: "var(--el-color-primary-light-3)"
                }
              }
            );
          }
        }
      }
      return we;
    };
    $.inheritAttrs = !1;
    const H = ({
      column: ue,
      tableData: ve
    }) => {
      const we = ue.filter((de) => de.prop && de.sum && de.itemType === "number");
      function Se(de) {
        return ve.reduce((ge, be) => ge + be[de], 0);
      }
      return /* @__PURE__ */ React.createElement("div", { class: "footer-summary" }, we.map((de) => /* @__PURE__ */ React.createElement("span", { class: "footer-summary--item" }, de.title, ":", Se(de.prop))));
    }, X = computed(() => t.showHeader ? P.value.length * headerHeight : 0);
    function te(ue, ve) {
      let we = ue;
      if (ve = ve.slice(0, -1), !ve.length)
        return we;
      for (const Se of ve)
        we = we[Se].children;
      return we;
    }
    const oe = (ue, ve, we = {}, Se = { value: 1 }) => {
      var be;
      let de = typeof t.headerCellProps == "function" ? t.headerCellProps({
        columns: P.value[0],
        headerIndex: +ve.split(",").at(-1)
      }) : t.headerCellProps;
      t.draggable && (de = mergeProps(de, {
        draggable: !0,
        ondragstart: (Pe) => {
          Pe.stopPropagation(), Pe.dataTransfer.setData("text/plain", ve), Pe.dataTransfer.dropEffect = "move", Pe.dataTransfer.effectAllowed = "move";
        },
        ondragover: () => {
        },
        ondrop: (Pe) => {
          var ze;
          Pe.preventDefault(), Pe.stopPropagation();
          const Te = (ze = Pe.dataTransfer) == null ? void 0 : ze.getData("text/plain");
          if (!Te)
            return;
          const Le = Te.split(","), Ae = ve.split(",");
          if (Le.length !== Ae.length)
            return;
          const Re = +Le.at(-1), Ve = +Ae.at(-1), Ie = te(P.value[0], Ae);
          [Ie[Ve], Ie[Re]] = [
            Ie[Re],
            Ie[Ve]
          ], console.log(
            "%c alc-list-v.vue:headerColumns.value =>",
            "background: linear-gradient(139deg, #fb8817, #ff4b01, #c12127, #e02aff); padding: 2px 4px; border-radius: 4px; color: #fff",
            P.value
          ), triggerRef(P), r("headerDrop", {
            dragIndex: Re,
            dropIndex: Ve,
            dropColumn: Ie[Re],
            dragColumn: Ie[Ve]
          });
        }
      }));
      const ge = V.value.get(ue);
      if ((be = ue.children) != null && be.length) {
        Se.value++;
        const ke = /* @__PURE__ */ React.createElement(
          "div",
          {
            class: "el-table-v2__header-cell",
            role: "columnheader",
            style: {
              ...we,
              width: `${ge}px`,
              display: "flex",
              flexFlow: "column nowrap",
              padding: "0"
            },
            ...de
          },
          /* @__PURE__ */ React.createElement(
            "div",
            {
              style: {
                display: "flex",
                width: "100%",
                height: `${headerHeight}px`,
                alignItems: "center",
                padding: "0 8px",
                userSelect: "none",
                overflow: "hidden",
                borderBottom: "var(--el-table-border)"
              }
            },
            De(ue)
          ),
          /* @__PURE__ */ React.createElement(
            "div",
            {
              style: {
                display: "flex",
                flexFlow: "row nowrap"
              },
              onDragover: (Ne) => Ne.preventDefault(),
              onDrop: (Ne) => Ne.preventDefault()
            },
            ue.children.map(
              (Ne, Oe) => oe(
                Ne,
                `${ve},${Oe}`,
                we,
                Se
              )
            )
          )
        );
        return Se.value--, ke;
      }
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          class: "el-table-v2__header-cell",
          role: "columnheader",
          style: {
            ...we,
            width: `${ge}px`,
            height: `${(P.value.length - Se.value + 1) * headerHeight}px`,
            borderBottom: Se.value === 1 ? "var(--el-table-border)" : void 0,
            resize: "horizontal"
          },
          dataResizeable: ue.prop,
          ...de
        },
        De(ue)
      );
    }, ne = ({ cells: ue, columns: ve }) => {
      const we = P.value[0].map((Se, de) => oe(Se, String(de)));
      return we.length < ve.length ? we : ue;
    }, ie = ref(), se = computed(() => !t.highlightCurrent || t.highlightCurrent === "row" ? "" : {
      column: "hovering__column",
      cross: "hovering__cross"
    }[t.highlightCurrent]), pe = (ue) => {
      var de, ge;
      const ve = {
        class: typeof t.cellClass == "function" ? t.cellClass(ue) : t.cellClass,
        style: {
          // 根据列类型设置单元格内容的对齐方式。单元格内对齐方式覆盖逻辑：props.cellStyle > scope.column.align > props.cellProps
          justifyContent: ue.column.align || Me(ue.column.itemType),
          ...typeof t.cellStyle == "function" ? t.cellStyle(ue) : t.cellStyle
        },
        onClick: (be) => {
          r("cellClick", { ...ue, event: be });
        },
        onDblclick: (be) => {
          r("cellDblclick", { ...ue, event: be });
        },
        onContextmenu: (be) => {
          r("cellContextmenu", { ...ue, event: be });
        }
      }, we = typeof t.cellProps == "function" ? t.cellProps(ue) : t.cellProps;
      if (!t.highlightCurrent || t.highlightCurrent === "row")
        return mergeProps(we, ve);
      let Se = "";
      return ((de = ie.value) == null ? void 0 : de.x) === ue.rowIndex && (Se += "x"), ((ge = ie.value) == null ? void 0 : ge.y) === ue.columnIndex && (Se += "y"), mergeProps(we, ve, {
        "data-hover": Se,
        onMouseenter: () => {
          ie.value = {
            x: ue.rowIndex,
            y: ue.columnIndex
          };
        },
        onMouseleave: () => {
          ie.value = void 0;
        }
      });
    }, he = reactive({
      start: -1,
      enter: -1
    }), ae = (ue) => {
      let ve = typeof t.rowProps == "function" ? t.rowProps(ue) : t.rowProps;
      const we = (ge) => {
        N.value = ue.rowIndex, r("rowClick", {
          rowIndex: ue.rowIndex,
          rowData: ue.rowData,
          event: ge
        });
      }, Se = (ge) => {
        r("rowDblclick", {
          rowIndex: ue.rowIndex,
          rowData: ue.rowData,
          event: ge
        });
      }, de = (ge) => {
        r("rowContextmenu", {
          rowIndex: ue.rowIndex,
          rowData: ue.rowData,
          event: ge
        });
      };
      return t.draggable && (ve = mergeProps(ve, {
        draggable: !0,
        ondragstart: (Oe) => {
          he.start = ue.rowIndex, Oe.dataTransfer.setData("text/plain", ue.rowIndex.toString()), Oe.dataTransfer.dropEffect = "move", Oe.dataTransfer.effectAllowed = "move";
        },
        ondragenter: () => {
          he.enter = ue.rowIndex;
        },
        ondragend: () => {
          he.start !== he.enter && (he.start = -1, he.enter = -1);
        },
        ondrop: (Oe) => {
          var Te;
          Oe.preventDefault(), Oe.stopPropagation();
          let Pe = (Te = Oe.dataTransfer) == null ? void 0 : Te.getData("text/plain");
          Pe && (Pe = Number(Pe), [s.value[Pe], s.value[ue.rowIndex]] = [
            s.value[ue.rowIndex],
            s.value[Pe]
          ], N.value = ue.rowIndex, r("drop", {
            dragIndex: +Pe,
            dropIndex: ue.rowIndex,
            dragRow: s.value[ue.rowIndex],
            dropRow: s.value[+Pe]
          }));
        }
      })), mergeProps(
        ve,
        // 如果 rowProps 中有相同的事件响应，预置的 emit 事件后触发
        {
          onClick: we,
          onDblclick: Se,
          onContextmenu: de
        }
      );
    }, le = (ue) => {
      const ve = typeof t.rowClass == "function" ? t.rowClass(ue) : t.rowClass, we = N.value === ue.rowIndex || ue.rowIndex === he.enter ? "is-highlight-row" : "";
      return ve ? `${ve} ${we}` : we;
    };
    let fe;
    const Ce = (ue) => {
      typeof fe > "u" && (fe = ue.scrollTop), fe !== ue.scrollTop && (f.value = !1), fe = ue.scrollTop;
    };
    function Be(ue) {
      return `${ue}Header`;
    }
    function De(ue, ve = !0) {
      if (ve) {
        const we = Be(ue.prop);
        if (a[we])
          return a[we]();
        if (a.headerCell)
          return a.headerCell({ item: ue });
      }
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
        "div",
        {
          class: "header-cell__title single-line-overflow",
          title: ue.label || ue.title
        },
        ue.label || ue.title
      ), ue.tips ? /* @__PURE__ */ React.createElement(AlcTooltip, { class: "header-cell__tips", content: ue.tips }) : "");
    }
    function Fe(ue, ve) {
      return /* @__PURE__ */ React.createElement(
        AlcDisplay,
        {
          "model-value": ue.rowData[ve.prop],
          "item-type": ve.itemType,
          formatter: ve.formatter ? (we) => ve.formatter(
            ue.row,
            ue.column,
            we,
            ue.$index
          ) : void 0,
          code: ve.code
        }
      );
    }
    function Me(ue) {
      return ue === "checkbox" ? "center" : ue === "number" ? "right" : void 0;
    }
    function xe(ue, ve) {
      return t.rowKey ? ue[t.rowKey] : ve;
    }
    function _e() {
      m.clear();
    }
    function Ee() {
      return ee.value;
    }
    function re(ue, ve = !0) {
      if (typeof ue == "object") {
        const we = s.value.findIndex((Se) => Se === ue);
        if (~we) {
          const Se = xe(ue, we);
          ve ? m.add(Se) : m.delete(Se);
        }
      } else {
        const we = s.value[ue];
        if (we) {
          const Se = xe(we, ue);
          ve ? m.add(Se) : m.delete(Se);
        }
      }
    }
    function ce() {
      m.size === s.value.length ? m.clear() : s.value.forEach((ue, ve) => {
        m.add(xe(ue, ve));
      });
    }
    function ye(ue) {
      typeof ue == "object" && (ue = s.value.findIndex((ve) => ve === ue)), ~ue && (N.value = ue);
    }
    o({
      ...getInstanceMethod(d, [
        "scrollTo",
        "scrollToLeft",
        "scrollToTop",
        "scrollToRow"
      ]),
      clearSelection: _e,
      getSelectionRows: Ee,
      toggleRowSelection: re,
      toggleAllSelection: ce,
      setCurrentRow: ye
    });
    const me = { props: t, emits: r, slots: a, accept: l, tableData: s, expandedRowKeys$: c, tableV2Ref: d, indexColumn: p, popVisible: f, popConfig: g, operationColumn: b, operationColumnCopy: k, openOperationConfirm: x, currentRow: N, SelectionCell: O, selectedSet: m, selection: ee, multipleColumn: z, headerColumns: P, headerColumnSpan: V, resizeGather: U, columns: E, getLeafNodes: C, flatHeaderHeight: I, adjacentGroup: v, rowMergeCatch: M, Row: $, Footer: H, headerHeight, headerHeight$: X, arrayFindByPath: te, SubHeader: oe, MultiLevelHeader: ne, hoverAxis: ie, hoverClass: se, cellProps$: pe, rowDragIndex: he, rowProps$: ae, rowClass$: le, get oldScrollTop() {
      return fe;
    }, set oldScrollTop(ue) {
      fe = ue;
    }, onScroll: Ce, geHeaderSlotName: Be, HeaderCell: De, Cell: Fe, getAlign: Me, getRowIdentValue: xe, clearSelection: _e, getSelectionRows: Ee, toggleRowSelection: re, toggleAllSelection: ce, setCurrentRow: ye, get ElAutoResizer() {
      return ElAutoResizer;
    }, get ElEmpty() {
      return ElEmpty;
    }, get ElPopconfirm() {
      return ElPopconfirm;
    }, get ElTableV2() {
      return ElTableV2;
    }, get objPick() {
      return objPick;
    } };
    return Object.defineProperty(me, "__isScriptSetup", { enumerable: !1, value: !0 }), me;
  }
}), _hoisted_1$d = { class: "flex items-center justify-center h100" }, _hoisted_2$b = { class: "h100" };
function _sfc_render$e(e, o, n, t, r, a) {
  const l = resolveDirective("load-on");
  return openBlock(), createBlock(t.ElAutoResizer, {
    style: normalizeStyle({
      height: n.height,
      maxHeight: n.maxHeight
    }),
    class: normalizeClass(t.props.class)
  }, {
    default: withCtx(({ height: s, width: c }) => [
      createVNode(t.ElTableV2, mergeProps({ ref: "tableV2Ref" }, t.objPick(e.$props, t.accept), {
        "expanded-row-keys": t.expandedRowKeys$,
        "onUpdate:expandedRowKeys": o[0] || (o[0] = (d) => t.expandedRowKeys$ = d),
        "expand-column-key": n.schema[0].prop,
        data: t.tableData,
        columns: t.columns,
        width: c,
        height: s,
        "header-height": t.headerHeight$,
        "row-height": n.rowHeight,
        "scrollbar-always-on": !1,
        "cell-props": t.cellProps$,
        "row-class": t.rowClass$,
        "row-props": t.rowProps$,
        class: [
          n.tableClass,
          "alc-table-v2__root",
          t.hoverClass,
          { "alc-table--striped": n.stripe && !n.rowMerge && !n.colMerge },
          { border: n.border || !!n.colMerge || !!n.rowMerge }
        ],
        fixed: "",
        onScroll: t.onScroll
      }), createSlots({
        header: withCtx((d) => [
          renderSlot(e.$slots, "header", normalizeProps(guardReactiveProps(d)), () => [
            createVNode(t.MultiLevelHeader, normalizeProps(guardReactiveProps(d)), null, 16)
          ])
        ]),
        row: withCtx((d) => [
          renderSlot(e.$slots, "row", normalizeProps(guardReactiveProps(d)), () => [
            createVNode(t.Row, normalizeProps(guardReactiveProps(d)), null, 16)
          ])
        ]),
        empty: withCtx(() => [
          renderSlot(e.$slots, "empty", {}, () => [
            createElementVNode("div", _hoisted_1$d, [
              createVNode(t.ElEmpty)
            ])
          ])
        ]),
        _: 2
      }, [
        e.$slots.footer || n.showSummary ? {
          name: "footer",
          fn: withCtx(() => [
            renderSlot(e.$slots, "footer", {}, () => [
              createVNode(t.Footer, normalizeProps(guardReactiveProps({ column: t.columns, tableData: n.data })), null, 16)
            ])
          ]),
          key: "0"
        } : void 0,
        n.loading ? {
          name: "overlay",
          fn: withCtx(() => [
            withDirectives(createElementVNode("div", _hoisted_2$b, null, 512), [
              [l, n.loading]
            ])
          ]),
          key: "1"
        } : void 0
      ]), 1040, ["expanded-row-keys", "expand-column-key", "data", "columns", "width", "height", "header-height", "row-height", "class"]),
      createVNode(t.ElPopconfirm, mergeProps({
        visible: t.popVisible,
        "onUpdate:visible": o[1] || (o[1] = (d) => t.popVisible = d),
        width: "200px"
      }, t.popConfig, {
        trigger: "click",
        "virtual-triggering": ""
      }), null, 16, ["visible"])
    ]),
    _: 3
  }, 8, ["style", "class"]);
}
const ListV = /* @__PURE__ */ _export_sfc(_sfc_main$e, [["render", _sfc_render$e], ["__file", "list-v.vue"]]), AlcListV = withInstall(ListV), alcProcessTrackProps = {
  /**
   * 按钮 icon
   * @default 'ri-flow-chart'
   */
  icon: { type: String, default: "ri-flow-chart" },
  /**
   * 入口按钮标题
   * @description 文本优先 icon 显示，只支持显示四个字符
   */
  title: { type: String },
  /**
   * 指向的页面路径
   */
  url: { type: String },
  /**
   * 附加打印内容
   * @todo 未实现
   */
  extraHtmlContent: { type: String, default: "" },
  /**
   * 需要自定义流程触发入口
   */
  customEnter: { type: Boolean, default: !1 },
  /**
   * 需要移除的审核流程界面的按钮
   * @description 多个时逗号分隔
   */
  removeButtons: { type: String, default: "" }
}, _sfc_main$d = /* @__PURE__ */ defineComponent({
  name: "alc-process-track",
  inheritAttrs: !1,
  __name: "process-track",
  props: /* @__PURE__ */ mergeModels(alcProcessTrackProps, {
    visible: { type: Boolean },
    visibleModifiers: {}
  }),
  emits: /* @__PURE__ */ mergeModels(["cancel"], ["update:visible"]),
  setup(e, { expose: o }) {
    o();
    const n = e, t = useModel(e, "visible"), r = useProviderConfig("state"), { position: a } = U(), { doRemoveButtons: l } = E(), s = computed(() => n.title ? {
      class: "process-track--title",
      title: n.title,
      "data-first-title": n.title.slice(0, 2),
      "data-last-title": n.title.slice(2, 4)
    } : {
      class: n.icon
    }), c = window.location.origin, d = computed(() => n.url ? `${c + n.url}&${toQueryParams({
      cAccUuid: r.value.cAccUuid,
      Authorization: r.value.token
    }).slice(1)}` : ""), p = shallowRef();
    function f() {
      var I, v;
      (v = (I = p.value) == null ? void 0 : I.contentWindow) == null || v.postMessage({ type: "print" }, c);
    }
    let g = 0, b = 0, k = 0, x = 0, N = 0, O = 0, m;
    const ee = throttle((I) => {
      const v = I.clientX - g, M = I.clientY - b, $ = I.clientX + (N - I.offsetX) <= m.right && I.clientX - I.offsetX >= m.left, H = I.clientY + (O - I.offsetY) <= m.bottom && I.clientY - I.offsetY >= m.top;
      $ && (v < 0 ? a.x -= -v + k : v > 0 && (a.x = a.x + v - k), k = v), H && (M < 0 ? a.y -= -M + x : M > 0 && (a.y = a.y + M - x), x = M);
    }, 100);
    let z;
    const P = (I) => {
      z = Date.now(), I.stopPropagation();
      const v = document.querySelector(".layout-backtop");
      m = v == null ? void 0 : v.getBoundingClientRect(), k = 0, x = 0, g = I.clientX, b = I.clientY, { clientWidth: N, clientHeight: O } = I.currentTarget, document.addEventListener("mousemove", ee, {
        passive: !0
      }), document.addEventListener(
        "mouseup",
        () => {
          document.removeEventListener("mousemove", ee);
        },
        { capture: !0, once: !0 }
      );
    }, V = () => {
      Date.now() - z < 500 && (t.value = !0);
    };
    function U() {
      let $ = 0;
      eventEmit(ALC_PROCESS_TRACK_COUNT, 1), eventOn(ALC_PROCESS_TRACK_COUNT, (X) => {
        $ += X, H.y = -90 - 50 * $;
      });
      const H = reactive({
        x: -40,
        y: -90
      });
      return {
        position: H
      };
    }
    function E() {
      const I = new MutationObserver((M) => {
        var H;
        const $ = n.removeButtons.split(",");
        for (const X of M)
          for (const te of X.addedNodes) {
            const oe = ((H = te.textContent) == null ? void 0 : H.trim()) || "";
            $.some((ne) => oe === ne) && te.parentNode.removeChild(te);
          }
      });
      function v() {
        var $, H;
        if (!n.removeButtons)
          return;
        const M = (H = ($ = p.value) == null ? void 0 : $.contentDocument) == null ? void 0 : H.querySelector(
          ".panel-heading.fixheader > div"
        );
        M && (M.setAttribute(
          "data-remove-buttons",
          n.removeButtons
        ), I.observe(M, {
          attributes: !1,
          subtree: !1,
          childList: !0
        }));
      }
      return onBeforeUnmount(() => {
        I.disconnect();
      }), {
        doRemoveButtons: v
      };
    }
    const C = { props: n, dialogVisible: t, coreState: r, position: a, doRemoveButtons: l, buttonTips: s, origin: c, iframeSrc: d, iframeRef: p, print: f, get dictX() {
      return g;
    }, set dictX(I) {
      g = I;
    }, get dictY() {
      return b;
    }, set dictY(I) {
      b = I;
    }, get lastOffsetX() {
      return k;
    }, set lastOffsetX(I) {
      k = I;
    }, get lastOffsetY() {
      return x;
    }, set lastOffsetY(I) {
      x = I;
    }, get clientWidth() {
      return N;
    }, set clientWidth(I) {
      N = I;
    }, get clientHeight() {
      return O;
    }, set clientHeight(I) {
      O = I;
    }, get wrapBounding() {
      return m;
    }, set wrapBounding(I) {
      m = I;
    }, onMousemove: ee, get time() {
      return z;
    }, set time(I) {
      z = I;
    }, onMousedown: P, onMouseup: V, useCascadePosition: U, useRemoveButtons: E, get AlcDialog() {
      return AlcDialog;
    }, get ElButton() {
      return ElButton;
    } };
    return Object.defineProperty(C, "__isScriptSetup", { enumerable: !1, value: !0 }), C;
  }
}), _hoisted_1$c = ["src"];
function _sfc_render$d(e, o, n, t, r, a) {
  return openBlock(), createElementBlock(Fragment, null, [
    t.iframeSrc && !e.customEnter ? (openBlock(), createBlock(t.ElButton, mergeProps({
      key: 0,
      style: {
        transform: `translate3d(${t.position.x}px, ${t.position.y}px, 0)`
      }
    }, t.buttonTips, {
      size: "large",
      type: "primary",
      plain: "",
      circle: "",
      class: "alc-component-process-track",
      onMousedown: t.onMousedown,
      onMouseup: t.onMouseup
    }), null, 16, ["style"])) : createCommentVNode("", !0),
    createVNode(t.AlcDialog, {
      modelValue: t.dialogVisible,
      "onUpdate:modelValue": o[1] || (o[1] = (l) => t.dialogVisible = l),
      title: "审核流程",
      fullscreen: "",
      "width-type": "lg",
      "confirm-button-text": "打印",
      draggable: "",
      "content-height-fit": "",
      onConfirm: t.print,
      onCancel: o[2] || (o[2] = (l) => e.$emit("cancel"))
    }, {
      default: withCtx(() => [
        createElementVNode("iframe", {
          ref: "iframeRef",
          src: t.iframeSrc,
          onLoad: o[0] || (o[0] = (...l) => t.doRemoveButtons && t.doRemoveButtons(...l)),
          style: { width: "100%", "min-height": "360px", height: "100%", border: "0", "object-position": "50% 50%", "object-fit": "scale-down" }
        }, null, 40, _hoisted_1$c)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64);
}
const ProcessTrack = /* @__PURE__ */ _export_sfc(_sfc_main$d, [["render", _sfc_render$d], ["__file", "process-track.vue"]]), AlcProcessTrack = withInstall(ProcessTrack), alcQuickKeyboardProps = {
  /**
   * 输入绑定值点击空格时是否允许插入空格
   * @default false
   */
  insertSpace: { type: Boolean, default: !1 },
  /**
   * 键盘模式
   * @enum full 全键盘
   * @enum number 数字键盘
   * @default full
   */
  type: {
    type: String,
    default: "full"
  },
  /**
   * 混淆键盘布局
   * @default false
   */
  confuse: { type: Boolean, default: !1 },
  /**
   * 快捷键盘参照元素，点击该元素保持 keyboard 显示
   */
  referenceEl: { type: Object },
  /**
   * 键盘按钮基准宽度
   * @default 54
   */
  keyWidth: { type: Number, default: 54 }
}, _sfc_main$c = /* @__PURE__ */ defineComponent({
  name: "alc-quick-keyboard",
  inheritAttrs: !1,
  __name: "quick-keyboard",
  props: /* @__PURE__ */ mergeModels(alcQuickKeyboardProps, {
    visible: {
      default: !1
    },
    visibleModifiers: {},
    modelValue: {
      default: ""
    },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ mergeModels(["enter", "hide"], ["update:visible", "update:modelValue"]),
  setup(e, { expose: o, emit: n }) {
    o();
    const t = e, r = n, a = useModel(e, "visible"), l = useModel(e, "modelValue"), s = [
      "` ~",
      "1 !",
      "2 @",
      "3 #",
      "4 $",
      "5 %",
      "6 ^",
      "7 &",
      "8 *",
      "9 (",
      "0 )",
      "- _",
      "= +"
    ], c = [
      "q Q",
      "w W",
      "e E",
      "r R",
      "t T",
      "y Y",
      "u U",
      "i I",
      "o O",
      "p P"
    ], d = [
      "a A",
      "s S",
      "d D",
      "f F",
      "g G",
      "h H",
      "j J",
      "k K",
      "l L"
    ], p = ["z Z", "x X", "c C", "v V", "b B", "n N", "m M"], f = computed(() => {
      let [P, V, U, E] = [
        s,
        c,
        d,
        p
      ];
      return t.confuse && ([P, V, U, E] = [
        s,
        c,
        d,
        p
      ].map((C) => [...C].sort(() => 0.5 - Math.random()))), [
        ["esc", ...P, "Delete"],
        ["Tab", ...V, "[ {", "] }", "\\ |"],
        ["CapsLock", ...U, "; :", `' "`, "Enter"],
        ["Shift", ...E, ", <", ". >", "/ ?", "Shift"],
        ["Space"]
      ];
    }), g = new Proxy(
      {
        "*": 1,
        "\\ |": 1.5,
        Delete: 2.5,
        Tab: 1.5,
        CapsLock: 2.5,
        Enter: 2.6,
        Shift: 3,
        Space: 9
      },
      {
        get(P, V) {
          return Object.hasOwn(g, V) ? Reflect.get(P, V) : Reflect.get(P, "*");
        }
      }
    ), b = (P) => {
      const V = P.codePointAt(0);
      return V >= 97 && V <= 122;
    }, k = Math.max(
      ...f.value.map((P) => P.reduce((V, U) => V + g[U] * t.keyWidth, 0))
    ), x = ref(!1), N = ref(!1), O = {
      esc: () => {
        a.value = !1, r("hide");
      },
      Enter: () => {
        a.value = !1, r("enter", l.value), r("hide");
      },
      Shift: () => {
        x.value = !x.value;
      },
      Delete: () => {
        l.value = l.value.slice(0, -1);
      },
      Tab: () => {
        l.value += "	";
      },
      CapsLock: () => {
        N.value = !N.value;
      },
      Space: () => {
        t.insertSpace && (l.value += " ");
      }
    }, z = { props: t, emits: r, isVisible: a, value: l, oneLine: s, twoLine: c, threeLine: d, fourLine: p, layout: f, spans: g, canUpperCase: b, maxLength: k, shiftKeyDown: x, capsLockKeyDown: N, commandKeyEvent: O, disposeBindKey: (P) => {
      if (Object.hasOwn(O, P))
        O[P]();
      else {
        const [V, U] = P.split(" ");
        x.value || N.value && b(V) ? l.value += U : l.value += V;
      }
    }, hideKeyboardPanel: (P) => {
      (P.path || P.composedPath && P.composedPath()).includes(t.referenceEl) || a.value && (a.value = !1, r("hide"));
    }, get vClickOutside() {
      return ClickOutside;
    } };
    return Object.defineProperty(z, "__isScriptSetup", { enumerable: !1, value: !0 }), z;
  }
}), _hoisted_1$b = ["onClick"], _hoisted_2$a = ["data-id", "onClick"];
function _sfc_render$c(e, o, n, t, r, a) {
  return openBlock(), createBlock(Teleport, { to: "body" }, [
    createVNode(Transition$1, {
      name: "el-zoom-in-bottom",
      mode: "out-in"
    }, {
      default: withCtx(() => [
        withDirectives((openBlock(), createElementBlock("div", mergeProps({ class: "keyboard-container" }, e.$attrs, {
          style: { width: `${t.maxLength}px` }
        }), [
          (openBlock(!0), createElementBlock(Fragment, null, renderList(t.layout, (l, s) => (openBlock(), createElementBlock("div", {
            key: s,
            style: normalizeStyle({
              "justify-content": l.length === 1 ? "center" : "flex-start"
            }),
            class: "keyboard-line"
          }, [
            (openBlock(!0), createElementBlock(Fragment, null, renderList(l, (c, d) => (openBlock(), createElementBlock(Fragment, null, [
              ~c.search(" ") ? (openBlock(), createElementBlock("button", {
                key: `${d}_else`,
                style: normalizeStyle({ width: `${t.spans[c] * e.keyWidth}px` }),
                "data-id": c[2],
                class: normalizeClass([
                  t.canUpperCase(c[0]) ? "" : "keyboard-key__extra",
                  "keyboard-key"
                ]),
                onClick: (p) => t.disposeBindKey(c)
              }, toDisplayString$1(t.canUpperCase(c[0]) && t.capsLockKeyDown ? c[2] : c[0]), 15, _hoisted_2$a)) : (openBlock(), createElementBlock("button", {
                key: d,
                style: normalizeStyle({ width: `${t.spans[c] * e.keyWidth}px` }),
                class: normalizeClass([{
                  "keyboard-key-active": c === "Shift" && t.shiftKeyDown || c === "CapsLock" && t.capsLockKeyDown
                }, "keyboard-key"]),
                onClick: (p) => t.disposeBindKey(c)
              }, toDisplayString$1(c), 15, _hoisted_1$b))
            ], 64))), 256))
          ], 4))), 128))
        ], 16)), [
          [vShow, t.isVisible],
          [t.vClickOutside, t.hideKeyboardPanel]
        ])
      ]),
      _: 1
    })
  ]);
}
const QuickKeyboard = /* @__PURE__ */ _export_sfc(_sfc_main$c, [["render", _sfc_render$c], ["__file", "quick-keyboard.vue"]]), AlcQuickKeyboard = withInstall(QuickKeyboard), _sfc_main$b = defineComponent({
  name: "report-set-group",
  components: {
    Draggable,
    ElButton
  },
  props: {
    // 分组属性数据对象 默认：{}
    property: {
      type: Object,
      default() {
        return {};
      }
    },
    // 分组顺序数据集合 默认：[]
    order: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  emits: ["group-click", "group-unchoose", "group-change", "group-delete"],
  setup(e, o) {
    const n = reactive({
      // 分组设置属性数据对象
      reportGroupSetProperty: {},
      // 分组设置序列数据集合
      reportGroupSetOrder: []
    });
    onMounted(() => {
      r();
    }), onUnmounted(() => {
      n.reportGroupSetProperty = {}, n.reportGroupSetOrder = [];
    });
    function t(k) {
      return isArray(k.children) ? "alc-cpt-reportset-group-class" : "alc-cpt-reportset-item-class";
    }
    function r() {
      n.reportGroupSetProperty = isEmptyObject(e.property) ? {} : e.property, n.reportGroupSetOrder = isArray(e.order) && e.order.length > 0 ? e.order : [];
    }
    function a() {
      if (f(
        n.reportGroupSetOrder
      ) === 4) {
        operatorErrorTip("分组数量已达上限");
        return;
      }
      const N = `uuid${getUTCTimeStamp()}`;
      n.reportGroupSetOrder.unshift({
        uuid: N,
        children: []
      }), n.reportGroupSetProperty[N] = {
        bOccupyColumn: !1,
        bCount: !1,
        cName: "新建分组",
        cByFields: "",
        cCountFields: ""
      }, o.emit("group-change", {
        groupOrder: n.reportGroupSetOrder,
        groupProperty: n.reportGroupSetProperty
      });
    }
    function l(k, x) {
      if (isArray(k.children) && k.children.length > 1) {
        operatorErrorTip("分组不为空，请先移除子分组");
        return;
      }
      delete n.reportGroupSetProperty[k.uuid], n.reportGroupSetOrder.splice(x, 1), isEmptyObject(n.reportGroupSetOrder[x]) || s(n.reportGroupSetOrder[x]), o.emit("group-change", {
        groupOrder: n.reportGroupSetOrder,
        groupProperty: n.reportGroupSetProperty
      });
    }
    function s(k) {
      o.emit("group-click", {
        uuid: k.uuid,
        occupyColumn: n.reportGroupSetProperty[k.uuid].bOccupyColumn,
        count: n.reportGroupSetProperty[k.uuid].bCount,
        name: n.reportGroupSetProperty[k.uuid].cName,
        byFields: n.reportGroupSetProperty[k.uuid].cByFields,
        countFields: n.reportGroupSetProperty[k.uuid].cCountFields
      });
    }
    function c(k) {
      o.emit("group-click", k);
    }
    function d() {
      o.emit("group-unchoose");
    }
    function p() {
      o.emit("group-change", {
        groupOrder: n.reportGroupSetOrder,
        groupProperty: n.reportGroupSetProperty
      });
    }
    function f(k) {
      let x = 0;
      return k.forEach((N) => {
        x++, N.children.length > 0 && (x += f(N.children));
      }), x;
    }
    function g(k) {
      return isArray(k) ? k.length === 0 ? !0 : k.length > 1 ? !1 : !(k[0].children.length > 0 && !g(k[0].children)) : !1;
    }
    function b() {
      return g(n.reportGroupSetOrder);
    }
    return {
      ...toRefs$1(n),
      isArray,
      reportItemClass: t,
      updateData: r,
      addGroup: a,
      deleteGroup: l,
      editGroup: s,
      editSubGroup: c,
      onListUnChoose: d,
      onListSortChange: p,
      checkGroupOrder: b
    };
  }
}), _hoisted_1$a = {
  class: "flex alc-cpt-reportset-info-container",
  style: { "background-color": "#fff" }
}, _hoisted_2$9 = /* @__PURE__ */ createElementVNode("div", { class: "alc-cpt-reportset-info-handle" }, [
  /* @__PURE__ */ createElementVNode("i", {
    class: "ri-arrow-up-down-line report-groupset-edit-handle",
    title: "拖放排序"
  })
], -1), _hoisted_3$9 = ["onClick"];
function _sfc_render$b(e, o, n, t, r, a) {
  const l = resolveComponent("ElButton"), s = resolveComponent("report-set-group", !0), c = resolveComponent("Draggable");
  return openBlock(), createBlock(c, {
    animation: "200",
    "ghost-class": "drag-ghost",
    handle: ".report-groupset-edit-handle",
    "item-key": "uuid",
    tag: "div",
    group: "reportGroupSet",
    class: "draggable-box",
    "data-empty-text": "拖拽栏目至此处",
    list: e.reportGroupSetOrder,
    "force-fallback": !0,
    disabled: !1,
    onUnchoose: e.onListUnChoose,
    onSort: e.onListSortChange
  }, {
    item: withCtx(({ element: d, index: p }) => [
      e.reportGroupSetProperty[d.uuid] ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(e.reportItemClass(d))
      }, [
        createElementVNode("div", _hoisted_1$a, [
          _hoisted_2$9,
          createElementVNode("div", {
            class: "alc-cpt-reportset-info-name",
            onClick: (f) => e.editGroup(d)
          }, toDisplayString$1(e.reportGroupSetProperty[d.uuid].cName), 9, _hoisted_3$9),
          d.children ? (openBlock(), createBlock(l, {
            key: 0,
            class: "ri-delete-bin-3-line delete-handle",
            title: "删除",
            type: "danger",
            link: "",
            onClick: (f) => e.deleteGroup(d, p)
          }, null, 8, ["onClick"])) : createCommentVNode("", !0)
        ]),
        d.children ? (openBlock(), createBlock(s, {
          key: 0,
          property: e.reportGroupSetProperty,
          order: d.children,
          onGroupClick: e.editSubGroup
        }, null, 8, ["property", "order", "onGroupClick"])) : createCommentVNode("", !0)
      ], 2)) : createCommentVNode("", !0)
    ]),
    _: 1
  }, 8, ["list", "onUnchoose", "onSort"]);
}
const ReportSetGroup = /* @__PURE__ */ _export_sfc(_sfc_main$b, [["render", _sfc_render$b], ["__file", "report-set-group.vue"]]), _sfc_main$a = defineComponent({
  name: "report-set-item",
  components: {
    Draggable,
    ElButton,
    ElCheckbox
  },
  props: {
    // 栏目属性数据对象 默认：{}
    property: {
      type: Object,
      default() {
        return {};
      }
    },
    // 栏目顺序数据集合 默认：[]
    order: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  emits: ["column-click", "column-unchoose", "column-change"],
  setup(e, o) {
    const n = reactive({
      // 栏目设置属性数据对象
      reportItemSetProperty: {},
      // 栏目设置序列数据集合
      reportItemSetOrder: []
    });
    onMounted(() => {
      r();
    }), onUnmounted(() => {
      n.reportItemSetProperty = {}, n.reportItemSetOrder = [];
    });
    function t(f) {
      return isArray(f.children) ? "alc-cpt-reportset-group-class" : "alc-cpt-reportset-item-class";
    }
    function r() {
      n.reportItemSetProperty = isEmptyObject(e.property) ? {} : e.property, n.reportItemSetOrder = isArray(e.order) && e.order.length > 0 ? e.order : [];
    }
    function a() {
      const f = getUTCTimeStamp(), g = `uuid${f}`, b = `col${f}`;
      n.reportItemSetOrder.unshift({
        uuid: g,
        children: []
      }), n.reportItemSetProperty[g] = {
        bShow: !0,
        bGroupTitle: !0,
        cColumn: b,
        cShowName: "新建组标题",
        iWidth: 3,
        eTextAlign: "MiddleLeft"
      };
    }
    function l(f, g) {
      if (isArray(f.children) && f.children.length > 1) {
        operatorErrorTip("标题组不为空，请先移除子栏目");
        return;
      }
      delete n.reportItemSetProperty[f.uuid], n.reportItemSetOrder.splice(g, 1), isEmptyObject(n.reportItemSetOrder[g]) || s(n.reportItemSetOrder[g]);
    }
    function s(f) {
      o.emit("column-click", {
        uuid: f.uuid,
        show: n.reportItemSetProperty[f.uuid].bShow,
        groupTitle: n.reportItemSetProperty[f.uuid].bGroupTitle,
        column: n.reportItemSetProperty[f.uuid].cColumn,
        showName: n.reportItemSetProperty[f.uuid].cShowName,
        width: n.reportItemSetProperty[f.uuid].iWidth,
        textAlign: n.reportItemSetProperty[f.uuid].eTextAlign
      });
    }
    function c(f) {
      o.emit("column-click", f);
    }
    function d() {
      o.emit("column-unchoose");
    }
    function p() {
      o.emit("column-change");
    }
    return {
      ...toRefs$1(n),
      isArray,
      reportItemClass: t,
      updateData: r,
      addColumnGroup: a,
      deleteColumnGroup: l,
      editColumnItem: s,
      editSubColumnItem: c,
      onListUnChoose: d,
      onListSortChange: p
    };
  }
}), _hoisted_1$9 = { class: "flex alc-cpt-reportset-info-container" }, _hoisted_2$8 = /* @__PURE__ */ createElementVNode("div", { class: "alc-cpt-reportset-info-handle" }, [
  /* @__PURE__ */ createElementVNode("i", {
    class: "ri-arrow-up-down-line report-itemset-edit-handle",
    title: "拖放排序"
  })
], -1), _hoisted_3$8 = ["onClick"];
function _sfc_render$a(e, o, n, t, r, a) {
  const l = resolveComponent("ElCheckbox"), s = resolveComponent("ElButton"), c = resolveComponent("report-set-item", !0), d = resolveComponent("Draggable");
  return openBlock(), createBlock(d, {
    animation: "200",
    "ghost-class": "drag-ghost",
    handle: ".report-itemset-edit-handle",
    "item-key": "uuid",
    tag: "div",
    group: "reportItemSet",
    class: "draggable-box",
    "data-empty-text": "拖拽栏目至此处",
    list: e.reportItemSetOrder,
    "force-fallback": !0,
    disabled: !1,
    onUnchoose: e.onListUnChoose,
    onSort: e.onListSortChange
  }, {
    item: withCtx(({ element: p, index: f }) => [
      e.reportItemSetProperty[p.uuid] ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(e.reportItemClass(p))
      }, [
        createElementVNode("div", _hoisted_1$9, [
          _hoisted_2$8,
          createVNode(l, {
            modelValue: e.reportItemSetProperty[p.uuid].bShow,
            "onUpdate:modelValue": (g) => e.reportItemSetProperty[p.uuid].bShow = g,
            label: e.reportItemSetProperty[p.uuid].cShowName,
            class: "alc-cpt-reportset-info-show",
            onChange: (g) => e.editColumnItem(p)
          }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onChange"]),
          createElementVNode("div", {
            style: { "flex-grow": "1", height: "30px", cursor: "pointer" },
            onClick: (g) => e.editColumnItem(p)
          }, null, 8, _hoisted_3$8),
          p.children ? (openBlock(), createBlock(s, {
            key: 0,
            class: "ri-delete-bin-3-line delete-handle",
            type: "danger",
            link: "",
            title: "删除",
            onClick: (g) => e.deleteColumnGroup(p, f)
          }, null, 8, ["onClick"])) : createCommentVNode("", !0)
        ]),
        p.children ? (openBlock(), createBlock(c, {
          key: 0,
          ref: "subColumnItemHandle",
          property: e.reportItemSetProperty,
          order: p.children,
          onColumnClick: e.editSubColumnItem
        }, null, 8, ["property", "order", "onColumnClick"])) : createCommentVNode("", !0)
      ], 2)) : createCommentVNode("", !0)
    ]),
    _: 1
  }, 8, ["list", "onUnchoose", "onSort"]);
}
const ReportSetItem = /* @__PURE__ */ _export_sfc(_sfc_main$a, [["render", _sfc_render$a], ["__file", "report-set-item.vue"]]), _sfc_main$9 = defineComponent({
  name: "alc-report-set",
  components: {
    AlcTooltip,
    AlcDialogFooter,
    AlcForm,
    ElCard,
    ElScrollbar,
    ElRadioGroup,
    ElRadioButton,
    ElButton,
    ElFormItem,
    ReportSetGroup,
    ReportSetItem,
    AlcSelect,
    AlcInputNumber,
    AlcInput
  },
  props: {
    // 报表模板UUID 默认：''
    uuid: { type: String, required: !0, default: "" },
    // 报表模板编码 默认：''
    code: { type: String, required: !0, default: "" }
  },
  emits: ["modalConfirm"],
  setup(e, o) {
    const n = useProviderConfig("state"), t = reactive({
      // 栏目设置组件操作句柄
      reportItemSetHandle: null,
      // 栏目设置滚动容器
      reportItemSetScrollbarHandle: null,
      // 分组设置组件操作句柄
      reportGroupSetHandle: null,
      // 分组设置滚动容器
      reportGroupSetScrollbarHandle: null,
      // 当前选择的方案类型标识 2:个人 3：组织
      planType: 2,
      // 栏目设置loading标识
      itemSetLoading: !0,
      // 分组设置loading标识
      groupSetLoading: !0,
      // 保存设置按钮loading标识
      saveSchemeLoading: !1,
      // 栏目设置文本对齐方式枚举
      textAlignMenu: [
        { value: "TopLeft", label: "左上对齐" },
        { value: "TopCenter", label: "中上对齐" },
        { value: "TopRight", label: "右上对齐" },
        { value: "MiddleLeft", label: "左中对齐" },
        { value: "MiddleCenter", label: "中中对齐" },
        { value: "MiddleRight", label: "右中对齐" },
        { value: "BottomLeft", label: "左下对齐" },
        { value: "BottomCenter", label: "中下对齐" },
        { value: "BottomRight", label: "右下对齐" },
        { value: "TopJustiy", label: "两端上对齐" },
        { value: "MiddleJustiy", label: "两端中对齐" },
        { value: "BottomJustiy", label: "两端下对齐" }
      ],
      // 栏目设置数据对象
      itemSetData: {
        itemOrder: [],
        itemProperty: {}
      },
      // 分组设置数据对象
      groupSetData: {
        groupFields: [],
        groupOrder: [],
        groupProperty: {}
      },
      // 当前选择的栏目节点
      currentChooseItem: {
        // 栏目uuid
        uuid: "#",
        // 是否显示
        show: !0,
        // 是否栏目组
        groupTitle: !1,
        // 栏目字段属性名称
        column: "",
        // 栏目显示名称
        showName: "",
        // 栏目列宽度
        width: 0,
        // 栏目文本对齐方式
        textAlign: "TopLeft"
      },
      // 当前选中的分组表单实例
      currentChooseFormRef: null,
      // 当前选择的分组节点
      currentChooseGroup: {
        // 分组uuid
        uuid: "#",
        // 是否合并列
        occupyColumn: !1,
        // 是否合计
        count: !1,
        // 分组名称
        name: "",
        // 分组依据字段
        byFields: "",
        // 合计列字段
        countFields: ""
      },
      // 分组依据枚举项集合
      groupFieldMenu: [],
      // 分组合计枚举项集合
      groupCountMenu: []
      // currentConfig: '1',
      // currentConfigItem: 'column',
      // tabPanels: [{ label: '默认设置', name: '1', closable: false }],
      // candidateConfig: '',
      // candidateList: [
      //     { label: '组织设置', value: '3', disabled: false },
      //     { label: '个人设置', value: '2', disabled: false },
      // ],
    }), r = computed(() => [
      {
        itemType: "input",
        label: "分组名称",
        prop: "name",
        maxlength: 10,
        onChange: V
      },
      {
        itemType: "checkbox",
        label: "分组合并",
        prop: "occupyColumn",
        span: 12,
        onChange: V
      },
      {
        itemType: "checkbox",
        label: "分组合计",
        prop: "count",
        span: 12,
        onChange: V
      },
      {
        itemType: "select",
        label: "分组依据",
        prop: "byFields",
        options: t.groupFieldMenu,
        multiple: !0,
        onMounted: s,
        onRefresh: s,
        onChange: V
      },
      {
        itemType: "select",
        label: "合计字段",
        prop: "countFields",
        options: t.groupCountMenu,
        disabled: !t.currentChooseGroup.count,
        multiple: !0,
        onRefresh: s,
        onChange: V
      }
    ]), { close: a } = useDialogState();
    l();
    function l() {
      t.itemSetLoading = !0, t.groupSetLoading = !0, d().then((U) => {
        U.code === 1 && !isEmptyObject(U.data) && (b(U.data.columnSetData), k(U.data.groupSetData));
      }).catch(() => {
        apiLinkErrorTip("报表设置获取");
      }).finally(() => {
        t.itemSetLoading = !1, t.groupSetLoading = !1;
      });
    }
    function s() {
      t.currentChooseFormRef.refs.byFields.setRefreshLoad(!0), t.currentChooseFormRef.refs.countFields.setRefreshLoad(!0), g().then((U) => {
        t.groupSetData.groupFields = [], U.code === 1 && isArray(U.data) && (t.groupSetData.groupFields = U.data);
        const E = t.groupSetData.groupFields;
        t.groupFieldMenu = [], t.groupCountMenu = [], E.forEach((C) => {
          t.groupFieldMenu.push({
            value: C.cDataField,
            label: C.cText
          }), ["Integer", "Float", "Currency"].includes(
            C.cType
          ) && t.groupCountMenu.push({
            value: C.cDataField,
            label: C.cText
          });
        });
      }).catch(() => {
        ElMessage.error("分组设置基础字段获取服务链接失败");
      }).finally(() => {
        t.currentChooseFormRef.refs.byFields.setRefreshLoad(
          !1
        ), t.currentChooseFormRef.refs.countFields.setRefreshLoad(
          !1
        );
      });
    }
    function c() {
      const U = t.planType === 3 ? "确认删除组织报表设置？" : "确认删除个人报表设置？";
      openConfirm(U, {}, (E) => {
        E.action === "confirm" && f().then((C) => {
          C.code === 1 ? (ElMessage.success("报表设置删除完成"), k({}), l(), o.emit("modalConfirm", {})) : operatorErrorTip(C.msg);
        }).catch(() => {
          apiLinkErrorTip("报表设置删除服务链接失败");
        });
      });
    }
    function d() {
      const {
        cAccUuid: U,
        cPersonUuid: E,
        cOrgUuid: C
      } = n.value;
      return msPost(
        `alc-public-framework/ReportConfigAction/getConfig/${e.uuid}`,
        {
          cAccUniqueId: U,
          cOrgUuid: C,
          cPersonUuid: t.planType === 2 ? E : void 0
        }
      );
    }
    function p() {
      const {
        cAccUuid: U,
        cPersonUuid: E,
        cOrgUuid: C
      } = n.value;
      return msPost(
        "alc-public-framework/ReportConfigAction/saveConfig",
        {
          cTemplateUuid: e.uuid,
          columnSetData: {
            cConfigUuid: e.uuid,
            iType: t.planType,
            cAccUniqueId: U,
            cPersonUuid: E,
            cOrgUuid: C,
            orderObj: t.itemSetData.itemOrder,
            dataMap: t.itemSetData.itemProperty
          },
          groupSetData: {
            cConfigUuid: e.uuid,
            iType: t.planType,
            cAccUniqueId: U,
            cPersonUuid: E,
            cOrgUuid: C,
            orderObj: t.groupSetData.groupOrder,
            dataMap: t.groupSetData.groupProperty
          }
        }
      );
    }
    function f() {
      const { cAccUuid: U, cPersonUuid: E, cOrgUuid: C } = n.value;
      return msPost(
        `alc-public-framework/ReportConfigAction/deleteConfig/${e.uuid}/${t.planType}/${U}/${C}/${E}/0`
      );
    }
    function g() {
      return msPost(
        `alc-public-framework/ReportTemplateAction/getColumnList/${e.uuid}`
      );
    }
    function b(U) {
      isEmptyObject(U) ? (t.itemSetData.itemOrder = [], t.itemSetData.itemProperty = {}, t.currentChooseItem = {
        uuid: "#",
        show: !0,
        groupTitle: !1,
        column: "",
        showName: "",
        width: 0,
        textAlign: "TopLeft"
      }) : (t.itemSetData.itemOrder = U.orderObj, t.itemSetData.itemProperty = U.dataMap), nextTick(() => {
        t.reportItemSetHandle.updateData(), t.itemSetData.itemOrder.length > 0 && t.reportItemSetHandle.editColumnItem(
          t.itemSetData.itemOrder[0],
          0
        );
      });
    }
    function k(U) {
      isEmptyObject(U) ? (t.groupSetData.groupOrder = [], t.groupSetData.groupProperty = {}, t.currentChooseGroup = {
        uuid: "#",
        occupyColumn: !1,
        count: !1,
        name: "",
        byFields: "",
        countFields: ""
      }) : (t.groupSetData.groupOrder = U.orderObj, t.groupSetData.groupProperty = U.dataMap), nextTick(() => {
        t.reportGroupSetHandle.updateData(), t.groupSetData.groupOrder.length > 0 && t.reportGroupSetHandle.editGroup(
          t.groupSetData.groupOrder[0],
          0
        );
      });
    }
    function x() {
      if (!t.reportGroupSetHandle.checkGroupOrder()) {
        operatorErrorTip("同级分组只能有一个，请调整分组层级");
        return;
      }
      t.saveSchemeLoading = !0, p().then((U) => {
        U.code === 1 ? (o.emit("modalConfirm", {}), a(), ElMessage.success("条件设置保存完成")) : operatorErrorTip(U.msg);
      }).catch(() => {
        apiLinkErrorTip("报表设置保存");
      }).finally(() => {
        t.saveSchemeLoading = !1;
      });
    }
    function N() {
      t.reportItemSetHandle.addColumnGroup(), t.reportItemSetScrollbarHandle.setScrollTop(0);
    }
    function O(U) {
      t.currentChooseItem = {
        uuid: U.uuid,
        show: U.show,
        groupTitle: U.groupTitle,
        column: U.column,
        showName: U.showName,
        width: U.width,
        textAlign: U.textAlign
      };
    }
    function m() {
      t.currentChooseItem.uuid !== "#" && (t.itemSetData.itemProperty[t.currentChooseItem.uuid] = {
        bGroupTitle: t.currentChooseItem.groupTitle,
        bShow: t.currentChooseItem.show,
        cColumn: t.currentChooseItem.column,
        cShowName: t.currentChooseItem.showName,
        eTextAlign: t.currentChooseItem.textAlign,
        iWidth: t.currentChooseItem.width
      });
    }
    function ee() {
      t.reportGroupSetHandle.addGroup(), t.reportGroupSetScrollbarHandle.setScrollTop(0);
    }
    function z(U) {
      t.currentChooseGroup = {
        uuid: U.uuid,
        occupyColumn: U.occupyColumn,
        count: U.count,
        name: U.name,
        byFields: U.byFields,
        countFields: U.countFields
      };
    }
    function P(U) {
      let E = {};
      (U.groupOrder.length > 0 || !isEmptyObject(U.groupProperty)) && (E = {
        orderObj: U.groupOrder,
        dataMap: U.groupProperty
      }), k(E);
    }
    function V() {
      t.currentChooseGroup.uuid !== "#" && (t.groupSetData.groupProperty[t.currentChooseGroup.uuid] = {
        bOccupyColumn: t.currentChooseGroup.occupyColumn,
        bCount: t.currentChooseGroup.count,
        cName: t.currentChooseGroup.name,
        cByFields: t.currentChooseGroup.byFields,
        cCountFields: t.currentChooseGroup.countFields
      });
    }
    return {
      ...toRefs$1(t),
      operationSchema: r,
      deleteScheme: c,
      btnClickOK: x,
      onPlanTypeChange: l,
      onAddColumnGroupClick: N,
      onColumnItemClick: O,
      onColumnPropertyChange: m,
      onAddGroupClick: ee,
      onGroupItemClick: z,
      onGroupItemChange: P
    };
  }
}), _hoisted_1$8 = { class: "alc-component-reportset-container" }, _hoisted_2$7 = { class: "flex alc-cpt-reportset" }, _hoisted_3$7 = {
  class: "flex",
  style: { width: "auto", "align-items": "center", "margin-left": "20px" }
}, _hoisted_4$7 = { class: "flex alc-cpt-reportset-main" }, _hoisted_5$6 = { class: "flex w100 cpt-card-header" }, _hoisted_6$5 = /* @__PURE__ */ createElementVNode("span", null, "栏目", -1), _hoisted_7$5 = { class: "flex w100 alc-cpt-columnset-container" }, _hoisted_8$5 = { class: "alc-cpt-columnset-list" }, _hoisted_9$5 = {
  key: 0,
  class: "h100 alc-cpt-columnset-operation"
}, _hoisted_10$4 = { class: "flex w100 cpt-card-header" }, _hoisted_11$3 = /* @__PURE__ */ createElementVNode("span", null, "分组", -1), _hoisted_12$2 = { class: "flex w100 alc-cpt-groupset-container" }, _hoisted_13$1 = { class: "alc-cpt-groupset-list" };
function _sfc_render$9(e, o, n, t, r, a) {
  const l = resolveComponent("ElRadioButton"), s = resolveComponent("ElRadioGroup"), c = resolveComponent("AlcTooltip"), d = resolveComponent("ElButton"), p = resolveComponent("ReportSetItem"), f = resolveComponent("ElScrollbar"), g = resolveComponent("AlcInput"), b = resolveComponent("ElFormItem"), k = resolveComponent("AlcInputNumber"), x = resolveComponent("AlcSelect"), N = resolveComponent("ElCard"), O = resolveComponent("ReportSetGroup"), m = resolveComponent("AlcForm"), ee = resolveComponent("AlcDialogFooter");
  return openBlock(), createElementBlock(Fragment, null, [
    createElementVNode("div", _hoisted_1$8, [
      createElementVNode("div", _hoisted_2$7, [
        createVNode(s, {
          modelValue: e.planType,
          "onUpdate:modelValue": o[0] || (o[0] = (z) => e.planType = z),
          onChange: e.onPlanTypeChange
        }, {
          default: withCtx(() => [
            createVNode(l, { value: 3 }, {
              default: withCtx(() => [
                createTextVNode("组织设置")
              ]),
              _: 1
            }),
            createVNode(l, { value: 2 }, {
              default: withCtx(() => [
                createTextVNode("个人设置")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "onChange"]),
        createElementVNode("div", _hoisted_3$7, [
          createVNode(c, {
            content: "<p>1、报表设置优先级：个人 > 组织</p><p>2、栏目设置只有标题组可以嵌套栏目</p><p>3、分组设置最多只能嵌套3层，同级分组只能有一个</p>",
            tabindex: null
          })
        ]),
        e.planType === 3 || e.planType === 2 ? (openBlock(), createBlock(d, {
          key: 0,
          text: "",
          class: "alc-cpt-reportset-delete",
          title: e.planType === 3 ? "删除组织设置" : "删除个人设置",
          onClick: withModifiers(e.deleteScheme, ["stop"])
        }, {
          default: withCtx(() => [
            createTextVNode(" 删除设置 ")
          ]),
          _: 1
        }, 8, ["title", "onClick"])) : createCommentVNode("", !0)
      ]),
      createElementVNode("div", _hoisted_4$7, [
        createVNode(N, {
          shadow: "never",
          class: "h100",
          style: { width: "470px" }
        }, {
          header: withCtx(() => [
            createElementVNode("div", _hoisted_5$6, [
              _hoisted_6$5,
              createVNode(d, {
                loading: e.itemSetLoading,
                text: "",
                onClick: e.onAddColumnGroupClick
              }, {
                default: withCtx(() => [
                  createTextVNode(" 添加标题组 ")
                ]),
                _: 1
              }, 8, ["loading", "onClick"])
            ])
          ]),
          default: withCtx(() => [
            createElementVNode("div", _hoisted_7$5, [
              createElementVNode("div", _hoisted_8$5, [
                createVNode(f, {
                  ref: "reportItemSetScrollbarHandle",
                  class: "w100 h100"
                }, {
                  default: withCtx(() => [
                    withDirectives(createVNode(p, {
                      ref: "reportItemSetHandle",
                      property: e.itemSetData.itemProperty,
                      order: e.itemSetData.itemOrder,
                      onColumnClick: e.onColumnItemClick,
                      onColumnUnchoose: o[1] || (o[1] = (z) => e.reportItemSetScrollbarHandle.update())
                    }, null, 8, ["property", "order", "onColumnClick"]), [
                      [vShow, !e.itemSetLoading]
                    ])
                  ]),
                  _: 1
                }, 512)
              ]),
              e.itemSetLoading ? createCommentVNode("", !0) : (openBlock(), createElementBlock("div", _hoisted_9$5, [
                createVNode(b, { label: "名称" }, {
                  default: withCtx(() => [
                    createVNode(g, {
                      modelValue: e.currentChooseItem.showName,
                      "onUpdate:modelValue": o[2] || (o[2] = (z) => e.currentChooseItem.showName = z),
                      maxlength: "6",
                      onChange: e.onColumnPropertyChange
                    }, null, 8, ["modelValue", "onChange"])
                  ]),
                  _: 1
                }),
                createVNode(b, { label: "宽度" }, {
                  default: withCtx(() => [
                    createVNode(k, {
                      modelValue: e.currentChooseItem.width,
                      "onUpdate:modelValue": o[3] || (o[3] = (z) => e.currentChooseItem.width = z),
                      min: 1,
                      onChange: e.onColumnPropertyChange
                    }, null, 8, ["modelValue", "onChange"])
                  ]),
                  _: 1
                }),
                createVNode(b, { label: "对齐" }, {
                  default: withCtx(() => [
                    createVNode(x, {
                      modelValue: e.currentChooseItem.textAlign,
                      "onUpdate:modelValue": o[4] || (o[4] = (z) => e.currentChooseItem.textAlign = z),
                      options: e.textAlignMenu,
                      onChange: e.onColumnPropertyChange
                    }, null, 8, ["modelValue", "options", "onChange"])
                  ]),
                  _: 1
                })
              ]))
            ])
          ]),
          _: 1
        }),
        createVNode(N, {
          shadow: "never",
          class: "h100",
          style: { width: "470px" }
        }, {
          header: withCtx(() => [
            createElementVNode("div", _hoisted_10$4, [
              _hoisted_11$3,
              createVNode(d, {
                loading: e.itemSetLoading,
                text: "",
                onClick: e.onAddGroupClick
              }, {
                default: withCtx(() => [
                  createTextVNode(" 添加分组 ")
                ]),
                _: 1
              }, 8, ["loading", "onClick"])
            ])
          ]),
          default: withCtx(() => [
            createElementVNode("div", _hoisted_12$2, [
              createElementVNode("div", _hoisted_13$1, [
                createVNode(f, {
                  ref: "reportGroupSetScrollbarHandle",
                  class: "w100 h100"
                }, {
                  default: withCtx(() => [
                    withDirectives(createVNode(O, {
                      ref: "reportGroupSetHandle",
                      property: e.groupSetData.groupProperty,
                      order: e.groupSetData.groupOrder,
                      onGroupClick: e.onGroupItemClick,
                      onGroupUnchoose: o[5] || (o[5] = (z) => e.reportGroupSetScrollbarHandle.update()),
                      onGroupChange: e.onGroupItemChange
                    }, null, 8, ["property", "order", "onGroupClick", "onGroupChange"]), [
                      [vShow, !e.itemSetLoading]
                    ])
                  ]),
                  _: 1
                }, 512)
              ]),
              e.itemSetLoading ? createCommentVNode("", !0) : (openBlock(), createBlock(m, {
                key: 0,
                ref: "currentChooseFormRef",
                modelValue: e.currentChooseGroup,
                "onUpdate:modelValue": o[6] || (o[6] = (z) => e.currentChooseGroup = z),
                schema: e.operationSchema,
                column: 1,
                "same-label": ""
              }, null, 8, ["modelValue", "schema"]))
            ])
          ]),
          _: 1
        })
      ])
    ]),
    createVNode(ee, null, {
      default: withCtx(() => [
        createVNode(d, {
          type: "primary",
          loading: e.saveSchemeLoading,
          onClick: e.btnClickOK
        }, {
          default: withCtx(() => [
            createTextVNode(" 保存设置 ")
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ]),
      _: 1
    })
  ], 64);
}
const AlcReportSet = /* @__PURE__ */ _export_sfc(_sfc_main$9, [["render", _sfc_render$9], ["__file", "report-set.vue"]]), _sfc_main$8 = defineComponent({
  name: "alc-report",
  directives: {
    loadOn
  },
  components: {
    ElScrollbar,
    ElButton,
    ElPagination,
    AlcDialog,
    AlcReportSet,
    ElInputNumber
  },
  props: {
    // 布局方案编码 默认：''
    code: { type: String, required: !0, default: "" },
    // 每页条数  默认：50
    pagesize: { type: Number, default: 50 },
    // 数据总条数  默认：0
    total: { type: Number, default: 0 },
    // 组件唯一ID 默认：''
    uid: { type: String, default: "" },
    // 是否显示翻页 默认：true
    pagination: { type: Boolean, default: !0 },
    // 是否初始化模板数据 默认：true
    init: { type: Boolean, default: !0 },
    // 是否交叉表 默认：false
    crosstab: { type: Boolean, default: !1 },
    // 交叉表监听双击事件的单元格名称 默认：''
    crosstabcell: { type: String, default: "" }
  },
  emits: [
    "template-loaded",
    "template-reload",
    "row-dbclick",
    "cell-dbclick",
    "page-change",
    "size-change"
  ],
  setup(e, { emit: o }) {
    const n = useProviderConfig("state"), t = reactive({
      // 设置弹窗显隐状态
      dialogVisible: !1,
      // 操作句柄
      reportHandle: null,
      // 列属性设置操作句柄
      reportSetHandle: null,
      // 唯一标识
      reportUid: `${e.uid}_report_${(/* @__PURE__ */ new Date()).getTime()}`,
      // 报表容器高度
      referHeight: computed(() => t.isPagination === !0 ? "pagination-show" : "pagination-hidden"),
      // 报表组件初始化loading标识
      reportTemplateLoading: !1,
      // 报表翻页状态
      isPagination: computed(() => e.pagination !== !1),
      // 报表交叉状态
      isCrosstab: computed(() => e.crosstab === !0),
      // gridReport视图对象
      viewer: null,
      // gridReport表格对象
      report: null,
      // gridReport明细表格对象
      detailGrid: null,
      // gridReport记录集合
      recordSet: null,
      // 报表uuid
      reportUuid: "",
      // 报表主题uuid
      reportThemeUuid: "",
      // 报表类型，是否多选
      reportType: "",
      // 报表模板原始数据（json格式串）
      reportTemplate: "",
      // 报表数据
      reportData: {},
      // 当前页码
      currentPage: 1,
      // 每页条数（输入框设置）
      pageSize: 10,
      // 数据总条数
      dataTotal: e.total,
      // 默认分页选择数组
      defaultPageSizes: [10, 30, 50, 100, 500, 1e3],
      // 分页选择数组
      pageSizes: computed(() => {
        const v = [];
        let M = !1;
        return t.defaultPageSizes.forEach(($) => {
          t.pageSize < $ && v.indexOf(t.pageSize) === -1 && (v.push(t.pageSize), M = !0), t.pageSize === $ && (M = !0), v.push($);
        }), M === !1 && v.push(t.pageSize), v;
      })
    }), { open: r } = usePrintGrp(), { open: a } = useExportGrp();
    onPageVisit(() => {
      s().then(() => {
        e.init === !0 && b(), window.addEventListener("resize", l, {
          passive: !0
        });
      }).catch((v) => {
        console.log(v), apiLinkErrorTip("报表初始化");
      });
    }), onPageLeave(() => {
      window.removeEventListener("resize", l);
    });
    function l() {
      t.viewer && t.viewer.update();
    }
    function s() {
      return new Promise((v, M) => {
        try {
          t.viewer = window.rubylong.grhtml5.insertReportViewer(
            t.reportUid
          ), t.viewer.reportPrepared = !0, t.viewer.dataPrepared = !0, t.viewer.options.fixedHeaderFooter = !0, t.viewer.options.reportFitWidth = !1, t.viewer.options.detailgridResize = 3, t.viewer.options.controlPosition = 2, t.viewer.options.hoverEnabled = !0, t.viewer.options.hoverBackColor = "#F4F8FD", t.viewer.options.hoverTextColor = "#000", t.viewer.options.selectionHighlight = !0, t.viewer.options.selectionBackColor = "rgba(244,248,253,1)", t.viewer.options.selectionTextColor = "rgba(0,0,0,1)", t.viewer.report.OnInitialize = c, v();
        } catch ($) {
          t.viewer = null, M($);
        }
      });
    }
    function c() {
      if (t.report = t.viewer.report, console.log(t.report), t.detailGrid = t.viewer.report.DetailGrid, console.log(t.detailGrid), t.recordSet = t.viewer.report.DetailGrid.Recordset, console.log(t.recordSet), t.report.ControlByName("AllCheckBox") !== void 0 && (t.report.ControlByName("AllCheckBox").onclick = f), !t.isCrosstab) {
        t.detailGrid.ColumnContent.ondblclick = d;
        for (let v = 1; v <= 2; v++)
          t.detailGrid.Groups.Item(v) !== void 0 && (t.detailGrid.Groups.Item(v).Header.ondblclick = d, t.detailGrid.Groups.Item(v).Footer.ondblclick = d);
      }
      t.isCrosstab && (t.viewer.options.selectionCell = !0, e.crosstabcell.split(",").forEach((v) => {
        t.report.ColumnByName(v) !== void 0 && (t.report.ColumnByName(v).ContentCell.ondblclick = p);
      }));
    }
    function d(v) {
      const M = t.recordSet.curRecord, $ = t.detailGrid.getClickedRow(), H = v.target.innerText;
      $.type === "content" && o("row-dbclick", {
        type: "content",
        row: M,
        cell: H,
        index: $.recordNo
      }), $.type === "groupheader" && o("row-dbclick", {
        type: "groupheader",
        row: M,
        cell: H,
        index: $.groupIndex
      }), $.type === "groupfooter" && o("row-dbclick", {
        type: "groupfooter",
        row: M,
        cell: H,
        index: $.groupIndex
      });
    }
    function p(v) {
      const M = t.report.RunningDetailGrid.Recordset.curRecord, $ = t.report.RunningDetailGrid.getClickedRow(), H = v.target.innerText;
      $.type === "content" && o("cell-dbclick", {
        type: "content",
        row: M,
        cell: H,
        index: $.recordNo
      }), $.type === "groupheader" && o("cell-dbclick", {
        type: "groupheader",
        row: M,
        cell: H,
        index: $.groupIndex
      }), $.type === "groupfooter" && o("cell-dbclick", {
        type: "groupfooter",
        row: M,
        cell: H,
        index: $.groupIndex
      });
    }
    function f(v, M) {
      if (t.recordSet == null)
        return;
      const $ = t.report.ControlByName("CheckBox");
      for (t.recordSet.First(); !t.recordSet.Eof(); )
        $.checked = M.checked, t.recordSet.Next();
    }
    function g() {
      return msPost(
        "alc-public-framework/ReportTemplateAction/getTemplate",
        {
          cReportCode: e.code,
          bMobile: 0,
          cOrgUuid: n.value.cOrgUuid,
          cPersonUuid: n.value.cPersonUuid,
          columnMap: null,
          groupMap: null
        }
      );
    }
    function b() {
      t.reportTemplateLoading = !0, g().then((v) => {
        v.code === 1 ? (t.reportTemplate = v.data.strJSON, t.reportUuid = v.data.cTemplateUuid, t.viewer.loadReport(t.reportTemplate, !1), t.viewer.update(), o("template-loaded")) : operatorErrorTip("报表模板获取失败");
      }).finally(() => {
        t.reportTemplateLoading = !1;
      });
    }
    function k() {
      b();
    }
    function x() {
      return t.reportTemplate;
    }
    function N(v) {
      isBlank(v) && (t.reportTemplate = v), t.reportData.length = 0, t.viewer.loadReport(t.reportTemplate, !1), t.viewer.update(), o("template-reload");
    }
    function O(v) {
      t.reportData = { recordset: deepClone(v) }, t.currentPage = 1, t.dataTotal = 0, ee();
    }
    function m() {
      t.reportData = {}, ee();
    }
    function ee() {
      if (isBlank(t.reportTemplate)) {
        operatorErrorTip("未检测到报表模板");
        return;
      }
      t.viewer.loadData(t.reportData, !1), t.viewer.loadReport(t.reportTemplate, !1), t.viewer.update();
    }
    function z() {
      if (t.isPagination === !0)
        return {
          currentPage: t.currentPage,
          pageSize: t.pageSize
        };
    }
    function P(v) {
      t.currentPage !== v && (t.currentPage = v, o("page-change", {
        currentPage: t.currentPage,
        pageSize: t.pageSize
      }));
    }
    function V(v) {
      t.pageSize = v, o("size-change", {
        currentPage: t.currentPage,
        pageSize: t.pageSize
      });
    }
    function U() {
      o("size-change", {
        currentPage: t.currentPage,
        pageSize: t.pageSize
      });
    }
    function E() {
      t.dialogVisible = !0;
    }
    function C(v) {
      a({
        code: e.code,
        dataSource: v.data,
        pageSize: e.pagesize,
        fileName: v.fileName
      });
    }
    function I(v) {
      r({
        templateCode: e.code,
        dataSource: v,
        pageSize: e.pagesize
      });
    }
    return {
      ...toRefs$1(t),
      isBlank,
      reportSetChange: k,
      getReportTemplate: x,
      setReportTemplate: N,
      setReportData: O,
      clearReportData: m,
      onCurrentPageChange: P,
      onPageSizeChange: V,
      onPageSizeChangeInput: U,
      getReportPageInfo: z,
      openReportSet: E,
      dataExport: C,
      openPrintModal: I
    };
  }
}), _hoisted_1$7 = { class: "flex h100 alc-component-report-container" }, _hoisted_2$6 = ["id"], _hoisted_3$6 = /* @__PURE__ */ createElementVNode("i", {
  class: "ri-list-settings-line",
  title: "报表设置"
}, null, -1), _hoisted_4$6 = { style: { margin: "0 8px", "font-size": "14px", color: "var(--el-text-color-regular)" } };
function _sfc_render$8(e, o, n, t, r, a) {
  const l = resolveComponent("ElButton"), s = resolveComponent("ElScrollbar"), c = resolveComponent("ElInputNumber"), d = resolveComponent("ElPagination"), p = resolveComponent("AlcReportSet"), f = resolveComponent("AlcDialog"), g = resolveDirective("load-on");
  return withDirectives((openBlock(), createElementBlock("div", _hoisted_1$7, [
    createVNode(s, {
      class: normalizeClass([e.referHeight, "w100 alc-component-report-main"])
    }, {
      default: withCtx(() => [
        createElementVNode("div", { id: e.reportUid }, null, 8, _hoisted_2$6),
        createVNode(l, {
          class: "report-set--button",
          onClick: e.openReportSet
        }, {
          default: withCtx(() => [
            _hoisted_3$6
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["class"]),
    e.isPagination ? (openBlock(), createBlock(d, {
      key: 0,
      "pager-count": 5,
      total: e.dataTotal,
      "page-size": e.pageSize,
      "page-sizes": e.pageSizes,
      "current-page": e.currentPage,
      layout: "prev, pager, next, jumper, ->, slot, sizes, total",
      "onUpdate:currentPage": e.onCurrentPageChange,
      "onUpdate:pageSize": e.onPageSizeChange
    }, {
      default: withCtx(() => [
        createElementVNode("div", _hoisted_4$6, [
          createTextVNode(" 加载 "),
          createVNode(c, {
            modelValue: e.pageSize,
            "onUpdate:modelValue": o[0] || (o[0] = (b) => e.pageSize = b),
            controls: !1,
            min: 1,
            max: 1e4,
            style: { margin: "0 8px", width: "70px" },
            onChange: e.onPageSizeChangeInput
          }, null, 8, ["modelValue", "onChange"]),
          createTextVNode(" 条 ")
        ])
      ]),
      _: 1
    }, 8, ["total", "page-size", "page-sizes", "current-page", "onUpdate:currentPage", "onUpdate:pageSize"])) : createCommentVNode("", !0),
    createVNode(f, {
      modelValue: e.dialogVisible,
      "onUpdate:modelValue": o[1] || (o[1] = (b) => e.dialogVisible = b),
      title: "报表设置",
      "width-type": "md",
      draggable: "",
      "show-fullscreen": "",
      "close-on-click-modal": "",
      "close-on-press-escape": ""
    }, {
      default: withCtx(() => [
        createVNode(p, {
          ref: "reportSetHandle",
          code: e.code,
          uuid: e.reportUuid,
          onModalConfirm: e.reportSetChange
        }, null, 8, ["code", "uuid", "onModalConfirm"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ])), [
    [
      g,
      e.reportTemplateLoading,
      void 0,
      { large: !0 }
    ]
  ]);
}
const Report = /* @__PURE__ */ _export_sfc(_sfc_main$8, [["render", _sfc_render$8], ["__file", "report.vue"]]), alcReportProps = {
  /**
   * 布局方案编码
   */
  code: { type: String, required: !0 },
  /**
   * 每页条数
   * @default 50
   */
  pagesize: { type: Number, default: 50 },
  /**
   * 数据总条数
   * @default 0
   */
  total: { type: Number, default: 0 },
  /**
   * 显示翻页
   * @default true
   */
  pagination: { type: Boolean, default: !0 },
  /**
   * 初始化模板数据
   * @default true
   */
  init: { type: Boolean, default: !0 },
  /**
   * 交叉表
   * @default false
   */
  crosstab: { type: Boolean, default: !1 },
  /**
   * 交叉表监听双击事件的单元格名称
   */
  crosstabcell: { type: String, default: "" }
}, AlcReport = withInstall(Report), _sfc_main$7 = defineComponent({
  name: "voucher-input-data-source",
  components: {
    AlcTooltip,
    AlcInput,
    AlcDateTime,
    AlcSelect,
    AlcInputNumber,
    AlcDialogFooter,
    ElCheckbox,
    ElButton,
    ElScrollbar,
    ElRow,
    ElCol
  },
  props: {
    // 参照表的 uuid
    tableUuid: { type: String, default: "" },
    // 参照表字段的 uuid
    fieldUuid: { type: String, default: "" },
    // 是否多选 默认：false
    multiple: { type: Boolean, default: !1 },
    // 纵向填充是否启用  默认：false
    portraitFill: { type: Boolean, default: !1 }
  },
  emits: ["select", "clear"],
  setup(e, { emit: o }) {
    const n = useProviderConfig("state"), { close: t } = useDialogState(), r = shallowRef([]), a = reactive([
      {
        itemType: "input"
      }
    ]), l = ref(""), s = computed(() => r.value.map((I) => ({
      label: I.label,
      value: I.prop,
      disabled: a.some((v) => v.queryName === I.prop)
    }))), c = ref(), d = shallowReactive([]), p = ref(
      {}
    ), { searchFn: f, sliceList: g, paging: b, total: k } = useSliceList((I) => msPost(
      "alc-city-framework/SysDefinedDataSourceAction/queryDefinedDataPage",
      {
        // 数据表 UUID
        cTableUuid: e.tableUuid,
        // 数据字段 UUID
        cFieldUuid: e.fieldUuid,
        // 是否分页
        isPage: !0,
        // 每页记录数
        pageSize: I.pageSize,
        // 页码
        pageNumber: I.pageNumber,
        // 过滤数据，该数据主要针对参照字段数据进行模糊查询
        cWhere: l.value ? encryptAES(l.value) : void 0,
        cAccUuid: n.value.cAccUuid,
        cOrgUuid: n.value.cOrgUuid
      }
    ).then((v) => {
      if (v.code === 1) {
        r.value.length || (r.value = v.data.showFieldList.map(($) => {
          const H = {
            label: $.cFieldLabel,
            prop: $.cFieldName,
            width: 156
          };
          switch ($.cDataType) {
            case "string":
              H.itemType = "input";
              break;
            case "date":
              H.itemType = "date", H.code = "datetime";
              break;
            case "int":
              H.itemType = "number", H.code = 0;
              break;
            case "float":
              H.itemType = "number", H.code = 2;
              break;
            default:
              H.itemType = "input";
              break;
          }
          return H;
        }));
        const M = v.data.results || [];
        return M.length && nextTick(() => {
          const $ = c.value.getInstance();
          M.forEach((H) => {
            $.toggleRowSelection(
              H,
              d.some((X) => deepCompare(H, X))
            );
          });
        }), p.value = v.data.saveField, {
          list: M,
          total: v.data.allRow
        };
      }
      operatorErrorTip(v.msg);
    }).catch(() => {
      apiLinkErrorTip("自定义项数据源");
    }));
    f();
    const x = (I, v) => {
      I.itemType = r.value.find((M) => M.prop === v).itemType;
    }, N = (I) => {
      I ? l.value = toSqlWhere(
        I.reduce((v, M) => (M.queryName && M.queryValue && M.queryType && (v[M.queryName] = {
          queryName: M.queryName,
          queryValue: M.queryValue,
          queryType: M.queryType,
          ...M.itemType === "date" ? { queryValueTypeCode: "datetime" } : {}
        }), v), {})
      ) : (l.value = "", a.splice(0, a.length, {
        itemType: "input"
      })), f();
    }, O = (I) => {
      e.multiple || d.splice(0, d.length, I);
    }, m = (I) => {
      e.multiple ? d.some((v) => deepCompare(v, I)) || d.push(I) : (d.splice(0, d.length, I), o("select", V()), t());
    }, ee = (I, v) => {
      if (isEmptyObject(v))
        !(isArray(I) && I.length === 0) ? I.forEach(($) => {
          d.some((H) => deepCompare(H, $)) || d.push($);
        }) : g.value.forEach(($) => {
          d.splice(
            0,
            d.length,
            ...d.filter((H) => !deepCompare(H, $))
          );
        });
      else {
        const M = d.findIndex(($) => deepCompare($, v));
        ~M ? d.splice(M, 1) : d.push(v);
      }
    }, z = () => {
      a.push({ itemType: "input" });
    }, P = (I) => {
      a.splice(I, 1), a.length || z();
    }, V = () => d.map((I) => I[p.value.cFieldName]);
    return {
      schema: r,
      listRef: c,
      queryQueue: a,
      queryField: s,
      sliceList: g,
      paging: b,
      total: k,
      selectedRow: d,
      saveFieldRef: p,
      close: t,
      doQuery: N,
      rowClick: O,
      rowDbClick: m,
      onSelect: ee,
      setPreQueryItemType: x,
      pushQueue: z,
      delQuery: P,
      onClear: () => {
        d.splice(0, d.length), o("clear");
      },
      onConfirm: () => {
        o("select", V()), t();
      },
      onRemove: (I, v) => {
        d.splice(v, 1);
        const M = g.value.find(($) => deepCompare($, I));
        M && c.value.getInstance().toggleRowSelection(M, !1);
      }
    };
  }
}), _hoisted_1$6 = { class: "h100 auto-width--wrap alc-component--voucher-data-source" }, _hoisted_2$5 = { class: "auto-width--target auto-height--wrap" }, _hoisted_3$5 = { class: "custom-query--wrap" }, _hoisted_4$5 = { style: { width: "160px" } }, _hoisted_5$5 = /* @__PURE__ */ createElementVNode("i", { class: "ri-delete-back-line" }, null, -1), _hoisted_6$4 = { style: { padding: "16px 16px 16px 0", display: "flex", "align-items": "flex-end", "justify-content": "flex-end", "flex-flow": "row wrap" } }, _hoisted_7$4 = {
  key: 0,
  class: "h100 refer-multiple--list auto-height--wrap"
}, _hoisted_8$4 = { class: "flex refer-multiple--list-title" }, _hoisted_9$4 = { class: "refer-item--title single-line-overflow" }, _hoisted_10$3 = ["onClick"], _hoisted_11$2 = { style: { display: "flex", "flex-flow": "row nowrap", "align-items": "center", "justify-content": "flex-end" } };
function _sfc_render$7(e, o, n, t, r, a) {
  const l = resolveComponent("AlcSelect"), s = resolveComponent("AlcInputNumber"), c = resolveComponent("AlcDateTime"), d = resolveComponent("AlcInput"), p = resolveComponent("ElButton"), f = resolveComponent("ElCol"), g = resolveComponent("ElRow"), b = resolveComponent("AlcList"), k = resolveComponent("ElCheckbox"), x = resolveComponent("AlcTooltip"), N = resolveComponent("ElScrollbar"), O = resolveComponent("AlcDialogFooter");
  return openBlock(), createElementBlock(Fragment, null, [
    createElementVNode("div", _hoisted_1$6, [
      createElementVNode("div", _hoisted_2$5, [
        createElementVNode("div", _hoisted_3$5, [
          createVNode(g, {
            gutter: 30,
            style: { flex: "1", padding: "16px 32px 2px 32px" }
          }, {
            default: withCtx(() => [
              (openBlock(!0), createElementBlock(Fragment, null, renderList(e.queryQueue, (m, ee) => (openBlock(), createBlock(f, {
                key: `${m.queryName}_${ee}`,
                span: e.multiple ? 24 : 12,
                class: "simple-input query-item",
                style: { display: "flex", "flex-flow": "row nowrap" }
              }, {
                default: withCtx(() => [
                  createVNode(l, {
                    modelValue: m.queryName,
                    "onUpdate:modelValue": (z) => m.queryName = z,
                    options: e.queryField,
                    placeholder: "查询项",
                    onChange: (z) => e.setPreQueryItemType(m, z)
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onChange"]),
                  createVNode(l, {
                    modelValue: m.queryType,
                    "onUpdate:modelValue": (z) => m.queryType = z,
                    code: "queryType",
                    filter: "6",
                    placeholder: "查询类型",
                    style: { width: "174px" }
                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                  createElementVNode("div", _hoisted_4$5, [
                    m.itemType === "number" ? (openBlock(), createBlock(s, {
                      key: 0,
                      modelValue: m.queryValue,
                      "onUpdate:modelValue": (z) => m.queryValue = z,
                      onEnter: o[0] || (o[0] = (z) => e.doQuery(e.queryQueue))
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])) : m.itemType === "date" ? (openBlock(), createBlock(c, {
                      key: 1,
                      modelValue: m.queryValue,
                      "onUpdate:modelValue": (z) => m.queryValue = z,
                      onChange: o[1] || (o[1] = (z) => e.doQuery(e.queryQueue))
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])) : (openBlock(), createBlock(d, {
                      key: 2,
                      modelValue: m.queryValue,
                      "onUpdate:modelValue": (z) => m.queryValue = z,
                      placeholder: "查询值",
                      onEnter: o[2] || (o[2] = (z) => e.doQuery(e.queryQueue))
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                  ]),
                  createVNode(p, {
                    link: "",
                    type: "danger",
                    class: "delete-handle",
                    onClick: (z) => e.delQuery(ee)
                  }, {
                    default: withCtx(() => [
                      _hoisted_5$5
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 2
              }, 1032, ["span"]))), 128))
            ]),
            _: 1
          }),
          createElementVNode("div", _hoisted_6$4, [
            createVNode(p, {
              disabled: e.queryQueue.length === e.queryField.length,
              onClick: e.pushQueue
            }, {
              default: withCtx(() => [
                createTextVNode(" + 查询项 ")
              ]),
              _: 1
            }, 8, ["disabled", "onClick"]),
            createVNode(p, {
              type: "primary",
              onClick: o[3] || (o[3] = (m) => e.doQuery(e.queryQueue))
            }, {
              default: withCtx(() => [
                createTextVNode(" 查询 ")
              ]),
              _: 1
            }),
            createVNode(p, {
              text: "",
              bg: "",
              onClick: o[4] || (o[4] = (m) => e.doQuery())
            }, {
              default: withCtx(() => [
                createTextVNode(" 重置 ")
              ]),
              _: 1
            })
          ])
        ]),
        createVNode(b, {
          ref: "listRef",
          "page-size": e.paging.pageSize,
          "onUpdate:pageSize": o[5] || (o[5] = (m) => e.paging.pageSize = m),
          "current-page": e.paging.pageNumber,
          "onUpdate:currentPage": o[6] || (o[6] = (m) => e.paging.pageNumber = m),
          data: e.sliceList,
          schema: e.schema,
          multiple: e.multiple,
          total: e.total,
          class: "auto-height--target",
          style: { "min-height": "400px" },
          onRowClick: e.rowClick,
          onRowDblclick: e.rowDbClick,
          onSelect: e.onSelect,
          onSelectAll: e.onSelect
        }, null, 8, ["page-size", "current-page", "data", "schema", "multiple", "total", "onRowClick", "onRowDblclick", "onSelect", "onSelectAll"])
      ]),
      e.multiple ? (openBlock(), createElementBlock("div", _hoisted_7$4, [
        createElementVNode("div", _hoisted_8$4, [
          createElementVNode("span", null, "已选： " + toDisplayString$1(e.selectedRow.length) + " 项", 1),
          e.portraitFill ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            e.portraitFill ? (openBlock(), createBlock(k, {
              key: 0,
              "model-value": !0,
              disabled: ""
            }, {
              default: withCtx(() => [
                createTextVNode(" 纵向填充 ")
              ]),
              _: 1
            })) : createCommentVNode("", !0),
            createVNode(x, {
              content: "选择的每个参照项将在表格中生成一条独立的记录",
              tabindex: null
            })
          ], 64)) : createCommentVNode("", !0)
        ]),
        createVNode(N, { class: "auto-height--target w100" }, {
          default: withCtx(() => [
            (openBlock(!0), createElementBlock(Fragment, null, renderList(e.selectedRow, (m, ee) => (openBlock(), createElementBlock("div", {
              key: ee,
              class: "flex refer-item"
            }, [
              createElementVNode("div", _hoisted_9$4, toDisplayString$1(m[e.saveFieldRef.cFieldName]), 1),
              createElementVNode("i", {
                class: "ri-close-line refer-item__remove",
                title: "删除选择项",
                onClick: (z) => e.onRemove(m, ee)
              }, null, 8, _hoisted_10$3)
            ]))), 128))
          ]),
          _: 1
        })
      ])) : createCommentVNode("", !0)
    ]),
    createVNode(O, null, {
      default: withCtx(() => [
        createElementVNode("div", _hoisted_11$2, [
          createVNode(p, {
            title: "清除参照选择结果",
            onClick: e.onClear
          }, {
            default: withCtx(() => [
              createTextVNode(" 清空 ")
            ]),
            _: 1
          }, 8, ["onClick"]),
          createVNode(p, {
            type: "primary",
            onClick: e.onConfirm
          }, {
            default: withCtx(() => [
              createTextVNode("确定")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    })
  ], 64);
}
const CustomInputDataSource = /* @__PURE__ */ _export_sfc(_sfc_main$7, [["render", _sfc_render$7], ["__file", "input-data-source.vue"]]), _sfc_main$6 = defineComponent({
  name: "voucher-custom-item",
  components: { AlcInputNumber, AlcInput },
  props: {
    // 自定义项类型
    type: {
      type: String,
      required: !0
    },
    // 数据绑定值 默认：0
    modelValue: { type: [Number, String], default: "" },
    // 公式
    formula: { type: String, default: "" },
    // 参照表的 uuid
    tableUuid: { type: String, default: "" },
    // 参照表字段的 uuid
    fieldUuid: { type: String, default: "" },
    // 是否只读 默认：false
    readonly: { type: Boolean, default: !1 },
    // 是否禁用 默认：false
    disabled: { type: Boolean, default: !1 },
    // 联动数据
    relationData: { type: Object, required: !0 },
    // 水印提示 默认：''
    placeholder: { type: String, default: "" },
    // 公式计算的精度
    precision: { type: Number, default: 0 },
    // 最大长度
    maxlength: { type: Number, default: void 0 },
    // 数据类型
    dataType: {
      type: String,
      required: !0
    },
    // 是否多选 默认：false
    multiple: { type: Boolean, default: !1 },
    // 纵向填充是否启用  默认：false
    portraitFill: { type: Boolean, default: !1 },
    // 字段名称，适配表格中多选批量填充和纵向填充的情况（只在 alc-table 中使用）
    fieldName: { type: String, default: "" }
  },
  emits: ["update:modelValue", "change", "clear"],
  setup(props, { emit, expose }) {
    const value = useModel(props, "modelValue"), formulaArray = computed(() => isJSON(props.formula) ? JSON.parse(props.formula) : []);
    props.type === "formula" && watch(
      () => props.relationData,
      (data) => {
        const execStr = formulaArray.value.reduce((e, o) => e += o.type === "c" ? o.value : data[o.value.split(",")[1]], ""), result = eval(execStr);
        typeof result == "number" && !Number.isNaN(result) && (value.value = Number(result.toFixed(props.precision)));
      },
      { deep: !0, immediate: !0 }
    );
    const { open } = useDialogOpen(CustomInputDataSource, {
      title: "选择数据源字段",
      widthType: "md",
      contentHeightFit: !0
    });
    function openSourceField() {
      ["archives", "voucher"].includes(props.type) && open({
        tableUuid: props.tableUuid,
        fieldUuid: props.fieldUuid,
        multiple: props.multiple,
        portraitFill: props.portraitFill,
        onSelect: selectRowHandle,
        onClear
      });
    }
    function onClear() {
      value.value = "", emit("clear");
    }
    function selectRowHandle(e) {
      props.fieldName ? (props.dataType === "string" ? e = e.map((o) => typeof props.maxlength < "u" ? String(o).slice(0, props.maxlength) : o) : props.dataType === "date" && (e = e.map((o) => formatDate(o, "yyyy-MM-dd HH:mm:ss"))), value.value = e[0], e = e.map((o) => ({
        [props.fieldName]: o
      })), emit("change", {
        // 多选并且纵向填充时，传递数组
        referValue: props.multiple ? e : e[0],
        isPortraitFill: props.portraitFill,
        saveField: props.fieldName,
        showField: props.fieldName,
        referDataKey: props.fieldName
      })) : e[0] && (props.dataType === "string" ? value.value = typeof props.maxlength < "u" ? String(e[0]).slice(0, props.maxlength) : e[0] : props.dataType === "date" ? value.value = formatDate(
        e[0],
        "yyyy-MM-dd HH:mm:ss"
      ) : value.value = e[0]);
    }
    return expose({
      focus: openSourceField
    }), {
      value,
      openSourceField
    };
  }
});
function _sfc_render$6(e, o, n, t, r, a) {
  const l = resolveComponent("AlcInputNumber"), s = resolveComponent("AlcInput");
  return e.type === "formula" ? (openBlock(), createBlock(l, {
    key: 0,
    modelValue: e.value,
    "onUpdate:modelValue": o[0] || (o[0] = (c) => e.value = c),
    disabled: e.disabled,
    placeholder: e.placeholder,
    precision: e.precision,
    readonly: "",
    class: "alc-component-voucher-custom-item",
    onClear: o[1] || (o[1] = (c) => e.$emit("clear"))
  }, null, 8, ["modelValue", "disabled", "placeholder", "precision"])) : (openBlock(), createBlock(s, {
    key: 1,
    "model-value": e.value,
    "onUpdate:modelValue": o[3] || (o[3] = (c) => e.value = c),
    readonly: e.readonly || e.type !== "input",
    disabled: e.disabled,
    placeholder: e.placeholder,
    class: "alc-component-voucher-custom-item",
    onClick: e.openSourceField,
    onClear: o[4] || (o[4] = (c) => e.$emit("clear"))
  }, createSlots({ _: 2 }, [
    e.disabled ? void 0 : {
      name: "suffix",
      fn: withCtx(() => [
        createElementVNode("i", {
          class: "ri-search-line",
          title: "参照选择",
          onClick: o[2] || (o[2] = (...c) => e.openSourceField && e.openSourceField(...c))
        })
      ]),
      key: "0"
    }
  ]), 1032, ["model-value", "readonly", "disabled", "placeholder", "onClick"]));
}
const AlcVoucherCustomInput = /* @__PURE__ */ _export_sfc(_sfc_main$6, [["render", _sfc_render$6], ["__file", "custom-input.vue"]]), indexColWidth = 54, editOperationTips = `
    <ul style="list-style: decimal">
         <li>单击 [+] 在当前行下方新增空白行，右键单击可以添加多个空白行</li>
        <li>单击 [×] 删除当前行</li>
        <li>按 Tab 键可横向向右切换编辑项，Tab + Shift 组合键向相反方向切换</li>
        <li>按 Ctrl + Enter 键可纵向向下切换编辑项，Ctrl + Enter + Shift 组合键向相反方向切换</li>
        <li>双击单元格或表格选中后按 Space 可编辑当前单元格，按 Delete 清除单元格和其关联内容</li>
        <li>表格框选后支持复制、粘贴、批量填充、删除等操作</li>
        <li>粘贴时最多粘贴 100 条/次</li>
        <li>批量填充时根据框选的第一条数据最多填充 50 行/次，填充开始的行到目标行数之间的数据会被覆盖</li>
        <li>[是/1/true/TRUE]作为布尔类型的真值</li>
    </ul>
`, editOperationColWidth = 64, qrcodeColWidth = 56;
function generatorKey(e, o) {
  return `${e}_${o}`;
}
function splitKey(e) {
  return e.split("_");
}
const useAccessibility = (e, o, n, t, r, a, l) => {
  const { emit: s } = getCurrentInstance(), c = ref(!1), d = useProviderConfig("dict"), p = useProviderConfig("state"), f = useProp("fieldReadonly"), g = useProp("disabled"), b = useProp("referQueryAlias"), k = shallowReactive(/* @__PURE__ */ new WeakSet()), x = reactive({
    index: "",
    fieldName: ""
  }), N = computed(() => generatorKey(x.index, x.fieldName)), O = ref([]), m = ref(!1), ee = ref(1), z = /* @__PURE__ */ new Map();
  watch(() => [g.value, o.value], te);
  function P() {
    var de;
    return (de = e.value) == null ? void 0 : de.$el.querySelector(
      ".el-table__body-wrapper > .el-scrollbar > .el-scrollbar__wrap"
    );
  }
  useEventListener$1(P, "mousedown", E, {
    passive: !1
  }), useEventListener$1(P, "keydown", ne, {
    passive: !1
  }), useEventListener$1(P, "scroll", ie, {
    passive: !1
  }), onPageVisit(() => {
    const de = P();
    de.tabIndex = 0, de.style.outline = "none";
  });
  const V = debounce(
    (de, ge, be, ke) => {
      const Pe = ge.getBoundingClientRect(), Te = de.clientX - Pe.x, Le = de.clientY - Pe.y;
      let Ae = ge.scrollLeft, Re = ge.scrollTop;
      ge.clientWidth - ke - Te < 40 ? Ae += 80 : Te - be - 40 < 0 && (Ae -= 80), ge.clientHeight - Le < 40 ? Re += 80 : Le - 40 < 0 && (Re -= 80), (Ae !== ge.scrollLeft || Re !== ge.scrollTop) && (ge.scrollTo({
        left: Ae,
        top: Re,
        behavior: "smooth"
      }), se(ge));
    },
    16
  );
  function U(de, ge, be, ke, Ne) {
    de.preventDefault();
    const { target: Oe, currentTarget: Pe } = de;
    if (!(Pe instanceof HTMLDivElement))
      return;
    const Te = I(Oe);
    if (Te) {
      if (ge !== Te && ge) {
        const Le = M(Pe, Te, !0), Ae = M(
          Pe,
          ge,
          !1
        ), Re = Le || Ae || Pe.style.position === "initial", Ve = Te.getBoundingClientRect(), Ie = ge.getBoundingClientRect(), ze = Ve.y < Ie.y, He = Ve.x < Ie.x, Ue = He ? Ve.x : Ie.x, Ge = ze ? Ve.y : Ie.y, qe = ze ? Ie.y - Ge + Ie.height : Ve.y - Ge + Ve.height, Xe = He ? Ie.x - Ue + Ie.width : Ve.x - Ue + Ve.width;
        let je = null;
        Le && Ae ? je = Te.offsetLeft < ge.offsetLeft ? Te : ge : Le ? je = Te : Ae && (je = ge);
        let Ze = 0, $e = je == null ? void 0 : je.previousElementSibling;
        for (; $e != null && $e.classList.contains(
          "el-table-fixed-column--left"
        ) && !($e != null && $e.classList.contains("no-interaction")); )
          Ze += $e.offsetWidth, $e = $e.previousElementSibling;
        V(de, Pe, ke, Ne);
        const Ke = Math.min(
          Te.offsetLeft,
          ge.offsetLeft
        ), We = Math.min(Te.offsetTop, ge.offsetTop);
        $(be, {
          x: Re ? Ke - Pe.scrollLeft : Ke,
          y: Re ? We - Pe.scrollTop : We,
          height: qe,
          // 不能让边框覆盖在右侧的浮动列上，最大宽度应该是数据列的显式宽度
          width: Re ? Math.min(
            Xe,
            Pe.offsetWidth - ke - Ne - Ze
          ) : Xe,
          oY: We
        });
      } else if (ge === Te) {
        const Le = Te.getBoundingClientRect(), Ae = M(Pe, Te) || Pe.style.position === "initial";
        $(be, {
          x: Ae ? Te.offsetLeft - Pe.scrollLeft : Te.offsetLeft,
          y: Ae ? Te.offsetTop - Pe.scrollTop : Te.offsetTop,
          height: Le.height,
          width: Le.width,
          oY: Te.offsetTop
        });
      }
    }
  }
  function E(de) {
    de.preventDefault();
    const { target: ge, currentTarget: be } = de, ke = I(ge);
    if (!ke || !(be instanceof HTMLDivElement))
      return;
    const Ne = be.querySelector(
      ".select-edge-cell"
    );
    if (Ne && Ne !== ke) {
      const Ae = ke.tabIndex;
      ke.tabIndex = 1, ke.focus({ preventScroll: !1 }), ke.tabIndex = Ae, ve();
    }
    m.value = !1, H(be, ke);
    const Oe = be.querySelector(
      ".select-cell-border"
    ), Pe = ke.parentElement.querySelectorAll("td.no-interaction"), [Te, Le] = C(Pe);
    Oe.style.setProperty("--left-offset", `${Te}px`), be.onmousemove = (Ae) => {
      U(Ae, ke, Oe, Te, Le);
    }, be.addEventListener(
      "mouseup",
      (Ae) => {
        Ae.preventDefault();
        let Re = null, Ve = null;
        const Ie = I(Ae.target);
        if (Ie === ke ? (Re = Ie, Ve = Ie) : ve(), Ie) {
          const ze = v(Ie), He = Ie.parentElement.rowIndex, Ue = v(ke), Ge = ke.parentElement.rowIndex, qe = Math.min(
            Ue,
            ze
          ), Xe = Math.max(
            Ue,
            ze
          ), je = Math.min(
            Ge,
            He
          ), Ze = Math.max(
            Ge,
            He
          ), $e = ke.parentElement.parentElement.querySelectorAll("tr"), Ke = $e.item(je), We = $e.item(Ze);
          Re = Ke.querySelectorAll("td:not(.no-interaction)").item(qe), Ve = We.querySelectorAll("td:not(.no-interaction)").item(Xe), Re.classList.add("select-edge-cell"), Ve.classList.add("select-edge-cell"), X(
            {
              x: qe,
              y: je,
              target: markRaw(Re)
            },
            {
              x: Xe,
              y: Ze,
              target: markRaw(Ve)
            }
          );
          const Ye = window.getSelection();
          if (Ye) {
            Ye.removeAllRanges();
            let Ct = Ze - je + 1, Qe = Ke;
            for (; Ct && Qe; ) {
              const Je = document.createRange(), At = Qe.querySelectorAll("td:not(.no-interaction)").item(qe), Tt = Qe.querySelectorAll("td:not(.no-interaction)").item(Xe);
              Je.setStart(At, 0), Je.setEnd(Tt, 1), Ye.addRange(Je), Ct--, Qe = Re === Ne ? Qe.nextElementSibling : Qe.previousElementSibling;
            }
          }
        }
        Ae.currentTarget.focus({
          preventScroll: !0
        }), be.onmousemove = null;
      },
      { once: !0, passive: !1 }
    );
  }
  function C(de) {
    const ge = [], be = [];
    for (let Oe = 0; Oe < de.length; Oe++) {
      const Pe = de.item(Oe);
      if (ge.push(Pe), Pe.nextElementSibling !== de.item(Oe + 1)) {
        be.push(...[...de].slice(Oe + 1));
        break;
      }
    }
    const ke = ge.reduce((Oe, Pe) => Oe + Pe.offsetWidth, 0), Ne = be.reduce((Oe, Pe) => Oe + Pe.offsetWidth, 0);
    return [ke, Ne];
  }
  function I(de) {
    return de instanceof HTMLElement ? de == null ? void 0 : de.closest("td:not(.no-interaction)") : null;
  }
  function v(de) {
    const ge = de.parentElement;
    return ge ? [...ge.querySelectorAll("td:not(.no-interaction)")].findIndex(
      (be) => be === de
    ) : -1;
  }
  function M(de, ge, be = !0) {
    const ke = ge.classList.contains("el-table-fixed-column--left");
    return ke ? (de.style.setProperty(
      "--select-border-index",
      "calc(var(--el-table-index) + 1)"
    ), de.style.position = "initial") : be && (de.style.setProperty(
      "--select-border-index",
      "var(--el-table-index)"
    ), de.style.position = "relative"), ke;
  }
  function $(de, ge) {
    de && (de.style.top = `${ge.y}px`, de.style.left = `${ge.x}px`, de.style.height = `${ge.height}px`, de.style.width = `${ge.width}px`, ge.oY != null && de.style.setProperty("--border-top", `${ge.oY}px`));
  }
  function H(de, ge) {
    let be = de.querySelector(
      ".select-cell-border"
    );
    be || (be = document.createElement("div"), be.className = "select-cell-border", de.append(be)), de.querySelectorAll(".select-edge-cell").forEach((Pe) => {
      Pe.classList.remove("select-edge-cell");
    }), de.querySelectorAll(".select-cell").forEach((Pe) => {
      Pe.classList.remove("select-cell");
    });
    const ke = M(de, ge), { height: Ne, width: Oe } = ge.getBoundingClientRect();
    $(be, {
      x: ke ? ge.offsetLeft - de.scrollLeft : ge.offsetLeft,
      y: ke ? ge.offsetTop - de.scrollTop : ge.offsetTop,
      height: Ne,
      width: Oe,
      oY: ge.offsetTop
    });
  }
  function X(de, ge) {
    O.value = [de, ge], ee.value = Math.max(ge.y - de.y, 1), m.value = !0;
  }
  function te() {
    var ge;
    (ge = e.value.$el.querySelector(".select-cell-border")) == null || ge.remove(), O.value = [], m.value = !1, ve();
  }
  function oe(de, ge, be, ke, Ne) {
    return Ne ? de-- : de++, (de < 0 || de >= be) && (Ne ? (ge--, de = be - 1) : (ge++, de = 0)), ge > ke || ge < 0 ? { x: void 0, y: void 0 } : { x: de, y: ge };
  }
  function ne(de) {
    if (!(de.currentTarget instanceof HTMLDivElement))
      return;
    if ((/(Mac|iPad)/i.test(navigator.platform) ? de.metaKey : de.ctrlKey) && de.code === "KeyC") {
      de.preventDefault(), ae();
      return;
    }
    const ke = de.currentTarget.querySelectorAll(".select-edge-cell");
    if (ke.length !== 1)
      return;
    if (de.code === "Delete") {
      de.preventDefault(), Ce();
      return;
    }
    const Ne = ke.item(0), Oe = Ne.parentElement, Pe = Oe.parentElement, Te = v(Ne);
    if ((de.code.startsWith("Key") || de.code.startsWith("Numpad") || de.code.startsWith("Digit") || de.code === "Space") && !de.metaKey && !de.ctrlKey) {
      pe({
        x: Te,
        y: Oe.rowIndex,
        target: Ne
      });
      return;
    }
    if (de.code === "Tab" || de.code === "Enter" && de.ctrlKey) {
      de.preventDefault();
      let Le, Ae;
      if (de.code === "Tab" ? { x: Le, y: Ae } = oe(
        Te,
        Oe.rowIndex,
        Oe.querySelectorAll("td:not(.no-interaction)").length,
        Pe.rows.length,
        de.shiftKey
      ) : { x: Ae, y: Le } = oe(
        Oe.rowIndex,
        Te,
        Pe.rows.length,
        Oe.querySelectorAll("td:not(.no-interaction)").length,
        de.shiftKey
      ), Le !== void 0 && Ae !== void 0) {
        const Re = Pe.rows.item(Ae), Ve = Re == null ? void 0 : Re.querySelectorAll("td:not(.no-interaction)").item(Le);
        Ve && (H(de.currentTarget, Ve), X(
          {
            x: Le,
            y: Ae,
            target: markRaw(Ve)
          },
          {
            x: Le,
            y: Ae,
            target: markRaw(Ve)
          }
        ), pe({
          x: Le,
          y: Ae,
          target: Ve
        })), de.currentTarget.focus({
          preventScroll: !0
        });
      } else
        ve();
    }
  }
  function ie(de) {
    se(de.currentTarget);
  }
  function se(de) {
    const ge = de.querySelector(
      ".select-cell-border"
    ), [be, ke] = de.querySelectorAll(
      ".select-edge-cell"
    );
    if (!ge || !be)
      return;
    const Ne = be.classList.contains(
      "el-table-fixed-column--left"
    ), Oe = !!(ke != null && ke.classList.contains(
      "el-table-fixed-column--left"
    ));
    if (!(Ne || Oe))
      return;
    const Te = Ne ? be : ke;
    let Le = Te.offsetWidth || 0, Ae = Te.nextElementSibling;
    for (; Ae != null && Ae.classList.contains("el-table-fixed-column--left"); )
      Le += Ae.offsetWidth, Ae = Ae.nextElementSibling;
    let Re = 0, Ve = Te.previousElementSibling;
    for (; Ve != null && Ve.classList.contains("el-table-fixed-column--left") && !(Ve != null && Ve.classList.contains("no-interaction")); )
      Re += Ve.offsetWidth, Ve = Ve.previousElementSibling;
    const Ie = Number.parseInt(
      ge.style.getPropertyValue("--border-top") || "0"
    ), ze = Number.parseInt(
      ge.style.getPropertyValue("--left-offset") || "0"
    ), He = be.offsetLeft + be.offsetWidth, Ue = ke ? ke.offsetLeft + ke.offsetWidth : 0, Ge = Math.max(
      Ne ? He - de.scrollLeft : He,
      ke ? Oe ? Ue - de.scrollLeft : Ue : 0
    ) - ze - de.scrollLeft - Re;
    ge.style.width = `${Ge < Le ? Le : Ge}px`, ge.style.top = `${Ie - de.scrollTop}px`;
  }
  function pe(de) {
    if (_e(
      de.y,
      n.value[de.x].prop,
      t[de.y]
    ))
      return;
    const ge = n.value[de.x];
    if (ge.prop) {
      let be;
      ge.itemType === "checkbox" && (be = de.target.querySelector(
        ".el-checkbox"
      )), ue(de.y, ge.prop, be || ge.itemType);
    }
  }
  function he(de) {
    switch (de) {
      case "copy":
        ae();
        break;
      case "paste":
        fe();
        break;
      case "delete":
        Ce();
        break;
      case "fill":
        le();
        break;
    }
  }
  function ae() {
    const [de, ge] = O.value;
    if (!de || !ge)
      return void operatorErrorTip("请选择要拷贝的单元");
    const be = t.slice(
      Math.min(de.y, ge.y),
      Math.max(de.y, ge.y) + 1
    ), ke = n.value.slice(
      Math.min(de.x, ge.x),
      Math.max(de.x, ge.x) + 1
    ), Ne = be.map((Oe) => ke.map((Pe) => {
      const Te = toDisplayString(
        Pe.itemType,
        Oe[Pe.prop],
        Pe.code,
        !0
      );
      return Te ?? "";
    }).join("	")).join(`
`);
    execCopy(Ne).then(() => {
      ElMessage.success("复制成功");
    }).catch(() => {
      operatorErrorTip(
        "无法访问剪切板，请检查浏览器设置是否开启相关权限"
      );
    });
  }
  async function le() {
    if (o.value)
      return void operatorErrorTip("表格已禁用，无法填充");
    const [de] = O.value;
    if (!de)
      return;
    let { x: ge, y: be } = de;
    const ke = t[be], Ne = n.value[ge], { prop: Oe, itemType: Pe, code: Te } = Ne;
    if (r.has(generatorKey(be, Oe)))
      return void operatorErrorTip("填充失败，数据来源不明确");
    const Le = { [Oe]: ke[Oe] };
    if (Pe === "refer" && Te) {
      const Re = await xe([[ke[Oe]]], [Ne]);
      if (!Re)
        return void operatorErrorTip("参照数据获取失败，数据填充失败");
      const { allFields: Ve, referData: Ie } = Re[Te], ze = Ie == null ? void 0 : Ie[ke[Oe]];
      if (!ze || ze.length !== 1)
        return void operatorErrorTip("参照数据来源不确定，无法填充");
      const [He] = ze;
      Ve.forEach((Ue) => {
        Le[Ue] = He[Ue];
      });
    }
    let Ae = ee.value;
    for (; Ae > 0 && (be++, r.delete(generatorKey(be, Oe)), !_e(be, Oe)); ) {
      let Re = t[be];
      Re ? (Object.assign(Re, deepClone(Le)), a(Re)) : (l(deepClone(Le), be), Re = t[be]), Ae--, s("cellEdit", {
        rowIndex: be,
        fieldName: Oe,
        scope: {
          row: Re,
          $index: be
        }
      });
    }
  }
  async function fe(de) {
    var Pe;
    if (o.value)
      return void operatorErrorTip("表格已禁用，无法粘贴");
    if (c.value)
      return void operatorErrorTip("正在处理，请稍后");
    const [ge] = O.value;
    if (!ge)
      return void operatorErrorTip("请选择要粘贴的起始单元格");
    c.value = !0;
    const be = ((Pe = de == null ? void 0 : de.clipboardData) == null ? void 0 : Pe.getData("text/plain")) || await Me();
    if (!be)
      return c.value = !1, void operatorErrorTip("没有检测到粘贴的数据");
    const ke = be.split(/\r?\n/).reduce(
      (Te, Le) => (Te.push(Le.split("	")), Te),
      []
    ), Ne = Math.max(
      ...ke.map((Te) => Te.length)
    ), Oe = n.value.slice(ge.x, ge.x + Ne);
    Oe.filter((Te) => Te.itemType === "refer").forEach((Te) => {
      let Le = 0;
      for (; Le < ke.length; )
        r.delete(
          generatorKey(ge.y + Le, Te.prop)
        ), Le++;
    }), await Fe(ke.slice(0, 100), Oe, ge.y), c.value = !1;
  }
  async function Ce() {
    const [de, ge] = O.value;
    if (!de || de.target !== (ge == null ? void 0 : ge.target))
      return;
    const { x: be, y: ke } = de, Ne = n.value[be];
    if (!Ne.prop)
      return warn(
        "[select-cell/onkeydown/Delete]",
        "请提供列属性名称信息"
      );
    const Oe = t[ke];
    if (!_e(ke, Ne.prop, Oe)) {
      if (Ne.itemType !== "refer") {
        delete Oe[Ne.prop], a(Oe), s("cellClear", { row: Oe, fieldName: Ne.prop });
        return;
      }
      if (!Ne.code)
        return warn(
          "[select-cell/onkeydown/Delete]",
          "请提供参照类型的编码信息"
        );
      if (!z.has(Ne.prop))
        try {
          const Pe = await apiGetReferArchive(Ne.code);
          if (Pe.data) {
            const { cSaveField: Te, cShowField: Le } = Pe.data;
            z.set(Ne.prop, `${Te},${Le}`);
          } else
            return void operatorErrorTip(Pe.msg);
        } catch {
          return void apiLinkErrorTip("参照档案");
        }
      z.get(Ne.prop).split(",").forEach((Pe) => {
        delete Oe[Pe];
      }), a(Oe), s("cellClear", { row: Oe, fieldName: Ne.prop });
    }
  }
  function Be(de, ge) {
    var be;
    return ((be = de.find((ke) => ke.label === ge)) == null ? void 0 : be.value) || "";
  }
  function De(de, ge) {
    var be, ke;
    return ((ke = (be = d.value[de]) == null ? void 0 : be.find((Ne) => Ne.label === ge)) == null ? void 0 : ke.value) || "";
  }
  async function Fe(de, ge, be) {
    const ke = await xe(de, ge);
    if (!ke)
      return void operatorErrorTip("参照数据获取失败，数据填充失败");
    de.forEach((Ne, Oe) => {
      const Pe = be + Oe;
      ge.forEach((Te, Le) => {
        const Ae = t[Pe] || {};
        if (Pe < t.length ? a(Ae) : l(Ae, Pe), _e(Pe, Te.prop, Ae))
          return;
        const Re = Ne[Le];
        if (!isBlank(Re)) {
          if (Te.itemType === "select")
            Ae[Te.prop] = Te.code ? De(Te.code, Re) : Be(Te.options, Re);
          else if (Te.itemType === "refer") {
            const { referData: Ve, allFields: Ie } = ke[Te.code], ze = Ve == null ? void 0 : Ve[Re];
            if (ze && ze.length === 1) {
              const [He] = ze;
              Ie.forEach((Ue) => {
                Ae[Ue] = He[Ue];
              });
            } else
              r.add(generatorKey(Pe, Te.prop)), Ae[Te.prop] = Re;
          } else Te.itemType === "number" ? Ae[Te.prop] = isNumber(Re) ? Number(Re) : isPrettierNumber(Re) ? Number(Re.replaceAll(",", "")) : void 0 : Te.itemType === "checkbox" ? Ae[Te.prop] = ["是", "1", "true", "TRUE"].includes(
            Re.trim()
          ) : Ae[Te.prop] = Re;
          s("cellEdit", {
            rowIndex: Pe,
            fieldName: Te.prop,
            scope: {
              $index: Pe,
              row: Ae
            }
          });
        }
      });
    });
  }
  function Me() {
    var de;
    return (de = navigator.clipboard) == null ? void 0 : de.readText().then((ge) => ge).catch(() => {
      operatorErrorTip(
        "无法访问剪切板，请检查浏览器设置中是否开启相关权限或更新浏览器后重试"
      );
    });
  }
  async function xe(de, ge) {
    const be = ge.filter((Pe) => Pe.itemType === "refer" && Pe.code);
    if (!be.length)
      return {};
    const ke = {
      cPersonUuid: p.value.cPersonUuid,
      cOrgUuid: p.value.cOrgUuid,
      cAccUuid: p.value.cAccUuid
    }, { params: Ne, codeValue: Oe } = be.reduce(
      (Pe, Te, Le) => {
        var Re, Ve, Ie, ze;
        const Ae = de.map((He) => He[Le]).filter(Boolean);
        return Ae.length && (Te.multiple && !Te.portraitFill && (Pe.codeValue[Te.code] = Ae), Pe.params.push({
          cReferCode: Te.code,
          cWhere: encryptAES(
            ((Re = Te.listOption) == null ? void 0 : Re.where) || ((Ve = Te.treeOption) == null ? void 0 : Ve.where) || ""
          ),
          queryConditionList: (Ie = Te.listOption) == null ? void 0 : Ie.query,
          cFilterField: encryptAES(
            ((ze = b.value) == null ? void 0 : ze[Te.prop]) || Te.prop
          ),
          cFilterValue: encryptAES(
            toEscapeCharset(Ae.join(","))
          ),
          ...ke
        })), Pe;
      },
      {
        codeValue: {},
        params: []
      }
    );
    return Ne.length === 0 ? {} : Promise.all(Ne.map(apiGetReferDataByCode)).then((Pe) => Pe.every((Le) => Le.code === 1) ? Pe.reduce((Le, Ae) => {
      const { cSaveField: Re, cShowField: Ve } = Ae.data.referBase, { cReferCode: Ie, referData: ze } = Ae.data, He = Re.split(",").concat(Ve.split(",")), Ue = be.find((Ge) => Ge.code === Ie);
      return Ue.multiple && !Ue.portraitFill && ze && Oe[Ie].forEach((qe) => {
        const Xe = qe.split(",").map(($e) => ze[$e].length), je = Math.min(...Xe), Ze = Math.max(...Xe);
        if (je !== 1 || Ze !== 1) {
          ze[qe] = [];
          return;
        }
        ze[qe] = [
          He.reduce(
            ($e, Ke) => ($e[Ke] = qe.split(",").reduce((We, Ye) => (We && (We += ","), We += ze[Ye][0][Ke] ?? ""), ""), $e),
            {}
          )
        ];
      }), Le[Ie] = {
        ...Ae.data,
        allFields: He
      }, Le;
    }, {}) : null).catch(() => null);
  }
  function _e(de, ge, be) {
    var Oe;
    const ke = be ?? t[de];
    if (o.value || k.has(ke))
      return !0;
    const Ne = (Oe = f.value) == null ? void 0 : Oe[ge];
    return Ne === !0 || typeof Ne == "function" && Ne({ row: ke, $index: de });
  }
  function Ee(de, ge = !0) {
    ge ? k.add(de) : k.delete(de);
  }
  function re(de) {
    return k.has(de);
  }
  const ce = /\b(el-table__cell|el-time-panel|el-picker-panel|el-overlay-message-box|el-overlay-dialog|el-popper)\b/i;
  function ye(de) {
    (de.path || de.composedPath()).some((be) => {
      var ke, Ne;
      return be.className && !!~((Ne = (ke = be.className).search) == null ? void 0 : Ne.call(ke, ce));
    }) || te();
  }
  const me = ref();
  async function ue(de, ge, be) {
    be && (Object.assign(x, {
      index: String(de),
      fieldName: ge
    }), be instanceof HTMLElement ? be.focus() : (await nextTick(), me.value.focus()));
  }
  function ve() {
    Object.assign(x, {
      index: "",
      fieldName: ""
    });
  }
  function we(de) {
    de.key === "Tab" || de.key === "Enter" || de.stopPropagation();
  }
  function Se(de, ge, be) {
    const [ke, Ne] = O.value;
    if (!ke || !Ne || !n.value.slice(ke.x, Ne.x + 1).some((Re) => Re.prop === be.property))
      return;
    const Te = e.value.$el.querySelector(
      ".select-cell-border"
    );
    if (!Te)
      return;
    const Ae = Number.parseInt(Te.style.width) + (de - ge);
    Te.style.width = `${Ae}px`;
  }
  return {
    isLoading: c,
    referFieldMap: z,
    cellEditHandle: me,
    cellSelectRange: O,
    selectAreaOperateMountEl: m,
    fillCount: ee,
    editFlagFmt: N,
    isReadonlyRow: re,
    checkCellDisabled: _e,
    setRowReadonly: Ee,
    clickOutSide: ye,
    cellFocus: ue,
    selectRangeOperate: he,
    onInteractKeydown: we,
    doPaste: fe,
    onHeaderDragend: Se,
    cancelCellSelect: te
  };
}, useData = (e) => {
  const o = useProp("blankRow"), n = useProp("data"), {
    data: t,
    delData: r,
    getInsertData: a,
    getUpdateData: l,
    doInsert: s,
    doUpdate: c,
    doDel: d,
    checkBlankRow: p
  } = useCudData(e);
  watch(n, (ee) => {
    t.length = 0, r.value = [], ee && t.push(...ee);
  });
  const f = o.value === !1 ? 0 : isNumber(o.value) ? o.value : 20;
  f && k(f);
  function g() {
    return t.filter((ee) => !p(ee));
  }
  function b(ee) {
    r.value = [], t.splice(0, t.length, ...ee);
    const z = f - ee.length;
    z > 0 && k(z);
  }
  function k(ee) {
    s(
      Array.from({ length: ee }, () => ({}))
    );
  }
  function x(ee, z) {
    const P = isNumber(z) ? z : 1;
    s(
      Array.from({ length: P }, () => ({})),
      ee + 1
    );
  }
  function N(ee, z) {
    z === !0 ? b(ee) : (ee = [...ee], t.forEach((P, V) => {
      p(P) && (t[V] = {
        ...ee.shift(),
        [ROW_STATE]: INSERT_ROW
      });
    }), ee.length && s(ee));
  }
  function O(ee, z) {
    let P = [...t].reverse().findIndex((V) => p(V));
    if (P === -1 ? P = 0 : P = t.length - P, z) {
      const V = [...t];
      ee.forEach((U) => {
        const E = V.findIndex((C) => U[z] === C[z]);
        ~E ? (c(Object.assign(t[E], U)), V.splice(E, 1)) : (t[P] = U, c(t[P]));
      });
    } else
      t.splice(
        P,
        ee.length,
        ...ee.map((V) => c({ ...V }))
      );
  }
  function m(ee) {
    d(ee);
  }
  return {
    tableValue: t,
    delData: r,
    doUpdate: c,
    doInsert: s,
    appendBlankRow: x,
    removeRow: m,
    getTableData: g,
    setTableData: b,
    getTableAddData: a,
    getTableEditData: l,
    setTableNewData: N,
    setTableEditData: O,
    checkBlankRow: p
  };
}, useHeaderCheckbox = (e) => {
  const o = ({
    sn: t,
    value: r,
    disabled: a
  }) => {
    const l = (d) => {
      r.forEach((p, f) => {
        typeof t.selectable == "function" && !t.selectable(p, f) || (p[t.prop] = d);
      });
    }, s = r.every((d) => !!d[t.prop]), c = r.some((d) => !!d[t.prop]);
    return /* @__PURE__ */ React.createElement(
      ElCheckbox,
      {
        disabled: a,
        modelValue: s,
        indeterminate: c && !s,
        onChange: l
      }
    );
  };
  return {
    headerCheckboxSlots: computed(() => e.value.filter((t) => t.itemType === "checkbox" && t.selectAll)),
    HeaderCheckbox: o
  };
}, useSchema = (e) => {
  const o = useProp("rules"), n = useProp("schema"), t = useProp("fieldConfig"), r = useProp("tips"), a = computed(() => {
    var c;
    let s = [];
    return (c = n.value) != null && c.length ? s = n.value : s = e.value.filter((d) => d.show), s.map((d) => {
      var f, g, b;
      const p = d.required ?? [(f = o.value) == null ? void 0 : f[d.prop]].flat().some((k) => k == null ? void 0 : k.required);
      return {
        isHeaderSlots: d.itemType === "checkbox" && d.selectAll,
        ...d,
        // fieldConfig 合并到 schema 中
        ...(g = t.value) == null ? void 0 : g[d.prop],
        // 暂时只允许左侧浮动
        fixed: [!0, "left"].includes(d.fixed),
        tips: d.tips || ((b = r.value) == null ? void 0 : b[d.prop]),
        required: p,
        labelClassName: p ? "is-required" : ""
      };
    });
  }), l = computed(() => a.value.reduce(
    (s, c) => {
      var d, p;
      if ((d = s[c.prop]) != null && d.required)
        return s[c.prop] = [s[c.prop]], s;
      if ((p = s[c.prop]) != null && p.some((f) => f.required))
        return s;
      if (c.required && c.itemType !== "checkbox") {
        const f = {
          required: !0,
          message: `请${["input", "number"].includes(c.itemType) ? "输入" : "选择"}${c.label}`
        };
        isArray(s[c.prop]) ? s[c.prop].unshift(f) : isPlainObject(s[c.prop]) ? s[c.prop] = [
          f,
          s[c.prop]
        ] : s[c.prop] = [f];
      }
      return s;
    },
    { ...o.value }
  ));
  return {
    schema: a,
    rules: l
  };
}, useValidate = (e, o, n, t, r) => {
  const a = useProp("rowEdit"), l = useProp("inlineMessage"), s = reactive(/* @__PURE__ */ new Map()), c = reactive(/* @__PURE__ */ new Set());
  watch(
    () => s,
    (b) => {
      const k = e.value.$el.querySelector(".el-table__body");
      k.querySelectorAll("td[data-error]").forEach((x) => {
        x.removeAttribute("data-error");
      }), b.forEach((x, N) => {
        const [O, m] = splitKey(N), ee = o.value.findIndex((P) => P.prop === m), z = k.querySelectorAll(
          `tr:nth-child(${+O + 1}) td:not(.no-interaction)`
        ).item(ee);
        z && z.setAttribute("data-error", x);
      });
    },
    { deep: !0 }
  );
  function d(b, k) {
    const x = e.value.instanceRef.scrollBarRef.wrapRef, N = x.querySelectorAll(
      `table tr:nth-child(${b + 1}) td:not(.no-interaction)`
    ).item(k);
    (x.offsetWidth < x.scrollWidth || x.offsetHeight < x.scrollHeight) && x.scrollTo({
      top: N.offsetTop,
      left: N.offsetLeft - indexColWidth - (a.value ? editOperationColWidth : 0),
      behavior: "smooth"
    });
  }
  function p(b) {
    var N;
    if (typeof b == "string" && (b = [b]), s.clear(), isEmptyObject(n.value) && c.size === 0)
      return !0;
    function k(O) {
      return O == null || O === "";
    }
    function x(O, m, ee) {
      const z = o.value.findIndex((P) => P.prop === m);
      return d(O, z), s.set(
        generatorKey(O, o.value[z].prop),
        ee
      ), l.value ? !1 : !operatorErrorTip(
        `【${O + 1}行：${o.value[z].label || ""}】${ee}`
      );
    }
    for (let O = 0; O < t.length; O++) {
      if (r(t[O]))
        continue;
      const m = t[O];
      for (let ee = 0; ee < b.length; ee++) {
        if (c.has(generatorKey(O, b[ee]))) {
          const P = o.value.findIndex((V) => V.prop === b[ee]);
          return d(O, P), !1;
        }
        const z = n.value[b[ee]];
        if (z)
          for (const P of z) {
            if (P.required && k(m[b[ee]]))
              return x(
                O,
                b[ee],
                P.message || "本项必填"
              );
            if (P.pattern && !P.pattern.test(m[b[ee]]))
              return x(
                O,
                b[ee],
                P.message || "格式有误"
              );
            const V = (N = P.validator) == null ? void 0 : N.call(P, m, 1, t);
            if (V === !1 || typeof V == "string" && V)
              return x(
                O,
                b[ee],
                P.message || V
              );
          }
      }
    }
    return !0;
  }
  function f() {
    const b = Object.keys(n.value), k = [...c.values()].map((O) => splitKey(O)[1]), x = /* @__PURE__ */ new Set([...b, ...k]), N = o.value.filter((O) => x.has(O.prop)).map((O) => O.prop);
    return p(N);
  }
  function g() {
    s.clear(), c.clear();
  }
  return {
    errorItemMap: s,
    pasteDuplicateSet: c,
    validate: f,
    validateField: p,
    clearValidate: g
  };
}, _sfc_main$5 = /* @__PURE__ */ defineComponent({
  name: "alc-table",
  inheritAttrs: !1,
  __name: "table",
  props: {
    code: {},
    loading: { type: Boolean },
    title: {},
    showTitle: { type: Boolean },
    height: { default: "100%" },
    maxHeight: {},
    schema: {},
    data: {},
    rowEdit: { type: [Boolean, String], default: !0 },
    blankRow: { type: [Boolean, Number], default: 20 },
    operation: {},
    operationWidth: {},
    operationTips: {},
    disabled: { type: Boolean },
    tips: {},
    fieldReadonly: {},
    fieldConfig: {},
    cellConfig: {},
    rules: {},
    inlineMessage: { type: Boolean, default: !0 },
    beforeAdd: {},
    beforeRemove: {},
    addButtonText: { default: "添加数据" },
    codeFieldName: {},
    modifyLayout: { type: Boolean, default: !0 },
    referQueryAlias: {},
    cellClassName: {},
    cellStyle: {},
    rowClassName: {},
    rowStyle: {},
    summaryMethod: {}
  },
  emits: ["layoutLoaded", "cellEdit", "cellClear", "currentChange", "openedReferChoose", "operationClick"],
  setup(e, { expose: o, emit: n }) {
    const t = e, r = n, a = useSlots(), l = useFormDisabled(), s = ref(), { isFetch: c, tableFile: d, listSchema: p, initLayout: f } = useTableArchive(
      toRef(t, "code")
    );
    t.schema || f().then(() => {
      r("layoutLoaded");
    });
    const {
      tableValue: g,
      delData: b,
      doUpdate: k,
      doInsert: x,
      appendBlankRow: N,
      removeRow: O,
      getTableData: m,
      setTableData: ee,
      getTableAddData: z,
      getTableEditData: P,
      setTableNewData: V,
      setTableEditData: U,
      checkBlankRow: E
    } = useData(t.data), { schema: C, rules: I } = useSchema(p), {
      errorItemMap: v,
      pasteDuplicateSet: M,
      validate: $,
      validateField: H,
      clearValidate: X
    } = useValidate(s, C, I, g, E), {
      selectAreaOperateMountEl: te,
      cellSelectRange: oe,
      fillCount: ne,
      isLoading: ie,
      cellEditHandle: se,
      editFlagFmt: pe,
      referFieldMap: he,
      selectRangeOperate: ae,
      isReadonlyRow: le,
      checkCellDisabled: fe,
      setRowReadonly: Ce,
      clickOutSide: Be,
      cellFocus: De,
      onInteractKeydown: Fe,
      doPaste: Me,
      onHeaderDragend: xe,
      cancelCellSelect: _e
    } = useAccessibility(
      s,
      l,
      C,
      g,
      M,
      k,
      x
    ), { headerCheckboxSlots: Ee, HeaderCheckbox: re } = useHeaderCheckbox(C), ce = computed(() => t.loading || c.value || ie.value), ye = [
      {
        command: 5,
        label: "添加5行"
      },
      {
        command: 10,
        label: "添加10行"
      }
    ];
    async function me(Ae) {
      const Re = Ae.triggerEl.closest("tr");
      let Ve = 0, Ie = Re.rowIndex;
      for (; Ve < Ae.command; )
        await Ne({
          $index: Ie,
          row: g[Ie]
        }), Ie++, Ve++;
    }
    async function ue(Ae) {
      let Re = 0;
      for (; Re < Ae; )
        await Ne({
          $index: g.length - 1,
          row: g.at(-1) || {}
        }), Re++;
    }
    const ve = computed(() => t.showTitle || t.title || a.extra ? t.title || d.value.baseList.cListName : void 0);
    function we(Ae) {
      return Ae === "checkbox" || Ae === "boolean";
    }
    function Se(Ae) {
      const { rowIndex: Re, column: Ve } = Ae, Ie = typeof t.cellClassName == "function" ? t.cellClassName(Ae) : isBlank(t.cellClassName) ? "" : t.cellClassName;
      if (!Ve.property || Ve.property === "$operation" || fe(Re, Ve.property))
        return Ie;
      const ze = generatorKey(Re, Ve.property), He = C.value.findIndex(
        (Ue) => Ue.prop === Ve.property
      );
      return normalizeClass([
        Ie,
        {
          // 设置了 itemType 就可以编辑
          "alc-cpt-table-cell-editable": !!C.value[He].itemType,
          // 校验不通过的单元格
          "alc-cpt-table-cell-highlight": v.has(ze),
          // 粘贴时数据来源不明确的单元格
          "paste-duplicate": M.has(ze)
        }
      ]);
    }
    function de(Ae, Re) {
      if (!Re.property)
        return;
      const Ve = g.findIndex((ze) => ze === Ae);
      if (fe(Ve, Re.property))
        return;
      const Ie = C.value.find((ze) => ze.prop === Re.property);
      De(Ve, Ie.prop, Ie.itemType);
    }
    function ge(Ae, Re) {
      const Ve = generatorKey(Re.$index, Ae);
      v.delete(Ve), M.delete(Ve), k(Re.row), r("cellEdit", {
        rowIndex: Re.$index,
        fieldName: Ae,
        scope: Re
      });
    }
    function be(Ae, Re, Ve) {
      if (he.set(Re, `${Ae.saveField},${Ae.showField}`), isPlainObject(Ae.referValue))
        Object.keys(Ae.referValue).forEach((Ie) => {
          Ve.row[Ie] = Ae.referValue[Ie];
        });
      else if (isArray(Ae.referValue) && Ae.isPortraitFill === !1)
        Ve.row[Ae.showField] = Ae.referValue.map((Ie) => Ie[Ae.showField]).filter(Boolean).join(","), Ae.saveField && Ae.saveField.split(",").forEach((Ie) => {
          Ve.row[Ie] = Ae.referValue.map((ze) => ze[Ie]).filter(Boolean).join(",");
        });
      else if (isArray(Ae.referValue) && Ae.isPortraitFill === !0) {
        const Ie = [...Ae.referValue];
        Object.assign(Ve.row, Ie.shift());
        for (let ze = Ve.$index + 1; ze < g.length; ze++)
          E(g[ze]) && Object.assign(g[ze], Ie.shift(), {
            [ROW_STATE]: INSERT_ROW
          });
        Ie.length > 0 && x(Ie.map(deepClone));
      }
      ge(Re, Ve);
    }
    function ke(Ae, Re) {
      if (!(!t.cellConfig || typeof t.cellConfig[Ae] != "function"))
        return t.cellConfig[Ae](Re);
    }
    async function Ne(Ae) {
      typeof t.beforeAdd == "function" && !await syncReturnBoolean(t.beforeAdd, Ae.$index + 1, Ae) || N(Ae.$index);
    }
    async function Oe(Ae) {
      typeof t.beforeRemove == "function" && !await syncReturnBoolean(t.beforeRemove, Ae) || Pe(Ae.$index);
    }
    function Pe(Ae) {
      O(Ae), _e();
      const Re = /* @__PURE__ */ new Set();
      M.forEach((Ie) => {
        const [ze, He] = splitKey(Ie);
        +ze === Ae ? M.delete(Ie) : +ze > Ae && (M.delete(Ie), Re.add(generatorKey(+ze - 1, He)));
      }), Re.forEach((Ie) => {
        M.add(Ie);
      }), Re.clear();
      const Ve = /* @__PURE__ */ new Map();
      v.forEach((Ie, ze) => {
        const [He, Ue] = splitKey(ze);
        +He === Ae ? v.delete(ze) : +He > Ae && (v.delete(ze), Ve.set(generatorKey(+He - 1, Ue), Ie));
      }), Ve.forEach((Ie, ze) => {
        v.set(ze, Ie);
      }), Ve.clear();
    }
    function Te(Ae, Re) {
      l.value || r("currentChange", Ae, Re);
    }
    o({
      tableValue: g,
      delData: b,
      tableHandle: s,
      getInstance() {
        return s.value.instanceRef;
      },
      getRowDataByIndex(Ae) {
        return g[Ae];
      },
      setRowReadonly: Ce,
      removeRow: Pe,
      appendBlankRow: N,
      getTableData: m,
      setTableData: ee,
      getTableAddData: z,
      getTableEditData: P,
      setTableNewData: V,
      setTableEditData: U,
      pushDelData(...Ae) {
        b.value.push(...Ae);
      },
      clearDelData() {
        b.value = [];
      },
      getTableDeleteData() {
        return b.value;
      },
      validate: $,
      validateField: H,
      clearValidate: X,
      exportData(Ae = {}) {
        let Re = Ae.colInfo;
        Re || (Re = C.value.reduce(
          (Ve, Ie) => (Ve[Ie.prop] = {
            label: Ie.label,
            wpx: Ie.width,
            fieldType: Ie.itemType,
            fieldTypeCode: getDisplayStringFormatCode(Ie)
          }, Ve),
          {}
        )), exportToExcel(m(), {
          fileName: `导出_${t.title || d.value.baseList.cListName || "未命名文件"}_${Date.now()}`,
          ...Ae,
          colInfo: Re
        });
      }
    });
    const Le = { props: t, emits: r, slots: a, isDisabled: l, tableHandle: s, isFetch: c, tableFile: d, listSchema: p, initLayout: f, tableValue: g, delData: b, doUpdate: k, doInsert: x, appendBlankRow: N, removeRow: O, getTableData: m, setTableData: ee, getTableAddData: z, getTableEditData: P, setTableNewData: V, setTableEditData: U, checkBlankRow: E, schema$: C, rules$: I, errorItemMap: v, pasteDuplicateSet: M, validate: $, validateField: H, clearValidate: X, selectAreaOperateMountEl: te, cellSelectRange: oe, fillCount: ne, isLoading: ie, cellEditHandle: se, editFlagFmt: pe, referFieldMap: he, selectRangeOperate: ae, isReadonlyRow: le, checkCellDisabled: fe, setRowReadonly: Ce, clickOutSide: Be, cellFocus: De, onInteractKeydown: Fe, doPaste: Me, onHeaderDragend: xe, cancelCellSelect: _e, headerCheckboxSlots: Ee, HeaderCheckbox: re, loading$: ce, addRowMenuList: ye, onAddRowContextmenuClick: me, onInitAddRowClick: ue, title$: ve, isDirectEditType: we, cellClassName$: Se, onCellClick: de, onCellContentEdit: ge, onCellContentEditRefer: be, getCellAttr: ke, addRowHandle: Ne, removeRowHandle: Oe, removeRowAndDelIdent: Pe, onCurrentChange: Te, get AlcInput() {
      return AlcInput;
    }, get AlcInputNumber() {
      return AlcInputNumber;
    }, get AlcListNext() {
      return AlcListNext;
    }, AlcColumnSet, get AlcQrcode() {
      return AlcQrcode;
    }, get AlcRefer() {
      return AlcRefer;
    }, get AlcSelect() {
      return AlcSelect;
    }, get AlcTooltip() {
      return AlcTooltip;
    }, AlcVoucherCustomInput, get ElButton() {
      return ElButton;
    }, get ElCheckbox() {
      return ElCheckbox;
    }, get ElDropdown() {
      return ElDropdown;
    }, get ElDropdownItem() {
      return ElDropdownItem;
    }, get ElDropdownMenu() {
      return ElDropdownMenu;
    }, get ElTableColumn() {
      return ElTableColumn;
    }, get vClickOutside() {
      return ClickOutside;
    }, get AlcDialog() {
      return AlcDialog;
    }, get AlcDateTime() {
      return AlcDateTime;
    }, get AlcContextMenu() {
      return AlcContextMenu;
    }, get isBlank() {
      return isBlank;
    }, get editOperationColWidth() {
      return editOperationColWidth;
    }, get editOperationTips() {
      return editOperationTips;
    }, get generatorKey() {
      return generatorKey;
    }, get qrcodeColWidth() {
      return qrcodeColWidth;
    } };
    return Object.defineProperty(Le, "__isScriptSetup", { enumerable: !1, value: !0 }), Le;
  }
}), _hoisted_1$5 = { style: { display: "flex", "flex-flow": "column nowrap", "align-items": "center" } }, _hoisted_2$4 = /* @__PURE__ */ createElementVNode("i", {
  class: "ri-add-line",
  style: { "font-size": "16px", "margin-right": "4px" }
}, null, -1), _hoisted_3$4 = { key: 1 }, _hoisted_4$4 = { class: "alc-cpt-table-row-prefix-operate" }, _hoisted_5$4 = /* @__PURE__ */ createElementVNode("i", { class: "ri-add-line" }, null, -1), _hoisted_6$3 = /* @__PURE__ */ createElementVNode("i", { class: "ri-close-line" }, null, -1), _hoisted_7$3 = ["title"], _hoisted_8$3 = {
  key: 0,
  class: "w100 h100"
}, _hoisted_9$3 = /* @__PURE__ */ createElementVNode("i", { class: "ri-drag-drop-line" }, null, -1), _hoisted_10$2 = /* @__PURE__ */ createElementVNode("div", {
  class: "desc-item",
  "data-hot-key": "Ctrl/⌘ + C"
}, " 复制 ", -1), _hoisted_11$1 = /* @__PURE__ */ createElementVNode("div", {
  class: "desc-item",
  "data-hot-key": "Ctrl/⌘ + V"
}, " 粘贴 ", -1), _hoisted_12$1 = /* @__PURE__ */ createElementVNode("div", {
  class: "desc-item",
  "data-hot-key": "Delete/Backspace"
}, " 清除 ", -1);
function _sfc_render$5(e, o, n, t, r, a) {
  var s;
  const l = resolveDirective("load-on");
  return openBlock(), createElementBlock(Fragment, null, [
    withDirectives((openBlock(), createBlock(t.AlcListNext, {
      ref: "tableHandle",
      title: t.title$,
      schema: t.schema$,
      data: t.tableValue,
      operation: n.operation,
      "operation-width": n.operationWidth,
      "operation-tips": n.operationTips,
      "highlight-current-row": !1,
      height: n.height,
      "max-height": n.maxHeight,
      "summary-method": n.summaryMethod,
      "cell-class-name": t.cellClassName$,
      "cell-style": n.cellStyle,
      "row-class-name": n.rowClassName,
      "row-style": n.rowStyle,
      style: normalizeStyle(e.$attrs.style),
      class: normalizeClass(["alc-component-table-container", e.$attrs.class]),
      stripe: !1,
      border: "",
      onCellDblclick: t.onCellClick,
      onCurrentChange: t.onCurrentChange,
      onOperationClick: o[12] || (o[12] = (c) => e.$emit("operationClick", c)),
      onHeaderDragend: t.onHeaderDragend,
      onPaste: t.doPaste
    }, createSlots({
      empty: withCtx(() => [
        createElementVNode("div", _hoisted_1$5, [
          createVNode(t.ElDropdown, {
            disabled: n.disabled,
            "split-button": "",
            type: "primary",
            onClick: o[0] || (o[0] = (c) => t.onInitAddRowClick(1)),
            onCommand: t.onInitAddRowClick
          }, {
            dropdown: withCtx(() => [
              createVNode(t.ElDropdownMenu, null, {
                default: withCtx(() => [
                  createVNode(t.ElDropdownItem, { command: 5 }, {
                    default: withCtx(() => [
                      createTextVNode(" 5行 ")
                    ]),
                    _: 1
                  }),
                  createVNode(t.ElDropdownItem, { command: 10 }, {
                    default: withCtx(() => [
                      createTextVNode(" 10行 ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: withCtx(() => [
              _hoisted_2$4,
              createTextVNode(" " + toDisplayString$1(n.addButtonText) + " ", 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      indexHeader: withCtx(() => [
        renderSlot(e.$slots, "indexHeader", {}, () => [
          n.code && n.modifyLayout && !t.isDisabled ? (openBlock(), createBlock(t.AlcDialog, {
            key: 0,
            title: "栏目设置",
            "width-type": "md",
            draggable: "",
            "show-fullscreen": "",
            "close-on-click-modal": "",
            "close-on-press-escape": "",
            "content-height-fit": ""
          }, {
            reference: withCtx(() => [
              createVNode(t.ElButton, {
                loading: !t.isDisabled && t.isFetch,
                class: "ri-list-settings-line alc-list-set__icon",
                link: "",
                title: "栏目设置"
              }, null, 8, ["loading"])
            ]),
            default: withCtx(() => [
              createVNode(t.AlcColumnSet, {
                ref: "columnSetHandle",
                type: "table",
                code: n.code,
                "user-plan": t.tableFile.bHasPersonPlan,
                onChange: t.initLayout
              }, null, 8, ["code", "user-plan", "onChange"])
            ]),
            _: 1
          })) : (openBlock(), createElementBlock("span", _hoisted_3$4, "序号"))
        ])
      ]),
      columns: withCtx((c) => [
        n.rowEdit && !t.isDisabled ? (openBlock(), createBlock(t.ElTableColumn, {
          key: 0,
          resizable: !1,
          "label-class-name": c.labelClassName,
          "class-name": c.className,
          width: t.editOperationColWidth,
          fixed: "left",
          align: "center"
        }, {
          header: withCtx(() => [
            createVNode(t.AlcTooltip, {
              content: t.editOperationTips,
              style: { margin: "0" },
              tabindex: null
            }, null, 8, ["content"])
          ]),
          default: withCtx((d) => [
            createElementVNode("div", _hoisted_4$4, [
              (typeof n.rowEdit == "string" ? n.rowEdit === "add" : n.rowEdit) ? (openBlock(), createBlock(t.ElButton, {
                key: 0,
                type: "primary",
                link: "",
                class: "alc-cpt-table-row-add",
                title: "添加行",
                onClick: withModifiers((p) => t.addRowHandle(d), ["stop"])
              }, {
                default: withCtx(() => [
                  _hoisted_5$4
                ]),
                _: 2
              }, 1032, ["onClick"])) : createCommentVNode("", !0),
              (typeof n.rowEdit == "string" ? n.rowEdit === "delete" : n.rowEdit) ? (openBlock(), createBlock(t.ElButton, {
                key: 1,
                disabled: t.isReadonlyRow(d.row),
                link: "",
                type: "danger",
                title: "删除行",
                onClick: withModifiers((p) => t.removeRowHandle(d), ["stop"])
              }, {
                default: withCtx(() => [
                  _hoisted_6$3
                ]),
                _: 2
              }, 1032, ["disabled", "onClick"])) : createCommentVNode("", !0)
            ])
          ]),
          _: 2
        }, 1032, ["label-class-name", "class-name", "width"])) : createCommentVNode("", !0),
        n.codeFieldName ? (openBlock(), createBlock(t.ElTableColumn, {
          key: 1,
          resizable: !1,
          "label-class-name": c.labelClassName,
          "class-name": c.className,
          width: t.qrcodeColWidth,
          align: "center"
        }, {
          default: withCtx(({ row: d }) => [
            createVNode(t.AlcQrcode, {
              value: d[n.codeFieldName],
              size: 32,
              margin: 0,
              class: "qr_vertical-align"
            }, null, 8, ["value"])
          ]),
          _: 2
        }, 1032, ["label-class-name", "class-name", "width"])) : createCommentVNode("", !0)
      ]),
      cell: withCtx(({ item: c, ...d }) => [
        t.isDirectEditType(c.itemType) ? (openBlock(), createElementBlock("div", _hoisted_8$3, [
          createVNode(t.ElCheckbox, mergeProps(t.getCellAttr(c.prop, d), {
            modelValue: d.row[c.prop],
            "onUpdate:modelValue": (p) => d.row[c.prop] = p,
            disabled: t.checkCellDisabled(d.$index, c.prop),
            label: "",
            onChange: (p) => t.onCellContentEdit(c.prop, d)
          }), null, 16, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"])
        ])) : t.generatorKey(d.$index, c.prop) === t.editFlagFmt ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
          c.itemType === "input" ? (openBlock(), createBlock(t.AlcInput, mergeProps({
            key: 0,
            ref: "cellEditHandle"
          }, t.getCellAttr(c.prop, d), {
            modelValue: d.row[c.prop],
            "onUpdate:modelValue": (p) => d.row[c.prop] = p,
            clearable: !1,
            onChange: (p) => t.onCellContentEdit(c.prop, d),
            onPaste: o[1] || (o[1] = withModifiers(() => {
            }, ["stop"])),
            onMousedown: o[2] || (o[2] = withModifiers(() => {
            }, ["stop"])),
            onKeydown: t.onInteractKeydown
          }), null, 16, ["modelValue", "onUpdate:modelValue", "onChange", "onKeydown"])) : c.itemType === "number" ? (openBlock(), createBlock(t.AlcInputNumber, mergeProps({
            key: 1,
            ref: "cellEditHandle"
          }, t.getCellAttr(c.prop, d), {
            modelValue: d.row[c.prop],
            "onUpdate:modelValue": (p) => d.row[c.prop] = p,
            min: c.min,
            max: c.max,
            precision: c.precision || c.code,
            clearable: !1,
            onChange: (p) => t.onCellContentEdit(c.prop, d),
            onPaste: o[3] || (o[3] = withModifiers(() => {
            }, ["stop"])),
            onMousedown: o[4] || (o[4] = withModifiers(() => {
            }, ["stop"])),
            onKeydown: t.onInteractKeydown
          }), null, 16, ["modelValue", "onUpdate:modelValue", "min", "max", "precision", "onChange", "onKeydown"])) : c.itemType === "date" ? (openBlock(), createBlock(t.AlcDateTime, mergeProps({
            key: 2,
            ref: "cellEditHandle"
          }, {
            ...c,
            ...t.getCellAttr(c.prop, d)
          }, {
            modelValue: d.row[c.prop],
            "onUpdate:modelValue": (p) => d.row[c.prop] = p,
            type: c.type,
            format: c.format,
            range: c.range,
            clearable: !1,
            onChange: (p) => t.onCellContentEdit(c.prop, d),
            onPaste: o[5] || (o[5] = withModifiers(() => {
            }, ["stop"])),
            onMousedown: o[6] || (o[6] = withModifiers(() => {
            }, ["stop"])),
            onKeydown: t.onInteractKeydown
          }), null, 16, ["modelValue", "onUpdate:modelValue", "type", "format", "range", "onChange", "onKeydown"])) : c.itemType === "select" ? (openBlock(), createBlock(t.AlcSelect, mergeProps({
            key: 3,
            ref: "cellEditHandle"
          }, t.getCellAttr(c.prop, d), {
            modelValue: d.row[c.prop],
            "onUpdate:modelValue": (p) => d.row[c.prop] = p,
            options: c.options,
            multiple: c.multiple,
            code: c.code,
            clearable: !1,
            onChange: (p) => t.onCellContentEdit(c.prop, d),
            onMousedown: o[7] || (o[7] = withModifiers(() => {
            }, ["stop"])),
            onKeydown: t.onInteractKeydown
          }), null, 16, ["modelValue", "onUpdate:modelValue", "options", "multiple", "code", "onChange", "onKeydown"])) : c.itemType === "refer" ? (openBlock(), createBlock(t.AlcRefer, mergeProps({
            key: 4,
            ref: "cellEditHandle",
            multiple: c.multiple,
            "portrait-fill": c.portraitFill,
            "tree-option": c.treeOption,
            "list-option": c.listOption,
            code: c.code || ""
          }, t.getCellAttr(c.prop, d), {
            "model-value": d.row,
            clearable: !1,
            onChange: (p) => {
              t.onCellContentEditRefer(p, c.prop, d);
            },
            onClear: o[8] || (o[8] = (p) => t.selectRangeOperate("delete")),
            onOpenedChoose: (p) => e.$emit("openedReferChoose", {
              ...p,
              fieldName: c.prop,
              scope: d
            }),
            onMousedown: o[9] || (o[9] = withModifiers(() => {
            }, ["stop"]))
          }), null, 16, ["multiple", "portrait-fill", "tree-option", "list-option", "code", "model-value", "onChange", "onOpenedChoose"])) : c.itemType === "custom-item" ? (openBlock(), createBlock(t.AlcVoucherCustomInput, {
            key: 5,
            ref: "cellEditHandle",
            modelValue: d.row[c.prop],
            "onUpdate:modelValue": (p) => d.row[c.prop] = p,
            type: c.type,
            "data-type": c.dataType,
            formula: c.formula,
            "relation-data": { ...d.row, ...c.relationData },
            "table-uuid": c.tableUuid,
            "field-uuid": c.fieldUuid,
            precision: c.precision,
            maxlength: c.maxlength,
            multiple: c.multiple,
            "field-name": c.prop,
            "portrait-fill": c.portraitFill,
            clearable: !1,
            onChange: (p) => {
              t.onCellContentEditRefer(p, c.prop, d);
            },
            onPaste: o[10] || (o[10] = withModifiers(() => {
            }, ["prevent"])),
            onMousedown: o[11] || (o[11] = withModifiers(() => {
            }, ["stop"])),
            onKeydown: t.onInteractKeydown
          }, null, 8, ["modelValue", "onUpdate:modelValue", "type", "data-type", "formula", "relation-data", "table-uuid", "field-uuid", "precision", "maxlength", "multiple", "field-name", "portrait-fill", "onChange", "onKeydown"])) : createCommentVNode("", !0)
        ], 64)) : createCommentVNode("", !0)
      ]),
      _: 2
    }, [
      e.$slots.extra ? {
        name: "extra",
        fn: withCtx(() => [
          renderSlot(e.$slots, "extra")
        ]),
        key: "0"
      } : void 0,
      renderList(t.headerCheckboxSlots, (c) => ({
        name: `${c.prop}Header`,
        fn: withCtx(() => [
          createVNode(t.HeaderCheckbox, {
            sn: c,
            value: t.tableValue,
            disabled: n.disabled,
            style: { height: "unset", "margin-right": "4px" }
          }, null, 8, ["sn", "value", "disabled"]),
          createElementVNode("div", {
            class: "single-line-overflow header-cell__title",
            title: c.label
          }, toDisplayString$1(c.label), 9, _hoisted_7$3),
          t.isBlank(c.tips) ? createCommentVNode("", !0) : (openBlock(), createBlock(t.AlcTooltip, {
            key: 0,
            content: c.tips,
            tabindex: null
          }, null, 8, ["content"]))
        ])
      }))
    ]), 1032, ["title", "schema", "data", "operation", "operation-width", "operation-tips", "height", "max-height", "summary-method", "cell-style", "row-class-name", "row-style", "style", "class", "onHeaderDragend", "onPaste"])), [
      [t.vClickOutside, t.clickOutSide],
      [l, t.loading$]
    ]),
    createVNode(t.AlcContextMenu, {
      selector: (s = t.tableHandle) == null ? void 0 : s.$el,
      delegate: ".alc-cpt-table-row-add",
      "menu-list": t.addRowMenuList,
      onItemClick: t.onAddRowContextmenuClick
    }, null, 8, ["selector"]),
    t.selectAreaOperateMountEl ? (openBlock(), createBlock(Transition$1, {
      key: 0,
      name: "el-zoom-in-top",
      appear: ""
    }, {
      default: withCtx(() => [
        (openBlock(), createBlock(Teleport, { to: ".select-cell-border" }, [
          createVNode(t.ElDropdown, {
            trigger: "hover",
            class: "area-operate__trigger",
            "popper-class": "area-operate__menu",
            onCommand: t.selectRangeOperate,
            onMousedown: o[16] || (o[16] = withModifiers(() => {
            }, ["stop"])),
            tabindex: "-1"
          }, {
            dropdown: withCtx(() => [
              createVNode(t.ElDropdownMenu, null, {
                default: withCtx(() => {
                  var c, d;
                  return [
                    createVNode(t.ElDropdownItem, { command: "copy" }, {
                      default: withCtx(() => [
                        _hoisted_10$2
                      ]),
                      _: 1
                    }),
                    t.isDisabled ? createCommentVNode("", !0) : (openBlock(), createBlock(t.ElDropdownItem, {
                      key: 0,
                      command: "paste"
                    }, {
                      default: withCtx(() => [
                        _hoisted_11$1
                      ]),
                      _: 1
                    })),
                    t.isDisabled ? createCommentVNode("", !0) : (openBlock(), createBlock(t.ElDropdownItem, {
                      key: 1,
                      command: "delete"
                    }, {
                      default: withCtx(() => [
                        _hoisted_12$1
                      ]),
                      _: 1
                    })),
                    !t.isDisabled && ((c = t.cellSelectRange[0]) == null ? void 0 : c.x) === ((d = t.cellSelectRange[1]) == null ? void 0 : d.x) ? (openBlock(), createBlock(t.ElDropdownItem, {
                      key: 2,
                      command: "fill",
                      divided: ""
                    }, {
                      default: withCtx(() => [
                        createTextVNode(" 向下填充 "),
                        createVNode(t.AlcInputNumber, {
                          min: 1,
                          max: 50,
                          modelValue: t.fillCount,
                          "onUpdate:modelValue": o[13] || (o[13] = (p) => t.fillCount = p),
                          class: "fill-input",
                          onClick: o[14] || (o[14] = withModifiers(() => {
                          }, ["stop"])),
                          onEnter: o[15] || (o[15] = (p) => t.selectRangeOperate("fill")),
                          size: "small"
                        }, null, 8, ["modelValue"]),
                        createTextVNode(" 个单元格 ")
                      ]),
                      _: 1
                    })) : createCommentVNode("", !0)
                  ];
                }),
                _: 1
              })
            ]),
            default: withCtx(() => [
              _hoisted_9$3
            ]),
            _: 1
          }, 8, ["onCommand"])
        ]))
      ]),
      _: 1
    })) : createCommentVNode("", !0)
  ], 64);
}
const Table = /* @__PURE__ */ _export_sfc(_sfc_main$5, [["render", _sfc_render$5], ["__file", "table.vue"]]), AlcTable = withInstall(Table), _sfc_main$4 = defineComponent({
  name: "alc-toolbar-set",
  components: {
    AlcDialogFooter,
    AlcInputNumber,
    AlcTooltip,
    Draggable,
    ElInput,
    ElButton,
    ElCheckbox,
    ElScrollbar,
    ElRadioGroup,
    ElRadioButton
  },
  props: {
    // 父级组件当前方案 默认：false
    userPlan: { type: Boolean, required: !0, default: !1 }
  },
  emits: ["modalConfirm"],
  setup(e, o) {
    const n = useProviderConfig("state"), t = reactive({
      // 目标组件参数
      params: {},
      // 当前选择的方案类型标识
      planType: e.userPlan ? 3 : 2,
      // 工具栏布局方案（全部）
      toolbarLayout: {
        // 是否存在组件方案
        orgPlan: !1,
        // 是否存在个人方案
        userPlan: !1,
        // 工具栏布局信息
        layout: {
          zoneA: { buttonList: [] },
          zoneB: { buttonList: [] },
          zoneC: { buttonList: [] }
        },
        // 工具栏方案信息
        plan: {}
      },
      // 单元格编辑标识
      editFlag: {
        cEventName: "",
        cButtonName: ""
      },
      // 单元格编辑框操作句柄
      cellInputEditHandle: null,
      // 恢复默认按钮loading标识
      defaultSchemeLoading: !1,
      // 保存设置按钮loading标识
      saveSchemeLoading: !1,
      // 快速设置排序 目标序号
      targetSortIndex: 1
    });
    function r(V) {
      s(V).then((U) => {
        U.code === 1 && U.data ? p(U.data, !1) : a(!1);
      }).catch(() => {
        apiLinkErrorTip("工具栏设置获取");
      });
    }
    function a(V) {
      O(!0), s(1).then((U) => {
        O(!1), U.code === 1 ? p(U.data, V) : operatorErrorTip(U.msg);
      }).catch(() => {
        O(!1), apiLinkErrorTip("工具栏设置获取");
      });
    }
    function l() {
      const V = t.planType === 2 ? "确认删除组织工具栏设置？" : "确认删除个人工具栏设置？";
      openConfirm(V, {}, (U) => {
        U.action === "confirm" && c().then((E) => {
          E.code === 1 ? (ElMessage.success("工具栏设置删除完成"), a(!1), o.emit("modalConfirm", {})) : operatorErrorTip(E.msg);
        }).catch(() => {
          apiLinkErrorTip("工具栏设置删除");
        });
      });
    }
    function s(V) {
      return msPost(
        `alc-city-framework/SysToolbarAction/toolBarForMenuUuid/${n.value.cMenuUuid}`,
        {
          iPlanType: V,
          cOrgUuid: n.value.cOrgUuid,
          cPersonUuid: n.value.cPersonUuid,
          cZoneType: null
        }
      );
    }
    function c() {
      return msGet(
        `alc-city-framework/SysToolbarAction/delToolBar/${n.value.cMenuUuid}/${n.value.cOrgUuid}/${n.value.cPersonUuid}/${t.planType}`
      );
    }
    function d() {
      const V = {};
      let U = [];
      V.iButtonPlanId = t.toolbarLayout.plan.iButtonPlanId, V.cButtonPlanUuid = t.toolbarLayout.plan.cButtonPlanUuid, V.cMenuUuid = n.value.cMenuUuid, V.cOrgUuid = n.value.cOrgUuid, V.cPersonUuid = n.value.cPersonUuid, t.toolbarLayout.layout.zoneB.buttonList.forEach(
        (C, I) => {
          U.push(C), U[I].iOrder = I + 1;
        }
      ), t.toolbarLayout.plan.iPlanType !== t.planType && (V.iButtonPlanId = null, V.cButtonPlanUuid = null, U = U.concat(
        t.toolbarLayout.layout.zoneA.buttonList
      ), U = U.concat(
        t.toolbarLayout.layout.zoneC.buttonList
      )), V.buttonList = U;
      const E = {
        iPlanType: t.planType,
        buttonPlan: V
      };
      return msPost(
        "alc-city-framework/SysToolbarAction/saveToolBar",
        E
      );
    }
    function p(V, U) {
      V ? (U !== !0 && (t.toolbarLayout.orgPlan = V.planHave.bOrg === !0, t.toolbarLayout.userPlan = V.planHave.bPerson === !0, t.toolbarLayout.plan = {
        iButtonPlanId: V.iButtonPlanId,
        cButtonPlanUuid: V.cButtonPlanUuid,
        cMenuUuid: V.cMenuUuid,
        bInit: V.bInit,
        cPersonUuid: V.cPersonUuid,
        cOrgUuid: V.cOrgUuid,
        iPlanType: V.iPlanType
      }), t.toolbarLayout.layout.zoneA = {
        cButtonPlanUuid: V.zoneA.cButtonPlanUuid,
        cBtnZoneUuid: V.zoneA.cBtnZoneUuid,
        cZoneType: V.zoneA.cZoneType,
        buttonList: V.zoneA.buttonList || []
      }, t.toolbarLayout.layout.zoneB = {
        cButtonPlanUuid: V.zoneB.cButtonPlanUuid,
        cBtnZoneUuid: V.zoneB.cBtnZoneUuid,
        cZoneType: V.zoneB.cZoneType,
        buttonList: V.zoneB.buttonList || []
      }, t.toolbarLayout.layout.zoneC = {
        cButtonPlanUuid: V.zoneC.cButtonPlanUuid,
        cBtnZoneUuid: V.zoneC.cBtnZoneUuid,
        cZoneType: V.zoneC.cZoneType,
        buttonList: V.zoneC.buttonList || []
      }) : (U !== !0 && (t.toolbarLayout.orgPlan = !1, t.toolbarLayout.userPlan = !1, t.toolbarLayout.plan = {}), t.toolbarLayout.layout = {
        zoneA: { buttonList: [] },
        zoneB: { buttonList: [] },
        zoneC: { buttonList: [] }
      });
    }
    r(t.planType);
    function f() {
      N(!0), d().then((V) => {
        V.code === 1 ? (ElMessage.success("工具栏设置保存完成"), o.emit("modalConfirm", {})) : operatorErrorTip(V.msg);
      }).catch(() => {
        apiLinkErrorTip("工具栏设置保存");
      }).finally(() => {
        N(!1);
      });
    }
    function g() {
      a(!0);
    }
    function b() {
      r(t.planType);
    }
    function k(V, U) {
      t.editFlag = {
        cEventName: V,
        cButtonName: U
      }, nextTick(() => {
        t.cellInputEditHandle.focus();
      });
    }
    function x() {
      t.editFlag = {
        cEventName: "",
        cButtonName: ""
      };
    }
    function N(V) {
      t.saveSchemeLoading = V;
    }
    function O(V) {
      t.defaultSchemeLoading = V;
    }
    function m() {
      let V = 0;
      t.toolbarLayout.layout.zoneB.buttonList.forEach((U) => {
        U.bPriorityShow === !0 && V++;
      });
      for (let U = 0; U < t.toolbarLayout.layout.zoneB.buttonList.length; U++)
        t.toolbarLayout.layout.zoneB.buttonList[U].bPriorityShow = !1, V > 0 && (t.toolbarLayout.layout.zoneB.buttonList[U].bPriorityShow = !0, V--);
    }
    function ee(V) {
      if (V.bPriorityShow === !1) {
        let U = !0;
        for (let E = 0; E < t.toolbarLayout.layout.zoneB.buttonList.length; E++)
          t.toolbarLayout.layout.zoneB.buttonList[E].cEventName === V.cEventName && (U = !1), t.toolbarLayout.layout.zoneB.buttonList[E].bPriorityShow = U;
      } else {
        let U = !0;
        for (let E = 0; E < t.toolbarLayout.layout.zoneB.buttonList.length; E++)
          t.toolbarLayout.layout.zoneB.buttonList[E].bPriorityShow = U, t.toolbarLayout.layout.zoneB.buttonList[E].cEventName === V.cEventName && (U = !1);
      }
    }
    function z(V, U, E) {
      t.targetSortIndex = U, k(V, E);
    }
    function P(V, U) {
      if (U === void 0)
        return;
      x();
      const E = t.toolbarLayout.layout.zoneB.buttonList.layout, [C] = E.splice(V, 1);
      E.splice(U - 1, 0, C);
    }
    return {
      ...toRefs$1(t),
      deleteScheme: l,
      btnClickOK: f,
      btnClickDefault: g,
      onPlanTypeChange: b,
      onCellClick: k,
      onCellBlur: x,
      onListSortChange: m,
      onFixedCheckboxClick: ee,
      onFieldSortClick: z,
      onFieldSortChange: P
    };
  }
}), _hoisted_1$4 = { class: "alc-component-columnset-container" }, _hoisted_2$3 = { class: "flex alc-cpt-columnset" }, _hoisted_3$3 = {
  class: "flex",
  style: { width: "auto", "align-items": "center", "margin-left": "20px" }
}, _hoisted_4$3 = { class: "flex columnset-title-container" }, _hoisted_5$3 = /* @__PURE__ */ createElementVNode("div", {
  class: "columnset-title",
  style: { width: "80px" }
}, "排序", -1), _hoisted_6$2 = /* @__PURE__ */ createElementVNode("div", {
  class: "columnset-title",
  style: { width: "50px" }
}, "序号", -1), _hoisted_7$2 = /* @__PURE__ */ createElementVNode("div", {
  class: "columnset-title",
  style: { width: "220px" }
}, "显示名称", -1), _hoisted_8$2 = {
  class: "columnset-title",
  style: { width: "100px" }
}, _hoisted_9$2 = /* @__PURE__ */ createElementVNode("span", null, "显示", -1), _hoisted_10$1 = {
  class: "columnset-title alc-cpt-columnset-oper",
  style: { "text-align": "left" }
}, _hoisted_11 = /* @__PURE__ */ createElementVNode("span", null, "操作", -1), _hoisted_12 = { class: "flex columnset-item-container" }, _hoisted_13 = /* @__PURE__ */ createElementVNode("div", {
  class: "columnset-item",
  style: { width: "80px" }
}, [
  /* @__PURE__ */ createElementVNode("i", {
    class: "ri-arrow-up-down-line columnset-edit-handle",
    title: "拖放排序"
  })
], -1), _hoisted_14 = {
  class: "columnset-item",
  style: { width: "50px" }
}, _hoisted_15 = ["onClick"], _hoisted_16 = { key: 1 }, _hoisted_17 = {
  class: "flex columnset-item",
  style: { width: "100px", "max-width": "100px", "align-items": "center", "justify-content": "center" }
}, _hoisted_18 = {
  class: "flex columnset-item alc-cpt-columnset-oper",
  style: { "align-items": "center" }
}, _hoisted_19 = { style: { "max-width": "50px", "margin-left": "10px", display: "inline-block" } };
function _sfc_render$4(e, o, n, t, r, a) {
  const l = resolveComponent("ElRadioButton"), s = resolveComponent("ElRadioGroup"), c = resolveComponent("AlcTooltip"), d = resolveComponent("ElButton"), p = resolveComponent("ElInput"), f = resolveComponent("ElCheckbox"), g = resolveComponent("AlcInputNumber"), b = resolveComponent("Draggable"), k = resolveComponent("ElScrollbar"), x = resolveComponent("AlcDialogFooter");
  return openBlock(), createElementBlock(Fragment, null, [
    createElementVNode("div", _hoisted_1$4, [
      createElementVNode("div", _hoisted_2$3, [
        createVNode(s, {
          modelValue: e.planType,
          "onUpdate:modelValue": o[0] || (o[0] = (N) => e.planType = N),
          onChange: e.onPlanTypeChange,
          style: { "margin-left": "16px" }
        }, {
          default: withCtx(() => [
            createVNode(l, { value: 2 }, {
              default: withCtx(() => [
                createTextVNode(" 组织设置 ")
              ]),
              _: 1
            }),
            createVNode(l, { value: 3 }, {
              default: withCtx(() => [
                createTextVNode(" 个人设置 ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "onChange"]),
        createElementVNode("div", _hoisted_3$3, [
          createVNode(c, {
            content: "<p>1、按钮设置优先级：个人 > 组织 > 默认</p><p>2、组织或个人若无设置，会显示默认设置</p>",
            tabindex: null
          })
        ]),
        e.planType === 2 && e.toolbarLayout.orgPlan === !0 || e.planType === 3 && e.toolbarLayout.userPlan === !0 ? (openBlock(), createBlock(d, {
          key: 0,
          text: "",
          class: "alc-cpt-columnset-delete",
          title: e.planType === 2 ? "删除组织设置" : "删除个人设置",
          onClick: withModifiers(e.deleteScheme, ["stop"])
        }, {
          default: withCtx(() => [
            createTextVNode(" 删除设置 ")
          ]),
          _: 1
        }, 8, ["title", "onClick"])) : createCommentVNode("", !0)
      ]),
      createElementVNode("div", _hoisted_4$3, [
        _hoisted_5$3,
        _hoisted_6$2,
        _hoisted_7$2,
        createElementVNode("div", _hoisted_8$2, [
          _hoisted_9$2,
          createVNode(c, {
            content: "<p>1、设置工具栏扩展区域按钮显示状态</p><p>2、扩展区域最多显示6个按钮</p>",
            tabindex: null
          })
        ]),
        createElementVNode("div", _hoisted_10$1, [
          _hoisted_11,
          createVNode(c, {
            content: "<p>1、点击操作行中【移动至】按钮</p><p>2、输入移动的目标序号，回车确认</p>",
            tabindex: null
          })
        ])
      ]),
      createVNode(k, { style: { height: "calc(100% - 80px)" } }, {
        default: withCtx(() => [
          createVNode(b, {
            animation: "200",
            "ghost-class": "drag-ghost",
            handle: ".columnset-edit-handle",
            "item-key": "cEventName",
            modelValue: e.toolbarLayout.layout.zoneB.buttonList,
            "onUpdate:modelValue": o[2] || (o[2] = (N) => e.toolbarLayout.layout.zoneB.buttonList = N),
            "force-fallback": !0,
            disabled: !1,
            onSort: e.onListSortChange
          }, {
            item: withCtx(({ element: N, index: O }) => [
              createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                createElementVNode("div", _hoisted_14, toDisplayString$1(O + 1), 1),
                createElementVNode("div", {
                  class: "columnset-item",
                  style: { width: "220px", "max-width": "220px", cursor: "pointer" },
                  onClick: withModifiers((m) => e.onCellClick(N.cEventName, "cButtonName"), ["stop"])
                }, [
                  e.editFlag.cEventName === N.cEventName && e.editFlag.cButtonName === "cButtonName" ? (openBlock(), createBlock(p, {
                    key: 0,
                    ref: "cellInputEditHandle",
                    style: { "max-width": "180px", "text-align": "center" },
                    modelValue: N.cButtonName,
                    "onUpdate:modelValue": (m) => N.cButtonName = m,
                    onBlur: e.onCellBlur
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])) : (openBlock(), createElementBlock("span", _hoisted_16, toDisplayString$1(N.cButtonName), 1))
                ], 8, _hoisted_15),
                createElementVNode("div", _hoisted_17, [
                  O < 6 ? (openBlock(), createBlock(f, {
                    key: 0,
                    label: "",
                    modelValue: N.bPriorityShow,
                    "onUpdate:modelValue": (m) => N.bPriorityShow = m,
                    onChange: (m) => e.onFixedCheckboxClick(N)
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])) : createCommentVNode("", !0)
                ]),
                createElementVNode("div", _hoisted_18, [
                  createVNode(d, {
                    text: "",
                    onClick: withModifiers((m) => e.onFieldSortClick(
                      N.cEventName,
                      O + 1,
                      "fieldSort"
                    ), ["stop"])
                  }, {
                    default: withCtx(() => [
                      createTextVNode(" 移动至 ")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  createElementVNode("div", _hoisted_19, [
                    e.editFlag.cEventName === N.cEventName && e.editFlag.cButtonName === "fieldSort" ? (openBlock(), createBlock(g, {
                      key: 0,
                      ref: "cellInputEditHandle",
                      modelValue: e.targetSortIndex,
                      "onUpdate:modelValue": o[1] || (o[1] = (m) => e.targetSortIndex = m),
                      min: 1,
                      max: e.toolbarLayout.layout.zoneB.buttonList.length,
                      onEnter: (m) => e.onFieldSortChange(O, m)
                    }, null, 8, ["modelValue", "max", "onEnter"])) : createCommentVNode("", !0)
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "onSort"])
        ]),
        _: 1
      })
    ]),
    createVNode(x, null, {
      default: withCtx(() => [
        createVNode(d, {
          loading: e.defaultSchemeLoading,
          onClick: e.btnClickDefault
        }, {
          default: withCtx(() => [
            createTextVNode(" 恢复默认 ")
          ]),
          _: 1
        }, 8, ["loading", "onClick"]),
        createVNode(d, {
          type: "primary",
          loading: e.saveSchemeLoading,
          onClick: e.btnClickOK
        }, {
          default: withCtx(() => [
            createTextVNode(" 保存设置 ")
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ]),
      _: 1
    })
  ], 64);
}
const ToolbarSet = /* @__PURE__ */ _export_sfc(_sfc_main$4, [["render", _sfc_render$4], ["__file", "toolbar-set.vue"]]), alcToolbarProps = {
  /**
   * 显示单据操作
   * @default false
   */
  voucher: { type: Boolean, default: !1 },
  /**
   * 查询输入框占位提示
   * @default '请输入单据号'
   */
  searchPlaceholder: { type: String, default: "请输入单据号" },
  /**
   * 按钮禁用状态
   * @description 按钮 code 做键名，属性值为 true 则禁用
   * @default {}
   */
  disabled: {
    type: Object,
    default: () => ({})
  },
  /**
   * 按钮显示状态
   * @description 按钮 code 做键名，属性值为 true 则不渲染按钮
   * @default {}
   */
  hide: {
    type: Object,
    default: () => ({})
  },
  /**
   * 事件绑定
   * @description 按钮 code 做键名，属性值为回调函数
   */
  eventBind: {
    type: Object
  },
  /**
   * 单据操作按钮事件绑定
   */
  voucherEvent: {
    type: Object
  }
}, _sfc_main$3 = /* @__PURE__ */ defineComponent({
  name: "alc-toolbar",
  __name: "toolbar",
  props: alcToolbarProps,
  emits: ["layoutLoaded", "buttonClick", "voucherClick", "voucherSearch"],
  setup(e, { expose: o, emit: n }) {
    const t = e, r = n, a = ref(), l = ref(!1), s = ref(""), c = ref(t.disabled);
    watch(
      () => ({ ...t.disabled }),
      (U) => {
        c.value = U;
      }
    );
    const d = useProviderConfig(), p = useProviderConfig("state"), f = ref(!0), g = shallowRef({});
    d.value.acl[p.value.cMenuCode] = /* @__PURE__ */ new Set(), getAuthAccessButton(p.value.cMenuCode).then((U) => {
      d.value.acl[p.value.cMenuCode] = getFlatCode(U.data), g.value = U.data, r("layoutLoaded"), nextTick(() => {
        const E = a.value.wrapRef;
        l.value = !!E && E.scrollWidth > E.offsetWidth;
      });
    }).finally(() => {
      f.value = !1;
    });
    const b = computed(() => {
      var U;
      return ((U = g.value.planHave) == null ? void 0 : U.bPerson) || !1;
    }), k = computed(() => {
      var U;
      return O(((U = g.value.zoneA) == null ? void 0 : U.buttonList) || []);
    }), x = computed(() => {
      var U;
      return O(((U = g.value.zoneC) == null ? void 0 : U.buttonList) || []);
    }), N = computed(() => {
      var C;
      const [U, E] = O(
        ((C = g.value.zoneB) == null ? void 0 : C.buttonList) || []
      ).reduce(
        (I, v) => (I[+v.bPriorityShow || 0].push(v), I),
        [[], []]
      );
      return {
        show: E,
        more: [
          {
            label: "",
            icon: "ri-more-fill",
            child: U
          }
        ]
      };
    });
    function O(U) {
      return U.map((E) => {
        var C;
        return {
          label: E.cButtonName,
          command: E.cEventName,
          icon: E.cIconPath,
          child: (C = E.childrenList) != null && C.length ? O(E.childrenList) : void 0,
          // 没有在 AlcButtonList 中定义，只是在过滤 B 区显示按钮时用到
          bPriorityShow: E.bPriorityShow
        };
      });
    }
    function m(U, E) {
      U.split(",").forEach((I) => {
        c.value[I] = E === !0;
      });
    }
    function ee(U) {
      t.eventBind && typeof t.eventBind[U.command] == "function" ? t.eventBind[U.command]() : r("buttonClick", {
        name: U.label,
        event: U.command
      });
    }
    function z() {
      if (isBlank(s.value))
        return void operatorErrorTip("请先输入订单号！");
      r("voucherSearch", s.value);
    }
    function P(U) {
      t.voucherEvent && typeof t.voucherEvent[U] == "function" ? t.voucherEvent[U]() : r("voucherClick", U);
    }
    o({
      setButtonDisabled: m
    });
    const V = { props: t, emits: r, scrollbarRef: a, showScrollHandle: l, voucherCode: s, buttonDisabled: c, globalState: d, coreState: p, loading: f, toolbarPlan: g, userPlan: b, zoneA: k, zoneC: x, zoneB: N, getButtonList: O, setButtonDisabled: m, execCommand: ee, toolbarVoucherSearch: z, toolbarVoucherClick: P, get AlcButtonList() {
      return AlcButtonList;
    }, get AlcDialog() {
      return AlcDialog;
    }, get AlcInput() {
      return AlcInput;
    }, get ElButton() {
      return ElButton;
    }, get ElScrollbar() {
      return ElScrollbar;
    }, ToolbarSet, get vLoadOn() {
      return loadOn;
    } };
    return Object.defineProperty(V, "__isScriptSetup", { enumerable: !1, value: !0 }), V;
  }
}), _hoisted_1$3 = { class: "alc-component-toolbar-container auto-width--wrap" }, _hoisted_2$2 = /* @__PURE__ */ createElementVNode("i", {
  class: "ri-settings-4-line",
  style: { "font-size": "16px" }
}, null, -1), _hoisted_3$2 = {
  key: 2,
  class: "flex cpt-toolbar-voucher-zone"
}, _hoisted_4$2 = /* @__PURE__ */ createElementVNode("i", { class: "ri-search-line" }, null, -1), _hoisted_5$2 = /* @__PURE__ */ createElementVNode("i", {
  class: "ri-refresh-line",
  style: { "font-size": "14px" }
}, null, -1), _hoisted_6$1 = /* @__PURE__ */ createElementVNode("i", {
  class: "ri-skip-back-line",
  style: { "font-size": "16px" }
}, null, -1), _hoisted_7$1 = /* @__PURE__ */ createElementVNode("i", {
  class: "ri-arrow-left-s-line",
  style: { "font-size": "16px" }
}, null, -1), _hoisted_8$1 = /* @__PURE__ */ createElementVNode("i", {
  class: "ri-arrow-right-s-line",
  style: { "font-size": "16px" }
}, null, -1), _hoisted_9$1 = /* @__PURE__ */ createElementVNode("i", {
  class: "ri-skip-forward-line",
  style: { "font-size": "16px" }
}, null, -1);
function _sfc_render$3(e, o, n, t, r, a) {
  return withDirectives((openBlock(), createElementBlock("div", _hoisted_1$3, [
    t.showScrollHandle ? (openBlock(), createBlock(t.ElButton, {
      key: 0,
      link: "",
      class: "scrollbar-handle ri-arrow-left-s-line",
      onClick: o[0] || (o[0] = (l) => t.scrollbarRef.setScrollLeft(
        t.scrollbarRef.wrapRef.scrollLeft - t.scrollbarRef.wrapRef.offsetWidth / 2
      ))
    })) : createCommentVNode("", !0),
    createVNode(t.ElScrollbar, {
      ref: "scrollbarRef",
      class: "auto-width--target"
    }, {
      default: withCtx(() => {
        var l, s, c, d;
        return [
          createVNode(t.AlcButtonList, {
            data: t.zoneA,
            disabled: e.disabled,
            hide: e.hide,
            type: "primary",
            onCommand: t.execCommand
          }, null, 8, ["data", "disabled", "hide"]),
          createVNode(t.AlcButtonList, {
            data: t.zoneC,
            disabled: e.disabled,
            hide: e.hide,
            type: "primary",
            plain: "",
            onCommand: t.execCommand
          }, null, 8, ["data", "disabled", "hide"]),
          createVNode(t.AlcButtonList, {
            data: t.zoneB.show,
            disabled: e.disabled,
            hide: e.hide,
            plain: "",
            onCommand: t.execCommand
          }, null, 8, ["data", "disabled", "hide"]),
          (s = (l = t.zoneB.more[0]) == null ? void 0 : l.child) != null && s.length ? (openBlock(), createBlock(t.AlcButtonList, {
            key: 0,
            data: t.zoneB.more,
            disabled: e.disabled,
            hide: e.hide,
            plain: "",
            onCommand: t.execCommand
          }, null, 8, ["data", "disabled", "hide"])) : createCommentVNode("", !0),
          (d = (c = t.zoneB.more[0]) == null ? void 0 : c.child) != null && d.length || t.zoneB.show.length ? (openBlock(), createBlock(t.AlcDialog, {
            key: 1,
            title: "扩展区按钮设置",
            "width-type": "sm",
            "show-fullscreen": "",
            "close-on-click-modal": "",
            "close-on-press-escape": ""
          }, {
            reference: withCtx(() => [
              createVNode(t.ElButton, { title: "扩展区按钮设置" }, {
                default: withCtx(() => [
                  _hoisted_2$2
                ]),
                _: 1
              })
            ]),
            default: withCtx(() => [
              createVNode(t.ToolbarSet, { "user-plan": t.userPlan }, null, 8, ["user-plan"])
            ]),
            _: 1
          })) : createCommentVNode("", !0)
        ];
      }),
      _: 1
    }, 512),
    t.showScrollHandle ? (openBlock(), createBlock(t.ElButton, {
      key: 1,
      link: "",
      class: "scrollbar-handle ri-arrow-right-s-line",
      onClick: o[1] || (o[1] = (l) => t.scrollbarRef.setScrollLeft(
        t.scrollbarRef.wrapRef.scrollLeft + t.scrollbarRef.wrapRef.offsetWidth / 2
      ))
    })) : createCommentVNode("", !0),
    e.voucher ? (openBlock(), createElementBlock("div", _hoisted_3$2, [
      createVNode(t.AlcInput, {
        modelValue: t.voucherCode,
        "onUpdate:modelValue": o[2] || (o[2] = (l) => t.voucherCode = l),
        disabled: e.disabled.voucherSearch,
        placeholder: e.searchPlaceholder,
        class: "toolbar-voucher__search",
        onEnter: t.toolbarVoucherSearch
      }, {
        append: withCtx(() => [
          createVNode(t.ElButton, {
            title: "检索单据",
            disabled: e.disabled.voucherSearch,
            class: "voucher-operator",
            onClick: t.toolbarVoucherSearch
          }, {
            default: withCtx(() => [
              _hoisted_4$2
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      }, 8, ["modelValue", "disabled", "placeholder"]),
      createVNode(t.ElButton, {
        title: "刷新单据",
        disabled: e.disabled.voucherRefresh,
        class: "voucher-operator",
        onClick: o[3] || (o[3] = (l) => t.toolbarVoucherClick("voucherRefresh"))
      }, {
        default: withCtx(() => [
          _hoisted_5$2
        ]),
        _: 1
      }, 8, ["disabled"]),
      createVNode(t.ElButton, {
        title: "首张单据",
        disabled: e.disabled.voucherFirst,
        class: "voucher-operator",
        onClick: o[4] || (o[4] = (l) => t.toolbarVoucherClick("voucherFirst"))
      }, {
        default: withCtx(() => [
          _hoisted_6$1
        ]),
        _: 1
      }, 8, ["disabled"]),
      createVNode(t.ElButton, {
        title: "上一张单据",
        disabled: e.disabled.voucherPrev,
        class: "voucher-operator",
        onClick: o[5] || (o[5] = (l) => t.toolbarVoucherClick("voucherPrev"))
      }, {
        default: withCtx(() => [
          _hoisted_7$1
        ]),
        _: 1
      }, 8, ["disabled"]),
      createVNode(t.ElButton, {
        title: "下一张单据",
        disabled: e.disabled.voucherNext,
        class: "voucher-operator",
        onClick: o[6] || (o[6] = (l) => t.toolbarVoucherClick("voucherNext"))
      }, {
        default: withCtx(() => [
          _hoisted_8$1
        ]),
        _: 1
      }, 8, ["disabled"]),
      createVNode(t.ElButton, {
        title: "末张单据",
        disabled: e.disabled.voucherLast,
        class: "voucher-operator",
        onClick: o[7] || (o[7] = (l) => t.toolbarVoucherClick("voucherLast"))
      }, {
        default: withCtx(() => [
          _hoisted_9$1
        ]),
        _: 1
      }, 8, ["disabled"])
    ])) : createCommentVNode("", !0)
  ])), [
    [
      t.vLoadOn,
      t.loading,
      void 0,
      { small: !0 }
    ]
  ]);
}
const Toolbar = /* @__PURE__ */ _export_sfc(_sfc_main$3, [["render", _sfc_render$3], ["__file", "toolbar.vue"]]), AlcToolbar = withInstall(Toolbar), _sfc_main$2 = defineComponent({
  name: "alc-voucher-refer",
  directives: {
    loadOn
  },
  components: {
    ElCollapse,
    ElCollapseItem,
    AlcQuery,
    AlcList,
    AlcAreaTitle
  },
  props: {
    // 单据名称
    voucherName: { type: String, default: "" },
    // 查询条件结构 code
    queryCode: { type: String, required: !0 },
    // 查询组件元素额外绑定值
    queryProps: {
      type: Object,
      default: void 0
    },
    // 查询组件默认值
    queryDefaultValue: { type: Object, default: void 0 },
    // 表头结构 code
    mainCode: { type: String, required: !0 },
    // 表体结构 code
    detailCode: { type: String, required: !0 },
    // 表头查询设置
    mainSource: {
      type: Function,
      default: null
    },
    // 表体查询设置
    detailSource: {
      type: Function,
      default: null
    },
    // 验证选择的参照数据的方法，调用于单据参照确认按钮点击时，返回 false 或失败状态的 promise 终止关闭弹窗
    validReferVoucher: {
      type: Function,
      default: void 0
    },
    // 主表勾选时是否自动选中子表数据
    reactionSelect: { type: Boolean, default: !0 },
    // 关联选中的子表数据禁止取消选中
    checkStrictly: { type: Boolean, default: !1 }
  },
  setup(e, { expose: o }) {
    const n = reactive({
      queryRef: null,
      mainRef: null,
      detailRef: null,
      isLoading: !1,
      dialogVisible: !1,
      collapse: ["head", "detail"]
    }), t = reactive(/* @__PURE__ */ new Map()), r = shallowReactive(/* @__PURE__ */ new Map()), a = Symbol("selected"), l = computed(() => [...t.keys()]), s = useSliceList((P) => typeof e.mainSource != "function" ? void warn("voucher-refer", "请传入正确的 mainSource") : e.mainSource({
      queryValue: n.queryRef.getQuery(),
      paging: {
        currentPage: P.pageNumber,
        pageSize: P.pageSize
      }
    }).catch(() => {
      t.clear(), apiLinkErrorTip("查询上游单据主表");
    }));
    watch(s.sliceList, (P) => {
      t.forEach((E, C) => {
        C[a] && r.set(C, E);
      }), t.clear();
      const V = /* @__PURE__ */ new Set([...r.keys()]), U = new Set(P);
      U.forEach((E) => {
        V.forEach((C) => {
          deepCompare(C, E) && (E[a] = !0, t.set(E, r.get(C)), r.delete(C), U.delete(E), V.delete(C));
        });
      }), x(), N();
    });
    const c = computed(() => [...t.values()].flat().concat([...r.values()].flat())), d = useSliceList(c), p = computed(() => l.value.filter((P) => P[a])), f = computed(() => c.value.filter((P) => P[a])), g = computed(() => `${e.voucherName || ""}表头，共${s.total.value}条数据，已选中${p.value.length}条`), b = computed(() => `${e.voucherName || ""}明细，共${c.value.length}条数据，已选中${f.value.length}条`), k = () => {
      t.clear(), r.clear(), s.searchFn();
    }, x = () => {
      const P = n.mainRef.getInstance();
      nextTick(() => {
        n.mainRef.listValue.forEach((V) => {
          P.toggleRowSelection(V, !!V[a]);
        });
      });
    }, N = () => {
      const P = n.detailRef.getInstance();
      nextTick(() => {
        n.detailRef.listValue.forEach((V) => {
          P.toggleRowSelection(V, !!V[a]);
        });
      });
    }, O = async (...P) => {
      if (typeof e.detailSource != "function")
        return warn("voucher-refer", "请传入正确的 detailSource");
      if (P.length) {
        n.isLoading = !0;
        try {
          return (await Promise.all(
            P.map(e.detailSource)
          )).forEach((U, E) => {
            const C = U || [];
            e.reactionSelect && C.forEach((I) => {
              I[a] = !0;
            }), P[E][a] && t.set(P[E], C.map(shallowReactive));
          }), N(), !0;
        } catch {
          const V = n.mainRef.getInstance();
          P.forEach((U) => {
            V.toggleRowSelection(U, !1);
          }), apiLinkErrorTip("查询上游单据子表");
        } finally {
          n.isLoading = !1;
        }
      }
    }, m = (P, V) => {
      if (V) {
        if (V[a] = !V[a], !V[a])
          return t.delete(V), r.delete(V), void N();
        O(V);
      } else if (P.length && P.length <= s.paging.pageSize) {
        const U = [];
        P.forEach((E) => {
          E[a] || (U.push(E), E[a] = !0);
        }), O(...U);
      } else P.length || (t.forEach((U, E, C) => {
        E[a] = !1, C.set(E, []);
      }), N());
    }, ee = (P, V) => {
      const { pageNumber: U, pageSize: E } = d.paging, C = (U - 1) * E;
      V ? V[a] = !V[a] : P.length && P.length <= d.paging.pageSize ? c.value.slice(C, C + E).forEach((I) => {
        I[a] = !0;
      }) : P.length || c.value.slice(C, C + E).forEach((I) => {
        I[a] = !1;
      }), N();
    }, z = () => !e.checkStrictly;
    return onDialogConfirm(async () => {
      const P = {
        detailData: readonly(c.value),
        mainSelection: readonly(p.value),
        detailSelection: readonly(f.value)
      };
      return typeof e.validReferVoucher == "function" ? await syncReturnBoolean(
        e.validReferVoucher,
        P
      ) ? P : !1 : P;
    }), o(), {
      ...toRefs$1(n),
      mainData: l,
      useMain: s,
      detailData: c,
      useDetail: d,
      mainSelection: p,
      detailSelection: f,
      headTitle: g,
      bodyTitle: b,
      detailSelectable: z,
      queryOk: k,
      setBodyData: N,
      onHeadSelect: m,
      onBodySelect: ee
    };
  }
}), _hoisted_1$2 = { class: "h100 alc-component-voucher-refer-container auto-height--wrap" };
function _sfc_render$2(e, o, n, t, r, a) {
  const l = resolveComponent("AlcQuery"), s = resolveComponent("AlcAreaTitle"), c = resolveComponent("AlcList"), d = resolveComponent("ElCollapseItem"), p = resolveComponent("ElCollapse"), f = resolveDirective("load-on");
  return openBlock(), createElementBlock("div", _hoisted_1$2, [
    createVNode(l, {
      ref: "queryRef",
      code: e.queryCode,
      "default-value": e.queryDefaultValue,
      "extra-bind": e.queryProps,
      "show-lines": 1,
      onQueryOk: e.queryOk,
      onQueryClear: e.queryOk
    }, null, 8, ["code", "default-value", "extra-bind", "onQueryOk", "onQueryClear"]),
    createVNode(p, {
      modelValue: e.collapse,
      "onUpdate:modelValue": o[4] || (o[4] = (g) => e.collapse = g),
      class: "auto-height--target auto-height--wrap alc-component-voucher-refer-content"
    }, {
      default: withCtx(() => [
        createVNode(d, {
          name: "head",
          class: normalizeClass({ "auto-height--target": e.collapse.includes("head") })
        }, {
          title: withCtx(() => [
            createVNode(s, { title: e.headTitle }, null, 8, ["title"])
          ]),
          default: withCtx(() => [
            withDirectives((openBlock(), createBlock(c, {
              ref: "mainRef",
              code: e.mainCode,
              data: e.useMain.sliceList.value,
              total: e.useMain.total.value,
              "init-fetch": !1,
              "page-size": e.useMain.paging.pageSize,
              "onUpdate:pageSize": o[0] || (o[0] = (g) => e.useMain.paging.pageSize = g),
              "current-page": e.useMain.paging.pageNumber,
              "onUpdate:currentPage": o[1] || (o[1] = (g) => e.useMain.paging.pageNumber = g),
              onSelect: e.onHeadSelect,
              onSelectAll: e.onHeadSelect,
              multiple: ""
            }, {
              empty: withCtx(() => [
                createTextVNode(" 暂无数据 ")
              ]),
              _: 1
            }, 8, ["code", "data", "total", "page-size", "current-page", "onSelect", "onSelectAll"])), [
              [f, e.useMain.isLoading.value]
            ])
          ]),
          _: 1
        }, 8, ["class"]),
        createVNode(d, {
          name: "detail",
          class: normalizeClass({ "auto-height--target": e.collapse.includes("detail") })
        }, {
          title: withCtx(() => [
            createVNode(s, { title: e.bodyTitle }, null, 8, ["title"])
          ]),
          default: withCtx(() => [
            withDirectives((openBlock(), createBlock(c, {
              ref: "detailRef",
              selectable: e.detailSelectable,
              code: e.detailCode,
              data: e.useDetail.sliceList.value,
              total: e.useDetail.total.value,
              "init-fetch": !1,
              "page-size": e.useDetail.paging.pageSize,
              "onUpdate:pageSize": [
                o[2] || (o[2] = (g) => e.useDetail.paging.pageSize = g),
                e.setBodyData
              ],
              "current-page": e.useDetail.paging.pageNumber,
              "onUpdate:currentPage": [
                o[3] || (o[3] = (g) => e.useDetail.paging.pageNumber = g),
                e.setBodyData
              ],
              onSelect: e.onBodySelect,
              onSelectAll: e.onBodySelect,
              multiple: ""
            }, {
              empty: withCtx(() => [
                createTextVNode(" 暂无数据 ")
              ]),
              _: 1
            }, 8, ["selectable", "code", "data", "total", "page-size", "current-page", "onUpdate:pageSize", "onUpdate:currentPage", "onSelect", "onSelectAll"])), [
              [f, e.useMain.isLoading.value || e.isLoading]
            ])
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]);
}
const VoucherRefer = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["render", _sfc_render$2], ["__file", "voucher-refer.vue"]]), useFormCollapse = (e, o) => {
  const n = computed(() => `${16 + 46 * o}px`), t = ref(!1), r = o * 24, a = computed(() => {
    let s = 0;
    for (const c of e.value) {
      if (s >= r)
        return !0;
      s += c.span;
    }
    return !1;
  }), l = computed(() => {
    if (t.value) {
      let s = 0;
      return e.value.reduce((c, d) => s + d.span <= r ? (c.push(d), s += d.span, c) : (c.push(Object.assign({}, d, { itemType: "" })), c), []);
    }
    return e.value;
  });
  return {
    showSpan: r,
    isCollapse: t,
    canCollapse: a,
    headerFormHeight: n,
    showFormSchema: l
  };
}, useVoucherLayout = (formValue) => {
  const { emit } = getCurrentInstance(), code = useProp("code"), formItemConfig = useProp("formItemConfig"), bodyReadonly = useProp("bodyReadonly"), bodySummaryField = useProp("bodySummaryField"), rules = useProp("rules"), voucher = shallowRef({}), voucherTemplateLoading = ref(!0), isShowAuthTips = ref(!1), headerFormSchema = computed(() => {
    var e;
    return ((e = voucher.value.headerList) == null ? void 0 : e.map(getSchema)) || [];
  }), footerFormSchema = computed(() => {
    var e;
    return ((e = voucher.value.footerList) == null ? void 0 : e.map(getSchema)) || [];
  }), detailTableSchema = computed(() => {
    var e;
    return ((e = voucher.value.detailList) == null ? void 0 : e.reduce((o, n) => {
      var a;
      const t = n.bDefined && n.cDefinedSourceType !== "input" ? "custom-item" : itemTypeRef[n.cFieldType], r = Object.assign(
        {
          itemType: t,
          label: n.cLabelName,
          prop: n.cFieldName,
          width: n.iSpan,
          show: n.bShow,
          required: n.bRequired,
          sum: n.bSum || ((a = bodySummaryField.value) == null ? void 0 : a.includes(n.cFieldName)),
          sortable: !1,
          fixed: !1
        },
        transferProp(t, n)
      );
      if (n.bDefined && n.cDefinedSourceType === "formula") {
        let l;
        try {
          l = JSON.parse(n.cDefinedFormula) || [];
        } catch {
          l = [];
        }
        Object.assign(r, {
          itemType: void 0,
          align: "right",
          // 自定义项的值在 formatter 的时候更新
          formatter: (s) => customItemFormatter(
            l,
            s,
            n.cFieldName,
            n.iPrecision
          )
        });
      }
      return o.push(r), o;
    }, [])) || [];
  }), layoutReadonly = shallowRef({}), bodyFieldReadonly = computed(() => Object.assign({}, layoutReadonly.value, bodyReadonly.value)), layoutRules = computed(() => {
    var e;
    return (e = voucher.value.headerList) == null ? void 0 : e.concat(voucher.value.footerList || []).reduce((o, n) => {
      if (n.bRequired) {
        const t = ["Text", "TextArea", "Number"].includes(
          n.cFieldType
        );
        o[n.cFieldName] = {
          required: !0,
          message: `请${t ? "输入" : "选择"}${n.cLabelName}`,
          trigger: t ? "blur" : "change"
        };
      }
      return o;
    }, {});
  }), fullRules = computed(() => rules.value ? deepMerge(layoutRules.value, rules.value) : layoutRules.value), itemTypeRef = {
    Text: "input",
    TextArea: "input",
    Number: "number",
    Date: "date",
    Select: "select",
    Refer: "refer",
    Checkbox: "checkbox"
  }, positionRef = { body: "表体", header: "表头" }, registerFormItem = {
    "custom-item": "voucher-custom-input"
  };
  loadDefaultVoucherTemplate();
  function loadDefaultVoucherTemplate() {
    return apiGetDefaultVoucherTemplate(
      code.value,
      useProviderConfig().value.state.cMenuName
    ).then((e) => {
      e.code === 1 ? (setVoucher(e.data), initHeaderDefaultData(voucher.value), emit("tplLoaded", readonly(e.data))) : (e.code === 2106 && (isShowAuthTips.value = !0), operatorErrorTip(e.msg));
    }).catch((e) => {
      warn("use-voucher-layout", e), voucher.value = {}, isShowAuthTips.value = !1, apiLinkErrorTip("单据默认模板加载");
    }).finally(() => {
      voucherTemplateLoading.value = !1;
    });
  }
  function setVoucher(e) {
    function o(n) {
      return n.bShow;
    }
    voucher.value = {
      template: e.template,
      upstreamList: e.upstreamList.filter((n) => n.bUse),
      showTemplatePcList: e.showTemplatePcList.map((n) => ({
        ...n,
        _checked: n.cTemplateUuid === e.template.cTemplateUuid
      })),
      headerList: e.headerList.filter(o),
      footerList: e.footerList.filter(o),
      detailList: e.detailList.filter(o)
    };
  }
  function getSchema(e) {
    const n = {
      itemType: e.bDefined && e.cDefinedSourceType !== "input" ? "custom-item" : itemTypeRef[e.cFieldType],
      label: e.cLabelName,
      prop: e.cFieldName,
      labelColor: e.cWordColor,
      labelSize: e.cWordSize,
      span: e.iSpan || 6
    };
    return Object.assign(
      transferProp(n.itemType, e),
      formItemConfig.value[e.cFieldName],
      n
    );
  }
  function transferProp(e, o) {
    var n;
    switch (e) {
      case "input":
        return {
          type: o.cFieldType === "TextArea" ? "textarea" : void 0,
          readonly: o.bReadOnly,
          maxlength: o.cDefinedSourceType === "input" ? o.cDefinedDbLength : void 0
        };
      case "select":
        return {
          readonly: o.bReadOnly,
          options: ((n = o.enumData) == null ? void 0 : n.optionList.filter((t) => t.bUse).map((t) => ({
            label: t.cOptionName,
            value: t.cOptionKey
          }))) || [],
          formatter: (t, r, a) => {
            var l, s;
            return (s = (l = o.enumData) == null ? void 0 : l.optionList.find((c) => c.cOptionKey === String(a))) == null ? void 0 : s.cOptionName;
          }
        };
      case "number":
        return {
          min: o.iMin,
          max: o.iMax,
          precision: o.iPrecision,
          readonly: o.bReadOnly
        };
      case "date": {
        const { startLimit: t, endLimit: r } = disabledDate(o), a = {
          readonly: o.bReadOnly,
          disabledDateStart: t,
          disabledDateEnd: r
        };
        if (o.cFieldTypeCode)
          try {
            const l = JSON.parse(o.cFieldTypeCode);
            return Object.assign(
              objPick(l, ["type", "range", "format"]),
              {
                // code 是给 alc-display 组件用的，做反显
                code: l.type
              },
              a
            );
          } catch {
            return Object.assign(
              {
                type: o.cFieldTypeCode,
                code: o.cFieldTypeCode
              },
              a
            );
          }
        return a;
      }
      case "refer":
        return {
          code: o.cFieldTypeCode,
          readonly: o.bReadOnly
        };
      case "custom-item": {
        let t;
        try {
          t = JSON.parse(o.cDefinedFormula) || [];
        } catch {
          t = [];
        }
        const r = t.reduce((a, l) => {
          if (l.type === "c")
            return a + l.value;
          const [s, , c] = l.value.split(",");
          return `${a}[${positionRef[s]}.${c}]`;
        }, "");
        return {
          type: o.cDefinedSourceType,
          formula: o.cDefinedFormula,
          relationData: formValue.value,
          readonly: o.bReadOnly || o.cDefinedSourceType === "formula",
          tableUuid: o.cDefinedSourceTableUuid,
          fieldUuid: o.cDefinedSourceFieldUuid,
          precision: o.iPrecision,
          tips: r,
          maxlength: o.cDefinedDbLength,
          dataType: o.cDefinedDbType
        };
      }
      default:
        return {};
    }
  }
  function customItemFormatter(formula, row, cFieldName, precision = 0) {
    const relationData = { ...row, ...formValue.value }, hasUndefinedField = formula.filter((e) => e.type === "v").some((e) => typeof relationData[e.value.split(",")[1]] > "u");
    if (hasUndefinedField)
      return "";
    const execStr = formula.reduce((e, o) => e += o.type === "c" ? o.value : relationData[o.value.split(",")[1]], "");
    if (!execStr)
      return;
    const result = eval(execStr);
    return row[cFieldName] = typeof result == "number" && !Number.isNaN(result) ? Number(result.toFixed(precision)) : void 0, row[cFieldName];
  }
  const disabledDate = function(e) {
    const {
      bControlDate: o,
      cStartDateType: n,
      iBeforeDays: t,
      cEndDateType: r,
      iAfterDays: a
    } = e;
    if (!o || n === "none" && r === "none")
      return {};
    const l = getLimitDate("start", n, t), s = getLimitDate("end", r, a);
    return { startLimit: l, endLimit: s };
  };
  function getLimitDate(e, o, n) {
    const t = /* @__PURE__ */ new Date();
    switch (o) {
      case "year":
        e === "start" ? t.setMonth(0, 1) : t.setMonth(12, 0);
        break;
      case "month":
        e === "start" ? t.setDate(1) : t.setMonth(t.getMonth() + 1, 0);
        break;
      case "none":
        return e === "start" ? -1 / 0 : 1 / 0;
      case "before":
        t.setDate(t.getDate() - (n || 0));
        break;
      case "after":
        t.setDate(t.getDate() + (n || 0));
        break;
    }
    return e === "start" ? t.setHours(0, 0, 0, 0) : t.setHours(23, 59, 59, 999), t;
  }
  function initHeaderDefaultData(e) {
    e.headerList.forEach((o) => {
      if (o.cDefaultValue && [null, void 0].includes(
        formValue.value[o.cFieldName]
      )) {
        if (typeof o.cDefaultValue == "string" && o.cDefaultValue.startsWith('{"') && isJSON(o.cDefaultValue)) {
          formValue.value[o.cFieldName] = JSON.parse(
            o.cDefaultValue
          );
          return;
        }
        formValue.value[o.cFieldName] = o.cDefaultValue;
      }
    });
  }
  function getTemplateByUuid(e) {
    voucherTemplateLoading.value = !0, apiGetVoucherTemplateByUuid(e).then((o) => {
      o.code === 1 ? (setVoucher(o.data), initHeaderDefaultData(voucher.value), emit("tplChange", readonly(o.data))) : operatorErrorTip(o.msg);
    }).catch(() => {
      apiLinkErrorTip("单据模板");
    }).finally(() => {
      voucherTemplateLoading.value = !1;
    });
  }
  return {
    voucher,
    voucherTemplateLoading,
    isShowAuthTips,
    headerFormSchema,
    footerFormSchema,
    detailTableSchema,
    bodyFieldReadonly,
    fullRules,
    registerFormItem,
    loadDefaultVoucherTemplate,
    setVoucher,
    getTemplateByUuid
  };
}, _sfc_main$1 = /* @__PURE__ */ defineComponent({
  name: "voucher-header",
  __name: "voucher-header",
  props: {
    voucherCodeValue: {},
    showCreateVoucher: { type: Boolean },
    disabled: { type: Boolean },
    title: {},
    showUpVoucher: { type: Boolean },
    showCode: { type: Boolean },
    upperList: {},
    templateList: {}
  },
  emits: ["addBlank", "addUpper", "toggleTemplate"],
  setup(e, { expose: o, emit: n }) {
    o();
    const t = n;
    function r() {
      t("addBlank");
    }
    const a = { emits: t, onAddBlankVoucher: r, get AlcQrcode() {
      return AlcQrcode;
    }, get ElButton() {
      return ElButton;
    }, get ElDropdown() {
      return ElDropdown;
    }, get ElDropdownItem() {
      return ElDropdownItem;
    }, get ElDropdownMenu() {
      return ElDropdownMenu;
    }, get isBlank() {
      return isBlank;
    } };
    return Object.defineProperty(a, "__isScriptSetup", { enumerable: !1, value: !0 }), a;
  }
}), _hoisted_1$1 = { class: "flex alc-cpt-voucher-title-container" }, _hoisted_2$1 = { class: "alc-cpt-voucher-barcode" }, _hoisted_3$1 = { class: "alc-cpt-voucher-title" }, _hoisted_4$1 = { class: "alc-cpt-voucher-operation" }, _hoisted_5$1 = /* @__PURE__ */ createElementVNode("i", { class: "ri-arrow-down-s-line" }, null, -1), _hoisted_6 = { style: { "word-break": "keep-all" } }, _hoisted_7 = {
  class: "flex",
  style: { "align-items": "center" }
}, _hoisted_8 = { style: { "min-width": "19px" } }, _hoisted_9 = {
  key: 0,
  class: "ri-check-line"
}, _hoisted_10 = { style: { "word-break": "keep-all" } };
function _sfc_render$1(e, o, n, t, r, a) {
  return openBlock(), createElementBlock("div", _hoisted_1$1, [
    withDirectives(createElementVNode("div", _hoisted_2$1, [
      createVNode(t.AlcQrcode, {
        value: n.voucherCodeValue,
        size: 40,
        margin: 0
      }, null, 8, ["value"])
    ], 512), [
      [vShow, n.showCode]
    ]),
    createElementVNode("div", _hoisted_3$1, toDisplayString$1(n.title), 1),
    createElementVNode("div", _hoisted_4$1, [
      withDirectives(createVNode(t.ElButton, {
        plain: "",
        type: "primary",
        size: "small",
        title: "新建空白单据",
        disabled: n.disabled,
        style: normalizeStyle(
          n.showUpVoucher && n.upperList && n.upperList.length ? "border-radius: calc(var(--el-border-radius-base) - 1px) 0 0 calc(var(--el-border-radius-base) - 1px); border-right: 1px solid rgba(220, 223, 230, .5);" : ""
        ),
        onClick: t.onAddBlankVoucher
      }, {
        default: withCtx(() => [
          createTextVNode(" 新增 ")
        ]),
        _: 1
      }, 8, ["disabled", "style"]), [
        [vShow, n.showCreateVoucher]
      ]),
      withDirectives(createVNode(t.ElDropdown, {
        disabled: n.disabled,
        onClick: t.onAddBlankVoucher,
        onCommand: o[0] || (o[0] = (l) => e.$emit("addUpper", l))
      }, {
        dropdown: withCtx(() => [
          createVNode(t.ElDropdownMenu, null, {
            default: withCtx(() => [
              (openBlock(!0), createElementBlock(Fragment, null, renderList(n.upperList, (l, s) => (openBlock(), createBlock(t.ElDropdownItem, {
                key: s,
                command: l
              }, {
                default: withCtx(() => [
                  createElementVNode("span", _hoisted_6, " 参照【" + toDisplayString$1(l.cUpstreamVoucherName) + "】 ", 1)
                ]),
                _: 2
              }, 1032, ["command"]))), 128))
            ]),
            _: 1
          })
        ]),
        default: withCtx(() => [
          createVNode(t.ElButton, {
            plain: "",
            type: "primary",
            size: "small",
            style: normalizeStyle(
              n.showCreateVoucher && !t.isBlank(n.title) ? "border-radius: 0 calc(var(--el-border-radius-base) - 1px) calc(var(--el-border-radius-base) - 1px) 0;" : ""
            )
          }, {
            default: withCtx(() => [
              _hoisted_5$1
            ]),
            _: 1
          }, 8, ["style"])
        ]),
        _: 1
      }, 8, ["disabled"]), [
        [vShow, n.showUpVoucher && n.upperList && n.upperList.length]
      ]),
      withDirectives(createVNode(t.ElDropdown, {
        onCommand: o[1] || (o[1] = (l) => e.$emit("toggleTemplate", l.cTemplateUuid))
      }, {
        dropdown: withCtx(() => [
          createVNode(t.ElDropdownMenu, null, {
            default: withCtx(() => [
              (openBlock(!0), createElementBlock(Fragment, null, renderList(n.templateList, (l, s) => (openBlock(), createBlock(t.ElDropdownItem, {
                key: s,
                command: l,
                disabled: l._checked
              }, {
                default: withCtx(() => [
                  createElementVNode("div", _hoisted_7, [
                    createElementVNode("div", _hoisted_8, [
                      l._checked ? (openBlock(), createElementBlock("i", _hoisted_9)) : createCommentVNode("", !0)
                    ]),
                    createElementVNode("span", _hoisted_10, toDisplayString$1(l.cTemplateName), 1)
                  ])
                ]),
                _: 2
              }, 1032, ["command", "disabled"]))), 128))
            ]),
            _: 1
          })
        ]),
        default: withCtx(() => [
          createVNode(t.ElButton, {
            plain: "",
            type: "primary",
            size: "small",
            title: "选择单据模板",
            style: { "margin-left": "10px" }
          }, {
            default: withCtx(() => [
              createTextVNode(" 模板 ")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512), [
        [vShow, n.templateList && n.templateList.length > 1]
      ])
    ])
  ]);
}
const VoucherHeader = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["render", _sfc_render$1], ["__file", "voucher-header.vue"]]), _sfc_main = /* @__PURE__ */ defineComponent({
  name: "alc-voucher",
  __name: "voucher",
  props: {
    title: {},
    code: {},
    init: { type: Boolean, default: !0 },
    voucherCodeValue: {},
    appendixFileList: {},
    appendixFileAccept: {},
    appendixListType: { default: "text" },
    appendixFileDisabled: { type: Boolean, default: !1 },
    appendixFilePreview: { type: Boolean, default: !0 },
    appendixFileDownload: { type: Boolean, default: !1 },
    appendixFileLimit: { default: 3 },
    appendixFileLimitSize: { default: 3 * 1024 },
    upperMainSource: {},
    upperDetailSource: {},
    formItemConfig: { default: () => ({}) },
    formModel: { default: () => ({}) },
    rules: {},
    disabled: { type: Boolean, default: !1 },
    bodyRowEdit: { type: [Boolean, String], default: !0 },
    bodyBeforeAdd: {},
    bodyBeforeRemove: {},
    bodyTips: { default: () => ({}) },
    bodyConfig: { default: () => ({}) },
    bodyReadonly: { default: () => ({}) },
    bodyOperation: {},
    bodyOperationWidth: { default: 112 },
    bodyCellConfig: { default: () => ({}) },
    bodyCodeFieldName: {},
    bodyReferQueryAlias: {},
    bodySummaryField: {},
    businessType: { default: "voucherAttachment" },
    businessName: { default: "单据附件" },
    showCreateVoucher: { type: Boolean, default: !0 },
    showUpVoucher: { type: Boolean, default: !0 },
    validReferVoucher: {},
    referQueryProps: {},
    referQueryDefaultValue: {},
    headerCollapse: { type: Boolean, default: !0 },
    headerShowLines: { default: 2 },
    formValidateEvent: { type: Boolean, default: !1 }
  },
  emits: ["update:formModel", "tplLoaded", "tplChange", "bodyOperClick", "addBlank", "addUpper", "upperConfirm", "headerChange", "bodyCellEdit", "bodyCellClear", "bodyOpenedReferChoose"],
  setup(e, { expose: o, emit: n }) {
    const t = e, r = n, a = useModel(t, "formModel"), {
      voucher: l,
      voucherTemplateLoading: s,
      isShowAuthTips: c,
      headerFormSchema: d,
      footerFormSchema: p,
      detailTableSchema: f,
      bodyFieldReadonly: g,
      fullRules: b,
      registerFormItem: k,
      setVoucher: x,
      getTemplateByUuid: N,
      loadDefaultVoucherTemplate: O
    } = useVoucherLayout(a), m = computed(() => objPick(t, [
      "voucherCodeValue",
      "showCreateVoucher",
      "disabled",
      "showUpVoucher",
      "showCode"
    ])), {
      showSpan: ee,
      isCollapse: z,
      canCollapse: P,
      headerFormHeight: V,
      showFormSchema: U
    } = useFormCollapse(d, t.headerShowLines), { open: E } = usePrintGrp(), C = ref(), I = ref(), v = ref(), M = ref(), $ = ref(!0), H = ref(!1), X = shallowRef(), te = computed(() => {
      var ie;
      return (ie = X.value) == null ? void 0 : ie.cUpstreamVoucherName;
    });
    function oe(ie) {
      X.value = ie, r("addUpper", ie);
    }
    o({
      formValue: a,
      fileUploadHandle: I,
      headerFormRef: C,
      footerFormRef: M,
      bodyHandle: v,
      loadDefaultVoucherTemplate: O,
      getBodyInstance() {
        return v.value;
      },
      openUpperModal() {
        H.value = !0;
      },
      getAppendixData() {
        var ie;
        return (ie = I.value) == null ? void 0 : ie.fileList;
      },
      setTemplate: x,
      validate() {
        function ie(se) {
          const pe = Object.keys(se)[0], he = d.value.findIndex((fe) => fe.prop === pe), ae = d.value.slice(0, he);
          let le = 0;
          for (const fe of ae) {
            if (le >= ee)
              return !1;
            le += fe.span;
          }
          return !0;
        }
        return new Promise((se) => {
          if (isEmptyObject(b.value))
            return se(!0);
          C.value.validate((pe, he) => {
            pe ? M.value ? M.value.validate(se) : se(!0) : (z.value && (z.value = ie(he)), se(!1));
          });
        });
      },
      clearValidate() {
        var ie, se;
        (ie = C.value) == null || ie.clearValidate(), (se = M.value) == null || se.clearValidate();
      },
      openPrintModal(ie, se) {
        var pe;
        if (se || (se = (pe = I.value) == null ? void 0 : pe.fileList.map((he) => he.name).join(",")), ie)
          ie = ie.map((he) => Object.assign({}, he, {
            cPrintVoucherBarcode: t.voucherCodeValue,
            cPrintDetailBarcode: he[t.bodyCodeFieldName],
            cPrintVoucherAttachmentNames: se
          }));
        else {
          const he = Object.entries(a.value).reduce(
            (ae, [le, fe]) => (isPlainObject(fe) ? Object.assign(ae, fe) : ae[le] = fe, ae),
            {}
          );
          ie = v.value.getTableData().map((ae) => Object.assign({}, ae, he, {
            cPrintVoucherBarcode: t.voucherCodeValue,
            cPrintDetailBarcode: ae[t.bodyCodeFieldName],
            cPrintVoucherAttachmentNames: se
          }));
        }
        E({
          voucherCode: t.code,
          dataSource: ie
        });
      }
    });
    const ne = { props: t, emits: r, formValue: a, voucher: l, voucherTemplateLoading: s, isShowAuthTips: c, headerFormSchema: d, footerFormSchema: p, detailTableSchema: f, bodyFieldReadonly: g, fullRules: b, registerFormItem: k, setVoucher: x, getTemplateByUuid: N, loadDefaultVoucherTemplate: O, headerProps: m, showSpan: ee, isCollapse: z, canCollapse: P, headerFormHeight: V, showHeaderFormSchema: U, openPrintView: E, headerFormRef: C, fileUploadHandle: I, bodyHandle: v, footerFormRef: M, bodyHeightAuto: $, referDialogVisible: H, currentVoucherUpper: X, referVoucherName: te, onAddReferVoucher: oe, get AlcDialog() {
      return AlcDialog;
    }, get AlcForm() {
      return AlcForm;
    }, get AlcTable() {
      return AlcTable;
    }, get AlcUpload() {
      return AlcUpload;
    }, get vLoadOn() {
      return loadOn;
    }, get ElButton() {
      return ElButton;
    }, get ElResult() {
      return ElResult;
    }, VoucherRefer, VoucherHeader };
    return Object.defineProperty(ne, "__isScriptSetup", { enumerable: !1, value: !0 }), ne;
  }
}), _hoisted_1 = { class: "flex alc-component-voucher-container" }, _hoisted_2 = ["title"], _hoisted_3 = {
  key: 0,
  class: "w100 alc-cpt-voucher-appendix-container"
}, _hoisted_4 = {
  key: 0,
  class: "ri-line-height",
  title: "自动高度"
}, _hoisted_5 = {
  key: 1,
  class: "ri-phone-lock-line",
  title: "固定高度"
};
function _sfc_render(e, o, n, t, r, a) {
  var l, s, c, d;
  return withDirectives((openBlock(), createElementBlock("div", _hoisted_1, [
    (l = t.voucher.showTemplatePcList) != null && l.length || !t.isShowAuthTips ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
      createVNode(t.VoucherHeader, mergeProps(t.headerProps, {
        "show-code": ((s = t.voucher.template) == null ? void 0 : s.bUseVoucherBarcode) && !!n.voucherCodeValue,
        title: n.title || ((c = t.voucher.template) == null ? void 0 : c.cTemplateName),
        "upper-list": t.voucher.upstreamList,
        "template-list": t.voucher.showTemplatePcList,
        onAddBlank: o[0] || (o[0] = (p) => e.$emit("addBlank")),
        onAddUpper: t.onAddReferVoucher,
        onToggleTemplate: t.getTemplateByUuid
      }), null, 16, ["show-code", "title", "upper-list", "template-list", "onToggleTemplate"]),
      createElementVNode("div", {
        class: "alc-collapse--wrap",
        style: normalizeStyle({ height: t.isCollapse ? t.headerFormHeight : "auto" })
      }, [
        createVNode(t.AlcForm, {
          ref: "headerFormRef",
          modelValue: t.formValue,
          "onUpdate:modelValue": o[1] || (o[1] = (p) => t.formValue = p),
          schema: t.showHeaderFormSchema,
          rules: t.fullRules,
          disabled: n.disabled,
          "register-module": t.registerFormItem,
          "validate-event": n.formValidateEvent,
          "same-label": "",
          background: "",
          onChange: o[2] || (o[2] = (p) => e.$emit("headerChange", p))
        }, null, 8, ["modelValue", "schema", "rules", "disabled", "register-module", "validate-event"]),
        t.canCollapse ? (openBlock(), createElementBlock("span", {
          key: 0,
          class: normalizeClass([{ rotate: t.isCollapse }, "alc-collapse--handle"]),
          title: t.isCollapse ? "展开" : "收起",
          onClick: o[3] || (o[3] = (p) => t.isCollapse = !t.isCollapse)
        }, null, 10, _hoisted_2)) : createCommentVNode("", !0)
      ], 4),
      (d = t.voucher.template) != null && d.bUseAttachment ? (openBlock(), createElementBlock("div", _hoisted_3, [
        createVNode(t.AlcUpload, {
          ref: "fileUploadHandle",
          "list-type": n.appendixListType,
          accept: n.appendixFileAccept,
          limit: n.appendixFileLimit,
          "limit-size": n.appendixFileLimitSize,
          "business-type": n.businessType,
          "business-name": n.businessName,
          disabled: n.disabled || n.appendixFileDisabled,
          "file-list": n.appendixFileList,
          preview: n.appendixFilePreview,
          "button-text": "附件上传"
        }, null, 8, ["list-type", "accept", "limit", "limit-size", "business-type", "business-name", "disabled", "file-list", "preview"])
      ])) : createCommentVNode("", !0),
      createElementVNode("div", {
        class: normalizeClass([
          "w100",
          t.bodyHeightAuto ? "alc-cpt-voucher-body-container-auto" : "alc-cpt-voucher-body-container-all"
        ])
      }, [
        createVNode(t.AlcTable, {
          ref: "bodyHandle",
          schema: t.detailTableSchema,
          "row-edit": n.bodyRowEdit,
          "blank-row": 10,
          operation: n.bodyOperation,
          "operation-width": n.bodyOperationWidth,
          tips: n.bodyTips,
          disabled: n.disabled,
          "field-config": n.bodyConfig,
          "field-readonly": t.bodyFieldReadonly,
          "cell-config": n.bodyCellConfig,
          "code-field-name": n.bodyCodeFieldName,
          "before-add": n.bodyBeforeAdd,
          "before-remove": n.bodyBeforeRemove,
          "refer-query-alias": n.bodyReferQueryAlias,
          "inline-message": "",
          onOpenedReferChoose: o[5] || (o[5] = (p) => e.$emit("bodyOpenedReferChoose", p)),
          onCellEdit: o[6] || (o[6] = (p) => e.$emit("bodyCellEdit", p)),
          onCellClear: o[7] || (o[7] = (p) => e.$emit("bodyCellClear", p)),
          onOperationClick: o[8] || (o[8] = (p) => e.$emit("bodyOperClick", p))
        }, {
          indexHeader: withCtx(() => [
            createVNode(t.ElButton, {
              link: "",
              class: "alc-cpt-vouvher-body-heightoper",
              onClick: o[4] || (o[4] = (p) => t.bodyHeightAuto = !t.bodyHeightAuto)
            }, {
              default: withCtx(() => [
                t.bodyHeightAuto ? (openBlock(), createElementBlock("i", _hoisted_4)) : (openBlock(), createElementBlock("i", _hoisted_5))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["schema", "row-edit", "operation", "operation-width", "tips", "disabled", "field-config", "field-readonly", "cell-config", "code-field-name", "before-add", "before-remove", "refer-query-alias"])
      ], 2),
      t.footerFormSchema.length ? (openBlock(), createBlock(t.AlcForm, {
        key: 1,
        ref: "footerFormRef",
        modelValue: t.formValue,
        "onUpdate:modelValue": o[9] || (o[9] = (p) => t.formValue = p),
        schema: t.footerFormSchema,
        rules: t.fullRules,
        disabled: n.disabled,
        "register-module": t.registerFormItem,
        "validate-event": n.formValidateEvent,
        "same-label": "",
        onChange: o[10] || (o[10] = (p) => e.$emit("headerChange", p))
      }, null, 8, ["modelValue", "schema", "rules", "disabled", "register-module", "validate-event"])) : createCommentVNode("", !0)
    ], 64)) : !t.voucherTemplateLoading && t.isShowAuthTips ? (openBlock(), createBlock(t.ElResult, {
      key: 1,
      icon: "warning",
      title: "权限缺失",
      "sub-title": "当前单据启用了模板授权，请联系管理员授权"
    })) : createCommentVNode("", !0),
    createVNode(t.AlcDialog, {
      modelValue: t.referDialogVisible,
      "onUpdate:modelValue": o[11] || (o[11] = (p) => t.referDialogVisible = p),
      title: `单据参照${t.referVoucherName ? " - " + t.referVoucherName : ""}`,
      "width-type": "md",
      "content-height-fit": "",
      "show-fullscreen": "",
      onConfirm: o[12] || (o[12] = (p) => e.$emit("upperConfirm", p))
    }, {
      default: withCtx(() => {
        var p, f, g;
        return [
          createVNode(t.VoucherRefer, {
            "voucher-name": t.referVoucherName,
            "query-code": ((p = t.currentVoucherUpper) == null ? void 0 : p.cBaseQueryCodeUpstream) || "",
            "main-code": ((f = t.currentVoucherUpper) == null ? void 0 : f.cBaseListCodeUpstreamMain) || "",
            "detail-code": ((g = t.currentVoucherUpper) == null ? void 0 : g.cBaseListCodeUpstreamDetail) || "",
            "main-source": n.upperMainSource,
            "detail-source": n.upperDetailSource,
            "valid-refer-voucher": n.validReferVoucher,
            "query-props": n.referQueryProps,
            "query-default-value": n.referQueryDefaultValue
          }, null, 8, ["voucher-name", "query-code", "main-code", "detail-code", "main-source", "detail-source", "valid-refer-voucher", "query-props", "query-default-value"])
        ];
      }),
      _: 1
    }, 8, ["modelValue", "title"])
  ])), [
    [
      t.vLoadOn,
      t.voucherTemplateLoading,
      void 0,
      { large: !0 }
    ]
  ]);
}
const Voucher = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "voucher.vue"]]), AlcVoucher = withInstall(Voucher), alcComponents = [
  AlcAccessControl,
  AlcApiRequestError,
  AlcAreaTitle,
  AlcBarcode,
  AlcButton,
  AlcButtonList,
  AlcCascader,
  AlcCascaderRegion,
  AlcCascaderRegion2,
  AlcConfigProvider,
  AlcContextMenu,
  AlcDateInterval,
  AlcDateTime,
  AlcDialog,
  AlcDialogFooter,
  AlcDisplay,
  AlcEdit,
  AlcForm,
  AlcGrpCheck,
  AlcIconLauncher,
  AlcInput,
  AlcInputNumber,
  AlcInputTags,
  AlcList,
  AlcListNext,
  AlcListV,
  AlcPicturePreview,
  AlcProcessTrack,
  AlcQrcode,
  AlcQuery,
  AlcQuickKeyboard,
  AlcRefer,
  AlcReport,
  AlcSelect,
  AlcSelectIcon,
  AlcSplitView,
  AlcTable,
  AlcToolbar,
  AlcTooltip,
  AlcTree,
  AlcUpload,
  AlcUploadCardList,
  AlcUploadTextList,
  AlcVirtualGrid,
  AlcVoucher
], alcDirectives = [drag$1, loadOn, overflowTooltip], indexPc = {
  install
};
let appInstance;
function install(e, o) {
  appInstance = e, o && useGlobalConfig(o, e), alcComponents.forEach((n) => e.use(n)), alcDirectives.forEach((n) => e.use(n));
}
export {
  AlcAccessControl,
  AlcApiRequestError,
  AlcAreaTitle,
  AlcBarcode,
  AlcButton,
  AlcButtonList,
  AlcCascader,
  AlcCascaderRegion,
  AlcCascaderRegion2,
  AlcConfigProvider,
  AlcContextMenu,
  AlcDateInterval,
  AlcDateTime,
  AlcDialog,
  AlcDialogFooter,
  AlcDisplay,
  AlcEdit,
  AlcForm,
  AlcGrpCheck,
  AlcIconLauncher,
  AlcInput,
  AlcInputNumber,
  AlcInputTags,
  AlcList,
  AlcListNext,
  AlcListV,
  AlcPicturePreview,
  AlcProcessTrack,
  AlcQrcode,
  AlcQuery,
  AlcQuickKeyboard,
  AlcRefer,
  AlcReport,
  AlcSelect,
  AlcSelectIcon,
  AlcSplitView,
  AlcTable,
  AlcToolbar,
  AlcTooltip,
  AlcTree,
  AlcUpload,
  AlcUploadCardList,
  AlcUploadTextList,
  AlcVirtualGrid,
  AlcVoucher,
  BigNumber,
  alcAccessControlProps,
  alcAreaTitle,
  alcBarcodeProps,
  alcButtonListProps,
  alcButtonProps,
  alcCascaderProps,
  alcCascaderRegion2Props,
  alcCascaderRegionProps,
  alcContextMenuProps,
  alcDateIntervalProps,
  alcDateTimeProps,
  alcDisplayProps,
  alcEditProps,
  alcFormProps,
  alcIconLauncherProps,
  alcInputNumberProps,
  alcInputProps,
  alcInputTagsProps,
  alcPicturePreviewProps,
  alcProcessTrackProps,
  alcQrCodeProps,
  alcQueryProps,
  alcQuickKeyboardProps,
  alcReferProps,
  alcReportProps,
  alcSelectIconProps,
  alcSelectProps,
  alcSplitView,
  alcToolbarProps,
  alcTooltipProps,
  alcUploadContentListProps,
  alcUploadProps,
  apiLinkErrorTip,
  appInstance,
  attachEvent,
  authLogin,
  checkGrpServerState,
  closeAllDialogs,
  createAuthLoginUrl,
  indexPc as default,
  drag$1 as drag,
  exportByGrpTemplate,
  exportToExcel,
  getDisplayStringFormatCode,
  getEnumOptions,
  grpRun,
  inDialog,
  install,
  itemTypeRef,
  loadOn,
  mergeMethod,
  messageDefaultOptions,
  onDialogBeforeClose,
  onDialogConfirm,
  onDialogOpen,
  openAlert,
  openConfirm,
  openPrompt,
  operatorErrorTip,
  overflowTooltip,
  printByGrpTemplate,
  readExcel,
  shouldShowTooltip,
  toDisplayString,
  useAcl,
  useCropperView,
  useCudData,
  useDefineForm,
  useDialogOpen,
  useDialogState,
  useEnumOptions,
  useExportGrp,
  useExportList,
  useFormTimeTravel,
  useHoverShow,
  useImportData,
  useInvoiceApply,
  useInvoiceList,
  useMainApp,
  useNamespace,
  useOwnRouter,
  usePayView,
  usePreviewView,
  usePrintGrp,
  useQueryList,
  useRouterParams,
  useRouterQuery,
  useSameZIndex,
  useSetWxMsgTemp,
  useSliceList,
  useTabActiveLine,
  useTableArchive,
  useTreeData,
  useTreeLayout,
  useVoucherFlow,
  visitInnerPage,
  visitOuterPage,
  visitWorkflowPage,
  warn
};
